/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.net = (function() {

    /**
     * Namespace net.
     * @exports net
     * @namespace
     */
    var net = {};

    net.base_info = (function() {

        /**
         * Properties of a base_info.
         * @memberof net
         * @interface Ibase_info
         * @property {number|null} [uid] base_info uid
         * @property {Uint8Array|null} [nickname] base_info nickname
         * @property {Uint8Array|null} [phonenum] base_info phonenum
         * @property {Uint8Array|null} [headurl] base_info headurl
         * @property {number|null} [coin] base_info coin
         * @property {number|null} [lastlogouttime] base_info lastlogouttime
         * @property {Uint8Array|null} [sign] base_info sign
         * @property {Uint8Array|null} [region] base_info region
         * @property {Uint8Array|null} [qrcode] base_info qrcode
         * @property {number|null} [freezecoin] base_info freezecoin
         * @property {Uint8Array|null} [fname] base_info fname
         * @property {number|null} [usertype] base_info usertype
         * @property {Uint8Array|null} [zone] base_info zone
         * @property {number|null} [shopcoin] base_info shopcoin
         * @property {number|null} [fid] base_info fid
         * @property {Array.<net.Icoin_info>|null} [coin_list] base_info coin_list
         * @property {number|null} [channel] base_info channel
         * @property {number|null} [thirduid] base_info thirduid
         * @property {number|null} [viplevel] base_info viplevel
         * @property {number|null} [isadmin] base_info isadmin
         * @property {Uint8Array|null} [firstname] base_info firstname
         * @property {Uint8Array|null} [lastname] base_info lastname
         * @property {number|Long|null} [privacy] base_info privacy
         * @property {Uint8Array|null} [siteid] base_info siteid
         */

        /**
         * Constructs a new base_info.
         * @memberof net
         * @classdesc Represents a base_info.
         * @implements Ibase_info
         * @constructor
         * @param {net.Ibase_info=} [properties] Properties to set
         */
        function base_info(properties) {
            this.coin_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * base_info uid.
         * @member {number} uid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.uid = 0;

        /**
         * base_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.nickname = $util.newBuffer([]);

        /**
         * base_info phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.phonenum = $util.newBuffer([]);

        /**
         * base_info headurl.
         * @member {Uint8Array} headurl
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.headurl = $util.newBuffer([]);

        /**
         * base_info coin.
         * @member {number} coin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.coin = 0;

        /**
         * base_info lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.lastlogouttime = 0;

        /**
         * base_info sign.
         * @member {Uint8Array} sign
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.sign = $util.newBuffer([]);

        /**
         * base_info region.
         * @member {Uint8Array} region
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.region = $util.newBuffer([]);

        /**
         * base_info qrcode.
         * @member {Uint8Array} qrcode
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.qrcode = $util.newBuffer([]);

        /**
         * base_info freezecoin.
         * @member {number} freezecoin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.freezecoin = 0;

        /**
         * base_info fname.
         * @member {Uint8Array} fname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.fname = $util.newBuffer([]);

        /**
         * base_info usertype.
         * @member {number} usertype
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.usertype = 0;

        /**
         * base_info zone.
         * @member {Uint8Array} zone
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.zone = $util.newBuffer([]);

        /**
         * base_info shopcoin.
         * @member {number} shopcoin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.shopcoin = 0;

        /**
         * base_info fid.
         * @member {number} fid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.fid = 0;

        /**
         * base_info coin_list.
         * @member {Array.<net.Icoin_info>} coin_list
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.coin_list = $util.emptyArray;

        /**
         * base_info channel.
         * @member {number} channel
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.channel = 0;

        /**
         * base_info thirduid.
         * @member {number} thirduid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.thirduid = 0;

        /**
         * base_info viplevel.
         * @member {number} viplevel
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.viplevel = 0;

        /**
         * base_info isadmin.
         * @member {number} isadmin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.isadmin = 0;

        /**
         * base_info firstname.
         * @member {Uint8Array} firstname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.firstname = $util.newBuffer([]);

        /**
         * base_info lastname.
         * @member {Uint8Array} lastname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.lastname = $util.newBuffer([]);

        /**
         * base_info privacy.
         * @member {number|Long} privacy
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.privacy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * base_info siteid.
         * @member {Uint8Array} siteid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.siteid = $util.newBuffer([]);

        /**
         * Creates a new base_info instance using the specified properties.
         * @function create
         * @memberof net.base_info
         * @static
         * @param {net.Ibase_info=} [properties] Properties to set
         * @returns {net.base_info} base_info instance
         */
        base_info.create = function create(properties) {
            return new base_info(properties);
        };

        /**
         * Encodes the specified base_info message. Does not implicitly {@link net.base_info.verify|verify} messages.
         * @function encode
         * @memberof net.base_info
         * @static
         * @param {net.Ibase_info} message base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.headurl);
            if (message.coin != null && Object.hasOwnProperty.call(message, "coin"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.coin);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.lastlogouttime);
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.sign);
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.region);
            if (message.qrcode != null && Object.hasOwnProperty.call(message, "qrcode"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.qrcode);
            if (message.freezecoin != null && Object.hasOwnProperty.call(message, "freezecoin"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.freezecoin);
            if (message.fname != null && Object.hasOwnProperty.call(message, "fname"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.fname);
            if (message.usertype != null && Object.hasOwnProperty.call(message, "usertype"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.usertype);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.zone);
            if (message.shopcoin != null && Object.hasOwnProperty.call(message, "shopcoin"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.shopcoin);
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.fid);
            if (message.coin_list != null && message.coin_list.length)
                for (var i = 0; i < message.coin_list.length; ++i)
                    $root.net.coin_info.encode(message.coin_list[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.thirduid);
            if (message.viplevel != null && Object.hasOwnProperty.call(message, "viplevel"))
                writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.viplevel);
            if (message.isadmin != null && Object.hasOwnProperty.call(message, "isadmin"))
                writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.isadmin);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 21, wireType 2 =*/170).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 22, wireType 2 =*/178).bytes(message.lastname);
            if (message.privacy != null && Object.hasOwnProperty.call(message, "privacy"))
                writer.uint32(/* id 23, wireType 0 =*/184).int64(message.privacy);
            if (message.siteid != null && Object.hasOwnProperty.call(message, "siteid"))
                writer.uint32(/* id 24, wireType 2 =*/194).bytes(message.siteid);
            return writer;
        };

        /**
         * Encodes the specified base_info message, length delimited. Does not implicitly {@link net.base_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.base_info
         * @static
         * @param {net.Ibase_info} message base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        base_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.base_info} base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                case 4:
                    message.headurl = reader.bytes();
                    break;
                case 5:
                    message.coin = reader.uint32();
                    break;
                case 6:
                    message.lastlogouttime = reader.int32();
                    break;
                case 7:
                    message.sign = reader.bytes();
                    break;
                case 8:
                    message.region = reader.bytes();
                    break;
                case 9:
                    message.qrcode = reader.bytes();
                    break;
                case 10:
                    message.freezecoin = reader.uint32();
                    break;
                case 11:
                    message.fname = reader.bytes();
                    break;
                case 12:
                    message.usertype = reader.uint32();
                    break;
                case 13:
                    message.zone = reader.bytes();
                    break;
                case 14:
                    message.shopcoin = reader.uint32();
                    break;
                case 15:
                    message.fid = reader.uint32();
                    break;
                case 16:
                    if (!(message.coin_list && message.coin_list.length))
                        message.coin_list = [];
                    message.coin_list.push($root.net.coin_info.decode(reader, reader.uint32()));
                    break;
                case 17:
                    message.channel = reader.uint32();
                    break;
                case 18:
                    message.thirduid = reader.uint32();
                    break;
                case 19:
                    message.viplevel = reader.uint32();
                    break;
                case 20:
                    message.isadmin = reader.uint32();
                    break;
                case 21:
                    message.firstname = reader.bytes();
                    break;
                case 22:
                    message.lastname = reader.bytes();
                    break;
                case 23:
                    message.privacy = reader.int64();
                    break;
                case 24:
                    message.siteid = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a base_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.base_info} base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        base_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a base_info message.
         * @function verify
         * @memberof net.base_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        base_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (!$util.isInteger(message.coin))
                    return "coin: integer expected";
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                if (!$util.isInteger(message.lastlogouttime))
                    return "lastlogouttime: integer expected";
            if (message.sign != null && message.hasOwnProperty("sign"))
                if (!(message.sign && typeof message.sign.length === "number" || $util.isString(message.sign)))
                    return "sign: buffer expected";
            if (message.region != null && message.hasOwnProperty("region"))
                if (!(message.region && typeof message.region.length === "number" || $util.isString(message.region)))
                    return "region: buffer expected";
            if (message.qrcode != null && message.hasOwnProperty("qrcode"))
                if (!(message.qrcode && typeof message.qrcode.length === "number" || $util.isString(message.qrcode)))
                    return "qrcode: buffer expected";
            if (message.freezecoin != null && message.hasOwnProperty("freezecoin"))
                if (!$util.isInteger(message.freezecoin))
                    return "freezecoin: integer expected";
            if (message.fname != null && message.hasOwnProperty("fname"))
                if (!(message.fname && typeof message.fname.length === "number" || $util.isString(message.fname)))
                    return "fname: buffer expected";
            if (message.usertype != null && message.hasOwnProperty("usertype"))
                if (!$util.isInteger(message.usertype))
                    return "usertype: integer expected";
            if (message.zone != null && message.hasOwnProperty("zone"))
                if (!(message.zone && typeof message.zone.length === "number" || $util.isString(message.zone)))
                    return "zone: buffer expected";
            if (message.shopcoin != null && message.hasOwnProperty("shopcoin"))
                if (!$util.isInteger(message.shopcoin))
                    return "shopcoin: integer expected";
            if (message.fid != null && message.hasOwnProperty("fid"))
                if (!$util.isInteger(message.fid))
                    return "fid: integer expected";
            if (message.coin_list != null && message.hasOwnProperty("coin_list")) {
                if (!Array.isArray(message.coin_list))
                    return "coin_list: array expected";
                for (var i = 0; i < message.coin_list.length; ++i) {
                    var error = $root.net.coin_info.verify(message.coin_list[i]);
                    if (error)
                        return "coin_list." + error;
                }
            }
            if (message.channel != null && message.hasOwnProperty("channel"))
                if (!$util.isInteger(message.channel))
                    return "channel: integer expected";
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                if (!$util.isInteger(message.thirduid))
                    return "thirduid: integer expected";
            if (message.viplevel != null && message.hasOwnProperty("viplevel"))
                if (!$util.isInteger(message.viplevel))
                    return "viplevel: integer expected";
            if (message.isadmin != null && message.hasOwnProperty("isadmin"))
                if (!$util.isInteger(message.isadmin))
                    return "isadmin: integer expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!(message.firstname && typeof message.firstname.length === "number" || $util.isString(message.firstname)))
                    return "firstname: buffer expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!(message.lastname && typeof message.lastname.length === "number" || $util.isString(message.lastname)))
                    return "lastname: buffer expected";
            if (message.privacy != null && message.hasOwnProperty("privacy"))
                if (!$util.isInteger(message.privacy) && !(message.privacy && $util.isInteger(message.privacy.low) && $util.isInteger(message.privacy.high)))
                    return "privacy: integer|Long expected";
            if (message.siteid != null && message.hasOwnProperty("siteid"))
                if (!(message.siteid && typeof message.siteid.length === "number" || $util.isString(message.siteid)))
                    return "siteid: buffer expected";
            return null;
        };

        /**
         * Creates a base_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.base_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.base_info} base_info
         */
        base_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.base_info)
                return object;
            var message = new $root.net.base_info();
            if (object.uid != null)
                message.uid = object.uid >>> 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            if (object.coin != null)
                message.coin = object.coin >>> 0;
            if (object.lastlogouttime != null)
                message.lastlogouttime = object.lastlogouttime | 0;
            if (object.sign != null)
                if (typeof object.sign === "string")
                    $util.base64.decode(object.sign, message.sign = $util.newBuffer($util.base64.length(object.sign)), 0);
                else if (object.sign.length)
                    message.sign = object.sign;
            if (object.region != null)
                if (typeof object.region === "string")
                    $util.base64.decode(object.region, message.region = $util.newBuffer($util.base64.length(object.region)), 0);
                else if (object.region.length)
                    message.region = object.region;
            if (object.qrcode != null)
                if (typeof object.qrcode === "string")
                    $util.base64.decode(object.qrcode, message.qrcode = $util.newBuffer($util.base64.length(object.qrcode)), 0);
                else if (object.qrcode.length)
                    message.qrcode = object.qrcode;
            if (object.freezecoin != null)
                message.freezecoin = object.freezecoin >>> 0;
            if (object.fname != null)
                if (typeof object.fname === "string")
                    $util.base64.decode(object.fname, message.fname = $util.newBuffer($util.base64.length(object.fname)), 0);
                else if (object.fname.length)
                    message.fname = object.fname;
            if (object.usertype != null)
                message.usertype = object.usertype >>> 0;
            if (object.zone != null)
                if (typeof object.zone === "string")
                    $util.base64.decode(object.zone, message.zone = $util.newBuffer($util.base64.length(object.zone)), 0);
                else if (object.zone.length)
                    message.zone = object.zone;
            if (object.shopcoin != null)
                message.shopcoin = object.shopcoin >>> 0;
            if (object.fid != null)
                message.fid = object.fid >>> 0;
            if (object.coin_list) {
                if (!Array.isArray(object.coin_list))
                    throw TypeError(".net.base_info.coin_list: array expected");
                message.coin_list = [];
                for (var i = 0; i < object.coin_list.length; ++i) {
                    if (typeof object.coin_list[i] !== "object")
                        throw TypeError(".net.base_info.coin_list: object expected");
                    message.coin_list[i] = $root.net.coin_info.fromObject(object.coin_list[i]);
                }
            }
            if (object.channel != null)
                message.channel = object.channel >>> 0;
            if (object.thirduid != null)
                message.thirduid = object.thirduid >>> 0;
            if (object.viplevel != null)
                message.viplevel = object.viplevel >>> 0;
            if (object.isadmin != null)
                message.isadmin = object.isadmin >>> 0;
            if (object.firstname != null)
                if (typeof object.firstname === "string")
                    $util.base64.decode(object.firstname, message.firstname = $util.newBuffer($util.base64.length(object.firstname)), 0);
                else if (object.firstname.length)
                    message.firstname = object.firstname;
            if (object.lastname != null)
                if (typeof object.lastname === "string")
                    $util.base64.decode(object.lastname, message.lastname = $util.newBuffer($util.base64.length(object.lastname)), 0);
                else if (object.lastname.length)
                    message.lastname = object.lastname;
            if (object.privacy != null)
                if ($util.Long)
                    (message.privacy = $util.Long.fromValue(object.privacy)).unsigned = false;
                else if (typeof object.privacy === "string")
                    message.privacy = parseInt(object.privacy, 10);
                else if (typeof object.privacy === "number")
                    message.privacy = object.privacy;
                else if (typeof object.privacy === "object")
                    message.privacy = new $util.LongBits(object.privacy.low >>> 0, object.privacy.high >>> 0).toNumber();
            if (object.siteid != null)
                if (typeof object.siteid === "string")
                    $util.base64.decode(object.siteid, message.siteid = $util.newBuffer($util.base64.length(object.siteid)), 0);
                else if (object.siteid.length)
                    message.siteid = object.siteid;
            return message;
        };

        /**
         * Creates a plain object from a base_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.base_info
         * @static
         * @param {net.base_info} message base_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        base_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coin_list = [];
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
                object.coin = 0;
                object.lastlogouttime = 0;
                if (options.bytes === String)
                    object.sign = "";
                else {
                    object.sign = [];
                    if (options.bytes !== Array)
                        object.sign = $util.newBuffer(object.sign);
                }
                if (options.bytes === String)
                    object.region = "";
                else {
                    object.region = [];
                    if (options.bytes !== Array)
                        object.region = $util.newBuffer(object.region);
                }
                if (options.bytes === String)
                    object.qrcode = "";
                else {
                    object.qrcode = [];
                    if (options.bytes !== Array)
                        object.qrcode = $util.newBuffer(object.qrcode);
                }
                object.freezecoin = 0;
                if (options.bytes === String)
                    object.fname = "";
                else {
                    object.fname = [];
                    if (options.bytes !== Array)
                        object.fname = $util.newBuffer(object.fname);
                }
                object.usertype = 0;
                if (options.bytes === String)
                    object.zone = "";
                else {
                    object.zone = [];
                    if (options.bytes !== Array)
                        object.zone = $util.newBuffer(object.zone);
                }
                object.shopcoin = 0;
                object.fid = 0;
                object.channel = 0;
                object.thirduid = 0;
                object.viplevel = 0;
                object.isadmin = 0;
                if (options.bytes === String)
                    object.firstname = "";
                else {
                    object.firstname = [];
                    if (options.bytes !== Array)
                        object.firstname = $util.newBuffer(object.firstname);
                }
                if (options.bytes === String)
                    object.lastname = "";
                else {
                    object.lastname = [];
                    if (options.bytes !== Array)
                        object.lastname = $util.newBuffer(object.lastname);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.privacy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.privacy = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.siteid = "";
                else {
                    object.siteid = [];
                    if (options.bytes !== Array)
                        object.siteid = $util.newBuffer(object.siteid);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = message.coin;
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                object.lastlogouttime = message.lastlogouttime;
            if (message.sign != null && message.hasOwnProperty("sign"))
                object.sign = options.bytes === String ? $util.base64.encode(message.sign, 0, message.sign.length) : options.bytes === Array ? Array.prototype.slice.call(message.sign) : message.sign;
            if (message.region != null && message.hasOwnProperty("region"))
                object.region = options.bytes === String ? $util.base64.encode(message.region, 0, message.region.length) : options.bytes === Array ? Array.prototype.slice.call(message.region) : message.region;
            if (message.qrcode != null && message.hasOwnProperty("qrcode"))
                object.qrcode = options.bytes === String ? $util.base64.encode(message.qrcode, 0, message.qrcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.qrcode) : message.qrcode;
            if (message.freezecoin != null && message.hasOwnProperty("freezecoin"))
                object.freezecoin = message.freezecoin;
            if (message.fname != null && message.hasOwnProperty("fname"))
                object.fname = options.bytes === String ? $util.base64.encode(message.fname, 0, message.fname.length) : options.bytes === Array ? Array.prototype.slice.call(message.fname) : message.fname;
            if (message.usertype != null && message.hasOwnProperty("usertype"))
                object.usertype = message.usertype;
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = options.bytes === String ? $util.base64.encode(message.zone, 0, message.zone.length) : options.bytes === Array ? Array.prototype.slice.call(message.zone) : message.zone;
            if (message.shopcoin != null && message.hasOwnProperty("shopcoin"))
                object.shopcoin = message.shopcoin;
            if (message.fid != null && message.hasOwnProperty("fid"))
                object.fid = message.fid;
            if (message.coin_list && message.coin_list.length) {
                object.coin_list = [];
                for (var j = 0; j < message.coin_list.length; ++j)
                    object.coin_list[j] = $root.net.coin_info.toObject(message.coin_list[j], options);
            }
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                object.thirduid = message.thirduid;
            if (message.viplevel != null && message.hasOwnProperty("viplevel"))
                object.viplevel = message.viplevel;
            if (message.isadmin != null && message.hasOwnProperty("isadmin"))
                object.isadmin = message.isadmin;
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = options.bytes === String ? $util.base64.encode(message.firstname, 0, message.firstname.length) : options.bytes === Array ? Array.prototype.slice.call(message.firstname) : message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = options.bytes === String ? $util.base64.encode(message.lastname, 0, message.lastname.length) : options.bytes === Array ? Array.prototype.slice.call(message.lastname) : message.lastname;
            if (message.privacy != null && message.hasOwnProperty("privacy"))
                if (typeof message.privacy === "number")
                    object.privacy = options.longs === String ? String(message.privacy) : message.privacy;
                else
                    object.privacy = options.longs === String ? $util.Long.prototype.toString.call(message.privacy) : options.longs === Number ? new $util.LongBits(message.privacy.low >>> 0, message.privacy.high >>> 0).toNumber() : message.privacy;
            if (message.siteid != null && message.hasOwnProperty("siteid"))
                object.siteid = options.bytes === String ? $util.base64.encode(message.siteid, 0, message.siteid.length) : options.bytes === Array ? Array.prototype.slice.call(message.siteid) : message.siteid;
            return object;
        };

        /**
         * Converts this base_info to JSON.
         * @function toJSON
         * @memberof net.base_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        base_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return base_info;
    })();

    net.friend_apply = (function() {

        /**
         * Properties of a friend_apply.
         * @memberof net
         * @interface Ifriend_apply
         * @property {net.Ibase_info|null} [info] friend_apply info
         * @property {number|null} [applytime] friend_apply applytime
         * @property {number|null} [applyState] friend_apply applyState
         * @property {Uint8Array|null} [hellomsg] friend_apply hellomsg
         */

        /**
         * Constructs a new friend_apply.
         * @memberof net
         * @classdesc Represents a friend_apply.
         * @implements Ifriend_apply
         * @constructor
         * @param {net.Ifriend_apply=} [properties] Properties to set
         */
        function friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * friend_apply info.
         * @member {net.Ibase_info|null|undefined} info
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.info = null;

        /**
         * friend_apply applytime.
         * @member {number} applytime
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.applytime = 0;

        /**
         * friend_apply applyState.
         * @member {number} applyState
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.applyState = 0;

        /**
         * friend_apply hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Creates a new friend_apply instance using the specified properties.
         * @function create
         * @memberof net.friend_apply
         * @static
         * @param {net.Ifriend_apply=} [properties] Properties to set
         * @returns {net.friend_apply} friend_apply instance
         */
        friend_apply.create = function create(properties) {
            return new friend_apply(properties);
        };

        /**
         * Encodes the specified friend_apply message. Does not implicitly {@link net.friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.friend_apply
         * @static
         * @param {net.Ifriend_apply} message friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                $root.net.base_info.encode(message.info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.applytime != null && Object.hasOwnProperty.call(message, "applytime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.applytime);
            if (message.applyState != null && Object.hasOwnProperty.call(message, "applyState"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.applyState);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Encodes the specified friend_apply message, length delimited. Does not implicitly {@link net.friend_apply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.friend_apply
         * @static
         * @param {net.Ifriend_apply} message friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_apply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.friend_apply} friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.applytime = reader.uint32();
                    break;
                case 3:
                    message.applyState = reader.uint32();
                    break;
                case 4:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a friend_apply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.friend_apply} friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_apply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a friend_apply message.
         * @function verify
         * @memberof net.friend_apply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        friend_apply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.info != null && message.hasOwnProperty("info")) {
                var error = $root.net.base_info.verify(message.info);
                if (error)
                    return "info." + error;
            }
            if (message.applytime != null && message.hasOwnProperty("applytime"))
                if (!$util.isInteger(message.applytime))
                    return "applytime: integer expected";
            if (message.applyState != null && message.hasOwnProperty("applyState"))
                if (!$util.isInteger(message.applyState))
                    return "applyState: integer expected";
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                if (!(message.hellomsg && typeof message.hellomsg.length === "number" || $util.isString(message.hellomsg)))
                    return "hellomsg: buffer expected";
            return null;
        };

        /**
         * Creates a friend_apply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.friend_apply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.friend_apply} friend_apply
         */
        friend_apply.fromObject = function fromObject(object) {
            if (object instanceof $root.net.friend_apply)
                return object;
            var message = new $root.net.friend_apply();
            if (object.info != null) {
                if (typeof object.info !== "object")
                    throw TypeError(".net.friend_apply.info: object expected");
                message.info = $root.net.base_info.fromObject(object.info);
            }
            if (object.applytime != null)
                message.applytime = object.applytime >>> 0;
            if (object.applyState != null)
                message.applyState = object.applyState >>> 0;
            if (object.hellomsg != null)
                if (typeof object.hellomsg === "string")
                    $util.base64.decode(object.hellomsg, message.hellomsg = $util.newBuffer($util.base64.length(object.hellomsg)), 0);
                else if (object.hellomsg.length)
                    message.hellomsg = object.hellomsg;
            return message;
        };

        /**
         * Creates a plain object from a friend_apply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.friend_apply
         * @static
         * @param {net.friend_apply} message friend_apply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        friend_apply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.info = null;
                object.applytime = 0;
                object.applyState = 0;
                if (options.bytes === String)
                    object.hellomsg = "";
                else {
                    object.hellomsg = [];
                    if (options.bytes !== Array)
                        object.hellomsg = $util.newBuffer(object.hellomsg);
                }
            }
            if (message.info != null && message.hasOwnProperty("info"))
                object.info = $root.net.base_info.toObject(message.info, options);
            if (message.applytime != null && message.hasOwnProperty("applytime"))
                object.applytime = message.applytime;
            if (message.applyState != null && message.hasOwnProperty("applyState"))
                object.applyState = message.applyState;
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                object.hellomsg = options.bytes === String ? $util.base64.encode(message.hellomsg, 0, message.hellomsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.hellomsg) : message.hellomsg;
            return object;
        };

        /**
         * Converts this friend_apply to JSON.
         * @function toJSON
         * @memberof net.friend_apply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        friend_apply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return friend_apply;
    })();

    net.chat_msg = (function() {

        /**
         * Properties of a chat_msg.
         * @memberof net
         * @interface Ichat_msg
         * @property {number|Long|null} [chatkey] chat_msg chatkey
         * @property {number|null} [chatmsgno] chat_msg chatmsgno
         * @property {number|null} [uid] chat_msg uid
         * @property {number|null} [msgtype] chat_msg msgtype
         * @property {number|null} [msgtime] chat_msg msgtime
         * @property {Uint8Array|null} [content] chat_msg content
         * @property {Uint8Array|null} [nickname] chat_msg nickname
         * @property {Uint8Array|null} [headurl] chat_msg headurl
         * @property {Uint8Array|null} [clientkey] chat_msg clientkey
         * @property {number|null} [snaptime] chat_msg snaptime
         * @property {number|null} [viplevel] chat_msg viplevel
         * @property {number|null} [isadmin] chat_msg isadmin
         * @property {Uint8Array|null} [firstname] chat_msg firstname
         * @property {Uint8Array|null} [lastname] chat_msg lastname
         * @property {number|null} [channel] chat_msg channel
         */

        /**
         * Constructs a new chat_msg.
         * @memberof net
         * @classdesc Represents a chat_msg.
         * @implements Ichat_msg
         * @constructor
         * @param {net.Ichat_msg=} [properties] Properties to set
         */
        function chat_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * chat_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * chat_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.chatmsgno = 0;

        /**
         * chat_msg uid.
         * @member {number} uid
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.uid = 0;

        /**
         * chat_msg msgtype.
         * @member {number} msgtype
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.msgtype = 0;

        /**
         * chat_msg msgtime.
         * @member {number} msgtime
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.msgtime = 0;

        /**
         * chat_msg content.
         * @member {Uint8Array} content
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.content = $util.newBuffer([]);

        /**
         * chat_msg nickname.
         * @member {Uint8Array} nickname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.nickname = $util.newBuffer([]);

        /**
         * chat_msg headurl.
         * @member {Uint8Array} headurl
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.headurl = $util.newBuffer([]);

        /**
         * chat_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * chat_msg snaptime.
         * @member {number} snaptime
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.snaptime = 0;

        /**
         * chat_msg viplevel.
         * @member {number} viplevel
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.viplevel = 0;

        /**
         * chat_msg isadmin.
         * @member {number} isadmin
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.isadmin = 0;

        /**
         * chat_msg firstname.
         * @member {Uint8Array} firstname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.firstname = $util.newBuffer([]);

        /**
         * chat_msg lastname.
         * @member {Uint8Array} lastname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.lastname = $util.newBuffer([]);

        /**
         * chat_msg channel.
         * @member {number} channel
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.channel = 0;

        /**
         * Creates a new chat_msg instance using the specified properties.
         * @function create
         * @memberof net.chat_msg
         * @static
         * @param {net.Ichat_msg=} [properties] Properties to set
         * @returns {net.chat_msg} chat_msg instance
         */
        chat_msg.create = function create(properties) {
            return new chat_msg(properties);
        };

        /**
         * Encodes the specified chat_msg message. Does not implicitly {@link net.chat_msg.verify|verify} messages.
         * @function encode
         * @memberof net.chat_msg
         * @static
         * @param {net.Ichat_msg} message chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.msgtype != null && Object.hasOwnProperty.call(message, "msgtype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.msgtype);
            if (message.msgtime != null && Object.hasOwnProperty.call(message, "msgtime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.msgtime);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.content);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.nickname);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.headurl);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.clientkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.snaptime);
            if (message.viplevel != null && Object.hasOwnProperty.call(message, "viplevel"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.viplevel);
            if (message.isadmin != null && Object.hasOwnProperty.call(message, "isadmin"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.isadmin);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.lastname);
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.channel);
            return writer;
        };

        /**
         * Encodes the specified chat_msg message, length delimited. Does not implicitly {@link net.chat_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.chat_msg
         * @static
         * @param {net.Ichat_msg} message chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a chat_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.chat_msg} chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.chat_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.msgtype = reader.int32();
                    break;
                case 5:
                    message.msgtime = reader.int32();
                    break;
                case 6:
                    message.content = reader.bytes();
                    break;
                case 7:
                    message.nickname = reader.bytes();
                    break;
                case 8:
                    message.headurl = reader.bytes();
                    break;
                case 9:
                    message.clientkey = reader.bytes();
                    break;
                case 10:
                    message.snaptime = reader.int32();
                    break;
                case 11:
                    message.viplevel = reader.int32();
                    break;
                case 12:
                    message.isadmin = reader.int32();
                    break;
                case 13:
                    message.firstname = reader.bytes();
                    break;
                case 14:
                    message.lastname = reader.bytes();
                    break;
                case 15:
                    message.channel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a chat_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.chat_msg} chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a chat_msg message.
         * @function verify
         * @memberof net.chat_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        chat_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.msgtype != null && message.hasOwnProperty("msgtype"))
                if (!$util.isInteger(message.msgtype))
                    return "msgtype: integer expected";
            if (message.msgtime != null && message.hasOwnProperty("msgtime"))
                if (!$util.isInteger(message.msgtime))
                    return "msgtime: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                if (!(message.clientkey && typeof message.clientkey.length === "number" || $util.isString(message.clientkey)))
                    return "clientkey: buffer expected";
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                if (!$util.isInteger(message.snaptime))
                    return "snaptime: integer expected";
            if (message.viplevel != null && message.hasOwnProperty("viplevel"))
                if (!$util.isInteger(message.viplevel))
                    return "viplevel: integer expected";
            if (message.isadmin != null && message.hasOwnProperty("isadmin"))
                if (!$util.isInteger(message.isadmin))
                    return "isadmin: integer expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!(message.firstname && typeof message.firstname.length === "number" || $util.isString(message.firstname)))
                    return "firstname: buffer expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!(message.lastname && typeof message.lastname.length === "number" || $util.isString(message.lastname)))
                    return "lastname: buffer expected";
            if (message.channel != null && message.hasOwnProperty("channel"))
                if (!$util.isInteger(message.channel))
                    return "channel: integer expected";
            return null;
        };

        /**
         * Creates a chat_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.chat_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.chat_msg} chat_msg
         */
        chat_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.chat_msg)
                return object;
            var message = new $root.net.chat_msg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.msgtype != null)
                message.msgtype = object.msgtype | 0;
            if (object.msgtime != null)
                message.msgtime = object.msgtime | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            if (object.clientkey != null)
                if (typeof object.clientkey === "string")
                    $util.base64.decode(object.clientkey, message.clientkey = $util.newBuffer($util.base64.length(object.clientkey)), 0);
                else if (object.clientkey.length)
                    message.clientkey = object.clientkey;
            if (object.snaptime != null)
                message.snaptime = object.snaptime | 0;
            if (object.viplevel != null)
                message.viplevel = object.viplevel | 0;
            if (object.isadmin != null)
                message.isadmin = object.isadmin | 0;
            if (object.firstname != null)
                if (typeof object.firstname === "string")
                    $util.base64.decode(object.firstname, message.firstname = $util.newBuffer($util.base64.length(object.firstname)), 0);
                else if (object.firstname.length)
                    message.firstname = object.firstname;
            if (object.lastname != null)
                if (typeof object.lastname === "string")
                    $util.base64.decode(object.lastname, message.lastname = $util.newBuffer($util.base64.length(object.lastname)), 0);
                else if (object.lastname.length)
                    message.lastname = object.lastname;
            if (object.channel != null)
                message.channel = object.channel | 0;
            return message;
        };

        /**
         * Creates a plain object from a chat_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.chat_msg
         * @static
         * @param {net.chat_msg} message chat_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        chat_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
                object.uid = 0;
                object.msgtype = 0;
                object.msgtime = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
                if (options.bytes === String)
                    object.clientkey = "";
                else {
                    object.clientkey = [];
                    if (options.bytes !== Array)
                        object.clientkey = $util.newBuffer(object.clientkey);
                }
                object.snaptime = 0;
                object.viplevel = 0;
                object.isadmin = 0;
                if (options.bytes === String)
                    object.firstname = "";
                else {
                    object.firstname = [];
                    if (options.bytes !== Array)
                        object.firstname = $util.newBuffer(object.firstname);
                }
                if (options.bytes === String)
                    object.lastname = "";
                else {
                    object.lastname = [];
                    if (options.bytes !== Array)
                        object.lastname = $util.newBuffer(object.lastname);
                }
                object.channel = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.msgtype != null && message.hasOwnProperty("msgtype"))
                object.msgtype = message.msgtype;
            if (message.msgtime != null && message.hasOwnProperty("msgtime"))
                object.msgtime = message.msgtime;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                object.clientkey = options.bytes === String ? $util.base64.encode(message.clientkey, 0, message.clientkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.clientkey) : message.clientkey;
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                object.snaptime = message.snaptime;
            if (message.viplevel != null && message.hasOwnProperty("viplevel"))
                object.viplevel = message.viplevel;
            if (message.isadmin != null && message.hasOwnProperty("isadmin"))
                object.isadmin = message.isadmin;
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = options.bytes === String ? $util.base64.encode(message.firstname, 0, message.firstname.length) : options.bytes === Array ? Array.prototype.slice.call(message.firstname) : message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = options.bytes === String ? $util.base64.encode(message.lastname, 0, message.lastname.length) : options.bytes === Array ? Array.prototype.slice.call(message.lastname) : message.lastname;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            return object;
        };

        /**
         * Converts this chat_msg to JSON.
         * @function toJSON
         * @memberof net.chat_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        chat_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return chat_msg;
    })();

    net.red_info = (function() {

        /**
         * Properties of a red_info.
         * @memberof net
         * @interface Ired_info
         * @property {number|null} [redtype] red_info redtype
         * @property {number|Long|null} [chatkey] red_info chatkey
         * @property {number|null} [uid] red_info uid
         * @property {Uint8Array|null} [content] red_info content
         * @property {number|null} [unread_apply_num] red_info unread_apply_num
         */

        /**
         * Constructs a new red_info.
         * @memberof net
         * @classdesc Represents a red_info.
         * @implements Ired_info
         * @constructor
         * @param {net.Ired_info=} [properties] Properties to set
         */
        function red_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * red_info redtype.
         * @member {number} redtype
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.redtype = 0;

        /**
         * red_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * red_info uid.
         * @member {number} uid
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.uid = 0;

        /**
         * red_info content.
         * @member {Uint8Array} content
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.content = $util.newBuffer([]);

        /**
         * red_info unread_apply_num.
         * @member {number} unread_apply_num
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.unread_apply_num = 0;

        /**
         * Creates a new red_info instance using the specified properties.
         * @function create
         * @memberof net.red_info
         * @static
         * @param {net.Ired_info=} [properties] Properties to set
         * @returns {net.red_info} red_info instance
         */
        red_info.create = function create(properties) {
            return new red_info(properties);
        };

        /**
         * Encodes the specified red_info message. Does not implicitly {@link net.red_info.verify|verify} messages.
         * @function encode
         * @memberof net.red_info
         * @static
         * @param {net.Ired_info} message red_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        red_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redtype != null && Object.hasOwnProperty.call(message, "redtype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redtype);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.content);
            if (message.unread_apply_num != null && Object.hasOwnProperty.call(message, "unread_apply_num"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.unread_apply_num);
            return writer;
        };

        /**
         * Encodes the specified red_info message, length delimited. Does not implicitly {@link net.red_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.red_info
         * @static
         * @param {net.Ired_info} message red_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        red_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a red_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.red_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.red_info} red_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        red_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.red_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redtype = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.content = reader.bytes();
                    break;
                case 5:
                    message.unread_apply_num = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a red_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.red_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.red_info} red_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        red_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a red_info message.
         * @function verify
         * @memberof net.red_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        red_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.redtype != null && message.hasOwnProperty("redtype"))
                if (!$util.isInteger(message.redtype))
                    return "redtype: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.unread_apply_num != null && message.hasOwnProperty("unread_apply_num"))
                if (!$util.isInteger(message.unread_apply_num))
                    return "unread_apply_num: integer expected";
            return null;
        };

        /**
         * Creates a red_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.red_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.red_info} red_info
         */
        red_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.red_info)
                return object;
            var message = new $root.net.red_info();
            if (object.redtype != null)
                message.redtype = object.redtype | 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.unread_apply_num != null)
                message.unread_apply_num = object.unread_apply_num | 0;
            return message;
        };

        /**
         * Creates a plain object from a red_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.red_info
         * @static
         * @param {net.red_info} message red_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        red_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.redtype = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.uid = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                object.unread_apply_num = 0;
            }
            if (message.redtype != null && message.hasOwnProperty("redtype"))
                object.redtype = message.redtype;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.unread_apply_num != null && message.hasOwnProperty("unread_apply_num"))
                object.unread_apply_num = message.unread_apply_num;
            return object;
        };

        /**
         * Converts this red_info to JSON.
         * @function toJSON
         * @memberof net.red_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        red_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return red_info;
    })();

    net.group_base_info = (function() {

        /**
         * Properties of a group_base_info.
         * @memberof net
         * @interface Igroup_base_info
         * @property {number|null} [groupkey] group_base_info groupkey
         * @property {number|null} [chatmsgno] group_base_info chatmsgno
         * @property {number|null} [attrversion] group_base_info attrversion
         * @property {number|null} [grouphost] group_base_info grouphost
         * @property {Uint8Array|null} [groupname] group_base_info groupname
         * @property {Uint8Array|null} [groupnotify] group_base_info groupnotify
         * @property {Array.<number>|null} [groupadmins] group_base_info groupadmins
         * @property {number|null} [info_limits] group_base_info info_limits
         * @property {number|null} [add_limits] group_base_info add_limits
         * @property {number|null} [look_limits] group_base_info look_limits
         * @property {number|null} [member_cnt] group_base_info member_cnt
         * @property {number|null} [send_msg_limits] group_base_info send_msg_limits
         * @property {number|null} [notifyversion] group_base_info notifyversion
         * @property {number|null} [forbidbegintm] group_base_info forbidbegintm
         * @property {number|null} [forbidendtm] group_base_info forbidendtm
         * @property {number|null} [isforbid] group_base_info isforbid
         * @property {Uint8Array|null} [groupheadurl] group_base_info groupheadurl
         * @property {number|null} [online_cnt] group_base_info online_cnt
         * @property {Array.<net.Igroup_admin_info>|null} [admins] group_base_info admins
         * @property {Uint8Array|null} [forbid_uids] group_base_info forbid_uids
         * @property {Uint8Array|null} [white_uids] group_base_info white_uids
         */

        /**
         * Constructs a new group_base_info.
         * @memberof net
         * @classdesc Represents a group_base_info.
         * @implements Igroup_base_info
         * @constructor
         * @param {net.Igroup_base_info=} [properties] Properties to set
         */
        function group_base_info(properties) {
            this.groupadmins = [];
            this.admins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_base_info groupkey.
         * @member {number} groupkey
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupkey = 0;

        /**
         * group_base_info chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.chatmsgno = 0;

        /**
         * group_base_info attrversion.
         * @member {number} attrversion
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.attrversion = 0;

        /**
         * group_base_info grouphost.
         * @member {number} grouphost
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.grouphost = 0;

        /**
         * group_base_info groupname.
         * @member {Uint8Array} groupname
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupname = $util.newBuffer([]);

        /**
         * group_base_info groupnotify.
         * @member {Uint8Array} groupnotify
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupnotify = $util.newBuffer([]);

        /**
         * group_base_info groupadmins.
         * @member {Array.<number>} groupadmins
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupadmins = $util.emptyArray;

        /**
         * group_base_info info_limits.
         * @member {number} info_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.info_limits = 0;

        /**
         * group_base_info add_limits.
         * @member {number} add_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.add_limits = 0;

        /**
         * group_base_info look_limits.
         * @member {number} look_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.look_limits = 0;

        /**
         * group_base_info member_cnt.
         * @member {number} member_cnt
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.member_cnt = 0;

        /**
         * group_base_info send_msg_limits.
         * @member {number} send_msg_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.send_msg_limits = 0;

        /**
         * group_base_info notifyversion.
         * @member {number} notifyversion
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.notifyversion = 0;

        /**
         * group_base_info forbidbegintm.
         * @member {number} forbidbegintm
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.forbidbegintm = 0;

        /**
         * group_base_info forbidendtm.
         * @member {number} forbidendtm
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.forbidendtm = 0;

        /**
         * group_base_info isforbid.
         * @member {number} isforbid
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.isforbid = 0;

        /**
         * group_base_info groupheadurl.
         * @member {Uint8Array} groupheadurl
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupheadurl = $util.newBuffer([]);

        /**
         * group_base_info online_cnt.
         * @member {number} online_cnt
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.online_cnt = 0;

        /**
         * group_base_info admins.
         * @member {Array.<net.Igroup_admin_info>} admins
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.admins = $util.emptyArray;

        /**
         * group_base_info forbid_uids.
         * @member {Uint8Array} forbid_uids
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.forbid_uids = $util.newBuffer([]);

        /**
         * group_base_info white_uids.
         * @member {Uint8Array} white_uids
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.white_uids = $util.newBuffer([]);

        /**
         * Creates a new group_base_info instance using the specified properties.
         * @function create
         * @memberof net.group_base_info
         * @static
         * @param {net.Igroup_base_info=} [properties] Properties to set
         * @returns {net.group_base_info} group_base_info instance
         */
        group_base_info.create = function create(properties) {
            return new group_base_info(properties);
        };

        /**
         * Encodes the specified group_base_info message. Does not implicitly {@link net.group_base_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_base_info
         * @static
         * @param {net.Igroup_base_info} message group_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            if (message.attrversion != null && Object.hasOwnProperty.call(message, "attrversion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.attrversion);
            if (message.grouphost != null && Object.hasOwnProperty.call(message, "grouphost"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.grouphost);
            if (message.groupname != null && Object.hasOwnProperty.call(message, "groupname"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.groupname);
            if (message.groupnotify != null && Object.hasOwnProperty.call(message, "groupnotify"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.groupnotify);
            if (message.groupadmins != null && message.groupadmins.length)
                for (var i = 0; i < message.groupadmins.length; ++i)
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.groupadmins[i]);
            if (message.info_limits != null && Object.hasOwnProperty.call(message, "info_limits"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.info_limits);
            if (message.add_limits != null && Object.hasOwnProperty.call(message, "add_limits"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.add_limits);
            if (message.look_limits != null && Object.hasOwnProperty.call(message, "look_limits"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.look_limits);
            if (message.member_cnt != null && Object.hasOwnProperty.call(message, "member_cnt"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.member_cnt);
            if (message.send_msg_limits != null && Object.hasOwnProperty.call(message, "send_msg_limits"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.send_msg_limits);
            if (message.notifyversion != null && Object.hasOwnProperty.call(message, "notifyversion"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.notifyversion);
            if (message.forbidbegintm != null && Object.hasOwnProperty.call(message, "forbidbegintm"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.forbidbegintm);
            if (message.forbidendtm != null && Object.hasOwnProperty.call(message, "forbidendtm"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.forbidendtm);
            if (message.isforbid != null && Object.hasOwnProperty.call(message, "isforbid"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.isforbid);
            if (message.groupheadurl != null && Object.hasOwnProperty.call(message, "groupheadurl"))
                writer.uint32(/* id 17, wireType 2 =*/138).bytes(message.groupheadurl);
            if (message.online_cnt != null && Object.hasOwnProperty.call(message, "online_cnt"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.online_cnt);
            if (message.admins != null && message.admins.length)
                for (var i = 0; i < message.admins.length; ++i)
                    $root.net.group_admin_info.encode(message.admins[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.forbid_uids != null && Object.hasOwnProperty.call(message, "forbid_uids"))
                writer.uint32(/* id 20, wireType 2 =*/162).bytes(message.forbid_uids);
            if (message.white_uids != null && Object.hasOwnProperty.call(message, "white_uids"))
                writer.uint32(/* id 21, wireType 2 =*/170).bytes(message.white_uids);
            return writer;
        };

        /**
         * Encodes the specified group_base_info message, length delimited. Does not implicitly {@link net.group_base_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.group_base_info
         * @static
         * @param {net.Igroup_base_info} message group_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_base_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a group_base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_base_info} group_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                case 3:
                    message.attrversion = reader.int32();
                    break;
                case 4:
                    message.grouphost = reader.int32();
                    break;
                case 5:
                    message.groupname = reader.bytes();
                    break;
                case 6:
                    message.groupnotify = reader.bytes();
                    break;
                case 7:
                    if (!(message.groupadmins && message.groupadmins.length))
                        message.groupadmins = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.groupadmins.push(reader.int32());
                    } else
                        message.groupadmins.push(reader.int32());
                    break;
                case 8:
                    message.info_limits = reader.int32();
                    break;
                case 9:
                    message.add_limits = reader.int32();
                    break;
                case 10:
                    message.look_limits = reader.int32();
                    break;
                case 11:
                    message.member_cnt = reader.int32();
                    break;
                case 12:
                    message.send_msg_limits = reader.int32();
                    break;
                case 13:
                    message.notifyversion = reader.int32();
                    break;
                case 14:
                    message.forbidbegintm = reader.int32();
                    break;
                case 15:
                    message.forbidendtm = reader.int32();
                    break;
                case 16:
                    message.isforbid = reader.int32();
                    break;
                case 17:
                    message.groupheadurl = reader.bytes();
                    break;
                case 18:
                    message.online_cnt = reader.int32();
                    break;
                case 19:
                    if (!(message.admins && message.admins.length))
                        message.admins = [];
                    message.admins.push($root.net.group_admin_info.decode(reader, reader.uint32()));
                    break;
                case 20:
                    message.forbid_uids = reader.bytes();
                    break;
                case 21:
                    message.white_uids = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a group_base_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.group_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.group_base_info} group_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_base_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a group_base_info message.
         * @function verify
         * @memberof net.group_base_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        group_base_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            if (message.attrversion != null && message.hasOwnProperty("attrversion"))
                if (!$util.isInteger(message.attrversion))
                    return "attrversion: integer expected";
            if (message.grouphost != null && message.hasOwnProperty("grouphost"))
                if (!$util.isInteger(message.grouphost))
                    return "grouphost: integer expected";
            if (message.groupname != null && message.hasOwnProperty("groupname"))
                if (!(message.groupname && typeof message.groupname.length === "number" || $util.isString(message.groupname)))
                    return "groupname: buffer expected";
            if (message.groupnotify != null && message.hasOwnProperty("groupnotify"))
                if (!(message.groupnotify && typeof message.groupnotify.length === "number" || $util.isString(message.groupnotify)))
                    return "groupnotify: buffer expected";
            if (message.groupadmins != null && message.hasOwnProperty("groupadmins")) {
                if (!Array.isArray(message.groupadmins))
                    return "groupadmins: array expected";
                for (var i = 0; i < message.groupadmins.length; ++i)
                    if (!$util.isInteger(message.groupadmins[i]))
                        return "groupadmins: integer[] expected";
            }
            if (message.info_limits != null && message.hasOwnProperty("info_limits"))
                if (!$util.isInteger(message.info_limits))
                    return "info_limits: integer expected";
            if (message.add_limits != null && message.hasOwnProperty("add_limits"))
                if (!$util.isInteger(message.add_limits))
                    return "add_limits: integer expected";
            if (message.look_limits != null && message.hasOwnProperty("look_limits"))
                if (!$util.isInteger(message.look_limits))
                    return "look_limits: integer expected";
            if (message.member_cnt != null && message.hasOwnProperty("member_cnt"))
                if (!$util.isInteger(message.member_cnt))
                    return "member_cnt: integer expected";
            if (message.send_msg_limits != null && message.hasOwnProperty("send_msg_limits"))
                if (!$util.isInteger(message.send_msg_limits))
                    return "send_msg_limits: integer expected";
            if (message.notifyversion != null && message.hasOwnProperty("notifyversion"))
                if (!$util.isInteger(message.notifyversion))
                    return "notifyversion: integer expected";
            if (message.forbidbegintm != null && message.hasOwnProperty("forbidbegintm"))
                if (!$util.isInteger(message.forbidbegintm))
                    return "forbidbegintm: integer expected";
            if (message.forbidendtm != null && message.hasOwnProperty("forbidendtm"))
                if (!$util.isInteger(message.forbidendtm))
                    return "forbidendtm: integer expected";
            if (message.isforbid != null && message.hasOwnProperty("isforbid"))
                if (!$util.isInteger(message.isforbid))
                    return "isforbid: integer expected";
            if (message.groupheadurl != null && message.hasOwnProperty("groupheadurl"))
                if (!(message.groupheadurl && typeof message.groupheadurl.length === "number" || $util.isString(message.groupheadurl)))
                    return "groupheadurl: buffer expected";
            if (message.online_cnt != null && message.hasOwnProperty("online_cnt"))
                if (!$util.isInteger(message.online_cnt))
                    return "online_cnt: integer expected";
            if (message.admins != null && message.hasOwnProperty("admins")) {
                if (!Array.isArray(message.admins))
                    return "admins: array expected";
                for (var i = 0; i < message.admins.length; ++i) {
                    var error = $root.net.group_admin_info.verify(message.admins[i]);
                    if (error)
                        return "admins." + error;
                }
            }
            if (message.forbid_uids != null && message.hasOwnProperty("forbid_uids"))
                if (!(message.forbid_uids && typeof message.forbid_uids.length === "number" || $util.isString(message.forbid_uids)))
                    return "forbid_uids: buffer expected";
            if (message.white_uids != null && message.hasOwnProperty("white_uids"))
                if (!(message.white_uids && typeof message.white_uids.length === "number" || $util.isString(message.white_uids)))
                    return "white_uids: buffer expected";
            return null;
        };

        /**
         * Creates a group_base_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.group_base_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.group_base_info} group_base_info
         */
        group_base_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.group_base_info)
                return object;
            var message = new $root.net.group_base_info();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            if (object.attrversion != null)
                message.attrversion = object.attrversion | 0;
            if (object.grouphost != null)
                message.grouphost = object.grouphost | 0;
            if (object.groupname != null)
                if (typeof object.groupname === "string")
                    $util.base64.decode(object.groupname, message.groupname = $util.newBuffer($util.base64.length(object.groupname)), 0);
                else if (object.groupname.length)
                    message.groupname = object.groupname;
            if (object.groupnotify != null)
                if (typeof object.groupnotify === "string")
                    $util.base64.decode(object.groupnotify, message.groupnotify = $util.newBuffer($util.base64.length(object.groupnotify)), 0);
                else if (object.groupnotify.length)
                    message.groupnotify = object.groupnotify;
            if (object.groupadmins) {
                if (!Array.isArray(object.groupadmins))
                    throw TypeError(".net.group_base_info.groupadmins: array expected");
                message.groupadmins = [];
                for (var i = 0; i < object.groupadmins.length; ++i)
                    message.groupadmins[i] = object.groupadmins[i] | 0;
            }
            if (object.info_limits != null)
                message.info_limits = object.info_limits | 0;
            if (object.add_limits != null)
                message.add_limits = object.add_limits | 0;
            if (object.look_limits != null)
                message.look_limits = object.look_limits | 0;
            if (object.member_cnt != null)
                message.member_cnt = object.member_cnt | 0;
            if (object.send_msg_limits != null)
                message.send_msg_limits = object.send_msg_limits | 0;
            if (object.notifyversion != null)
                message.notifyversion = object.notifyversion | 0;
            if (object.forbidbegintm != null)
                message.forbidbegintm = object.forbidbegintm | 0;
            if (object.forbidendtm != null)
                message.forbidendtm = object.forbidendtm | 0;
            if (object.isforbid != null)
                message.isforbid = object.isforbid | 0;
            if (object.groupheadurl != null)
                if (typeof object.groupheadurl === "string")
                    $util.base64.decode(object.groupheadurl, message.groupheadurl = $util.newBuffer($util.base64.length(object.groupheadurl)), 0);
                else if (object.groupheadurl.length)
                    message.groupheadurl = object.groupheadurl;
            if (object.online_cnt != null)
                message.online_cnt = object.online_cnt | 0;
            if (object.admins) {
                if (!Array.isArray(object.admins))
                    throw TypeError(".net.group_base_info.admins: array expected");
                message.admins = [];
                for (var i = 0; i < object.admins.length; ++i) {
                    if (typeof object.admins[i] !== "object")
                        throw TypeError(".net.group_base_info.admins: object expected");
                    message.admins[i] = $root.net.group_admin_info.fromObject(object.admins[i]);
                }
            }
            if (object.forbid_uids != null)
                if (typeof object.forbid_uids === "string")
                    $util.base64.decode(object.forbid_uids, message.forbid_uids = $util.newBuffer($util.base64.length(object.forbid_uids)), 0);
                else if (object.forbid_uids.length)
                    message.forbid_uids = object.forbid_uids;
            if (object.white_uids != null)
                if (typeof object.white_uids === "string")
                    $util.base64.decode(object.white_uids, message.white_uids = $util.newBuffer($util.base64.length(object.white_uids)), 0);
                else if (object.white_uids.length)
                    message.white_uids = object.white_uids;
            return message;
        };

        /**
         * Creates a plain object from a group_base_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.group_base_info
         * @static
         * @param {net.group_base_info} message group_base_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        group_base_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.groupadmins = [];
                object.admins = [];
            }
            if (options.defaults) {
                object.groupkey = 0;
                object.chatmsgno = 0;
                object.attrversion = 0;
                object.grouphost = 0;
                if (options.bytes === String)
                    object.groupname = "";
                else {
                    object.groupname = [];
                    if (options.bytes !== Array)
                        object.groupname = $util.newBuffer(object.groupname);
                }
                if (options.bytes === String)
                    object.groupnotify = "";
                else {
                    object.groupnotify = [];
                    if (options.bytes !== Array)
                        object.groupnotify = $util.newBuffer(object.groupnotify);
                }
                object.info_limits = 0;
                object.add_limits = 0;
                object.look_limits = 0;
                object.member_cnt = 0;
                object.send_msg_limits = 0;
                object.notifyversion = 0;
                object.forbidbegintm = 0;
                object.forbidendtm = 0;
                object.isforbid = 0;
                if (options.bytes === String)
                    object.groupheadurl = "";
                else {
                    object.groupheadurl = [];
                    if (options.bytes !== Array)
                        object.groupheadurl = $util.newBuffer(object.groupheadurl);
                }
                object.online_cnt = 0;
                if (options.bytes === String)
                    object.forbid_uids = "";
                else {
                    object.forbid_uids = [];
                    if (options.bytes !== Array)
                        object.forbid_uids = $util.newBuffer(object.forbid_uids);
                }
                if (options.bytes === String)
                    object.white_uids = "";
                else {
                    object.white_uids = [];
                    if (options.bytes !== Array)
                        object.white_uids = $util.newBuffer(object.white_uids);
                }
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            if (message.attrversion != null && message.hasOwnProperty("attrversion"))
                object.attrversion = message.attrversion;
            if (message.grouphost != null && message.hasOwnProperty("grouphost"))
                object.grouphost = message.grouphost;
            if (message.groupname != null && message.hasOwnProperty("groupname"))
                object.groupname = options.bytes === String ? $util.base64.encode(message.groupname, 0, message.groupname.length) : options.bytes === Array ? Array.prototype.slice.call(message.groupname) : message.groupname;
            if (message.groupnotify != null && message.hasOwnProperty("groupnotify"))
                object.groupnotify = options.bytes === String ? $util.base64.encode(message.groupnotify, 0, message.groupnotify.length) : options.bytes === Array ? Array.prototype.slice.call(message.groupnotify) : message.groupnotify;
            if (message.groupadmins && message.groupadmins.length) {
                object.groupadmins = [];
                for (var j = 0; j < message.groupadmins.length; ++j)
                    object.groupadmins[j] = message.groupadmins[j];
            }
            if (message.info_limits != null && message.hasOwnProperty("info_limits"))
                object.info_limits = message.info_limits;
            if (message.add_limits != null && message.hasOwnProperty("add_limits"))
                object.add_limits = message.add_limits;
            if (message.look_limits != null && message.hasOwnProperty("look_limits"))
                object.look_limits = message.look_limits;
            if (message.member_cnt != null && message.hasOwnProperty("member_cnt"))
                object.member_cnt = message.member_cnt;
            if (message.send_msg_limits != null && message.hasOwnProperty("send_msg_limits"))
                object.send_msg_limits = message.send_msg_limits;
            if (message.notifyversion != null && message.hasOwnProperty("notifyversion"))
                object.notifyversion = message.notifyversion;
            if (message.forbidbegintm != null && message.hasOwnProperty("forbidbegintm"))
                object.forbidbegintm = message.forbidbegintm;
            if (message.forbidendtm != null && message.hasOwnProperty("forbidendtm"))
                object.forbidendtm = message.forbidendtm;
            if (message.isforbid != null && message.hasOwnProperty("isforbid"))
                object.isforbid = message.isforbid;
            if (message.groupheadurl != null && message.hasOwnProperty("groupheadurl"))
                object.groupheadurl = options.bytes === String ? $util.base64.encode(message.groupheadurl, 0, message.groupheadurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.groupheadurl) : message.groupheadurl;
            if (message.online_cnt != null && message.hasOwnProperty("online_cnt"))
                object.online_cnt = message.online_cnt;
            if (message.admins && message.admins.length) {
                object.admins = [];
                for (var j = 0; j < message.admins.length; ++j)
                    object.admins[j] = $root.net.group_admin_info.toObject(message.admins[j], options);
            }
            if (message.forbid_uids != null && message.hasOwnProperty("forbid_uids"))
                object.forbid_uids = options.bytes === String ? $util.base64.encode(message.forbid_uids, 0, message.forbid_uids.length) : options.bytes === Array ? Array.prototype.slice.call(message.forbid_uids) : message.forbid_uids;
            if (message.white_uids != null && message.hasOwnProperty("white_uids"))
                object.white_uids = options.bytes === String ? $util.base64.encode(message.white_uids, 0, message.white_uids.length) : options.bytes === Array ? Array.prototype.slice.call(message.white_uids) : message.white_uids;
            return object;
        };

        /**
         * Converts this group_base_info to JSON.
         * @function toJSON
         * @memberof net.group_base_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        group_base_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return group_base_info;
    })();

    net.group_admin_info = (function() {

        /**
         * Properties of a group_admin_info.
         * @memberof net
         * @interface Igroup_admin_info
         * @property {number|null} [groupkey] group_admin_info groupkey
         * @property {number|null} [adminuid] group_admin_info adminuid
         * @property {number|null} [permission] group_admin_info permission
         */

        /**
         * Constructs a new group_admin_info.
         * @memberof net
         * @classdesc Represents a group_admin_info.
         * @implements Igroup_admin_info
         * @constructor
         * @param {net.Igroup_admin_info=} [properties] Properties to set
         */
        function group_admin_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_admin_info groupkey.
         * @member {number} groupkey
         * @memberof net.group_admin_info
         * @instance
         */
        group_admin_info.prototype.groupkey = 0;

        /**
         * group_admin_info adminuid.
         * @member {number} adminuid
         * @memberof net.group_admin_info
         * @instance
         */
        group_admin_info.prototype.adminuid = 0;

        /**
         * group_admin_info permission.
         * @member {number} permission
         * @memberof net.group_admin_info
         * @instance
         */
        group_admin_info.prototype.permission = 0;

        /**
         * Creates a new group_admin_info instance using the specified properties.
         * @function create
         * @memberof net.group_admin_info
         * @static
         * @param {net.Igroup_admin_info=} [properties] Properties to set
         * @returns {net.group_admin_info} group_admin_info instance
         */
        group_admin_info.create = function create(properties) {
            return new group_admin_info(properties);
        };

        /**
         * Encodes the specified group_admin_info message. Does not implicitly {@link net.group_admin_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_admin_info
         * @static
         * @param {net.Igroup_admin_info} message group_admin_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_admin_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.adminuid != null && Object.hasOwnProperty.call(message, "adminuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.adminuid);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.permission);
            return writer;
        };

        /**
         * Encodes the specified group_admin_info message, length delimited. Does not implicitly {@link net.group_admin_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.group_admin_info
         * @static
         * @param {net.Igroup_admin_info} message group_admin_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_admin_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a group_admin_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_admin_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_admin_info} group_admin_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_admin_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_admin_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.adminuid = reader.int32();
                    break;
                case 3:
                    message.permission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a group_admin_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.group_admin_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.group_admin_info} group_admin_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_admin_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a group_admin_info message.
         * @function verify
         * @memberof net.group_admin_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        group_admin_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.adminuid != null && message.hasOwnProperty("adminuid"))
                if (!$util.isInteger(message.adminuid))
                    return "adminuid: integer expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission))
                    return "permission: integer expected";
            return null;
        };

        /**
         * Creates a group_admin_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.group_admin_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.group_admin_info} group_admin_info
         */
        group_admin_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.group_admin_info)
                return object;
            var message = new $root.net.group_admin_info();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.adminuid != null)
                message.adminuid = object.adminuid | 0;
            if (object.permission != null)
                message.permission = object.permission | 0;
            return message;
        };

        /**
         * Creates a plain object from a group_admin_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.group_admin_info
         * @static
         * @param {net.group_admin_info} message group_admin_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        group_admin_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.adminuid = 0;
                object.permission = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.adminuid != null && message.hasOwnProperty("adminuid"))
                object.adminuid = message.adminuid;
            if (message.permission != null && message.hasOwnProperty("permission"))
                object.permission = message.permission;
            return object;
        };

        /**
         * Converts this group_admin_info to JSON.
         * @function toJSON
         * @memberof net.group_admin_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        group_admin_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return group_admin_info;
    })();

    net.redbag_get_record = (function() {

        /**
         * Properties of a redbag_get_record.
         * @memberof net
         * @interface Iredbag_get_record
         * @property {number|null} [uid] redbag_get_record uid
         * @property {Uint8Array|null} [nickname] redbag_get_record nickname
         * @property {number|null} [getvalue] redbag_get_record getvalue
         * @property {number|null} [gettime] redbag_get_record gettime
         * @property {Uint8Array|null} [headurl] redbag_get_record headurl
         */

        /**
         * Constructs a new redbag_get_record.
         * @memberof net
         * @classdesc Represents a redbag_get_record.
         * @implements Iredbag_get_record
         * @constructor
         * @param {net.Iredbag_get_record=} [properties] Properties to set
         */
        function redbag_get_record(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * redbag_get_record uid.
         * @member {number} uid
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.uid = 0;

        /**
         * redbag_get_record nickname.
         * @member {Uint8Array} nickname
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.nickname = $util.newBuffer([]);

        /**
         * redbag_get_record getvalue.
         * @member {number} getvalue
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.getvalue = 0;

        /**
         * redbag_get_record gettime.
         * @member {number} gettime
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.gettime = 0;

        /**
         * redbag_get_record headurl.
         * @member {Uint8Array} headurl
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.headurl = $util.newBuffer([]);

        /**
         * Creates a new redbag_get_record instance using the specified properties.
         * @function create
         * @memberof net.redbag_get_record
         * @static
         * @param {net.Iredbag_get_record=} [properties] Properties to set
         * @returns {net.redbag_get_record} redbag_get_record instance
         */
        redbag_get_record.create = function create(properties) {
            return new redbag_get_record(properties);
        };

        /**
         * Encodes the specified redbag_get_record message. Does not implicitly {@link net.redbag_get_record.verify|verify} messages.
         * @function encode
         * @memberof net.redbag_get_record
         * @static
         * @param {net.Iredbag_get_record} message redbag_get_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_get_record.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.getvalue != null && Object.hasOwnProperty.call(message, "getvalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.getvalue);
            if (message.gettime != null && Object.hasOwnProperty.call(message, "gettime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.gettime);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.headurl);
            return writer;
        };

        /**
         * Encodes the specified redbag_get_record message, length delimited. Does not implicitly {@link net.redbag_get_record.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.redbag_get_record
         * @static
         * @param {net.Iredbag_get_record} message redbag_get_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_get_record.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a redbag_get_record message from the specified reader or buffer.
         * @function decode
         * @memberof net.redbag_get_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.redbag_get_record} redbag_get_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_get_record.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.redbag_get_record();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.getvalue = reader.int32();
                    break;
                case 4:
                    message.gettime = reader.int32();
                    break;
                case 5:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a redbag_get_record message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.redbag_get_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.redbag_get_record} redbag_get_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_get_record.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a redbag_get_record message.
         * @function verify
         * @memberof net.redbag_get_record
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        redbag_get_record.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.getvalue != null && message.hasOwnProperty("getvalue"))
                if (!$util.isInteger(message.getvalue))
                    return "getvalue: integer expected";
            if (message.gettime != null && message.hasOwnProperty("gettime"))
                if (!$util.isInteger(message.gettime))
                    return "gettime: integer expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            return null;
        };

        /**
         * Creates a redbag_get_record message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.redbag_get_record
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.redbag_get_record} redbag_get_record
         */
        redbag_get_record.fromObject = function fromObject(object) {
            if (object instanceof $root.net.redbag_get_record)
                return object;
            var message = new $root.net.redbag_get_record();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.getvalue != null)
                message.getvalue = object.getvalue | 0;
            if (object.gettime != null)
                message.gettime = object.gettime | 0;
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            return message;
        };

        /**
         * Creates a plain object from a redbag_get_record message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.redbag_get_record
         * @static
         * @param {net.redbag_get_record} message redbag_get_record
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        redbag_get_record.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                object.getvalue = 0;
                object.gettime = 0;
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.getvalue != null && message.hasOwnProperty("getvalue"))
                object.getvalue = message.getvalue;
            if (message.gettime != null && message.hasOwnProperty("gettime"))
                object.gettime = message.gettime;
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            return object;
        };

        /**
         * Converts this redbag_get_record to JSON.
         * @function toJSON
         * @memberof net.redbag_get_record
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        redbag_get_record.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return redbag_get_record;
    })();

    net.oper_chatkey_info = (function() {

        /**
         * Properties of an oper_chatkey_info.
         * @memberof net
         * @interface Ioper_chatkey_info
         * @property {number|Long|null} [chatkey] oper_chatkey_info chatkey
         * @property {number|null} [opertime] oper_chatkey_info opertime
         */

        /**
         * Constructs a new oper_chatkey_info.
         * @memberof net
         * @classdesc Represents an oper_chatkey_info.
         * @implements Ioper_chatkey_info
         * @constructor
         * @param {net.Ioper_chatkey_info=} [properties] Properties to set
         */
        function oper_chatkey_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * oper_chatkey_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.oper_chatkey_info
         * @instance
         */
        oper_chatkey_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * oper_chatkey_info opertime.
         * @member {number} opertime
         * @memberof net.oper_chatkey_info
         * @instance
         */
        oper_chatkey_info.prototype.opertime = 0;

        /**
         * Creates a new oper_chatkey_info instance using the specified properties.
         * @function create
         * @memberof net.oper_chatkey_info
         * @static
         * @param {net.Ioper_chatkey_info=} [properties] Properties to set
         * @returns {net.oper_chatkey_info} oper_chatkey_info instance
         */
        oper_chatkey_info.create = function create(properties) {
            return new oper_chatkey_info(properties);
        };

        /**
         * Encodes the specified oper_chatkey_info message. Does not implicitly {@link net.oper_chatkey_info.verify|verify} messages.
         * @function encode
         * @memberof net.oper_chatkey_info
         * @static
         * @param {net.Ioper_chatkey_info} message oper_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        oper_chatkey_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertime != null && Object.hasOwnProperty.call(message, "opertime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertime);
            return writer;
        };

        /**
         * Encodes the specified oper_chatkey_info message, length delimited. Does not implicitly {@link net.oper_chatkey_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.oper_chatkey_info
         * @static
         * @param {net.Ioper_chatkey_info} message oper_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        oper_chatkey_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an oper_chatkey_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.oper_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.oper_chatkey_info} oper_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        oper_chatkey_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.oper_chatkey_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an oper_chatkey_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.oper_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.oper_chatkey_info} oper_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        oper_chatkey_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an oper_chatkey_info message.
         * @function verify
         * @memberof net.oper_chatkey_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        oper_chatkey_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertime != null && message.hasOwnProperty("opertime"))
                if (!$util.isInteger(message.opertime))
                    return "opertime: integer expected";
            return null;
        };

        /**
         * Creates an oper_chatkey_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.oper_chatkey_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.oper_chatkey_info} oper_chatkey_info
         */
        oper_chatkey_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.oper_chatkey_info)
                return object;
            var message = new $root.net.oper_chatkey_info();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertime != null)
                message.opertime = object.opertime | 0;
            return message;
        };

        /**
         * Creates a plain object from an oper_chatkey_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.oper_chatkey_info
         * @static
         * @param {net.oper_chatkey_info} message oper_chatkey_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        oper_chatkey_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertime = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertime != null && message.hasOwnProperty("opertime"))
                object.opertime = message.opertime;
            return object;
        };

        /**
         * Converts this oper_chatkey_info to JSON.
         * @function toJSON
         * @memberof net.oper_chatkey_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        oper_chatkey_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return oper_chatkey_info;
    })();

    net.snap_chatkey_info = (function() {

        /**
         * Properties of a snap_chatkey_info.
         * @memberof net
         * @interface Isnap_chatkey_info
         * @property {number|Long|null} [chatkey] snap_chatkey_info chatkey
         * @property {number|null} [snaptime] snap_chatkey_info snaptime
         */

        /**
         * Constructs a new snap_chatkey_info.
         * @memberof net
         * @classdesc Represents a snap_chatkey_info.
         * @implements Isnap_chatkey_info
         * @constructor
         * @param {net.Isnap_chatkey_info=} [properties] Properties to set
         */
        function snap_chatkey_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * snap_chatkey_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.snap_chatkey_info
         * @instance
         */
        snap_chatkey_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * snap_chatkey_info snaptime.
         * @member {number} snaptime
         * @memberof net.snap_chatkey_info
         * @instance
         */
        snap_chatkey_info.prototype.snaptime = 0;

        /**
         * Creates a new snap_chatkey_info instance using the specified properties.
         * @function create
         * @memberof net.snap_chatkey_info
         * @static
         * @param {net.Isnap_chatkey_info=} [properties] Properties to set
         * @returns {net.snap_chatkey_info} snap_chatkey_info instance
         */
        snap_chatkey_info.create = function create(properties) {
            return new snap_chatkey_info(properties);
        };

        /**
         * Encodes the specified snap_chatkey_info message. Does not implicitly {@link net.snap_chatkey_info.verify|verify} messages.
         * @function encode
         * @memberof net.snap_chatkey_info
         * @static
         * @param {net.Isnap_chatkey_info} message snap_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        snap_chatkey_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.snaptime);
            return writer;
        };

        /**
         * Encodes the specified snap_chatkey_info message, length delimited. Does not implicitly {@link net.snap_chatkey_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.snap_chatkey_info
         * @static
         * @param {net.Isnap_chatkey_info} message snap_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        snap_chatkey_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a snap_chatkey_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.snap_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.snap_chatkey_info} snap_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        snap_chatkey_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.snap_chatkey_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a snap_chatkey_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.snap_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.snap_chatkey_info} snap_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        snap_chatkey_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a snap_chatkey_info message.
         * @function verify
         * @memberof net.snap_chatkey_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        snap_chatkey_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                if (!$util.isInteger(message.snaptime))
                    return "snaptime: integer expected";
            return null;
        };

        /**
         * Creates a snap_chatkey_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.snap_chatkey_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.snap_chatkey_info} snap_chatkey_info
         */
        snap_chatkey_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.snap_chatkey_info)
                return object;
            var message = new $root.net.snap_chatkey_info();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.snaptime != null)
                message.snaptime = object.snaptime | 0;
            return message;
        };

        /**
         * Creates a plain object from a snap_chatkey_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.snap_chatkey_info
         * @static
         * @param {net.snap_chatkey_info} message snap_chatkey_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        snap_chatkey_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.snaptime = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                object.snaptime = message.snaptime;
            return object;
        };

        /**
         * Converts this snap_chatkey_info to JSON.
         * @function toJSON
         * @memberof net.snap_chatkey_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        snap_chatkey_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return snap_chatkey_info;
    })();

    net.alias_info = (function() {

        /**
         * Properties of an alias_info.
         * @memberof net
         * @interface Ialias_info
         * @property {number|null} [fuid] alias_info fuid
         * @property {Uint8Array|null} [aliasname] alias_info aliasname
         */

        /**
         * Constructs a new alias_info.
         * @memberof net
         * @classdesc Represents an alias_info.
         * @implements Ialias_info
         * @constructor
         * @param {net.Ialias_info=} [properties] Properties to set
         */
        function alias_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * alias_info fuid.
         * @member {number} fuid
         * @memberof net.alias_info
         * @instance
         */
        alias_info.prototype.fuid = 0;

        /**
         * alias_info aliasname.
         * @member {Uint8Array} aliasname
         * @memberof net.alias_info
         * @instance
         */
        alias_info.prototype.aliasname = $util.newBuffer([]);

        /**
         * Creates a new alias_info instance using the specified properties.
         * @function create
         * @memberof net.alias_info
         * @static
         * @param {net.Ialias_info=} [properties] Properties to set
         * @returns {net.alias_info} alias_info instance
         */
        alias_info.create = function create(properties) {
            return new alias_info(properties);
        };

        /**
         * Encodes the specified alias_info message. Does not implicitly {@link net.alias_info.verify|verify} messages.
         * @function encode
         * @memberof net.alias_info
         * @static
         * @param {net.Ialias_info} message alias_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        alias_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.aliasname != null && Object.hasOwnProperty.call(message, "aliasname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.aliasname);
            return writer;
        };

        /**
         * Encodes the specified alias_info message, length delimited. Does not implicitly {@link net.alias_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.alias_info
         * @static
         * @param {net.Ialias_info} message alias_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        alias_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an alias_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.alias_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.alias_info} alias_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        alias_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.alias_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.aliasname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an alias_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.alias_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.alias_info} alias_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        alias_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an alias_info message.
         * @function verify
         * @memberof net.alias_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        alias_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                if (!$util.isInteger(message.fuid))
                    return "fuid: integer expected";
            if (message.aliasname != null && message.hasOwnProperty("aliasname"))
                if (!(message.aliasname && typeof message.aliasname.length === "number" || $util.isString(message.aliasname)))
                    return "aliasname: buffer expected";
            return null;
        };

        /**
         * Creates an alias_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.alias_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.alias_info} alias_info
         */
        alias_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.alias_info)
                return object;
            var message = new $root.net.alias_info();
            if (object.fuid != null)
                message.fuid = object.fuid | 0;
            if (object.aliasname != null)
                if (typeof object.aliasname === "string")
                    $util.base64.decode(object.aliasname, message.aliasname = $util.newBuffer($util.base64.length(object.aliasname)), 0);
                else if (object.aliasname.length)
                    message.aliasname = object.aliasname;
            return message;
        };

        /**
         * Creates a plain object from an alias_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.alias_info
         * @static
         * @param {net.alias_info} message alias_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        alias_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fuid = 0;
                if (options.bytes === String)
                    object.aliasname = "";
                else {
                    object.aliasname = [];
                    if (options.bytes !== Array)
                        object.aliasname = $util.newBuffer(object.aliasname);
                }
            }
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                object.fuid = message.fuid;
            if (message.aliasname != null && message.hasOwnProperty("aliasname"))
                object.aliasname = options.bytes === String ? $util.base64.encode(message.aliasname, 0, message.aliasname.length) : options.bytes === Array ? Array.prototype.slice.call(message.aliasname) : message.aliasname;
            return object;
        };

        /**
         * Converts this alias_info to JSON.
         * @function toJSON
         * @memberof net.alias_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        alias_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return alias_info;
    })();

    net.redbag_base_info = (function() {

        /**
         * Properties of a redbag_base_info.
         * @memberof net
         * @interface Iredbag_base_info
         * @property {number|null} [redbag_id] redbag_base_info redbag_id
         * @property {number|null} [redbagtype] redbag_base_info redbagtype
         * @property {number|null} [redbagvalue] redbag_base_info redbagvalue
         * @property {number|null} [tm] redbag_base_info tm
         * @property {number|null} [uid] redbag_base_info uid
         * @property {Uint8Array|null} [nickname] redbag_base_info nickname
         * @property {number|null} [cointype] redbag_base_info cointype
         */

        /**
         * Constructs a new redbag_base_info.
         * @memberof net
         * @classdesc Represents a redbag_base_info.
         * @implements Iredbag_base_info
         * @constructor
         * @param {net.Iredbag_base_info=} [properties] Properties to set
         */
        function redbag_base_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * redbag_base_info redbag_id.
         * @member {number} redbag_id
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbag_id = 0;

        /**
         * redbag_base_info redbagtype.
         * @member {number} redbagtype
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbagtype = 0;

        /**
         * redbag_base_info redbagvalue.
         * @member {number} redbagvalue
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbagvalue = 0;

        /**
         * redbag_base_info tm.
         * @member {number} tm
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.tm = 0;

        /**
         * redbag_base_info uid.
         * @member {number} uid
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.uid = 0;

        /**
         * redbag_base_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.nickname = $util.newBuffer([]);

        /**
         * redbag_base_info cointype.
         * @member {number} cointype
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.cointype = 0;

        /**
         * Creates a new redbag_base_info instance using the specified properties.
         * @function create
         * @memberof net.redbag_base_info
         * @static
         * @param {net.Iredbag_base_info=} [properties] Properties to set
         * @returns {net.redbag_base_info} redbag_base_info instance
         */
        redbag_base_info.create = function create(properties) {
            return new redbag_base_info(properties);
        };

        /**
         * Encodes the specified redbag_base_info message. Does not implicitly {@link net.redbag_base_info.verify|verify} messages.
         * @function encode
         * @memberof net.redbag_base_info
         * @static
         * @param {net.Iredbag_base_info} message redbag_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            if (message.redbagtype != null && Object.hasOwnProperty.call(message, "redbagtype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.redbagtype);
            if (message.redbagvalue != null && Object.hasOwnProperty.call(message, "redbagvalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.redbagvalue);
            if (message.tm != null && Object.hasOwnProperty.call(message, "tm"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tm);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.nickname);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.cointype);
            return writer;
        };

        /**
         * Encodes the specified redbag_base_info message, length delimited. Does not implicitly {@link net.redbag_base_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.redbag_base_info
         * @static
         * @param {net.Iredbag_base_info} message redbag_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_base_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a redbag_base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.redbag_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.redbag_base_info} redbag_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.redbag_base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                case 2:
                    message.redbagtype = reader.int32();
                    break;
                case 3:
                    message.redbagvalue = reader.int32();
                    break;
                case 4:
                    message.tm = reader.int32();
                    break;
                case 5:
                    message.uid = reader.int32();
                    break;
                case 6:
                    message.nickname = reader.bytes();
                    break;
                case 7:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a redbag_base_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.redbag_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.redbag_base_info} redbag_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_base_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a redbag_base_info message.
         * @function verify
         * @memberof net.redbag_base_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        redbag_base_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                if (!$util.isInteger(message.redbag_id))
                    return "redbag_id: integer expected";
            if (message.redbagtype != null && message.hasOwnProperty("redbagtype"))
                if (!$util.isInteger(message.redbagtype))
                    return "redbagtype: integer expected";
            if (message.redbagvalue != null && message.hasOwnProperty("redbagvalue"))
                if (!$util.isInteger(message.redbagvalue))
                    return "redbagvalue: integer expected";
            if (message.tm != null && message.hasOwnProperty("tm"))
                if (!$util.isInteger(message.tm))
                    return "tm: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            return null;
        };

        /**
         * Creates a redbag_base_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.redbag_base_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.redbag_base_info} redbag_base_info
         */
        redbag_base_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.redbag_base_info)
                return object;
            var message = new $root.net.redbag_base_info();
            if (object.redbag_id != null)
                message.redbag_id = object.redbag_id | 0;
            if (object.redbagtype != null)
                message.redbagtype = object.redbagtype | 0;
            if (object.redbagvalue != null)
                message.redbagvalue = object.redbagvalue | 0;
            if (object.tm != null)
                message.tm = object.tm | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a redbag_base_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.redbag_base_info
         * @static
         * @param {net.redbag_base_info} message redbag_base_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        redbag_base_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.redbag_id = 0;
                object.redbagtype = 0;
                object.redbagvalue = 0;
                object.tm = 0;
                object.uid = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                object.cointype = 0;
            }
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                object.redbag_id = message.redbag_id;
            if (message.redbagtype != null && message.hasOwnProperty("redbagtype"))
                object.redbagtype = message.redbagtype;
            if (message.redbagvalue != null && message.hasOwnProperty("redbagvalue"))
                object.redbagvalue = message.redbagvalue;
            if (message.tm != null && message.hasOwnProperty("tm"))
                object.tm = message.tm;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            return object;
        };

        /**
         * Converts this redbag_base_info to JSON.
         * @function toJSON
         * @memberof net.redbag_base_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        redbag_base_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return redbag_base_info;
    })();

    net.money_change_info = (function() {

        /**
         * Properties of a money_change_info.
         * @memberof net
         * @interface Imoney_change_info
         * @property {number|null} [uid] money_change_info uid
         * @property {number|null} [otheruid] money_change_info otheruid
         * @property {Uint8Array|null} [othername] money_change_info othername
         * @property {number|null} [moneytype] money_change_info moneytype
         * @property {number|null} [amount] money_change_info amount
         * @property {Uint8Array|null} [remarks] money_change_info remarks
         * @property {number|null} [ptime] money_change_info ptime
         * @property {number|Long|null} [orderid] money_change_info orderid
         * @property {number|null} [cointype] money_change_info cointype
         * @property {number|null} [outcointype] money_change_info outcointype
         */

        /**
         * Constructs a new money_change_info.
         * @memberof net
         * @classdesc Represents a money_change_info.
         * @implements Imoney_change_info
         * @constructor
         * @param {net.Imoney_change_info=} [properties] Properties to set
         */
        function money_change_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * money_change_info uid.
         * @member {number} uid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.uid = 0;

        /**
         * money_change_info otheruid.
         * @member {number} otheruid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.otheruid = 0;

        /**
         * money_change_info othername.
         * @member {Uint8Array} othername
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.othername = $util.newBuffer([]);

        /**
         * money_change_info moneytype.
         * @member {number} moneytype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.moneytype = 0;

        /**
         * money_change_info amount.
         * @member {number} amount
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.amount = 0;

        /**
         * money_change_info remarks.
         * @member {Uint8Array} remarks
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.remarks = $util.newBuffer([]);

        /**
         * money_change_info ptime.
         * @member {number} ptime
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.ptime = 0;

        /**
         * money_change_info orderid.
         * @member {number|Long} orderid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * money_change_info cointype.
         * @member {number} cointype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.cointype = 0;

        /**
         * money_change_info outcointype.
         * @member {number} outcointype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.outcointype = 0;

        /**
         * Creates a new money_change_info instance using the specified properties.
         * @function create
         * @memberof net.money_change_info
         * @static
         * @param {net.Imoney_change_info=} [properties] Properties to set
         * @returns {net.money_change_info} money_change_info instance
         */
        money_change_info.create = function create(properties) {
            return new money_change_info(properties);
        };

        /**
         * Encodes the specified money_change_info message. Does not implicitly {@link net.money_change_info.verify|verify} messages.
         * @function encode
         * @memberof net.money_change_info
         * @static
         * @param {net.Imoney_change_info} message money_change_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        money_change_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.othername != null && Object.hasOwnProperty.call(message, "othername"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.othername);
            if (message.moneytype != null && Object.hasOwnProperty.call(message, "moneytype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.moneytype);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.amount);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.remarks);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ptime);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.orderid);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.outcointype);
            return writer;
        };

        /**
         * Encodes the specified money_change_info message, length delimited. Does not implicitly {@link net.money_change_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.money_change_info
         * @static
         * @param {net.Imoney_change_info} message money_change_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        money_change_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a money_change_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.money_change_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.money_change_info} money_change_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        money_change_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.money_change_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.othername = reader.bytes();
                    break;
                case 4:
                    message.moneytype = reader.int32();
                    break;
                case 5:
                    message.amount = reader.int32();
                    break;
                case 6:
                    message.remarks = reader.bytes();
                    break;
                case 7:
                    message.ptime = reader.int32();
                    break;
                case 8:
                    message.orderid = reader.int64();
                    break;
                case 9:
                    message.cointype = reader.int32();
                    break;
                case 10:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a money_change_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.money_change_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.money_change_info} money_change_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        money_change_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a money_change_info message.
         * @function verify
         * @memberof net.money_change_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        money_change_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.othername != null && message.hasOwnProperty("othername"))
                if (!(message.othername && typeof message.othername.length === "number" || $util.isString(message.othername)))
                    return "othername: buffer expected";
            if (message.moneytype != null && message.hasOwnProperty("moneytype"))
                if (!$util.isInteger(message.moneytype))
                    return "moneytype: integer expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount))
                    return "amount: integer expected";
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                if (!(message.remarks && typeof message.remarks.length === "number" || $util.isString(message.remarks)))
                    return "remarks: buffer expected";
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (!$util.isInteger(message.ptime))
                    return "ptime: integer expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            return null;
        };

        /**
         * Creates a money_change_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.money_change_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.money_change_info} money_change_info
         */
        money_change_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.money_change_info)
                return object;
            var message = new $root.net.money_change_info();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.othername != null)
                if (typeof object.othername === "string")
                    $util.base64.decode(object.othername, message.othername = $util.newBuffer($util.base64.length(object.othername)), 0);
                else if (object.othername.length)
                    message.othername = object.othername;
            if (object.moneytype != null)
                message.moneytype = object.moneytype | 0;
            if (object.amount != null)
                message.amount = object.amount | 0;
            if (object.remarks != null)
                if (typeof object.remarks === "string")
                    $util.base64.decode(object.remarks, message.remarks = $util.newBuffer($util.base64.length(object.remarks)), 0);
                else if (object.remarks.length)
                    message.remarks = object.remarks;
            if (object.ptime != null)
                message.ptime = object.ptime | 0;
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a money_change_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.money_change_info
         * @static
         * @param {net.money_change_info} message money_change_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        money_change_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.otheruid = 0;
                if (options.bytes === String)
                    object.othername = "";
                else {
                    object.othername = [];
                    if (options.bytes !== Array)
                        object.othername = $util.newBuffer(object.othername);
                }
                object.moneytype = 0;
                object.amount = 0;
                if (options.bytes === String)
                    object.remarks = "";
                else {
                    object.remarks = [];
                    if (options.bytes !== Array)
                        object.remarks = $util.newBuffer(object.remarks);
                }
                object.ptime = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                object.cointype = 0;
                object.outcointype = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.othername != null && message.hasOwnProperty("othername"))
                object.othername = options.bytes === String ? $util.base64.encode(message.othername, 0, message.othername.length) : options.bytes === Array ? Array.prototype.slice.call(message.othername) : message.othername;
            if (message.moneytype != null && message.hasOwnProperty("moneytype"))
                object.moneytype = message.moneytype;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = message.amount;
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                object.remarks = options.bytes === String ? $util.base64.encode(message.remarks, 0, message.remarks.length) : options.bytes === Array ? Array.prototype.slice.call(message.remarks) : message.remarks;
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                object.ptime = message.ptime;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            return object;
        };

        /**
         * Converts this money_change_info to JSON.
         * @function toJSON
         * @memberof net.money_change_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        money_change_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return money_change_info;
    })();

    net.mobile_pay_info = (function() {

        /**
         * Properties of a mobile_pay_info.
         * @memberof net
         * @interface Imobile_pay_info
         * @property {number|null} [id] mobile_pay_info id
         * @property {number|null} [uid] mobile_pay_info uid
         * @property {number|null} [paytype] mobile_pay_info paytype
         * @property {Uint8Array|null} [accountname] mobile_pay_info accountname
         * @property {Uint8Array|null} [phoneno] mobile_pay_info phoneno
         * @property {number|null} [addfriendtype] mobile_pay_info addfriendtype
         * @property {Uint8Array|null} [name] mobile_pay_info name
         * @property {Uint8Array|null} [bankcode] mobile_pay_info bankcode
         */

        /**
         * Constructs a new mobile_pay_info.
         * @memberof net
         * @classdesc Represents a mobile_pay_info.
         * @implements Imobile_pay_info
         * @constructor
         * @param {net.Imobile_pay_info=} [properties] Properties to set
         */
        function mobile_pay_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * mobile_pay_info id.
         * @member {number} id
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.id = 0;

        /**
         * mobile_pay_info uid.
         * @member {number} uid
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.uid = 0;

        /**
         * mobile_pay_info paytype.
         * @member {number} paytype
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.paytype = 0;

        /**
         * mobile_pay_info accountname.
         * @member {Uint8Array} accountname
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.accountname = $util.newBuffer([]);

        /**
         * mobile_pay_info phoneno.
         * @member {Uint8Array} phoneno
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.phoneno = $util.newBuffer([]);

        /**
         * mobile_pay_info addfriendtype.
         * @member {number} addfriendtype
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.addfriendtype = 0;

        /**
         * mobile_pay_info name.
         * @member {Uint8Array} name
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.name = $util.newBuffer([]);

        /**
         * mobile_pay_info bankcode.
         * @member {Uint8Array} bankcode
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.bankcode = $util.newBuffer([]);

        /**
         * Creates a new mobile_pay_info instance using the specified properties.
         * @function create
         * @memberof net.mobile_pay_info
         * @static
         * @param {net.Imobile_pay_info=} [properties] Properties to set
         * @returns {net.mobile_pay_info} mobile_pay_info instance
         */
        mobile_pay_info.create = function create(properties) {
            return new mobile_pay_info(properties);
        };

        /**
         * Encodes the specified mobile_pay_info message. Does not implicitly {@link net.mobile_pay_info.verify|verify} messages.
         * @function encode
         * @memberof net.mobile_pay_info
         * @static
         * @param {net.Imobile_pay_info} message mobile_pay_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        mobile_pay_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytype);
            if (message.accountname != null && Object.hasOwnProperty.call(message, "accountname"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.accountname);
            if (message.phoneno != null && Object.hasOwnProperty.call(message, "phoneno"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.phoneno);
            if (message.addfriendtype != null && Object.hasOwnProperty.call(message, "addfriendtype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.addfriendtype);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.name);
            if (message.bankcode != null && Object.hasOwnProperty.call(message, "bankcode"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.bankcode);
            return writer;
        };

        /**
         * Encodes the specified mobile_pay_info message, length delimited. Does not implicitly {@link net.mobile_pay_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.mobile_pay_info
         * @static
         * @param {net.Imobile_pay_info} message mobile_pay_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        mobile_pay_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a mobile_pay_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.mobile_pay_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.mobile_pay_info} mobile_pay_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        mobile_pay_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.mobile_pay_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.paytype = reader.int32();
                    break;
                case 4:
                    message.accountname = reader.bytes();
                    break;
                case 5:
                    message.phoneno = reader.bytes();
                    break;
                case 6:
                    message.addfriendtype = reader.int32();
                    break;
                case 7:
                    message.name = reader.bytes();
                    break;
                case 8:
                    message.bankcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a mobile_pay_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.mobile_pay_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.mobile_pay_info} mobile_pay_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        mobile_pay_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a mobile_pay_info message.
         * @function verify
         * @memberof net.mobile_pay_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        mobile_pay_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.accountname != null && message.hasOwnProperty("accountname"))
                if (!(message.accountname && typeof message.accountname.length === "number" || $util.isString(message.accountname)))
                    return "accountname: buffer expected";
            if (message.phoneno != null && message.hasOwnProperty("phoneno"))
                if (!(message.phoneno && typeof message.phoneno.length === "number" || $util.isString(message.phoneno)))
                    return "phoneno: buffer expected";
            if (message.addfriendtype != null && message.hasOwnProperty("addfriendtype"))
                if (!$util.isInteger(message.addfriendtype))
                    return "addfriendtype: integer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!(message.name && typeof message.name.length === "number" || $util.isString(message.name)))
                    return "name: buffer expected";
            if (message.bankcode != null && message.hasOwnProperty("bankcode"))
                if (!(message.bankcode && typeof message.bankcode.length === "number" || $util.isString(message.bankcode)))
                    return "bankcode: buffer expected";
            return null;
        };

        /**
         * Creates a mobile_pay_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.mobile_pay_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.mobile_pay_info} mobile_pay_info
         */
        mobile_pay_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.mobile_pay_info)
                return object;
            var message = new $root.net.mobile_pay_info();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.accountname != null)
                if (typeof object.accountname === "string")
                    $util.base64.decode(object.accountname, message.accountname = $util.newBuffer($util.base64.length(object.accountname)), 0);
                else if (object.accountname.length)
                    message.accountname = object.accountname;
            if (object.phoneno != null)
                if (typeof object.phoneno === "string")
                    $util.base64.decode(object.phoneno, message.phoneno = $util.newBuffer($util.base64.length(object.phoneno)), 0);
                else if (object.phoneno.length)
                    message.phoneno = object.phoneno;
            if (object.addfriendtype != null)
                message.addfriendtype = object.addfriendtype | 0;
            if (object.name != null)
                if (typeof object.name === "string")
                    $util.base64.decode(object.name, message.name = $util.newBuffer($util.base64.length(object.name)), 0);
                else if (object.name.length)
                    message.name = object.name;
            if (object.bankcode != null)
                if (typeof object.bankcode === "string")
                    $util.base64.decode(object.bankcode, message.bankcode = $util.newBuffer($util.base64.length(object.bankcode)), 0);
                else if (object.bankcode.length)
                    message.bankcode = object.bankcode;
            return message;
        };

        /**
         * Creates a plain object from a mobile_pay_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.mobile_pay_info
         * @static
         * @param {net.mobile_pay_info} message mobile_pay_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        mobile_pay_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = 0;
                object.uid = 0;
                object.paytype = 0;
                if (options.bytes === String)
                    object.accountname = "";
                else {
                    object.accountname = [];
                    if (options.bytes !== Array)
                        object.accountname = $util.newBuffer(object.accountname);
                }
                if (options.bytes === String)
                    object.phoneno = "";
                else {
                    object.phoneno = [];
                    if (options.bytes !== Array)
                        object.phoneno = $util.newBuffer(object.phoneno);
                }
                object.addfriendtype = 0;
                if (options.bytes === String)
                    object.name = "";
                else {
                    object.name = [];
                    if (options.bytes !== Array)
                        object.name = $util.newBuffer(object.name);
                }
                if (options.bytes === String)
                    object.bankcode = "";
                else {
                    object.bankcode = [];
                    if (options.bytes !== Array)
                        object.bankcode = $util.newBuffer(object.bankcode);
                }
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.accountname != null && message.hasOwnProperty("accountname"))
                object.accountname = options.bytes === String ? $util.base64.encode(message.accountname, 0, message.accountname.length) : options.bytes === Array ? Array.prototype.slice.call(message.accountname) : message.accountname;
            if (message.phoneno != null && message.hasOwnProperty("phoneno"))
                object.phoneno = options.bytes === String ? $util.base64.encode(message.phoneno, 0, message.phoneno.length) : options.bytes === Array ? Array.prototype.slice.call(message.phoneno) : message.phoneno;
            if (message.addfriendtype != null && message.hasOwnProperty("addfriendtype"))
                object.addfriendtype = message.addfriendtype;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = options.bytes === String ? $util.base64.encode(message.name, 0, message.name.length) : options.bytes === Array ? Array.prototype.slice.call(message.name) : message.name;
            if (message.bankcode != null && message.hasOwnProperty("bankcode"))
                object.bankcode = options.bytes === String ? $util.base64.encode(message.bankcode, 0, message.bankcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.bankcode) : message.bankcode;
            return object;
        };

        /**
         * Converts this mobile_pay_info to JSON.
         * @function toJSON
         * @memberof net.mobile_pay_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        mobile_pay_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return mobile_pay_info;
    })();

    net.goods_info = (function() {

        /**
         * Properties of a goods_info.
         * @memberof net
         * @interface Igoods_info
         * @property {number|Long|null} [goodsid] goods_info goodsid
         * @property {number|null} [goodsvalue] goods_info goodsvalue
         * @property {number|null} [uid] goods_info uid
         * @property {number|null} [minlimit] goods_info minlimit
         * @property {number|null} [maxlimit] goods_info maxlimit
         * @property {number|null} [cointype] goods_info cointype
         * @property {number|null} [rate] goods_info rate
         * @property {number|null} [status] goods_info status
         * @property {number|null} [ptime] goods_info ptime
         * @property {Uint8Array|null} [username] goods_info username
         * @property {Array.<number>|null} [paylist] goods_info paylist
         * @property {Uint8Array|null} [headurl] goods_info headurl
         * @property {number|null} [dealnum] goods_info dealnum
         * @property {number|null} [goodstype] goods_info goodstype
         * @property {number|null} [outcointype] goods_info outcointype
         * @property {Array.<net.Imobile_pay_info>|null} [payinfolist] goods_info payinfolist
         */

        /**
         * Constructs a new goods_info.
         * @memberof net
         * @classdesc Represents a goods_info.
         * @implements Igoods_info
         * @constructor
         * @param {net.Igoods_info=} [properties] Properties to set
         */
        function goods_info(properties) {
            this.paylist = [];
            this.payinfolist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * goods_info goodsid.
         * @member {number|Long} goodsid
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * goods_info goodsvalue.
         * @member {number} goodsvalue
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodsvalue = 0;

        /**
         * goods_info uid.
         * @member {number} uid
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.uid = 0;

        /**
         * goods_info minlimit.
         * @member {number} minlimit
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.minlimit = 0;

        /**
         * goods_info maxlimit.
         * @member {number} maxlimit
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.maxlimit = 0;

        /**
         * goods_info cointype.
         * @member {number} cointype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.cointype = 0;

        /**
         * goods_info rate.
         * @member {number} rate
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.rate = 0;

        /**
         * goods_info status.
         * @member {number} status
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.status = 0;

        /**
         * goods_info ptime.
         * @member {number} ptime
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.ptime = 0;

        /**
         * goods_info username.
         * @member {Uint8Array} username
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.username = $util.newBuffer([]);

        /**
         * goods_info paylist.
         * @member {Array.<number>} paylist
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.paylist = $util.emptyArray;

        /**
         * goods_info headurl.
         * @member {Uint8Array} headurl
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.headurl = $util.newBuffer([]);

        /**
         * goods_info dealnum.
         * @member {number} dealnum
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.dealnum = 0;

        /**
         * goods_info goodstype.
         * @member {number} goodstype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodstype = 0;

        /**
         * goods_info outcointype.
         * @member {number} outcointype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.outcointype = 0;

        /**
         * goods_info payinfolist.
         * @member {Array.<net.Imobile_pay_info>} payinfolist
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.payinfolist = $util.emptyArray;

        /**
         * Creates a new goods_info instance using the specified properties.
         * @function create
         * @memberof net.goods_info
         * @static
         * @param {net.Igoods_info=} [properties] Properties to set
         * @returns {net.goods_info} goods_info instance
         */
        goods_info.create = function create(properties) {
            return new goods_info(properties);
        };

        /**
         * Encodes the specified goods_info message. Does not implicitly {@link net.goods_info.verify|verify} messages.
         * @function encode
         * @memberof net.goods_info
         * @static
         * @param {net.Igoods_info} message goods_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.goodsid);
            if (message.goodsvalue != null && Object.hasOwnProperty.call(message, "goodsvalue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.goodsvalue);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.minlimit != null && Object.hasOwnProperty.call(message, "minlimit"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minlimit);
            if (message.maxlimit != null && Object.hasOwnProperty.call(message, "maxlimit"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxlimit);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cointype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.rate);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.ptime);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.username);
            if (message.paylist != null && message.paylist.length)
                for (var i = 0; i < message.paylist.length; ++i)
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.paylist[i]);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.headurl);
            if (message.dealnum != null && Object.hasOwnProperty.call(message, "dealnum"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.dealnum);
            if (message.goodstype != null && Object.hasOwnProperty.call(message, "goodstype"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.goodstype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.outcointype);
            if (message.payinfolist != null && message.payinfolist.length)
                for (var i = 0; i < message.payinfolist.length; ++i)
                    $root.net.mobile_pay_info.encode(message.payinfolist[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified goods_info message, length delimited. Does not implicitly {@link net.goods_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.goods_info
         * @static
         * @param {net.Igoods_info} message goods_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a goods_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.goods_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.goods_info} goods_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.goods_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsid = reader.int64();
                    break;
                case 2:
                    message.goodsvalue = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.minlimit = reader.int32();
                    break;
                case 5:
                    message.maxlimit = reader.int32();
                    break;
                case 6:
                    message.cointype = reader.int32();
                    break;
                case 7:
                    message.rate = reader.int32();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.ptime = reader.int32();
                    break;
                case 10:
                    message.username = reader.bytes();
                    break;
                case 11:
                    if (!(message.paylist && message.paylist.length))
                        message.paylist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.paylist.push(reader.int32());
                    } else
                        message.paylist.push(reader.int32());
                    break;
                case 12:
                    message.headurl = reader.bytes();
                    break;
                case 13:
                    message.dealnum = reader.int32();
                    break;
                case 14:
                    message.goodstype = reader.int32();
                    break;
                case 15:
                    message.outcointype = reader.int32();
                    break;
                case 16:
                    if (!(message.payinfolist && message.payinfolist.length))
                        message.payinfolist = [];
                    message.payinfolist.push($root.net.mobile_pay_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a goods_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.goods_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.goods_info} goods_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a goods_info message.
         * @function verify
         * @memberof net.goods_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        goods_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (!$util.isInteger(message.goodsid) && !(message.goodsid && $util.isInteger(message.goodsid.low) && $util.isInteger(message.goodsid.high)))
                    return "goodsid: integer|Long expected";
            if (message.goodsvalue != null && message.hasOwnProperty("goodsvalue"))
                if (!$util.isInteger(message.goodsvalue))
                    return "goodsvalue: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.minlimit != null && message.hasOwnProperty("minlimit"))
                if (!$util.isInteger(message.minlimit))
                    return "minlimit: integer expected";
            if (message.maxlimit != null && message.hasOwnProperty("maxlimit"))
                if (!$util.isInteger(message.maxlimit))
                    return "maxlimit: integer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.rate != null && message.hasOwnProperty("rate"))
                if (!$util.isInteger(message.rate))
                    return "rate: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (!$util.isInteger(message.ptime))
                    return "ptime: integer expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!(message.username && typeof message.username.length === "number" || $util.isString(message.username)))
                    return "username: buffer expected";
            if (message.paylist != null && message.hasOwnProperty("paylist")) {
                if (!Array.isArray(message.paylist))
                    return "paylist: array expected";
                for (var i = 0; i < message.paylist.length; ++i)
                    if (!$util.isInteger(message.paylist[i]))
                        return "paylist: integer[] expected";
            }
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            if (message.dealnum != null && message.hasOwnProperty("dealnum"))
                if (!$util.isInteger(message.dealnum))
                    return "dealnum: integer expected";
            if (message.goodstype != null && message.hasOwnProperty("goodstype"))
                if (!$util.isInteger(message.goodstype))
                    return "goodstype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            if (message.payinfolist != null && message.hasOwnProperty("payinfolist")) {
                if (!Array.isArray(message.payinfolist))
                    return "payinfolist: array expected";
                for (var i = 0; i < message.payinfolist.length; ++i) {
                    var error = $root.net.mobile_pay_info.verify(message.payinfolist[i]);
                    if (error)
                        return "payinfolist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a goods_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.goods_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.goods_info} goods_info
         */
        goods_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.goods_info)
                return object;
            var message = new $root.net.goods_info();
            if (object.goodsid != null)
                if ($util.Long)
                    (message.goodsid = $util.Long.fromValue(object.goodsid)).unsigned = false;
                else if (typeof object.goodsid === "string")
                    message.goodsid = parseInt(object.goodsid, 10);
                else if (typeof object.goodsid === "number")
                    message.goodsid = object.goodsid;
                else if (typeof object.goodsid === "object")
                    message.goodsid = new $util.LongBits(object.goodsid.low >>> 0, object.goodsid.high >>> 0).toNumber();
            if (object.goodsvalue != null)
                message.goodsvalue = object.goodsvalue | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.minlimit != null)
                message.minlimit = object.minlimit | 0;
            if (object.maxlimit != null)
                message.maxlimit = object.maxlimit | 0;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.rate != null)
                message.rate = object.rate | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.ptime != null)
                message.ptime = object.ptime | 0;
            if (object.username != null)
                if (typeof object.username === "string")
                    $util.base64.decode(object.username, message.username = $util.newBuffer($util.base64.length(object.username)), 0);
                else if (object.username.length)
                    message.username = object.username;
            if (object.paylist) {
                if (!Array.isArray(object.paylist))
                    throw TypeError(".net.goods_info.paylist: array expected");
                message.paylist = [];
                for (var i = 0; i < object.paylist.length; ++i)
                    message.paylist[i] = object.paylist[i] | 0;
            }
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            if (object.dealnum != null)
                message.dealnum = object.dealnum | 0;
            if (object.goodstype != null)
                message.goodstype = object.goodstype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            if (object.payinfolist) {
                if (!Array.isArray(object.payinfolist))
                    throw TypeError(".net.goods_info.payinfolist: array expected");
                message.payinfolist = [];
                for (var i = 0; i < object.payinfolist.length; ++i) {
                    if (typeof object.payinfolist[i] !== "object")
                        throw TypeError(".net.goods_info.payinfolist: object expected");
                    message.payinfolist[i] = $root.net.mobile_pay_info.fromObject(object.payinfolist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a goods_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.goods_info
         * @static
         * @param {net.goods_info} message goods_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        goods_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.paylist = [];
                object.payinfolist = [];
            }
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.goodsid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.goodsid = options.longs === String ? "0" : 0;
                object.goodsvalue = 0;
                object.uid = 0;
                object.minlimit = 0;
                object.maxlimit = 0;
                object.cointype = 0;
                object.rate = 0;
                object.status = 0;
                object.ptime = 0;
                if (options.bytes === String)
                    object.username = "";
                else {
                    object.username = [];
                    if (options.bytes !== Array)
                        object.username = $util.newBuffer(object.username);
                }
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
                object.dealnum = 0;
                object.goodstype = 0;
                object.outcointype = 0;
            }
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (typeof message.goodsid === "number")
                    object.goodsid = options.longs === String ? String(message.goodsid) : message.goodsid;
                else
                    object.goodsid = options.longs === String ? $util.Long.prototype.toString.call(message.goodsid) : options.longs === Number ? new $util.LongBits(message.goodsid.low >>> 0, message.goodsid.high >>> 0).toNumber() : message.goodsid;
            if (message.goodsvalue != null && message.hasOwnProperty("goodsvalue"))
                object.goodsvalue = message.goodsvalue;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.minlimit != null && message.hasOwnProperty("minlimit"))
                object.minlimit = message.minlimit;
            if (message.maxlimit != null && message.hasOwnProperty("maxlimit"))
                object.maxlimit = message.maxlimit;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.rate != null && message.hasOwnProperty("rate"))
                object.rate = message.rate;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                object.ptime = message.ptime;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = options.bytes === String ? $util.base64.encode(message.username, 0, message.username.length) : options.bytes === Array ? Array.prototype.slice.call(message.username) : message.username;
            if (message.paylist && message.paylist.length) {
                object.paylist = [];
                for (var j = 0; j < message.paylist.length; ++j)
                    object.paylist[j] = message.paylist[j];
            }
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            if (message.dealnum != null && message.hasOwnProperty("dealnum"))
                object.dealnum = message.dealnum;
            if (message.goodstype != null && message.hasOwnProperty("goodstype"))
                object.goodstype = message.goodstype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            if (message.payinfolist && message.payinfolist.length) {
                object.payinfolist = [];
                for (var j = 0; j < message.payinfolist.length; ++j)
                    object.payinfolist[j] = $root.net.mobile_pay_info.toObject(message.payinfolist[j], options);
            }
            return object;
        };

        /**
         * Converts this goods_info to JSON.
         * @function toJSON
         * @memberof net.goods_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        goods_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return goods_info;
    })();

    net.order_info = (function() {

        /**
         * Properties of an order_info.
         * @memberof net
         * @interface Iorder_info
         * @property {number|Long|null} [orderid] order_info orderid
         * @property {number|Long|null} [goodsid] order_info goodsid
         * @property {number|null} [ordertype] order_info ordertype
         * @property {number|null} [buyer] order_info buyer
         * @property {number|null} [seller] order_info seller
         * @property {number|null} [status] order_info status
         * @property {number|null} [ordervalue] order_info ordervalue
         * @property {number|null} [expiretm] order_info expiretm
         * @property {number|null} [paytype] order_info paytype
         * @property {number|null} [rate] order_info rate
         * @property {number|null} [createtm] order_info createtm
         * @property {number|null} [cancelflag] order_info cancelflag
         * @property {number|null} [cointype] order_info cointype
         * @property {number|null} [outcointype] order_info outcointype
         */

        /**
         * Constructs a new order_info.
         * @memberof net
         * @classdesc Represents an order_info.
         * @implements Iorder_info
         * @constructor
         * @param {net.Iorder_info=} [properties] Properties to set
         */
        function order_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * order_info orderid.
         * @member {number|Long} orderid
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * order_info goodsid.
         * @member {number|Long} goodsid
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * order_info ordertype.
         * @member {number} ordertype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.ordertype = 0;

        /**
         * order_info buyer.
         * @member {number} buyer
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.buyer = 0;

        /**
         * order_info seller.
         * @member {number} seller
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.seller = 0;

        /**
         * order_info status.
         * @member {number} status
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.status = 0;

        /**
         * order_info ordervalue.
         * @member {number} ordervalue
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.ordervalue = 0;

        /**
         * order_info expiretm.
         * @member {number} expiretm
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.expiretm = 0;

        /**
         * order_info paytype.
         * @member {number} paytype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.paytype = 0;

        /**
         * order_info rate.
         * @member {number} rate
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.rate = 0;

        /**
         * order_info createtm.
         * @member {number} createtm
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.createtm = 0;

        /**
         * order_info cancelflag.
         * @member {number} cancelflag
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.cancelflag = 0;

        /**
         * order_info cointype.
         * @member {number} cointype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.cointype = 0;

        /**
         * order_info outcointype.
         * @member {number} outcointype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.outcointype = 0;

        /**
         * Creates a new order_info instance using the specified properties.
         * @function create
         * @memberof net.order_info
         * @static
         * @param {net.Iorder_info=} [properties] Properties to set
         * @returns {net.order_info} order_info instance
         */
        order_info.create = function create(properties) {
            return new order_info(properties);
        };

        /**
         * Encodes the specified order_info message. Does not implicitly {@link net.order_info.verify|verify} messages.
         * @function encode
         * @memberof net.order_info
         * @static
         * @param {net.Iorder_info} message order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        order_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.goodsid);
            if (message.ordertype != null && Object.hasOwnProperty.call(message, "ordertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ordertype);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.seller);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
            if (message.ordervalue != null && Object.hasOwnProperty.call(message, "ordervalue"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ordervalue);
            if (message.expiretm != null && Object.hasOwnProperty.call(message, "expiretm"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.expiretm);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.paytype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.rate);
            if (message.createtm != null && Object.hasOwnProperty.call(message, "createtm"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.createtm);
            if (message.cancelflag != null && Object.hasOwnProperty.call(message, "cancelflag"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.cancelflag);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.outcointype);
            return writer;
        };

        /**
         * Encodes the specified order_info message, length delimited. Does not implicitly {@link net.order_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.order_info
         * @static
         * @param {net.Iorder_info} message order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        order_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an order_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.order_info} order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        order_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.order_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.goodsid = reader.int64();
                    break;
                case 3:
                    message.ordertype = reader.int32();
                    break;
                case 4:
                    message.buyer = reader.int32();
                    break;
                case 5:
                    message.seller = reader.int32();
                    break;
                case 6:
                    message.status = reader.int32();
                    break;
                case 7:
                    message.ordervalue = reader.int32();
                    break;
                case 8:
                    message.expiretm = reader.int32();
                    break;
                case 9:
                    message.paytype = reader.int32();
                    break;
                case 10:
                    message.rate = reader.int32();
                    break;
                case 11:
                    message.createtm = reader.int32();
                    break;
                case 12:
                    message.cancelflag = reader.int32();
                    break;
                case 13:
                    message.cointype = reader.int32();
                    break;
                case 14:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an order_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.order_info} order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        order_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an order_info message.
         * @function verify
         * @memberof net.order_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        order_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (!$util.isInteger(message.goodsid) && !(message.goodsid && $util.isInteger(message.goodsid.low) && $util.isInteger(message.goodsid.high)))
                    return "goodsid: integer|Long expected";
            if (message.ordertype != null && message.hasOwnProperty("ordertype"))
                if (!$util.isInteger(message.ordertype))
                    return "ordertype: integer expected";
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                if (!$util.isInteger(message.buyer))
                    return "buyer: integer expected";
            if (message.seller != null && message.hasOwnProperty("seller"))
                if (!$util.isInteger(message.seller))
                    return "seller: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.ordervalue != null && message.hasOwnProperty("ordervalue"))
                if (!$util.isInteger(message.ordervalue))
                    return "ordervalue: integer expected";
            if (message.expiretm != null && message.hasOwnProperty("expiretm"))
                if (!$util.isInteger(message.expiretm))
                    return "expiretm: integer expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.rate != null && message.hasOwnProperty("rate"))
                if (!$util.isInteger(message.rate))
                    return "rate: integer expected";
            if (message.createtm != null && message.hasOwnProperty("createtm"))
                if (!$util.isInteger(message.createtm))
                    return "createtm: integer expected";
            if (message.cancelflag != null && message.hasOwnProperty("cancelflag"))
                if (!$util.isInteger(message.cancelflag))
                    return "cancelflag: integer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            return null;
        };

        /**
         * Creates an order_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.order_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.order_info} order_info
         */
        order_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.order_info)
                return object;
            var message = new $root.net.order_info();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.goodsid != null)
                if ($util.Long)
                    (message.goodsid = $util.Long.fromValue(object.goodsid)).unsigned = false;
                else if (typeof object.goodsid === "string")
                    message.goodsid = parseInt(object.goodsid, 10);
                else if (typeof object.goodsid === "number")
                    message.goodsid = object.goodsid;
                else if (typeof object.goodsid === "object")
                    message.goodsid = new $util.LongBits(object.goodsid.low >>> 0, object.goodsid.high >>> 0).toNumber();
            if (object.ordertype != null)
                message.ordertype = object.ordertype | 0;
            if (object.buyer != null)
                message.buyer = object.buyer | 0;
            if (object.seller != null)
                message.seller = object.seller | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.ordervalue != null)
                message.ordervalue = object.ordervalue | 0;
            if (object.expiretm != null)
                message.expiretm = object.expiretm | 0;
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.rate != null)
                message.rate = object.rate | 0;
            if (object.createtm != null)
                message.createtm = object.createtm | 0;
            if (object.cancelflag != null)
                message.cancelflag = object.cancelflag | 0;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            return message;
        };

        /**
         * Creates a plain object from an order_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.order_info
         * @static
         * @param {net.order_info} message order_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        order_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.goodsid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.goodsid = options.longs === String ? "0" : 0;
                object.ordertype = 0;
                object.buyer = 0;
                object.seller = 0;
                object.status = 0;
                object.ordervalue = 0;
                object.expiretm = 0;
                object.paytype = 0;
                object.rate = 0;
                object.createtm = 0;
                object.cancelflag = 0;
                object.cointype = 0;
                object.outcointype = 0;
            }
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (typeof message.goodsid === "number")
                    object.goodsid = options.longs === String ? String(message.goodsid) : message.goodsid;
                else
                    object.goodsid = options.longs === String ? $util.Long.prototype.toString.call(message.goodsid) : options.longs === Number ? new $util.LongBits(message.goodsid.low >>> 0, message.goodsid.high >>> 0).toNumber() : message.goodsid;
            if (message.ordertype != null && message.hasOwnProperty("ordertype"))
                object.ordertype = message.ordertype;
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                object.buyer = message.buyer;
            if (message.seller != null && message.hasOwnProperty("seller"))
                object.seller = message.seller;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.ordervalue != null && message.hasOwnProperty("ordervalue"))
                object.ordervalue = message.ordervalue;
            if (message.expiretm != null && message.hasOwnProperty("expiretm"))
                object.expiretm = message.expiretm;
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.rate != null && message.hasOwnProperty("rate"))
                object.rate = message.rate;
            if (message.createtm != null && message.hasOwnProperty("createtm"))
                object.createtm = message.createtm;
            if (message.cancelflag != null && message.hasOwnProperty("cancelflag"))
                object.cancelflag = message.cancelflag;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            return object;
        };

        /**
         * Converts this order_info to JSON.
         * @function toJSON
         * @memberof net.order_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        order_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return order_info;
    })();

    net.group_nickname_info = (function() {

        /**
         * Properties of a group_nickname_info.
         * @memberof net
         * @interface Igroup_nickname_info
         * @property {number|null} [uid] group_nickname_info uid
         * @property {Uint8Array|null} [nickname] group_nickname_info nickname
         */

        /**
         * Constructs a new group_nickname_info.
         * @memberof net
         * @classdesc Represents a group_nickname_info.
         * @implements Igroup_nickname_info
         * @constructor
         * @param {net.Igroup_nickname_info=} [properties] Properties to set
         */
        function group_nickname_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_nickname_info uid.
         * @member {number} uid
         * @memberof net.group_nickname_info
         * @instance
         */
        group_nickname_info.prototype.uid = 0;

        /**
         * group_nickname_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.group_nickname_info
         * @instance
         */
        group_nickname_info.prototype.nickname = $util.newBuffer([]);

        /**
         * Creates a new group_nickname_info instance using the specified properties.
         * @function create
         * @memberof net.group_nickname_info
         * @static
         * @param {net.Igroup_nickname_info=} [properties] Properties to set
         * @returns {net.group_nickname_info} group_nickname_info instance
         */
        group_nickname_info.create = function create(properties) {
            return new group_nickname_info(properties);
        };

        /**
         * Encodes the specified group_nickname_info message. Does not implicitly {@link net.group_nickname_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_nickname_info
         * @static
         * @param {net.Igroup_nickname_info} message group_nickname_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_nickname_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            return writer;
        };

        /**
         * Encodes the specified group_nickname_info message, length delimited. Does not implicitly {@link net.group_nickname_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.group_nickname_info
         * @static
         * @param {net.Igroup_nickname_info} message group_nickname_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_nickname_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a group_nickname_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_nickname_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_nickname_info} group_nickname_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_nickname_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_nickname_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a group_nickname_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.group_nickname_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.group_nickname_info} group_nickname_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_nickname_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a group_nickname_info message.
         * @function verify
         * @memberof net.group_nickname_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        group_nickname_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            return null;
        };

        /**
         * Creates a group_nickname_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.group_nickname_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.group_nickname_info} group_nickname_info
         */
        group_nickname_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.group_nickname_info)
                return object;
            var message = new $root.net.group_nickname_info();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            return message;
        };

        /**
         * Creates a plain object from a group_nickname_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.group_nickname_info
         * @static
         * @param {net.group_nickname_info} message group_nickname_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        group_nickname_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            return object;
        };

        /**
         * Converts this group_nickname_info to JSON.
         * @function toJSON
         * @memberof net.group_nickname_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        group_nickname_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return group_nickname_info;
    })();

    net.customer_info = (function() {

        /**
         * Properties of a customer_info.
         * @memberof net
         * @interface Icustomer_info
         * @property {number|null} [customer_type] customer_info customer_type
         * @property {number|null} [uid] customer_info uid
         */

        /**
         * Constructs a new customer_info.
         * @memberof net
         * @classdesc Represents a customer_info.
         * @implements Icustomer_info
         * @constructor
         * @param {net.Icustomer_info=} [properties] Properties to set
         */
        function customer_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * customer_info customer_type.
         * @member {number} customer_type
         * @memberof net.customer_info
         * @instance
         */
        customer_info.prototype.customer_type = 0;

        /**
         * customer_info uid.
         * @member {number} uid
         * @memberof net.customer_info
         * @instance
         */
        customer_info.prototype.uid = 0;

        /**
         * Creates a new customer_info instance using the specified properties.
         * @function create
         * @memberof net.customer_info
         * @static
         * @param {net.Icustomer_info=} [properties] Properties to set
         * @returns {net.customer_info} customer_info instance
         */
        customer_info.create = function create(properties) {
            return new customer_info(properties);
        };

        /**
         * Encodes the specified customer_info message. Does not implicitly {@link net.customer_info.verify|verify} messages.
         * @function encode
         * @memberof net.customer_info
         * @static
         * @param {net.Icustomer_info} message customer_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        customer_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customer_type != null && Object.hasOwnProperty.call(message, "customer_type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.customer_type);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified customer_info message, length delimited. Does not implicitly {@link net.customer_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.customer_info
         * @static
         * @param {net.Icustomer_info} message customer_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        customer_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a customer_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.customer_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.customer_info} customer_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        customer_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.customer_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customer_type = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a customer_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.customer_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.customer_info} customer_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        customer_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a customer_info message.
         * @function verify
         * @memberof net.customer_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        customer_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customer_type != null && message.hasOwnProperty("customer_type"))
                if (!$util.isInteger(message.customer_type))
                    return "customer_type: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a customer_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.customer_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.customer_info} customer_info
         */
        customer_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.customer_info)
                return object;
            var message = new $root.net.customer_info();
            if (object.customer_type != null)
                message.customer_type = object.customer_type | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a customer_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.customer_info
         * @static
         * @param {net.customer_info} message customer_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        customer_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.customer_type = 0;
                object.uid = 0;
            }
            if (message.customer_type != null && message.hasOwnProperty("customer_type"))
                object.customer_type = message.customer_type;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this customer_info to JSON.
         * @function toJSON
         * @memberof net.customer_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        customer_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return customer_info;
    })();

    net.coin_info = (function() {

        /**
         * Properties of a coin_info.
         * @memberof net
         * @interface Icoin_info
         * @property {number|null} [cointype] coin_info cointype
         * @property {number|null} [coin] coin_info coin
         * @property {number|null} [freezecoin] coin_info freezecoin
         * @property {number|null} [shopcoin] coin_info shopcoin
         * @property {number|null} [shopfreezecoin] coin_info shopfreezecoin
         */

        /**
         * Constructs a new coin_info.
         * @memberof net
         * @classdesc Represents a coin_info.
         * @implements Icoin_info
         * @constructor
         * @param {net.Icoin_info=} [properties] Properties to set
         */
        function coin_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * coin_info cointype.
         * @member {number} cointype
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.cointype = 0;

        /**
         * coin_info coin.
         * @member {number} coin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.coin = 0;

        /**
         * coin_info freezecoin.
         * @member {number} freezecoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.freezecoin = 0;

        /**
         * coin_info shopcoin.
         * @member {number} shopcoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.shopcoin = 0;

        /**
         * coin_info shopfreezecoin.
         * @member {number} shopfreezecoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.shopfreezecoin = 0;

        /**
         * Creates a new coin_info instance using the specified properties.
         * @function create
         * @memberof net.coin_info
         * @static
         * @param {net.Icoin_info=} [properties] Properties to set
         * @returns {net.coin_info} coin_info instance
         */
        coin_info.create = function create(properties) {
            return new coin_info(properties);
        };

        /**
         * Encodes the specified coin_info message. Does not implicitly {@link net.coin_info.verify|verify} messages.
         * @function encode
         * @memberof net.coin_info
         * @static
         * @param {net.Icoin_info} message coin_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        coin_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cointype);
            if (message.coin != null && Object.hasOwnProperty.call(message, "coin"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.coin);
            if (message.freezecoin != null && Object.hasOwnProperty.call(message, "freezecoin"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.freezecoin);
            if (message.shopcoin != null && Object.hasOwnProperty.call(message, "shopcoin"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.shopcoin);
            if (message.shopfreezecoin != null && Object.hasOwnProperty.call(message, "shopfreezecoin"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.shopfreezecoin);
            return writer;
        };

        /**
         * Encodes the specified coin_info message, length delimited. Does not implicitly {@link net.coin_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.coin_info
         * @static
         * @param {net.Icoin_info} message coin_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        coin_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a coin_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.coin_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.coin_info} coin_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        coin_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.coin_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cointype = reader.int32();
                    break;
                case 2:
                    message.coin = reader.int32();
                    break;
                case 3:
                    message.freezecoin = reader.int32();
                    break;
                case 4:
                    message.shopcoin = reader.int32();
                    break;
                case 5:
                    message.shopfreezecoin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a coin_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.coin_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.coin_info} coin_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        coin_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a coin_info message.
         * @function verify
         * @memberof net.coin_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        coin_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (!$util.isInteger(message.coin))
                    return "coin: integer expected";
            if (message.freezecoin != null && message.hasOwnProperty("freezecoin"))
                if (!$util.isInteger(message.freezecoin))
                    return "freezecoin: integer expected";
            if (message.shopcoin != null && message.hasOwnProperty("shopcoin"))
                if (!$util.isInteger(message.shopcoin))
                    return "shopcoin: integer expected";
            if (message.shopfreezecoin != null && message.hasOwnProperty("shopfreezecoin"))
                if (!$util.isInteger(message.shopfreezecoin))
                    return "shopfreezecoin: integer expected";
            return null;
        };

        /**
         * Creates a coin_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.coin_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.coin_info} coin_info
         */
        coin_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.coin_info)
                return object;
            var message = new $root.net.coin_info();
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.coin != null)
                message.coin = object.coin | 0;
            if (object.freezecoin != null)
                message.freezecoin = object.freezecoin | 0;
            if (object.shopcoin != null)
                message.shopcoin = object.shopcoin | 0;
            if (object.shopfreezecoin != null)
                message.shopfreezecoin = object.shopfreezecoin | 0;
            return message;
        };

        /**
         * Creates a plain object from a coin_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.coin_info
         * @static
         * @param {net.coin_info} message coin_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        coin_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cointype = 0;
                object.coin = 0;
                object.freezecoin = 0;
                object.shopcoin = 0;
                object.shopfreezecoin = 0;
            }
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = message.coin;
            if (message.freezecoin != null && message.hasOwnProperty("freezecoin"))
                object.freezecoin = message.freezecoin;
            if (message.shopcoin != null && message.hasOwnProperty("shopcoin"))
                object.shopcoin = message.shopcoin;
            if (message.shopfreezecoin != null && message.hasOwnProperty("shopfreezecoin"))
                object.shopfreezecoin = message.shopfreezecoin;
            return object;
        };

        /**
         * Converts this coin_info to JSON.
         * @function toJSON
         * @memberof net.coin_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        coin_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return coin_info;
    })();

    net.rate_info = (function() {

        /**
         * Properties of a rate_info.
         * @memberof net
         * @interface Irate_info
         * @property {number|null} [cointype] rate_info cointype
         * @property {number|null} [outcointype] rate_info outcointype
         * @property {number|null} [crate] rate_info crate
         * @property {number|null} [trate] rate_info trate
         * @property {number|null} [drate] rate_info drate
         * @property {number|null} [crate1] rate_info crate1
         * @property {number|null} [trate1] rate_info trate1
         * @property {number|null} [drate1] rate_info drate1
         */

        /**
         * Constructs a new rate_info.
         * @memberof net
         * @classdesc Represents a rate_info.
         * @implements Irate_info
         * @constructor
         * @param {net.Irate_info=} [properties] Properties to set
         */
        function rate_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * rate_info cointype.
         * @member {number} cointype
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.cointype = 0;

        /**
         * rate_info outcointype.
         * @member {number} outcointype
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.outcointype = 0;

        /**
         * rate_info crate.
         * @member {number} crate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.crate = 0;

        /**
         * rate_info trate.
         * @member {number} trate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.trate = 0;

        /**
         * rate_info drate.
         * @member {number} drate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.drate = 0;

        /**
         * rate_info crate1.
         * @member {number} crate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.crate1 = 0;

        /**
         * rate_info trate1.
         * @member {number} trate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.trate1 = 0;

        /**
         * rate_info drate1.
         * @member {number} drate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.drate1 = 0;

        /**
         * Creates a new rate_info instance using the specified properties.
         * @function create
         * @memberof net.rate_info
         * @static
         * @param {net.Irate_info=} [properties] Properties to set
         * @returns {net.rate_info} rate_info instance
         */
        rate_info.create = function create(properties) {
            return new rate_info(properties);
        };

        /**
         * Encodes the specified rate_info message. Does not implicitly {@link net.rate_info.verify|verify} messages.
         * @function encode
         * @memberof net.rate_info
         * @static
         * @param {net.Irate_info} message rate_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        rate_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.outcointype);
            if (message.crate != null && Object.hasOwnProperty.call(message, "crate"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.crate);
            if (message.trate != null && Object.hasOwnProperty.call(message, "trate"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.trate);
            if (message.drate != null && Object.hasOwnProperty.call(message, "drate"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.drate);
            if (message.crate1 != null && Object.hasOwnProperty.call(message, "crate1"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.crate1);
            if (message.trate1 != null && Object.hasOwnProperty.call(message, "trate1"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.trate1);
            if (message.drate1 != null && Object.hasOwnProperty.call(message, "drate1"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.drate1);
            return writer;
        };

        /**
         * Encodes the specified rate_info message, length delimited. Does not implicitly {@link net.rate_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.rate_info
         * @static
         * @param {net.Irate_info} message rate_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        rate_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a rate_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.rate_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.rate_info} rate_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        rate_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.rate_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cointype = reader.int32();
                    break;
                case 2:
                    message.outcointype = reader.int32();
                    break;
                case 3:
                    message.crate = reader.int32();
                    break;
                case 4:
                    message.trate = reader.int32();
                    break;
                case 5:
                    message.drate = reader.int32();
                    break;
                case 6:
                    message.crate1 = reader.int32();
                    break;
                case 7:
                    message.trate1 = reader.int32();
                    break;
                case 8:
                    message.drate1 = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a rate_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.rate_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.rate_info} rate_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        rate_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a rate_info message.
         * @function verify
         * @memberof net.rate_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        rate_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            if (message.crate != null && message.hasOwnProperty("crate"))
                if (!$util.isInteger(message.crate))
                    return "crate: integer expected";
            if (message.trate != null && message.hasOwnProperty("trate"))
                if (!$util.isInteger(message.trate))
                    return "trate: integer expected";
            if (message.drate != null && message.hasOwnProperty("drate"))
                if (!$util.isInteger(message.drate))
                    return "drate: integer expected";
            if (message.crate1 != null && message.hasOwnProperty("crate1"))
                if (!$util.isInteger(message.crate1))
                    return "crate1: integer expected";
            if (message.trate1 != null && message.hasOwnProperty("trate1"))
                if (!$util.isInteger(message.trate1))
                    return "trate1: integer expected";
            if (message.drate1 != null && message.hasOwnProperty("drate1"))
                if (!$util.isInteger(message.drate1))
                    return "drate1: integer expected";
            return null;
        };

        /**
         * Creates a rate_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.rate_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.rate_info} rate_info
         */
        rate_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.rate_info)
                return object;
            var message = new $root.net.rate_info();
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            if (object.crate != null)
                message.crate = object.crate | 0;
            if (object.trate != null)
                message.trate = object.trate | 0;
            if (object.drate != null)
                message.drate = object.drate | 0;
            if (object.crate1 != null)
                message.crate1 = object.crate1 | 0;
            if (object.trate1 != null)
                message.trate1 = object.trate1 | 0;
            if (object.drate1 != null)
                message.drate1 = object.drate1 | 0;
            return message;
        };

        /**
         * Creates a plain object from a rate_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.rate_info
         * @static
         * @param {net.rate_info} message rate_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        rate_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cointype = 0;
                object.outcointype = 0;
                object.crate = 0;
                object.trate = 0;
                object.drate = 0;
                object.crate1 = 0;
                object.trate1 = 0;
                object.drate1 = 0;
            }
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            if (message.crate != null && message.hasOwnProperty("crate"))
                object.crate = message.crate;
            if (message.trate != null && message.hasOwnProperty("trate"))
                object.trate = message.trate;
            if (message.drate != null && message.hasOwnProperty("drate"))
                object.drate = message.drate;
            if (message.crate1 != null && message.hasOwnProperty("crate1"))
                object.crate1 = message.crate1;
            if (message.trate1 != null && message.hasOwnProperty("trate1"))
                object.trate1 = message.trate1;
            if (message.drate1 != null && message.hasOwnProperty("drate1"))
                object.drate1 = message.drate1;
            return object;
        };

        /**
         * Converts this rate_info to JSON.
         * @function toJSON
         * @memberof net.rate_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        rate_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return rate_info;
    })();

    net.goods_deal_data = (function() {

        /**
         * Properties of a goods_deal_data.
         * @memberof net
         * @interface Igoods_deal_data
         * @property {number|null} [cnum] goods_deal_data cnum
         * @property {number|null} [cval] goods_deal_data cval
         * @property {number|null} [tnum] goods_deal_data tnum
         * @property {number|null} [tval] goods_deal_data tval
         * @property {number|null} [innum] goods_deal_data innum
         * @property {number|null} [inval] goods_deal_data inval
         * @property {number|null} [outnum] goods_deal_data outnum
         * @property {number|null} [outval] goods_deal_data outval
         * @property {number|null} [cointype] goods_deal_data cointype
         */

        /**
         * Constructs a new goods_deal_data.
         * @memberof net
         * @classdesc Represents a goods_deal_data.
         * @implements Igoods_deal_data
         * @constructor
         * @param {net.Igoods_deal_data=} [properties] Properties to set
         */
        function goods_deal_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * goods_deal_data cnum.
         * @member {number} cnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cnum = 0;

        /**
         * goods_deal_data cval.
         * @member {number} cval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cval = 0;

        /**
         * goods_deal_data tnum.
         * @member {number} tnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.tnum = 0;

        /**
         * goods_deal_data tval.
         * @member {number} tval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.tval = 0;

        /**
         * goods_deal_data innum.
         * @member {number} innum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.innum = 0;

        /**
         * goods_deal_data inval.
         * @member {number} inval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.inval = 0;

        /**
         * goods_deal_data outnum.
         * @member {number} outnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.outnum = 0;

        /**
         * goods_deal_data outval.
         * @member {number} outval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.outval = 0;

        /**
         * goods_deal_data cointype.
         * @member {number} cointype
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cointype = 0;

        /**
         * Creates a new goods_deal_data instance using the specified properties.
         * @function create
         * @memberof net.goods_deal_data
         * @static
         * @param {net.Igoods_deal_data=} [properties] Properties to set
         * @returns {net.goods_deal_data} goods_deal_data instance
         */
        goods_deal_data.create = function create(properties) {
            return new goods_deal_data(properties);
        };

        /**
         * Encodes the specified goods_deal_data message. Does not implicitly {@link net.goods_deal_data.verify|verify} messages.
         * @function encode
         * @memberof net.goods_deal_data
         * @static
         * @param {net.Igoods_deal_data} message goods_deal_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_deal_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cnum != null && Object.hasOwnProperty.call(message, "cnum"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cnum);
            if (message.cval != null && Object.hasOwnProperty.call(message, "cval"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cval);
            if (message.tnum != null && Object.hasOwnProperty.call(message, "tnum"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.tnum);
            if (message.tval != null && Object.hasOwnProperty.call(message, "tval"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tval);
            if (message.innum != null && Object.hasOwnProperty.call(message, "innum"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.innum);
            if (message.inval != null && Object.hasOwnProperty.call(message, "inval"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.inval);
            if (message.outnum != null && Object.hasOwnProperty.call(message, "outnum"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.outnum);
            if (message.outval != null && Object.hasOwnProperty.call(message, "outval"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.outval);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cointype);
            return writer;
        };

        /**
         * Encodes the specified goods_deal_data message, length delimited. Does not implicitly {@link net.goods_deal_data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.goods_deal_data
         * @static
         * @param {net.Igoods_deal_data} message goods_deal_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_deal_data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a goods_deal_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.goods_deal_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.goods_deal_data} goods_deal_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_deal_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.goods_deal_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cnum = reader.int32();
                    break;
                case 2:
                    message.cval = reader.int32();
                    break;
                case 3:
                    message.tnum = reader.int32();
                    break;
                case 4:
                    message.tval = reader.int32();
                    break;
                case 5:
                    message.innum = reader.int32();
                    break;
                case 6:
                    message.inval = reader.int32();
                    break;
                case 7:
                    message.outnum = reader.int32();
                    break;
                case 8:
                    message.outval = reader.int32();
                    break;
                case 9:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a goods_deal_data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.goods_deal_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.goods_deal_data} goods_deal_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_deal_data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a goods_deal_data message.
         * @function verify
         * @memberof net.goods_deal_data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        goods_deal_data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cnum != null && message.hasOwnProperty("cnum"))
                if (!$util.isInteger(message.cnum))
                    return "cnum: integer expected";
            if (message.cval != null && message.hasOwnProperty("cval"))
                if (!$util.isInteger(message.cval))
                    return "cval: integer expected";
            if (message.tnum != null && message.hasOwnProperty("tnum"))
                if (!$util.isInteger(message.tnum))
                    return "tnum: integer expected";
            if (message.tval != null && message.hasOwnProperty("tval"))
                if (!$util.isInteger(message.tval))
                    return "tval: integer expected";
            if (message.innum != null && message.hasOwnProperty("innum"))
                if (!$util.isInteger(message.innum))
                    return "innum: integer expected";
            if (message.inval != null && message.hasOwnProperty("inval"))
                if (!$util.isInteger(message.inval))
                    return "inval: integer expected";
            if (message.outnum != null && message.hasOwnProperty("outnum"))
                if (!$util.isInteger(message.outnum))
                    return "outnum: integer expected";
            if (message.outval != null && message.hasOwnProperty("outval"))
                if (!$util.isInteger(message.outval))
                    return "outval: integer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            return null;
        };

        /**
         * Creates a goods_deal_data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.goods_deal_data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.goods_deal_data} goods_deal_data
         */
        goods_deal_data.fromObject = function fromObject(object) {
            if (object instanceof $root.net.goods_deal_data)
                return object;
            var message = new $root.net.goods_deal_data();
            if (object.cnum != null)
                message.cnum = object.cnum | 0;
            if (object.cval != null)
                message.cval = object.cval | 0;
            if (object.tnum != null)
                message.tnum = object.tnum | 0;
            if (object.tval != null)
                message.tval = object.tval | 0;
            if (object.innum != null)
                message.innum = object.innum | 0;
            if (object.inval != null)
                message.inval = object.inval | 0;
            if (object.outnum != null)
                message.outnum = object.outnum | 0;
            if (object.outval != null)
                message.outval = object.outval | 0;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a goods_deal_data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.goods_deal_data
         * @static
         * @param {net.goods_deal_data} message goods_deal_data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        goods_deal_data.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cnum = 0;
                object.cval = 0;
                object.tnum = 0;
                object.tval = 0;
                object.innum = 0;
                object.inval = 0;
                object.outnum = 0;
                object.outval = 0;
                object.cointype = 0;
            }
            if (message.cnum != null && message.hasOwnProperty("cnum"))
                object.cnum = message.cnum;
            if (message.cval != null && message.hasOwnProperty("cval"))
                object.cval = message.cval;
            if (message.tnum != null && message.hasOwnProperty("tnum"))
                object.tnum = message.tnum;
            if (message.tval != null && message.hasOwnProperty("tval"))
                object.tval = message.tval;
            if (message.innum != null && message.hasOwnProperty("innum"))
                object.innum = message.innum;
            if (message.inval != null && message.hasOwnProperty("inval"))
                object.inval = message.inval;
            if (message.outnum != null && message.hasOwnProperty("outnum"))
                object.outnum = message.outnum;
            if (message.outval != null && message.hasOwnProperty("outval"))
                object.outval = message.outval;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            return object;
        };

        /**
         * Converts this goods_deal_data to JSON.
         * @function toJSON
         * @memberof net.goods_deal_data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        goods_deal_data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return goods_deal_data;
    })();

    net.friend_state_info = (function() {

        /**
         * Properties of a friend_state_info.
         * @memberof net
         * @interface Ifriend_state_info
         * @property {number|null} [fuid] friend_state_info fuid
         * @property {number|null} [lastlogouttime] friend_state_info lastlogouttime
         */

        /**
         * Constructs a new friend_state_info.
         * @memberof net
         * @classdesc Represents a friend_state_info.
         * @implements Ifriend_state_info
         * @constructor
         * @param {net.Ifriend_state_info=} [properties] Properties to set
         */
        function friend_state_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * friend_state_info fuid.
         * @member {number} fuid
         * @memberof net.friend_state_info
         * @instance
         */
        friend_state_info.prototype.fuid = 0;

        /**
         * friend_state_info lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.friend_state_info
         * @instance
         */
        friend_state_info.prototype.lastlogouttime = 0;

        /**
         * Creates a new friend_state_info instance using the specified properties.
         * @function create
         * @memberof net.friend_state_info
         * @static
         * @param {net.Ifriend_state_info=} [properties] Properties to set
         * @returns {net.friend_state_info} friend_state_info instance
         */
        friend_state_info.create = function create(properties) {
            return new friend_state_info(properties);
        };

        /**
         * Encodes the specified friend_state_info message. Does not implicitly {@link net.friend_state_info.verify|verify} messages.
         * @function encode
         * @memberof net.friend_state_info
         * @static
         * @param {net.Ifriend_state_info} message friend_state_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_state_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.lastlogouttime);
            return writer;
        };

        /**
         * Encodes the specified friend_state_info message, length delimited. Does not implicitly {@link net.friend_state_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.friend_state_info
         * @static
         * @param {net.Ifriend_state_info} message friend_state_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_state_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a friend_state_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.friend_state_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.friend_state_info} friend_state_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_state_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.friend_state_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.lastlogouttime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a friend_state_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.friend_state_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.friend_state_info} friend_state_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_state_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a friend_state_info message.
         * @function verify
         * @memberof net.friend_state_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        friend_state_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                if (!$util.isInteger(message.fuid))
                    return "fuid: integer expected";
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                if (!$util.isInteger(message.lastlogouttime))
                    return "lastlogouttime: integer expected";
            return null;
        };

        /**
         * Creates a friend_state_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.friend_state_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.friend_state_info} friend_state_info
         */
        friend_state_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.friend_state_info)
                return object;
            var message = new $root.net.friend_state_info();
            if (object.fuid != null)
                message.fuid = object.fuid | 0;
            if (object.lastlogouttime != null)
                message.lastlogouttime = object.lastlogouttime | 0;
            return message;
        };

        /**
         * Creates a plain object from a friend_state_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.friend_state_info
         * @static
         * @param {net.friend_state_info} message friend_state_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        friend_state_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fuid = 0;
                object.lastlogouttime = 0;
            }
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                object.fuid = message.fuid;
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                object.lastlogouttime = message.lastlogouttime;
            return object;
        };

        /**
         * Converts this friend_state_info to JSON.
         * @function toJSON
         * @memberof net.friend_state_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        friend_state_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return friend_state_info;
    })();

    net.chat_room_info = (function() {

        /**
         * Properties of a chat_room_info.
         * @memberof net
         * @interface Ichat_room_info
         * @property {number|null} [roomkey] chat_room_info roomkey
         * @property {number|null} [roomhost] chat_room_info roomhost
         * @property {number|null} [createtm] chat_room_info createtm
         * @property {Uint8Array|null} [roomname] chat_room_info roomname
         * @property {Uint8Array|null} [pic] chat_room_info pic
         * @property {number|null} [usercnt] chat_room_info usercnt
         * @property {Array.<number>|null} [forbid_uids] chat_room_info forbid_uids
         * @property {Array.<number>|null} [channels] chat_room_info channels
         */

        /**
         * Constructs a new chat_room_info.
         * @memberof net
         * @classdesc Represents a chat_room_info.
         * @implements Ichat_room_info
         * @constructor
         * @param {net.Ichat_room_info=} [properties] Properties to set
         */
        function chat_room_info(properties) {
            this.forbid_uids = [];
            this.channels = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * chat_room_info roomkey.
         * @member {number} roomkey
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomkey = 0;

        /**
         * chat_room_info roomhost.
         * @member {number} roomhost
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomhost = 0;

        /**
         * chat_room_info createtm.
         * @member {number} createtm
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.createtm = 0;

        /**
         * chat_room_info roomname.
         * @member {Uint8Array} roomname
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomname = $util.newBuffer([]);

        /**
         * chat_room_info pic.
         * @member {Uint8Array} pic
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.pic = $util.newBuffer([]);

        /**
         * chat_room_info usercnt.
         * @member {number} usercnt
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.usercnt = 0;

        /**
         * chat_room_info forbid_uids.
         * @member {Array.<number>} forbid_uids
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.forbid_uids = $util.emptyArray;

        /**
         * chat_room_info channels.
         * @member {Array.<number>} channels
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.channels = $util.emptyArray;

        /**
         * Creates a new chat_room_info instance using the specified properties.
         * @function create
         * @memberof net.chat_room_info
         * @static
         * @param {net.Ichat_room_info=} [properties] Properties to set
         * @returns {net.chat_room_info} chat_room_info instance
         */
        chat_room_info.create = function create(properties) {
            return new chat_room_info(properties);
        };

        /**
         * Encodes the specified chat_room_info message. Does not implicitly {@link net.chat_room_info.verify|verify} messages.
         * @function encode
         * @memberof net.chat_room_info
         * @static
         * @param {net.Ichat_room_info} message chat_room_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_room_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.roomhost != null && Object.hasOwnProperty.call(message, "roomhost"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roomhost);
            if (message.createtm != null && Object.hasOwnProperty.call(message, "createtm"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.createtm);
            if (message.roomname != null && Object.hasOwnProperty.call(message, "roomname"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.roomname);
            if (message.pic != null && Object.hasOwnProperty.call(message, "pic"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.pic);
            if (message.usercnt != null && Object.hasOwnProperty.call(message, "usercnt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.usercnt);
            if (message.forbid_uids != null && message.forbid_uids.length)
                for (var i = 0; i < message.forbid_uids.length; ++i)
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.forbid_uids[i]);
            if (message.channels != null && message.channels.length)
                for (var i = 0; i < message.channels.length; ++i)
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.channels[i]);
            return writer;
        };

        /**
         * Encodes the specified chat_room_info message, length delimited. Does not implicitly {@link net.chat_room_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.chat_room_info
         * @static
         * @param {net.Ichat_room_info} message chat_room_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_room_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a chat_room_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.chat_room_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.chat_room_info} chat_room_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_room_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.chat_room_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.roomhost = reader.int32();
                    break;
                case 3:
                    message.createtm = reader.int32();
                    break;
                case 4:
                    message.roomname = reader.bytes();
                    break;
                case 5:
                    message.pic = reader.bytes();
                    break;
                case 6:
                    message.usercnt = reader.int32();
                    break;
                case 7:
                    if (!(message.forbid_uids && message.forbid_uids.length))
                        message.forbid_uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.forbid_uids.push(reader.int32());
                    } else
                        message.forbid_uids.push(reader.int32());
                    break;
                case 8:
                    if (!(message.channels && message.channels.length))
                        message.channels = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.channels.push(reader.int32());
                    } else
                        message.channels.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a chat_room_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.chat_room_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.chat_room_info} chat_room_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_room_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a chat_room_info message.
         * @function verify
         * @memberof net.chat_room_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        chat_room_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.roomhost != null && message.hasOwnProperty("roomhost"))
                if (!$util.isInteger(message.roomhost))
                    return "roomhost: integer expected";
            if (message.createtm != null && message.hasOwnProperty("createtm"))
                if (!$util.isInteger(message.createtm))
                    return "createtm: integer expected";
            if (message.roomname != null && message.hasOwnProperty("roomname"))
                if (!(message.roomname && typeof message.roomname.length === "number" || $util.isString(message.roomname)))
                    return "roomname: buffer expected";
            if (message.pic != null && message.hasOwnProperty("pic"))
                if (!(message.pic && typeof message.pic.length === "number" || $util.isString(message.pic)))
                    return "pic: buffer expected";
            if (message.usercnt != null && message.hasOwnProperty("usercnt"))
                if (!$util.isInteger(message.usercnt))
                    return "usercnt: integer expected";
            if (message.forbid_uids != null && message.hasOwnProperty("forbid_uids")) {
                if (!Array.isArray(message.forbid_uids))
                    return "forbid_uids: array expected";
                for (var i = 0; i < message.forbid_uids.length; ++i)
                    if (!$util.isInteger(message.forbid_uids[i]))
                        return "forbid_uids: integer[] expected";
            }
            if (message.channels != null && message.hasOwnProperty("channels")) {
                if (!Array.isArray(message.channels))
                    return "channels: array expected";
                for (var i = 0; i < message.channels.length; ++i)
                    if (!$util.isInteger(message.channels[i]))
                        return "channels: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a chat_room_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.chat_room_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.chat_room_info} chat_room_info
         */
        chat_room_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.chat_room_info)
                return object;
            var message = new $root.net.chat_room_info();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.roomhost != null)
                message.roomhost = object.roomhost | 0;
            if (object.createtm != null)
                message.createtm = object.createtm | 0;
            if (object.roomname != null)
                if (typeof object.roomname === "string")
                    $util.base64.decode(object.roomname, message.roomname = $util.newBuffer($util.base64.length(object.roomname)), 0);
                else if (object.roomname.length)
                    message.roomname = object.roomname;
            if (object.pic != null)
                if (typeof object.pic === "string")
                    $util.base64.decode(object.pic, message.pic = $util.newBuffer($util.base64.length(object.pic)), 0);
                else if (object.pic.length)
                    message.pic = object.pic;
            if (object.usercnt != null)
                message.usercnt = object.usercnt | 0;
            if (object.forbid_uids) {
                if (!Array.isArray(object.forbid_uids))
                    throw TypeError(".net.chat_room_info.forbid_uids: array expected");
                message.forbid_uids = [];
                for (var i = 0; i < object.forbid_uids.length; ++i)
                    message.forbid_uids[i] = object.forbid_uids[i] | 0;
            }
            if (object.channels) {
                if (!Array.isArray(object.channels))
                    throw TypeError(".net.chat_room_info.channels: array expected");
                message.channels = [];
                for (var i = 0; i < object.channels.length; ++i)
                    message.channels[i] = object.channels[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a chat_room_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.chat_room_info
         * @static
         * @param {net.chat_room_info} message chat_room_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        chat_room_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.forbid_uids = [];
                object.channels = [];
            }
            if (options.defaults) {
                object.roomkey = 0;
                object.roomhost = 0;
                object.createtm = 0;
                if (options.bytes === String)
                    object.roomname = "";
                else {
                    object.roomname = [];
                    if (options.bytes !== Array)
                        object.roomname = $util.newBuffer(object.roomname);
                }
                if (options.bytes === String)
                    object.pic = "";
                else {
                    object.pic = [];
                    if (options.bytes !== Array)
                        object.pic = $util.newBuffer(object.pic);
                }
                object.usercnt = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.roomhost != null && message.hasOwnProperty("roomhost"))
                object.roomhost = message.roomhost;
            if (message.createtm != null && message.hasOwnProperty("createtm"))
                object.createtm = message.createtm;
            if (message.roomname != null && message.hasOwnProperty("roomname"))
                object.roomname = options.bytes === String ? $util.base64.encode(message.roomname, 0, message.roomname.length) : options.bytes === Array ? Array.prototype.slice.call(message.roomname) : message.roomname;
            if (message.pic != null && message.hasOwnProperty("pic"))
                object.pic = options.bytes === String ? $util.base64.encode(message.pic, 0, message.pic.length) : options.bytes === Array ? Array.prototype.slice.call(message.pic) : message.pic;
            if (message.usercnt != null && message.hasOwnProperty("usercnt"))
                object.usercnt = message.usercnt;
            if (message.forbid_uids && message.forbid_uids.length) {
                object.forbid_uids = [];
                for (var j = 0; j < message.forbid_uids.length; ++j)
                    object.forbid_uids[j] = message.forbid_uids[j];
            }
            if (message.channels && message.channels.length) {
                object.channels = [];
                for (var j = 0; j < message.channels.length; ++j)
                    object.channels[j] = message.channels[j];
            }
            return object;
        };

        /**
         * Converts this chat_room_info to JSON.
         * @function toJSON
         * @memberof net.chat_room_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        chat_room_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return chat_room_info;
    })();

    net.group_voice_state_info = (function() {

        /**
         * Properties of a group_voice_state_info.
         * @memberof net
         * @interface Igroup_voice_state_info
         * @property {number|null} [uid] group_voice_state_info uid
         * @property {number|null} [voicestate] group_voice_state_info voicestate
         * @property {number|null} [videostate] group_voice_state_info videostate
         */

        /**
         * Constructs a new group_voice_state_info.
         * @memberof net
         * @classdesc Represents a group_voice_state_info.
         * @implements Igroup_voice_state_info
         * @constructor
         * @param {net.Igroup_voice_state_info=} [properties] Properties to set
         */
        function group_voice_state_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_voice_state_info uid.
         * @member {number} uid
         * @memberof net.group_voice_state_info
         * @instance
         */
        group_voice_state_info.prototype.uid = 0;

        /**
         * group_voice_state_info voicestate.
         * @member {number} voicestate
         * @memberof net.group_voice_state_info
         * @instance
         */
        group_voice_state_info.prototype.voicestate = 0;

        /**
         * group_voice_state_info videostate.
         * @member {number} videostate
         * @memberof net.group_voice_state_info
         * @instance
         */
        group_voice_state_info.prototype.videostate = 0;

        /**
         * Creates a new group_voice_state_info instance using the specified properties.
         * @function create
         * @memberof net.group_voice_state_info
         * @static
         * @param {net.Igroup_voice_state_info=} [properties] Properties to set
         * @returns {net.group_voice_state_info} group_voice_state_info instance
         */
        group_voice_state_info.create = function create(properties) {
            return new group_voice_state_info(properties);
        };

        /**
         * Encodes the specified group_voice_state_info message. Does not implicitly {@link net.group_voice_state_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_voice_state_info
         * @static
         * @param {net.Igroup_voice_state_info} message group_voice_state_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_voice_state_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.voicestate != null && Object.hasOwnProperty.call(message, "voicestate"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.voicestate);
            if (message.videostate != null && Object.hasOwnProperty.call(message, "videostate"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.videostate);
            return writer;
        };

        /**
         * Encodes the specified group_voice_state_info message, length delimited. Does not implicitly {@link net.group_voice_state_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.group_voice_state_info
         * @static
         * @param {net.Igroup_voice_state_info} message group_voice_state_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_voice_state_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a group_voice_state_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_voice_state_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_voice_state_info} group_voice_state_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_voice_state_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_voice_state_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.voicestate = reader.int32();
                    break;
                case 3:
                    message.videostate = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a group_voice_state_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.group_voice_state_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.group_voice_state_info} group_voice_state_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_voice_state_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a group_voice_state_info message.
         * @function verify
         * @memberof net.group_voice_state_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        group_voice_state_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                if (!$util.isInteger(message.voicestate))
                    return "voicestate: integer expected";
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                if (!$util.isInteger(message.videostate))
                    return "videostate: integer expected";
            return null;
        };

        /**
         * Creates a group_voice_state_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.group_voice_state_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.group_voice_state_info} group_voice_state_info
         */
        group_voice_state_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.group_voice_state_info)
                return object;
            var message = new $root.net.group_voice_state_info();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.voicestate != null)
                message.voicestate = object.voicestate | 0;
            if (object.videostate != null)
                message.videostate = object.videostate | 0;
            return message;
        };

        /**
         * Creates a plain object from a group_voice_state_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.group_voice_state_info
         * @static
         * @param {net.group_voice_state_info} message group_voice_state_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        group_voice_state_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.voicestate = 0;
                object.videostate = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                object.voicestate = message.voicestate;
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                object.videostate = message.videostate;
            return object;
        };

        /**
         * Converts this group_voice_state_info to JSON.
         * @function toJSON
         * @memberof net.group_voice_state_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        group_voice_state_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return group_voice_state_info;
    })();

    net.msg_heart_test = (function() {

        /**
         * Properties of a msg_heart_test.
         * @memberof net
         * @interface Imsg_heart_test
         * @property {number|null} [svr_time] msg_heart_test svr_time
         * @property {number|Long|null} [ms_time] msg_heart_test ms_time
         */

        /**
         * Constructs a new msg_heart_test.
         * @memberof net
         * @classdesc Represents a msg_heart_test.
         * @implements Imsg_heart_test
         * @constructor
         * @param {net.Imsg_heart_test=} [properties] Properties to set
         */
        function msg_heart_test(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_heart_test svr_time.
         * @member {number} svr_time
         * @memberof net.msg_heart_test
         * @instance
         */
        msg_heart_test.prototype.svr_time = 0;

        /**
         * msg_heart_test ms_time.
         * @member {number|Long} ms_time
         * @memberof net.msg_heart_test
         * @instance
         */
        msg_heart_test.prototype.ms_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_heart_test instance using the specified properties.
         * @function create
         * @memberof net.msg_heart_test
         * @static
         * @param {net.Imsg_heart_test=} [properties] Properties to set
         * @returns {net.msg_heart_test} msg_heart_test instance
         */
        msg_heart_test.create = function create(properties) {
            return new msg_heart_test(properties);
        };

        /**
         * Encodes the specified msg_heart_test message. Does not implicitly {@link net.msg_heart_test.verify|verify} messages.
         * @function encode
         * @memberof net.msg_heart_test
         * @static
         * @param {net.Imsg_heart_test} message msg_heart_test message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_heart_test.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.svr_time != null && Object.hasOwnProperty.call(message, "svr_time"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.svr_time);
            if (message.ms_time != null && Object.hasOwnProperty.call(message, "ms_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ms_time);
            return writer;
        };

        /**
         * Encodes the specified msg_heart_test message, length delimited. Does not implicitly {@link net.msg_heart_test.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_heart_test
         * @static
         * @param {net.Imsg_heart_test} message msg_heart_test message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_heart_test.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_heart_test message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_heart_test
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_heart_test} msg_heart_test
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_heart_test.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_heart_test();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.svr_time = reader.uint32();
                    break;
                case 2:
                    message.ms_time = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_heart_test message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_heart_test
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_heart_test} msg_heart_test
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_heart_test.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_heart_test message.
         * @function verify
         * @memberof net.msg_heart_test
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_heart_test.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.svr_time != null && message.hasOwnProperty("svr_time"))
                if (!$util.isInteger(message.svr_time))
                    return "svr_time: integer expected";
            if (message.ms_time != null && message.hasOwnProperty("ms_time"))
                if (!$util.isInteger(message.ms_time) && !(message.ms_time && $util.isInteger(message.ms_time.low) && $util.isInteger(message.ms_time.high)))
                    return "ms_time: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_heart_test message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_heart_test
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_heart_test} msg_heart_test
         */
        msg_heart_test.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_heart_test)
                return object;
            var message = new $root.net.msg_heart_test();
            if (object.svr_time != null)
                message.svr_time = object.svr_time >>> 0;
            if (object.ms_time != null)
                if ($util.Long)
                    (message.ms_time = $util.Long.fromValue(object.ms_time)).unsigned = false;
                else if (typeof object.ms_time === "string")
                    message.ms_time = parseInt(object.ms_time, 10);
                else if (typeof object.ms_time === "number")
                    message.ms_time = object.ms_time;
                else if (typeof object.ms_time === "object")
                    message.ms_time = new $util.LongBits(object.ms_time.low >>> 0, object.ms_time.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_heart_test message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_heart_test
         * @static
         * @param {net.msg_heart_test} message msg_heart_test
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_heart_test.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.svr_time = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.ms_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ms_time = options.longs === String ? "0" : 0;
            }
            if (message.svr_time != null && message.hasOwnProperty("svr_time"))
                object.svr_time = message.svr_time;
            if (message.ms_time != null && message.hasOwnProperty("ms_time"))
                if (typeof message.ms_time === "number")
                    object.ms_time = options.longs === String ? String(message.ms_time) : message.ms_time;
                else
                    object.ms_time = options.longs === String ? $util.Long.prototype.toString.call(message.ms_time) : options.longs === Number ? new $util.LongBits(message.ms_time.low >>> 0, message.ms_time.high >>> 0).toNumber() : message.ms_time;
            return object;
        };

        /**
         * Converts this msg_heart_test to JSON.
         * @function toJSON
         * @memberof net.msg_heart_test
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_heart_test.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_heart_test;
    })();

    net.msg_login_req = (function() {

        /**
         * Properties of a msg_login_req.
         * @memberof net
         * @interface Imsg_login_req
         * @property {number|null} [uid] msg_login_req uid
         * @property {Uint8Array|null} [fastkey] msg_login_req fastkey
         * @property {Uint8Array|null} [phonenum] msg_login_req phonenum
         * @property {Uint8Array|null} [deviceid] msg_login_req deviceid
         * @property {Uint8Array|null} [version] msg_login_req version
         */

        /**
         * Constructs a new msg_login_req.
         * @memberof net
         * @classdesc Represents a msg_login_req.
         * @implements Imsg_login_req
         * @constructor
         * @param {net.Imsg_login_req=} [properties] Properties to set
         */
        function msg_login_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_req uid.
         * @member {number} uid
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.uid = 0;

        /**
         * msg_login_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_login_req phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_login_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_login_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.version = $util.newBuffer([]);

        /**
         * Creates a new msg_login_req instance using the specified properties.
         * @function create
         * @memberof net.msg_login_req
         * @static
         * @param {net.Imsg_login_req=} [properties] Properties to set
         * @returns {net.msg_login_req} msg_login_req instance
         */
        msg_login_req.create = function create(properties) {
            return new msg_login_req(properties);
        };

        /**
         * Encodes the specified msg_login_req message. Does not implicitly {@link net.msg_login_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_req
         * @static
         * @param {net.Imsg_login_req} message msg_login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_login_req message, length delimited. Does not implicitly {@link net.msg_login_req.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_login_req
         * @static
         * @param {net.Imsg_login_req} message msg_login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_req.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_login_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_req} msg_login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                case 4:
                    message.deviceid = reader.bytes();
                    break;
                case 5:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_login_req message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_login_req} msg_login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_req.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_login_req message.
         * @function verify
         * @memberof net.msg_login_req
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_login_req.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                if (!(message.fastkey && typeof message.fastkey.length === "number" || $util.isString(message.fastkey)))
                    return "fastkey: buffer expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (!(message.deviceid && typeof message.deviceid.length === "number" || $util.isString(message.deviceid)))
                    return "deviceid: buffer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!(message.version && typeof message.version.length === "number" || $util.isString(message.version)))
                    return "version: buffer expected";
            return null;
        };

        /**
         * Creates a msg_login_req message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_login_req
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_login_req} msg_login_req
         */
        msg_login_req.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_login_req)
                return object;
            var message = new $root.net.msg_login_req();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.fastkey != null)
                if (typeof object.fastkey === "string")
                    $util.base64.decode(object.fastkey, message.fastkey = $util.newBuffer($util.base64.length(object.fastkey)), 0);
                else if (object.fastkey.length)
                    message.fastkey = object.fastkey;
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            if (object.deviceid != null)
                if (typeof object.deviceid === "string")
                    $util.base64.decode(object.deviceid, message.deviceid = $util.newBuffer($util.base64.length(object.deviceid)), 0);
                else if (object.deviceid.length)
                    message.deviceid = object.deviceid;
            if (object.version != null)
                if (typeof object.version === "string")
                    $util.base64.decode(object.version, message.version = $util.newBuffer($util.base64.length(object.version)), 0);
                else if (object.version.length)
                    message.version = object.version;
            return message;
        };

        /**
         * Creates a plain object from a msg_login_req message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_login_req
         * @static
         * @param {net.msg_login_req} message msg_login_req
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_login_req.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.fastkey = "";
                else {
                    object.fastkey = [];
                    if (options.bytes !== Array)
                        object.fastkey = $util.newBuffer(object.fastkey);
                }
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
                if (options.bytes === String)
                    object.deviceid = "";
                else {
                    object.deviceid = [];
                    if (options.bytes !== Array)
                        object.deviceid = $util.newBuffer(object.deviceid);
                }
                if (options.bytes === String)
                    object.version = "";
                else {
                    object.version = [];
                    if (options.bytes !== Array)
                        object.version = $util.newBuffer(object.version);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                object.fastkey = options.bytes === String ? $util.base64.encode(message.fastkey, 0, message.fastkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.fastkey) : message.fastkey;
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                object.deviceid = options.bytes === String ? $util.base64.encode(message.deviceid, 0, message.deviceid.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceid) : message.deviceid;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = options.bytes === String ? $util.base64.encode(message.version, 0, message.version.length) : options.bytes === Array ? Array.prototype.slice.call(message.version) : message.version;
            return object;
        };

        /**
         * Converts this msg_login_req to JSON.
         * @function toJSON
         * @memberof net.msg_login_req
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_login_req.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_login_req;
    })();

    net.msg_login_rep = (function() {

        /**
         * Properties of a msg_login_rep.
         * @memberof net
         * @interface Imsg_login_rep
         * @property {number|null} [result] msg_login_rep result
         * @property {number|null} [server_time] msg_login_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_login_rep customer_list
         * @property {number|Long|null} [ms_time] msg_login_rep ms_time
         */

        /**
         * Constructs a new msg_login_rep.
         * @memberof net
         * @classdesc Represents a msg_login_rep.
         * @implements Imsg_login_rep
         * @constructor
         * @param {net.Imsg_login_rep=} [properties] Properties to set
         */
        function msg_login_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_rep result.
         * @member {number} result
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.result = 0;

        /**
         * msg_login_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.server_time = 0;

        /**
         * msg_login_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.customer_list = $util.emptyArray;

        /**
         * msg_login_rep ms_time.
         * @member {number|Long} ms_time
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.ms_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_login_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_login_rep
         * @static
         * @param {net.Imsg_login_rep=} [properties] Properties to set
         * @returns {net.msg_login_rep} msg_login_rep instance
         */
        msg_login_rep.create = function create(properties) {
            return new msg_login_rep(properties);
        };

        /**
         * Encodes the specified msg_login_rep message. Does not implicitly {@link net.msg_login_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_rep
         * @static
         * @param {net.Imsg_login_rep} message msg_login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.ms_time != null && Object.hasOwnProperty.call(message, "ms_time"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ms_time);
            return writer;
        };

        /**
         * Encodes the specified msg_login_rep message, length delimited. Does not implicitly {@link net.msg_login_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_login_rep
         * @static
         * @param {net.Imsg_login_rep} message msg_login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_login_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_rep} msg_login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.ms_time = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_login_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_login_rep} msg_login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_login_rep message.
         * @function verify
         * @memberof net.msg_login_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_login_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                if (!$util.isInteger(message.server_time))
                    return "server_time: integer expected";
            if (message.customer_list != null && message.hasOwnProperty("customer_list")) {
                if (!Array.isArray(message.customer_list))
                    return "customer_list: array expected";
                for (var i = 0; i < message.customer_list.length; ++i) {
                    var error = $root.net.customer_info.verify(message.customer_list[i]);
                    if (error)
                        return "customer_list." + error;
                }
            }
            if (message.ms_time != null && message.hasOwnProperty("ms_time"))
                if (!$util.isInteger(message.ms_time) && !(message.ms_time && $util.isInteger(message.ms_time.low) && $util.isInteger(message.ms_time.high)))
                    return "ms_time: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_login_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_login_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_login_rep} msg_login_rep
         */
        msg_login_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_login_rep)
                return object;
            var message = new $root.net.msg_login_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.server_time != null)
                message.server_time = object.server_time >>> 0;
            if (object.customer_list) {
                if (!Array.isArray(object.customer_list))
                    throw TypeError(".net.msg_login_rep.customer_list: array expected");
                message.customer_list = [];
                for (var i = 0; i < object.customer_list.length; ++i) {
                    if (typeof object.customer_list[i] !== "object")
                        throw TypeError(".net.msg_login_rep.customer_list: object expected");
                    message.customer_list[i] = $root.net.customer_info.fromObject(object.customer_list[i]);
                }
            }
            if (object.ms_time != null)
                if ($util.Long)
                    (message.ms_time = $util.Long.fromValue(object.ms_time)).unsigned = false;
                else if (typeof object.ms_time === "string")
                    message.ms_time = parseInt(object.ms_time, 10);
                else if (typeof object.ms_time === "number")
                    message.ms_time = object.ms_time;
                else if (typeof object.ms_time === "object")
                    message.ms_time = new $util.LongBits(object.ms_time.low >>> 0, object.ms_time.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_login_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_login_rep
         * @static
         * @param {net.msg_login_rep} message msg_login_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_login_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.customer_list = [];
            if (options.defaults) {
                object.result = 0;
                object.server_time = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.ms_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ms_time = options.longs === String ? "0" : 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                object.server_time = message.server_time;
            if (message.customer_list && message.customer_list.length) {
                object.customer_list = [];
                for (var j = 0; j < message.customer_list.length; ++j)
                    object.customer_list[j] = $root.net.customer_info.toObject(message.customer_list[j], options);
            }
            if (message.ms_time != null && message.hasOwnProperty("ms_time"))
                if (typeof message.ms_time === "number")
                    object.ms_time = options.longs === String ? String(message.ms_time) : message.ms_time;
                else
                    object.ms_time = options.longs === String ? $util.Long.prototype.toString.call(message.ms_time) : options.longs === Number ? new $util.LongBits(message.ms_time.low >>> 0, message.ms_time.high >>> 0).toNumber() : message.ms_time;
            return object;
        };

        /**
         * Converts this msg_login_rep to JSON.
         * @function toJSON
         * @memberof net.msg_login_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_login_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_login_rep;
    })();

    net.msg_user_data_rep = (function() {

        /**
         * Properties of a msg_user_data_rep.
         * @memberof net
         * @interface Imsg_user_data_rep
         * @property {net.Ibase_info|null} [base_data] msg_user_data_rep base_data
         */

        /**
         * Constructs a new msg_user_data_rep.
         * @memberof net
         * @classdesc Represents a msg_user_data_rep.
         * @implements Imsg_user_data_rep
         * @constructor
         * @param {net.Imsg_user_data_rep=} [properties] Properties to set
         */
        function msg_user_data_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_user_data_rep base_data.
         * @member {net.Ibase_info|null|undefined} base_data
         * @memberof net.msg_user_data_rep
         * @instance
         */
        msg_user_data_rep.prototype.base_data = null;

        /**
         * Creates a new msg_user_data_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_user_data_rep
         * @static
         * @param {net.Imsg_user_data_rep=} [properties] Properties to set
         * @returns {net.msg_user_data_rep} msg_user_data_rep instance
         */
        msg_user_data_rep.create = function create(properties) {
            return new msg_user_data_rep(properties);
        };

        /**
         * Encodes the specified msg_user_data_rep message. Does not implicitly {@link net.msg_user_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_user_data_rep
         * @static
         * @param {net.Imsg_user_data_rep} message msg_user_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_user_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.base_data != null && Object.hasOwnProperty.call(message, "base_data"))
                $root.net.base_info.encode(message.base_data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_user_data_rep message, length delimited. Does not implicitly {@link net.msg_user_data_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_user_data_rep
         * @static
         * @param {net.Imsg_user_data_rep} message msg_user_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_user_data_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_user_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_user_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_user_data_rep} msg_user_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_user_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_user_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.base_data = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_user_data_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_user_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_user_data_rep} msg_user_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_user_data_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_user_data_rep message.
         * @function verify
         * @memberof net.msg_user_data_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_user_data_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.base_data != null && message.hasOwnProperty("base_data")) {
                var error = $root.net.base_info.verify(message.base_data);
                if (error)
                    return "base_data." + error;
            }
            return null;
        };

        /**
         * Creates a msg_user_data_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_user_data_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_user_data_rep} msg_user_data_rep
         */
        msg_user_data_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_user_data_rep)
                return object;
            var message = new $root.net.msg_user_data_rep();
            if (object.base_data != null) {
                if (typeof object.base_data !== "object")
                    throw TypeError(".net.msg_user_data_rep.base_data: object expected");
                message.base_data = $root.net.base_info.fromObject(object.base_data);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_user_data_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_user_data_rep
         * @static
         * @param {net.msg_user_data_rep} message msg_user_data_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_user_data_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.base_data = null;
            if (message.base_data != null && message.hasOwnProperty("base_data"))
                object.base_data = $root.net.base_info.toObject(message.base_data, options);
            return object;
        };

        /**
         * Converts this msg_user_data_rep to JSON.
         * @function toJSON
         * @memberof net.msg_user_data_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_user_data_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_user_data_rep;
    })();

    net.msg_add_friend_nty = (function() {

        /**
         * Properties of a msg_add_friend_nty.
         * @memberof net
         * @interface Imsg_add_friend_nty
         * @property {number|null} [uid] msg_add_friend_nty uid
         */

        /**
         * Constructs a new msg_add_friend_nty.
         * @memberof net
         * @classdesc Represents a msg_add_friend_nty.
         * @implements Imsg_add_friend_nty
         * @constructor
         * @param {net.Imsg_add_friend_nty=} [properties] Properties to set
         */
        function msg_add_friend_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_nty uid.
         * @member {number} uid
         * @memberof net.msg_add_friend_nty
         * @instance
         */
        msg_add_friend_nty.prototype.uid = 0;

        /**
         * Creates a new msg_add_friend_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {net.Imsg_add_friend_nty=} [properties] Properties to set
         * @returns {net.msg_add_friend_nty} msg_add_friend_nty instance
         */
        msg_add_friend_nty.create = function create(properties) {
            return new msg_add_friend_nty(properties);
        };

        /**
         * Encodes the specified msg_add_friend_nty message. Does not implicitly {@link net.msg_add_friend_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {net.Imsg_add_friend_nty} message msg_add_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_add_friend_nty message, length delimited. Does not implicitly {@link net.msg_add_friend_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {net.Imsg_add_friend_nty} message msg_add_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_friend_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_nty} msg_add_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_friend_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_friend_nty} msg_add_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_friend_nty message.
         * @function verify
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_friend_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_add_friend_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_friend_nty} msg_add_friend_nty
         */
        msg_add_friend_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_friend_nty)
                return object;
            var message = new $root.net.msg_add_friend_nty();
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_friend_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {net.msg_add_friend_nty} message msg_add_friend_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_friend_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = 0;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_add_friend_nty to JSON.
         * @function toJSON
         * @memberof net.msg_add_friend_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_friend_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_friend_nty;
    })();

    net.msg_add_friend = (function() {

        /**
         * Properties of a msg_add_friend.
         * @memberof net
         * @interface Imsg_add_friend
         * @property {Uint8Array|null} [phonenum] msg_add_friend phonenum
         * @property {Uint8Array|null} [hellomsg] msg_add_friend hellomsg
         */

        /**
         * Constructs a new msg_add_friend.
         * @memberof net
         * @classdesc Represents a msg_add_friend.
         * @implements Imsg_add_friend
         * @constructor
         * @param {net.Imsg_add_friend=} [properties] Properties to set
         */
        function msg_add_friend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_add_friend
         * @instance
         */
        msg_add_friend.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_add_friend hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.msg_add_friend
         * @instance
         */
        msg_add_friend.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Creates a new msg_add_friend instance using the specified properties.
         * @function create
         * @memberof net.msg_add_friend
         * @static
         * @param {net.Imsg_add_friend=} [properties] Properties to set
         * @returns {net.msg_add_friend} msg_add_friend instance
         */
        msg_add_friend.create = function create(properties) {
            return new msg_add_friend(properties);
        };

        /**
         * Encodes the specified msg_add_friend message. Does not implicitly {@link net.msg_add_friend.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend
         * @static
         * @param {net.Imsg_add_friend} message msg_add_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.phonenum);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Encodes the specified msg_add_friend message, length delimited. Does not implicitly {@link net.msg_add_friend.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_friend
         * @static
         * @param {net.Imsg_add_friend} message msg_add_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_friend message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend} msg_add_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.phonenum = reader.bytes();
                    break;
                case 2:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_friend message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_friend} msg_add_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_friend message.
         * @function verify
         * @memberof net.msg_add_friend
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_friend.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                if (!(message.hellomsg && typeof message.hellomsg.length === "number" || $util.isString(message.hellomsg)))
                    return "hellomsg: buffer expected";
            return null;
        };

        /**
         * Creates a msg_add_friend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_friend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_friend} msg_add_friend
         */
        msg_add_friend.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_friend)
                return object;
            var message = new $root.net.msg_add_friend();
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            if (object.hellomsg != null)
                if (typeof object.hellomsg === "string")
                    $util.base64.decode(object.hellomsg, message.hellomsg = $util.newBuffer($util.base64.length(object.hellomsg)), 0);
                else if (object.hellomsg.length)
                    message.hellomsg = object.hellomsg;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_friend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_friend
         * @static
         * @param {net.msg_add_friend} message msg_add_friend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_friend.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
                if (options.bytes === String)
                    object.hellomsg = "";
                else {
                    object.hellomsg = [];
                    if (options.bytes !== Array)
                        object.hellomsg = $util.newBuffer(object.hellomsg);
                }
            }
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                object.hellomsg = options.bytes === String ? $util.base64.encode(message.hellomsg, 0, message.hellomsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.hellomsg) : message.hellomsg;
            return object;
        };

        /**
         * Converts this msg_add_friend to JSON.
         * @function toJSON
         * @memberof net.msg_add_friend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_friend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_friend;
    })();

    net.msg_add_friend_rep = (function() {

        /**
         * Properties of a msg_add_friend_rep.
         * @memberof net
         * @interface Imsg_add_friend_rep
         * @property {number|null} [result] msg_add_friend_rep result
         */

        /**
         * Constructs a new msg_add_friend_rep.
         * @memberof net
         * @classdesc Represents a msg_add_friend_rep.
         * @implements Imsg_add_friend_rep
         * @constructor
         * @param {net.Imsg_add_friend_rep=} [properties] Properties to set
         */
        function msg_add_friend_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_rep result.
         * @member {number} result
         * @memberof net.msg_add_friend_rep
         * @instance
         */
        msg_add_friend_rep.prototype.result = 0;

        /**
         * Creates a new msg_add_friend_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {net.Imsg_add_friend_rep=} [properties] Properties to set
         * @returns {net.msg_add_friend_rep} msg_add_friend_rep instance
         */
        msg_add_friend_rep.create = function create(properties) {
            return new msg_add_friend_rep(properties);
        };

        /**
         * Encodes the specified msg_add_friend_rep message. Does not implicitly {@link net.msg_add_friend_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {net.Imsg_add_friend_rep} message msg_add_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_add_friend_rep message, length delimited. Does not implicitly {@link net.msg_add_friend_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {net.Imsg_add_friend_rep} message msg_add_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_friend_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_rep} msg_add_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_friend_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_friend_rep} msg_add_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_friend_rep message.
         * @function verify
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_friend_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_add_friend_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_friend_rep} msg_add_friend_rep
         */
        msg_add_friend_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_friend_rep)
                return object;
            var message = new $root.net.msg_add_friend_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_friend_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {net.msg_add_friend_rep} message msg_add_friend_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_friend_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_add_friend_rep to JSON.
         * @function toJSON
         * @memberof net.msg_add_friend_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_friend_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_friend_rep;
    })();

    net.msg_handle_friend_apply = (function() {

        /**
         * Properties of a msg_handle_friend_apply.
         * @memberof net
         * @interface Imsg_handle_friend_apply
         * @property {number|null} [otheruid] msg_handle_friend_apply otheruid
         * @property {number|null} [handletype] msg_handle_friend_apply handletype
         */

        /**
         * Constructs a new msg_handle_friend_apply.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_apply.
         * @implements Imsg_handle_friend_apply
         * @constructor
         * @param {net.Imsg_handle_friend_apply=} [properties] Properties to set
         */
        function msg_handle_friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_apply otheruid.
         * @member {number} otheruid
         * @memberof net.msg_handle_friend_apply
         * @instance
         */
        msg_handle_friend_apply.prototype.otheruid = 0;

        /**
         * msg_handle_friend_apply handletype.
         * @member {number} handletype
         * @memberof net.msg_handle_friend_apply
         * @instance
         */
        msg_handle_friend_apply.prototype.handletype = 0;

        /**
         * Creates a new msg_handle_friend_apply instance using the specified properties.
         * @function create
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {net.Imsg_handle_friend_apply=} [properties] Properties to set
         * @returns {net.msg_handle_friend_apply} msg_handle_friend_apply instance
         */
        msg_handle_friend_apply.create = function create(properties) {
            return new msg_handle_friend_apply(properties);
        };

        /**
         * Encodes the specified msg_handle_friend_apply message. Does not implicitly {@link net.msg_handle_friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {net.Imsg_handle_friend_apply} message msg_handle_friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            if (message.handletype != null && Object.hasOwnProperty.call(message, "handletype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.handletype);
            return writer;
        };

        /**
         * Encodes the specified msg_handle_friend_apply message, length delimited. Does not implicitly {@link net.msg_handle_friend_apply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {net.Imsg_handle_friend_apply} message msg_handle_friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_handle_friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_apply} msg_handle_friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                case 2:
                    message.handletype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_handle_friend_apply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_handle_friend_apply} msg_handle_friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_handle_friend_apply message.
         * @function verify
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_handle_friend_apply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.handletype != null && message.hasOwnProperty("handletype"))
                if (!$util.isInteger(message.handletype))
                    return "handletype: integer expected";
            return null;
        };

        /**
         * Creates a msg_handle_friend_apply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_handle_friend_apply} msg_handle_friend_apply
         */
        msg_handle_friend_apply.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_handle_friend_apply)
                return object;
            var message = new $root.net.msg_handle_friend_apply();
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.handletype != null)
                message.handletype = object.handletype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_handle_friend_apply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {net.msg_handle_friend_apply} message msg_handle_friend_apply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_handle_friend_apply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.otheruid = 0;
                object.handletype = 0;
            }
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.handletype != null && message.hasOwnProperty("handletype"))
                object.handletype = message.handletype;
            return object;
        };

        /**
         * Converts this msg_handle_friend_apply to JSON.
         * @function toJSON
         * @memberof net.msg_handle_friend_apply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_handle_friend_apply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_handle_friend_apply;
    })();

    net.msg_handle_friend_apply_rep = (function() {

        /**
         * Properties of a msg_handle_friend_apply_rep.
         * @memberof net
         * @interface Imsg_handle_friend_apply_rep
         * @property {number|null} [result] msg_handle_friend_apply_rep result
         * @property {number|null} [otheruid] msg_handle_friend_apply_rep otheruid
         * @property {number|null} [handletype] msg_handle_friend_apply_rep handletype
         */

        /**
         * Constructs a new msg_handle_friend_apply_rep.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_apply_rep.
         * @implements Imsg_handle_friend_apply_rep
         * @constructor
         * @param {net.Imsg_handle_friend_apply_rep=} [properties] Properties to set
         */
        function msg_handle_friend_apply_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_apply_rep result.
         * @member {number} result
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.result = 0;

        /**
         * msg_handle_friend_apply_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.otheruid = 0;

        /**
         * msg_handle_friend_apply_rep handletype.
         * @member {number} handletype
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.handletype = 0;

        /**
         * Creates a new msg_handle_friend_apply_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {net.Imsg_handle_friend_apply_rep=} [properties] Properties to set
         * @returns {net.msg_handle_friend_apply_rep} msg_handle_friend_apply_rep instance
         */
        msg_handle_friend_apply_rep.create = function create(properties) {
            return new msg_handle_friend_apply_rep(properties);
        };

        /**
         * Encodes the specified msg_handle_friend_apply_rep message. Does not implicitly {@link net.msg_handle_friend_apply_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {net.Imsg_handle_friend_apply_rep} message msg_handle_friend_apply_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.handletype != null && Object.hasOwnProperty.call(message, "handletype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.handletype);
            return writer;
        };

        /**
         * Encodes the specified msg_handle_friend_apply_rep message, length delimited. Does not implicitly {@link net.msg_handle_friend_apply_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {net.Imsg_handle_friend_apply_rep} message msg_handle_friend_apply_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_handle_friend_apply_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_apply_rep} msg_handle_friend_apply_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_apply_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.handletype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_handle_friend_apply_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_handle_friend_apply_rep} msg_handle_friend_apply_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_handle_friend_apply_rep message.
         * @function verify
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_handle_friend_apply_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.handletype != null && message.hasOwnProperty("handletype"))
                if (!$util.isInteger(message.handletype))
                    return "handletype: integer expected";
            return null;
        };

        /**
         * Creates a msg_handle_friend_apply_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_handle_friend_apply_rep} msg_handle_friend_apply_rep
         */
        msg_handle_friend_apply_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_handle_friend_apply_rep)
                return object;
            var message = new $root.net.msg_handle_friend_apply_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.handletype != null)
                message.handletype = object.handletype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_handle_friend_apply_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {net.msg_handle_friend_apply_rep} message msg_handle_friend_apply_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_handle_friend_apply_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.otheruid = 0;
                object.handletype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.handletype != null && message.hasOwnProperty("handletype"))
                object.handletype = message.handletype;
            return object;
        };

        /**
         * Converts this msg_handle_friend_apply_rep to JSON.
         * @function toJSON
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_handle_friend_apply_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_handle_friend_apply_rep;
    })();

    net.msg_friend_apply_list = (function() {

        /**
         * Properties of a msg_friend_apply_list.
         * @memberof net
         * @interface Imsg_friend_apply_list
         */

        /**
         * Constructs a new msg_friend_apply_list.
         * @memberof net
         * @classdesc Represents a msg_friend_apply_list.
         * @implements Imsg_friend_apply_list
         * @constructor
         * @param {net.Imsg_friend_apply_list=} [properties] Properties to set
         */
        function msg_friend_apply_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_friend_apply_list instance using the specified properties.
         * @function create
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {net.Imsg_friend_apply_list=} [properties] Properties to set
         * @returns {net.msg_friend_apply_list} msg_friend_apply_list instance
         */
        msg_friend_apply_list.create = function create(properties) {
            return new msg_friend_apply_list(properties);
        };

        /**
         * Encodes the specified msg_friend_apply_list message. Does not implicitly {@link net.msg_friend_apply_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {net.Imsg_friend_apply_list} message msg_friend_apply_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_friend_apply_list message, length delimited. Does not implicitly {@link net.msg_friend_apply_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {net.Imsg_friend_apply_list} message msg_friend_apply_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_friend_apply_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_apply_list} msg_friend_apply_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_apply_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_friend_apply_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_friend_apply_list} msg_friend_apply_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_friend_apply_list message.
         * @function verify
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_friend_apply_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_friend_apply_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_friend_apply_list} msg_friend_apply_list
         */
        msg_friend_apply_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_friend_apply_list)
                return object;
            return new $root.net.msg_friend_apply_list();
        };

        /**
         * Creates a plain object from a msg_friend_apply_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {net.msg_friend_apply_list} message msg_friend_apply_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_friend_apply_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_friend_apply_list to JSON.
         * @function toJSON
         * @memberof net.msg_friend_apply_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_friend_apply_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_friend_apply_list;
    })();

    net.msg_friend_apply_list_rep = (function() {

        /**
         * Properties of a msg_friend_apply_list_rep.
         * @memberof net
         * @interface Imsg_friend_apply_list_rep
         * @property {Array.<net.Ifriend_apply>|null} [apply_list] msg_friend_apply_list_rep apply_list
         */

        /**
         * Constructs a new msg_friend_apply_list_rep.
         * @memberof net
         * @classdesc Represents a msg_friend_apply_list_rep.
         * @implements Imsg_friend_apply_list_rep
         * @constructor
         * @param {net.Imsg_friend_apply_list_rep=} [properties] Properties to set
         */
        function msg_friend_apply_list_rep(properties) {
            this.apply_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_apply_list_rep apply_list.
         * @member {Array.<net.Ifriend_apply>} apply_list
         * @memberof net.msg_friend_apply_list_rep
         * @instance
         */
        msg_friend_apply_list_rep.prototype.apply_list = $util.emptyArray;

        /**
         * Creates a new msg_friend_apply_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {net.Imsg_friend_apply_list_rep=} [properties] Properties to set
         * @returns {net.msg_friend_apply_list_rep} msg_friend_apply_list_rep instance
         */
        msg_friend_apply_list_rep.create = function create(properties) {
            return new msg_friend_apply_list_rep(properties);
        };

        /**
         * Encodes the specified msg_friend_apply_list_rep message. Does not implicitly {@link net.msg_friend_apply_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {net.Imsg_friend_apply_list_rep} message msg_friend_apply_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.apply_list != null && message.apply_list.length)
                for (var i = 0; i < message.apply_list.length; ++i)
                    $root.net.friend_apply.encode(message.apply_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_friend_apply_list_rep message, length delimited. Does not implicitly {@link net.msg_friend_apply_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {net.Imsg_friend_apply_list_rep} message msg_friend_apply_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_friend_apply_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_apply_list_rep} msg_friend_apply_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_apply_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.apply_list && message.apply_list.length))
                        message.apply_list = [];
                    message.apply_list.push($root.net.friend_apply.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_friend_apply_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_friend_apply_list_rep} msg_friend_apply_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_friend_apply_list_rep message.
         * @function verify
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_friend_apply_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.apply_list != null && message.hasOwnProperty("apply_list")) {
                if (!Array.isArray(message.apply_list))
                    return "apply_list: array expected";
                for (var i = 0; i < message.apply_list.length; ++i) {
                    var error = $root.net.friend_apply.verify(message.apply_list[i]);
                    if (error)
                        return "apply_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_friend_apply_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_friend_apply_list_rep} msg_friend_apply_list_rep
         */
        msg_friend_apply_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_friend_apply_list_rep)
                return object;
            var message = new $root.net.msg_friend_apply_list_rep();
            if (object.apply_list) {
                if (!Array.isArray(object.apply_list))
                    throw TypeError(".net.msg_friend_apply_list_rep.apply_list: array expected");
                message.apply_list = [];
                for (var i = 0; i < object.apply_list.length; ++i) {
                    if (typeof object.apply_list[i] !== "object")
                        throw TypeError(".net.msg_friend_apply_list_rep.apply_list: object expected");
                    message.apply_list[i] = $root.net.friend_apply.fromObject(object.apply_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_friend_apply_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {net.msg_friend_apply_list_rep} message msg_friend_apply_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_friend_apply_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.apply_list = [];
            if (message.apply_list && message.apply_list.length) {
                object.apply_list = [];
                for (var j = 0; j < message.apply_list.length; ++j)
                    object.apply_list[j] = $root.net.friend_apply.toObject(message.apply_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_friend_apply_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_friend_apply_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_friend_apply_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_friend_apply_list_rep;
    })();

    net.msg_friend_list = (function() {

        /**
         * Properties of a msg_friend_list.
         * @memberof net
         * @interface Imsg_friend_list
         */

        /**
         * Constructs a new msg_friend_list.
         * @memberof net
         * @classdesc Represents a msg_friend_list.
         * @implements Imsg_friend_list
         * @constructor
         * @param {net.Imsg_friend_list=} [properties] Properties to set
         */
        function msg_friend_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_friend_list instance using the specified properties.
         * @function create
         * @memberof net.msg_friend_list
         * @static
         * @param {net.Imsg_friend_list=} [properties] Properties to set
         * @returns {net.msg_friend_list} msg_friend_list instance
         */
        msg_friend_list.create = function create(properties) {
            return new msg_friend_list(properties);
        };

        /**
         * Encodes the specified msg_friend_list message. Does not implicitly {@link net.msg_friend_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_list
         * @static
         * @param {net.Imsg_friend_list} message msg_friend_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_friend_list message, length delimited. Does not implicitly {@link net.msg_friend_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_friend_list
         * @static
         * @param {net.Imsg_friend_list} message msg_friend_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_friend_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_list} msg_friend_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_friend_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_friend_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_friend_list} msg_friend_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_friend_list message.
         * @function verify
         * @memberof net.msg_friend_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_friend_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_friend_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_friend_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_friend_list} msg_friend_list
         */
        msg_friend_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_friend_list)
                return object;
            return new $root.net.msg_friend_list();
        };

        /**
         * Creates a plain object from a msg_friend_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_friend_list
         * @static
         * @param {net.msg_friend_list} message msg_friend_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_friend_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_friend_list to JSON.
         * @function toJSON
         * @memberof net.msg_friend_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_friend_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_friend_list;
    })();

    net.msg_friend_list_rep = (function() {

        /**
         * Properties of a msg_friend_list_rep.
         * @memberof net
         * @interface Imsg_friend_list_rep
         * @property {Array.<net.Ibase_info>|null} [flist] msg_friend_list_rep flist
         * @property {number|null} [isfirst] msg_friend_list_rep isfirst
         * @property {number|null} [isend] msg_friend_list_rep isend
         * @property {number|null} [version] msg_friend_list_rep version
         */

        /**
         * Constructs a new msg_friend_list_rep.
         * @memberof net
         * @classdesc Represents a msg_friend_list_rep.
         * @implements Imsg_friend_list_rep
         * @constructor
         * @param {net.Imsg_friend_list_rep=} [properties] Properties to set
         */
        function msg_friend_list_rep(properties) {
            this.flist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_list_rep flist.
         * @member {Array.<net.Ibase_info>} flist
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.flist = $util.emptyArray;

        /**
         * msg_friend_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.isfirst = 0;

        /**
         * msg_friend_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.isend = 0;

        /**
         * msg_friend_list_rep version.
         * @member {number} version
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.version = 0;

        /**
         * Creates a new msg_friend_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {net.Imsg_friend_list_rep=} [properties] Properties to set
         * @returns {net.msg_friend_list_rep} msg_friend_list_rep instance
         */
        msg_friend_list_rep.create = function create(properties) {
            return new msg_friend_list_rep(properties);
        };

        /**
         * Encodes the specified msg_friend_list_rep message. Does not implicitly {@link net.msg_friend_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {net.Imsg_friend_list_rep} message msg_friend_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flist != null && message.flist.length)
                for (var i = 0; i < message.flist.length; ++i)
                    $root.net.base_info.encode(message.flist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isend);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_friend_list_rep message, length delimited. Does not implicitly {@link net.msg_friend_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {net.Imsg_friend_list_rep} message msg_friend_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_friend_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_list_rep} msg_friend_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.flist && message.flist.length))
                        message.flist = [];
                    message.flist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    message.isend = reader.int32();
                    break;
                case 4:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_friend_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_friend_list_rep} msg_friend_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_friend_list_rep message.
         * @function verify
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_friend_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.flist != null && message.hasOwnProperty("flist")) {
                if (!Array.isArray(message.flist))
                    return "flist: array expected";
                for (var i = 0; i < message.flist.length; ++i) {
                    var error = $root.net.base_info.verify(message.flist[i]);
                    if (error)
                        return "flist." + error;
                }
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                if (!$util.isInteger(message.isfirst))
                    return "isfirst: integer expected";
            if (message.isend != null && message.hasOwnProperty("isend"))
                if (!$util.isInteger(message.isend))
                    return "isend: integer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            return null;
        };

        /**
         * Creates a msg_friend_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_friend_list_rep} msg_friend_list_rep
         */
        msg_friend_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_friend_list_rep)
                return object;
            var message = new $root.net.msg_friend_list_rep();
            if (object.flist) {
                if (!Array.isArray(object.flist))
                    throw TypeError(".net.msg_friend_list_rep.flist: array expected");
                message.flist = [];
                for (var i = 0; i < object.flist.length; ++i) {
                    if (typeof object.flist[i] !== "object")
                        throw TypeError(".net.msg_friend_list_rep.flist: object expected");
                    message.flist[i] = $root.net.base_info.fromObject(object.flist[i]);
                }
            }
            if (object.isfirst != null)
                message.isfirst = object.isfirst | 0;
            if (object.isend != null)
                message.isend = object.isend | 0;
            if (object.version != null)
                message.version = object.version | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_friend_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {net.msg_friend_list_rep} message msg_friend_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_friend_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.flist = [];
            if (options.defaults) {
                object.isfirst = 0;
                object.isend = 0;
                object.version = 0;
            }
            if (message.flist && message.flist.length) {
                object.flist = [];
                for (var j = 0; j < message.flist.length; ++j)
                    object.flist[j] = $root.net.base_info.toObject(message.flist[j], options);
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                object.isfirst = message.isfirst;
            if (message.isend != null && message.hasOwnProperty("isend"))
                object.isend = message.isend;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this msg_friend_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_friend_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_friend_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_friend_list_rep;
    })();

    net.msg_get_user_info = (function() {

        /**
         * Properties of a msg_get_user_info.
         * @memberof net
         * @interface Imsg_get_user_info
         * @property {Uint8Array|null} [phonenum] msg_get_user_info phonenum
         * @property {number|null} [uid] msg_get_user_info uid
         * @property {number|null} [fid] msg_get_user_info fid
         * @property {number|null} [channel] msg_get_user_info channel
         * @property {number|null} [thirduid] msg_get_user_info thirduid
         * @property {Uint8Array|null} [zone] msg_get_user_info zone
         */

        /**
         * Constructs a new msg_get_user_info.
         * @memberof net
         * @classdesc Represents a msg_get_user_info.
         * @implements Imsg_get_user_info
         * @constructor
         * @param {net.Imsg_get_user_info=} [properties] Properties to set
         */
        function msg_get_user_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_user_info phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_get_user_info uid.
         * @member {number} uid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.uid = 0;

        /**
         * msg_get_user_info fid.
         * @member {number} fid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.fid = 0;

        /**
         * msg_get_user_info channel.
         * @member {number} channel
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.channel = 0;

        /**
         * msg_get_user_info thirduid.
         * @member {number} thirduid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.thirduid = 0;

        /**
         * msg_get_user_info zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.zone = $util.newBuffer([]);

        /**
         * Creates a new msg_get_user_info instance using the specified properties.
         * @function create
         * @memberof net.msg_get_user_info
         * @static
         * @param {net.Imsg_get_user_info=} [properties] Properties to set
         * @returns {net.msg_get_user_info} msg_get_user_info instance
         */
        msg_get_user_info.create = function create(properties) {
            return new msg_get_user_info(properties);
        };

        /**
         * Encodes the specified msg_get_user_info message. Does not implicitly {@link net.msg_get_user_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_user_info
         * @static
         * @param {net.Imsg_get_user_info} message msg_get_user_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.phonenum);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.fid);
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.thirduid);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.zone);
            return writer;
        };

        /**
         * Encodes the specified msg_get_user_info message, length delimited. Does not implicitly {@link net.msg_get_user_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_user_info
         * @static
         * @param {net.Imsg_get_user_info} message msg_get_user_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_user_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_user_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_user_info} msg_get_user_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_user_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.phonenum = reader.bytes();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.fid = reader.int32();
                    break;
                case 4:
                    message.channel = reader.uint32();
                    break;
                case 5:
                    message.thirduid = reader.uint32();
                    break;
                case 6:
                    message.zone = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_user_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_user_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_user_info} msg_get_user_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_user_info message.
         * @function verify
         * @memberof net.msg_get_user_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_user_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.fid != null && message.hasOwnProperty("fid"))
                if (!$util.isInteger(message.fid))
                    return "fid: integer expected";
            if (message.channel != null && message.hasOwnProperty("channel"))
                if (!$util.isInteger(message.channel))
                    return "channel: integer expected";
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                if (!$util.isInteger(message.thirduid))
                    return "thirduid: integer expected";
            if (message.zone != null && message.hasOwnProperty("zone"))
                if (!(message.zone && typeof message.zone.length === "number" || $util.isString(message.zone)))
                    return "zone: buffer expected";
            return null;
        };

        /**
         * Creates a msg_get_user_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_user_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_user_info} msg_get_user_info
         */
        msg_get_user_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_user_info)
                return object;
            var message = new $root.net.msg_get_user_info();
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.fid != null)
                message.fid = object.fid | 0;
            if (object.channel != null)
                message.channel = object.channel >>> 0;
            if (object.thirduid != null)
                message.thirduid = object.thirduid >>> 0;
            if (object.zone != null)
                if (typeof object.zone === "string")
                    $util.base64.decode(object.zone, message.zone = $util.newBuffer($util.base64.length(object.zone)), 0);
                else if (object.zone.length)
                    message.zone = object.zone;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_user_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_user_info
         * @static
         * @param {net.msg_get_user_info} message msg_get_user_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_user_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
                object.uid = 0;
                object.fid = 0;
                object.channel = 0;
                object.thirduid = 0;
                if (options.bytes === String)
                    object.zone = "";
                else {
                    object.zone = [];
                    if (options.bytes !== Array)
                        object.zone = $util.newBuffer(object.zone);
                }
            }
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.fid != null && message.hasOwnProperty("fid"))
                object.fid = message.fid;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                object.thirduid = message.thirduid;
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = options.bytes === String ? $util.base64.encode(message.zone, 0, message.zone.length) : options.bytes === Array ? Array.prototype.slice.call(message.zone) : message.zone;
            return object;
        };

        /**
         * Converts this msg_get_user_info to JSON.
         * @function toJSON
         * @memberof net.msg_get_user_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_user_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_user_info;
    })();

    net.msg_get_user_info_rep = (function() {

        /**
         * Properties of a msg_get_user_info_rep.
         * @memberof net
         * @interface Imsg_get_user_info_rep
         * @property {net.Ibase_info|null} [user_info] msg_get_user_info_rep user_info
         */

        /**
         * Constructs a new msg_get_user_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_user_info_rep.
         * @implements Imsg_get_user_info_rep
         * @constructor
         * @param {net.Imsg_get_user_info_rep=} [properties] Properties to set
         */
        function msg_get_user_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_user_info_rep user_info.
         * @member {net.Ibase_info|null|undefined} user_info
         * @memberof net.msg_get_user_info_rep
         * @instance
         */
        msg_get_user_info_rep.prototype.user_info = null;

        /**
         * Creates a new msg_get_user_info_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {net.Imsg_get_user_info_rep=} [properties] Properties to set
         * @returns {net.msg_get_user_info_rep} msg_get_user_info_rep instance
         */
        msg_get_user_info_rep.create = function create(properties) {
            return new msg_get_user_info_rep(properties);
        };

        /**
         * Encodes the specified msg_get_user_info_rep message. Does not implicitly {@link net.msg_get_user_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {net.Imsg_get_user_info_rep} message msg_get_user_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.user_info != null && Object.hasOwnProperty.call(message, "user_info"))
                $root.net.base_info.encode(message.user_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_user_info_rep message, length delimited. Does not implicitly {@link net.msg_get_user_info_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {net.Imsg_get_user_info_rep} message msg_get_user_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_user_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_user_info_rep} msg_get_user_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_user_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.user_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_user_info_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_user_info_rep} msg_get_user_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_user_info_rep message.
         * @function verify
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_user_info_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.user_info != null && message.hasOwnProperty("user_info")) {
                var error = $root.net.base_info.verify(message.user_info);
                if (error)
                    return "user_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_get_user_info_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_user_info_rep} msg_get_user_info_rep
         */
        msg_get_user_info_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_user_info_rep)
                return object;
            var message = new $root.net.msg_get_user_info_rep();
            if (object.user_info != null) {
                if (typeof object.user_info !== "object")
                    throw TypeError(".net.msg_get_user_info_rep.user_info: object expected");
                message.user_info = $root.net.base_info.fromObject(object.user_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_user_info_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {net.msg_get_user_info_rep} message msg_get_user_info_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_user_info_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.user_info = null;
            if (message.user_info != null && message.hasOwnProperty("user_info"))
                object.user_info = $root.net.base_info.toObject(message.user_info, options);
            return object;
        };

        /**
         * Converts this msg_get_user_info_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_user_info_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_user_info_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_user_info_rep;
    })();

    net.msg_send_private_msg = (function() {

        /**
         * Properties of a msg_send_private_msg.
         * @memberof net
         * @interface Imsg_send_private_msg
         * @property {number|null} [recvuid] msg_send_private_msg recvuid
         * @property {number|null} [msg_type] msg_send_private_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_private_msg content
         * @property {Uint8Array|null} [clientkey] msg_send_private_msg clientkey
         * @property {number|null} [nopush] msg_send_private_msg nopush
         * @property {Uint8Array|null} [authcode] msg_send_private_msg authcode
         */

        /**
         * Constructs a new msg_send_private_msg.
         * @memberof net
         * @classdesc Represents a msg_send_private_msg.
         * @implements Imsg_send_private_msg
         * @constructor
         * @param {net.Imsg_send_private_msg=} [properties] Properties to set
         */
        function msg_send_private_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_private_msg recvuid.
         * @member {number} recvuid
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.recvuid = 0;

        /**
         * msg_send_private_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.msg_type = 0;

        /**
         * msg_send_private_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.content = $util.newBuffer([]);

        /**
         * msg_send_private_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * msg_send_private_msg nopush.
         * @member {number} nopush
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.nopush = 0;

        /**
         * msg_send_private_msg authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.authcode = $util.newBuffer([]);

        /**
         * Creates a new msg_send_private_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_send_private_msg
         * @static
         * @param {net.Imsg_send_private_msg=} [properties] Properties to set
         * @returns {net.msg_send_private_msg} msg_send_private_msg instance
         */
        msg_send_private_msg.create = function create(properties) {
            return new msg_send_private_msg(properties);
        };

        /**
         * Encodes the specified msg_send_private_msg message. Does not implicitly {@link net.msg_send_private_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_private_msg
         * @static
         * @param {net.Imsg_send_private_msg} message msg_send_private_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recvuid != null && Object.hasOwnProperty.call(message, "recvuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.recvuid);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.clientkey);
            if (message.nopush != null && Object.hasOwnProperty.call(message, "nopush"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.nopush);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.authcode);
            return writer;
        };

        /**
         * Encodes the specified msg_send_private_msg message, length delimited. Does not implicitly {@link net.msg_send_private_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_private_msg
         * @static
         * @param {net.Imsg_send_private_msg} message msg_send_private_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_private_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_private_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_private_msg} msg_send_private_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_private_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recvuid = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                case 4:
                    message.clientkey = reader.bytes();
                    break;
                case 5:
                    message.nopush = reader.int32();
                    break;
                case 6:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_private_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_private_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_private_msg} msg_send_private_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_private_msg message.
         * @function verify
         * @memberof net.msg_send_private_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_private_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recvuid != null && message.hasOwnProperty("recvuid"))
                if (!$util.isInteger(message.recvuid))
                    return "recvuid: integer expected";
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                if (!$util.isInteger(message.msg_type))
                    return "msg_type: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                if (!(message.clientkey && typeof message.clientkey.length === "number" || $util.isString(message.clientkey)))
                    return "clientkey: buffer expected";
            if (message.nopush != null && message.hasOwnProperty("nopush"))
                if (!$util.isInteger(message.nopush))
                    return "nopush: integer expected";
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                if (!(message.authcode && typeof message.authcode.length === "number" || $util.isString(message.authcode)))
                    return "authcode: buffer expected";
            return null;
        };

        /**
         * Creates a msg_send_private_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_private_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_private_msg} msg_send_private_msg
         */
        msg_send_private_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_private_msg)
                return object;
            var message = new $root.net.msg_send_private_msg();
            if (object.recvuid != null)
                message.recvuid = object.recvuid | 0;
            if (object.msg_type != null)
                message.msg_type = object.msg_type | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.clientkey != null)
                if (typeof object.clientkey === "string")
                    $util.base64.decode(object.clientkey, message.clientkey = $util.newBuffer($util.base64.length(object.clientkey)), 0);
                else if (object.clientkey.length)
                    message.clientkey = object.clientkey;
            if (object.nopush != null)
                message.nopush = object.nopush | 0;
            if (object.authcode != null)
                if (typeof object.authcode === "string")
                    $util.base64.decode(object.authcode, message.authcode = $util.newBuffer($util.base64.length(object.authcode)), 0);
                else if (object.authcode.length)
                    message.authcode = object.authcode;
            return message;
        };

        /**
         * Creates a plain object from a msg_send_private_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_private_msg
         * @static
         * @param {net.msg_send_private_msg} message msg_send_private_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_private_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.recvuid = 0;
                object.msg_type = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                if (options.bytes === String)
                    object.clientkey = "";
                else {
                    object.clientkey = [];
                    if (options.bytes !== Array)
                        object.clientkey = $util.newBuffer(object.clientkey);
                }
                object.nopush = 0;
                if (options.bytes === String)
                    object.authcode = "";
                else {
                    object.authcode = [];
                    if (options.bytes !== Array)
                        object.authcode = $util.newBuffer(object.authcode);
                }
            }
            if (message.recvuid != null && message.hasOwnProperty("recvuid"))
                object.recvuid = message.recvuid;
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                object.msg_type = message.msg_type;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                object.clientkey = options.bytes === String ? $util.base64.encode(message.clientkey, 0, message.clientkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.clientkey) : message.clientkey;
            if (message.nopush != null && message.hasOwnProperty("nopush"))
                object.nopush = message.nopush;
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                object.authcode = options.bytes === String ? $util.base64.encode(message.authcode, 0, message.authcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.authcode) : message.authcode;
            return object;
        };

        /**
         * Converts this msg_send_private_msg to JSON.
         * @function toJSON
         * @memberof net.msg_send_private_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_private_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_private_msg;
    })();

    net.msg_send_private_msg_rep = (function() {

        /**
         * Properties of a msg_send_private_msg_rep.
         * @memberof net
         * @interface Imsg_send_private_msg_rep
         * @property {number|null} [result] msg_send_private_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_private_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_private_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_private_msg_rep.
         * @implements Imsg_send_private_msg_rep
         * @constructor
         * @param {net.Imsg_send_private_msg_rep=} [properties] Properties to set
         */
        function msg_send_private_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_private_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_private_msg_rep
         * @instance
         */
        msg_send_private_msg_rep.prototype.result = 0;

        /**
         * msg_send_private_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_private_msg_rep
         * @instance
         */
        msg_send_private_msg_rep.prototype.msg_info = null;

        /**
         * Creates a new msg_send_private_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {net.Imsg_send_private_msg_rep=} [properties] Properties to set
         * @returns {net.msg_send_private_msg_rep} msg_send_private_msg_rep instance
         */
        msg_send_private_msg_rep.create = function create(properties) {
            return new msg_send_private_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_send_private_msg_rep message. Does not implicitly {@link net.msg_send_private_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {net.Imsg_send_private_msg_rep} message msg_send_private_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_send_private_msg_rep message, length delimited. Does not implicitly {@link net.msg_send_private_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {net.Imsg_send_private_msg_rep} message msg_send_private_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_private_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_private_msg_rep} msg_send_private_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_private_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_private_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_private_msg_rep} msg_send_private_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_private_msg_rep message.
         * @function verify
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_private_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.msg_info != null && message.hasOwnProperty("msg_info")) {
                var error = $root.net.chat_msg.verify(message.msg_info);
                if (error)
                    return "msg_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_send_private_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_private_msg_rep} msg_send_private_msg_rep
         */
        msg_send_private_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_private_msg_rep)
                return object;
            var message = new $root.net.msg_send_private_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.msg_info != null) {
                if (typeof object.msg_info !== "object")
                    throw TypeError(".net.msg_send_private_msg_rep.msg_info: object expected");
                message.msg_info = $root.net.chat_msg.fromObject(object.msg_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_send_private_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {net.msg_send_private_msg_rep} message msg_send_private_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_private_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.msg_info = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.msg_info != null && message.hasOwnProperty("msg_info"))
                object.msg_info = $root.net.chat_msg.toObject(message.msg_info, options);
            return object;
        };

        /**
         * Converts this msg_send_private_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_send_private_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_private_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_private_msg_rep;
    })();

    net.msg_get_msg_list = (function() {

        /**
         * Properties of a msg_get_msg_list.
         * @memberof net
         * @interface Imsg_get_msg_list
         * @property {number|Long|null} [chatkey] msg_get_msg_list chatkey
         * @property {number|null} [chatmsgno] msg_get_msg_list chatmsgno
         */

        /**
         * Constructs a new msg_get_msg_list.
         * @memberof net
         * @classdesc Represents a msg_get_msg_list.
         * @implements Imsg_get_msg_list
         * @constructor
         * @param {net.Imsg_get_msg_list=} [properties] Properties to set
         */
        function msg_get_msg_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_msg_list chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_msg_list
         * @instance
         */
        msg_get_msg_list.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_msg_list chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_get_msg_list
         * @instance
         */
        msg_get_msg_list.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_get_msg_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_msg_list
         * @static
         * @param {net.Imsg_get_msg_list=} [properties] Properties to set
         * @returns {net.msg_get_msg_list} msg_get_msg_list instance
         */
        msg_get_msg_list.create = function create(properties) {
            return new msg_get_msg_list(properties);
        };

        /**
         * Encodes the specified msg_get_msg_list message. Does not implicitly {@link net.msg_get_msg_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_msg_list
         * @static
         * @param {net.Imsg_get_msg_list} message msg_get_msg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_get_msg_list message, length delimited. Does not implicitly {@link net.msg_get_msg_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_msg_list
         * @static
         * @param {net.Imsg_get_msg_list} message msg_get_msg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_msg_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_msg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_msg_list} msg_get_msg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_msg_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_msg_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_msg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_msg_list} msg_get_msg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_msg_list message.
         * @function verify
         * @memberof net.msg_get_msg_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_msg_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_msg_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_msg_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_msg_list} msg_get_msg_list
         */
        msg_get_msg_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_msg_list)
                return object;
            var message = new $root.net.msg_get_msg_list();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_msg_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_msg_list
         * @static
         * @param {net.msg_get_msg_list} message msg_get_msg_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_msg_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_get_msg_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_msg_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_msg_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_msg_list;
    })();

    net.msg_get_msg_list_rep = (function() {

        /**
         * Properties of a msg_get_msg_list_rep.
         * @memberof net
         * @interface Imsg_get_msg_list_rep
         * @property {Array.<net.Ichat_msg>|null} [msg_list] msg_get_msg_list_rep msg_list
         * @property {number|null} [hasred] msg_get_msg_list_rep hasred
         * @property {number|null} [readversion] msg_get_msg_list_rep readversion
         */

        /**
         * Constructs a new msg_get_msg_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_msg_list_rep.
         * @implements Imsg_get_msg_list_rep
         * @constructor
         * @param {net.Imsg_get_msg_list_rep=} [properties] Properties to set
         */
        function msg_get_msg_list_rep(properties) {
            this.msg_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_msg_list_rep msg_list.
         * @member {Array.<net.Ichat_msg>} msg_list
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.msg_list = $util.emptyArray;

        /**
         * msg_get_msg_list_rep hasred.
         * @member {number} hasred
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.hasred = 0;

        /**
         * msg_get_msg_list_rep readversion.
         * @member {number} readversion
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.readversion = 0;

        /**
         * Creates a new msg_get_msg_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {net.Imsg_get_msg_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_msg_list_rep} msg_get_msg_list_rep instance
         */
        msg_get_msg_list_rep.create = function create(properties) {
            return new msg_get_msg_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_msg_list_rep message. Does not implicitly {@link net.msg_get_msg_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {net.Imsg_get_msg_list_rep} message msg_get_msg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msg_list != null && message.msg_list.length)
                for (var i = 0; i < message.msg_list.length; ++i)
                    $root.net.chat_msg.encode(message.msg_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.hasred != null && Object.hasOwnProperty.call(message, "hasred"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.hasred);
            if (message.readversion != null && Object.hasOwnProperty.call(message, "readversion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.readversion);
            return writer;
        };

        /**
         * Encodes the specified msg_get_msg_list_rep message, length delimited. Does not implicitly {@link net.msg_get_msg_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {net.Imsg_get_msg_list_rep} message msg_get_msg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_msg_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_msg_list_rep} msg_get_msg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_msg_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.msg_list && message.msg_list.length))
                        message.msg_list = [];
                    message.msg_list.push($root.net.chat_msg.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.hasred = reader.int32();
                    break;
                case 3:
                    message.readversion = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_msg_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_msg_list_rep} msg_get_msg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_msg_list_rep message.
         * @function verify
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_msg_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msg_list != null && message.hasOwnProperty("msg_list")) {
                if (!Array.isArray(message.msg_list))
                    return "msg_list: array expected";
                for (var i = 0; i < message.msg_list.length; ++i) {
                    var error = $root.net.chat_msg.verify(message.msg_list[i]);
                    if (error)
                        return "msg_list." + error;
                }
            }
            if (message.hasred != null && message.hasOwnProperty("hasred"))
                if (!$util.isInteger(message.hasred))
                    return "hasred: integer expected";
            if (message.readversion != null && message.hasOwnProperty("readversion"))
                if (!$util.isInteger(message.readversion))
                    return "readversion: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_msg_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_msg_list_rep} msg_get_msg_list_rep
         */
        msg_get_msg_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_msg_list_rep)
                return object;
            var message = new $root.net.msg_get_msg_list_rep();
            if (object.msg_list) {
                if (!Array.isArray(object.msg_list))
                    throw TypeError(".net.msg_get_msg_list_rep.msg_list: array expected");
                message.msg_list = [];
                for (var i = 0; i < object.msg_list.length; ++i) {
                    if (typeof object.msg_list[i] !== "object")
                        throw TypeError(".net.msg_get_msg_list_rep.msg_list: object expected");
                    message.msg_list[i] = $root.net.chat_msg.fromObject(object.msg_list[i]);
                }
            }
            if (object.hasred != null)
                message.hasred = object.hasred | 0;
            if (object.readversion != null)
                message.readversion = object.readversion | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_msg_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {net.msg_get_msg_list_rep} message msg_get_msg_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_msg_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.msg_list = [];
            if (options.defaults) {
                object.hasred = 0;
                object.readversion = 0;
            }
            if (message.msg_list && message.msg_list.length) {
                object.msg_list = [];
                for (var j = 0; j < message.msg_list.length; ++j)
                    object.msg_list[j] = $root.net.chat_msg.toObject(message.msg_list[j], options);
            }
            if (message.hasred != null && message.hasOwnProperty("hasred"))
                object.hasred = message.hasred;
            if (message.readversion != null && message.hasOwnProperty("readversion"))
                object.readversion = message.readversion;
            return object;
        };

        /**
         * Converts this msg_get_msg_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_msg_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_msg_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_msg_list_rep;
    })();

    net.msg_confirm_read_msg = (function() {

        /**
         * Properties of a msg_confirm_read_msg.
         * @memberof net
         * @interface Imsg_confirm_read_msg
         * @property {number|Long|null} [chatkey] msg_confirm_read_msg chatkey
         * @property {number|null} [chatmsgno] msg_confirm_read_msg chatmsgno
         */

        /**
         * Constructs a new msg_confirm_read_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_read_msg.
         * @implements Imsg_confirm_read_msg
         * @constructor
         * @param {net.Imsg_confirm_read_msg=} [properties] Properties to set
         */
        function msg_confirm_read_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_read_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_read_msg
         * @instance
         */
        msg_confirm_read_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_read_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_read_msg
         * @instance
         */
        msg_confirm_read_msg.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_confirm_read_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {net.Imsg_confirm_read_msg=} [properties] Properties to set
         * @returns {net.msg_confirm_read_msg} msg_confirm_read_msg instance
         */
        msg_confirm_read_msg.create = function create(properties) {
            return new msg_confirm_read_msg(properties);
        };

        /**
         * Encodes the specified msg_confirm_read_msg message. Does not implicitly {@link net.msg_confirm_read_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {net.Imsg_confirm_read_msg} message msg_confirm_read_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_read_msg message, length delimited. Does not implicitly {@link net.msg_confirm_read_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {net.Imsg_confirm_read_msg} message msg_confirm_read_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_read_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_read_msg} msg_confirm_read_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_read_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_read_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_read_msg} msg_confirm_read_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_read_msg message.
         * @function verify
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_read_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_read_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_read_msg} msg_confirm_read_msg
         */
        msg_confirm_read_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_read_msg)
                return object;
            var message = new $root.net.msg_confirm_read_msg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_read_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {net.msg_confirm_read_msg} message msg_confirm_read_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_read_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_confirm_read_msg to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_read_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_read_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_read_msg;
    })();

    net.msg_confirm_read_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_read_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_read_msg_rep
         * @property {number|null} [result] msg_confirm_read_msg_rep result
         */

        /**
         * Constructs a new msg_confirm_read_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_read_msg_rep.
         * @implements Imsg_confirm_read_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_read_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_read_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_read_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_read_msg_rep
         * @instance
         */
        msg_confirm_read_msg_rep.prototype.result = 0;

        /**
         * Creates a new msg_confirm_read_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {net.Imsg_confirm_read_msg_rep=} [properties] Properties to set
         * @returns {net.msg_confirm_read_msg_rep} msg_confirm_read_msg_rep instance
         */
        msg_confirm_read_msg_rep.create = function create(properties) {
            return new msg_confirm_read_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_confirm_read_msg_rep message. Does not implicitly {@link net.msg_confirm_read_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {net.Imsg_confirm_read_msg_rep} message msg_confirm_read_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_read_msg_rep message, length delimited. Does not implicitly {@link net.msg_confirm_read_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {net.Imsg_confirm_read_msg_rep} message msg_confirm_read_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_read_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_read_msg_rep} msg_confirm_read_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_read_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_read_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_read_msg_rep} msg_confirm_read_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_read_msg_rep message.
         * @function verify
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_read_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_read_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_read_msg_rep} msg_confirm_read_msg_rep
         */
        msg_confirm_read_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_read_msg_rep)
                return object;
            var message = new $root.net.msg_confirm_read_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_read_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {net.msg_confirm_read_msg_rep} message msg_confirm_read_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_read_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_confirm_read_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_read_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_read_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_read_msg_rep;
    })();

    net.msg_create_group_chat = (function() {

        /**
         * Properties of a msg_create_group_chat.
         * @memberof net
         * @interface Imsg_create_group_chat
         * @property {Array.<number>|null} [uids] msg_create_group_chat uids
         * @property {number|null} [opertm] msg_create_group_chat opertm
         * @property {Uint8Array|null} [groupname] msg_create_group_chat groupname
         * @property {Uint8Array|null} [group_headurl] msg_create_group_chat group_headurl
         */

        /**
         * Constructs a new msg_create_group_chat.
         * @memberof net
         * @classdesc Represents a msg_create_group_chat.
         * @implements Imsg_create_group_chat
         * @constructor
         * @param {net.Imsg_create_group_chat=} [properties] Properties to set
         */
        function msg_create_group_chat(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_group_chat uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.uids = $util.emptyArray;

        /**
         * msg_create_group_chat opertm.
         * @member {number} opertm
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.opertm = 0;

        /**
         * msg_create_group_chat groupname.
         * @member {Uint8Array} groupname
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.groupname = $util.newBuffer([]);

        /**
         * msg_create_group_chat group_headurl.
         * @member {Uint8Array} group_headurl
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.group_headurl = $util.newBuffer([]);

        /**
         * Creates a new msg_create_group_chat instance using the specified properties.
         * @function create
         * @memberof net.msg_create_group_chat
         * @static
         * @param {net.Imsg_create_group_chat=} [properties] Properties to set
         * @returns {net.msg_create_group_chat} msg_create_group_chat instance
         */
        msg_create_group_chat.create = function create(properties) {
            return new msg_create_group_chat(properties);
        };

        /**
         * Encodes the specified msg_create_group_chat message. Does not implicitly {@link net.msg_create_group_chat.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_group_chat
         * @static
         * @param {net.Imsg_create_group_chat} message msg_create_group_chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.opertm != null && Object.hasOwnProperty.call(message, "opertm"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.opertm);
            if (message.groupname != null && Object.hasOwnProperty.call(message, "groupname"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.groupname);
            if (message.group_headurl != null && Object.hasOwnProperty.call(message, "group_headurl"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.group_headurl);
            return writer;
        };

        /**
         * Encodes the specified msg_create_group_chat message, length delimited. Does not implicitly {@link net.msg_create_group_chat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_group_chat
         * @static
         * @param {net.Imsg_create_group_chat} message msg_create_group_chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_group_chat message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_group_chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_group_chat} msg_create_group_chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_group_chat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.opertm = reader.uint32();
                    break;
                case 3:
                    message.groupname = reader.bytes();
                    break;
                case 4:
                    message.group_headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_group_chat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_group_chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_group_chat} msg_create_group_chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_group_chat message.
         * @function verify
         * @memberof net.msg_create_group_chat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_group_chat.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            if (message.opertm != null && message.hasOwnProperty("opertm"))
                if (!$util.isInteger(message.opertm))
                    return "opertm: integer expected";
            if (message.groupname != null && message.hasOwnProperty("groupname"))
                if (!(message.groupname && typeof message.groupname.length === "number" || $util.isString(message.groupname)))
                    return "groupname: buffer expected";
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                if (!(message.group_headurl && typeof message.group_headurl.length === "number" || $util.isString(message.group_headurl)))
                    return "group_headurl: buffer expected";
            return null;
        };

        /**
         * Creates a msg_create_group_chat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_group_chat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_group_chat} msg_create_group_chat
         */
        msg_create_group_chat.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_group_chat)
                return object;
            var message = new $root.net.msg_create_group_chat();
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_create_group_chat.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            if (object.opertm != null)
                message.opertm = object.opertm >>> 0;
            if (object.groupname != null)
                if (typeof object.groupname === "string")
                    $util.base64.decode(object.groupname, message.groupname = $util.newBuffer($util.base64.length(object.groupname)), 0);
                else if (object.groupname.length)
                    message.groupname = object.groupname;
            if (object.group_headurl != null)
                if (typeof object.group_headurl === "string")
                    $util.base64.decode(object.group_headurl, message.group_headurl = $util.newBuffer($util.base64.length(object.group_headurl)), 0);
                else if (object.group_headurl.length)
                    message.group_headurl = object.group_headurl;
            return message;
        };

        /**
         * Creates a plain object from a msg_create_group_chat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_group_chat
         * @static
         * @param {net.msg_create_group_chat} message msg_create_group_chat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_group_chat.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults) {
                object.opertm = 0;
                if (options.bytes === String)
                    object.groupname = "";
                else {
                    object.groupname = [];
                    if (options.bytes !== Array)
                        object.groupname = $util.newBuffer(object.groupname);
                }
                if (options.bytes === String)
                    object.group_headurl = "";
                else {
                    object.group_headurl = [];
                    if (options.bytes !== Array)
                        object.group_headurl = $util.newBuffer(object.group_headurl);
                }
            }
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            if (message.opertm != null && message.hasOwnProperty("opertm"))
                object.opertm = message.opertm;
            if (message.groupname != null && message.hasOwnProperty("groupname"))
                object.groupname = options.bytes === String ? $util.base64.encode(message.groupname, 0, message.groupname.length) : options.bytes === Array ? Array.prototype.slice.call(message.groupname) : message.groupname;
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                object.group_headurl = options.bytes === String ? $util.base64.encode(message.group_headurl, 0, message.group_headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.group_headurl) : message.group_headurl;
            return object;
        };

        /**
         * Converts this msg_create_group_chat to JSON.
         * @function toJSON
         * @memberof net.msg_create_group_chat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_group_chat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_group_chat;
    })();

    net.msg_create_group_chat_rep = (function() {

        /**
         * Properties of a msg_create_group_chat_rep.
         * @memberof net
         * @interface Imsg_create_group_chat_rep
         * @property {number|null} [result] msg_create_group_chat_rep result
         * @property {net.Igroup_base_info|null} [group_info] msg_create_group_chat_rep group_info
         * @property {Array.<net.Ibase_info>|null} [users] msg_create_group_chat_rep users
         */

        /**
         * Constructs a new msg_create_group_chat_rep.
         * @memberof net
         * @classdesc Represents a msg_create_group_chat_rep.
         * @implements Imsg_create_group_chat_rep
         * @constructor
         * @param {net.Imsg_create_group_chat_rep=} [properties] Properties to set
         */
        function msg_create_group_chat_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_group_chat_rep result.
         * @member {number} result
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.result = 0;

        /**
         * msg_create_group_chat_rep group_info.
         * @member {net.Igroup_base_info|null|undefined} group_info
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.group_info = null;

        /**
         * msg_create_group_chat_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.users = $util.emptyArray;

        /**
         * Creates a new msg_create_group_chat_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {net.Imsg_create_group_chat_rep=} [properties] Properties to set
         * @returns {net.msg_create_group_chat_rep} msg_create_group_chat_rep instance
         */
        msg_create_group_chat_rep.create = function create(properties) {
            return new msg_create_group_chat_rep(properties);
        };

        /**
         * Encodes the specified msg_create_group_chat_rep message. Does not implicitly {@link net.msg_create_group_chat_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {net.Imsg_create_group_chat_rep} message msg_create_group_chat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.group_info != null && Object.hasOwnProperty.call(message, "group_info"))
                $root.net.group_base_info.encode(message.group_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_create_group_chat_rep message, length delimited. Does not implicitly {@link net.msg_create_group_chat_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {net.Imsg_create_group_chat_rep} message msg_create_group_chat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_group_chat_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_group_chat_rep} msg_create_group_chat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_group_chat_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.group_info = $root.net.group_base_info.decode(reader, reader.uint32());
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_group_chat_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_group_chat_rep} msg_create_group_chat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_group_chat_rep message.
         * @function verify
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_group_chat_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.group_info != null && message.hasOwnProperty("group_info")) {
                var error = $root.net.group_base_info.verify(message.group_info);
                if (error)
                    return "group_info." + error;
            }
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_create_group_chat_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_group_chat_rep} msg_create_group_chat_rep
         */
        msg_create_group_chat_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_group_chat_rep)
                return object;
            var message = new $root.net.msg_create_group_chat_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.group_info != null) {
                if (typeof object.group_info !== "object")
                    throw TypeError(".net.msg_create_group_chat_rep.group_info: object expected");
                message.group_info = $root.net.group_base_info.fromObject(object.group_info);
            }
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_create_group_chat_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_create_group_chat_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_create_group_chat_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {net.msg_create_group_chat_rep} message msg_create_group_chat_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_group_chat_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.result = 0;
                object.group_info = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.group_info != null && message.hasOwnProperty("group_info"))
                object.group_info = $root.net.group_base_info.toObject(message.group_info, options);
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_create_group_chat_rep to JSON.
         * @function toJSON
         * @memberof net.msg_create_group_chat_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_group_chat_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_group_chat_rep;
    })();

    net.msg_add_group_member = (function() {

        /**
         * Properties of a msg_add_group_member.
         * @memberof net
         * @interface Imsg_add_group_member
         * @property {number|null} [groupkey] msg_add_group_member groupkey
         * @property {Array.<number>|null} [uids] msg_add_group_member uids
         */

        /**
         * Constructs a new msg_add_group_member.
         * @memberof net
         * @classdesc Represents a msg_add_group_member.
         * @implements Imsg_add_group_member
         * @constructor
         * @param {net.Imsg_add_group_member=} [properties] Properties to set
         */
        function msg_add_group_member(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_group_member groupkey.
         * @member {number} groupkey
         * @memberof net.msg_add_group_member
         * @instance
         */
        msg_add_group_member.prototype.groupkey = 0;

        /**
         * msg_add_group_member uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_add_group_member
         * @instance
         */
        msg_add_group_member.prototype.uids = $util.emptyArray;

        /**
         * Creates a new msg_add_group_member instance using the specified properties.
         * @function create
         * @memberof net.msg_add_group_member
         * @static
         * @param {net.Imsg_add_group_member=} [properties] Properties to set
         * @returns {net.msg_add_group_member} msg_add_group_member instance
         */
        msg_add_group_member.create = function create(properties) {
            return new msg_add_group_member(properties);
        };

        /**
         * Encodes the specified msg_add_group_member message. Does not implicitly {@link net.msg_add_group_member.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_group_member
         * @static
         * @param {net.Imsg_add_group_member} message msg_add_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uids[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_add_group_member message, length delimited. Does not implicitly {@link net.msg_add_group_member.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_group_member
         * @static
         * @param {net.Imsg_add_group_member} message msg_add_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_group_member message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_group_member} msg_add_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_group_member();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_group_member message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_group_member} msg_add_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_group_member message.
         * @function verify
         * @memberof net.msg_add_group_member
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_group_member.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_add_group_member message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_group_member
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_group_member} msg_add_group_member
         */
        msg_add_group_member.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_group_member)
                return object;
            var message = new $root.net.msg_add_group_member();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_add_group_member.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_add_group_member message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_group_member
         * @static
         * @param {net.msg_add_group_member} message msg_add_group_member
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_group_member.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            return object;
        };

        /**
         * Converts this msg_add_group_member to JSON.
         * @function toJSON
         * @memberof net.msg_add_group_member
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_group_member.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_group_member;
    })();

    net.msg_add_group_member_rep = (function() {

        /**
         * Properties of a msg_add_group_member_rep.
         * @memberof net
         * @interface Imsg_add_group_member_rep
         * @property {number|null} [result] msg_add_group_member_rep result
         */

        /**
         * Constructs a new msg_add_group_member_rep.
         * @memberof net
         * @classdesc Represents a msg_add_group_member_rep.
         * @implements Imsg_add_group_member_rep
         * @constructor
         * @param {net.Imsg_add_group_member_rep=} [properties] Properties to set
         */
        function msg_add_group_member_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_group_member_rep result.
         * @member {number} result
         * @memberof net.msg_add_group_member_rep
         * @instance
         */
        msg_add_group_member_rep.prototype.result = 0;

        /**
         * Creates a new msg_add_group_member_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {net.Imsg_add_group_member_rep=} [properties] Properties to set
         * @returns {net.msg_add_group_member_rep} msg_add_group_member_rep instance
         */
        msg_add_group_member_rep.create = function create(properties) {
            return new msg_add_group_member_rep(properties);
        };

        /**
         * Encodes the specified msg_add_group_member_rep message. Does not implicitly {@link net.msg_add_group_member_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {net.Imsg_add_group_member_rep} message msg_add_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_add_group_member_rep message, length delimited. Does not implicitly {@link net.msg_add_group_member_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {net.Imsg_add_group_member_rep} message msg_add_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_group_member_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_group_member_rep} msg_add_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_group_member_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_group_member_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_group_member_rep} msg_add_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_group_member_rep message.
         * @function verify
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_group_member_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_add_group_member_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_group_member_rep} msg_add_group_member_rep
         */
        msg_add_group_member_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_group_member_rep)
                return object;
            var message = new $root.net.msg_add_group_member_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_group_member_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {net.msg_add_group_member_rep} message msg_add_group_member_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_group_member_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_add_group_member_rep to JSON.
         * @function toJSON
         * @memberof net.msg_add_group_member_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_group_member_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_group_member_rep;
    })();

    net.msg_del_group_member = (function() {

        /**
         * Properties of a msg_del_group_member.
         * @memberof net
         * @interface Imsg_del_group_member
         * @property {number|null} [groupkey] msg_del_group_member groupkey
         * @property {Array.<number>|null} [uids] msg_del_group_member uids
         */

        /**
         * Constructs a new msg_del_group_member.
         * @memberof net
         * @classdesc Represents a msg_del_group_member.
         * @implements Imsg_del_group_member
         * @constructor
         * @param {net.Imsg_del_group_member=} [properties] Properties to set
         */
        function msg_del_group_member(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_group_member groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_group_member
         * @instance
         */
        msg_del_group_member.prototype.groupkey = 0;

        /**
         * msg_del_group_member uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_group_member
         * @instance
         */
        msg_del_group_member.prototype.uids = $util.emptyArray;

        /**
         * Creates a new msg_del_group_member instance using the specified properties.
         * @function create
         * @memberof net.msg_del_group_member
         * @static
         * @param {net.Imsg_del_group_member=} [properties] Properties to set
         * @returns {net.msg_del_group_member} msg_del_group_member instance
         */
        msg_del_group_member.create = function create(properties) {
            return new msg_del_group_member(properties);
        };

        /**
         * Encodes the specified msg_del_group_member message. Does not implicitly {@link net.msg_del_group_member.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_group_member
         * @static
         * @param {net.Imsg_del_group_member} message msg_del_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uids[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_del_group_member message, length delimited. Does not implicitly {@link net.msg_del_group_member.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_group_member
         * @static
         * @param {net.Imsg_del_group_member} message msg_del_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_group_member message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_group_member} msg_del_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_group_member();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_group_member message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_group_member} msg_del_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_group_member message.
         * @function verify
         * @memberof net.msg_del_group_member
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_group_member.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_del_group_member message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_group_member
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_group_member} msg_del_group_member
         */
        msg_del_group_member.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_group_member)
                return object;
            var message = new $root.net.msg_del_group_member();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_del_group_member.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_del_group_member message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_group_member
         * @static
         * @param {net.msg_del_group_member} message msg_del_group_member
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_group_member.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            return object;
        };

        /**
         * Converts this msg_del_group_member to JSON.
         * @function toJSON
         * @memberof net.msg_del_group_member
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_group_member.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_group_member;
    })();

    net.msg_del_group_member_rep = (function() {

        /**
         * Properties of a msg_del_group_member_rep.
         * @memberof net
         * @interface Imsg_del_group_member_rep
         * @property {number|null} [result] msg_del_group_member_rep result
         * @property {number|null} [groupkey] msg_del_group_member_rep groupkey
         * @property {Array.<number>|null} [uids] msg_del_group_member_rep uids
         */

        /**
         * Constructs a new msg_del_group_member_rep.
         * @memberof net
         * @classdesc Represents a msg_del_group_member_rep.
         * @implements Imsg_del_group_member_rep
         * @constructor
         * @param {net.Imsg_del_group_member_rep=} [properties] Properties to set
         */
        function msg_del_group_member_rep(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_group_member_rep result.
         * @member {number} result
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.result = 0;

        /**
         * msg_del_group_member_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.groupkey = 0;

        /**
         * msg_del_group_member_rep uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.uids = $util.emptyArray;

        /**
         * Creates a new msg_del_group_member_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {net.Imsg_del_group_member_rep=} [properties] Properties to set
         * @returns {net.msg_del_group_member_rep} msg_del_group_member_rep instance
         */
        msg_del_group_member_rep.create = function create(properties) {
            return new msg_del_group_member_rep(properties);
        };

        /**
         * Encodes the specified msg_del_group_member_rep message. Does not implicitly {@link net.msg_del_group_member_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {net.Imsg_del_group_member_rep} message msg_del_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uids[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_del_group_member_rep message, length delimited. Does not implicitly {@link net.msg_del_group_member_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {net.Imsg_del_group_member_rep} message msg_del_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_group_member_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_group_member_rep} msg_del_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_group_member_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_group_member_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_group_member_rep} msg_del_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_group_member_rep message.
         * @function verify
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_group_member_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_del_group_member_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_group_member_rep} msg_del_group_member_rep
         */
        msg_del_group_member_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_group_member_rep)
                return object;
            var message = new $root.net.msg_del_group_member_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_del_group_member_rep.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_del_group_member_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {net.msg_del_group_member_rep} message msg_del_group_member_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_group_member_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            return object;
        };

        /**
         * Converts this msg_del_group_member_rep to JSON.
         * @function toJSON
         * @memberof net.msg_del_group_member_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_group_member_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_group_member_rep;
    })();

    net.msg_dismiss_group = (function() {

        /**
         * Properties of a msg_dismiss_group.
         * @memberof net
         * @interface Imsg_dismiss_group
         * @property {number|null} [groupkey] msg_dismiss_group groupkey
         */

        /**
         * Constructs a new msg_dismiss_group.
         * @memberof net
         * @classdesc Represents a msg_dismiss_group.
         * @implements Imsg_dismiss_group
         * @constructor
         * @param {net.Imsg_dismiss_group=} [properties] Properties to set
         */
        function msg_dismiss_group(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_dismiss_group groupkey.
         * @member {number} groupkey
         * @memberof net.msg_dismiss_group
         * @instance
         */
        msg_dismiss_group.prototype.groupkey = 0;

        /**
         * Creates a new msg_dismiss_group instance using the specified properties.
         * @function create
         * @memberof net.msg_dismiss_group
         * @static
         * @param {net.Imsg_dismiss_group=} [properties] Properties to set
         * @returns {net.msg_dismiss_group} msg_dismiss_group instance
         */
        msg_dismiss_group.create = function create(properties) {
            return new msg_dismiss_group(properties);
        };

        /**
         * Encodes the specified msg_dismiss_group message. Does not implicitly {@link net.msg_dismiss_group.verify|verify} messages.
         * @function encode
         * @memberof net.msg_dismiss_group
         * @static
         * @param {net.Imsg_dismiss_group} message msg_dismiss_group message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_dismiss_group message, length delimited. Does not implicitly {@link net.msg_dismiss_group.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_dismiss_group
         * @static
         * @param {net.Imsg_dismiss_group} message msg_dismiss_group message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_dismiss_group message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_dismiss_group
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_dismiss_group} msg_dismiss_group
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_dismiss_group();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_dismiss_group message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_dismiss_group
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_dismiss_group} msg_dismiss_group
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_dismiss_group message.
         * @function verify
         * @memberof net.msg_dismiss_group
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_dismiss_group.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_dismiss_group message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_dismiss_group
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_dismiss_group} msg_dismiss_group
         */
        msg_dismiss_group.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_dismiss_group)
                return object;
            var message = new $root.net.msg_dismiss_group();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_dismiss_group message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_dismiss_group
         * @static
         * @param {net.msg_dismiss_group} message msg_dismiss_group
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_dismiss_group.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_dismiss_group to JSON.
         * @function toJSON
         * @memberof net.msg_dismiss_group
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_dismiss_group.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_dismiss_group;
    })();

    net.msg_dismiss_group_rep = (function() {

        /**
         * Properties of a msg_dismiss_group_rep.
         * @memberof net
         * @interface Imsg_dismiss_group_rep
         * @property {number|null} [result] msg_dismiss_group_rep result
         * @property {number|null} [groupkey] msg_dismiss_group_rep groupkey
         */

        /**
         * Constructs a new msg_dismiss_group_rep.
         * @memberof net
         * @classdesc Represents a msg_dismiss_group_rep.
         * @implements Imsg_dismiss_group_rep
         * @constructor
         * @param {net.Imsg_dismiss_group_rep=} [properties] Properties to set
         */
        function msg_dismiss_group_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_dismiss_group_rep result.
         * @member {number} result
         * @memberof net.msg_dismiss_group_rep
         * @instance
         */
        msg_dismiss_group_rep.prototype.result = 0;

        /**
         * msg_dismiss_group_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_dismiss_group_rep
         * @instance
         */
        msg_dismiss_group_rep.prototype.groupkey = 0;

        /**
         * Creates a new msg_dismiss_group_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {net.Imsg_dismiss_group_rep=} [properties] Properties to set
         * @returns {net.msg_dismiss_group_rep} msg_dismiss_group_rep instance
         */
        msg_dismiss_group_rep.create = function create(properties) {
            return new msg_dismiss_group_rep(properties);
        };

        /**
         * Encodes the specified msg_dismiss_group_rep message. Does not implicitly {@link net.msg_dismiss_group_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {net.Imsg_dismiss_group_rep} message msg_dismiss_group_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_dismiss_group_rep message, length delimited. Does not implicitly {@link net.msg_dismiss_group_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {net.Imsg_dismiss_group_rep} message msg_dismiss_group_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_dismiss_group_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_dismiss_group_rep} msg_dismiss_group_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_dismiss_group_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_dismiss_group_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_dismiss_group_rep} msg_dismiss_group_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_dismiss_group_rep message.
         * @function verify
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_dismiss_group_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_dismiss_group_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_dismiss_group_rep} msg_dismiss_group_rep
         */
        msg_dismiss_group_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_dismiss_group_rep)
                return object;
            var message = new $root.net.msg_dismiss_group_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_dismiss_group_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {net.msg_dismiss_group_rep} message msg_dismiss_group_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_dismiss_group_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_dismiss_group_rep to JSON.
         * @function toJSON
         * @memberof net.msg_dismiss_group_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_dismiss_group_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_dismiss_group_rep;
    })();

    net.msg_send_group_msg = (function() {

        /**
         * Properties of a msg_send_group_msg.
         * @memberof net
         * @interface Imsg_send_group_msg
         * @property {number|null} [groupkey] msg_send_group_msg groupkey
         * @property {number|null} [msg_type] msg_send_group_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_group_msg content
         * @property {Uint8Array|null} [clientkey] msg_send_group_msg clientkey
         * @property {number|null} [nopush] msg_send_group_msg nopush
         * @property {Uint8Array|null} [authcode] msg_send_group_msg authcode
         */

        /**
         * Constructs a new msg_send_group_msg.
         * @memberof net
         * @classdesc Represents a msg_send_group_msg.
         * @implements Imsg_send_group_msg
         * @constructor
         * @param {net.Imsg_send_group_msg=} [properties] Properties to set
         */
        function msg_send_group_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_group_msg groupkey.
         * @member {number} groupkey
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.groupkey = 0;

        /**
         * msg_send_group_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.msg_type = 0;

        /**
         * msg_send_group_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.content = $util.newBuffer([]);

        /**
         * msg_send_group_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * msg_send_group_msg nopush.
         * @member {number} nopush
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.nopush = 0;

        /**
         * msg_send_group_msg authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.authcode = $util.newBuffer([]);

        /**
         * Creates a new msg_send_group_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_send_group_msg
         * @static
         * @param {net.Imsg_send_group_msg=} [properties] Properties to set
         * @returns {net.msg_send_group_msg} msg_send_group_msg instance
         */
        msg_send_group_msg.create = function create(properties) {
            return new msg_send_group_msg(properties);
        };

        /**
         * Encodes the specified msg_send_group_msg message. Does not implicitly {@link net.msg_send_group_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_group_msg
         * @static
         * @param {net.Imsg_send_group_msg} message msg_send_group_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.clientkey);
            if (message.nopush != null && Object.hasOwnProperty.call(message, "nopush"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.nopush);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.authcode);
            return writer;
        };

        /**
         * Encodes the specified msg_send_group_msg message, length delimited. Does not implicitly {@link net.msg_send_group_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_group_msg
         * @static
         * @param {net.Imsg_send_group_msg} message msg_send_group_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_group_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_group_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_group_msg} msg_send_group_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_group_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                case 4:
                    message.clientkey = reader.bytes();
                    break;
                case 5:
                    message.nopush = reader.int32();
                    break;
                case 6:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_group_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_group_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_group_msg} msg_send_group_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_group_msg message.
         * @function verify
         * @memberof net.msg_send_group_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_group_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                if (!$util.isInteger(message.msg_type))
                    return "msg_type: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                if (!(message.clientkey && typeof message.clientkey.length === "number" || $util.isString(message.clientkey)))
                    return "clientkey: buffer expected";
            if (message.nopush != null && message.hasOwnProperty("nopush"))
                if (!$util.isInteger(message.nopush))
                    return "nopush: integer expected";
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                if (!(message.authcode && typeof message.authcode.length === "number" || $util.isString(message.authcode)))
                    return "authcode: buffer expected";
            return null;
        };

        /**
         * Creates a msg_send_group_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_group_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_group_msg} msg_send_group_msg
         */
        msg_send_group_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_group_msg)
                return object;
            var message = new $root.net.msg_send_group_msg();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.msg_type != null)
                message.msg_type = object.msg_type | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.clientkey != null)
                if (typeof object.clientkey === "string")
                    $util.base64.decode(object.clientkey, message.clientkey = $util.newBuffer($util.base64.length(object.clientkey)), 0);
                else if (object.clientkey.length)
                    message.clientkey = object.clientkey;
            if (object.nopush != null)
                message.nopush = object.nopush | 0;
            if (object.authcode != null)
                if (typeof object.authcode === "string")
                    $util.base64.decode(object.authcode, message.authcode = $util.newBuffer($util.base64.length(object.authcode)), 0);
                else if (object.authcode.length)
                    message.authcode = object.authcode;
            return message;
        };

        /**
         * Creates a plain object from a msg_send_group_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_group_msg
         * @static
         * @param {net.msg_send_group_msg} message msg_send_group_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_group_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.msg_type = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                if (options.bytes === String)
                    object.clientkey = "";
                else {
                    object.clientkey = [];
                    if (options.bytes !== Array)
                        object.clientkey = $util.newBuffer(object.clientkey);
                }
                object.nopush = 0;
                if (options.bytes === String)
                    object.authcode = "";
                else {
                    object.authcode = [];
                    if (options.bytes !== Array)
                        object.authcode = $util.newBuffer(object.authcode);
                }
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                object.msg_type = message.msg_type;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.clientkey != null && message.hasOwnProperty("clientkey"))
                object.clientkey = options.bytes === String ? $util.base64.encode(message.clientkey, 0, message.clientkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.clientkey) : message.clientkey;
            if (message.nopush != null && message.hasOwnProperty("nopush"))
                object.nopush = message.nopush;
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                object.authcode = options.bytes === String ? $util.base64.encode(message.authcode, 0, message.authcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.authcode) : message.authcode;
            return object;
        };

        /**
         * Converts this msg_send_group_msg to JSON.
         * @function toJSON
         * @memberof net.msg_send_group_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_group_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_group_msg;
    })();

    net.msg_send_group_msg_rep = (function() {

        /**
         * Properties of a msg_send_group_msg_rep.
         * @memberof net
         * @interface Imsg_send_group_msg_rep
         * @property {number|null} [result] msg_send_group_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_group_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_group_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_group_msg_rep.
         * @implements Imsg_send_group_msg_rep
         * @constructor
         * @param {net.Imsg_send_group_msg_rep=} [properties] Properties to set
         */
        function msg_send_group_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_group_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_group_msg_rep
         * @instance
         */
        msg_send_group_msg_rep.prototype.result = 0;

        /**
         * msg_send_group_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_group_msg_rep
         * @instance
         */
        msg_send_group_msg_rep.prototype.msg_info = null;

        /**
         * Creates a new msg_send_group_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {net.Imsg_send_group_msg_rep=} [properties] Properties to set
         * @returns {net.msg_send_group_msg_rep} msg_send_group_msg_rep instance
         */
        msg_send_group_msg_rep.create = function create(properties) {
            return new msg_send_group_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_send_group_msg_rep message. Does not implicitly {@link net.msg_send_group_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {net.Imsg_send_group_msg_rep} message msg_send_group_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_send_group_msg_rep message, length delimited. Does not implicitly {@link net.msg_send_group_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {net.Imsg_send_group_msg_rep} message msg_send_group_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_group_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_group_msg_rep} msg_send_group_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_group_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_group_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_group_msg_rep} msg_send_group_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_group_msg_rep message.
         * @function verify
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_group_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.msg_info != null && message.hasOwnProperty("msg_info")) {
                var error = $root.net.chat_msg.verify(message.msg_info);
                if (error)
                    return "msg_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_send_group_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_group_msg_rep} msg_send_group_msg_rep
         */
        msg_send_group_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_group_msg_rep)
                return object;
            var message = new $root.net.msg_send_group_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.msg_info != null) {
                if (typeof object.msg_info !== "object")
                    throw TypeError(".net.msg_send_group_msg_rep.msg_info: object expected");
                message.msg_info = $root.net.chat_msg.fromObject(object.msg_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_send_group_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {net.msg_send_group_msg_rep} message msg_send_group_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_group_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.msg_info = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.msg_info != null && message.hasOwnProperty("msg_info"))
                object.msg_info = $root.net.chat_msg.toObject(message.msg_info, options);
            return object;
        };

        /**
         * Converts this msg_send_group_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_send_group_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_group_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_group_msg_rep;
    })();

    net.msg_get_group_info = (function() {

        /**
         * Properties of a msg_get_group_info.
         * @memberof net
         * @interface Imsg_get_group_info
         * @property {number|null} [groupkey] msg_get_group_info groupkey
         * @property {number|null} [is_stranger] msg_get_group_info is_stranger
         * @property {number|null} [is_end] msg_get_group_info is_end
         */

        /**
         * Constructs a new msg_get_group_info.
         * @memberof net
         * @classdesc Represents a msg_get_group_info.
         * @implements Imsg_get_group_info
         * @constructor
         * @param {net.Imsg_get_group_info=} [properties] Properties to set
         */
        function msg_get_group_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_info groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.groupkey = 0;

        /**
         * msg_get_group_info is_stranger.
         * @member {number} is_stranger
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.is_stranger = 0;

        /**
         * msg_get_group_info is_end.
         * @member {number} is_end
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.is_end = 0;

        /**
         * Creates a new msg_get_group_info instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_info
         * @static
         * @param {net.Imsg_get_group_info=} [properties] Properties to set
         * @returns {net.msg_get_group_info} msg_get_group_info instance
         */
        msg_get_group_info.create = function create(properties) {
            return new msg_get_group_info(properties);
        };

        /**
         * Encodes the specified msg_get_group_info message. Does not implicitly {@link net.msg_get_group_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_info
         * @static
         * @param {net.Imsg_get_group_info} message msg_get_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.is_stranger != null && Object.hasOwnProperty.call(message, "is_stranger"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_stranger);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_end);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_info message, length delimited. Does not implicitly {@link net.msg_get_group_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_info
         * @static
         * @param {net.Imsg_get_group_info} message msg_get_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_info} msg_get_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.is_stranger = reader.int32();
                    break;
                case 3:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_info} msg_get_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_info message.
         * @function verify
         * @memberof net.msg_get_group_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.is_stranger != null && message.hasOwnProperty("is_stranger"))
                if (!$util.isInteger(message.is_stranger))
                    return "is_stranger: integer expected";
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                if (!$util.isInteger(message.is_end))
                    return "is_end: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_info} msg_get_group_info
         */
        msg_get_group_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_info)
                return object;
            var message = new $root.net.msg_get_group_info();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.is_stranger != null)
                message.is_stranger = object.is_stranger | 0;
            if (object.is_end != null)
                message.is_end = object.is_end | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_info
         * @static
         * @param {net.msg_get_group_info} message msg_get_group_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.is_stranger = 0;
                object.is_end = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.is_stranger != null && message.hasOwnProperty("is_stranger"))
                object.is_stranger = message.is_stranger;
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                object.is_end = message.is_end;
            return object;
        };

        /**
         * Converts this msg_get_group_info to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_info;
    })();

    net.msg_get_group_info_rep = (function() {

        /**
         * Properties of a msg_get_group_info_rep.
         * @memberof net
         * @interface Imsg_get_group_info_rep
         * @property {net.Igroup_base_info|null} [group_info] msg_get_group_info_rep group_info
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_group_info_rep users
         * @property {number|null} [is_stranger] msg_get_group_info_rep is_stranger
         * @property {number|null} [is_end] msg_get_group_info_rep is_end
         */

        /**
         * Constructs a new msg_get_group_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_info_rep.
         * @implements Imsg_get_group_info_rep
         * @constructor
         * @param {net.Imsg_get_group_info_rep=} [properties] Properties to set
         */
        function msg_get_group_info_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_info_rep group_info.
         * @member {net.Igroup_base_info|null|undefined} group_info
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.group_info = null;

        /**
         * msg_get_group_info_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_group_info_rep is_stranger.
         * @member {number} is_stranger
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.is_stranger = 0;

        /**
         * msg_get_group_info_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.is_end = 0;

        /**
         * Creates a new msg_get_group_info_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {net.Imsg_get_group_info_rep=} [properties] Properties to set
         * @returns {net.msg_get_group_info_rep} msg_get_group_info_rep instance
         */
        msg_get_group_info_rep.create = function create(properties) {
            return new msg_get_group_info_rep(properties);
        };

        /**
         * Encodes the specified msg_get_group_info_rep message. Does not implicitly {@link net.msg_get_group_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {net.Imsg_get_group_info_rep} message msg_get_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_info != null && Object.hasOwnProperty.call(message, "group_info"))
                $root.net.group_base_info.encode(message.group_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.is_stranger != null && Object.hasOwnProperty.call(message, "is_stranger"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_stranger);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.is_end);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_info_rep message, length delimited. Does not implicitly {@link net.msg_get_group_info_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {net.Imsg_get_group_info_rep} message msg_get_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_info_rep} msg_get_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_info = $root.net.group_base_info.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.is_stranger = reader.int32();
                    break;
                case 4:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_info_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_info_rep} msg_get_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_info_rep message.
         * @function verify
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_info_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.group_info != null && message.hasOwnProperty("group_info")) {
                var error = $root.net.group_base_info.verify(message.group_info);
                if (error)
                    return "group_info." + error;
            }
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            if (message.is_stranger != null && message.hasOwnProperty("is_stranger"))
                if (!$util.isInteger(message.is_stranger))
                    return "is_stranger: integer expected";
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                if (!$util.isInteger(message.is_end))
                    return "is_end: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_info_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_info_rep} msg_get_group_info_rep
         */
        msg_get_group_info_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_info_rep)
                return object;
            var message = new $root.net.msg_get_group_info_rep();
            if (object.group_info != null) {
                if (typeof object.group_info !== "object")
                    throw TypeError(".net.msg_get_group_info_rep.group_info: object expected");
                message.group_info = $root.net.group_base_info.fromObject(object.group_info);
            }
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_group_info_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_group_info_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            if (object.is_stranger != null)
                message.is_stranger = object.is_stranger | 0;
            if (object.is_end != null)
                message.is_end = object.is_end | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_info_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {net.msg_get_group_info_rep} message msg_get_group_info_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_info_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.group_info = null;
                object.is_stranger = 0;
                object.is_end = 0;
            }
            if (message.group_info != null && message.hasOwnProperty("group_info"))
                object.group_info = $root.net.group_base_info.toObject(message.group_info, options);
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            if (message.is_stranger != null && message.hasOwnProperty("is_stranger"))
                object.is_stranger = message.is_stranger;
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                object.is_end = message.is_end;
            return object;
        };

        /**
         * Converts this msg_get_group_info_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_info_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_info_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_info_rep;
    })();

    net.msg_confirm_group_info = (function() {

        /**
         * Properties of a msg_confirm_group_info.
         * @memberof net
         * @interface Imsg_confirm_group_info
         * @property {number|null} [groupkey] msg_confirm_group_info groupkey
         * @property {number|null} [attrversion] msg_confirm_group_info attrversion
         */

        /**
         * Constructs a new msg_confirm_group_info.
         * @memberof net
         * @classdesc Represents a msg_confirm_group_info.
         * @implements Imsg_confirm_group_info
         * @constructor
         * @param {net.Imsg_confirm_group_info=} [properties] Properties to set
         */
        function msg_confirm_group_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_group_info groupkey.
         * @member {number} groupkey
         * @memberof net.msg_confirm_group_info
         * @instance
         */
        msg_confirm_group_info.prototype.groupkey = 0;

        /**
         * msg_confirm_group_info attrversion.
         * @member {number} attrversion
         * @memberof net.msg_confirm_group_info
         * @instance
         */
        msg_confirm_group_info.prototype.attrversion = 0;

        /**
         * Creates a new msg_confirm_group_info instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {net.Imsg_confirm_group_info=} [properties] Properties to set
         * @returns {net.msg_confirm_group_info} msg_confirm_group_info instance
         */
        msg_confirm_group_info.create = function create(properties) {
            return new msg_confirm_group_info(properties);
        };

        /**
         * Encodes the specified msg_confirm_group_info message. Does not implicitly {@link net.msg_confirm_group_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {net.Imsg_confirm_group_info} message msg_confirm_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.attrversion != null && Object.hasOwnProperty.call(message, "attrversion"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.attrversion);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_group_info message, length delimited. Does not implicitly {@link net.msg_confirm_group_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {net.Imsg_confirm_group_info} message msg_confirm_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_group_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_group_info} msg_confirm_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_group_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.attrversion = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_group_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_group_info} msg_confirm_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_group_info message.
         * @function verify
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_group_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.attrversion != null && message.hasOwnProperty("attrversion"))
                if (!$util.isInteger(message.attrversion))
                    return "attrversion: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_group_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_group_info} msg_confirm_group_info
         */
        msg_confirm_group_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_group_info)
                return object;
            var message = new $root.net.msg_confirm_group_info();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.attrversion != null)
                message.attrversion = object.attrversion | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_group_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {net.msg_confirm_group_info} message msg_confirm_group_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_group_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.attrversion = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.attrversion != null && message.hasOwnProperty("attrversion"))
                object.attrversion = message.attrversion;
            return object;
        };

        /**
         * Converts this msg_confirm_group_info to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_group_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_group_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_group_info;
    })();

    net.msg_confirm_group_info_rep = (function() {

        /**
         * Properties of a msg_confirm_group_info_rep.
         * @memberof net
         * @interface Imsg_confirm_group_info_rep
         * @property {number|null} [result] msg_confirm_group_info_rep result
         */

        /**
         * Constructs a new msg_confirm_group_info_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_group_info_rep.
         * @implements Imsg_confirm_group_info_rep
         * @constructor
         * @param {net.Imsg_confirm_group_info_rep=} [properties] Properties to set
         */
        function msg_confirm_group_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_group_info_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_group_info_rep
         * @instance
         */
        msg_confirm_group_info_rep.prototype.result = 0;

        /**
         * Creates a new msg_confirm_group_info_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {net.Imsg_confirm_group_info_rep=} [properties] Properties to set
         * @returns {net.msg_confirm_group_info_rep} msg_confirm_group_info_rep instance
         */
        msg_confirm_group_info_rep.create = function create(properties) {
            return new msg_confirm_group_info_rep(properties);
        };

        /**
         * Encodes the specified msg_confirm_group_info_rep message. Does not implicitly {@link net.msg_confirm_group_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {net.Imsg_confirm_group_info_rep} message msg_confirm_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_group_info_rep message, length delimited. Does not implicitly {@link net.msg_confirm_group_info_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {net.Imsg_confirm_group_info_rep} message msg_confirm_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_group_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_group_info_rep} msg_confirm_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_group_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_group_info_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_group_info_rep} msg_confirm_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_group_info_rep message.
         * @function verify
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_group_info_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_group_info_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_group_info_rep} msg_confirm_group_info_rep
         */
        msg_confirm_group_info_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_group_info_rep)
                return object;
            var message = new $root.net.msg_confirm_group_info_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_group_info_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {net.msg_confirm_group_info_rep} message msg_confirm_group_info_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_group_info_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_confirm_group_info_rep to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_group_info_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_group_info_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_group_info_rep;
    })();

    net.msg_modify_groupname = (function() {

        /**
         * Properties of a msg_modify_groupname.
         * @memberof net
         * @interface Imsg_modify_groupname
         * @property {Uint8Array|null} [new_name] msg_modify_groupname new_name
         * @property {number|null} [groupkey] msg_modify_groupname groupkey
         */

        /**
         * Constructs a new msg_modify_groupname.
         * @memberof net
         * @classdesc Represents a msg_modify_groupname.
         * @implements Imsg_modify_groupname
         * @constructor
         * @param {net.Imsg_modify_groupname=} [properties] Properties to set
         */
        function msg_modify_groupname(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupname new_name.
         * @member {Uint8Array} new_name
         * @memberof net.msg_modify_groupname
         * @instance
         */
        msg_modify_groupname.prototype.new_name = $util.newBuffer([]);

        /**
         * msg_modify_groupname groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupname
         * @instance
         */
        msg_modify_groupname.prototype.groupkey = 0;

        /**
         * Creates a new msg_modify_groupname instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_groupname
         * @static
         * @param {net.Imsg_modify_groupname=} [properties] Properties to set
         * @returns {net.msg_modify_groupname} msg_modify_groupname instance
         */
        msg_modify_groupname.create = function create(properties) {
            return new msg_modify_groupname(properties);
        };

        /**
         * Encodes the specified msg_modify_groupname message. Does not implicitly {@link net.msg_modify_groupname.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupname
         * @static
         * @param {net.Imsg_modify_groupname} message msg_modify_groupname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.new_name != null && Object.hasOwnProperty.call(message, "new_name"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.new_name);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_groupname message, length delimited. Does not implicitly {@link net.msg_modify_groupname.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_groupname
         * @static
         * @param {net.Imsg_modify_groupname} message msg_modify_groupname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_groupname message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupname} msg_modify_groupname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupname();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.new_name = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_groupname message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_groupname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_groupname} msg_modify_groupname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_groupname message.
         * @function verify
         * @memberof net.msg_modify_groupname
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_groupname.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.new_name != null && message.hasOwnProperty("new_name"))
                if (!(message.new_name && typeof message.new_name.length === "number" || $util.isString(message.new_name)))
                    return "new_name: buffer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_modify_groupname message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_groupname
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_groupname} msg_modify_groupname
         */
        msg_modify_groupname.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_groupname)
                return object;
            var message = new $root.net.msg_modify_groupname();
            if (object.new_name != null)
                if (typeof object.new_name === "string")
                    $util.base64.decode(object.new_name, message.new_name = $util.newBuffer($util.base64.length(object.new_name)), 0);
                else if (object.new_name.length)
                    message.new_name = object.new_name;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_groupname message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_groupname
         * @static
         * @param {net.msg_modify_groupname} message msg_modify_groupname
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_groupname.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.new_name = "";
                else {
                    object.new_name = [];
                    if (options.bytes !== Array)
                        object.new_name = $util.newBuffer(object.new_name);
                }
                object.groupkey = 0;
            }
            if (message.new_name != null && message.hasOwnProperty("new_name"))
                object.new_name = options.bytes === String ? $util.base64.encode(message.new_name, 0, message.new_name.length) : options.bytes === Array ? Array.prototype.slice.call(message.new_name) : message.new_name;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_modify_groupname to JSON.
         * @function toJSON
         * @memberof net.msg_modify_groupname
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_groupname.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_groupname;
    })();

    net.msg_modify_groupname_rep = (function() {

        /**
         * Properties of a msg_modify_groupname_rep.
         * @memberof net
         * @interface Imsg_modify_groupname_rep
         * @property {number|null} [result] msg_modify_groupname_rep result
         * @property {number|null} [groupkey] msg_modify_groupname_rep groupkey
         * @property {Uint8Array|null} [new_name] msg_modify_groupname_rep new_name
         */

        /**
         * Constructs a new msg_modify_groupname_rep.
         * @memberof net
         * @classdesc Represents a msg_modify_groupname_rep.
         * @implements Imsg_modify_groupname_rep
         * @constructor
         * @param {net.Imsg_modify_groupname_rep=} [properties] Properties to set
         */
        function msg_modify_groupname_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupname_rep result.
         * @member {number} result
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.result = 0;

        /**
         * msg_modify_groupname_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.groupkey = 0;

        /**
         * msg_modify_groupname_rep new_name.
         * @member {Uint8Array} new_name
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.new_name = $util.newBuffer([]);

        /**
         * Creates a new msg_modify_groupname_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {net.Imsg_modify_groupname_rep=} [properties] Properties to set
         * @returns {net.msg_modify_groupname_rep} msg_modify_groupname_rep instance
         */
        msg_modify_groupname_rep.create = function create(properties) {
            return new msg_modify_groupname_rep(properties);
        };

        /**
         * Encodes the specified msg_modify_groupname_rep message. Does not implicitly {@link net.msg_modify_groupname_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {net.Imsg_modify_groupname_rep} message msg_modify_groupname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.new_name != null && Object.hasOwnProperty.call(message, "new_name"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.new_name);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_groupname_rep message, length delimited. Does not implicitly {@link net.msg_modify_groupname_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {net.Imsg_modify_groupname_rep} message msg_modify_groupname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_groupname_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupname_rep} msg_modify_groupname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupname_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.new_name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_groupname_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_groupname_rep} msg_modify_groupname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_groupname_rep message.
         * @function verify
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_groupname_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.new_name != null && message.hasOwnProperty("new_name"))
                if (!(message.new_name && typeof message.new_name.length === "number" || $util.isString(message.new_name)))
                    return "new_name: buffer expected";
            return null;
        };

        /**
         * Creates a msg_modify_groupname_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_groupname_rep} msg_modify_groupname_rep
         */
        msg_modify_groupname_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_groupname_rep)
                return object;
            var message = new $root.net.msg_modify_groupname_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.new_name != null)
                if (typeof object.new_name === "string")
                    $util.base64.decode(object.new_name, message.new_name = $util.newBuffer($util.base64.length(object.new_name)), 0);
                else if (object.new_name.length)
                    message.new_name = object.new_name;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_groupname_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {net.msg_modify_groupname_rep} message msg_modify_groupname_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_groupname_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
                if (options.bytes === String)
                    object.new_name = "";
                else {
                    object.new_name = [];
                    if (options.bytes !== Array)
                        object.new_name = $util.newBuffer(object.new_name);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.new_name != null && message.hasOwnProperty("new_name"))
                object.new_name = options.bytes === String ? $util.base64.encode(message.new_name, 0, message.new_name.length) : options.bytes === Array ? Array.prototype.slice.call(message.new_name) : message.new_name;
            return object;
        };

        /**
         * Converts this msg_modify_groupname_rep to JSON.
         * @function toJSON
         * @memberof net.msg_modify_groupname_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_groupname_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_groupname_rep;
    })();

    net.msg_modify_groupnotify = (function() {

        /**
         * Properties of a msg_modify_groupnotify.
         * @memberof net
         * @interface Imsg_modify_groupnotify
         * @property {Uint8Array|null} [new_notify] msg_modify_groupnotify new_notify
         * @property {number|null} [groupkey] msg_modify_groupnotify groupkey
         */

        /**
         * Constructs a new msg_modify_groupnotify.
         * @memberof net
         * @classdesc Represents a msg_modify_groupnotify.
         * @implements Imsg_modify_groupnotify
         * @constructor
         * @param {net.Imsg_modify_groupnotify=} [properties] Properties to set
         */
        function msg_modify_groupnotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupnotify new_notify.
         * @member {Uint8Array} new_notify
         * @memberof net.msg_modify_groupnotify
         * @instance
         */
        msg_modify_groupnotify.prototype.new_notify = $util.newBuffer([]);

        /**
         * msg_modify_groupnotify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupnotify
         * @instance
         */
        msg_modify_groupnotify.prototype.groupkey = 0;

        /**
         * Creates a new msg_modify_groupnotify instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {net.Imsg_modify_groupnotify=} [properties] Properties to set
         * @returns {net.msg_modify_groupnotify} msg_modify_groupnotify instance
         */
        msg_modify_groupnotify.create = function create(properties) {
            return new msg_modify_groupnotify(properties);
        };

        /**
         * Encodes the specified msg_modify_groupnotify message. Does not implicitly {@link net.msg_modify_groupnotify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {net.Imsg_modify_groupnotify} message msg_modify_groupnotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.new_notify != null && Object.hasOwnProperty.call(message, "new_notify"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.new_notify);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_groupnotify message, length delimited. Does not implicitly {@link net.msg_modify_groupnotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {net.Imsg_modify_groupnotify} message msg_modify_groupnotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_groupnotify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupnotify} msg_modify_groupnotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupnotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.new_notify = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_groupnotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_groupnotify} msg_modify_groupnotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_groupnotify message.
         * @function verify
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_groupnotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.new_notify != null && message.hasOwnProperty("new_notify"))
                if (!(message.new_notify && typeof message.new_notify.length === "number" || $util.isString(message.new_notify)))
                    return "new_notify: buffer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_modify_groupnotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_groupnotify} msg_modify_groupnotify
         */
        msg_modify_groupnotify.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_groupnotify)
                return object;
            var message = new $root.net.msg_modify_groupnotify();
            if (object.new_notify != null)
                if (typeof object.new_notify === "string")
                    $util.base64.decode(object.new_notify, message.new_notify = $util.newBuffer($util.base64.length(object.new_notify)), 0);
                else if (object.new_notify.length)
                    message.new_notify = object.new_notify;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_groupnotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {net.msg_modify_groupnotify} message msg_modify_groupnotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_groupnotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.new_notify = "";
                else {
                    object.new_notify = [];
                    if (options.bytes !== Array)
                        object.new_notify = $util.newBuffer(object.new_notify);
                }
                object.groupkey = 0;
            }
            if (message.new_notify != null && message.hasOwnProperty("new_notify"))
                object.new_notify = options.bytes === String ? $util.base64.encode(message.new_notify, 0, message.new_notify.length) : options.bytes === Array ? Array.prototype.slice.call(message.new_notify) : message.new_notify;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_modify_groupnotify to JSON.
         * @function toJSON
         * @memberof net.msg_modify_groupnotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_groupnotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_groupnotify;
    })();

    net.msg_modify_groupnotify_rep = (function() {

        /**
         * Properties of a msg_modify_groupnotify_rep.
         * @memberof net
         * @interface Imsg_modify_groupnotify_rep
         * @property {number|null} [result] msg_modify_groupnotify_rep result
         * @property {number|null} [groupkey] msg_modify_groupnotify_rep groupkey
         * @property {Uint8Array|null} [new_notify] msg_modify_groupnotify_rep new_notify
         */

        /**
         * Constructs a new msg_modify_groupnotify_rep.
         * @memberof net
         * @classdesc Represents a msg_modify_groupnotify_rep.
         * @implements Imsg_modify_groupnotify_rep
         * @constructor
         * @param {net.Imsg_modify_groupnotify_rep=} [properties] Properties to set
         */
        function msg_modify_groupnotify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupnotify_rep result.
         * @member {number} result
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.result = 0;

        /**
         * msg_modify_groupnotify_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.groupkey = 0;

        /**
         * msg_modify_groupnotify_rep new_notify.
         * @member {Uint8Array} new_notify
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.new_notify = $util.newBuffer([]);

        /**
         * Creates a new msg_modify_groupnotify_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {net.Imsg_modify_groupnotify_rep=} [properties] Properties to set
         * @returns {net.msg_modify_groupnotify_rep} msg_modify_groupnotify_rep instance
         */
        msg_modify_groupnotify_rep.create = function create(properties) {
            return new msg_modify_groupnotify_rep(properties);
        };

        /**
         * Encodes the specified msg_modify_groupnotify_rep message. Does not implicitly {@link net.msg_modify_groupnotify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {net.Imsg_modify_groupnotify_rep} message msg_modify_groupnotify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.new_notify != null && Object.hasOwnProperty.call(message, "new_notify"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.new_notify);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_groupnotify_rep message, length delimited. Does not implicitly {@link net.msg_modify_groupnotify_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {net.Imsg_modify_groupnotify_rep} message msg_modify_groupnotify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_groupnotify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupnotify_rep} msg_modify_groupnotify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupnotify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.new_notify = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_groupnotify_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_groupnotify_rep} msg_modify_groupnotify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_groupnotify_rep message.
         * @function verify
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_groupnotify_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.new_notify != null && message.hasOwnProperty("new_notify"))
                if (!(message.new_notify && typeof message.new_notify.length === "number" || $util.isString(message.new_notify)))
                    return "new_notify: buffer expected";
            return null;
        };

        /**
         * Creates a msg_modify_groupnotify_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_groupnotify_rep} msg_modify_groupnotify_rep
         */
        msg_modify_groupnotify_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_groupnotify_rep)
                return object;
            var message = new $root.net.msg_modify_groupnotify_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.new_notify != null)
                if (typeof object.new_notify === "string")
                    $util.base64.decode(object.new_notify, message.new_notify = $util.newBuffer($util.base64.length(object.new_notify)), 0);
                else if (object.new_notify.length)
                    message.new_notify = object.new_notify;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_groupnotify_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {net.msg_modify_groupnotify_rep} message msg_modify_groupnotify_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_groupnotify_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
                if (options.bytes === String)
                    object.new_notify = "";
                else {
                    object.new_notify = [];
                    if (options.bytes !== Array)
                        object.new_notify = $util.newBuffer(object.new_notify);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.new_notify != null && message.hasOwnProperty("new_notify"))
                object.new_notify = options.bytes === String ? $util.base64.encode(message.new_notify, 0, message.new_notify.length) : options.bytes === Array ? Array.prototype.slice.call(message.new_notify) : message.new_notify;
            return object;
        };

        /**
         * Converts this msg_modify_groupnotify_rep to JSON.
         * @function toJSON
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_groupnotify_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_groupnotify_rep;
    })();

    net.msg_set_groupadmin = (function() {

        /**
         * Properties of a msg_set_groupadmin.
         * @memberof net
         * @interface Imsg_set_groupadmin
         * @property {Array.<number>|null} [uids] msg_set_groupadmin uids
         * @property {number|null} [groupkey] msg_set_groupadmin groupkey
         */

        /**
         * Constructs a new msg_set_groupadmin.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin.
         * @implements Imsg_set_groupadmin
         * @constructor
         * @param {net.Imsg_set_groupadmin=} [properties] Properties to set
         */
        function msg_set_groupadmin(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_set_groupadmin
         * @instance
         */
        msg_set_groupadmin.prototype.uids = $util.emptyArray;

        /**
         * msg_set_groupadmin groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupadmin
         * @instance
         */
        msg_set_groupadmin.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_groupadmin instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {net.Imsg_set_groupadmin=} [properties] Properties to set
         * @returns {net.msg_set_groupadmin} msg_set_groupadmin instance
         */
        msg_set_groupadmin.create = function create(properties) {
            return new msg_set_groupadmin(properties);
        };

        /**
         * Encodes the specified msg_set_groupadmin message. Does not implicitly {@link net.msg_set_groupadmin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {net.Imsg_set_groupadmin} message msg_set_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadmin message, length delimited. Does not implicitly {@link net.msg_set_groupadmin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {net.Imsg_set_groupadmin} message msg_set_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadmin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin} msg_set_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadmin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadmin} msg_set_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadmin message.
         * @function verify
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadmin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadmin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadmin} msg_set_groupadmin
         */
        msg_set_groupadmin.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadmin)
                return object;
            var message = new $root.net.msg_set_groupadmin();
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_set_groupadmin.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadmin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {net.msg_set_groupadmin} message msg_set_groupadmin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadmin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_groupadmin to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadmin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadmin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadmin;
    })();

    net.msg_set_groupadmin_rep = (function() {

        /**
         * Properties of a msg_set_groupadmin_rep.
         * @memberof net
         * @interface Imsg_set_groupadmin_rep
         * @property {number|null} [result] msg_set_groupadmin_rep result
         */

        /**
         * Constructs a new msg_set_groupadmin_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin_rep.
         * @implements Imsg_set_groupadmin_rep
         * @constructor
         * @param {net.Imsg_set_groupadmin_rep=} [properties] Properties to set
         */
        function msg_set_groupadmin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupadmin_rep
         * @instance
         */
        msg_set_groupadmin_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupadmin_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {net.Imsg_set_groupadmin_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupadmin_rep} msg_set_groupadmin_rep instance
         */
        msg_set_groupadmin_rep.create = function create(properties) {
            return new msg_set_groupadmin_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupadmin_rep message. Does not implicitly {@link net.msg_set_groupadmin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {net.Imsg_set_groupadmin_rep} message msg_set_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadmin_rep message, length delimited. Does not implicitly {@link net.msg_set_groupadmin_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {net.Imsg_set_groupadmin_rep} message msg_set_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadmin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin_rep} msg_set_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadmin_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadmin_rep} msg_set_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadmin_rep message.
         * @function verify
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadmin_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadmin_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadmin_rep} msg_set_groupadmin_rep
         */
        msg_set_groupadmin_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadmin_rep)
                return object;
            var message = new $root.net.msg_set_groupadmin_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadmin_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {net.msg_set_groupadmin_rep} message msg_set_groupadmin_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadmin_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupadmin_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadmin_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadmin_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadmin_rep;
    })();

    net.msg_set_groupadmin_new = (function() {

        /**
         * Properties of a msg_set_groupadmin_new.
         * @memberof net
         * @interface Imsg_set_groupadmin_new
         * @property {number|null} [groupkey] msg_set_groupadmin_new groupkey
         * @property {number|null} [adminuid] msg_set_groupadmin_new adminuid
         * @property {number|null} [permission] msg_set_groupadmin_new permission
         */

        /**
         * Constructs a new msg_set_groupadmin_new.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin_new.
         * @implements Imsg_set_groupadmin_new
         * @constructor
         * @param {net.Imsg_set_groupadmin_new=} [properties] Properties to set
         */
        function msg_set_groupadmin_new(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin_new groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupadmin_new
         * @instance
         */
        msg_set_groupadmin_new.prototype.groupkey = 0;

        /**
         * msg_set_groupadmin_new adminuid.
         * @member {number} adminuid
         * @memberof net.msg_set_groupadmin_new
         * @instance
         */
        msg_set_groupadmin_new.prototype.adminuid = 0;

        /**
         * msg_set_groupadmin_new permission.
         * @member {number} permission
         * @memberof net.msg_set_groupadmin_new
         * @instance
         */
        msg_set_groupadmin_new.prototype.permission = 0;

        /**
         * Creates a new msg_set_groupadmin_new instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {net.Imsg_set_groupadmin_new=} [properties] Properties to set
         * @returns {net.msg_set_groupadmin_new} msg_set_groupadmin_new instance
         */
        msg_set_groupadmin_new.create = function create(properties) {
            return new msg_set_groupadmin_new(properties);
        };

        /**
         * Encodes the specified msg_set_groupadmin_new message. Does not implicitly {@link net.msg_set_groupadmin_new.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {net.Imsg_set_groupadmin_new} message msg_set_groupadmin_new message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_new.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.adminuid != null && Object.hasOwnProperty.call(message, "adminuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.adminuid);
            if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.permission);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadmin_new message, length delimited. Does not implicitly {@link net.msg_set_groupadmin_new.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {net.Imsg_set_groupadmin_new} message msg_set_groupadmin_new message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_new.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadmin_new message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin_new} msg_set_groupadmin_new
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_new.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin_new();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.adminuid = reader.int32();
                    break;
                case 3:
                    message.permission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadmin_new message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadmin_new} msg_set_groupadmin_new
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_new.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadmin_new message.
         * @function verify
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadmin_new.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.adminuid != null && message.hasOwnProperty("adminuid"))
                if (!$util.isInteger(message.adminuid))
                    return "adminuid: integer expected";
            if (message.permission != null && message.hasOwnProperty("permission"))
                if (!$util.isInteger(message.permission))
                    return "permission: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadmin_new message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadmin_new} msg_set_groupadmin_new
         */
        msg_set_groupadmin_new.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadmin_new)
                return object;
            var message = new $root.net.msg_set_groupadmin_new();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.adminuid != null)
                message.adminuid = object.adminuid | 0;
            if (object.permission != null)
                message.permission = object.permission | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadmin_new message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadmin_new
         * @static
         * @param {net.msg_set_groupadmin_new} message msg_set_groupadmin_new
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadmin_new.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.adminuid = 0;
                object.permission = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.adminuid != null && message.hasOwnProperty("adminuid"))
                object.adminuid = message.adminuid;
            if (message.permission != null && message.hasOwnProperty("permission"))
                object.permission = message.permission;
            return object;
        };

        /**
         * Converts this msg_set_groupadmin_new to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadmin_new
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadmin_new.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadmin_new;
    })();

    net.msg_set_groupadmin_new_rep = (function() {

        /**
         * Properties of a msg_set_groupadmin_new_rep.
         * @memberof net
         * @interface Imsg_set_groupadmin_new_rep
         * @property {number|null} [result] msg_set_groupadmin_new_rep result
         */

        /**
         * Constructs a new msg_set_groupadmin_new_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin_new_rep.
         * @implements Imsg_set_groupadmin_new_rep
         * @constructor
         * @param {net.Imsg_set_groupadmin_new_rep=} [properties] Properties to set
         */
        function msg_set_groupadmin_new_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin_new_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupadmin_new_rep
         * @instance
         */
        msg_set_groupadmin_new_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupadmin_new_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {net.Imsg_set_groupadmin_new_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupadmin_new_rep} msg_set_groupadmin_new_rep instance
         */
        msg_set_groupadmin_new_rep.create = function create(properties) {
            return new msg_set_groupadmin_new_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupadmin_new_rep message. Does not implicitly {@link net.msg_set_groupadmin_new_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {net.Imsg_set_groupadmin_new_rep} message msg_set_groupadmin_new_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_new_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadmin_new_rep message, length delimited. Does not implicitly {@link net.msg_set_groupadmin_new_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {net.Imsg_set_groupadmin_new_rep} message msg_set_groupadmin_new_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_new_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadmin_new_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin_new_rep} msg_set_groupadmin_new_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_new_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin_new_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadmin_new_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadmin_new_rep} msg_set_groupadmin_new_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_new_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadmin_new_rep message.
         * @function verify
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadmin_new_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadmin_new_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadmin_new_rep} msg_set_groupadmin_new_rep
         */
        msg_set_groupadmin_new_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadmin_new_rep)
                return object;
            var message = new $root.net.msg_set_groupadmin_new_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadmin_new_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadmin_new_rep
         * @static
         * @param {net.msg_set_groupadmin_new_rep} message msg_set_groupadmin_new_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadmin_new_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupadmin_new_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadmin_new_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadmin_new_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadmin_new_rep;
    })();

    net.msg_set_groupinfo_limits = (function() {

        /**
         * Properties of a msg_set_groupinfo_limits.
         * @memberof net
         * @interface Imsg_set_groupinfo_limits
         * @property {number|null} [limits] msg_set_groupinfo_limits limits
         * @property {number|null} [groupkey] msg_set_groupinfo_limits groupkey
         */

        /**
         * Constructs a new msg_set_groupinfo_limits.
         * @memberof net
         * @classdesc Represents a msg_set_groupinfo_limits.
         * @implements Imsg_set_groupinfo_limits
         * @constructor
         * @param {net.Imsg_set_groupinfo_limits=} [properties] Properties to set
         */
        function msg_set_groupinfo_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupinfo_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_groupinfo_limits
         * @instance
         */
        msg_set_groupinfo_limits.prototype.limits = 0;

        /**
         * msg_set_groupinfo_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupinfo_limits
         * @instance
         */
        msg_set_groupinfo_limits.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_groupinfo_limits instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {net.Imsg_set_groupinfo_limits=} [properties] Properties to set
         * @returns {net.msg_set_groupinfo_limits} msg_set_groupinfo_limits instance
         */
        msg_set_groupinfo_limits.create = function create(properties) {
            return new msg_set_groupinfo_limits(properties);
        };

        /**
         * Encodes the specified msg_set_groupinfo_limits message. Does not implicitly {@link net.msg_set_groupinfo_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {net.Imsg_set_groupinfo_limits} message msg_set_groupinfo_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupinfo_limits message, length delimited. Does not implicitly {@link net.msg_set_groupinfo_limits.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {net.Imsg_set_groupinfo_limits} message msg_set_groupinfo_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupinfo_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupinfo_limits} msg_set_groupinfo_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupinfo_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupinfo_limits message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupinfo_limits} msg_set_groupinfo_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupinfo_limits message.
         * @function verify
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupinfo_limits.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.limits != null && message.hasOwnProperty("limits"))
                if (!$util.isInteger(message.limits))
                    return "limits: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupinfo_limits message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupinfo_limits} msg_set_groupinfo_limits
         */
        msg_set_groupinfo_limits.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupinfo_limits)
                return object;
            var message = new $root.net.msg_set_groupinfo_limits();
            if (object.limits != null)
                message.limits = object.limits | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupinfo_limits message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {net.msg_set_groupinfo_limits} message msg_set_groupinfo_limits
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupinfo_limits.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.limits = 0;
                object.groupkey = 0;
            }
            if (message.limits != null && message.hasOwnProperty("limits"))
                object.limits = message.limits;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_groupinfo_limits to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupinfo_limits
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupinfo_limits.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupinfo_limits;
    })();

    net.msg_set_groupinfo_limits_rep = (function() {

        /**
         * Properties of a msg_set_groupinfo_limits_rep.
         * @memberof net
         * @interface Imsg_set_groupinfo_limits_rep
         * @property {number|null} [result] msg_set_groupinfo_limits_rep result
         */

        /**
         * Constructs a new msg_set_groupinfo_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupinfo_limits_rep.
         * @implements Imsg_set_groupinfo_limits_rep
         * @constructor
         * @param {net.Imsg_set_groupinfo_limits_rep=} [properties] Properties to set
         */
        function msg_set_groupinfo_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupinfo_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupinfo_limits_rep
         * @instance
         */
        msg_set_groupinfo_limits_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupinfo_limits_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {net.Imsg_set_groupinfo_limits_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupinfo_limits_rep} msg_set_groupinfo_limits_rep instance
         */
        msg_set_groupinfo_limits_rep.create = function create(properties) {
            return new msg_set_groupinfo_limits_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupinfo_limits_rep message. Does not implicitly {@link net.msg_set_groupinfo_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {net.Imsg_set_groupinfo_limits_rep} message msg_set_groupinfo_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupinfo_limits_rep message, length delimited. Does not implicitly {@link net.msg_set_groupinfo_limits_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {net.Imsg_set_groupinfo_limits_rep} message msg_set_groupinfo_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupinfo_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupinfo_limits_rep} msg_set_groupinfo_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupinfo_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupinfo_limits_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupinfo_limits_rep} msg_set_groupinfo_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupinfo_limits_rep message.
         * @function verify
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupinfo_limits_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupinfo_limits_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupinfo_limits_rep} msg_set_groupinfo_limits_rep
         */
        msg_set_groupinfo_limits_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupinfo_limits_rep)
                return object;
            var message = new $root.net.msg_set_groupinfo_limits_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupinfo_limits_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {net.msg_set_groupinfo_limits_rep} message msg_set_groupinfo_limits_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupinfo_limits_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupinfo_limits_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupinfo_limits_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupinfo_limits_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupinfo_limits_rep;
    })();

    net.msg_set_groupadd_limits = (function() {

        /**
         * Properties of a msg_set_groupadd_limits.
         * @memberof net
         * @interface Imsg_set_groupadd_limits
         * @property {number|null} [limits] msg_set_groupadd_limits limits
         * @property {number|null} [groupkey] msg_set_groupadd_limits groupkey
         */

        /**
         * Constructs a new msg_set_groupadd_limits.
         * @memberof net
         * @classdesc Represents a msg_set_groupadd_limits.
         * @implements Imsg_set_groupadd_limits
         * @constructor
         * @param {net.Imsg_set_groupadd_limits=} [properties] Properties to set
         */
        function msg_set_groupadd_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadd_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_groupadd_limits
         * @instance
         */
        msg_set_groupadd_limits.prototype.limits = 0;

        /**
         * msg_set_groupadd_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupadd_limits
         * @instance
         */
        msg_set_groupadd_limits.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_groupadd_limits instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {net.Imsg_set_groupadd_limits=} [properties] Properties to set
         * @returns {net.msg_set_groupadd_limits} msg_set_groupadd_limits instance
         */
        msg_set_groupadd_limits.create = function create(properties) {
            return new msg_set_groupadd_limits(properties);
        };

        /**
         * Encodes the specified msg_set_groupadd_limits message. Does not implicitly {@link net.msg_set_groupadd_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {net.Imsg_set_groupadd_limits} message msg_set_groupadd_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadd_limits message, length delimited. Does not implicitly {@link net.msg_set_groupadd_limits.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {net.Imsg_set_groupadd_limits} message msg_set_groupadd_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadd_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadd_limits} msg_set_groupadd_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadd_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadd_limits message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadd_limits} msg_set_groupadd_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadd_limits message.
         * @function verify
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadd_limits.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.limits != null && message.hasOwnProperty("limits"))
                if (!$util.isInteger(message.limits))
                    return "limits: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadd_limits message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadd_limits} msg_set_groupadd_limits
         */
        msg_set_groupadd_limits.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadd_limits)
                return object;
            var message = new $root.net.msg_set_groupadd_limits();
            if (object.limits != null)
                message.limits = object.limits | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadd_limits message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {net.msg_set_groupadd_limits} message msg_set_groupadd_limits
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadd_limits.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.limits = 0;
                object.groupkey = 0;
            }
            if (message.limits != null && message.hasOwnProperty("limits"))
                object.limits = message.limits;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_groupadd_limits to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadd_limits
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadd_limits.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadd_limits;
    })();

    net.msg_set_groupadd_limits_rep = (function() {

        /**
         * Properties of a msg_set_groupadd_limits_rep.
         * @memberof net
         * @interface Imsg_set_groupadd_limits_rep
         * @property {number|null} [result] msg_set_groupadd_limits_rep result
         */

        /**
         * Constructs a new msg_set_groupadd_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupadd_limits_rep.
         * @implements Imsg_set_groupadd_limits_rep
         * @constructor
         * @param {net.Imsg_set_groupadd_limits_rep=} [properties] Properties to set
         */
        function msg_set_groupadd_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadd_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupadd_limits_rep
         * @instance
         */
        msg_set_groupadd_limits_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupadd_limits_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {net.Imsg_set_groupadd_limits_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupadd_limits_rep} msg_set_groupadd_limits_rep instance
         */
        msg_set_groupadd_limits_rep.create = function create(properties) {
            return new msg_set_groupadd_limits_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupadd_limits_rep message. Does not implicitly {@link net.msg_set_groupadd_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {net.Imsg_set_groupadd_limits_rep} message msg_set_groupadd_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupadd_limits_rep message, length delimited. Does not implicitly {@link net.msg_set_groupadd_limits_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {net.Imsg_set_groupadd_limits_rep} message msg_set_groupadd_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupadd_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadd_limits_rep} msg_set_groupadd_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadd_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupadd_limits_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupadd_limits_rep} msg_set_groupadd_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupadd_limits_rep message.
         * @function verify
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupadd_limits_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupadd_limits_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupadd_limits_rep} msg_set_groupadd_limits_rep
         */
        msg_set_groupadd_limits_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupadd_limits_rep)
                return object;
            var message = new $root.net.msg_set_groupadd_limits_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupadd_limits_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {net.msg_set_groupadd_limits_rep} message msg_set_groupadd_limits_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupadd_limits_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupadd_limits_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupadd_limits_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupadd_limits_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupadd_limits_rep;
    })();

    net.msg_del_groupadmin = (function() {

        /**
         * Properties of a msg_del_groupadmin.
         * @memberof net
         * @interface Imsg_del_groupadmin
         * @property {Array.<number>|null} [uids] msg_del_groupadmin uids
         * @property {number|null} [groupkey] msg_del_groupadmin groupkey
         */

        /**
         * Constructs a new msg_del_groupadmin.
         * @memberof net
         * @classdesc Represents a msg_del_groupadmin.
         * @implements Imsg_del_groupadmin
         * @constructor
         * @param {net.Imsg_del_groupadmin=} [properties] Properties to set
         */
        function msg_del_groupadmin(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_groupadmin uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_groupadmin
         * @instance
         */
        msg_del_groupadmin.prototype.uids = $util.emptyArray;

        /**
         * msg_del_groupadmin groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_groupadmin
         * @instance
         */
        msg_del_groupadmin.prototype.groupkey = 0;

        /**
         * Creates a new msg_del_groupadmin instance using the specified properties.
         * @function create
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {net.Imsg_del_groupadmin=} [properties] Properties to set
         * @returns {net.msg_del_groupadmin} msg_del_groupadmin instance
         */
        msg_del_groupadmin.create = function create(properties) {
            return new msg_del_groupadmin(properties);
        };

        /**
         * Encodes the specified msg_del_groupadmin message. Does not implicitly {@link net.msg_del_groupadmin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {net.Imsg_del_groupadmin} message msg_del_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_del_groupadmin message, length delimited. Does not implicitly {@link net.msg_del_groupadmin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {net.Imsg_del_groupadmin} message msg_del_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_groupadmin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_groupadmin} msg_del_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_groupadmin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_groupadmin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_groupadmin} msg_del_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_groupadmin message.
         * @function verify
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_groupadmin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_del_groupadmin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_groupadmin} msg_del_groupadmin
         */
        msg_del_groupadmin.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_groupadmin)
                return object;
            var message = new $root.net.msg_del_groupadmin();
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_del_groupadmin.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_del_groupadmin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {net.msg_del_groupadmin} message msg_del_groupadmin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_groupadmin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_del_groupadmin to JSON.
         * @function toJSON
         * @memberof net.msg_del_groupadmin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_groupadmin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_groupadmin;
    })();

    net.msg_del_groupadmin_rep = (function() {

        /**
         * Properties of a msg_del_groupadmin_rep.
         * @memberof net
         * @interface Imsg_del_groupadmin_rep
         * @property {number|null} [result] msg_del_groupadmin_rep result
         */

        /**
         * Constructs a new msg_del_groupadmin_rep.
         * @memberof net
         * @classdesc Represents a msg_del_groupadmin_rep.
         * @implements Imsg_del_groupadmin_rep
         * @constructor
         * @param {net.Imsg_del_groupadmin_rep=} [properties] Properties to set
         */
        function msg_del_groupadmin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_groupadmin_rep result.
         * @member {number} result
         * @memberof net.msg_del_groupadmin_rep
         * @instance
         */
        msg_del_groupadmin_rep.prototype.result = 0;

        /**
         * Creates a new msg_del_groupadmin_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {net.Imsg_del_groupadmin_rep=} [properties] Properties to set
         * @returns {net.msg_del_groupadmin_rep} msg_del_groupadmin_rep instance
         */
        msg_del_groupadmin_rep.create = function create(properties) {
            return new msg_del_groupadmin_rep(properties);
        };

        /**
         * Encodes the specified msg_del_groupadmin_rep message. Does not implicitly {@link net.msg_del_groupadmin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {net.Imsg_del_groupadmin_rep} message msg_del_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_del_groupadmin_rep message, length delimited. Does not implicitly {@link net.msg_del_groupadmin_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {net.Imsg_del_groupadmin_rep} message msg_del_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_groupadmin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_groupadmin_rep} msg_del_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_groupadmin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_groupadmin_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_groupadmin_rep} msg_del_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_groupadmin_rep message.
         * @function verify
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_groupadmin_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_del_groupadmin_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_groupadmin_rep} msg_del_groupadmin_rep
         */
        msg_del_groupadmin_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_groupadmin_rep)
                return object;
            var message = new $root.net.msg_del_groupadmin_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_del_groupadmin_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {net.msg_del_groupadmin_rep} message msg_del_groupadmin_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_groupadmin_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_del_groupadmin_rep to JSON.
         * @function toJSON
         * @memberof net.msg_del_groupadmin_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_groupadmin_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_groupadmin_rep;
    })();

    net.msg_set_grouplook_limits = (function() {

        /**
         * Properties of a msg_set_grouplook_limits.
         * @memberof net
         * @interface Imsg_set_grouplook_limits
         * @property {number|null} [limits] msg_set_grouplook_limits limits
         * @property {number|null} [groupkey] msg_set_grouplook_limits groupkey
         */

        /**
         * Constructs a new msg_set_grouplook_limits.
         * @memberof net
         * @classdesc Represents a msg_set_grouplook_limits.
         * @implements Imsg_set_grouplook_limits
         * @constructor
         * @param {net.Imsg_set_grouplook_limits=} [properties] Properties to set
         */
        function msg_set_grouplook_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouplook_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_grouplook_limits
         * @instance
         */
        msg_set_grouplook_limits.prototype.limits = 0;

        /**
         * msg_set_grouplook_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouplook_limits
         * @instance
         */
        msg_set_grouplook_limits.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_grouplook_limits instance using the specified properties.
         * @function create
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {net.Imsg_set_grouplook_limits=} [properties] Properties to set
         * @returns {net.msg_set_grouplook_limits} msg_set_grouplook_limits instance
         */
        msg_set_grouplook_limits.create = function create(properties) {
            return new msg_set_grouplook_limits(properties);
        };

        /**
         * Encodes the specified msg_set_grouplook_limits message. Does not implicitly {@link net.msg_set_grouplook_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {net.Imsg_set_grouplook_limits} message msg_set_grouplook_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_grouplook_limits message, length delimited. Does not implicitly {@link net.msg_set_grouplook_limits.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {net.Imsg_set_grouplook_limits} message msg_set_grouplook_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_grouplook_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouplook_limits} msg_set_grouplook_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouplook_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_grouplook_limits message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_grouplook_limits} msg_set_grouplook_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_grouplook_limits message.
         * @function verify
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_grouplook_limits.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.limits != null && message.hasOwnProperty("limits"))
                if (!$util.isInteger(message.limits))
                    return "limits: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_grouplook_limits message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_grouplook_limits} msg_set_grouplook_limits
         */
        msg_set_grouplook_limits.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_grouplook_limits)
                return object;
            var message = new $root.net.msg_set_grouplook_limits();
            if (object.limits != null)
                message.limits = object.limits | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_grouplook_limits message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {net.msg_set_grouplook_limits} message msg_set_grouplook_limits
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_grouplook_limits.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.limits = 0;
                object.groupkey = 0;
            }
            if (message.limits != null && message.hasOwnProperty("limits"))
                object.limits = message.limits;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_grouplook_limits to JSON.
         * @function toJSON
         * @memberof net.msg_set_grouplook_limits
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_grouplook_limits.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_grouplook_limits;
    })();

    net.msg_set_grouplook_limits_rep = (function() {

        /**
         * Properties of a msg_set_grouplook_limits_rep.
         * @memberof net
         * @interface Imsg_set_grouplook_limits_rep
         * @property {number|null} [result] msg_set_grouplook_limits_rep result
         */

        /**
         * Constructs a new msg_set_grouplook_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_grouplook_limits_rep.
         * @implements Imsg_set_grouplook_limits_rep
         * @constructor
         * @param {net.Imsg_set_grouplook_limits_rep=} [properties] Properties to set
         */
        function msg_set_grouplook_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouplook_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_grouplook_limits_rep
         * @instance
         */
        msg_set_grouplook_limits_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_grouplook_limits_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {net.Imsg_set_grouplook_limits_rep=} [properties] Properties to set
         * @returns {net.msg_set_grouplook_limits_rep} msg_set_grouplook_limits_rep instance
         */
        msg_set_grouplook_limits_rep.create = function create(properties) {
            return new msg_set_grouplook_limits_rep(properties);
        };

        /**
         * Encodes the specified msg_set_grouplook_limits_rep message. Does not implicitly {@link net.msg_set_grouplook_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {net.Imsg_set_grouplook_limits_rep} message msg_set_grouplook_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_grouplook_limits_rep message, length delimited. Does not implicitly {@link net.msg_set_grouplook_limits_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {net.Imsg_set_grouplook_limits_rep} message msg_set_grouplook_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_grouplook_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouplook_limits_rep} msg_set_grouplook_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouplook_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_grouplook_limits_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_grouplook_limits_rep} msg_set_grouplook_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_grouplook_limits_rep message.
         * @function verify
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_grouplook_limits_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_grouplook_limits_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_grouplook_limits_rep} msg_set_grouplook_limits_rep
         */
        msg_set_grouplook_limits_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_grouplook_limits_rep)
                return object;
            var message = new $root.net.msg_set_grouplook_limits_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_grouplook_limits_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {net.msg_set_grouplook_limits_rep} message msg_set_grouplook_limits_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_grouplook_limits_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_grouplook_limits_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_grouplook_limits_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_grouplook_limits_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_grouplook_limits_rep;
    })();

    net.msg_set_groupsendmsg_limit = (function() {

        /**
         * Properties of a msg_set_groupsendmsg_limit.
         * @memberof net
         * @interface Imsg_set_groupsendmsg_limit
         * @property {number|null} [limits] msg_set_groupsendmsg_limit limits
         * @property {number|null} [groupkey] msg_set_groupsendmsg_limit groupkey
         */

        /**
         * Constructs a new msg_set_groupsendmsg_limit.
         * @memberof net
         * @classdesc Represents a msg_set_groupsendmsg_limit.
         * @implements Imsg_set_groupsendmsg_limit
         * @constructor
         * @param {net.Imsg_set_groupsendmsg_limit=} [properties] Properties to set
         */
        function msg_set_groupsendmsg_limit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupsendmsg_limit limits.
         * @member {number} limits
         * @memberof net.msg_set_groupsendmsg_limit
         * @instance
         */
        msg_set_groupsendmsg_limit.prototype.limits = 0;

        /**
         * msg_set_groupsendmsg_limit groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupsendmsg_limit
         * @instance
         */
        msg_set_groupsendmsg_limit.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_groupsendmsg_limit instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit=} [properties] Properties to set
         * @returns {net.msg_set_groupsendmsg_limit} msg_set_groupsendmsg_limit instance
         */
        msg_set_groupsendmsg_limit.create = function create(properties) {
            return new msg_set_groupsendmsg_limit(properties);
        };

        /**
         * Encodes the specified msg_set_groupsendmsg_limit message. Does not implicitly {@link net.msg_set_groupsendmsg_limit.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit} message msg_set_groupsendmsg_limit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupsendmsg_limit message, length delimited. Does not implicitly {@link net.msg_set_groupsendmsg_limit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit} message msg_set_groupsendmsg_limit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupsendmsg_limit} msg_set_groupsendmsg_limit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupsendmsg_limit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupsendmsg_limit} msg_set_groupsendmsg_limit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupsendmsg_limit message.
         * @function verify
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupsendmsg_limit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.limits != null && message.hasOwnProperty("limits"))
                if (!$util.isInteger(message.limits))
                    return "limits: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupsendmsg_limit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupsendmsg_limit} msg_set_groupsendmsg_limit
         */
        msg_set_groupsendmsg_limit.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupsendmsg_limit)
                return object;
            var message = new $root.net.msg_set_groupsendmsg_limit();
            if (object.limits != null)
                message.limits = object.limits | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupsendmsg_limit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {net.msg_set_groupsendmsg_limit} message msg_set_groupsendmsg_limit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupsendmsg_limit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.limits = 0;
                object.groupkey = 0;
            }
            if (message.limits != null && message.hasOwnProperty("limits"))
                object.limits = message.limits;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_groupsendmsg_limit to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupsendmsg_limit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupsendmsg_limit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupsendmsg_limit;
    })();

    net.msg_set_groupsendmsg_limit_rep = (function() {

        /**
         * Properties of a msg_set_groupsendmsg_limit_rep.
         * @memberof net
         * @interface Imsg_set_groupsendmsg_limit_rep
         * @property {number|null} [result] msg_set_groupsendmsg_limit_rep result
         */

        /**
         * Constructs a new msg_set_groupsendmsg_limit_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupsendmsg_limit_rep.
         * @implements Imsg_set_groupsendmsg_limit_rep
         * @constructor
         * @param {net.Imsg_set_groupsendmsg_limit_rep=} [properties] Properties to set
         */
        function msg_set_groupsendmsg_limit_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupsendmsg_limit_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @instance
         */
        msg_set_groupsendmsg_limit_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupsendmsg_limit_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupsendmsg_limit_rep} msg_set_groupsendmsg_limit_rep instance
         */
        msg_set_groupsendmsg_limit_rep.create = function create(properties) {
            return new msg_set_groupsendmsg_limit_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupsendmsg_limit_rep message. Does not implicitly {@link net.msg_set_groupsendmsg_limit_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit_rep} message msg_set_groupsendmsg_limit_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupsendmsg_limit_rep message, length delimited. Does not implicitly {@link net.msg_set_groupsendmsg_limit_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit_rep} message msg_set_groupsendmsg_limit_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupsendmsg_limit_rep} msg_set_groupsendmsg_limit_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupsendmsg_limit_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupsendmsg_limit_rep} msg_set_groupsendmsg_limit_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupsendmsg_limit_rep message.
         * @function verify
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupsendmsg_limit_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupsendmsg_limit_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupsendmsg_limit_rep} msg_set_groupsendmsg_limit_rep
         */
        msg_set_groupsendmsg_limit_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupsendmsg_limit_rep)
                return object;
            var message = new $root.net.msg_set_groupsendmsg_limit_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupsendmsg_limit_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {net.msg_set_groupsendmsg_limit_rep} message msg_set_groupsendmsg_limit_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupsendmsg_limit_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupsendmsg_limit_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupsendmsg_limit_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupsendmsg_limit_rep;
    })();

    net.msg_set_grouphost = (function() {

        /**
         * Properties of a msg_set_grouphost.
         * @memberof net
         * @interface Imsg_set_grouphost
         * @property {number|null} [uid] msg_set_grouphost uid
         * @property {number|null} [groupkey] msg_set_grouphost groupkey
         */

        /**
         * Constructs a new msg_set_grouphost.
         * @memberof net
         * @classdesc Represents a msg_set_grouphost.
         * @implements Imsg_set_grouphost
         * @constructor
         * @param {net.Imsg_set_grouphost=} [properties] Properties to set
         */
        function msg_set_grouphost(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouphost uid.
         * @member {number} uid
         * @memberof net.msg_set_grouphost
         * @instance
         */
        msg_set_grouphost.prototype.uid = 0;

        /**
         * msg_set_grouphost groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouphost
         * @instance
         */
        msg_set_grouphost.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_grouphost instance using the specified properties.
         * @function create
         * @memberof net.msg_set_grouphost
         * @static
         * @param {net.Imsg_set_grouphost=} [properties] Properties to set
         * @returns {net.msg_set_grouphost} msg_set_grouphost instance
         */
        msg_set_grouphost.create = function create(properties) {
            return new msg_set_grouphost(properties);
        };

        /**
         * Encodes the specified msg_set_grouphost message. Does not implicitly {@link net.msg_set_grouphost.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouphost
         * @static
         * @param {net.Imsg_set_grouphost} message msg_set_grouphost message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_grouphost message, length delimited. Does not implicitly {@link net.msg_set_grouphost.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_grouphost
         * @static
         * @param {net.Imsg_set_grouphost} message msg_set_grouphost message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_grouphost message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouphost
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouphost} msg_set_grouphost
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouphost();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_grouphost message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_grouphost
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_grouphost} msg_set_grouphost
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_grouphost message.
         * @function verify
         * @memberof net.msg_set_grouphost
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_grouphost.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_grouphost message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_grouphost
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_grouphost} msg_set_grouphost
         */
        msg_set_grouphost.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_grouphost)
                return object;
            var message = new $root.net.msg_set_grouphost();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_grouphost message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_grouphost
         * @static
         * @param {net.msg_set_grouphost} message msg_set_grouphost
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_grouphost.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.groupkey = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_grouphost to JSON.
         * @function toJSON
         * @memberof net.msg_set_grouphost
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_grouphost.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_grouphost;
    })();

    net.msg_set_grouphost_rep = (function() {

        /**
         * Properties of a msg_set_grouphost_rep.
         * @memberof net
         * @interface Imsg_set_grouphost_rep
         * @property {number|null} [result] msg_set_grouphost_rep result
         * @property {number|null} [groupkey] msg_set_grouphost_rep groupkey
         * @property {number|null} [uid] msg_set_grouphost_rep uid
         */

        /**
         * Constructs a new msg_set_grouphost_rep.
         * @memberof net
         * @classdesc Represents a msg_set_grouphost_rep.
         * @implements Imsg_set_grouphost_rep
         * @constructor
         * @param {net.Imsg_set_grouphost_rep=} [properties] Properties to set
         */
        function msg_set_grouphost_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouphost_rep result.
         * @member {number} result
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.result = 0;

        /**
         * msg_set_grouphost_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.groupkey = 0;

        /**
         * msg_set_grouphost_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.uid = 0;

        /**
         * Creates a new msg_set_grouphost_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {net.Imsg_set_grouphost_rep=} [properties] Properties to set
         * @returns {net.msg_set_grouphost_rep} msg_set_grouphost_rep instance
         */
        msg_set_grouphost_rep.create = function create(properties) {
            return new msg_set_grouphost_rep(properties);
        };

        /**
         * Encodes the specified msg_set_grouphost_rep message. Does not implicitly {@link net.msg_set_grouphost_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {net.Imsg_set_grouphost_rep} message msg_set_grouphost_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_grouphost_rep message, length delimited. Does not implicitly {@link net.msg_set_grouphost_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {net.Imsg_set_grouphost_rep} message msg_set_grouphost_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_grouphost_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouphost_rep} msg_set_grouphost_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouphost_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_grouphost_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_grouphost_rep} msg_set_grouphost_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_grouphost_rep message.
         * @function verify
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_grouphost_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_grouphost_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_grouphost_rep} msg_set_grouphost_rep
         */
        msg_set_grouphost_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_grouphost_rep)
                return object;
            var message = new $root.net.msg_set_grouphost_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_grouphost_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {net.msg_set_grouphost_rep} message msg_set_grouphost_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_grouphost_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
                object.uid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_set_grouphost_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_grouphost_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_grouphost_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_grouphost_rep;
    })();

    net.msg_set_group_headurl = (function() {

        /**
         * Properties of a msg_set_group_headurl.
         * @memberof net
         * @interface Imsg_set_group_headurl
         * @property {Uint8Array|null} [group_headurl] msg_set_group_headurl group_headurl
         * @property {number|null} [groupkey] msg_set_group_headurl groupkey
         */

        /**
         * Constructs a new msg_set_group_headurl.
         * @memberof net
         * @classdesc Represents a msg_set_group_headurl.
         * @implements Imsg_set_group_headurl
         * @constructor
         * @param {net.Imsg_set_group_headurl=} [properties] Properties to set
         */
        function msg_set_group_headurl(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_headurl group_headurl.
         * @member {Uint8Array} group_headurl
         * @memberof net.msg_set_group_headurl
         * @instance
         */
        msg_set_group_headurl.prototype.group_headurl = $util.newBuffer([]);

        /**
         * msg_set_group_headurl groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_headurl
         * @instance
         */
        msg_set_group_headurl.prototype.groupkey = 0;

        /**
         * Creates a new msg_set_group_headurl instance using the specified properties.
         * @function create
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {net.Imsg_set_group_headurl=} [properties] Properties to set
         * @returns {net.msg_set_group_headurl} msg_set_group_headurl instance
         */
        msg_set_group_headurl.create = function create(properties) {
            return new msg_set_group_headurl(properties);
        };

        /**
         * Encodes the specified msg_set_group_headurl message. Does not implicitly {@link net.msg_set_group_headurl.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {net.Imsg_set_group_headurl} message msg_set_group_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_headurl != null && Object.hasOwnProperty.call(message, "group_headurl"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.group_headurl);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_set_group_headurl message, length delimited. Does not implicitly {@link net.msg_set_group_headurl.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {net.Imsg_set_group_headurl} message msg_set_group_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_group_headurl message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_headurl} msg_set_group_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_headurl();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_headurl = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_group_headurl message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_group_headurl} msg_set_group_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_group_headurl message.
         * @function verify
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_group_headurl.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                if (!(message.group_headurl && typeof message.group_headurl.length === "number" || $util.isString(message.group_headurl)))
                    return "group_headurl: buffer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_group_headurl message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_group_headurl} msg_set_group_headurl
         */
        msg_set_group_headurl.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_group_headurl)
                return object;
            var message = new $root.net.msg_set_group_headurl();
            if (object.group_headurl != null)
                if (typeof object.group_headurl === "string")
                    $util.base64.decode(object.group_headurl, message.group_headurl = $util.newBuffer($util.base64.length(object.group_headurl)), 0);
                else if (object.group_headurl.length)
                    message.group_headurl = object.group_headurl;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_group_headurl message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {net.msg_set_group_headurl} message msg_set_group_headurl
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_group_headurl.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.group_headurl = "";
                else {
                    object.group_headurl = [];
                    if (options.bytes !== Array)
                        object.group_headurl = $util.newBuffer(object.group_headurl);
                }
                object.groupkey = 0;
            }
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                object.group_headurl = options.bytes === String ? $util.base64.encode(message.group_headurl, 0, message.group_headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.group_headurl) : message.group_headurl;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_set_group_headurl to JSON.
         * @function toJSON
         * @memberof net.msg_set_group_headurl
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_group_headurl.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_group_headurl;
    })();

    net.msg_set_group_headurl_rep = (function() {

        /**
         * Properties of a msg_set_group_headurl_rep.
         * @memberof net
         * @interface Imsg_set_group_headurl_rep
         * @property {number|null} [result] msg_set_group_headurl_rep result
         * @property {number|null} [groupkey] msg_set_group_headurl_rep groupkey
         * @property {Uint8Array|null} [group_headurl] msg_set_group_headurl_rep group_headurl
         */

        /**
         * Constructs a new msg_set_group_headurl_rep.
         * @memberof net
         * @classdesc Represents a msg_set_group_headurl_rep.
         * @implements Imsg_set_group_headurl_rep
         * @constructor
         * @param {net.Imsg_set_group_headurl_rep=} [properties] Properties to set
         */
        function msg_set_group_headurl_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_headurl_rep result.
         * @member {number} result
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.result = 0;

        /**
         * msg_set_group_headurl_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.groupkey = 0;

        /**
         * msg_set_group_headurl_rep group_headurl.
         * @member {Uint8Array} group_headurl
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.group_headurl = $util.newBuffer([]);

        /**
         * Creates a new msg_set_group_headurl_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {net.Imsg_set_group_headurl_rep=} [properties] Properties to set
         * @returns {net.msg_set_group_headurl_rep} msg_set_group_headurl_rep instance
         */
        msg_set_group_headurl_rep.create = function create(properties) {
            return new msg_set_group_headurl_rep(properties);
        };

        /**
         * Encodes the specified msg_set_group_headurl_rep message. Does not implicitly {@link net.msg_set_group_headurl_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {net.Imsg_set_group_headurl_rep} message msg_set_group_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.group_headurl != null && Object.hasOwnProperty.call(message, "group_headurl"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.group_headurl);
            return writer;
        };

        /**
         * Encodes the specified msg_set_group_headurl_rep message, length delimited. Does not implicitly {@link net.msg_set_group_headurl_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {net.Imsg_set_group_headurl_rep} message msg_set_group_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_group_headurl_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_headurl_rep} msg_set_group_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_headurl_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.group_headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_group_headurl_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_group_headurl_rep} msg_set_group_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_group_headurl_rep message.
         * @function verify
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_group_headurl_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                if (!(message.group_headurl && typeof message.group_headurl.length === "number" || $util.isString(message.group_headurl)))
                    return "group_headurl: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_group_headurl_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_group_headurl_rep} msg_set_group_headurl_rep
         */
        msg_set_group_headurl_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_group_headurl_rep)
                return object;
            var message = new $root.net.msg_set_group_headurl_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.group_headurl != null)
                if (typeof object.group_headurl === "string")
                    $util.base64.decode(object.group_headurl, message.group_headurl = $util.newBuffer($util.base64.length(object.group_headurl)), 0);
                else if (object.group_headurl.length)
                    message.group_headurl = object.group_headurl;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_group_headurl_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {net.msg_set_group_headurl_rep} message msg_set_group_headurl_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_group_headurl_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
                if (options.bytes === String)
                    object.group_headurl = "";
                else {
                    object.group_headurl = [];
                    if (options.bytes !== Array)
                        object.group_headurl = $util.newBuffer(object.group_headurl);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.group_headurl != null && message.hasOwnProperty("group_headurl"))
                object.group_headurl = options.bytes === String ? $util.base64.encode(message.group_headurl, 0, message.group_headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.group_headurl) : message.group_headurl;
            return object;
        };

        /**
         * Converts this msg_set_group_headurl_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_group_headurl_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_group_headurl_rep;
    })();

    net.msg_get_redbag_info = (function() {

        /**
         * Properties of a msg_get_redbag_info.
         * @memberof net
         * @interface Imsg_get_redbag_info
         * @property {number|null} [redbag_id] msg_get_redbag_info redbag_id
         */

        /**
         * Constructs a new msg_get_redbag_info.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_info.
         * @implements Imsg_get_redbag_info
         * @constructor
         * @param {net.Imsg_get_redbag_info=} [properties] Properties to set
         */
        function msg_get_redbag_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_info redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_info
         * @instance
         */
        msg_get_redbag_info.prototype.redbag_id = 0;

        /**
         * Creates a new msg_get_redbag_info instance using the specified properties.
         * @function create
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {net.Imsg_get_redbag_info=} [properties] Properties to set
         * @returns {net.msg_get_redbag_info} msg_get_redbag_info instance
         */
        msg_get_redbag_info.create = function create(properties) {
            return new msg_get_redbag_info(properties);
        };

        /**
         * Encodes the specified msg_get_redbag_info message. Does not implicitly {@link net.msg_get_redbag_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {net.Imsg_get_redbag_info} message msg_get_redbag_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            return writer;
        };

        /**
         * Encodes the specified msg_get_redbag_info message, length delimited. Does not implicitly {@link net.msg_get_redbag_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {net.Imsg_get_redbag_info} message msg_get_redbag_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_redbag_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_info} msg_get_redbag_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_redbag_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_redbag_info} msg_get_redbag_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_redbag_info message.
         * @function verify
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_redbag_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                if (!$util.isInteger(message.redbag_id))
                    return "redbag_id: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_redbag_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_redbag_info} msg_get_redbag_info
         */
        msg_get_redbag_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_redbag_info)
                return object;
            var message = new $root.net.msg_get_redbag_info();
            if (object.redbag_id != null)
                message.redbag_id = object.redbag_id | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_redbag_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {net.msg_get_redbag_info} message msg_get_redbag_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_redbag_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.redbag_id = 0;
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                object.redbag_id = message.redbag_id;
            return object;
        };

        /**
         * Converts this msg_get_redbag_info to JSON.
         * @function toJSON
         * @memberof net.msg_get_redbag_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_redbag_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_redbag_info;
    })();

    net.msg_get_redbag_info_rep = (function() {

        /**
         * Properties of a msg_get_redbag_info_rep.
         * @memberof net
         * @interface Imsg_get_redbag_info_rep
         * @property {number|null} [redbag_id] msg_get_redbag_info_rep redbag_id
         * @property {number|Long|null} [chatkey] msg_get_redbag_info_rep chatkey
         * @property {number|null} [chatmsgno] msg_get_redbag_info_rep chatmsgno
         * @property {number|null} [uid] msg_get_redbag_info_rep uid
         * @property {number|null} [redbagtype] msg_get_redbag_info_rep redbagtype
         * @property {number|null} [redbagvalue] msg_get_redbag_info_rep redbagvalue
         * @property {number|null} [redbagnum] msg_get_redbag_info_rep redbagnum
         * @property {number|null} [leftnum] msg_get_redbag_info_rep leftnum
         * @property {number|null} [redbagtime] msg_get_redbag_info_rep redbagtime
         * @property {Array.<net.Iredbag_get_record>|null} [records] msg_get_redbag_info_rep records
         * @property {Uint8Array|null} [nickname] msg_get_redbag_info_rep nickname
         * @property {Uint8Array|null} [headurl] msg_get_redbag_info_rep headurl
         * @property {number|null} [cointype] msg_get_redbag_info_rep cointype
         */

        /**
         * Constructs a new msg_get_redbag_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_info_rep.
         * @implements Imsg_get_redbag_info_rep
         * @constructor
         * @param {net.Imsg_get_redbag_info_rep=} [properties] Properties to set
         */
        function msg_get_redbag_info_rep(properties) {
            this.records = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_info_rep redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbag_id = 0;

        /**
         * msg_get_redbag_info_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_redbag_info_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.chatmsgno = 0;

        /**
         * msg_get_redbag_info_rep uid.
         * @member {number} uid
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.uid = 0;

        /**
         * msg_get_redbag_info_rep redbagtype.
         * @member {number} redbagtype
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagtype = 0;

        /**
         * msg_get_redbag_info_rep redbagvalue.
         * @member {number} redbagvalue
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagvalue = 0;

        /**
         * msg_get_redbag_info_rep redbagnum.
         * @member {number} redbagnum
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagnum = 0;

        /**
         * msg_get_redbag_info_rep leftnum.
         * @member {number} leftnum
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.leftnum = 0;

        /**
         * msg_get_redbag_info_rep redbagtime.
         * @member {number} redbagtime
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagtime = 0;

        /**
         * msg_get_redbag_info_rep records.
         * @member {Array.<net.Iredbag_get_record>} records
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.records = $util.emptyArray;

        /**
         * msg_get_redbag_info_rep nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.nickname = $util.newBuffer([]);

        /**
         * msg_get_redbag_info_rep headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.headurl = $util.newBuffer([]);

        /**
         * msg_get_redbag_info_rep cointype.
         * @member {number} cointype
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.cointype = 0;

        /**
         * Creates a new msg_get_redbag_info_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {net.Imsg_get_redbag_info_rep=} [properties] Properties to set
         * @returns {net.msg_get_redbag_info_rep} msg_get_redbag_info_rep instance
         */
        msg_get_redbag_info_rep.create = function create(properties) {
            return new msg_get_redbag_info_rep(properties);
        };

        /**
         * Encodes the specified msg_get_redbag_info_rep message. Does not implicitly {@link net.msg_get_redbag_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {net.Imsg_get_redbag_info_rep} message msg_get_redbag_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            if (message.redbagtype != null && Object.hasOwnProperty.call(message, "redbagtype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.redbagtype);
            if (message.redbagvalue != null && Object.hasOwnProperty.call(message, "redbagvalue"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.redbagvalue);
            if (message.redbagnum != null && Object.hasOwnProperty.call(message, "redbagnum"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.redbagnum);
            if (message.leftnum != null && Object.hasOwnProperty.call(message, "leftnum"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.leftnum);
            if (message.redbagtime != null && Object.hasOwnProperty.call(message, "redbagtime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.redbagtime);
            if (message.records != null && message.records.length)
                for (var i = 0; i < message.records.length; ++i)
                    $root.net.redbag_get_record.encode(message.records[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.nickname);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.headurl);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.cointype);
            return writer;
        };

        /**
         * Encodes the specified msg_get_redbag_info_rep message, length delimited. Does not implicitly {@link net.msg_get_redbag_info_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {net.Imsg_get_redbag_info_rep} message msg_get_redbag_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_redbag_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_info_rep} msg_get_redbag_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                case 5:
                    message.redbagtype = reader.int32();
                    break;
                case 6:
                    message.redbagvalue = reader.int32();
                    break;
                case 7:
                    message.redbagnum = reader.int32();
                    break;
                case 8:
                    message.leftnum = reader.int32();
                    break;
                case 9:
                    message.redbagtime = reader.int32();
                    break;
                case 10:
                    if (!(message.records && message.records.length))
                        message.records = [];
                    message.records.push($root.net.redbag_get_record.decode(reader, reader.uint32()));
                    break;
                case 11:
                    message.nickname = reader.bytes();
                    break;
                case 12:
                    message.headurl = reader.bytes();
                    break;
                case 13:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_redbag_info_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_redbag_info_rep} msg_get_redbag_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_redbag_info_rep message.
         * @function verify
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_redbag_info_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                if (!$util.isInteger(message.redbag_id))
                    return "redbag_id: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.redbagtype != null && message.hasOwnProperty("redbagtype"))
                if (!$util.isInteger(message.redbagtype))
                    return "redbagtype: integer expected";
            if (message.redbagvalue != null && message.hasOwnProperty("redbagvalue"))
                if (!$util.isInteger(message.redbagvalue))
                    return "redbagvalue: integer expected";
            if (message.redbagnum != null && message.hasOwnProperty("redbagnum"))
                if (!$util.isInteger(message.redbagnum))
                    return "redbagnum: integer expected";
            if (message.leftnum != null && message.hasOwnProperty("leftnum"))
                if (!$util.isInteger(message.leftnum))
                    return "leftnum: integer expected";
            if (message.redbagtime != null && message.hasOwnProperty("redbagtime"))
                if (!$util.isInteger(message.redbagtime))
                    return "redbagtime: integer expected";
            if (message.records != null && message.hasOwnProperty("records")) {
                if (!Array.isArray(message.records))
                    return "records: array expected";
                for (var i = 0; i < message.records.length; ++i) {
                    var error = $root.net.redbag_get_record.verify(message.records[i]);
                    if (error)
                        return "records." + error;
                }
            }
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_redbag_info_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_redbag_info_rep} msg_get_redbag_info_rep
         */
        msg_get_redbag_info_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_redbag_info_rep)
                return object;
            var message = new $root.net.msg_get_redbag_info_rep();
            if (object.redbag_id != null)
                message.redbag_id = object.redbag_id | 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.redbagtype != null)
                message.redbagtype = object.redbagtype | 0;
            if (object.redbagvalue != null)
                message.redbagvalue = object.redbagvalue | 0;
            if (object.redbagnum != null)
                message.redbagnum = object.redbagnum | 0;
            if (object.leftnum != null)
                message.leftnum = object.leftnum | 0;
            if (object.redbagtime != null)
                message.redbagtime = object.redbagtime | 0;
            if (object.records) {
                if (!Array.isArray(object.records))
                    throw TypeError(".net.msg_get_redbag_info_rep.records: array expected");
                message.records = [];
                for (var i = 0; i < object.records.length; ++i) {
                    if (typeof object.records[i] !== "object")
                        throw TypeError(".net.msg_get_redbag_info_rep.records: object expected");
                    message.records[i] = $root.net.redbag_get_record.fromObject(object.records[i]);
                }
            }
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_redbag_info_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {net.msg_get_redbag_info_rep} message msg_get_redbag_info_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_redbag_info_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.records = [];
            if (options.defaults) {
                object.redbag_id = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
                object.uid = 0;
                object.redbagtype = 0;
                object.redbagvalue = 0;
                object.redbagnum = 0;
                object.leftnum = 0;
                object.redbagtime = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
                object.cointype = 0;
            }
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                object.redbag_id = message.redbag_id;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.redbagtype != null && message.hasOwnProperty("redbagtype"))
                object.redbagtype = message.redbagtype;
            if (message.redbagvalue != null && message.hasOwnProperty("redbagvalue"))
                object.redbagvalue = message.redbagvalue;
            if (message.redbagnum != null && message.hasOwnProperty("redbagnum"))
                object.redbagnum = message.redbagnum;
            if (message.leftnum != null && message.hasOwnProperty("leftnum"))
                object.leftnum = message.leftnum;
            if (message.redbagtime != null && message.hasOwnProperty("redbagtime"))
                object.redbagtime = message.redbagtime;
            if (message.records && message.records.length) {
                object.records = [];
                for (var j = 0; j < message.records.length; ++j)
                    object.records[j] = $root.net.redbag_get_record.toObject(message.records[j], options);
            }
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            return object;
        };

        /**
         * Converts this msg_get_redbag_info_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_redbag_info_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_redbag_info_rep;
    })();

    net.msg_get_redbag = (function() {

        /**
         * Properties of a msg_get_redbag.
         * @memberof net
         * @interface Imsg_get_redbag
         * @property {number|null} [redbag_id] msg_get_redbag redbag_id
         */

        /**
         * Constructs a new msg_get_redbag.
         * @memberof net
         * @classdesc Represents a msg_get_redbag.
         * @implements Imsg_get_redbag
         * @constructor
         * @param {net.Imsg_get_redbag=} [properties] Properties to set
         */
        function msg_get_redbag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag
         * @instance
         */
        msg_get_redbag.prototype.redbag_id = 0;

        /**
         * Creates a new msg_get_redbag instance using the specified properties.
         * @function create
         * @memberof net.msg_get_redbag
         * @static
         * @param {net.Imsg_get_redbag=} [properties] Properties to set
         * @returns {net.msg_get_redbag} msg_get_redbag instance
         */
        msg_get_redbag.create = function create(properties) {
            return new msg_get_redbag(properties);
        };

        /**
         * Encodes the specified msg_get_redbag message. Does not implicitly {@link net.msg_get_redbag.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag
         * @static
         * @param {net.Imsg_get_redbag} message msg_get_redbag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            return writer;
        };

        /**
         * Encodes the specified msg_get_redbag message, length delimited. Does not implicitly {@link net.msg_get_redbag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_redbag
         * @static
         * @param {net.Imsg_get_redbag} message msg_get_redbag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_redbag message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag} msg_get_redbag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_redbag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_redbag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_redbag} msg_get_redbag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_redbag message.
         * @function verify
         * @memberof net.msg_get_redbag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_redbag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                if (!$util.isInteger(message.redbag_id))
                    return "redbag_id: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_redbag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_redbag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_redbag} msg_get_redbag
         */
        msg_get_redbag.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_redbag)
                return object;
            var message = new $root.net.msg_get_redbag();
            if (object.redbag_id != null)
                message.redbag_id = object.redbag_id | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_redbag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_redbag
         * @static
         * @param {net.msg_get_redbag} message msg_get_redbag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_redbag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.redbag_id = 0;
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                object.redbag_id = message.redbag_id;
            return object;
        };

        /**
         * Converts this msg_get_redbag to JSON.
         * @function toJSON
         * @memberof net.msg_get_redbag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_redbag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_redbag;
    })();

    net.msg_get_redbag_rep = (function() {

        /**
         * Properties of a msg_get_redbag_rep.
         * @memberof net
         * @interface Imsg_get_redbag_rep
         * @property {number|null} [result] msg_get_redbag_rep result
         * @property {number|null} [redbag_id] msg_get_redbag_rep redbag_id
         */

        /**
         * Constructs a new msg_get_redbag_rep.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_rep.
         * @implements Imsg_get_redbag_rep
         * @constructor
         * @param {net.Imsg_get_redbag_rep=} [properties] Properties to set
         */
        function msg_get_redbag_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_rep result.
         * @member {number} result
         * @memberof net.msg_get_redbag_rep
         * @instance
         */
        msg_get_redbag_rep.prototype.result = 0;

        /**
         * msg_get_redbag_rep redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_rep
         * @instance
         */
        msg_get_redbag_rep.prototype.redbag_id = 0;

        /**
         * Creates a new msg_get_redbag_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {net.Imsg_get_redbag_rep=} [properties] Properties to set
         * @returns {net.msg_get_redbag_rep} msg_get_redbag_rep instance
         */
        msg_get_redbag_rep.create = function create(properties) {
            return new msg_get_redbag_rep(properties);
        };

        /**
         * Encodes the specified msg_get_redbag_rep message. Does not implicitly {@link net.msg_get_redbag_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {net.Imsg_get_redbag_rep} message msg_get_redbag_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.redbag_id);
            return writer;
        };

        /**
         * Encodes the specified msg_get_redbag_rep message, length delimited. Does not implicitly {@link net.msg_get_redbag_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {net.Imsg_get_redbag_rep} message msg_get_redbag_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_redbag_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_rep} msg_get_redbag_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_redbag_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_redbag_rep} msg_get_redbag_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_redbag_rep message.
         * @function verify
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_redbag_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                if (!$util.isInteger(message.redbag_id))
                    return "redbag_id: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_redbag_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_redbag_rep} msg_get_redbag_rep
         */
        msg_get_redbag_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_redbag_rep)
                return object;
            var message = new $root.net.msg_get_redbag_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.redbag_id != null)
                message.redbag_id = object.redbag_id | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_redbag_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {net.msg_get_redbag_rep} message msg_get_redbag_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_redbag_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.redbag_id = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.redbag_id != null && message.hasOwnProperty("redbag_id"))
                object.redbag_id = message.redbag_id;
            return object;
        };

        /**
         * Converts this msg_get_redbag_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_redbag_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_redbag_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_redbag_rep;
    })();

    net.msg_input_sync = (function() {

        /**
         * Properties of a msg_input_sync.
         * @memberof net
         * @interface Imsg_input_sync
         * @property {number|Long|null} [chatkey] msg_input_sync chatkey
         * @property {number|null} [is_input] msg_input_sync is_input
         */

        /**
         * Constructs a new msg_input_sync.
         * @memberof net
         * @classdesc Represents a msg_input_sync.
         * @implements Imsg_input_sync
         * @constructor
         * @param {net.Imsg_input_sync=} [properties] Properties to set
         */
        function msg_input_sync(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_input_sync chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_input_sync
         * @instance
         */
        msg_input_sync.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_input_sync is_input.
         * @member {number} is_input
         * @memberof net.msg_input_sync
         * @instance
         */
        msg_input_sync.prototype.is_input = 0;

        /**
         * Creates a new msg_input_sync instance using the specified properties.
         * @function create
         * @memberof net.msg_input_sync
         * @static
         * @param {net.Imsg_input_sync=} [properties] Properties to set
         * @returns {net.msg_input_sync} msg_input_sync instance
         */
        msg_input_sync.create = function create(properties) {
            return new msg_input_sync(properties);
        };

        /**
         * Encodes the specified msg_input_sync message. Does not implicitly {@link net.msg_input_sync.verify|verify} messages.
         * @function encode
         * @memberof net.msg_input_sync
         * @static
         * @param {net.Imsg_input_sync} message msg_input_sync message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.is_input != null && Object.hasOwnProperty.call(message, "is_input"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_input);
            return writer;
        };

        /**
         * Encodes the specified msg_input_sync message, length delimited. Does not implicitly {@link net.msg_input_sync.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_input_sync
         * @static
         * @param {net.Imsg_input_sync} message msg_input_sync message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_input_sync message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_input_sync
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_input_sync} msg_input_sync
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_input_sync();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.is_input = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_input_sync message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_input_sync
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_input_sync} msg_input_sync
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_input_sync message.
         * @function verify
         * @memberof net.msg_input_sync
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_input_sync.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.is_input != null && message.hasOwnProperty("is_input"))
                if (!$util.isInteger(message.is_input))
                    return "is_input: integer expected";
            return null;
        };

        /**
         * Creates a msg_input_sync message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_input_sync
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_input_sync} msg_input_sync
         */
        msg_input_sync.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_input_sync)
                return object;
            var message = new $root.net.msg_input_sync();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.is_input != null)
                message.is_input = object.is_input | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_input_sync message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_input_sync
         * @static
         * @param {net.msg_input_sync} message msg_input_sync
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_input_sync.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.is_input = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.is_input != null && message.hasOwnProperty("is_input"))
                object.is_input = message.is_input;
            return object;
        };

        /**
         * Converts this msg_input_sync to JSON.
         * @function toJSON
         * @memberof net.msg_input_sync
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_input_sync.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_input_sync;
    })();

    net.msg_input_sync_rep = (function() {

        /**
         * Properties of a msg_input_sync_rep.
         * @memberof net
         * @interface Imsg_input_sync_rep
         * @property {number|Long|null} [chatkey] msg_input_sync_rep chatkey
         * @property {number|null} [is_input] msg_input_sync_rep is_input
         */

        /**
         * Constructs a new msg_input_sync_rep.
         * @memberof net
         * @classdesc Represents a msg_input_sync_rep.
         * @implements Imsg_input_sync_rep
         * @constructor
         * @param {net.Imsg_input_sync_rep=} [properties] Properties to set
         */
        function msg_input_sync_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_input_sync_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_input_sync_rep
         * @instance
         */
        msg_input_sync_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_input_sync_rep is_input.
         * @member {number} is_input
         * @memberof net.msg_input_sync_rep
         * @instance
         */
        msg_input_sync_rep.prototype.is_input = 0;

        /**
         * Creates a new msg_input_sync_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {net.Imsg_input_sync_rep=} [properties] Properties to set
         * @returns {net.msg_input_sync_rep} msg_input_sync_rep instance
         */
        msg_input_sync_rep.create = function create(properties) {
            return new msg_input_sync_rep(properties);
        };

        /**
         * Encodes the specified msg_input_sync_rep message. Does not implicitly {@link net.msg_input_sync_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {net.Imsg_input_sync_rep} message msg_input_sync_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.is_input != null && Object.hasOwnProperty.call(message, "is_input"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_input);
            return writer;
        };

        /**
         * Encodes the specified msg_input_sync_rep message, length delimited. Does not implicitly {@link net.msg_input_sync_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {net.Imsg_input_sync_rep} message msg_input_sync_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_input_sync_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_input_sync_rep} msg_input_sync_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_input_sync_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.is_input = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_input_sync_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_input_sync_rep} msg_input_sync_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_input_sync_rep message.
         * @function verify
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_input_sync_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.is_input != null && message.hasOwnProperty("is_input"))
                if (!$util.isInteger(message.is_input))
                    return "is_input: integer expected";
            return null;
        };

        /**
         * Creates a msg_input_sync_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_input_sync_rep} msg_input_sync_rep
         */
        msg_input_sync_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_input_sync_rep)
                return object;
            var message = new $root.net.msg_input_sync_rep();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.is_input != null)
                message.is_input = object.is_input | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_input_sync_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {net.msg_input_sync_rep} message msg_input_sync_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_input_sync_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.is_input = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.is_input != null && message.hasOwnProperty("is_input"))
                object.is_input = message.is_input;
            return object;
        };

        /**
         * Converts this msg_input_sync_rep to JSON.
         * @function toJSON
         * @memberof net.msg_input_sync_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_input_sync_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_input_sync_rep;
    })();

    net.msg_get_online_state = (function() {

        /**
         * Properties of a msg_get_online_state.
         * @memberof net
         * @interface Imsg_get_online_state
         * @property {number|null} [uid] msg_get_online_state uid
         */

        /**
         * Constructs a new msg_get_online_state.
         * @memberof net
         * @classdesc Represents a msg_get_online_state.
         * @implements Imsg_get_online_state
         * @constructor
         * @param {net.Imsg_get_online_state=} [properties] Properties to set
         */
        function msg_get_online_state(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_state uid.
         * @member {number} uid
         * @memberof net.msg_get_online_state
         * @instance
         */
        msg_get_online_state.prototype.uid = 0;

        /**
         * Creates a new msg_get_online_state instance using the specified properties.
         * @function create
         * @memberof net.msg_get_online_state
         * @static
         * @param {net.Imsg_get_online_state=} [properties] Properties to set
         * @returns {net.msg_get_online_state} msg_get_online_state instance
         */
        msg_get_online_state.create = function create(properties) {
            return new msg_get_online_state(properties);
        };

        /**
         * Encodes the specified msg_get_online_state message. Does not implicitly {@link net.msg_get_online_state.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_state
         * @static
         * @param {net.Imsg_get_online_state} message msg_get_online_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_online_state message, length delimited. Does not implicitly {@link net.msg_get_online_state.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_online_state
         * @static
         * @param {net.Imsg_get_online_state} message msg_get_online_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_online_state message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_state} msg_get_online_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_state();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_online_state message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_online_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_online_state} msg_get_online_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_online_state message.
         * @function verify
         * @memberof net.msg_get_online_state
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_online_state.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_online_state message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_online_state
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_online_state} msg_get_online_state
         */
        msg_get_online_state.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_online_state)
                return object;
            var message = new $root.net.msg_get_online_state();
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_online_state message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_online_state
         * @static
         * @param {net.msg_get_online_state} message msg_get_online_state
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_online_state.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = 0;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_get_online_state to JSON.
         * @function toJSON
         * @memberof net.msg_get_online_state
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_online_state.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_online_state;
    })();

    net.msg_get_online_state_rep = (function() {

        /**
         * Properties of a msg_get_online_state_rep.
         * @memberof net
         * @interface Imsg_get_online_state_rep
         * @property {number|null} [uid] msg_get_online_state_rep uid
         * @property {number|null} [lastlogouttime] msg_get_online_state_rep lastlogouttime
         */

        /**
         * Constructs a new msg_get_online_state_rep.
         * @memberof net
         * @classdesc Represents a msg_get_online_state_rep.
         * @implements Imsg_get_online_state_rep
         * @constructor
         * @param {net.Imsg_get_online_state_rep=} [properties] Properties to set
         */
        function msg_get_online_state_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_state_rep uid.
         * @member {number} uid
         * @memberof net.msg_get_online_state_rep
         * @instance
         */
        msg_get_online_state_rep.prototype.uid = 0;

        /**
         * msg_get_online_state_rep lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.msg_get_online_state_rep
         * @instance
         */
        msg_get_online_state_rep.prototype.lastlogouttime = 0;

        /**
         * Creates a new msg_get_online_state_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {net.Imsg_get_online_state_rep=} [properties] Properties to set
         * @returns {net.msg_get_online_state_rep} msg_get_online_state_rep instance
         */
        msg_get_online_state_rep.create = function create(properties) {
            return new msg_get_online_state_rep(properties);
        };

        /**
         * Encodes the specified msg_get_online_state_rep message. Does not implicitly {@link net.msg_get_online_state_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {net.Imsg_get_online_state_rep} message msg_get_online_state_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.lastlogouttime);
            return writer;
        };

        /**
         * Encodes the specified msg_get_online_state_rep message, length delimited. Does not implicitly {@link net.msg_get_online_state_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {net.Imsg_get_online_state_rep} message msg_get_online_state_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_online_state_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_state_rep} msg_get_online_state_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_state_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.lastlogouttime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_online_state_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_online_state_rep} msg_get_online_state_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_online_state_rep message.
         * @function verify
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_online_state_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                if (!$util.isInteger(message.lastlogouttime))
                    return "lastlogouttime: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_online_state_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_online_state_rep} msg_get_online_state_rep
         */
        msg_get_online_state_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_online_state_rep)
                return object;
            var message = new $root.net.msg_get_online_state_rep();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.lastlogouttime != null)
                message.lastlogouttime = object.lastlogouttime | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_online_state_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {net.msg_get_online_state_rep} message msg_get_online_state_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_online_state_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.lastlogouttime = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.lastlogouttime != null && message.hasOwnProperty("lastlogouttime"))
                object.lastlogouttime = message.lastlogouttime;
            return object;
        };

        /**
         * Converts this msg_get_online_state_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_online_state_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_online_state_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_online_state_rep;
    })();

    net.msg_get_group_online = (function() {

        /**
         * Properties of a msg_get_group_online.
         * @memberof net
         * @interface Imsg_get_group_online
         * @property {number|null} [groupkey] msg_get_group_online groupkey
         */

        /**
         * Constructs a new msg_get_group_online.
         * @memberof net
         * @classdesc Represents a msg_get_group_online.
         * @implements Imsg_get_group_online
         * @constructor
         * @param {net.Imsg_get_group_online=} [properties] Properties to set
         */
        function msg_get_group_online(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_online groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_online
         * @instance
         */
        msg_get_group_online.prototype.groupkey = 0;

        /**
         * Creates a new msg_get_group_online instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_online
         * @static
         * @param {net.Imsg_get_group_online=} [properties] Properties to set
         * @returns {net.msg_get_group_online} msg_get_group_online instance
         */
        msg_get_group_online.create = function create(properties) {
            return new msg_get_group_online(properties);
        };

        /**
         * Encodes the specified msg_get_group_online message. Does not implicitly {@link net.msg_get_group_online.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_online
         * @static
         * @param {net.Imsg_get_group_online} message msg_get_group_online message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_online message, length delimited. Does not implicitly {@link net.msg_get_group_online.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_online
         * @static
         * @param {net.Imsg_get_group_online} message msg_get_group_online message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_online message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_online
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_online} msg_get_group_online
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_online();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_online message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_online
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_online} msg_get_group_online
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_online message.
         * @function verify
         * @memberof net.msg_get_group_online
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_online.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_online message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_online
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_online} msg_get_group_online
         */
        msg_get_group_online.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_online)
                return object;
            var message = new $root.net.msg_get_group_online();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_online message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_online
         * @static
         * @param {net.msg_get_group_online} message msg_get_group_online
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_online.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_get_group_online to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_online
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_online.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_online;
    })();

    net.msg_get_group_online_rep = (function() {

        /**
         * Properties of a msg_get_group_online_rep.
         * @memberof net
         * @interface Imsg_get_group_online_rep
         * @property {number|null} [group_online] msg_get_group_online_rep group_online
         */

        /**
         * Constructs a new msg_get_group_online_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_online_rep.
         * @implements Imsg_get_group_online_rep
         * @constructor
         * @param {net.Imsg_get_group_online_rep=} [properties] Properties to set
         */
        function msg_get_group_online_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_online_rep group_online.
         * @member {number} group_online
         * @memberof net.msg_get_group_online_rep
         * @instance
         */
        msg_get_group_online_rep.prototype.group_online = 0;

        /**
         * Creates a new msg_get_group_online_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {net.Imsg_get_group_online_rep=} [properties] Properties to set
         * @returns {net.msg_get_group_online_rep} msg_get_group_online_rep instance
         */
        msg_get_group_online_rep.create = function create(properties) {
            return new msg_get_group_online_rep(properties);
        };

        /**
         * Encodes the specified msg_get_group_online_rep message. Does not implicitly {@link net.msg_get_group_online_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {net.Imsg_get_group_online_rep} message msg_get_group_online_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_online != null && Object.hasOwnProperty.call(message, "group_online"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.group_online);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_online_rep message, length delimited. Does not implicitly {@link net.msg_get_group_online_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {net.Imsg_get_group_online_rep} message msg_get_group_online_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_online_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_online_rep} msg_get_group_online_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_online_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_online = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_online_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_online_rep} msg_get_group_online_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_online_rep message.
         * @function verify
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_online_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.group_online != null && message.hasOwnProperty("group_online"))
                if (!$util.isInteger(message.group_online))
                    return "group_online: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_online_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_online_rep} msg_get_group_online_rep
         */
        msg_get_group_online_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_online_rep)
                return object;
            var message = new $root.net.msg_get_group_online_rep();
            if (object.group_online != null)
                message.group_online = object.group_online | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_online_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {net.msg_get_group_online_rep} message msg_get_group_online_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_online_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.group_online = 0;
            if (message.group_online != null && message.hasOwnProperty("group_online"))
                object.group_online = message.group_online;
            return object;
        };

        /**
         * Converts this msg_get_group_online_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_online_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_online_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_online_rep;
    })();

    net.msg_set_mute_notifications = (function() {

        /**
         * Properties of a msg_set_mute_notifications.
         * @memberof net
         * @interface Imsg_set_mute_notifications
         * @property {number|Long|null} [chatkey] msg_set_mute_notifications chatkey
         * @property {number|null} [opertype] msg_set_mute_notifications opertype
         */

        /**
         * Constructs a new msg_set_mute_notifications.
         * @memberof net
         * @classdesc Represents a msg_set_mute_notifications.
         * @implements Imsg_set_mute_notifications
         * @constructor
         * @param {net.Imsg_set_mute_notifications=} [properties] Properties to set
         */
        function msg_set_mute_notifications(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_mute_notifications chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_mute_notifications
         * @instance
         */
        msg_set_mute_notifications.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_mute_notifications opertype.
         * @member {number} opertype
         * @memberof net.msg_set_mute_notifications
         * @instance
         */
        msg_set_mute_notifications.prototype.opertype = 0;

        /**
         * Creates a new msg_set_mute_notifications instance using the specified properties.
         * @function create
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {net.Imsg_set_mute_notifications=} [properties] Properties to set
         * @returns {net.msg_set_mute_notifications} msg_set_mute_notifications instance
         */
        msg_set_mute_notifications.create = function create(properties) {
            return new msg_set_mute_notifications(properties);
        };

        /**
         * Encodes the specified msg_set_mute_notifications message. Does not implicitly {@link net.msg_set_mute_notifications.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {net.Imsg_set_mute_notifications} message msg_set_mute_notifications message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_set_mute_notifications message, length delimited. Does not implicitly {@link net.msg_set_mute_notifications.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {net.Imsg_set_mute_notifications} message msg_set_mute_notifications message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_mute_notifications message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_mute_notifications} msg_set_mute_notifications
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_mute_notifications();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_mute_notifications message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_mute_notifications} msg_set_mute_notifications
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_mute_notifications message.
         * @function verify
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_mute_notifications.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_mute_notifications message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_mute_notifications} msg_set_mute_notifications
         */
        msg_set_mute_notifications.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_mute_notifications)
                return object;
            var message = new $root.net.msg_set_mute_notifications();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_mute_notifications message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {net.msg_set_mute_notifications} message msg_set_mute_notifications
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_mute_notifications.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_set_mute_notifications to JSON.
         * @function toJSON
         * @memberof net.msg_set_mute_notifications
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_mute_notifications.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_mute_notifications;
    })();

    net.msg_set_mute_notifications_rep = (function() {

        /**
         * Properties of a msg_set_mute_notifications_rep.
         * @memberof net
         * @interface Imsg_set_mute_notifications_rep
         * @property {number|null} [result] msg_set_mute_notifications_rep result
         * @property {number|Long|null} [chatkey] msg_set_mute_notifications_rep chatkey
         * @property {number|null} [opertype] msg_set_mute_notifications_rep opertype
         */

        /**
         * Constructs a new msg_set_mute_notifications_rep.
         * @memberof net
         * @classdesc Represents a msg_set_mute_notifications_rep.
         * @implements Imsg_set_mute_notifications_rep
         * @constructor
         * @param {net.Imsg_set_mute_notifications_rep=} [properties] Properties to set
         */
        function msg_set_mute_notifications_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_mute_notifications_rep result.
         * @member {number} result
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.result = 0;

        /**
         * msg_set_mute_notifications_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_mute_notifications_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.opertype = 0;

        /**
         * Creates a new msg_set_mute_notifications_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {net.Imsg_set_mute_notifications_rep=} [properties] Properties to set
         * @returns {net.msg_set_mute_notifications_rep} msg_set_mute_notifications_rep instance
         */
        msg_set_mute_notifications_rep.create = function create(properties) {
            return new msg_set_mute_notifications_rep(properties);
        };

        /**
         * Encodes the specified msg_set_mute_notifications_rep message. Does not implicitly {@link net.msg_set_mute_notifications_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {net.Imsg_set_mute_notifications_rep} message msg_set_mute_notifications_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_set_mute_notifications_rep message, length delimited. Does not implicitly {@link net.msg_set_mute_notifications_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {net.Imsg_set_mute_notifications_rep} message msg_set_mute_notifications_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_mute_notifications_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_mute_notifications_rep} msg_set_mute_notifications_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_mute_notifications_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_mute_notifications_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_mute_notifications_rep} msg_set_mute_notifications_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_mute_notifications_rep message.
         * @function verify
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_mute_notifications_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_mute_notifications_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_mute_notifications_rep} msg_set_mute_notifications_rep
         */
        msg_set_mute_notifications_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_mute_notifications_rep)
                return object;
            var message = new $root.net.msg_set_mute_notifications_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_mute_notifications_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {net.msg_set_mute_notifications_rep} message msg_set_mute_notifications_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_mute_notifications_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_set_mute_notifications_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_mute_notifications_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_mute_notifications_rep;
    })();

    net.msg_set_chat_on_top = (function() {

        /**
         * Properties of a msg_set_chat_on_top.
         * @memberof net
         * @interface Imsg_set_chat_on_top
         * @property {number|Long|null} [chatkey] msg_set_chat_on_top chatkey
         * @property {number|null} [opertype] msg_set_chat_on_top opertype
         */

        /**
         * Constructs a new msg_set_chat_on_top.
         * @memberof net
         * @classdesc Represents a msg_set_chat_on_top.
         * @implements Imsg_set_chat_on_top
         * @constructor
         * @param {net.Imsg_set_chat_on_top=} [properties] Properties to set
         */
        function msg_set_chat_on_top(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_chat_on_top chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_chat_on_top
         * @instance
         */
        msg_set_chat_on_top.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_chat_on_top opertype.
         * @member {number} opertype
         * @memberof net.msg_set_chat_on_top
         * @instance
         */
        msg_set_chat_on_top.prototype.opertype = 0;

        /**
         * Creates a new msg_set_chat_on_top instance using the specified properties.
         * @function create
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {net.Imsg_set_chat_on_top=} [properties] Properties to set
         * @returns {net.msg_set_chat_on_top} msg_set_chat_on_top instance
         */
        msg_set_chat_on_top.create = function create(properties) {
            return new msg_set_chat_on_top(properties);
        };

        /**
         * Encodes the specified msg_set_chat_on_top message. Does not implicitly {@link net.msg_set_chat_on_top.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {net.Imsg_set_chat_on_top} message msg_set_chat_on_top message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_set_chat_on_top message, length delimited. Does not implicitly {@link net.msg_set_chat_on_top.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {net.Imsg_set_chat_on_top} message msg_set_chat_on_top message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_chat_on_top message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_chat_on_top} msg_set_chat_on_top
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_chat_on_top();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_chat_on_top message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_chat_on_top} msg_set_chat_on_top
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_chat_on_top message.
         * @function verify
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_chat_on_top.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_chat_on_top message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_chat_on_top} msg_set_chat_on_top
         */
        msg_set_chat_on_top.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_chat_on_top)
                return object;
            var message = new $root.net.msg_set_chat_on_top();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_chat_on_top message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {net.msg_set_chat_on_top} message msg_set_chat_on_top
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_chat_on_top.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_set_chat_on_top to JSON.
         * @function toJSON
         * @memberof net.msg_set_chat_on_top
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_chat_on_top.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_chat_on_top;
    })();

    net.msg_set_chat_on_top_rep = (function() {

        /**
         * Properties of a msg_set_chat_on_top_rep.
         * @memberof net
         * @interface Imsg_set_chat_on_top_rep
         * @property {number|null} [result] msg_set_chat_on_top_rep result
         * @property {number|Long|null} [chatkey] msg_set_chat_on_top_rep chatkey
         * @property {number|null} [opertype] msg_set_chat_on_top_rep opertype
         * @property {number|null} [opertime] msg_set_chat_on_top_rep opertime
         */

        /**
         * Constructs a new msg_set_chat_on_top_rep.
         * @memberof net
         * @classdesc Represents a msg_set_chat_on_top_rep.
         * @implements Imsg_set_chat_on_top_rep
         * @constructor
         * @param {net.Imsg_set_chat_on_top_rep=} [properties] Properties to set
         */
        function msg_set_chat_on_top_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_chat_on_top_rep result.
         * @member {number} result
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.result = 0;

        /**
         * msg_set_chat_on_top_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_chat_on_top_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.opertype = 0;

        /**
         * msg_set_chat_on_top_rep opertime.
         * @member {number} opertime
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.opertime = 0;

        /**
         * Creates a new msg_set_chat_on_top_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {net.Imsg_set_chat_on_top_rep=} [properties] Properties to set
         * @returns {net.msg_set_chat_on_top_rep} msg_set_chat_on_top_rep instance
         */
        msg_set_chat_on_top_rep.create = function create(properties) {
            return new msg_set_chat_on_top_rep(properties);
        };

        /**
         * Encodes the specified msg_set_chat_on_top_rep message. Does not implicitly {@link net.msg_set_chat_on_top_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {net.Imsg_set_chat_on_top_rep} message msg_set_chat_on_top_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            if (message.opertime != null && Object.hasOwnProperty.call(message, "opertime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.opertime);
            return writer;
        };

        /**
         * Encodes the specified msg_set_chat_on_top_rep message, length delimited. Does not implicitly {@link net.msg_set_chat_on_top_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {net.Imsg_set_chat_on_top_rep} message msg_set_chat_on_top_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_chat_on_top_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_chat_on_top_rep} msg_set_chat_on_top_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_chat_on_top_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                case 4:
                    message.opertime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_chat_on_top_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_chat_on_top_rep} msg_set_chat_on_top_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_chat_on_top_rep message.
         * @function verify
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_chat_on_top_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            if (message.opertime != null && message.hasOwnProperty("opertime"))
                if (!$util.isInteger(message.opertime))
                    return "opertime: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_chat_on_top_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_chat_on_top_rep} msg_set_chat_on_top_rep
         */
        msg_set_chat_on_top_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_chat_on_top_rep)
                return object;
            var message = new $root.net.msg_set_chat_on_top_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            if (object.opertime != null)
                message.opertime = object.opertime | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_chat_on_top_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {net.msg_set_chat_on_top_rep} message msg_set_chat_on_top_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_chat_on_top_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
                object.opertime = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            if (message.opertime != null && message.hasOwnProperty("opertime"))
                object.opertime = message.opertime;
            return object;
        };

        /**
         * Converts this msg_set_chat_on_top_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_chat_on_top_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_chat_on_top_rep;
    })();

    net.msg_get_mute_notify_list = (function() {

        /**
         * Properties of a msg_get_mute_notify_list.
         * @memberof net
         * @interface Imsg_get_mute_notify_list
         */

        /**
         * Constructs a new msg_get_mute_notify_list.
         * @memberof net
         * @classdesc Represents a msg_get_mute_notify_list.
         * @implements Imsg_get_mute_notify_list
         * @constructor
         * @param {net.Imsg_get_mute_notify_list=} [properties] Properties to set
         */
        function msg_get_mute_notify_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_mute_notify_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {net.Imsg_get_mute_notify_list=} [properties] Properties to set
         * @returns {net.msg_get_mute_notify_list} msg_get_mute_notify_list instance
         */
        msg_get_mute_notify_list.create = function create(properties) {
            return new msg_get_mute_notify_list(properties);
        };

        /**
         * Encodes the specified msg_get_mute_notify_list message. Does not implicitly {@link net.msg_get_mute_notify_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {net.Imsg_get_mute_notify_list} message msg_get_mute_notify_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_mute_notify_list message, length delimited. Does not implicitly {@link net.msg_get_mute_notify_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {net.Imsg_get_mute_notify_list} message msg_get_mute_notify_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_mute_notify_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_mute_notify_list} msg_get_mute_notify_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_mute_notify_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_mute_notify_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_mute_notify_list} msg_get_mute_notify_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_mute_notify_list message.
         * @function verify
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_mute_notify_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_mute_notify_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_mute_notify_list} msg_get_mute_notify_list
         */
        msg_get_mute_notify_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_mute_notify_list)
                return object;
            return new $root.net.msg_get_mute_notify_list();
        };

        /**
         * Creates a plain object from a msg_get_mute_notify_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {net.msg_get_mute_notify_list} message msg_get_mute_notify_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_mute_notify_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_mute_notify_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_mute_notify_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_mute_notify_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_mute_notify_list;
    })();

    net.msg_get_mute_notify_list_rep = (function() {

        /**
         * Properties of a msg_get_mute_notify_list_rep.
         * @memberof net
         * @interface Imsg_get_mute_notify_list_rep
         * @property {Array.<net.Ioper_chatkey_info>|null} [chatkeys] msg_get_mute_notify_list_rep chatkeys
         */

        /**
         * Constructs a new msg_get_mute_notify_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_mute_notify_list_rep.
         * @implements Imsg_get_mute_notify_list_rep
         * @constructor
         * @param {net.Imsg_get_mute_notify_list_rep=} [properties] Properties to set
         */
        function msg_get_mute_notify_list_rep(properties) {
            this.chatkeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_mute_notify_list_rep chatkeys.
         * @member {Array.<net.Ioper_chatkey_info>} chatkeys
         * @memberof net.msg_get_mute_notify_list_rep
         * @instance
         */
        msg_get_mute_notify_list_rep.prototype.chatkeys = $util.emptyArray;

        /**
         * Creates a new msg_get_mute_notify_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {net.Imsg_get_mute_notify_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_mute_notify_list_rep} msg_get_mute_notify_list_rep instance
         */
        msg_get_mute_notify_list_rep.create = function create(properties) {
            return new msg_get_mute_notify_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_mute_notify_list_rep message. Does not implicitly {@link net.msg_get_mute_notify_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {net.Imsg_get_mute_notify_list_rep} message msg_get_mute_notify_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkeys != null && message.chatkeys.length)
                for (var i = 0; i < message.chatkeys.length; ++i)
                    $root.net.oper_chatkey_info.encode(message.chatkeys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_mute_notify_list_rep message, length delimited. Does not implicitly {@link net.msg_get_mute_notify_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {net.Imsg_get_mute_notify_list_rep} message msg_get_mute_notify_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_mute_notify_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_mute_notify_list_rep} msg_get_mute_notify_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_mute_notify_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.chatkeys && message.chatkeys.length))
                        message.chatkeys = [];
                    message.chatkeys.push($root.net.oper_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_mute_notify_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_mute_notify_list_rep} msg_get_mute_notify_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_mute_notify_list_rep message.
         * @function verify
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_mute_notify_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkeys != null && message.hasOwnProperty("chatkeys")) {
                if (!Array.isArray(message.chatkeys))
                    return "chatkeys: array expected";
                for (var i = 0; i < message.chatkeys.length; ++i) {
                    var error = $root.net.oper_chatkey_info.verify(message.chatkeys[i]);
                    if (error)
                        return "chatkeys." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_mute_notify_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_mute_notify_list_rep} msg_get_mute_notify_list_rep
         */
        msg_get_mute_notify_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_mute_notify_list_rep)
                return object;
            var message = new $root.net.msg_get_mute_notify_list_rep();
            if (object.chatkeys) {
                if (!Array.isArray(object.chatkeys))
                    throw TypeError(".net.msg_get_mute_notify_list_rep.chatkeys: array expected");
                message.chatkeys = [];
                for (var i = 0; i < object.chatkeys.length; ++i) {
                    if (typeof object.chatkeys[i] !== "object")
                        throw TypeError(".net.msg_get_mute_notify_list_rep.chatkeys: object expected");
                    message.chatkeys[i] = $root.net.oper_chatkey_info.fromObject(object.chatkeys[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_mute_notify_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {net.msg_get_mute_notify_list_rep} message msg_get_mute_notify_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_mute_notify_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatkeys = [];
            if (message.chatkeys && message.chatkeys.length) {
                object.chatkeys = [];
                for (var j = 0; j < message.chatkeys.length; ++j)
                    object.chatkeys[j] = $root.net.oper_chatkey_info.toObject(message.chatkeys[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_mute_notify_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_mute_notify_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_mute_notify_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_mute_notify_list_rep;
    })();

    net.msg_get_chat_on_top_list = (function() {

        /**
         * Properties of a msg_get_chat_on_top_list.
         * @memberof net
         * @interface Imsg_get_chat_on_top_list
         */

        /**
         * Constructs a new msg_get_chat_on_top_list.
         * @memberof net
         * @classdesc Represents a msg_get_chat_on_top_list.
         * @implements Imsg_get_chat_on_top_list
         * @constructor
         * @param {net.Imsg_get_chat_on_top_list=} [properties] Properties to set
         */
        function msg_get_chat_on_top_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_chat_on_top_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {net.Imsg_get_chat_on_top_list=} [properties] Properties to set
         * @returns {net.msg_get_chat_on_top_list} msg_get_chat_on_top_list instance
         */
        msg_get_chat_on_top_list.create = function create(properties) {
            return new msg_get_chat_on_top_list(properties);
        };

        /**
         * Encodes the specified msg_get_chat_on_top_list message. Does not implicitly {@link net.msg_get_chat_on_top_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {net.Imsg_get_chat_on_top_list} message msg_get_chat_on_top_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chat_on_top_list message, length delimited. Does not implicitly {@link net.msg_get_chat_on_top_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {net.Imsg_get_chat_on_top_list} message msg_get_chat_on_top_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chat_on_top_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chat_on_top_list} msg_get_chat_on_top_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chat_on_top_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chat_on_top_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chat_on_top_list} msg_get_chat_on_top_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chat_on_top_list message.
         * @function verify
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chat_on_top_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_chat_on_top_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chat_on_top_list} msg_get_chat_on_top_list
         */
        msg_get_chat_on_top_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chat_on_top_list)
                return object;
            return new $root.net.msg_get_chat_on_top_list();
        };

        /**
         * Creates a plain object from a msg_get_chat_on_top_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {net.msg_get_chat_on_top_list} message msg_get_chat_on_top_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chat_on_top_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_chat_on_top_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_chat_on_top_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chat_on_top_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chat_on_top_list;
    })();

    net.msg_get_chat_on_top_list_rep = (function() {

        /**
         * Properties of a msg_get_chat_on_top_list_rep.
         * @memberof net
         * @interface Imsg_get_chat_on_top_list_rep
         * @property {Array.<net.Ioper_chatkey_info>|null} [chatkeys] msg_get_chat_on_top_list_rep chatkeys
         */

        /**
         * Constructs a new msg_get_chat_on_top_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chat_on_top_list_rep.
         * @implements Imsg_get_chat_on_top_list_rep
         * @constructor
         * @param {net.Imsg_get_chat_on_top_list_rep=} [properties] Properties to set
         */
        function msg_get_chat_on_top_list_rep(properties) {
            this.chatkeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chat_on_top_list_rep chatkeys.
         * @member {Array.<net.Ioper_chatkey_info>} chatkeys
         * @memberof net.msg_get_chat_on_top_list_rep
         * @instance
         */
        msg_get_chat_on_top_list_rep.prototype.chatkeys = $util.emptyArray;

        /**
         * Creates a new msg_get_chat_on_top_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {net.Imsg_get_chat_on_top_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_chat_on_top_list_rep} msg_get_chat_on_top_list_rep instance
         */
        msg_get_chat_on_top_list_rep.create = function create(properties) {
            return new msg_get_chat_on_top_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_chat_on_top_list_rep message. Does not implicitly {@link net.msg_get_chat_on_top_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {net.Imsg_get_chat_on_top_list_rep} message msg_get_chat_on_top_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkeys != null && message.chatkeys.length)
                for (var i = 0; i < message.chatkeys.length; ++i)
                    $root.net.oper_chatkey_info.encode(message.chatkeys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chat_on_top_list_rep message, length delimited. Does not implicitly {@link net.msg_get_chat_on_top_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {net.Imsg_get_chat_on_top_list_rep} message msg_get_chat_on_top_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chat_on_top_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chat_on_top_list_rep} msg_get_chat_on_top_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chat_on_top_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.chatkeys && message.chatkeys.length))
                        message.chatkeys = [];
                    message.chatkeys.push($root.net.oper_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chat_on_top_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chat_on_top_list_rep} msg_get_chat_on_top_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chat_on_top_list_rep message.
         * @function verify
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chat_on_top_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkeys != null && message.hasOwnProperty("chatkeys")) {
                if (!Array.isArray(message.chatkeys))
                    return "chatkeys: array expected";
                for (var i = 0; i < message.chatkeys.length; ++i) {
                    var error = $root.net.oper_chatkey_info.verify(message.chatkeys[i]);
                    if (error)
                        return "chatkeys." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_chat_on_top_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chat_on_top_list_rep} msg_get_chat_on_top_list_rep
         */
        msg_get_chat_on_top_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chat_on_top_list_rep)
                return object;
            var message = new $root.net.msg_get_chat_on_top_list_rep();
            if (object.chatkeys) {
                if (!Array.isArray(object.chatkeys))
                    throw TypeError(".net.msg_get_chat_on_top_list_rep.chatkeys: array expected");
                message.chatkeys = [];
                for (var i = 0; i < object.chatkeys.length; ++i) {
                    if (typeof object.chatkeys[i] !== "object")
                        throw TypeError(".net.msg_get_chat_on_top_list_rep.chatkeys: object expected");
                    message.chatkeys[i] = $root.net.oper_chatkey_info.fromObject(object.chatkeys[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chat_on_top_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {net.msg_get_chat_on_top_list_rep} message msg_get_chat_on_top_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chat_on_top_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatkeys = [];
            if (message.chatkeys && message.chatkeys.length) {
                object.chatkeys = [];
                for (var j = 0; j < message.chatkeys.length; ++j)
                    object.chatkeys[j] = $root.net.oper_chatkey_info.toObject(message.chatkeys[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_chat_on_top_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_chat_on_top_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chat_on_top_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chat_on_top_list_rep;
    })();

    net.msg_del_chat_msg = (function() {

        /**
         * Properties of a msg_del_chat_msg.
         * @memberof net
         * @interface Imsg_del_chat_msg
         * @property {number|Long|null} [chatkey] msg_del_chat_msg chatkey
         */

        /**
         * Constructs a new msg_del_chat_msg.
         * @memberof net
         * @classdesc Represents a msg_del_chat_msg.
         * @implements Imsg_del_chat_msg
         * @constructor
         * @param {net.Imsg_del_chat_msg=} [properties] Properties to set
         */
        function msg_del_chat_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chat_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_del_chat_msg
         * @instance
         */
        msg_del_chat_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_del_chat_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {net.Imsg_del_chat_msg=} [properties] Properties to set
         * @returns {net.msg_del_chat_msg} msg_del_chat_msg instance
         */
        msg_del_chat_msg.create = function create(properties) {
            return new msg_del_chat_msg(properties);
        };

        /**
         * Encodes the specified msg_del_chat_msg message. Does not implicitly {@link net.msg_del_chat_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {net.Imsg_del_chat_msg} message msg_del_chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            return writer;
        };

        /**
         * Encodes the specified msg_del_chat_msg message, length delimited. Does not implicitly {@link net.msg_del_chat_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {net.Imsg_del_chat_msg} message msg_del_chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_chat_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chat_msg} msg_del_chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chat_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_chat_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_chat_msg} msg_del_chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_chat_msg message.
         * @function verify
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_chat_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_del_chat_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_chat_msg} msg_del_chat_msg
         */
        msg_del_chat_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_chat_msg)
                return object;
            var message = new $root.net.msg_del_chat_msg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_del_chat_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {net.msg_del_chat_msg} message msg_del_chat_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_chat_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            return object;
        };

        /**
         * Converts this msg_del_chat_msg to JSON.
         * @function toJSON
         * @memberof net.msg_del_chat_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_chat_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_chat_msg;
    })();

    net.msg_del_chat_msg_rep = (function() {

        /**
         * Properties of a msg_del_chat_msg_rep.
         * @memberof net
         * @interface Imsg_del_chat_msg_rep
         * @property {number|null} [result] msg_del_chat_msg_rep result
         * @property {number|Long|null} [chatkey] msg_del_chat_msg_rep chatkey
         * @property {number|null} [chatmsgno] msg_del_chat_msg_rep chatmsgno
         * @property {number|null} [uid] msg_del_chat_msg_rep uid
         */

        /**
         * Constructs a new msg_del_chat_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_del_chat_msg_rep.
         * @implements Imsg_del_chat_msg_rep
         * @constructor
         * @param {net.Imsg_del_chat_msg_rep=} [properties] Properties to set
         */
        function msg_del_chat_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chat_msg_rep result.
         * @member {number} result
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.result = 0;

        /**
         * msg_del_chat_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_del_chat_msg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.chatmsgno = 0;

        /**
         * msg_del_chat_msg_rep uid.
         * @member {number} uid
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.uid = 0;

        /**
         * Creates a new msg_del_chat_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {net.Imsg_del_chat_msg_rep=} [properties] Properties to set
         * @returns {net.msg_del_chat_msg_rep} msg_del_chat_msg_rep instance
         */
        msg_del_chat_msg_rep.create = function create(properties) {
            return new msg_del_chat_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_del_chat_msg_rep message. Does not implicitly {@link net.msg_del_chat_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {net.Imsg_del_chat_msg_rep} message msg_del_chat_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_del_chat_msg_rep message, length delimited. Does not implicitly {@link net.msg_del_chat_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {net.Imsg_del_chat_msg_rep} message msg_del_chat_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_chat_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chat_msg_rep} msg_del_chat_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chat_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_chat_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_chat_msg_rep} msg_del_chat_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_chat_msg_rep message.
         * @function verify
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_chat_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_del_chat_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_chat_msg_rep} msg_del_chat_msg_rep
         */
        msg_del_chat_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_chat_msg_rep)
                return object;
            var message = new $root.net.msg_del_chat_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_del_chat_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {net.msg_del_chat_msg_rep} message msg_del_chat_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_chat_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
                object.uid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_del_chat_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_chat_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_chat_msg_rep;
    })();

    net.msg_confirm_del_msg = (function() {

        /**
         * Properties of a msg_confirm_del_msg.
         * @memberof net
         * @interface Imsg_confirm_del_msg
         * @property {number|Long|null} [chatkey] msg_confirm_del_msg chatkey
         * @property {number|null} [chatmsgno] msg_confirm_del_msg chatmsgno
         */

        /**
         * Constructs a new msg_confirm_del_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_del_msg.
         * @implements Imsg_confirm_del_msg
         * @constructor
         * @param {net.Imsg_confirm_del_msg=} [properties] Properties to set
         */
        function msg_confirm_del_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_del_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_del_msg
         * @instance
         */
        msg_confirm_del_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_del_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_del_msg
         * @instance
         */
        msg_confirm_del_msg.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_confirm_del_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {net.Imsg_confirm_del_msg=} [properties] Properties to set
         * @returns {net.msg_confirm_del_msg} msg_confirm_del_msg instance
         */
        msg_confirm_del_msg.create = function create(properties) {
            return new msg_confirm_del_msg(properties);
        };

        /**
         * Encodes the specified msg_confirm_del_msg message. Does not implicitly {@link net.msg_confirm_del_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {net.Imsg_confirm_del_msg} message msg_confirm_del_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_del_msg message, length delimited. Does not implicitly {@link net.msg_confirm_del_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {net.Imsg_confirm_del_msg} message msg_confirm_del_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_del_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_del_msg} msg_confirm_del_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_del_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_del_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_del_msg} msg_confirm_del_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_del_msg message.
         * @function verify
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_del_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_del_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_del_msg} msg_confirm_del_msg
         */
        msg_confirm_del_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_del_msg)
                return object;
            var message = new $root.net.msg_confirm_del_msg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_del_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {net.msg_confirm_del_msg} message msg_confirm_del_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_del_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_confirm_del_msg to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_del_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_del_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_del_msg;
    })();

    net.msg_confirm_del_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_del_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_del_msg_rep
         * @property {number|null} [result] msg_confirm_del_msg_rep result
         * @property {number|Long|null} [chatkey] msg_confirm_del_msg_rep chatkey
         * @property {number|null} [chatmsgno] msg_confirm_del_msg_rep chatmsgno
         */

        /**
         * Constructs a new msg_confirm_del_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_del_msg_rep.
         * @implements Imsg_confirm_del_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_del_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_del_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_del_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.result = 0;

        /**
         * msg_confirm_del_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_del_msg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_confirm_del_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {net.Imsg_confirm_del_msg_rep=} [properties] Properties to set
         * @returns {net.msg_confirm_del_msg_rep} msg_confirm_del_msg_rep instance
         */
        msg_confirm_del_msg_rep.create = function create(properties) {
            return new msg_confirm_del_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_confirm_del_msg_rep message. Does not implicitly {@link net.msg_confirm_del_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {net.Imsg_confirm_del_msg_rep} message msg_confirm_del_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_del_msg_rep message, length delimited. Does not implicitly {@link net.msg_confirm_del_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {net.Imsg_confirm_del_msg_rep} message msg_confirm_del_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_del_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_del_msg_rep} msg_confirm_del_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_del_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_del_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_del_msg_rep} msg_confirm_del_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_del_msg_rep message.
         * @function verify
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_del_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_del_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_del_msg_rep} msg_confirm_del_msg_rep
         */
        msg_confirm_del_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_del_msg_rep)
                return object;
            var message = new $root.net.msg_confirm_del_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_del_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {net.msg_confirm_del_msg_rep} message msg_confirm_del_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_del_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_confirm_del_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_del_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_del_msg_rep;
    })();

    net.msg_get_offline_data = (function() {

        /**
         * Properties of a msg_get_offline_data.
         * @memberof net
         * @interface Imsg_get_offline_data
         */

        /**
         * Constructs a new msg_get_offline_data.
         * @memberof net
         * @classdesc Represents a msg_get_offline_data.
         * @implements Imsg_get_offline_data
         * @constructor
         * @param {net.Imsg_get_offline_data=} [properties] Properties to set
         */
        function msg_get_offline_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_offline_data instance using the specified properties.
         * @function create
         * @memberof net.msg_get_offline_data
         * @static
         * @param {net.Imsg_get_offline_data=} [properties] Properties to set
         * @returns {net.msg_get_offline_data} msg_get_offline_data instance
         */
        msg_get_offline_data.create = function create(properties) {
            return new msg_get_offline_data(properties);
        };

        /**
         * Encodes the specified msg_get_offline_data message. Does not implicitly {@link net.msg_get_offline_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_offline_data
         * @static
         * @param {net.Imsg_get_offline_data} message msg_get_offline_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_offline_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_offline_data message, length delimited. Does not implicitly {@link net.msg_get_offline_data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_offline_data
         * @static
         * @param {net.Imsg_get_offline_data} message msg_get_offline_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_offline_data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_offline_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_offline_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_offline_data} msg_get_offline_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_offline_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_offline_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_offline_data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_offline_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_offline_data} msg_get_offline_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_offline_data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_offline_data message.
         * @function verify
         * @memberof net.msg_get_offline_data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_offline_data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_offline_data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_offline_data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_offline_data} msg_get_offline_data
         */
        msg_get_offline_data.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_offline_data)
                return object;
            return new $root.net.msg_get_offline_data();
        };

        /**
         * Creates a plain object from a msg_get_offline_data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_offline_data
         * @static
         * @param {net.msg_get_offline_data} message msg_get_offline_data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_offline_data.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_offline_data to JSON.
         * @function toJSON
         * @memberof net.msg_get_offline_data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_offline_data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_offline_data;
    })();

    net.msg_get_offline_data_rep = (function() {

        /**
         * Properties of a msg_get_offline_data_rep.
         * @memberof net
         * @interface Imsg_get_offline_data_rep
         */

        /**
         * Constructs a new msg_get_offline_data_rep.
         * @memberof net
         * @classdesc Represents a msg_get_offline_data_rep.
         * @implements Imsg_get_offline_data_rep
         * @constructor
         * @param {net.Imsg_get_offline_data_rep=} [properties] Properties to set
         */
        function msg_get_offline_data_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_offline_data_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {net.Imsg_get_offline_data_rep=} [properties] Properties to set
         * @returns {net.msg_get_offline_data_rep} msg_get_offline_data_rep instance
         */
        msg_get_offline_data_rep.create = function create(properties) {
            return new msg_get_offline_data_rep(properties);
        };

        /**
         * Encodes the specified msg_get_offline_data_rep message. Does not implicitly {@link net.msg_get_offline_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {net.Imsg_get_offline_data_rep} message msg_get_offline_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_offline_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_offline_data_rep message, length delimited. Does not implicitly {@link net.msg_get_offline_data_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {net.Imsg_get_offline_data_rep} message msg_get_offline_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_offline_data_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_offline_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_offline_data_rep} msg_get_offline_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_offline_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_offline_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_offline_data_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_offline_data_rep} msg_get_offline_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_offline_data_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_offline_data_rep message.
         * @function verify
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_offline_data_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_offline_data_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_offline_data_rep} msg_get_offline_data_rep
         */
        msg_get_offline_data_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_offline_data_rep)
                return object;
            return new $root.net.msg_get_offline_data_rep();
        };

        /**
         * Creates a plain object from a msg_get_offline_data_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_offline_data_rep
         * @static
         * @param {net.msg_get_offline_data_rep} message msg_get_offline_data_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_offline_data_rep.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_offline_data_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_offline_data_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_offline_data_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_offline_data_rep;
    })();

    net.msg_delete_friend = (function() {

        /**
         * Properties of a msg_delete_friend.
         * @memberof net
         * @interface Imsg_delete_friend
         * @property {number|null} [frienduid] msg_delete_friend frienduid
         */

        /**
         * Constructs a new msg_delete_friend.
         * @memberof net
         * @classdesc Represents a msg_delete_friend.
         * @implements Imsg_delete_friend
         * @constructor
         * @param {net.Imsg_delete_friend=} [properties] Properties to set
         */
        function msg_delete_friend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_delete_friend frienduid.
         * @member {number} frienduid
         * @memberof net.msg_delete_friend
         * @instance
         */
        msg_delete_friend.prototype.frienduid = 0;

        /**
         * Creates a new msg_delete_friend instance using the specified properties.
         * @function create
         * @memberof net.msg_delete_friend
         * @static
         * @param {net.Imsg_delete_friend=} [properties] Properties to set
         * @returns {net.msg_delete_friend} msg_delete_friend instance
         */
        msg_delete_friend.create = function create(properties) {
            return new msg_delete_friend(properties);
        };

        /**
         * Encodes the specified msg_delete_friend message. Does not implicitly {@link net.msg_delete_friend.verify|verify} messages.
         * @function encode
         * @memberof net.msg_delete_friend
         * @static
         * @param {net.Imsg_delete_friend} message msg_delete_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.frienduid != null && Object.hasOwnProperty.call(message, "frienduid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.frienduid);
            return writer;
        };

        /**
         * Encodes the specified msg_delete_friend message, length delimited. Does not implicitly {@link net.msg_delete_friend.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_delete_friend
         * @static
         * @param {net.Imsg_delete_friend} message msg_delete_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_delete_friend message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_delete_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_delete_friend} msg_delete_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_delete_friend();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.frienduid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_delete_friend message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_delete_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_delete_friend} msg_delete_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_delete_friend message.
         * @function verify
         * @memberof net.msg_delete_friend
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_delete_friend.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.frienduid != null && message.hasOwnProperty("frienduid"))
                if (!$util.isInteger(message.frienduid))
                    return "frienduid: integer expected";
            return null;
        };

        /**
         * Creates a msg_delete_friend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_delete_friend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_delete_friend} msg_delete_friend
         */
        msg_delete_friend.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_delete_friend)
                return object;
            var message = new $root.net.msg_delete_friend();
            if (object.frienduid != null)
                message.frienduid = object.frienduid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_delete_friend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_delete_friend
         * @static
         * @param {net.msg_delete_friend} message msg_delete_friend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_delete_friend.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.frienduid = 0;
            if (message.frienduid != null && message.hasOwnProperty("frienduid"))
                object.frienduid = message.frienduid;
            return object;
        };

        /**
         * Converts this msg_delete_friend to JSON.
         * @function toJSON
         * @memberof net.msg_delete_friend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_delete_friend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_delete_friend;
    })();

    net.msg_delete_friend_rep = (function() {

        /**
         * Properties of a msg_delete_friend_rep.
         * @memberof net
         * @interface Imsg_delete_friend_rep
         * @property {number|null} [result] msg_delete_friend_rep result
         * @property {number|null} [frienduid] msg_delete_friend_rep frienduid
         */

        /**
         * Constructs a new msg_delete_friend_rep.
         * @memberof net
         * @classdesc Represents a msg_delete_friend_rep.
         * @implements Imsg_delete_friend_rep
         * @constructor
         * @param {net.Imsg_delete_friend_rep=} [properties] Properties to set
         */
        function msg_delete_friend_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_delete_friend_rep result.
         * @member {number} result
         * @memberof net.msg_delete_friend_rep
         * @instance
         */
        msg_delete_friend_rep.prototype.result = 0;

        /**
         * msg_delete_friend_rep frienduid.
         * @member {number} frienduid
         * @memberof net.msg_delete_friend_rep
         * @instance
         */
        msg_delete_friend_rep.prototype.frienduid = 0;

        /**
         * Creates a new msg_delete_friend_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {net.Imsg_delete_friend_rep=} [properties] Properties to set
         * @returns {net.msg_delete_friend_rep} msg_delete_friend_rep instance
         */
        msg_delete_friend_rep.create = function create(properties) {
            return new msg_delete_friend_rep(properties);
        };

        /**
         * Encodes the specified msg_delete_friend_rep message. Does not implicitly {@link net.msg_delete_friend_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {net.Imsg_delete_friend_rep} message msg_delete_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.frienduid != null && Object.hasOwnProperty.call(message, "frienduid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.frienduid);
            return writer;
        };

        /**
         * Encodes the specified msg_delete_friend_rep message, length delimited. Does not implicitly {@link net.msg_delete_friend_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {net.Imsg_delete_friend_rep} message msg_delete_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_delete_friend_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_delete_friend_rep} msg_delete_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_delete_friend_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.frienduid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_delete_friend_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_delete_friend_rep} msg_delete_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_delete_friend_rep message.
         * @function verify
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_delete_friend_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.frienduid != null && message.hasOwnProperty("frienduid"))
                if (!$util.isInteger(message.frienduid))
                    return "frienduid: integer expected";
            return null;
        };

        /**
         * Creates a msg_delete_friend_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_delete_friend_rep} msg_delete_friend_rep
         */
        msg_delete_friend_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_delete_friend_rep)
                return object;
            var message = new $root.net.msg_delete_friend_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.frienduid != null)
                message.frienduid = object.frienduid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_delete_friend_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {net.msg_delete_friend_rep} message msg_delete_friend_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_delete_friend_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.frienduid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.frienduid != null && message.hasOwnProperty("frienduid"))
                object.frienduid = message.frienduid;
            return object;
        };

        /**
         * Converts this msg_delete_friend_rep to JSON.
         * @function toJSON
         * @memberof net.msg_delete_friend_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_delete_friend_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_delete_friend_rep;
    })();

    net.msg_set_alias = (function() {

        /**
         * Properties of a msg_set_alias.
         * @memberof net
         * @interface Imsg_set_alias
         * @property {number|null} [fuid] msg_set_alias fuid
         * @property {Uint8Array|null} [alias] msg_set_alias alias
         */

        /**
         * Constructs a new msg_set_alias.
         * @memberof net
         * @classdesc Represents a msg_set_alias.
         * @implements Imsg_set_alias
         * @constructor
         * @param {net.Imsg_set_alias=} [properties] Properties to set
         */
        function msg_set_alias(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_alias fuid.
         * @member {number} fuid
         * @memberof net.msg_set_alias
         * @instance
         */
        msg_set_alias.prototype.fuid = 0;

        /**
         * msg_set_alias alias.
         * @member {Uint8Array} alias
         * @memberof net.msg_set_alias
         * @instance
         */
        msg_set_alias.prototype.alias = $util.newBuffer([]);

        /**
         * Creates a new msg_set_alias instance using the specified properties.
         * @function create
         * @memberof net.msg_set_alias
         * @static
         * @param {net.Imsg_set_alias=} [properties] Properties to set
         * @returns {net.msg_set_alias} msg_set_alias instance
         */
        msg_set_alias.create = function create(properties) {
            return new msg_set_alias(properties);
        };

        /**
         * Encodes the specified msg_set_alias message. Does not implicitly {@link net.msg_set_alias.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_alias
         * @static
         * @param {net.Imsg_set_alias} message msg_set_alias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.alias);
            return writer;
        };

        /**
         * Encodes the specified msg_set_alias message, length delimited. Does not implicitly {@link net.msg_set_alias.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_alias
         * @static
         * @param {net.Imsg_set_alias} message msg_set_alias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_alias message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_alias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_alias} msg_set_alias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_alias();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.alias = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_alias message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_alias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_alias} msg_set_alias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_alias message.
         * @function verify
         * @memberof net.msg_set_alias
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_alias.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                if (!$util.isInteger(message.fuid))
                    return "fuid: integer expected";
            if (message.alias != null && message.hasOwnProperty("alias"))
                if (!(message.alias && typeof message.alias.length === "number" || $util.isString(message.alias)))
                    return "alias: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_alias message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_alias
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_alias} msg_set_alias
         */
        msg_set_alias.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_alias)
                return object;
            var message = new $root.net.msg_set_alias();
            if (object.fuid != null)
                message.fuid = object.fuid | 0;
            if (object.alias != null)
                if (typeof object.alias === "string")
                    $util.base64.decode(object.alias, message.alias = $util.newBuffer($util.base64.length(object.alias)), 0);
                else if (object.alias.length)
                    message.alias = object.alias;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_alias message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_alias
         * @static
         * @param {net.msg_set_alias} message msg_set_alias
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_alias.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fuid = 0;
                if (options.bytes === String)
                    object.alias = "";
                else {
                    object.alias = [];
                    if (options.bytes !== Array)
                        object.alias = $util.newBuffer(object.alias);
                }
            }
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                object.fuid = message.fuid;
            if (message.alias != null && message.hasOwnProperty("alias"))
                object.alias = options.bytes === String ? $util.base64.encode(message.alias, 0, message.alias.length) : options.bytes === Array ? Array.prototype.slice.call(message.alias) : message.alias;
            return object;
        };

        /**
         * Converts this msg_set_alias to JSON.
         * @function toJSON
         * @memberof net.msg_set_alias
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_alias.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_alias;
    })();

    net.msg_set_alias_rep = (function() {

        /**
         * Properties of a msg_set_alias_rep.
         * @memberof net
         * @interface Imsg_set_alias_rep
         * @property {number|null} [result] msg_set_alias_rep result
         * @property {number|null} [fuid] msg_set_alias_rep fuid
         * @property {Uint8Array|null} [alias] msg_set_alias_rep alias
         */

        /**
         * Constructs a new msg_set_alias_rep.
         * @memberof net
         * @classdesc Represents a msg_set_alias_rep.
         * @implements Imsg_set_alias_rep
         * @constructor
         * @param {net.Imsg_set_alias_rep=} [properties] Properties to set
         */
        function msg_set_alias_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_alias_rep result.
         * @member {number} result
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.result = 0;

        /**
         * msg_set_alias_rep fuid.
         * @member {number} fuid
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.fuid = 0;

        /**
         * msg_set_alias_rep alias.
         * @member {Uint8Array} alias
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.alias = $util.newBuffer([]);

        /**
         * Creates a new msg_set_alias_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {net.Imsg_set_alias_rep=} [properties] Properties to set
         * @returns {net.msg_set_alias_rep} msg_set_alias_rep instance
         */
        msg_set_alias_rep.create = function create(properties) {
            return new msg_set_alias_rep(properties);
        };

        /**
         * Encodes the specified msg_set_alias_rep message. Does not implicitly {@link net.msg_set_alias_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {net.Imsg_set_alias_rep} message msg_set_alias_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.fuid);
            if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.alias);
            return writer;
        };

        /**
         * Encodes the specified msg_set_alias_rep message, length delimited. Does not implicitly {@link net.msg_set_alias_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {net.Imsg_set_alias_rep} message msg_set_alias_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_alias_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_alias_rep} msg_set_alias_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_alias_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.fuid = reader.int32();
                    break;
                case 3:
                    message.alias = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_alias_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_alias_rep} msg_set_alias_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_alias_rep message.
         * @function verify
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_alias_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                if (!$util.isInteger(message.fuid))
                    return "fuid: integer expected";
            if (message.alias != null && message.hasOwnProperty("alias"))
                if (!(message.alias && typeof message.alias.length === "number" || $util.isString(message.alias)))
                    return "alias: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_alias_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_alias_rep} msg_set_alias_rep
         */
        msg_set_alias_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_alias_rep)
                return object;
            var message = new $root.net.msg_set_alias_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.fuid != null)
                message.fuid = object.fuid | 0;
            if (object.alias != null)
                if (typeof object.alias === "string")
                    $util.base64.decode(object.alias, message.alias = $util.newBuffer($util.base64.length(object.alias)), 0);
                else if (object.alias.length)
                    message.alias = object.alias;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_alias_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {net.msg_set_alias_rep} message msg_set_alias_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_alias_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.fuid = 0;
                if (options.bytes === String)
                    object.alias = "";
                else {
                    object.alias = [];
                    if (options.bytes !== Array)
                        object.alias = $util.newBuffer(object.alias);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.fuid != null && message.hasOwnProperty("fuid"))
                object.fuid = message.fuid;
            if (message.alias != null && message.hasOwnProperty("alias"))
                object.alias = options.bytes === String ? $util.base64.encode(message.alias, 0, message.alias.length) : options.bytes === Array ? Array.prototype.slice.call(message.alias) : message.alias;
            return object;
        };

        /**
         * Converts this msg_set_alias_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_alias_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_alias_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_alias_rep;
    })();

    net.msg_getalias_list = (function() {

        /**
         * Properties of a msg_getalias_list.
         * @memberof net
         * @interface Imsg_getalias_list
         */

        /**
         * Constructs a new msg_getalias_list.
         * @memberof net
         * @classdesc Represents a msg_getalias_list.
         * @implements Imsg_getalias_list
         * @constructor
         * @param {net.Imsg_getalias_list=} [properties] Properties to set
         */
        function msg_getalias_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_getalias_list instance using the specified properties.
         * @function create
         * @memberof net.msg_getalias_list
         * @static
         * @param {net.Imsg_getalias_list=} [properties] Properties to set
         * @returns {net.msg_getalias_list} msg_getalias_list instance
         */
        msg_getalias_list.create = function create(properties) {
            return new msg_getalias_list(properties);
        };

        /**
         * Encodes the specified msg_getalias_list message. Does not implicitly {@link net.msg_getalias_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_getalias_list
         * @static
         * @param {net.Imsg_getalias_list} message msg_getalias_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_getalias_list message, length delimited. Does not implicitly {@link net.msg_getalias_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_getalias_list
         * @static
         * @param {net.Imsg_getalias_list} message msg_getalias_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_getalias_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_getalias_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_getalias_list} msg_getalias_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_getalias_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_getalias_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_getalias_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_getalias_list} msg_getalias_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_getalias_list message.
         * @function verify
         * @memberof net.msg_getalias_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_getalias_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_getalias_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_getalias_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_getalias_list} msg_getalias_list
         */
        msg_getalias_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_getalias_list)
                return object;
            return new $root.net.msg_getalias_list();
        };

        /**
         * Creates a plain object from a msg_getalias_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_getalias_list
         * @static
         * @param {net.msg_getalias_list} message msg_getalias_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_getalias_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_getalias_list to JSON.
         * @function toJSON
         * @memberof net.msg_getalias_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_getalias_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_getalias_list;
    })();

    net.msg_getalias_list_rep = (function() {

        /**
         * Properties of a msg_getalias_list_rep.
         * @memberof net
         * @interface Imsg_getalias_list_rep
         * @property {Array.<net.Ialias_info>|null} [alias_list] msg_getalias_list_rep alias_list
         */

        /**
         * Constructs a new msg_getalias_list_rep.
         * @memberof net
         * @classdesc Represents a msg_getalias_list_rep.
         * @implements Imsg_getalias_list_rep
         * @constructor
         * @param {net.Imsg_getalias_list_rep=} [properties] Properties to set
         */
        function msg_getalias_list_rep(properties) {
            this.alias_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_getalias_list_rep alias_list.
         * @member {Array.<net.Ialias_info>} alias_list
         * @memberof net.msg_getalias_list_rep
         * @instance
         */
        msg_getalias_list_rep.prototype.alias_list = $util.emptyArray;

        /**
         * Creates a new msg_getalias_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {net.Imsg_getalias_list_rep=} [properties] Properties to set
         * @returns {net.msg_getalias_list_rep} msg_getalias_list_rep instance
         */
        msg_getalias_list_rep.create = function create(properties) {
            return new msg_getalias_list_rep(properties);
        };

        /**
         * Encodes the specified msg_getalias_list_rep message. Does not implicitly {@link net.msg_getalias_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {net.Imsg_getalias_list_rep} message msg_getalias_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.alias_list != null && message.alias_list.length)
                for (var i = 0; i < message.alias_list.length; ++i)
                    $root.net.alias_info.encode(message.alias_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_getalias_list_rep message, length delimited. Does not implicitly {@link net.msg_getalias_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {net.Imsg_getalias_list_rep} message msg_getalias_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_getalias_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_getalias_list_rep} msg_getalias_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_getalias_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.alias_list && message.alias_list.length))
                        message.alias_list = [];
                    message.alias_list.push($root.net.alias_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_getalias_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_getalias_list_rep} msg_getalias_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_getalias_list_rep message.
         * @function verify
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_getalias_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.alias_list != null && message.hasOwnProperty("alias_list")) {
                if (!Array.isArray(message.alias_list))
                    return "alias_list: array expected";
                for (var i = 0; i < message.alias_list.length; ++i) {
                    var error = $root.net.alias_info.verify(message.alias_list[i]);
                    if (error)
                        return "alias_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_getalias_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_getalias_list_rep} msg_getalias_list_rep
         */
        msg_getalias_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_getalias_list_rep)
                return object;
            var message = new $root.net.msg_getalias_list_rep();
            if (object.alias_list) {
                if (!Array.isArray(object.alias_list))
                    throw TypeError(".net.msg_getalias_list_rep.alias_list: array expected");
                message.alias_list = [];
                for (var i = 0; i < object.alias_list.length; ++i) {
                    if (typeof object.alias_list[i] !== "object")
                        throw TypeError(".net.msg_getalias_list_rep.alias_list: object expected");
                    message.alias_list[i] = $root.net.alias_info.fromObject(object.alias_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_getalias_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {net.msg_getalias_list_rep} message msg_getalias_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_getalias_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.alias_list = [];
            if (message.alias_list && message.alias_list.length) {
                object.alias_list = [];
                for (var j = 0; j < message.alias_list.length; ++j)
                    object.alias_list[j] = $root.net.alias_info.toObject(message.alias_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_getalias_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_getalias_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_getalias_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_getalias_list_rep;
    })();

    net.msg_set_sign = (function() {

        /**
         * Properties of a msg_set_sign.
         * @memberof net
         * @interface Imsg_set_sign
         * @property {Uint8Array|null} [sign] msg_set_sign sign
         */

        /**
         * Constructs a new msg_set_sign.
         * @memberof net
         * @classdesc Represents a msg_set_sign.
         * @implements Imsg_set_sign
         * @constructor
         * @param {net.Imsg_set_sign=} [properties] Properties to set
         */
        function msg_set_sign(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_sign sign.
         * @member {Uint8Array} sign
         * @memberof net.msg_set_sign
         * @instance
         */
        msg_set_sign.prototype.sign = $util.newBuffer([]);

        /**
         * Creates a new msg_set_sign instance using the specified properties.
         * @function create
         * @memberof net.msg_set_sign
         * @static
         * @param {net.Imsg_set_sign=} [properties] Properties to set
         * @returns {net.msg_set_sign} msg_set_sign instance
         */
        msg_set_sign.create = function create(properties) {
            return new msg_set_sign(properties);
        };

        /**
         * Encodes the specified msg_set_sign message. Does not implicitly {@link net.msg_set_sign.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_sign
         * @static
         * @param {net.Imsg_set_sign} message msg_set_sign message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.sign);
            return writer;
        };

        /**
         * Encodes the specified msg_set_sign message, length delimited. Does not implicitly {@link net.msg_set_sign.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_sign
         * @static
         * @param {net.Imsg_set_sign} message msg_set_sign message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_sign message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_sign
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_sign} msg_set_sign
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_sign();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sign = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_sign message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_sign
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_sign} msg_set_sign
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_sign message.
         * @function verify
         * @memberof net.msg_set_sign
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_sign.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sign != null && message.hasOwnProperty("sign"))
                if (!(message.sign && typeof message.sign.length === "number" || $util.isString(message.sign)))
                    return "sign: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_sign message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_sign
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_sign} msg_set_sign
         */
        msg_set_sign.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_sign)
                return object;
            var message = new $root.net.msg_set_sign();
            if (object.sign != null)
                if (typeof object.sign === "string")
                    $util.base64.decode(object.sign, message.sign = $util.newBuffer($util.base64.length(object.sign)), 0);
                else if (object.sign.length)
                    message.sign = object.sign;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_sign message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_sign
         * @static
         * @param {net.msg_set_sign} message msg_set_sign
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_sign.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.sign = "";
                else {
                    object.sign = [];
                    if (options.bytes !== Array)
                        object.sign = $util.newBuffer(object.sign);
                }
            if (message.sign != null && message.hasOwnProperty("sign"))
                object.sign = options.bytes === String ? $util.base64.encode(message.sign, 0, message.sign.length) : options.bytes === Array ? Array.prototype.slice.call(message.sign) : message.sign;
            return object;
        };

        /**
         * Converts this msg_set_sign to JSON.
         * @function toJSON
         * @memberof net.msg_set_sign
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_sign.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_sign;
    })();

    net.msg_set_sign_rep = (function() {

        /**
         * Properties of a msg_set_sign_rep.
         * @memberof net
         * @interface Imsg_set_sign_rep
         * @property {number|null} [result] msg_set_sign_rep result
         * @property {Uint8Array|null} [sign] msg_set_sign_rep sign
         */

        /**
         * Constructs a new msg_set_sign_rep.
         * @memberof net
         * @classdesc Represents a msg_set_sign_rep.
         * @implements Imsg_set_sign_rep
         * @constructor
         * @param {net.Imsg_set_sign_rep=} [properties] Properties to set
         */
        function msg_set_sign_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_sign_rep result.
         * @member {number} result
         * @memberof net.msg_set_sign_rep
         * @instance
         */
        msg_set_sign_rep.prototype.result = 0;

        /**
         * msg_set_sign_rep sign.
         * @member {Uint8Array} sign
         * @memberof net.msg_set_sign_rep
         * @instance
         */
        msg_set_sign_rep.prototype.sign = $util.newBuffer([]);

        /**
         * Creates a new msg_set_sign_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {net.Imsg_set_sign_rep=} [properties] Properties to set
         * @returns {net.msg_set_sign_rep} msg_set_sign_rep instance
         */
        msg_set_sign_rep.create = function create(properties) {
            return new msg_set_sign_rep(properties);
        };

        /**
         * Encodes the specified msg_set_sign_rep message. Does not implicitly {@link net.msg_set_sign_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {net.Imsg_set_sign_rep} message msg_set_sign_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.sign);
            return writer;
        };

        /**
         * Encodes the specified msg_set_sign_rep message, length delimited. Does not implicitly {@link net.msg_set_sign_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {net.Imsg_set_sign_rep} message msg_set_sign_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_sign_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_sign_rep} msg_set_sign_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_sign_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.sign = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_sign_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_sign_rep} msg_set_sign_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_sign_rep message.
         * @function verify
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_sign_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.sign != null && message.hasOwnProperty("sign"))
                if (!(message.sign && typeof message.sign.length === "number" || $util.isString(message.sign)))
                    return "sign: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_sign_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_sign_rep} msg_set_sign_rep
         */
        msg_set_sign_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_sign_rep)
                return object;
            var message = new $root.net.msg_set_sign_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.sign != null)
                if (typeof object.sign === "string")
                    $util.base64.decode(object.sign, message.sign = $util.newBuffer($util.base64.length(object.sign)), 0);
                else if (object.sign.length)
                    message.sign = object.sign;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_sign_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {net.msg_set_sign_rep} message msg_set_sign_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_sign_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.sign = "";
                else {
                    object.sign = [];
                    if (options.bytes !== Array)
                        object.sign = $util.newBuffer(object.sign);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.sign != null && message.hasOwnProperty("sign"))
                object.sign = options.bytes === String ? $util.base64.encode(message.sign, 0, message.sign.length) : options.bytes === Array ? Array.prototype.slice.call(message.sign) : message.sign;
            return object;
        };

        /**
         * Converts this msg_set_sign_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_sign_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_sign_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_sign_rep;
    })();

    net.msg_set_region = (function() {

        /**
         * Properties of a msg_set_region.
         * @memberof net
         * @interface Imsg_set_region
         * @property {Uint8Array|null} [region] msg_set_region region
         */

        /**
         * Constructs a new msg_set_region.
         * @memberof net
         * @classdesc Represents a msg_set_region.
         * @implements Imsg_set_region
         * @constructor
         * @param {net.Imsg_set_region=} [properties] Properties to set
         */
        function msg_set_region(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_region region.
         * @member {Uint8Array} region
         * @memberof net.msg_set_region
         * @instance
         */
        msg_set_region.prototype.region = $util.newBuffer([]);

        /**
         * Creates a new msg_set_region instance using the specified properties.
         * @function create
         * @memberof net.msg_set_region
         * @static
         * @param {net.Imsg_set_region=} [properties] Properties to set
         * @returns {net.msg_set_region} msg_set_region instance
         */
        msg_set_region.create = function create(properties) {
            return new msg_set_region(properties);
        };

        /**
         * Encodes the specified msg_set_region message. Does not implicitly {@link net.msg_set_region.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_region
         * @static
         * @param {net.Imsg_set_region} message msg_set_region message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.region);
            return writer;
        };

        /**
         * Encodes the specified msg_set_region message, length delimited. Does not implicitly {@link net.msg_set_region.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_region
         * @static
         * @param {net.Imsg_set_region} message msg_set_region message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_region message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_region
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_region} msg_set_region
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_region();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.region = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_region message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_region
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_region} msg_set_region
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_region message.
         * @function verify
         * @memberof net.msg_set_region
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_region.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.region != null && message.hasOwnProperty("region"))
                if (!(message.region && typeof message.region.length === "number" || $util.isString(message.region)))
                    return "region: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_region message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_region
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_region} msg_set_region
         */
        msg_set_region.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_region)
                return object;
            var message = new $root.net.msg_set_region();
            if (object.region != null)
                if (typeof object.region === "string")
                    $util.base64.decode(object.region, message.region = $util.newBuffer($util.base64.length(object.region)), 0);
                else if (object.region.length)
                    message.region = object.region;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_region message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_region
         * @static
         * @param {net.msg_set_region} message msg_set_region
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_region.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.region = "";
                else {
                    object.region = [];
                    if (options.bytes !== Array)
                        object.region = $util.newBuffer(object.region);
                }
            if (message.region != null && message.hasOwnProperty("region"))
                object.region = options.bytes === String ? $util.base64.encode(message.region, 0, message.region.length) : options.bytes === Array ? Array.prototype.slice.call(message.region) : message.region;
            return object;
        };

        /**
         * Converts this msg_set_region to JSON.
         * @function toJSON
         * @memberof net.msg_set_region
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_region.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_region;
    })();

    net.msg_set_region_rep = (function() {

        /**
         * Properties of a msg_set_region_rep.
         * @memberof net
         * @interface Imsg_set_region_rep
         * @property {number|null} [result] msg_set_region_rep result
         * @property {Uint8Array|null} [region] msg_set_region_rep region
         */

        /**
         * Constructs a new msg_set_region_rep.
         * @memberof net
         * @classdesc Represents a msg_set_region_rep.
         * @implements Imsg_set_region_rep
         * @constructor
         * @param {net.Imsg_set_region_rep=} [properties] Properties to set
         */
        function msg_set_region_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_region_rep result.
         * @member {number} result
         * @memberof net.msg_set_region_rep
         * @instance
         */
        msg_set_region_rep.prototype.result = 0;

        /**
         * msg_set_region_rep region.
         * @member {Uint8Array} region
         * @memberof net.msg_set_region_rep
         * @instance
         */
        msg_set_region_rep.prototype.region = $util.newBuffer([]);

        /**
         * Creates a new msg_set_region_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_region_rep
         * @static
         * @param {net.Imsg_set_region_rep=} [properties] Properties to set
         * @returns {net.msg_set_region_rep} msg_set_region_rep instance
         */
        msg_set_region_rep.create = function create(properties) {
            return new msg_set_region_rep(properties);
        };

        /**
         * Encodes the specified msg_set_region_rep message. Does not implicitly {@link net.msg_set_region_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_region_rep
         * @static
         * @param {net.Imsg_set_region_rep} message msg_set_region_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.region);
            return writer;
        };

        /**
         * Encodes the specified msg_set_region_rep message, length delimited. Does not implicitly {@link net.msg_set_region_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_region_rep
         * @static
         * @param {net.Imsg_set_region_rep} message msg_set_region_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_region_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_region_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_region_rep} msg_set_region_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_region_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.region = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_region_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_region_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_region_rep} msg_set_region_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_region_rep message.
         * @function verify
         * @memberof net.msg_set_region_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_region_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.region != null && message.hasOwnProperty("region"))
                if (!(message.region && typeof message.region.length === "number" || $util.isString(message.region)))
                    return "region: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_region_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_region_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_region_rep} msg_set_region_rep
         */
        msg_set_region_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_region_rep)
                return object;
            var message = new $root.net.msg_set_region_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.region != null)
                if (typeof object.region === "string")
                    $util.base64.decode(object.region, message.region = $util.newBuffer($util.base64.length(object.region)), 0);
                else if (object.region.length)
                    message.region = object.region;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_region_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_region_rep
         * @static
         * @param {net.msg_set_region_rep} message msg_set_region_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_region_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.region = "";
                else {
                    object.region = [];
                    if (options.bytes !== Array)
                        object.region = $util.newBuffer(object.region);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.region != null && message.hasOwnProperty("region"))
                object.region = options.bytes === String ? $util.base64.encode(message.region, 0, message.region.length) : options.bytes === Array ? Array.prototype.slice.call(message.region) : message.region;
            return object;
        };

        /**
         * Converts this msg_set_region_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_region_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_region_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_region_rep;
    })();

    net.msg_set_headurl = (function() {

        /**
         * Properties of a msg_set_headurl.
         * @memberof net
         * @interface Imsg_set_headurl
         * @property {Uint8Array|null} [headurl] msg_set_headurl headurl
         */

        /**
         * Constructs a new msg_set_headurl.
         * @memberof net
         * @classdesc Represents a msg_set_headurl.
         * @implements Imsg_set_headurl
         * @constructor
         * @param {net.Imsg_set_headurl=} [properties] Properties to set
         */
        function msg_set_headurl(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_headurl headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_set_headurl
         * @instance
         */
        msg_set_headurl.prototype.headurl = $util.newBuffer([]);

        /**
         * Creates a new msg_set_headurl instance using the specified properties.
         * @function create
         * @memberof net.msg_set_headurl
         * @static
         * @param {net.Imsg_set_headurl=} [properties] Properties to set
         * @returns {net.msg_set_headurl} msg_set_headurl instance
         */
        msg_set_headurl.create = function create(properties) {
            return new msg_set_headurl(properties);
        };

        /**
         * Encodes the specified msg_set_headurl message. Does not implicitly {@link net.msg_set_headurl.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_headurl
         * @static
         * @param {net.Imsg_set_headurl} message msg_set_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.headurl);
            return writer;
        };

        /**
         * Encodes the specified msg_set_headurl message, length delimited. Does not implicitly {@link net.msg_set_headurl.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_headurl
         * @static
         * @param {net.Imsg_set_headurl} message msg_set_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_headurl message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_headurl} msg_set_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_headurl();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_headurl message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_headurl} msg_set_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_headurl message.
         * @function verify
         * @memberof net.msg_set_headurl
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_headurl.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_headurl message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_headurl
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_headurl} msg_set_headurl
         */
        msg_set_headurl.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_headurl)
                return object;
            var message = new $root.net.msg_set_headurl();
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_headurl message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_headurl
         * @static
         * @param {net.msg_set_headurl} message msg_set_headurl
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_headurl.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            return object;
        };

        /**
         * Converts this msg_set_headurl to JSON.
         * @function toJSON
         * @memberof net.msg_set_headurl
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_headurl.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_headurl;
    })();

    net.msg_set_headurl_rep = (function() {

        /**
         * Properties of a msg_set_headurl_rep.
         * @memberof net
         * @interface Imsg_set_headurl_rep
         * @property {number|null} [result] msg_set_headurl_rep result
         * @property {Uint8Array|null} [headurl] msg_set_headurl_rep headurl
         */

        /**
         * Constructs a new msg_set_headurl_rep.
         * @memberof net
         * @classdesc Represents a msg_set_headurl_rep.
         * @implements Imsg_set_headurl_rep
         * @constructor
         * @param {net.Imsg_set_headurl_rep=} [properties] Properties to set
         */
        function msg_set_headurl_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_headurl_rep result.
         * @member {number} result
         * @memberof net.msg_set_headurl_rep
         * @instance
         */
        msg_set_headurl_rep.prototype.result = 0;

        /**
         * msg_set_headurl_rep headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_set_headurl_rep
         * @instance
         */
        msg_set_headurl_rep.prototype.headurl = $util.newBuffer([]);

        /**
         * Creates a new msg_set_headurl_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {net.Imsg_set_headurl_rep=} [properties] Properties to set
         * @returns {net.msg_set_headurl_rep} msg_set_headurl_rep instance
         */
        msg_set_headurl_rep.create = function create(properties) {
            return new msg_set_headurl_rep(properties);
        };

        /**
         * Encodes the specified msg_set_headurl_rep message. Does not implicitly {@link net.msg_set_headurl_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {net.Imsg_set_headurl_rep} message msg_set_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.headurl);
            return writer;
        };

        /**
         * Encodes the specified msg_set_headurl_rep message, length delimited. Does not implicitly {@link net.msg_set_headurl_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {net.Imsg_set_headurl_rep} message msg_set_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_headurl_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_headurl_rep} msg_set_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_headurl_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_headurl_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_headurl_rep} msg_set_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_headurl_rep message.
         * @function verify
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_headurl_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                if (!(message.headurl && typeof message.headurl.length === "number" || $util.isString(message.headurl)))
                    return "headurl: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_headurl_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_headurl_rep} msg_set_headurl_rep
         */
        msg_set_headurl_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_headurl_rep)
                return object;
            var message = new $root.net.msg_set_headurl_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.headurl != null)
                if (typeof object.headurl === "string")
                    $util.base64.decode(object.headurl, message.headurl = $util.newBuffer($util.base64.length(object.headurl)), 0);
                else if (object.headurl.length)
                    message.headurl = object.headurl;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_headurl_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {net.msg_set_headurl_rep} message msg_set_headurl_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_headurl_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.headurl = "";
                else {
                    object.headurl = [];
                    if (options.bytes !== Array)
                        object.headurl = $util.newBuffer(object.headurl);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.headurl != null && message.hasOwnProperty("headurl"))
                object.headurl = options.bytes === String ? $util.base64.encode(message.headurl, 0, message.headurl.length) : options.bytes === Array ? Array.prototype.slice.call(message.headurl) : message.headurl;
            return object;
        };

        /**
         * Converts this msg_set_headurl_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_headurl_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_headurl_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_headurl_rep;
    })();

    net.msg_set_name = (function() {

        /**
         * Properties of a msg_set_name.
         * @memberof net
         * @interface Imsg_set_name
         * @property {Uint8Array|null} [name] msg_set_name name
         */

        /**
         * Constructs a new msg_set_name.
         * @memberof net
         * @classdesc Represents a msg_set_name.
         * @implements Imsg_set_name
         * @constructor
         * @param {net.Imsg_set_name=} [properties] Properties to set
         */
        function msg_set_name(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_name name.
         * @member {Uint8Array} name
         * @memberof net.msg_set_name
         * @instance
         */
        msg_set_name.prototype.name = $util.newBuffer([]);

        /**
         * Creates a new msg_set_name instance using the specified properties.
         * @function create
         * @memberof net.msg_set_name
         * @static
         * @param {net.Imsg_set_name=} [properties] Properties to set
         * @returns {net.msg_set_name} msg_set_name instance
         */
        msg_set_name.create = function create(properties) {
            return new msg_set_name(properties);
        };

        /**
         * Encodes the specified msg_set_name message. Does not implicitly {@link net.msg_set_name.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_name
         * @static
         * @param {net.Imsg_set_name} message msg_set_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.name);
            return writer;
        };

        /**
         * Encodes the specified msg_set_name message, length delimited. Does not implicitly {@link net.msg_set_name.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_name
         * @static
         * @param {net.Imsg_set_name} message msg_set_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_name message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_name} msg_set_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_name();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_name message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_name} msg_set_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_name message.
         * @function verify
         * @memberof net.msg_set_name
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_name.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!(message.name && typeof message.name.length === "number" || $util.isString(message.name)))
                    return "name: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_name message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_name
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_name} msg_set_name
         */
        msg_set_name.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_name)
                return object;
            var message = new $root.net.msg_set_name();
            if (object.name != null)
                if (typeof object.name === "string")
                    $util.base64.decode(object.name, message.name = $util.newBuffer($util.base64.length(object.name)), 0);
                else if (object.name.length)
                    message.name = object.name;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_name message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_name
         * @static
         * @param {net.msg_set_name} message msg_set_name
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_name.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.name = "";
                else {
                    object.name = [];
                    if (options.bytes !== Array)
                        object.name = $util.newBuffer(object.name);
                }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = options.bytes === String ? $util.base64.encode(message.name, 0, message.name.length) : options.bytes === Array ? Array.prototype.slice.call(message.name) : message.name;
            return object;
        };

        /**
         * Converts this msg_set_name to JSON.
         * @function toJSON
         * @memberof net.msg_set_name
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_name.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_name;
    })();

    net.msg_set_name_rep = (function() {

        /**
         * Properties of a msg_set_name_rep.
         * @memberof net
         * @interface Imsg_set_name_rep
         * @property {number|null} [result] msg_set_name_rep result
         * @property {Uint8Array|null} [name] msg_set_name_rep name
         */

        /**
         * Constructs a new msg_set_name_rep.
         * @memberof net
         * @classdesc Represents a msg_set_name_rep.
         * @implements Imsg_set_name_rep
         * @constructor
         * @param {net.Imsg_set_name_rep=} [properties] Properties to set
         */
        function msg_set_name_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_name_rep result.
         * @member {number} result
         * @memberof net.msg_set_name_rep
         * @instance
         */
        msg_set_name_rep.prototype.result = 0;

        /**
         * msg_set_name_rep name.
         * @member {Uint8Array} name
         * @memberof net.msg_set_name_rep
         * @instance
         */
        msg_set_name_rep.prototype.name = $util.newBuffer([]);

        /**
         * Creates a new msg_set_name_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_name_rep
         * @static
         * @param {net.Imsg_set_name_rep=} [properties] Properties to set
         * @returns {net.msg_set_name_rep} msg_set_name_rep instance
         */
        msg_set_name_rep.create = function create(properties) {
            return new msg_set_name_rep(properties);
        };

        /**
         * Encodes the specified msg_set_name_rep message. Does not implicitly {@link net.msg_set_name_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_name_rep
         * @static
         * @param {net.Imsg_set_name_rep} message msg_set_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.name);
            return writer;
        };

        /**
         * Encodes the specified msg_set_name_rep message, length delimited. Does not implicitly {@link net.msg_set_name_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_name_rep
         * @static
         * @param {net.Imsg_set_name_rep} message msg_set_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_name_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_name_rep} msg_set_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_name_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_name_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_name_rep} msg_set_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_name_rep message.
         * @function verify
         * @memberof net.msg_set_name_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_name_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!(message.name && typeof message.name.length === "number" || $util.isString(message.name)))
                    return "name: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_name_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_name_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_name_rep} msg_set_name_rep
         */
        msg_set_name_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_name_rep)
                return object;
            var message = new $root.net.msg_set_name_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.name != null)
                if (typeof object.name === "string")
                    $util.base64.decode(object.name, message.name = $util.newBuffer($util.base64.length(object.name)), 0);
                else if (object.name.length)
                    message.name = object.name;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_name_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_name_rep
         * @static
         * @param {net.msg_set_name_rep} message msg_set_name_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_name_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.name = "";
                else {
                    object.name = [];
                    if (options.bytes !== Array)
                        object.name = $util.newBuffer(object.name);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = options.bytes === String ? $util.base64.encode(message.name, 0, message.name.length) : options.bytes === Array ? Array.prototype.slice.call(message.name) : message.name;
            return object;
        };

        /**
         * Converts this msg_set_name_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_name_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_name_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_name_rep;
    })();

    net.msg_total_redbag_record = (function() {

        /**
         * Properties of a msg_total_redbag_record.
         * @memberof net
         * @interface Imsg_total_redbag_record
         */

        /**
         * Constructs a new msg_total_redbag_record.
         * @memberof net
         * @classdesc Represents a msg_total_redbag_record.
         * @implements Imsg_total_redbag_record
         * @constructor
         * @param {net.Imsg_total_redbag_record=} [properties] Properties to set
         */
        function msg_total_redbag_record(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_total_redbag_record instance using the specified properties.
         * @function create
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {net.Imsg_total_redbag_record=} [properties] Properties to set
         * @returns {net.msg_total_redbag_record} msg_total_redbag_record instance
         */
        msg_total_redbag_record.create = function create(properties) {
            return new msg_total_redbag_record(properties);
        };

        /**
         * Encodes the specified msg_total_redbag_record message. Does not implicitly {@link net.msg_total_redbag_record.verify|verify} messages.
         * @function encode
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {net.Imsg_total_redbag_record} message msg_total_redbag_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_total_redbag_record message, length delimited. Does not implicitly {@link net.msg_total_redbag_record.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {net.Imsg_total_redbag_record} message msg_total_redbag_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_total_redbag_record message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_total_redbag_record} msg_total_redbag_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_total_redbag_record();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_total_redbag_record message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_total_redbag_record} msg_total_redbag_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_total_redbag_record message.
         * @function verify
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_total_redbag_record.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_total_redbag_record message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_total_redbag_record} msg_total_redbag_record
         */
        msg_total_redbag_record.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_total_redbag_record)
                return object;
            return new $root.net.msg_total_redbag_record();
        };

        /**
         * Creates a plain object from a msg_total_redbag_record message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {net.msg_total_redbag_record} message msg_total_redbag_record
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_total_redbag_record.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_total_redbag_record to JSON.
         * @function toJSON
         * @memberof net.msg_total_redbag_record
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_total_redbag_record.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_total_redbag_record;
    })();

    net.msg_total_redbag_record_resp = (function() {

        /**
         * Properties of a msg_total_redbag_record_resp.
         * @memberof net
         * @interface Imsg_total_redbag_record_resp
         * @property {Array.<net.Iredbag_base_info>|null} [sendlist] msg_total_redbag_record_resp sendlist
         * @property {Array.<net.Iredbag_base_info>|null} [recvlist] msg_total_redbag_record_resp recvlist
         */

        /**
         * Constructs a new msg_total_redbag_record_resp.
         * @memberof net
         * @classdesc Represents a msg_total_redbag_record_resp.
         * @implements Imsg_total_redbag_record_resp
         * @constructor
         * @param {net.Imsg_total_redbag_record_resp=} [properties] Properties to set
         */
        function msg_total_redbag_record_resp(properties) {
            this.sendlist = [];
            this.recvlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_total_redbag_record_resp sendlist.
         * @member {Array.<net.Iredbag_base_info>} sendlist
         * @memberof net.msg_total_redbag_record_resp
         * @instance
         */
        msg_total_redbag_record_resp.prototype.sendlist = $util.emptyArray;

        /**
         * msg_total_redbag_record_resp recvlist.
         * @member {Array.<net.Iredbag_base_info>} recvlist
         * @memberof net.msg_total_redbag_record_resp
         * @instance
         */
        msg_total_redbag_record_resp.prototype.recvlist = $util.emptyArray;

        /**
         * Creates a new msg_total_redbag_record_resp instance using the specified properties.
         * @function create
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {net.Imsg_total_redbag_record_resp=} [properties] Properties to set
         * @returns {net.msg_total_redbag_record_resp} msg_total_redbag_record_resp instance
         */
        msg_total_redbag_record_resp.create = function create(properties) {
            return new msg_total_redbag_record_resp(properties);
        };

        /**
         * Encodes the specified msg_total_redbag_record_resp message. Does not implicitly {@link net.msg_total_redbag_record_resp.verify|verify} messages.
         * @function encode
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {net.Imsg_total_redbag_record_resp} message msg_total_redbag_record_resp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record_resp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sendlist != null && message.sendlist.length)
                for (var i = 0; i < message.sendlist.length; ++i)
                    $root.net.redbag_base_info.encode(message.sendlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.recvlist != null && message.recvlist.length)
                for (var i = 0; i < message.recvlist.length; ++i)
                    $root.net.redbag_base_info.encode(message.recvlist[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_total_redbag_record_resp message, length delimited. Does not implicitly {@link net.msg_total_redbag_record_resp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {net.Imsg_total_redbag_record_resp} message msg_total_redbag_record_resp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record_resp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_total_redbag_record_resp message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_total_redbag_record_resp} msg_total_redbag_record_resp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record_resp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_total_redbag_record_resp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.sendlist && message.sendlist.length))
                        message.sendlist = [];
                    message.sendlist.push($root.net.redbag_base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.recvlist && message.recvlist.length))
                        message.recvlist = [];
                    message.recvlist.push($root.net.redbag_base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_total_redbag_record_resp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_total_redbag_record_resp} msg_total_redbag_record_resp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record_resp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_total_redbag_record_resp message.
         * @function verify
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_total_redbag_record_resp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sendlist != null && message.hasOwnProperty("sendlist")) {
                if (!Array.isArray(message.sendlist))
                    return "sendlist: array expected";
                for (var i = 0; i < message.sendlist.length; ++i) {
                    var error = $root.net.redbag_base_info.verify(message.sendlist[i]);
                    if (error)
                        return "sendlist." + error;
                }
            }
            if (message.recvlist != null && message.hasOwnProperty("recvlist")) {
                if (!Array.isArray(message.recvlist))
                    return "recvlist: array expected";
                for (var i = 0; i < message.recvlist.length; ++i) {
                    var error = $root.net.redbag_base_info.verify(message.recvlist[i]);
                    if (error)
                        return "recvlist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_total_redbag_record_resp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_total_redbag_record_resp} msg_total_redbag_record_resp
         */
        msg_total_redbag_record_resp.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_total_redbag_record_resp)
                return object;
            var message = new $root.net.msg_total_redbag_record_resp();
            if (object.sendlist) {
                if (!Array.isArray(object.sendlist))
                    throw TypeError(".net.msg_total_redbag_record_resp.sendlist: array expected");
                message.sendlist = [];
                for (var i = 0; i < object.sendlist.length; ++i) {
                    if (typeof object.sendlist[i] !== "object")
                        throw TypeError(".net.msg_total_redbag_record_resp.sendlist: object expected");
                    message.sendlist[i] = $root.net.redbag_base_info.fromObject(object.sendlist[i]);
                }
            }
            if (object.recvlist) {
                if (!Array.isArray(object.recvlist))
                    throw TypeError(".net.msg_total_redbag_record_resp.recvlist: array expected");
                message.recvlist = [];
                for (var i = 0; i < object.recvlist.length; ++i) {
                    if (typeof object.recvlist[i] !== "object")
                        throw TypeError(".net.msg_total_redbag_record_resp.recvlist: object expected");
                    message.recvlist[i] = $root.net.redbag_base_info.fromObject(object.recvlist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_total_redbag_record_resp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {net.msg_total_redbag_record_resp} message msg_total_redbag_record_resp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_total_redbag_record_resp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.sendlist = [];
                object.recvlist = [];
            }
            if (message.sendlist && message.sendlist.length) {
                object.sendlist = [];
                for (var j = 0; j < message.sendlist.length; ++j)
                    object.sendlist[j] = $root.net.redbag_base_info.toObject(message.sendlist[j], options);
            }
            if (message.recvlist && message.recvlist.length) {
                object.recvlist = [];
                for (var j = 0; j < message.recvlist.length; ++j)
                    object.recvlist[j] = $root.net.redbag_base_info.toObject(message.recvlist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_total_redbag_record_resp to JSON.
         * @function toJSON
         * @memberof net.msg_total_redbag_record_resp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_total_redbag_record_resp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_total_redbag_record_resp;
    })();

    net.msg_upload_addressbook = (function() {

        /**
         * Properties of a msg_upload_addressbook.
         * @memberof net
         * @interface Imsg_upload_addressbook
         * @property {Uint8Array|null} [addressbook] msg_upload_addressbook addressbook
         * @property {number|null} [is_end] msg_upload_addressbook is_end
         */

        /**
         * Constructs a new msg_upload_addressbook.
         * @memberof net
         * @classdesc Represents a msg_upload_addressbook.
         * @implements Imsg_upload_addressbook
         * @constructor
         * @param {net.Imsg_upload_addressbook=} [properties] Properties to set
         */
        function msg_upload_addressbook(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_addressbook addressbook.
         * @member {Uint8Array} addressbook
         * @memberof net.msg_upload_addressbook
         * @instance
         */
        msg_upload_addressbook.prototype.addressbook = $util.newBuffer([]);

        /**
         * msg_upload_addressbook is_end.
         * @member {number} is_end
         * @memberof net.msg_upload_addressbook
         * @instance
         */
        msg_upload_addressbook.prototype.is_end = 0;

        /**
         * Creates a new msg_upload_addressbook instance using the specified properties.
         * @function create
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {net.Imsg_upload_addressbook=} [properties] Properties to set
         * @returns {net.msg_upload_addressbook} msg_upload_addressbook instance
         */
        msg_upload_addressbook.create = function create(properties) {
            return new msg_upload_addressbook(properties);
        };

        /**
         * Encodes the specified msg_upload_addressbook message. Does not implicitly {@link net.msg_upload_addressbook.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {net.Imsg_upload_addressbook} message msg_upload_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addressbook != null && Object.hasOwnProperty.call(message, "addressbook"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.addressbook);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Encodes the specified msg_upload_addressbook message, length delimited. Does not implicitly {@link net.msg_upload_addressbook.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {net.Imsg_upload_addressbook} message msg_upload_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_upload_addressbook message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_addressbook} msg_upload_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_addressbook();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.addressbook = reader.bytes();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_upload_addressbook message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_upload_addressbook} msg_upload_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_upload_addressbook message.
         * @function verify
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_upload_addressbook.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.addressbook != null && message.hasOwnProperty("addressbook"))
                if (!(message.addressbook && typeof message.addressbook.length === "number" || $util.isString(message.addressbook)))
                    return "addressbook: buffer expected";
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                if (!$util.isInteger(message.is_end))
                    return "is_end: integer expected";
            return null;
        };

        /**
         * Creates a msg_upload_addressbook message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_upload_addressbook} msg_upload_addressbook
         */
        msg_upload_addressbook.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_upload_addressbook)
                return object;
            var message = new $root.net.msg_upload_addressbook();
            if (object.addressbook != null)
                if (typeof object.addressbook === "string")
                    $util.base64.decode(object.addressbook, message.addressbook = $util.newBuffer($util.base64.length(object.addressbook)), 0);
                else if (object.addressbook.length)
                    message.addressbook = object.addressbook;
            if (object.is_end != null)
                message.is_end = object.is_end | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_upload_addressbook message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {net.msg_upload_addressbook} message msg_upload_addressbook
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_upload_addressbook.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.addressbook = "";
                else {
                    object.addressbook = [];
                    if (options.bytes !== Array)
                        object.addressbook = $util.newBuffer(object.addressbook);
                }
                object.is_end = 0;
            }
            if (message.addressbook != null && message.hasOwnProperty("addressbook"))
                object.addressbook = options.bytes === String ? $util.base64.encode(message.addressbook, 0, message.addressbook.length) : options.bytes === Array ? Array.prototype.slice.call(message.addressbook) : message.addressbook;
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                object.is_end = message.is_end;
            return object;
        };

        /**
         * Converts this msg_upload_addressbook to JSON.
         * @function toJSON
         * @memberof net.msg_upload_addressbook
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_upload_addressbook.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_upload_addressbook;
    })();

    net.msg_upload_addressbook_rep = (function() {

        /**
         * Properties of a msg_upload_addressbook_rep.
         * @memberof net
         * @interface Imsg_upload_addressbook_rep
         * @property {number|null} [result] msg_upload_addressbook_rep result
         * @property {number|null} [is_end] msg_upload_addressbook_rep is_end
         */

        /**
         * Constructs a new msg_upload_addressbook_rep.
         * @memberof net
         * @classdesc Represents a msg_upload_addressbook_rep.
         * @implements Imsg_upload_addressbook_rep
         * @constructor
         * @param {net.Imsg_upload_addressbook_rep=} [properties] Properties to set
         */
        function msg_upload_addressbook_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_addressbook_rep result.
         * @member {number} result
         * @memberof net.msg_upload_addressbook_rep
         * @instance
         */
        msg_upload_addressbook_rep.prototype.result = 0;

        /**
         * msg_upload_addressbook_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_upload_addressbook_rep
         * @instance
         */
        msg_upload_addressbook_rep.prototype.is_end = 0;

        /**
         * Creates a new msg_upload_addressbook_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {net.Imsg_upload_addressbook_rep=} [properties] Properties to set
         * @returns {net.msg_upload_addressbook_rep} msg_upload_addressbook_rep instance
         */
        msg_upload_addressbook_rep.create = function create(properties) {
            return new msg_upload_addressbook_rep(properties);
        };

        /**
         * Encodes the specified msg_upload_addressbook_rep message. Does not implicitly {@link net.msg_upload_addressbook_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {net.Imsg_upload_addressbook_rep} message msg_upload_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Encodes the specified msg_upload_addressbook_rep message, length delimited. Does not implicitly {@link net.msg_upload_addressbook_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {net.Imsg_upload_addressbook_rep} message msg_upload_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_upload_addressbook_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_addressbook_rep} msg_upload_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_addressbook_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_upload_addressbook_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_upload_addressbook_rep} msg_upload_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_upload_addressbook_rep message.
         * @function verify
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_upload_addressbook_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                if (!$util.isInteger(message.is_end))
                    return "is_end: integer expected";
            return null;
        };

        /**
         * Creates a msg_upload_addressbook_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_upload_addressbook_rep} msg_upload_addressbook_rep
         */
        msg_upload_addressbook_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_upload_addressbook_rep)
                return object;
            var message = new $root.net.msg_upload_addressbook_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.is_end != null)
                message.is_end = object.is_end | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_upload_addressbook_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {net.msg_upload_addressbook_rep} message msg_upload_addressbook_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_upload_addressbook_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.is_end = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                object.is_end = message.is_end;
            return object;
        };

        /**
         * Converts this msg_upload_addressbook_rep to JSON.
         * @function toJSON
         * @memberof net.msg_upload_addressbook_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_upload_addressbook_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_upload_addressbook_rep;
    })();

    net.msg_get_addressbook = (function() {

        /**
         * Properties of a msg_get_addressbook.
         * @memberof net
         * @interface Imsg_get_addressbook
         */

        /**
         * Constructs a new msg_get_addressbook.
         * @memberof net
         * @classdesc Represents a msg_get_addressbook.
         * @implements Imsg_get_addressbook
         * @constructor
         * @param {net.Imsg_get_addressbook=} [properties] Properties to set
         */
        function msg_get_addressbook(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_addressbook instance using the specified properties.
         * @function create
         * @memberof net.msg_get_addressbook
         * @static
         * @param {net.Imsg_get_addressbook=} [properties] Properties to set
         * @returns {net.msg_get_addressbook} msg_get_addressbook instance
         */
        msg_get_addressbook.create = function create(properties) {
            return new msg_get_addressbook(properties);
        };

        /**
         * Encodes the specified msg_get_addressbook message. Does not implicitly {@link net.msg_get_addressbook.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_addressbook
         * @static
         * @param {net.Imsg_get_addressbook} message msg_get_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_addressbook message, length delimited. Does not implicitly {@link net.msg_get_addressbook.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_addressbook
         * @static
         * @param {net.Imsg_get_addressbook} message msg_get_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_addressbook message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_addressbook} msg_get_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_addressbook();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_addressbook message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_addressbook} msg_get_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_addressbook message.
         * @function verify
         * @memberof net.msg_get_addressbook
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_addressbook.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_addressbook message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_addressbook
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_addressbook} msg_get_addressbook
         */
        msg_get_addressbook.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_addressbook)
                return object;
            return new $root.net.msg_get_addressbook();
        };

        /**
         * Creates a plain object from a msg_get_addressbook message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_addressbook
         * @static
         * @param {net.msg_get_addressbook} message msg_get_addressbook
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_addressbook.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_addressbook to JSON.
         * @function toJSON
         * @memberof net.msg_get_addressbook
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_addressbook.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_addressbook;
    })();

    net.msg_get_addressbook_rep = (function() {

        /**
         * Properties of a msg_get_addressbook_rep.
         * @memberof net
         * @interface Imsg_get_addressbook_rep
         * @property {Uint8Array|null} [addressbook] msg_get_addressbook_rep addressbook
         * @property {number|null} [is_end] msg_get_addressbook_rep is_end
         */

        /**
         * Constructs a new msg_get_addressbook_rep.
         * @memberof net
         * @classdesc Represents a msg_get_addressbook_rep.
         * @implements Imsg_get_addressbook_rep
         * @constructor
         * @param {net.Imsg_get_addressbook_rep=} [properties] Properties to set
         */
        function msg_get_addressbook_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_addressbook_rep addressbook.
         * @member {Uint8Array} addressbook
         * @memberof net.msg_get_addressbook_rep
         * @instance
         */
        msg_get_addressbook_rep.prototype.addressbook = $util.newBuffer([]);

        /**
         * msg_get_addressbook_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_get_addressbook_rep
         * @instance
         */
        msg_get_addressbook_rep.prototype.is_end = 0;

        /**
         * Creates a new msg_get_addressbook_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {net.Imsg_get_addressbook_rep=} [properties] Properties to set
         * @returns {net.msg_get_addressbook_rep} msg_get_addressbook_rep instance
         */
        msg_get_addressbook_rep.create = function create(properties) {
            return new msg_get_addressbook_rep(properties);
        };

        /**
         * Encodes the specified msg_get_addressbook_rep message. Does not implicitly {@link net.msg_get_addressbook_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {net.Imsg_get_addressbook_rep} message msg_get_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addressbook != null && Object.hasOwnProperty.call(message, "addressbook"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.addressbook);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Encodes the specified msg_get_addressbook_rep message, length delimited. Does not implicitly {@link net.msg_get_addressbook_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {net.Imsg_get_addressbook_rep} message msg_get_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_addressbook_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_addressbook_rep} msg_get_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_addressbook_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.addressbook = reader.bytes();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_addressbook_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_addressbook_rep} msg_get_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_addressbook_rep message.
         * @function verify
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_addressbook_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.addressbook != null && message.hasOwnProperty("addressbook"))
                if (!(message.addressbook && typeof message.addressbook.length === "number" || $util.isString(message.addressbook)))
                    return "addressbook: buffer expected";
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                if (!$util.isInteger(message.is_end))
                    return "is_end: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_addressbook_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_addressbook_rep} msg_get_addressbook_rep
         */
        msg_get_addressbook_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_addressbook_rep)
                return object;
            var message = new $root.net.msg_get_addressbook_rep();
            if (object.addressbook != null)
                if (typeof object.addressbook === "string")
                    $util.base64.decode(object.addressbook, message.addressbook = $util.newBuffer($util.base64.length(object.addressbook)), 0);
                else if (object.addressbook.length)
                    message.addressbook = object.addressbook;
            if (object.is_end != null)
                message.is_end = object.is_end | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_addressbook_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {net.msg_get_addressbook_rep} message msg_get_addressbook_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_addressbook_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.addressbook = "";
                else {
                    object.addressbook = [];
                    if (options.bytes !== Array)
                        object.addressbook = $util.newBuffer(object.addressbook);
                }
                object.is_end = 0;
            }
            if (message.addressbook != null && message.hasOwnProperty("addressbook"))
                object.addressbook = options.bytes === String ? $util.base64.encode(message.addressbook, 0, message.addressbook.length) : options.bytes === Array ? Array.prototype.slice.call(message.addressbook) : message.addressbook;
            if (message.is_end != null && message.hasOwnProperty("is_end"))
                object.is_end = message.is_end;
            return object;
        };

        /**
         * Converts this msg_get_addressbook_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_addressbook_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_addressbook_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_addressbook_rep;
    })();

    net.msg_upload_pushid = (function() {

        /**
         * Properties of a msg_upload_pushid.
         * @memberof net
         * @interface Imsg_upload_pushid
         * @property {Uint8Array|null} [pushid] msg_upload_pushid pushid
         * @property {number|null} [pushchannel] msg_upload_pushid pushchannel
         */

        /**
         * Constructs a new msg_upload_pushid.
         * @memberof net
         * @classdesc Represents a msg_upload_pushid.
         * @implements Imsg_upload_pushid
         * @constructor
         * @param {net.Imsg_upload_pushid=} [properties] Properties to set
         */
        function msg_upload_pushid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_pushid pushid.
         * @member {Uint8Array} pushid
         * @memberof net.msg_upload_pushid
         * @instance
         */
        msg_upload_pushid.prototype.pushid = $util.newBuffer([]);

        /**
         * msg_upload_pushid pushchannel.
         * @member {number} pushchannel
         * @memberof net.msg_upload_pushid
         * @instance
         */
        msg_upload_pushid.prototype.pushchannel = 0;

        /**
         * Creates a new msg_upload_pushid instance using the specified properties.
         * @function create
         * @memberof net.msg_upload_pushid
         * @static
         * @param {net.Imsg_upload_pushid=} [properties] Properties to set
         * @returns {net.msg_upload_pushid} msg_upload_pushid instance
         */
        msg_upload_pushid.create = function create(properties) {
            return new msg_upload_pushid(properties);
        };

        /**
         * Encodes the specified msg_upload_pushid message. Does not implicitly {@link net.msg_upload_pushid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_pushid
         * @static
         * @param {net.Imsg_upload_pushid} message msg_upload_pushid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pushid != null && Object.hasOwnProperty.call(message, "pushid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.pushid);
            if (message.pushchannel != null && Object.hasOwnProperty.call(message, "pushchannel"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pushchannel);
            return writer;
        };

        /**
         * Encodes the specified msg_upload_pushid message, length delimited. Does not implicitly {@link net.msg_upload_pushid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_upload_pushid
         * @static
         * @param {net.Imsg_upload_pushid} message msg_upload_pushid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_upload_pushid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_pushid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_pushid} msg_upload_pushid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_pushid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pushid = reader.bytes();
                    break;
                case 2:
                    message.pushchannel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_upload_pushid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_upload_pushid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_upload_pushid} msg_upload_pushid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_upload_pushid message.
         * @function verify
         * @memberof net.msg_upload_pushid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_upload_pushid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pushid != null && message.hasOwnProperty("pushid"))
                if (!(message.pushid && typeof message.pushid.length === "number" || $util.isString(message.pushid)))
                    return "pushid: buffer expected";
            if (message.pushchannel != null && message.hasOwnProperty("pushchannel"))
                if (!$util.isInteger(message.pushchannel))
                    return "pushchannel: integer expected";
            return null;
        };

        /**
         * Creates a msg_upload_pushid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_upload_pushid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_upload_pushid} msg_upload_pushid
         */
        msg_upload_pushid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_upload_pushid)
                return object;
            var message = new $root.net.msg_upload_pushid();
            if (object.pushid != null)
                if (typeof object.pushid === "string")
                    $util.base64.decode(object.pushid, message.pushid = $util.newBuffer($util.base64.length(object.pushid)), 0);
                else if (object.pushid.length)
                    message.pushid = object.pushid;
            if (object.pushchannel != null)
                message.pushchannel = object.pushchannel | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_upload_pushid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_upload_pushid
         * @static
         * @param {net.msg_upload_pushid} message msg_upload_pushid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_upload_pushid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.pushid = "";
                else {
                    object.pushid = [];
                    if (options.bytes !== Array)
                        object.pushid = $util.newBuffer(object.pushid);
                }
                object.pushchannel = 0;
            }
            if (message.pushid != null && message.hasOwnProperty("pushid"))
                object.pushid = options.bytes === String ? $util.base64.encode(message.pushid, 0, message.pushid.length) : options.bytes === Array ? Array.prototype.slice.call(message.pushid) : message.pushid;
            if (message.pushchannel != null && message.hasOwnProperty("pushchannel"))
                object.pushchannel = message.pushchannel;
            return object;
        };

        /**
         * Converts this msg_upload_pushid to JSON.
         * @function toJSON
         * @memberof net.msg_upload_pushid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_upload_pushid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_upload_pushid;
    })();

    net.msg_upload_pushid_rep = (function() {

        /**
         * Properties of a msg_upload_pushid_rep.
         * @memberof net
         * @interface Imsg_upload_pushid_rep
         */

        /**
         * Constructs a new msg_upload_pushid_rep.
         * @memberof net
         * @classdesc Represents a msg_upload_pushid_rep.
         * @implements Imsg_upload_pushid_rep
         * @constructor
         * @param {net.Imsg_upload_pushid_rep=} [properties] Properties to set
         */
        function msg_upload_pushid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_upload_pushid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {net.Imsg_upload_pushid_rep=} [properties] Properties to set
         * @returns {net.msg_upload_pushid_rep} msg_upload_pushid_rep instance
         */
        msg_upload_pushid_rep.create = function create(properties) {
            return new msg_upload_pushid_rep(properties);
        };

        /**
         * Encodes the specified msg_upload_pushid_rep message. Does not implicitly {@link net.msg_upload_pushid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {net.Imsg_upload_pushid_rep} message msg_upload_pushid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_upload_pushid_rep message, length delimited. Does not implicitly {@link net.msg_upload_pushid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {net.Imsg_upload_pushid_rep} message msg_upload_pushid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_upload_pushid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_pushid_rep} msg_upload_pushid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_pushid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_upload_pushid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_upload_pushid_rep} msg_upload_pushid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_upload_pushid_rep message.
         * @function verify
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_upload_pushid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_upload_pushid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_upload_pushid_rep} msg_upload_pushid_rep
         */
        msg_upload_pushid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_upload_pushid_rep)
                return object;
            return new $root.net.msg_upload_pushid_rep();
        };

        /**
         * Creates a plain object from a msg_upload_pushid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {net.msg_upload_pushid_rep} message msg_upload_pushid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_upload_pushid_rep.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_upload_pushid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_upload_pushid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_upload_pushid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_upload_pushid_rep;
    })();

    net.msg_set_background = (function() {

        /**
         * Properties of a msg_set_background.
         * @memberof net
         * @interface Imsg_set_background
         * @property {number|null} [is_back] msg_set_background is_back
         */

        /**
         * Constructs a new msg_set_background.
         * @memberof net
         * @classdesc Represents a msg_set_background.
         * @implements Imsg_set_background
         * @constructor
         * @param {net.Imsg_set_background=} [properties] Properties to set
         */
        function msg_set_background(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_background is_back.
         * @member {number} is_back
         * @memberof net.msg_set_background
         * @instance
         */
        msg_set_background.prototype.is_back = 0;

        /**
         * Creates a new msg_set_background instance using the specified properties.
         * @function create
         * @memberof net.msg_set_background
         * @static
         * @param {net.Imsg_set_background=} [properties] Properties to set
         * @returns {net.msg_set_background} msg_set_background instance
         */
        msg_set_background.create = function create(properties) {
            return new msg_set_background(properties);
        };

        /**
         * Encodes the specified msg_set_background message. Does not implicitly {@link net.msg_set_background.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_background
         * @static
         * @param {net.Imsg_set_background} message msg_set_background message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_background.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.is_back != null && Object.hasOwnProperty.call(message, "is_back"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.is_back);
            return writer;
        };

        /**
         * Encodes the specified msg_set_background message, length delimited. Does not implicitly {@link net.msg_set_background.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_background
         * @static
         * @param {net.Imsg_set_background} message msg_set_background message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_background.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_background message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_background
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_background} msg_set_background
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_background.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_background();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.is_back = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_background message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_background
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_background} msg_set_background
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_background.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_background message.
         * @function verify
         * @memberof net.msg_set_background
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_background.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.is_back != null && message.hasOwnProperty("is_back"))
                if (!$util.isInteger(message.is_back))
                    return "is_back: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_background message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_background
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_background} msg_set_background
         */
        msg_set_background.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_background)
                return object;
            var message = new $root.net.msg_set_background();
            if (object.is_back != null)
                message.is_back = object.is_back | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_background message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_background
         * @static
         * @param {net.msg_set_background} message msg_set_background
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_background.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.is_back = 0;
            if (message.is_back != null && message.hasOwnProperty("is_back"))
                object.is_back = message.is_back;
            return object;
        };

        /**
         * Converts this msg_set_background to JSON.
         * @function toJSON
         * @memberof net.msg_set_background
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_background.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_background;
    })();

    net.msg_confirm_hasread_msg = (function() {

        /**
         * Properties of a msg_confirm_hasread_msg.
         * @memberof net
         * @interface Imsg_confirm_hasread_msg
         * @property {number|Long|null} [chatkey] msg_confirm_hasread_msg chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_confirm_hasread_msg chatmsgno_list
         */

        /**
         * Constructs a new msg_confirm_hasread_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_hasread_msg.
         * @implements Imsg_confirm_hasread_msg
         * @constructor
         * @param {net.Imsg_confirm_hasread_msg=} [properties] Properties to set
         */
        function msg_confirm_hasread_msg(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_hasread_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_hasread_msg
         * @instance
         */
        msg_confirm_hasread_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_hasread_msg chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_confirm_hasread_msg
         * @instance
         */
        msg_confirm_hasread_msg.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Creates a new msg_confirm_hasread_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {net.Imsg_confirm_hasread_msg=} [properties] Properties to set
         * @returns {net.msg_confirm_hasread_msg} msg_confirm_hasread_msg instance
         */
        msg_confirm_hasread_msg.create = function create(properties) {
            return new msg_confirm_hasread_msg(properties);
        };

        /**
         * Encodes the specified msg_confirm_hasread_msg message. Does not implicitly {@link net.msg_confirm_hasread_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {net.Imsg_confirm_hasread_msg} message msg_confirm_hasread_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_hasread_msg message, length delimited. Does not implicitly {@link net.msg_confirm_hasread_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {net.Imsg_confirm_hasread_msg} message msg_confirm_hasread_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_hasread_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_hasread_msg} msg_confirm_hasread_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_hasread_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_hasread_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_hasread_msg} msg_confirm_hasread_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_hasread_msg message.
         * @function verify
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_hasread_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno_list != null && message.hasOwnProperty("chatmsgno_list")) {
                if (!Array.isArray(message.chatmsgno_list))
                    return "chatmsgno_list: array expected";
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    if (!$util.isInteger(message.chatmsgno_list[i]))
                        return "chatmsgno_list: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_confirm_hasread_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_hasread_msg} msg_confirm_hasread_msg
         */
        msg_confirm_hasread_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_hasread_msg)
                return object;
            var message = new $root.net.msg_confirm_hasread_msg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno_list) {
                if (!Array.isArray(object.chatmsgno_list))
                    throw TypeError(".net.msg_confirm_hasread_msg.chatmsgno_list: array expected");
                message.chatmsgno_list = [];
                for (var i = 0; i < object.chatmsgno_list.length; ++i)
                    message.chatmsgno_list[i] = object.chatmsgno_list[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_hasread_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {net.msg_confirm_hasread_msg} message msg_confirm_hasread_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_hasread_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatmsgno_list = [];
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno_list && message.chatmsgno_list.length) {
                object.chatmsgno_list = [];
                for (var j = 0; j < message.chatmsgno_list.length; ++j)
                    object.chatmsgno_list[j] = message.chatmsgno_list[j];
            }
            return object;
        };

        /**
         * Converts this msg_confirm_hasread_msg to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_hasread_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_hasread_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_hasread_msg;
    })();

    net.msg_confirm_hasread_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_hasread_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_hasread_msg_rep
         * @property {number|null} [result] msg_confirm_hasread_msg_rep result
         * @property {number|Long|null} [chatkey] msg_confirm_hasread_msg_rep chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_confirm_hasread_msg_rep chatmsgno_list
         */

        /**
         * Constructs a new msg_confirm_hasread_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_hasread_msg_rep.
         * @implements Imsg_confirm_hasread_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_hasread_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_hasread_msg_rep(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_hasread_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.result = 0;

        /**
         * msg_confirm_hasread_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_hasread_msg_rep chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Creates a new msg_confirm_hasread_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {net.Imsg_confirm_hasread_msg_rep=} [properties] Properties to set
         * @returns {net.msg_confirm_hasread_msg_rep} msg_confirm_hasread_msg_rep instance
         */
        msg_confirm_hasread_msg_rep.create = function create(properties) {
            return new msg_confirm_hasread_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_confirm_hasread_msg_rep message. Does not implicitly {@link net.msg_confirm_hasread_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {net.Imsg_confirm_hasread_msg_rep} message msg_confirm_hasread_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_hasread_msg_rep message, length delimited. Does not implicitly {@link net.msg_confirm_hasread_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {net.Imsg_confirm_hasread_msg_rep} message msg_confirm_hasread_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_hasread_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_hasread_msg_rep} msg_confirm_hasread_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_hasread_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_hasread_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_hasread_msg_rep} msg_confirm_hasread_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_hasread_msg_rep message.
         * @function verify
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_hasread_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno_list != null && message.hasOwnProperty("chatmsgno_list")) {
                if (!Array.isArray(message.chatmsgno_list))
                    return "chatmsgno_list: array expected";
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    if (!$util.isInteger(message.chatmsgno_list[i]))
                        return "chatmsgno_list: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_confirm_hasread_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_hasread_msg_rep} msg_confirm_hasread_msg_rep
         */
        msg_confirm_hasread_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_hasread_msg_rep)
                return object;
            var message = new $root.net.msg_confirm_hasread_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno_list) {
                if (!Array.isArray(object.chatmsgno_list))
                    throw TypeError(".net.msg_confirm_hasread_msg_rep.chatmsgno_list: array expected");
                message.chatmsgno_list = [];
                for (var i = 0; i < object.chatmsgno_list.length; ++i)
                    message.chatmsgno_list[i] = object.chatmsgno_list[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_hasread_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {net.msg_confirm_hasread_msg_rep} message msg_confirm_hasread_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_hasread_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatmsgno_list = [];
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno_list && message.chatmsgno_list.length) {
                object.chatmsgno_list = [];
                for (var j = 0; j < message.chatmsgno_list.length; ++j)
                    object.chatmsgno_list[j] = message.chatmsgno_list[j];
            }
            return object;
        };

        /**
         * Converts this msg_confirm_hasread_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_hasread_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_hasread_msg_rep;
    })();

    net.msg_get_hasread_list = (function() {

        /**
         * Properties of a msg_get_hasread_list.
         * @memberof net
         * @interface Imsg_get_hasread_list
         * @property {number|Long|null} [chatkey] msg_get_hasread_list chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_get_hasread_list chatmsgno_list
         */

        /**
         * Constructs a new msg_get_hasread_list.
         * @memberof net
         * @classdesc Represents a msg_get_hasread_list.
         * @implements Imsg_get_hasread_list
         * @constructor
         * @param {net.Imsg_get_hasread_list=} [properties] Properties to set
         */
        function msg_get_hasread_list(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_hasread_list chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_hasread_list
         * @instance
         */
        msg_get_hasread_list.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_hasread_list chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_get_hasread_list
         * @instance
         */
        msg_get_hasread_list.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Creates a new msg_get_hasread_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {net.Imsg_get_hasread_list=} [properties] Properties to set
         * @returns {net.msg_get_hasread_list} msg_get_hasread_list instance
         */
        msg_get_hasread_list.create = function create(properties) {
            return new msg_get_hasread_list(properties);
        };

        /**
         * Encodes the specified msg_get_hasread_list message. Does not implicitly {@link net.msg_get_hasread_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {net.Imsg_get_hasread_list} message msg_get_hasread_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_get_hasread_list message, length delimited. Does not implicitly {@link net.msg_get_hasread_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {net.Imsg_get_hasread_list} message msg_get_hasread_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_hasread_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_hasread_list} msg_get_hasread_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_hasread_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_hasread_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_hasread_list} msg_get_hasread_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_hasread_list message.
         * @function verify
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_hasread_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno_list != null && message.hasOwnProperty("chatmsgno_list")) {
                if (!Array.isArray(message.chatmsgno_list))
                    return "chatmsgno_list: array expected";
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    if (!$util.isInteger(message.chatmsgno_list[i]))
                        return "chatmsgno_list: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_get_hasread_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_hasread_list} msg_get_hasread_list
         */
        msg_get_hasread_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_hasread_list)
                return object;
            var message = new $root.net.msg_get_hasread_list();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno_list) {
                if (!Array.isArray(object.chatmsgno_list))
                    throw TypeError(".net.msg_get_hasread_list.chatmsgno_list: array expected");
                message.chatmsgno_list = [];
                for (var i = 0; i < object.chatmsgno_list.length; ++i)
                    message.chatmsgno_list[i] = object.chatmsgno_list[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_hasread_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {net.msg_get_hasread_list} message msg_get_hasread_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_hasread_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatmsgno_list = [];
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno_list && message.chatmsgno_list.length) {
                object.chatmsgno_list = [];
                for (var j = 0; j < message.chatmsgno_list.length; ++j)
                    object.chatmsgno_list[j] = message.chatmsgno_list[j];
            }
            return object;
        };

        /**
         * Converts this msg_get_hasread_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_hasread_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_hasread_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_hasread_list;
    })();

    net.msg_get_hasread_list_rep = (function() {

        /**
         * Properties of a msg_get_hasread_list_rep.
         * @memberof net
         * @interface Imsg_get_hasread_list_rep
         * @property {number|Long|null} [chatkey] msg_get_hasread_list_rep chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_get_hasread_list_rep chatmsgno_list
         */

        /**
         * Constructs a new msg_get_hasread_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_hasread_list_rep.
         * @implements Imsg_get_hasread_list_rep
         * @constructor
         * @param {net.Imsg_get_hasread_list_rep=} [properties] Properties to set
         */
        function msg_get_hasread_list_rep(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_hasread_list_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_hasread_list_rep
         * @instance
         */
        msg_get_hasread_list_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_hasread_list_rep chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_get_hasread_list_rep
         * @instance
         */
        msg_get_hasread_list_rep.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Creates a new msg_get_hasread_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {net.Imsg_get_hasread_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_hasread_list_rep} msg_get_hasread_list_rep instance
         */
        msg_get_hasread_list_rep.create = function create(properties) {
            return new msg_get_hasread_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_hasread_list_rep message. Does not implicitly {@link net.msg_get_hasread_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {net.Imsg_get_hasread_list_rep} message msg_get_hasread_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_get_hasread_list_rep message, length delimited. Does not implicitly {@link net.msg_get_hasread_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {net.Imsg_get_hasread_list_rep} message msg_get_hasread_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_hasread_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_hasread_list_rep} msg_get_hasread_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_hasread_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_hasread_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_hasread_list_rep} msg_get_hasread_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_hasread_list_rep message.
         * @function verify
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_hasread_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno_list != null && message.hasOwnProperty("chatmsgno_list")) {
                if (!Array.isArray(message.chatmsgno_list))
                    return "chatmsgno_list: array expected";
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    if (!$util.isInteger(message.chatmsgno_list[i]))
                        return "chatmsgno_list: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_get_hasread_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_hasread_list_rep} msg_get_hasread_list_rep
         */
        msg_get_hasread_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_hasread_list_rep)
                return object;
            var message = new $root.net.msg_get_hasread_list_rep();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno_list) {
                if (!Array.isArray(object.chatmsgno_list))
                    throw TypeError(".net.msg_get_hasread_list_rep.chatmsgno_list: array expected");
                message.chatmsgno_list = [];
                for (var i = 0; i < object.chatmsgno_list.length; ++i)
                    message.chatmsgno_list[i] = object.chatmsgno_list[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_hasread_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {net.msg_get_hasread_list_rep} message msg_get_hasread_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_hasread_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chatmsgno_list = [];
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno_list && message.chatmsgno_list.length) {
                object.chatmsgno_list = [];
                for (var j = 0; j < message.chatmsgno_list.length; ++j)
                    object.chatmsgno_list[j] = message.chatmsgno_list[j];
            }
            return object;
        };

        /**
         * Converts this msg_get_hasread_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_hasread_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_hasread_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_hasread_list_rep;
    })();

    net.msg_transfer_account = (function() {

        /**
         * Properties of a msg_transfer_account.
         * @memberof net
         * @interface Imsg_transfer_account
         * @property {Uint8Array|null} [target_phonenum] msg_transfer_account target_phonenum
         * @property {number|null} [trans_type] msg_transfer_account trans_type
         * @property {number|null} [trans_amount] msg_transfer_account trans_amount
         * @property {Uint8Array|null} [remarks] msg_transfer_account remarks
         * @property {Uint8Array|null} [authcode] msg_transfer_account authcode
         * @property {number|null} [cointype] msg_transfer_account cointype
         */

        /**
         * Constructs a new msg_transfer_account.
         * @memberof net
         * @classdesc Represents a msg_transfer_account.
         * @implements Imsg_transfer_account
         * @constructor
         * @param {net.Imsg_transfer_account=} [properties] Properties to set
         */
        function msg_transfer_account(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_transfer_account target_phonenum.
         * @member {Uint8Array} target_phonenum
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.target_phonenum = $util.newBuffer([]);

        /**
         * msg_transfer_account trans_type.
         * @member {number} trans_type
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.trans_type = 0;

        /**
         * msg_transfer_account trans_amount.
         * @member {number} trans_amount
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.trans_amount = 0;

        /**
         * msg_transfer_account remarks.
         * @member {Uint8Array} remarks
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.remarks = $util.newBuffer([]);

        /**
         * msg_transfer_account authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.authcode = $util.newBuffer([]);

        /**
         * msg_transfer_account cointype.
         * @member {number} cointype
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.cointype = 0;

        /**
         * Creates a new msg_transfer_account instance using the specified properties.
         * @function create
         * @memberof net.msg_transfer_account
         * @static
         * @param {net.Imsg_transfer_account=} [properties] Properties to set
         * @returns {net.msg_transfer_account} msg_transfer_account instance
         */
        msg_transfer_account.create = function create(properties) {
            return new msg_transfer_account(properties);
        };

        /**
         * Encodes the specified msg_transfer_account message. Does not implicitly {@link net.msg_transfer_account.verify|verify} messages.
         * @function encode
         * @memberof net.msg_transfer_account
         * @static
         * @param {net.Imsg_transfer_account} message msg_transfer_account message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.target_phonenum != null && Object.hasOwnProperty.call(message, "target_phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.target_phonenum);
            if (message.trans_type != null && Object.hasOwnProperty.call(message, "trans_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.trans_type);
            if (message.trans_amount != null && Object.hasOwnProperty.call(message, "trans_amount"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.trans_amount);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.remarks);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.authcode);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cointype);
            return writer;
        };

        /**
         * Encodes the specified msg_transfer_account message, length delimited. Does not implicitly {@link net.msg_transfer_account.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_transfer_account
         * @static
         * @param {net.Imsg_transfer_account} message msg_transfer_account message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_transfer_account message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_transfer_account
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_transfer_account} msg_transfer_account
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_transfer_account();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.target_phonenum = reader.bytes();
                    break;
                case 2:
                    message.trans_type = reader.int32();
                    break;
                case 3:
                    message.trans_amount = reader.int32();
                    break;
                case 4:
                    message.remarks = reader.bytes();
                    break;
                case 5:
                    message.authcode = reader.bytes();
                    break;
                case 6:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_transfer_account message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_transfer_account
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_transfer_account} msg_transfer_account
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_transfer_account message.
         * @function verify
         * @memberof net.msg_transfer_account
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_transfer_account.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.target_phonenum != null && message.hasOwnProperty("target_phonenum"))
                if (!(message.target_phonenum && typeof message.target_phonenum.length === "number" || $util.isString(message.target_phonenum)))
                    return "target_phonenum: buffer expected";
            if (message.trans_type != null && message.hasOwnProperty("trans_type"))
                if (!$util.isInteger(message.trans_type))
                    return "trans_type: integer expected";
            if (message.trans_amount != null && message.hasOwnProperty("trans_amount"))
                if (!$util.isInteger(message.trans_amount))
                    return "trans_amount: integer expected";
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                if (!(message.remarks && typeof message.remarks.length === "number" || $util.isString(message.remarks)))
                    return "remarks: buffer expected";
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                if (!(message.authcode && typeof message.authcode.length === "number" || $util.isString(message.authcode)))
                    return "authcode: buffer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_transfer_account message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_transfer_account
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_transfer_account} msg_transfer_account
         */
        msg_transfer_account.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_transfer_account)
                return object;
            var message = new $root.net.msg_transfer_account();
            if (object.target_phonenum != null)
                if (typeof object.target_phonenum === "string")
                    $util.base64.decode(object.target_phonenum, message.target_phonenum = $util.newBuffer($util.base64.length(object.target_phonenum)), 0);
                else if (object.target_phonenum.length)
                    message.target_phonenum = object.target_phonenum;
            if (object.trans_type != null)
                message.trans_type = object.trans_type | 0;
            if (object.trans_amount != null)
                message.trans_amount = object.trans_amount | 0;
            if (object.remarks != null)
                if (typeof object.remarks === "string")
                    $util.base64.decode(object.remarks, message.remarks = $util.newBuffer($util.base64.length(object.remarks)), 0);
                else if (object.remarks.length)
                    message.remarks = object.remarks;
            if (object.authcode != null)
                if (typeof object.authcode === "string")
                    $util.base64.decode(object.authcode, message.authcode = $util.newBuffer($util.base64.length(object.authcode)), 0);
                else if (object.authcode.length)
                    message.authcode = object.authcode;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_transfer_account message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_transfer_account
         * @static
         * @param {net.msg_transfer_account} message msg_transfer_account
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_transfer_account.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.target_phonenum = "";
                else {
                    object.target_phonenum = [];
                    if (options.bytes !== Array)
                        object.target_phonenum = $util.newBuffer(object.target_phonenum);
                }
                object.trans_type = 0;
                object.trans_amount = 0;
                if (options.bytes === String)
                    object.remarks = "";
                else {
                    object.remarks = [];
                    if (options.bytes !== Array)
                        object.remarks = $util.newBuffer(object.remarks);
                }
                if (options.bytes === String)
                    object.authcode = "";
                else {
                    object.authcode = [];
                    if (options.bytes !== Array)
                        object.authcode = $util.newBuffer(object.authcode);
                }
                object.cointype = 0;
            }
            if (message.target_phonenum != null && message.hasOwnProperty("target_phonenum"))
                object.target_phonenum = options.bytes === String ? $util.base64.encode(message.target_phonenum, 0, message.target_phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.target_phonenum) : message.target_phonenum;
            if (message.trans_type != null && message.hasOwnProperty("trans_type"))
                object.trans_type = message.trans_type;
            if (message.trans_amount != null && message.hasOwnProperty("trans_amount"))
                object.trans_amount = message.trans_amount;
            if (message.remarks != null && message.hasOwnProperty("remarks"))
                object.remarks = options.bytes === String ? $util.base64.encode(message.remarks, 0, message.remarks.length) : options.bytes === Array ? Array.prototype.slice.call(message.remarks) : message.remarks;
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                object.authcode = options.bytes === String ? $util.base64.encode(message.authcode, 0, message.authcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.authcode) : message.authcode;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            return object;
        };

        /**
         * Converts this msg_transfer_account to JSON.
         * @function toJSON
         * @memberof net.msg_transfer_account
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_transfer_account.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_transfer_account;
    })();

    net.msg_transfer_account_rep = (function() {

        /**
         * Properties of a msg_transfer_account_rep.
         * @memberof net
         * @interface Imsg_transfer_account_rep
         * @property {number|null} [result] msg_transfer_account_rep result
         */

        /**
         * Constructs a new msg_transfer_account_rep.
         * @memberof net
         * @classdesc Represents a msg_transfer_account_rep.
         * @implements Imsg_transfer_account_rep
         * @constructor
         * @param {net.Imsg_transfer_account_rep=} [properties] Properties to set
         */
        function msg_transfer_account_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_transfer_account_rep result.
         * @member {number} result
         * @memberof net.msg_transfer_account_rep
         * @instance
         */
        msg_transfer_account_rep.prototype.result = 0;

        /**
         * Creates a new msg_transfer_account_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {net.Imsg_transfer_account_rep=} [properties] Properties to set
         * @returns {net.msg_transfer_account_rep} msg_transfer_account_rep instance
         */
        msg_transfer_account_rep.create = function create(properties) {
            return new msg_transfer_account_rep(properties);
        };

        /**
         * Encodes the specified msg_transfer_account_rep message. Does not implicitly {@link net.msg_transfer_account_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {net.Imsg_transfer_account_rep} message msg_transfer_account_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_transfer_account_rep message, length delimited. Does not implicitly {@link net.msg_transfer_account_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {net.Imsg_transfer_account_rep} message msg_transfer_account_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_transfer_account_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_transfer_account_rep} msg_transfer_account_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_transfer_account_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_transfer_account_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_transfer_account_rep} msg_transfer_account_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_transfer_account_rep message.
         * @function verify
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_transfer_account_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_transfer_account_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_transfer_account_rep} msg_transfer_account_rep
         */
        msg_transfer_account_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_transfer_account_rep)
                return object;
            var message = new $root.net.msg_transfer_account_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_transfer_account_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {net.msg_transfer_account_rep} message msg_transfer_account_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_transfer_account_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_transfer_account_rep to JSON.
         * @function toJSON
         * @memberof net.msg_transfer_account_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_transfer_account_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_transfer_account_rep;
    })();

    net.msg_get_online_list = (function() {

        /**
         * Properties of a msg_get_online_list.
         * @memberof net
         * @interface Imsg_get_online_list
         * @property {Array.<number>|null} [uidlist] msg_get_online_list uidlist
         */

        /**
         * Constructs a new msg_get_online_list.
         * @memberof net
         * @classdesc Represents a msg_get_online_list.
         * @implements Imsg_get_online_list
         * @constructor
         * @param {net.Imsg_get_online_list=} [properties] Properties to set
         */
        function msg_get_online_list(properties) {
            this.uidlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_list uidlist.
         * @member {Array.<number>} uidlist
         * @memberof net.msg_get_online_list
         * @instance
         */
        msg_get_online_list.prototype.uidlist = $util.emptyArray;

        /**
         * Creates a new msg_get_online_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_online_list
         * @static
         * @param {net.Imsg_get_online_list=} [properties] Properties to set
         * @returns {net.msg_get_online_list} msg_get_online_list instance
         */
        msg_get_online_list.create = function create(properties) {
            return new msg_get_online_list(properties);
        };

        /**
         * Encodes the specified msg_get_online_list message. Does not implicitly {@link net.msg_get_online_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_list
         * @static
         * @param {net.Imsg_get_online_list} message msg_get_online_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uidlist != null && message.uidlist.length)
                for (var i = 0; i < message.uidlist.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uidlist[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_get_online_list message, length delimited. Does not implicitly {@link net.msg_get_online_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_online_list
         * @static
         * @param {net.Imsg_get_online_list} message msg_get_online_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_online_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_list} msg_get_online_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uidlist && message.uidlist.length))
                        message.uidlist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uidlist.push(reader.int32());
                    } else
                        message.uidlist.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_online_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_online_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_online_list} msg_get_online_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_online_list message.
         * @function verify
         * @memberof net.msg_get_online_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_online_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uidlist != null && message.hasOwnProperty("uidlist")) {
                if (!Array.isArray(message.uidlist))
                    return "uidlist: array expected";
                for (var i = 0; i < message.uidlist.length; ++i)
                    if (!$util.isInteger(message.uidlist[i]))
                        return "uidlist: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_get_online_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_online_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_online_list} msg_get_online_list
         */
        msg_get_online_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_online_list)
                return object;
            var message = new $root.net.msg_get_online_list();
            if (object.uidlist) {
                if (!Array.isArray(object.uidlist))
                    throw TypeError(".net.msg_get_online_list.uidlist: array expected");
                message.uidlist = [];
                for (var i = 0; i < object.uidlist.length; ++i)
                    message.uidlist[i] = object.uidlist[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_online_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_online_list
         * @static
         * @param {net.msg_get_online_list} message msg_get_online_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_online_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uidlist = [];
            if (message.uidlist && message.uidlist.length) {
                object.uidlist = [];
                for (var j = 0; j < message.uidlist.length; ++j)
                    object.uidlist[j] = message.uidlist[j];
            }
            return object;
        };

        /**
         * Converts this msg_get_online_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_online_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_online_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_online_list;
    })();

    net.msg_get_online_list_rep = (function() {

        /**
         * Properties of a msg_get_online_list_rep.
         * @memberof net
         * @interface Imsg_get_online_list_rep
         * @property {Array.<number>|null} [onlinelist] msg_get_online_list_rep onlinelist
         */

        /**
         * Constructs a new msg_get_online_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_online_list_rep.
         * @implements Imsg_get_online_list_rep
         * @constructor
         * @param {net.Imsg_get_online_list_rep=} [properties] Properties to set
         */
        function msg_get_online_list_rep(properties) {
            this.onlinelist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_list_rep onlinelist.
         * @member {Array.<number>} onlinelist
         * @memberof net.msg_get_online_list_rep
         * @instance
         */
        msg_get_online_list_rep.prototype.onlinelist = $util.emptyArray;

        /**
         * Creates a new msg_get_online_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {net.Imsg_get_online_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_online_list_rep} msg_get_online_list_rep instance
         */
        msg_get_online_list_rep.create = function create(properties) {
            return new msg_get_online_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_online_list_rep message. Does not implicitly {@link net.msg_get_online_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {net.Imsg_get_online_list_rep} message msg_get_online_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.onlinelist != null && message.onlinelist.length)
                for (var i = 0; i < message.onlinelist.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.onlinelist[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_get_online_list_rep message, length delimited. Does not implicitly {@link net.msg_get_online_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {net.Imsg_get_online_list_rep} message msg_get_online_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_online_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_list_rep} msg_get_online_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.onlinelist && message.onlinelist.length))
                        message.onlinelist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.onlinelist.push(reader.int32());
                    } else
                        message.onlinelist.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_online_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_online_list_rep} msg_get_online_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_online_list_rep message.
         * @function verify
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_online_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.onlinelist != null && message.hasOwnProperty("onlinelist")) {
                if (!Array.isArray(message.onlinelist))
                    return "onlinelist: array expected";
                for (var i = 0; i < message.onlinelist.length; ++i)
                    if (!$util.isInteger(message.onlinelist[i]))
                        return "onlinelist: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_get_online_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_online_list_rep} msg_get_online_list_rep
         */
        msg_get_online_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_online_list_rep)
                return object;
            var message = new $root.net.msg_get_online_list_rep();
            if (object.onlinelist) {
                if (!Array.isArray(object.onlinelist))
                    throw TypeError(".net.msg_get_online_list_rep.onlinelist: array expected");
                message.onlinelist = [];
                for (var i = 0; i < object.onlinelist.length; ++i)
                    message.onlinelist[i] = object.onlinelist[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_online_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {net.msg_get_online_list_rep} message msg_get_online_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_online_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.onlinelist = [];
            if (message.onlinelist && message.onlinelist.length) {
                object.onlinelist = [];
                for (var j = 0; j < message.onlinelist.length; ++j)
                    object.onlinelist[j] = message.onlinelist[j];
            }
            return object;
        };

        /**
         * Converts this msg_get_online_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_online_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_online_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_online_list_rep;
    })();

    net.msg_get_money_change_list = (function() {

        /**
         * Properties of a msg_get_money_change_list.
         * @memberof net
         * @interface Imsg_get_money_change_list
         */

        /**
         * Constructs a new msg_get_money_change_list.
         * @memberof net
         * @classdesc Represents a msg_get_money_change_list.
         * @implements Imsg_get_money_change_list
         * @constructor
         * @param {net.Imsg_get_money_change_list=} [properties] Properties to set
         */
        function msg_get_money_change_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_money_change_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {net.Imsg_get_money_change_list=} [properties] Properties to set
         * @returns {net.msg_get_money_change_list} msg_get_money_change_list instance
         */
        msg_get_money_change_list.create = function create(properties) {
            return new msg_get_money_change_list(properties);
        };

        /**
         * Encodes the specified msg_get_money_change_list message. Does not implicitly {@link net.msg_get_money_change_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {net.Imsg_get_money_change_list} message msg_get_money_change_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_money_change_list message, length delimited. Does not implicitly {@link net.msg_get_money_change_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {net.Imsg_get_money_change_list} message msg_get_money_change_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_money_change_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_money_change_list} msg_get_money_change_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_money_change_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_money_change_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_money_change_list} msg_get_money_change_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_money_change_list message.
         * @function verify
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_money_change_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_money_change_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_money_change_list} msg_get_money_change_list
         */
        msg_get_money_change_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_money_change_list)
                return object;
            return new $root.net.msg_get_money_change_list();
        };

        /**
         * Creates a plain object from a msg_get_money_change_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {net.msg_get_money_change_list} message msg_get_money_change_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_money_change_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_money_change_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_money_change_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_money_change_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_money_change_list;
    })();

    net.msg_get_money_change_list_rep = (function() {

        /**
         * Properties of a msg_get_money_change_list_rep.
         * @memberof net
         * @interface Imsg_get_money_change_list_rep
         * @property {Array.<net.Imoney_change_info>|null} [money_list] msg_get_money_change_list_rep money_list
         */

        /**
         * Constructs a new msg_get_money_change_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_money_change_list_rep.
         * @implements Imsg_get_money_change_list_rep
         * @constructor
         * @param {net.Imsg_get_money_change_list_rep=} [properties] Properties to set
         */
        function msg_get_money_change_list_rep(properties) {
            this.money_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_money_change_list_rep money_list.
         * @member {Array.<net.Imoney_change_info>} money_list
         * @memberof net.msg_get_money_change_list_rep
         * @instance
         */
        msg_get_money_change_list_rep.prototype.money_list = $util.emptyArray;

        /**
         * Creates a new msg_get_money_change_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {net.Imsg_get_money_change_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_money_change_list_rep} msg_get_money_change_list_rep instance
         */
        msg_get_money_change_list_rep.create = function create(properties) {
            return new msg_get_money_change_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_money_change_list_rep message. Does not implicitly {@link net.msg_get_money_change_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {net.Imsg_get_money_change_list_rep} message msg_get_money_change_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.money_list != null && message.money_list.length)
                for (var i = 0; i < message.money_list.length; ++i)
                    $root.net.money_change_info.encode(message.money_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_money_change_list_rep message, length delimited. Does not implicitly {@link net.msg_get_money_change_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {net.Imsg_get_money_change_list_rep} message msg_get_money_change_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_money_change_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_money_change_list_rep} msg_get_money_change_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_money_change_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.money_list && message.money_list.length))
                        message.money_list = [];
                    message.money_list.push($root.net.money_change_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_money_change_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_money_change_list_rep} msg_get_money_change_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_money_change_list_rep message.
         * @function verify
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_money_change_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.money_list != null && message.hasOwnProperty("money_list")) {
                if (!Array.isArray(message.money_list))
                    return "money_list: array expected";
                for (var i = 0; i < message.money_list.length; ++i) {
                    var error = $root.net.money_change_info.verify(message.money_list[i]);
                    if (error)
                        return "money_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_money_change_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_money_change_list_rep} msg_get_money_change_list_rep
         */
        msg_get_money_change_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_money_change_list_rep)
                return object;
            var message = new $root.net.msg_get_money_change_list_rep();
            if (object.money_list) {
                if (!Array.isArray(object.money_list))
                    throw TypeError(".net.msg_get_money_change_list_rep.money_list: array expected");
                message.money_list = [];
                for (var i = 0; i < object.money_list.length; ++i) {
                    if (typeof object.money_list[i] !== "object")
                        throw TypeError(".net.msg_get_money_change_list_rep.money_list: object expected");
                    message.money_list[i] = $root.net.money_change_info.fromObject(object.money_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_money_change_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {net.msg_get_money_change_list_rep} message msg_get_money_change_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_money_change_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.money_list = [];
            if (message.money_list && message.money_list.length) {
                object.money_list = [];
                for (var j = 0; j < message.money_list.length; ++j)
                    object.money_list[j] = $root.net.money_change_info.toObject(message.money_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_money_change_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_money_change_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_money_change_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_money_change_list_rep;
    })();

    net.msg_get_pay_auth_code = (function() {

        /**
         * Properties of a msg_get_pay_auth_code.
         * @memberof net
         * @interface Imsg_get_pay_auth_code
         * @property {Uint8Array|null} [paypasswd] msg_get_pay_auth_code paypasswd
         */

        /**
         * Constructs a new msg_get_pay_auth_code.
         * @memberof net
         * @classdesc Represents a msg_get_pay_auth_code.
         * @implements Imsg_get_pay_auth_code
         * @constructor
         * @param {net.Imsg_get_pay_auth_code=} [properties] Properties to set
         */
        function msg_get_pay_auth_code(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_pay_auth_code paypasswd.
         * @member {Uint8Array} paypasswd
         * @memberof net.msg_get_pay_auth_code
         * @instance
         */
        msg_get_pay_auth_code.prototype.paypasswd = $util.newBuffer([]);

        /**
         * Creates a new msg_get_pay_auth_code instance using the specified properties.
         * @function create
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {net.Imsg_get_pay_auth_code=} [properties] Properties to set
         * @returns {net.msg_get_pay_auth_code} msg_get_pay_auth_code instance
         */
        msg_get_pay_auth_code.create = function create(properties) {
            return new msg_get_pay_auth_code(properties);
        };

        /**
         * Encodes the specified msg_get_pay_auth_code message. Does not implicitly {@link net.msg_get_pay_auth_code.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {net.Imsg_get_pay_auth_code} message msg_get_pay_auth_code message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.paypasswd != null && Object.hasOwnProperty.call(message, "paypasswd"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.paypasswd);
            return writer;
        };

        /**
         * Encodes the specified msg_get_pay_auth_code message, length delimited. Does not implicitly {@link net.msg_get_pay_auth_code.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {net.Imsg_get_pay_auth_code} message msg_get_pay_auth_code message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_pay_auth_code message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_pay_auth_code} msg_get_pay_auth_code
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_pay_auth_code();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.paypasswd = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_pay_auth_code message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_pay_auth_code} msg_get_pay_auth_code
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_pay_auth_code message.
         * @function verify
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_pay_auth_code.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.paypasswd != null && message.hasOwnProperty("paypasswd"))
                if (!(message.paypasswd && typeof message.paypasswd.length === "number" || $util.isString(message.paypasswd)))
                    return "paypasswd: buffer expected";
            return null;
        };

        /**
         * Creates a msg_get_pay_auth_code message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_pay_auth_code} msg_get_pay_auth_code
         */
        msg_get_pay_auth_code.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_pay_auth_code)
                return object;
            var message = new $root.net.msg_get_pay_auth_code();
            if (object.paypasswd != null)
                if (typeof object.paypasswd === "string")
                    $util.base64.decode(object.paypasswd, message.paypasswd = $util.newBuffer($util.base64.length(object.paypasswd)), 0);
                else if (object.paypasswd.length)
                    message.paypasswd = object.paypasswd;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_pay_auth_code message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {net.msg_get_pay_auth_code} message msg_get_pay_auth_code
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_pay_auth_code.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.paypasswd = "";
                else {
                    object.paypasswd = [];
                    if (options.bytes !== Array)
                        object.paypasswd = $util.newBuffer(object.paypasswd);
                }
            if (message.paypasswd != null && message.hasOwnProperty("paypasswd"))
                object.paypasswd = options.bytes === String ? $util.base64.encode(message.paypasswd, 0, message.paypasswd.length) : options.bytes === Array ? Array.prototype.slice.call(message.paypasswd) : message.paypasswd;
            return object;
        };

        /**
         * Converts this msg_get_pay_auth_code to JSON.
         * @function toJSON
         * @memberof net.msg_get_pay_auth_code
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_pay_auth_code.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_pay_auth_code;
    })();

    net.msg_get_pay_auth_code_rep = (function() {

        /**
         * Properties of a msg_get_pay_auth_code_rep.
         * @memberof net
         * @interface Imsg_get_pay_auth_code_rep
         * @property {number|null} [result] msg_get_pay_auth_code_rep result
         * @property {Uint8Array|null} [auth_code] msg_get_pay_auth_code_rep auth_code
         */

        /**
         * Constructs a new msg_get_pay_auth_code_rep.
         * @memberof net
         * @classdesc Represents a msg_get_pay_auth_code_rep.
         * @implements Imsg_get_pay_auth_code_rep
         * @constructor
         * @param {net.Imsg_get_pay_auth_code_rep=} [properties] Properties to set
         */
        function msg_get_pay_auth_code_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_pay_auth_code_rep result.
         * @member {number} result
         * @memberof net.msg_get_pay_auth_code_rep
         * @instance
         */
        msg_get_pay_auth_code_rep.prototype.result = 0;

        /**
         * msg_get_pay_auth_code_rep auth_code.
         * @member {Uint8Array} auth_code
         * @memberof net.msg_get_pay_auth_code_rep
         * @instance
         */
        msg_get_pay_auth_code_rep.prototype.auth_code = $util.newBuffer([]);

        /**
         * Creates a new msg_get_pay_auth_code_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {net.Imsg_get_pay_auth_code_rep=} [properties] Properties to set
         * @returns {net.msg_get_pay_auth_code_rep} msg_get_pay_auth_code_rep instance
         */
        msg_get_pay_auth_code_rep.create = function create(properties) {
            return new msg_get_pay_auth_code_rep(properties);
        };

        /**
         * Encodes the specified msg_get_pay_auth_code_rep message. Does not implicitly {@link net.msg_get_pay_auth_code_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {net.Imsg_get_pay_auth_code_rep} message msg_get_pay_auth_code_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.auth_code != null && Object.hasOwnProperty.call(message, "auth_code"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.auth_code);
            return writer;
        };

        /**
         * Encodes the specified msg_get_pay_auth_code_rep message, length delimited. Does not implicitly {@link net.msg_get_pay_auth_code_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {net.Imsg_get_pay_auth_code_rep} message msg_get_pay_auth_code_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_pay_auth_code_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_pay_auth_code_rep} msg_get_pay_auth_code_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_pay_auth_code_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.auth_code = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_pay_auth_code_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_pay_auth_code_rep} msg_get_pay_auth_code_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_pay_auth_code_rep message.
         * @function verify
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_pay_auth_code_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.auth_code != null && message.hasOwnProperty("auth_code"))
                if (!(message.auth_code && typeof message.auth_code.length === "number" || $util.isString(message.auth_code)))
                    return "auth_code: buffer expected";
            return null;
        };

        /**
         * Creates a msg_get_pay_auth_code_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_pay_auth_code_rep} msg_get_pay_auth_code_rep
         */
        msg_get_pay_auth_code_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_pay_auth_code_rep)
                return object;
            var message = new $root.net.msg_get_pay_auth_code_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.auth_code != null)
                if (typeof object.auth_code === "string")
                    $util.base64.decode(object.auth_code, message.auth_code = $util.newBuffer($util.base64.length(object.auth_code)), 0);
                else if (object.auth_code.length)
                    message.auth_code = object.auth_code;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_pay_auth_code_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {net.msg_get_pay_auth_code_rep} message msg_get_pay_auth_code_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_pay_auth_code_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.auth_code = "";
                else {
                    object.auth_code = [];
                    if (options.bytes !== Array)
                        object.auth_code = $util.newBuffer(object.auth_code);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.auth_code != null && message.hasOwnProperty("auth_code"))
                object.auth_code = options.bytes === String ? $util.base64.encode(message.auth_code, 0, message.auth_code.length) : options.bytes === Array ? Array.prototype.slice.call(message.auth_code) : message.auth_code;
            return object;
        };

        /**
         * Converts this msg_get_pay_auth_code_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_pay_auth_code_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_pay_auth_code_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_pay_auth_code_rep;
    })();

    net.msg_joingroup_byqrcode = (function() {

        /**
         * Properties of a msg_joingroup_byqrcode.
         * @memberof net
         * @interface Imsg_joingroup_byqrcode
         * @property {number|null} [groupkey] msg_joingroup_byqrcode groupkey
         * @property {number|null} [otheruid] msg_joingroup_byqrcode otheruid
         * @property {Uint8Array|null} [verify] msg_joingroup_byqrcode verify
         */

        /**
         * Constructs a new msg_joingroup_byqrcode.
         * @memberof net
         * @classdesc Represents a msg_joingroup_byqrcode.
         * @implements Imsg_joingroup_byqrcode
         * @constructor
         * @param {net.Imsg_joingroup_byqrcode=} [properties] Properties to set
         */
        function msg_joingroup_byqrcode(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_joingroup_byqrcode groupkey.
         * @member {number} groupkey
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.groupkey = 0;

        /**
         * msg_joingroup_byqrcode otheruid.
         * @member {number} otheruid
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.otheruid = 0;

        /**
         * msg_joingroup_byqrcode verify.
         * @member {Uint8Array} verify
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.verify = $util.newBuffer([]);

        /**
         * Creates a new msg_joingroup_byqrcode instance using the specified properties.
         * @function create
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {net.Imsg_joingroup_byqrcode=} [properties] Properties to set
         * @returns {net.msg_joingroup_byqrcode} msg_joingroup_byqrcode instance
         */
        msg_joingroup_byqrcode.create = function create(properties) {
            return new msg_joingroup_byqrcode(properties);
        };

        /**
         * Encodes the specified msg_joingroup_byqrcode message. Does not implicitly {@link net.msg_joingroup_byqrcode.verify|verify} messages.
         * @function encode
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {net.Imsg_joingroup_byqrcode} message msg_joingroup_byqrcode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.verify != null && Object.hasOwnProperty.call(message, "verify"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.verify);
            return writer;
        };

        /**
         * Encodes the specified msg_joingroup_byqrcode message, length delimited. Does not implicitly {@link net.msg_joingroup_byqrcode.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {net.Imsg_joingroup_byqrcode} message msg_joingroup_byqrcode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_joingroup_byqrcode message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_joingroup_byqrcode} msg_joingroup_byqrcode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_joingroup_byqrcode();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.verify = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_joingroup_byqrcode message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_joingroup_byqrcode} msg_joingroup_byqrcode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_joingroup_byqrcode message.
         * @function verify
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_joingroup_byqrcode.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.verify != null && message.hasOwnProperty("verify"))
                if (!(message.verify && typeof message.verify.length === "number" || $util.isString(message.verify)))
                    return "verify: buffer expected";
            return null;
        };

        /**
         * Creates a msg_joingroup_byqrcode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_joingroup_byqrcode} msg_joingroup_byqrcode
         */
        msg_joingroup_byqrcode.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_joingroup_byqrcode)
                return object;
            var message = new $root.net.msg_joingroup_byqrcode();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.verify != null)
                if (typeof object.verify === "string")
                    $util.base64.decode(object.verify, message.verify = $util.newBuffer($util.base64.length(object.verify)), 0);
                else if (object.verify.length)
                    message.verify = object.verify;
            return message;
        };

        /**
         * Creates a plain object from a msg_joingroup_byqrcode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {net.msg_joingroup_byqrcode} message msg_joingroup_byqrcode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_joingroup_byqrcode.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.otheruid = 0;
                if (options.bytes === String)
                    object.verify = "";
                else {
                    object.verify = [];
                    if (options.bytes !== Array)
                        object.verify = $util.newBuffer(object.verify);
                }
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.verify != null && message.hasOwnProperty("verify"))
                object.verify = options.bytes === String ? $util.base64.encode(message.verify, 0, message.verify.length) : options.bytes === Array ? Array.prototype.slice.call(message.verify) : message.verify;
            return object;
        };

        /**
         * Converts this msg_joingroup_byqrcode to JSON.
         * @function toJSON
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_joingroup_byqrcode.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_joingroup_byqrcode;
    })();

    net.msg_joingroup_byqrcode_rep = (function() {

        /**
         * Properties of a msg_joingroup_byqrcode_rep.
         * @memberof net
         * @interface Imsg_joingroup_byqrcode_rep
         * @property {number|null} [result] msg_joingroup_byqrcode_rep result
         */

        /**
         * Constructs a new msg_joingroup_byqrcode_rep.
         * @memberof net
         * @classdesc Represents a msg_joingroup_byqrcode_rep.
         * @implements Imsg_joingroup_byqrcode_rep
         * @constructor
         * @param {net.Imsg_joingroup_byqrcode_rep=} [properties] Properties to set
         */
        function msg_joingroup_byqrcode_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_joingroup_byqrcode_rep result.
         * @member {number} result
         * @memberof net.msg_joingroup_byqrcode_rep
         * @instance
         */
        msg_joingroup_byqrcode_rep.prototype.result = 0;

        /**
         * Creates a new msg_joingroup_byqrcode_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {net.Imsg_joingroup_byqrcode_rep=} [properties] Properties to set
         * @returns {net.msg_joingroup_byqrcode_rep} msg_joingroup_byqrcode_rep instance
         */
        msg_joingroup_byqrcode_rep.create = function create(properties) {
            return new msg_joingroup_byqrcode_rep(properties);
        };

        /**
         * Encodes the specified msg_joingroup_byqrcode_rep message. Does not implicitly {@link net.msg_joingroup_byqrcode_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {net.Imsg_joingroup_byqrcode_rep} message msg_joingroup_byqrcode_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_joingroup_byqrcode_rep message, length delimited. Does not implicitly {@link net.msg_joingroup_byqrcode_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {net.Imsg_joingroup_byqrcode_rep} message msg_joingroup_byqrcode_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_joingroup_byqrcode_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_joingroup_byqrcode_rep} msg_joingroup_byqrcode_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_joingroup_byqrcode_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_joingroup_byqrcode_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_joingroup_byqrcode_rep} msg_joingroup_byqrcode_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_joingroup_byqrcode_rep message.
         * @function verify
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_joingroup_byqrcode_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_joingroup_byqrcode_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_joingroup_byqrcode_rep} msg_joingroup_byqrcode_rep
         */
        msg_joingroup_byqrcode_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_joingroup_byqrcode_rep)
                return object;
            var message = new $root.net.msg_joingroup_byqrcode_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_joingroup_byqrcode_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {net.msg_joingroup_byqrcode_rep} message msg_joingroup_byqrcode_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_joingroup_byqrcode_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_joingroup_byqrcode_rep to JSON.
         * @function toJSON
         * @memberof net.msg_joingroup_byqrcode_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_joingroup_byqrcode_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_joingroup_byqrcode_rep;
    })();

    net.msg_create_goods = (function() {

        /**
         * Properties of a msg_create_goods.
         * @memberof net
         * @interface Imsg_create_goods
         * @property {number|null} [goodsvalue] msg_create_goods goodsvalue
         * @property {number|null} [minlimit] msg_create_goods minlimit
         * @property {number|null} [maxlimit] msg_create_goods maxlimit
         * @property {Array.<number>|null} [paylist] msg_create_goods paylist
         * @property {number|null} [cointype] msg_create_goods cointype
         * @property {number|null} [rate] msg_create_goods rate
         * @property {number|null} [status] msg_create_goods status
         * @property {number|null} [goodstype] msg_create_goods goodstype
         * @property {number|null} [outcointype] msg_create_goods outcointype
         */

        /**
         * Constructs a new msg_create_goods.
         * @memberof net
         * @classdesc Represents a msg_create_goods.
         * @implements Imsg_create_goods
         * @constructor
         * @param {net.Imsg_create_goods=} [properties] Properties to set
         */
        function msg_create_goods(properties) {
            this.paylist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_goods goodsvalue.
         * @member {number} goodsvalue
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.goodsvalue = 0;

        /**
         * msg_create_goods minlimit.
         * @member {number} minlimit
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.minlimit = 0;

        /**
         * msg_create_goods maxlimit.
         * @member {number} maxlimit
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.maxlimit = 0;

        /**
         * msg_create_goods paylist.
         * @member {Array.<number>} paylist
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.paylist = $util.emptyArray;

        /**
         * msg_create_goods cointype.
         * @member {number} cointype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.cointype = 0;

        /**
         * msg_create_goods rate.
         * @member {number} rate
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.rate = 0;

        /**
         * msg_create_goods status.
         * @member {number} status
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.status = 0;

        /**
         * msg_create_goods goodstype.
         * @member {number} goodstype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.goodstype = 0;

        /**
         * msg_create_goods outcointype.
         * @member {number} outcointype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.outcointype = 0;

        /**
         * Creates a new msg_create_goods instance using the specified properties.
         * @function create
         * @memberof net.msg_create_goods
         * @static
         * @param {net.Imsg_create_goods=} [properties] Properties to set
         * @returns {net.msg_create_goods} msg_create_goods instance
         */
        msg_create_goods.create = function create(properties) {
            return new msg_create_goods(properties);
        };

        /**
         * Encodes the specified msg_create_goods message. Does not implicitly {@link net.msg_create_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_goods
         * @static
         * @param {net.Imsg_create_goods} message msg_create_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsvalue != null && Object.hasOwnProperty.call(message, "goodsvalue"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.goodsvalue);
            if (message.minlimit != null && Object.hasOwnProperty.call(message, "minlimit"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minlimit);
            if (message.maxlimit != null && Object.hasOwnProperty.call(message, "maxlimit"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxlimit);
            if (message.paylist != null && message.paylist.length)
                for (var i = 0; i < message.paylist.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paylist[i]);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cointype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.rate);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
            if (message.goodstype != null && Object.hasOwnProperty.call(message, "goodstype"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.goodstype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.outcointype);
            return writer;
        };

        /**
         * Encodes the specified msg_create_goods message, length delimited. Does not implicitly {@link net.msg_create_goods.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_goods
         * @static
         * @param {net.Imsg_create_goods} message msg_create_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_goods} msg_create_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsvalue = reader.int32();
                    break;
                case 2:
                    message.minlimit = reader.int32();
                    break;
                case 3:
                    message.maxlimit = reader.int32();
                    break;
                case 4:
                    if (!(message.paylist && message.paylist.length))
                        message.paylist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.paylist.push(reader.int32());
                    } else
                        message.paylist.push(reader.int32());
                    break;
                case 5:
                    message.cointype = reader.int32();
                    break;
                case 6:
                    message.rate = reader.int32();
                    break;
                case 7:
                    message.status = reader.int32();
                    break;
                case 8:
                    message.goodstype = reader.int32();
                    break;
                case 9:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_goods message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_goods} msg_create_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_goods message.
         * @function verify
         * @memberof net.msg_create_goods
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_goods.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.goodsvalue != null && message.hasOwnProperty("goodsvalue"))
                if (!$util.isInteger(message.goodsvalue))
                    return "goodsvalue: integer expected";
            if (message.minlimit != null && message.hasOwnProperty("minlimit"))
                if (!$util.isInteger(message.minlimit))
                    return "minlimit: integer expected";
            if (message.maxlimit != null && message.hasOwnProperty("maxlimit"))
                if (!$util.isInteger(message.maxlimit))
                    return "maxlimit: integer expected";
            if (message.paylist != null && message.hasOwnProperty("paylist")) {
                if (!Array.isArray(message.paylist))
                    return "paylist: array expected";
                for (var i = 0; i < message.paylist.length; ++i)
                    if (!$util.isInteger(message.paylist[i]))
                        return "paylist: integer[] expected";
            }
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.rate != null && message.hasOwnProperty("rate"))
                if (!$util.isInteger(message.rate))
                    return "rate: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            if (message.goodstype != null && message.hasOwnProperty("goodstype"))
                if (!$util.isInteger(message.goodstype))
                    return "goodstype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_create_goods message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_goods
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_goods} msg_create_goods
         */
        msg_create_goods.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_goods)
                return object;
            var message = new $root.net.msg_create_goods();
            if (object.goodsvalue != null)
                message.goodsvalue = object.goodsvalue | 0;
            if (object.minlimit != null)
                message.minlimit = object.minlimit | 0;
            if (object.maxlimit != null)
                message.maxlimit = object.maxlimit | 0;
            if (object.paylist) {
                if (!Array.isArray(object.paylist))
                    throw TypeError(".net.msg_create_goods.paylist: array expected");
                message.paylist = [];
                for (var i = 0; i < object.paylist.length; ++i)
                    message.paylist[i] = object.paylist[i] | 0;
            }
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.rate != null)
                message.rate = object.rate | 0;
            if (object.status != null)
                message.status = object.status | 0;
            if (object.goodstype != null)
                message.goodstype = object.goodstype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_create_goods message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_goods
         * @static
         * @param {net.msg_create_goods} message msg_create_goods
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_goods.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.paylist = [];
            if (options.defaults) {
                object.goodsvalue = 0;
                object.minlimit = 0;
                object.maxlimit = 0;
                object.cointype = 0;
                object.rate = 0;
                object.status = 0;
                object.goodstype = 0;
                object.outcointype = 0;
            }
            if (message.goodsvalue != null && message.hasOwnProperty("goodsvalue"))
                object.goodsvalue = message.goodsvalue;
            if (message.minlimit != null && message.hasOwnProperty("minlimit"))
                object.minlimit = message.minlimit;
            if (message.maxlimit != null && message.hasOwnProperty("maxlimit"))
                object.maxlimit = message.maxlimit;
            if (message.paylist && message.paylist.length) {
                object.paylist = [];
                for (var j = 0; j < message.paylist.length; ++j)
                    object.paylist[j] = message.paylist[j];
            }
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.rate != null && message.hasOwnProperty("rate"))
                object.rate = message.rate;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.goodstype != null && message.hasOwnProperty("goodstype"))
                object.goodstype = message.goodstype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            return object;
        };

        /**
         * Converts this msg_create_goods to JSON.
         * @function toJSON
         * @memberof net.msg_create_goods
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_goods.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_goods;
    })();

    net.msg_create_goods_rep = (function() {

        /**
         * Properties of a msg_create_goods_rep.
         * @memberof net
         * @interface Imsg_create_goods_rep
         * @property {number|null} [result] msg_create_goods_rep result
         * @property {number|null} [cointype] msg_create_goods_rep cointype
         * @property {number|null} [outcointype] msg_create_goods_rep outcointype
         */

        /**
         * Constructs a new msg_create_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_create_goods_rep.
         * @implements Imsg_create_goods_rep
         * @constructor
         * @param {net.Imsg_create_goods_rep=} [properties] Properties to set
         */
        function msg_create_goods_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_goods_rep result.
         * @member {number} result
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.result = 0;

        /**
         * msg_create_goods_rep cointype.
         * @member {number} cointype
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.cointype = 0;

        /**
         * msg_create_goods_rep outcointype.
         * @member {number} outcointype
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.outcointype = 0;

        /**
         * Creates a new msg_create_goods_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {net.Imsg_create_goods_rep=} [properties] Properties to set
         * @returns {net.msg_create_goods_rep} msg_create_goods_rep instance
         */
        msg_create_goods_rep.create = function create(properties) {
            return new msg_create_goods_rep(properties);
        };

        /**
         * Encodes the specified msg_create_goods_rep message. Does not implicitly {@link net.msg_create_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {net.Imsg_create_goods_rep} message msg_create_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.outcointype);
            return writer;
        };

        /**
         * Encodes the specified msg_create_goods_rep message, length delimited. Does not implicitly {@link net.msg_create_goods_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {net.Imsg_create_goods_rep} message msg_create_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_goods_rep} msg_create_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.cointype = reader.int32();
                    break;
                case 3:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_goods_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_goods_rep} msg_create_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_goods_rep message.
         * @function verify
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_goods_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_create_goods_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_goods_rep} msg_create_goods_rep
         */
        msg_create_goods_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_goods_rep)
                return object;
            var message = new $root.net.msg_create_goods_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_create_goods_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {net.msg_create_goods_rep} message msg_create_goods_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_goods_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.cointype = 0;
                object.outcointype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            return object;
        };

        /**
         * Converts this msg_create_goods_rep to JSON.
         * @function toJSON
         * @memberof net.msg_create_goods_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_goods_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_goods_rep;
    })();

    net.msg_get_my_goods = (function() {

        /**
         * Properties of a msg_get_my_goods.
         * @memberof net
         * @interface Imsg_get_my_goods
         */

        /**
         * Constructs a new msg_get_my_goods.
         * @memberof net
         * @classdesc Represents a msg_get_my_goods.
         * @implements Imsg_get_my_goods
         * @constructor
         * @param {net.Imsg_get_my_goods=} [properties] Properties to set
         */
        function msg_get_my_goods(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_my_goods instance using the specified properties.
         * @function create
         * @memberof net.msg_get_my_goods
         * @static
         * @param {net.Imsg_get_my_goods=} [properties] Properties to set
         * @returns {net.msg_get_my_goods} msg_get_my_goods instance
         */
        msg_get_my_goods.create = function create(properties) {
            return new msg_get_my_goods(properties);
        };

        /**
         * Encodes the specified msg_get_my_goods message. Does not implicitly {@link net.msg_get_my_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_goods
         * @static
         * @param {net.Imsg_get_my_goods} message msg_get_my_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_my_goods message, length delimited. Does not implicitly {@link net.msg_get_my_goods.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_my_goods
         * @static
         * @param {net.Imsg_get_my_goods} message msg_get_my_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_my_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_goods} msg_get_my_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_my_goods message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_my_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_my_goods} msg_get_my_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_my_goods message.
         * @function verify
         * @memberof net.msg_get_my_goods
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_my_goods.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_my_goods message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_my_goods
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_my_goods} msg_get_my_goods
         */
        msg_get_my_goods.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_my_goods)
                return object;
            return new $root.net.msg_get_my_goods();
        };

        /**
         * Creates a plain object from a msg_get_my_goods message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_my_goods
         * @static
         * @param {net.msg_get_my_goods} message msg_get_my_goods
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_my_goods.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_my_goods to JSON.
         * @function toJSON
         * @memberof net.msg_get_my_goods
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_my_goods.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_my_goods;
    })();

    net.msg_get_my_goods_rep = (function() {

        /**
         * Properties of a msg_get_my_goods_rep.
         * @memberof net
         * @interface Imsg_get_my_goods_rep
         * @property {Array.<net.Igoods_info>|null} [g_info] msg_get_my_goods_rep g_info
         */

        /**
         * Constructs a new msg_get_my_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_get_my_goods_rep.
         * @implements Imsg_get_my_goods_rep
         * @constructor
         * @param {net.Imsg_get_my_goods_rep=} [properties] Properties to set
         */
        function msg_get_my_goods_rep(properties) {
            this.g_info = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_my_goods_rep g_info.
         * @member {Array.<net.Igoods_info>} g_info
         * @memberof net.msg_get_my_goods_rep
         * @instance
         */
        msg_get_my_goods_rep.prototype.g_info = $util.emptyArray;

        /**
         * Creates a new msg_get_my_goods_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {net.Imsg_get_my_goods_rep=} [properties] Properties to set
         * @returns {net.msg_get_my_goods_rep} msg_get_my_goods_rep instance
         */
        msg_get_my_goods_rep.create = function create(properties) {
            return new msg_get_my_goods_rep(properties);
        };

        /**
         * Encodes the specified msg_get_my_goods_rep message. Does not implicitly {@link net.msg_get_my_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {net.Imsg_get_my_goods_rep} message msg_get_my_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.g_info != null && message.g_info.length)
                for (var i = 0; i < message.g_info.length; ++i)
                    $root.net.goods_info.encode(message.g_info[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_my_goods_rep message, length delimited. Does not implicitly {@link net.msg_get_my_goods_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {net.Imsg_get_my_goods_rep} message msg_get_my_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_my_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_goods_rep} msg_get_my_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.g_info && message.g_info.length))
                        message.g_info = [];
                    message.g_info.push($root.net.goods_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_my_goods_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_my_goods_rep} msg_get_my_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_my_goods_rep message.
         * @function verify
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_my_goods_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.g_info != null && message.hasOwnProperty("g_info")) {
                if (!Array.isArray(message.g_info))
                    return "g_info: array expected";
                for (var i = 0; i < message.g_info.length; ++i) {
                    var error = $root.net.goods_info.verify(message.g_info[i]);
                    if (error)
                        return "g_info." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_my_goods_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_my_goods_rep} msg_get_my_goods_rep
         */
        msg_get_my_goods_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_my_goods_rep)
                return object;
            var message = new $root.net.msg_get_my_goods_rep();
            if (object.g_info) {
                if (!Array.isArray(object.g_info))
                    throw TypeError(".net.msg_get_my_goods_rep.g_info: array expected");
                message.g_info = [];
                for (var i = 0; i < object.g_info.length; ++i) {
                    if (typeof object.g_info[i] !== "object")
                        throw TypeError(".net.msg_get_my_goods_rep.g_info: object expected");
                    message.g_info[i] = $root.net.goods_info.fromObject(object.g_info[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_my_goods_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {net.msg_get_my_goods_rep} message msg_get_my_goods_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_my_goods_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.g_info = [];
            if (message.g_info && message.g_info.length) {
                object.g_info = [];
                for (var j = 0; j < message.g_info.length; ++j)
                    object.g_info[j] = $root.net.goods_info.toObject(message.g_info[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_my_goods_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_my_goods_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_my_goods_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_my_goods_rep;
    })();

    net.msg_get_goods = (function() {

        /**
         * Properties of a msg_get_goods.
         * @memberof net
         * @interface Imsg_get_goods
         * @property {number|null} [paytype] msg_get_goods paytype
         * @property {number|null} [opertype] msg_get_goods opertype
         * @property {number|null} [value] msg_get_goods value
         * @property {number|null} [cointype] msg_get_goods cointype
         * @property {number|null} [outcointype] msg_get_goods outcointype
         */

        /**
         * Constructs a new msg_get_goods.
         * @memberof net
         * @classdesc Represents a msg_get_goods.
         * @implements Imsg_get_goods
         * @constructor
         * @param {net.Imsg_get_goods=} [properties] Properties to set
         */
        function msg_get_goods(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods paytype.
         * @member {number} paytype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.paytype = 0;

        /**
         * msg_get_goods opertype.
         * @member {number} opertype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.opertype = 0;

        /**
         * msg_get_goods value.
         * @member {number} value
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.value = 0;

        /**
         * msg_get_goods cointype.
         * @member {number} cointype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.cointype = 0;

        /**
         * msg_get_goods outcointype.
         * @member {number} outcointype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.outcointype = 0;

        /**
         * Creates a new msg_get_goods instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods
         * @static
         * @param {net.Imsg_get_goods=} [properties] Properties to set
         * @returns {net.msg_get_goods} msg_get_goods instance
         */
        msg_get_goods.create = function create(properties) {
            return new msg_get_goods(properties);
        };

        /**
         * Encodes the specified msg_get_goods message. Does not implicitly {@link net.msg_get_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods
         * @static
         * @param {net.Imsg_get_goods} message msg_get_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.paytype);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.value);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.outcointype);
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods message, length delimited. Does not implicitly {@link net.msg_get_goods.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods
         * @static
         * @param {net.Imsg_get_goods} message msg_get_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods} msg_get_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.paytype = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                case 3:
                    message.value = reader.int32();
                    break;
                case 4:
                    message.cointype = reader.int32();
                    break;
                case 5:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods} msg_get_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods message.
         * @function verify
         * @memberof net.msg_get_goods
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isInteger(message.value))
                    return "value: integer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                if (!$util.isInteger(message.outcointype))
                    return "outcointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_goods message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods} msg_get_goods
         */
        msg_get_goods.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods)
                return object;
            var message = new $root.net.msg_get_goods();
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            if (object.value != null)
                message.value = object.value | 0;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            if (object.outcointype != null)
                message.outcointype = object.outcointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods
         * @static
         * @param {net.msg_get_goods} message msg_get_goods
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paytype = 0;
                object.opertype = 0;
                object.value = 0;
                object.cointype = 0;
                object.outcointype = 0;
            }
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            if (message.outcointype != null && message.hasOwnProperty("outcointype"))
                object.outcointype = message.outcointype;
            return object;
        };

        /**
         * Converts this msg_get_goods to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods;
    })();

    net.msg_get_goods_rep = (function() {

        /**
         * Properties of a msg_get_goods_rep.
         * @memberof net
         * @interface Imsg_get_goods_rep
         * @property {Array.<net.Igoods_info>|null} [goodslist] msg_get_goods_rep goodslist
         */

        /**
         * Constructs a new msg_get_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_rep.
         * @implements Imsg_get_goods_rep
         * @constructor
         * @param {net.Imsg_get_goods_rep=} [properties] Properties to set
         */
        function msg_get_goods_rep(properties) {
            this.goodslist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_rep goodslist.
         * @member {Array.<net.Igoods_info>} goodslist
         * @memberof net.msg_get_goods_rep
         * @instance
         */
        msg_get_goods_rep.prototype.goodslist = $util.emptyArray;

        /**
         * Creates a new msg_get_goods_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {net.Imsg_get_goods_rep=} [properties] Properties to set
         * @returns {net.msg_get_goods_rep} msg_get_goods_rep instance
         */
        msg_get_goods_rep.create = function create(properties) {
            return new msg_get_goods_rep(properties);
        };

        /**
         * Encodes the specified msg_get_goods_rep message. Does not implicitly {@link net.msg_get_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {net.Imsg_get_goods_rep} message msg_get_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodslist != null && message.goodslist.length)
                for (var i = 0; i < message.goodslist.length; ++i)
                    $root.net.goods_info.encode(message.goodslist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_rep message, length delimited. Does not implicitly {@link net.msg_get_goods_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {net.Imsg_get_goods_rep} message msg_get_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_rep} msg_get_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.goodslist && message.goodslist.length))
                        message.goodslist = [];
                    message.goodslist.push($root.net.goods_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_rep} msg_get_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_rep message.
         * @function verify
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.goodslist != null && message.hasOwnProperty("goodslist")) {
                if (!Array.isArray(message.goodslist))
                    return "goodslist: array expected";
                for (var i = 0; i < message.goodslist.length; ++i) {
                    var error = $root.net.goods_info.verify(message.goodslist[i]);
                    if (error)
                        return "goodslist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_goods_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_rep} msg_get_goods_rep
         */
        msg_get_goods_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_rep)
                return object;
            var message = new $root.net.msg_get_goods_rep();
            if (object.goodslist) {
                if (!Array.isArray(object.goodslist))
                    throw TypeError(".net.msg_get_goods_rep.goodslist: array expected");
                message.goodslist = [];
                for (var i = 0; i < object.goodslist.length; ++i) {
                    if (typeof object.goodslist[i] !== "object")
                        throw TypeError(".net.msg_get_goods_rep.goodslist: object expected");
                    message.goodslist[i] = $root.net.goods_info.fromObject(object.goodslist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {net.msg_get_goods_rep} message msg_get_goods_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.goodslist = [];
            if (message.goodslist && message.goodslist.length) {
                object.goodslist = [];
                for (var j = 0; j < message.goodslist.length; ++j)
                    object.goodslist[j] = $root.net.goods_info.toObject(message.goodslist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_goods_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_rep;
    })();

    net.msg_create_order = (function() {

        /**
         * Properties of a msg_create_order.
         * @memberof net
         * @interface Imsg_create_order
         * @property {number|null} [opertype] msg_create_order opertype
         * @property {number|Long|null} [goodsid] msg_create_order goodsid
         * @property {number|null} [ordervalue] msg_create_order ordervalue
         * @property {number|null} [paytype] msg_create_order paytype
         * @property {number|null} [paytypeid] msg_create_order paytypeid
         */

        /**
         * Constructs a new msg_create_order.
         * @memberof net
         * @classdesc Represents a msg_create_order.
         * @implements Imsg_create_order
         * @constructor
         * @param {net.Imsg_create_order=} [properties] Properties to set
         */
        function msg_create_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_order opertype.
         * @member {number} opertype
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.opertype = 0;

        /**
         * msg_create_order goodsid.
         * @member {number|Long} goodsid
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_create_order ordervalue.
         * @member {number} ordervalue
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.ordervalue = 0;

        /**
         * msg_create_order paytype.
         * @member {number} paytype
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.paytype = 0;

        /**
         * msg_create_order paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.paytypeid = 0;

        /**
         * Creates a new msg_create_order instance using the specified properties.
         * @function create
         * @memberof net.msg_create_order
         * @static
         * @param {net.Imsg_create_order=} [properties] Properties to set
         * @returns {net.msg_create_order} msg_create_order instance
         */
        msg_create_order.create = function create(properties) {
            return new msg_create_order(properties);
        };

        /**
         * Encodes the specified msg_create_order message. Does not implicitly {@link net.msg_create_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_order
         * @static
         * @param {net.Imsg_create_order} message msg_create_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opertype);
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.goodsid);
            if (message.ordervalue != null && Object.hasOwnProperty.call(message, "ordervalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ordervalue);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.paytypeid);
            return writer;
        };

        /**
         * Encodes the specified msg_create_order message, length delimited. Does not implicitly {@link net.msg_create_order.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_order
         * @static
         * @param {net.Imsg_create_order} message msg_create_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_order} msg_create_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.opertype = reader.int32();
                    break;
                case 2:
                    message.goodsid = reader.int64();
                    break;
                case 3:
                    message.ordervalue = reader.int32();
                    break;
                case 4:
                    message.paytype = reader.int32();
                    break;
                case 5:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_order message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_order} msg_create_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_order message.
         * @function verify
         * @memberof net.msg_create_order
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_order.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (!$util.isInteger(message.goodsid) && !(message.goodsid && $util.isInteger(message.goodsid.low) && $util.isInteger(message.goodsid.high)))
                    return "goodsid: integer|Long expected";
            if (message.ordervalue != null && message.hasOwnProperty("ordervalue"))
                if (!$util.isInteger(message.ordervalue))
                    return "ordervalue: integer expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                if (!$util.isInteger(message.paytypeid))
                    return "paytypeid: integer expected";
            return null;
        };

        /**
         * Creates a msg_create_order message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_order
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_order} msg_create_order
         */
        msg_create_order.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_order)
                return object;
            var message = new $root.net.msg_create_order();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            if (object.goodsid != null)
                if ($util.Long)
                    (message.goodsid = $util.Long.fromValue(object.goodsid)).unsigned = false;
                else if (typeof object.goodsid === "string")
                    message.goodsid = parseInt(object.goodsid, 10);
                else if (typeof object.goodsid === "number")
                    message.goodsid = object.goodsid;
                else if (typeof object.goodsid === "object")
                    message.goodsid = new $util.LongBits(object.goodsid.low >>> 0, object.goodsid.high >>> 0).toNumber();
            if (object.ordervalue != null)
                message.ordervalue = object.ordervalue | 0;
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.paytypeid != null)
                message.paytypeid = object.paytypeid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_create_order message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_order
         * @static
         * @param {net.msg_create_order} message msg_create_order
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_order.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.opertype = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.goodsid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.goodsid = options.longs === String ? "0" : 0;
                object.ordervalue = 0;
                object.paytype = 0;
                object.paytypeid = 0;
            }
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (typeof message.goodsid === "number")
                    object.goodsid = options.longs === String ? String(message.goodsid) : message.goodsid;
                else
                    object.goodsid = options.longs === String ? $util.Long.prototype.toString.call(message.goodsid) : options.longs === Number ? new $util.LongBits(message.goodsid.low >>> 0, message.goodsid.high >>> 0).toNumber() : message.goodsid;
            if (message.ordervalue != null && message.hasOwnProperty("ordervalue"))
                object.ordervalue = message.ordervalue;
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                object.paytypeid = message.paytypeid;
            return object;
        };

        /**
         * Converts this msg_create_order to JSON.
         * @function toJSON
         * @memberof net.msg_create_order
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_order.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_order;
    })();

    net.msg_create_order_rep = (function() {

        /**
         * Properties of a msg_create_order_rep.
         * @memberof net
         * @interface Imsg_create_order_rep
         * @property {number|null} [result] msg_create_order_rep result
         * @property {number|null} [otheruid] msg_create_order_rep otheruid
         */

        /**
         * Constructs a new msg_create_order_rep.
         * @memberof net
         * @classdesc Represents a msg_create_order_rep.
         * @implements Imsg_create_order_rep
         * @constructor
         * @param {net.Imsg_create_order_rep=} [properties] Properties to set
         */
        function msg_create_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_order_rep result.
         * @member {number} result
         * @memberof net.msg_create_order_rep
         * @instance
         */
        msg_create_order_rep.prototype.result = 0;

        /**
         * msg_create_order_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_create_order_rep
         * @instance
         */
        msg_create_order_rep.prototype.otheruid = 0;

        /**
         * Creates a new msg_create_order_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_create_order_rep
         * @static
         * @param {net.Imsg_create_order_rep=} [properties] Properties to set
         * @returns {net.msg_create_order_rep} msg_create_order_rep instance
         */
        msg_create_order_rep.create = function create(properties) {
            return new msg_create_order_rep(properties);
        };

        /**
         * Encodes the specified msg_create_order_rep message. Does not implicitly {@link net.msg_create_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_order_rep
         * @static
         * @param {net.Imsg_create_order_rep} message msg_create_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            return writer;
        };

        /**
         * Encodes the specified msg_create_order_rep message, length delimited. Does not implicitly {@link net.msg_create_order_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_create_order_rep
         * @static
         * @param {net.Imsg_create_order_rep} message msg_create_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_create_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_order_rep} msg_create_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_create_order_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_create_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_create_order_rep} msg_create_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_create_order_rep message.
         * @function verify
         * @memberof net.msg_create_order_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_create_order_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            return null;
        };

        /**
         * Creates a msg_create_order_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_create_order_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_create_order_rep} msg_create_order_rep
         */
        msg_create_order_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_create_order_rep)
                return object;
            var message = new $root.net.msg_create_order_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_create_order_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_create_order_rep
         * @static
         * @param {net.msg_create_order_rep} message msg_create_order_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_create_order_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.otheruid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            return object;
        };

        /**
         * Converts this msg_create_order_rep to JSON.
         * @function toJSON
         * @memberof net.msg_create_order_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_create_order_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_create_order_rep;
    })();

    net.msg_confirm_order = (function() {

        /**
         * Properties of a msg_confirm_order.
         * @memberof net
         * @interface Imsg_confirm_order
         * @property {number|Long|null} [orderid] msg_confirm_order orderid
         */

        /**
         * Constructs a new msg_confirm_order.
         * @memberof net
         * @classdesc Represents a msg_confirm_order.
         * @implements Imsg_confirm_order
         * @constructor
         * @param {net.Imsg_confirm_order=} [properties] Properties to set
         */
        function msg_confirm_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_order orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_confirm_order
         * @instance
         */
        msg_confirm_order.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_confirm_order instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_order
         * @static
         * @param {net.Imsg_confirm_order=} [properties] Properties to set
         * @returns {net.msg_confirm_order} msg_confirm_order instance
         */
        msg_confirm_order.create = function create(properties) {
            return new msg_confirm_order(properties);
        };

        /**
         * Encodes the specified msg_confirm_order message. Does not implicitly {@link net.msg_confirm_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_order
         * @static
         * @param {net.Imsg_confirm_order} message msg_confirm_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_order message, length delimited. Does not implicitly {@link net.msg_confirm_order.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_order
         * @static
         * @param {net.Imsg_confirm_order} message msg_confirm_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_order} msg_confirm_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_order message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_order} msg_confirm_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_order message.
         * @function verify
         * @memberof net.msg_confirm_order
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_order.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_confirm_order message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_order
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_order} msg_confirm_order
         */
        msg_confirm_order.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_order)
                return object;
            var message = new $root.net.msg_confirm_order();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_order message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_order
         * @static
         * @param {net.msg_confirm_order} message msg_confirm_order
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_order.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            return object;
        };

        /**
         * Converts this msg_confirm_order to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_order
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_order.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_order;
    })();

    net.msg_confirm_order_rep = (function() {

        /**
         * Properties of a msg_confirm_order_rep.
         * @memberof net
         * @interface Imsg_confirm_order_rep
         * @property {number|null} [result] msg_confirm_order_rep result
         * @property {number|null} [buyer] msg_confirm_order_rep buyer
         * @property {number|null} [seller] msg_confirm_order_rep seller
         * @property {number|null} [status] msg_confirm_order_rep status
         */

        /**
         * Constructs a new msg_confirm_order_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_order_rep.
         * @implements Imsg_confirm_order_rep
         * @constructor
         * @param {net.Imsg_confirm_order_rep=} [properties] Properties to set
         */
        function msg_confirm_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_order_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.result = 0;

        /**
         * msg_confirm_order_rep buyer.
         * @member {number} buyer
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.buyer = 0;

        /**
         * msg_confirm_order_rep seller.
         * @member {number} seller
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.seller = 0;

        /**
         * msg_confirm_order_rep status.
         * @member {number} status
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.status = 0;

        /**
         * Creates a new msg_confirm_order_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {net.Imsg_confirm_order_rep=} [properties] Properties to set
         * @returns {net.msg_confirm_order_rep} msg_confirm_order_rep instance
         */
        msg_confirm_order_rep.create = function create(properties) {
            return new msg_confirm_order_rep(properties);
        };

        /**
         * Encodes the specified msg_confirm_order_rep message. Does not implicitly {@link net.msg_confirm_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {net.Imsg_confirm_order_rep} message msg_confirm_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.seller);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified msg_confirm_order_rep message, length delimited. Does not implicitly {@link net.msg_confirm_order_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {net.Imsg_confirm_order_rep} message msg_confirm_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_confirm_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_order_rep} msg_confirm_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.buyer = reader.int32();
                    break;
                case 3:
                    message.seller = reader.int32();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_confirm_order_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_confirm_order_rep} msg_confirm_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_confirm_order_rep message.
         * @function verify
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_confirm_order_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                if (!$util.isInteger(message.buyer))
                    return "buyer: integer expected";
            if (message.seller != null && message.hasOwnProperty("seller"))
                if (!$util.isInteger(message.seller))
                    return "seller: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            return null;
        };

        /**
         * Creates a msg_confirm_order_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_confirm_order_rep} msg_confirm_order_rep
         */
        msg_confirm_order_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_confirm_order_rep)
                return object;
            var message = new $root.net.msg_confirm_order_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.buyer != null)
                message.buyer = object.buyer | 0;
            if (object.seller != null)
                message.seller = object.seller | 0;
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_confirm_order_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {net.msg_confirm_order_rep} message msg_confirm_order_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_confirm_order_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.buyer = 0;
                object.seller = 0;
                object.status = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                object.buyer = message.buyer;
            if (message.seller != null && message.hasOwnProperty("seller"))
                object.seller = message.seller;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this msg_confirm_order_rep to JSON.
         * @function toJSON
         * @memberof net.msg_confirm_order_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_confirm_order_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_confirm_order_rep;
    })();

    net.msg_get_my_orders = (function() {

        /**
         * Properties of a msg_get_my_orders.
         * @memberof net
         * @interface Imsg_get_my_orders
         */

        /**
         * Constructs a new msg_get_my_orders.
         * @memberof net
         * @classdesc Represents a msg_get_my_orders.
         * @implements Imsg_get_my_orders
         * @constructor
         * @param {net.Imsg_get_my_orders=} [properties] Properties to set
         */
        function msg_get_my_orders(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_my_orders instance using the specified properties.
         * @function create
         * @memberof net.msg_get_my_orders
         * @static
         * @param {net.Imsg_get_my_orders=} [properties] Properties to set
         * @returns {net.msg_get_my_orders} msg_get_my_orders instance
         */
        msg_get_my_orders.create = function create(properties) {
            return new msg_get_my_orders(properties);
        };

        /**
         * Encodes the specified msg_get_my_orders message. Does not implicitly {@link net.msg_get_my_orders.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_orders
         * @static
         * @param {net.Imsg_get_my_orders} message msg_get_my_orders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_my_orders message, length delimited. Does not implicitly {@link net.msg_get_my_orders.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_my_orders
         * @static
         * @param {net.Imsg_get_my_orders} message msg_get_my_orders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_my_orders message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_orders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_orders} msg_get_my_orders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_orders();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_my_orders message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_my_orders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_my_orders} msg_get_my_orders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_my_orders message.
         * @function verify
         * @memberof net.msg_get_my_orders
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_my_orders.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_my_orders message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_my_orders
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_my_orders} msg_get_my_orders
         */
        msg_get_my_orders.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_my_orders)
                return object;
            return new $root.net.msg_get_my_orders();
        };

        /**
         * Creates a plain object from a msg_get_my_orders message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_my_orders
         * @static
         * @param {net.msg_get_my_orders} message msg_get_my_orders
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_my_orders.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_my_orders to JSON.
         * @function toJSON
         * @memberof net.msg_get_my_orders
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_my_orders.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_my_orders;
    })();

    net.msg_get_my_orders_rep = (function() {

        /**
         * Properties of a msg_get_my_orders_rep.
         * @memberof net
         * @interface Imsg_get_my_orders_rep
         * @property {Array.<net.Iorder_info>|null} [orders] msg_get_my_orders_rep orders
         */

        /**
         * Constructs a new msg_get_my_orders_rep.
         * @memberof net
         * @classdesc Represents a msg_get_my_orders_rep.
         * @implements Imsg_get_my_orders_rep
         * @constructor
         * @param {net.Imsg_get_my_orders_rep=} [properties] Properties to set
         */
        function msg_get_my_orders_rep(properties) {
            this.orders = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_my_orders_rep orders.
         * @member {Array.<net.Iorder_info>} orders
         * @memberof net.msg_get_my_orders_rep
         * @instance
         */
        msg_get_my_orders_rep.prototype.orders = $util.emptyArray;

        /**
         * Creates a new msg_get_my_orders_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {net.Imsg_get_my_orders_rep=} [properties] Properties to set
         * @returns {net.msg_get_my_orders_rep} msg_get_my_orders_rep instance
         */
        msg_get_my_orders_rep.create = function create(properties) {
            return new msg_get_my_orders_rep(properties);
        };

        /**
         * Encodes the specified msg_get_my_orders_rep message. Does not implicitly {@link net.msg_get_my_orders_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {net.Imsg_get_my_orders_rep} message msg_get_my_orders_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orders != null && message.orders.length)
                for (var i = 0; i < message.orders.length; ++i)
                    $root.net.order_info.encode(message.orders[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_my_orders_rep message, length delimited. Does not implicitly {@link net.msg_get_my_orders_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {net.Imsg_get_my_orders_rep} message msg_get_my_orders_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_my_orders_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_orders_rep} msg_get_my_orders_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_orders_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.orders && message.orders.length))
                        message.orders = [];
                    message.orders.push($root.net.order_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_my_orders_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_my_orders_rep} msg_get_my_orders_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_my_orders_rep message.
         * @function verify
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_my_orders_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orders != null && message.hasOwnProperty("orders")) {
                if (!Array.isArray(message.orders))
                    return "orders: array expected";
                for (var i = 0; i < message.orders.length; ++i) {
                    var error = $root.net.order_info.verify(message.orders[i]);
                    if (error)
                        return "orders." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_my_orders_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_my_orders_rep} msg_get_my_orders_rep
         */
        msg_get_my_orders_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_my_orders_rep)
                return object;
            var message = new $root.net.msg_get_my_orders_rep();
            if (object.orders) {
                if (!Array.isArray(object.orders))
                    throw TypeError(".net.msg_get_my_orders_rep.orders: array expected");
                message.orders = [];
                for (var i = 0; i < object.orders.length; ++i) {
                    if (typeof object.orders[i] !== "object")
                        throw TypeError(".net.msg_get_my_orders_rep.orders: object expected");
                    message.orders[i] = $root.net.order_info.fromObject(object.orders[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_my_orders_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {net.msg_get_my_orders_rep} message msg_get_my_orders_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_my_orders_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.orders = [];
            if (message.orders && message.orders.length) {
                object.orders = [];
                for (var j = 0; j < message.orders.length; ++j)
                    object.orders[j] = $root.net.order_info.toObject(message.orders[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_my_orders_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_my_orders_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_my_orders_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_my_orders_rep;
    })();

    net.msg_get_order_info = (function() {

        /**
         * Properties of a msg_get_order_info.
         * @memberof net
         * @interface Imsg_get_order_info
         * @property {number|null} [otheruid] msg_get_order_info otheruid
         */

        /**
         * Constructs a new msg_get_order_info.
         * @memberof net
         * @classdesc Represents a msg_get_order_info.
         * @implements Imsg_get_order_info
         * @constructor
         * @param {net.Imsg_get_order_info=} [properties] Properties to set
         */
        function msg_get_order_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info otheruid.
         * @member {number} otheruid
         * @memberof net.msg_get_order_info
         * @instance
         */
        msg_get_order_info.prototype.otheruid = 0;

        /**
         * Creates a new msg_get_order_info instance using the specified properties.
         * @function create
         * @memberof net.msg_get_order_info
         * @static
         * @param {net.Imsg_get_order_info=} [properties] Properties to set
         * @returns {net.msg_get_order_info} msg_get_order_info instance
         */
        msg_get_order_info.create = function create(properties) {
            return new msg_get_order_info(properties);
        };

        /**
         * Encodes the specified msg_get_order_info message. Does not implicitly {@link net.msg_get_order_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info
         * @static
         * @param {net.Imsg_get_order_info} message msg_get_order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_order_info message, length delimited. Does not implicitly {@link net.msg_get_order_info.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_order_info
         * @static
         * @param {net.Imsg_get_order_info} message msg_get_order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_order_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info} msg_get_order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_order_info message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_order_info} msg_get_order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_order_info message.
         * @function verify
         * @memberof net.msg_get_order_info
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_order_info.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_order_info message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_order_info
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_order_info} msg_get_order_info
         */
        msg_get_order_info.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_order_info)
                return object;
            var message = new $root.net.msg_get_order_info();
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_order_info message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_order_info
         * @static
         * @param {net.msg_get_order_info} message msg_get_order_info
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_order_info.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.otheruid = 0;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            return object;
        };

        /**
         * Converts this msg_get_order_info to JSON.
         * @function toJSON
         * @memberof net.msg_get_order_info
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_order_info.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_order_info;
    })();

    net.msg_get_order_info_rep = (function() {

        /**
         * Properties of a msg_get_order_info_rep.
         * @memberof net
         * @interface Imsg_get_order_info_rep
         * @property {number|null} [result] msg_get_order_info_rep result
         * @property {net.Iorder_info|null} [order] msg_get_order_info_rep order
         */

        /**
         * Constructs a new msg_get_order_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_rep.
         * @implements Imsg_get_order_info_rep
         * @constructor
         * @param {net.Imsg_get_order_info_rep=} [properties] Properties to set
         */
        function msg_get_order_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_rep result.
         * @member {number} result
         * @memberof net.msg_get_order_info_rep
         * @instance
         */
        msg_get_order_info_rep.prototype.result = 0;

        /**
         * msg_get_order_info_rep order.
         * @member {net.Iorder_info|null|undefined} order
         * @memberof net.msg_get_order_info_rep
         * @instance
         */
        msg_get_order_info_rep.prototype.order = null;

        /**
         * Creates a new msg_get_order_info_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {net.Imsg_get_order_info_rep=} [properties] Properties to set
         * @returns {net.msg_get_order_info_rep} msg_get_order_info_rep instance
         */
        msg_get_order_info_rep.create = function create(properties) {
            return new msg_get_order_info_rep(properties);
        };

        /**
         * Encodes the specified msg_get_order_info_rep message. Does not implicitly {@link net.msg_get_order_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {net.Imsg_get_order_info_rep} message msg_get_order_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                $root.net.order_info.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_order_info_rep message, length delimited. Does not implicitly {@link net.msg_get_order_info_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {net.Imsg_get_order_info_rep} message msg_get_order_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_order_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_rep} msg_get_order_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.order = $root.net.order_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_order_info_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_order_info_rep} msg_get_order_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_order_info_rep message.
         * @function verify
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_order_info_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.order != null && message.hasOwnProperty("order")) {
                var error = $root.net.order_info.verify(message.order);
                if (error)
                    return "order." + error;
            }
            return null;
        };

        /**
         * Creates a msg_get_order_info_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_order_info_rep} msg_get_order_info_rep
         */
        msg_get_order_info_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_order_info_rep)
                return object;
            var message = new $root.net.msg_get_order_info_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.order != null) {
                if (typeof object.order !== "object")
                    throw TypeError(".net.msg_get_order_info_rep.order: object expected");
                message.order = $root.net.order_info.fromObject(object.order);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_order_info_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {net.msg_get_order_info_rep} message msg_get_order_info_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_order_info_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.order = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = $root.net.order_info.toObject(message.order, options);
            return object;
        };

        /**
         * Converts this msg_get_order_info_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_order_info_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_order_info_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_order_info_rep;
    })();

    net.msg_set_order_paytypeid = (function() {

        /**
         * Properties of a msg_set_order_paytypeid.
         * @memberof net
         * @interface Imsg_set_order_paytypeid
         * @property {number|Long|null} [orderid] msg_set_order_paytypeid orderid
         * @property {number|null} [paytype] msg_set_order_paytypeid paytype
         * @property {number|null} [paytypeid] msg_set_order_paytypeid paytypeid
         */

        /**
         * Constructs a new msg_set_order_paytypeid.
         * @memberof net
         * @classdesc Represents a msg_set_order_paytypeid.
         * @implements Imsg_set_order_paytypeid
         * @constructor
         * @param {net.Imsg_set_order_paytypeid=} [properties] Properties to set
         */
        function msg_set_order_paytypeid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_order_paytypeid orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_order_paytypeid paytype.
         * @member {number} paytype
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.paytype = 0;

        /**
         * msg_set_order_paytypeid paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.paytypeid = 0;

        /**
         * Creates a new msg_set_order_paytypeid instance using the specified properties.
         * @function create
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {net.Imsg_set_order_paytypeid=} [properties] Properties to set
         * @returns {net.msg_set_order_paytypeid} msg_set_order_paytypeid instance
         */
        msg_set_order_paytypeid.create = function create(properties) {
            return new msg_set_order_paytypeid(properties);
        };

        /**
         * Encodes the specified msg_set_order_paytypeid message. Does not implicitly {@link net.msg_set_order_paytypeid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {net.Imsg_set_order_paytypeid} message msg_set_order_paytypeid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytypeid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_order_paytypeid message, length delimited. Does not implicitly {@link net.msg_set_order_paytypeid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {net.Imsg_set_order_paytypeid} message msg_set_order_paytypeid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_order_paytypeid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_order_paytypeid} msg_set_order_paytypeid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_order_paytypeid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.paytype = reader.int32();
                    break;
                case 3:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_order_paytypeid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_order_paytypeid} msg_set_order_paytypeid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_order_paytypeid message.
         * @function verify
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_order_paytypeid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                if (!$util.isInteger(message.paytypeid))
                    return "paytypeid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_order_paytypeid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_order_paytypeid} msg_set_order_paytypeid
         */
        msg_set_order_paytypeid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_order_paytypeid)
                return object;
            var message = new $root.net.msg_set_order_paytypeid();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.paytypeid != null)
                message.paytypeid = object.paytypeid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_order_paytypeid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {net.msg_set_order_paytypeid} message msg_set_order_paytypeid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_order_paytypeid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                object.paytype = 0;
                object.paytypeid = 0;
            }
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                object.paytypeid = message.paytypeid;
            return object;
        };

        /**
         * Converts this msg_set_order_paytypeid to JSON.
         * @function toJSON
         * @memberof net.msg_set_order_paytypeid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_order_paytypeid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_order_paytypeid;
    })();

    net.msg_set_order_paytypeid_rep = (function() {

        /**
         * Properties of a msg_set_order_paytypeid_rep.
         * @memberof net
         * @interface Imsg_set_order_paytypeid_rep
         * @property {number|null} [result] msg_set_order_paytypeid_rep result
         * @property {number|Long|null} [orderid] msg_set_order_paytypeid_rep orderid
         * @property {number|null} [paytype] msg_set_order_paytypeid_rep paytype
         * @property {number|null} [paytypeid] msg_set_order_paytypeid_rep paytypeid
         */

        /**
         * Constructs a new msg_set_order_paytypeid_rep.
         * @memberof net
         * @classdesc Represents a msg_set_order_paytypeid_rep.
         * @implements Imsg_set_order_paytypeid_rep
         * @constructor
         * @param {net.Imsg_set_order_paytypeid_rep=} [properties] Properties to set
         */
        function msg_set_order_paytypeid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_order_paytypeid_rep result.
         * @member {number} result
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.result = 0;

        /**
         * msg_set_order_paytypeid_rep orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_order_paytypeid_rep paytype.
         * @member {number} paytype
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.paytype = 0;

        /**
         * msg_set_order_paytypeid_rep paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.paytypeid = 0;

        /**
         * Creates a new msg_set_order_paytypeid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {net.Imsg_set_order_paytypeid_rep=} [properties] Properties to set
         * @returns {net.msg_set_order_paytypeid_rep} msg_set_order_paytypeid_rep instance
         */
        msg_set_order_paytypeid_rep.create = function create(properties) {
            return new msg_set_order_paytypeid_rep(properties);
        };

        /**
         * Encodes the specified msg_set_order_paytypeid_rep message. Does not implicitly {@link net.msg_set_order_paytypeid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {net.Imsg_set_order_paytypeid_rep} message msg_set_order_paytypeid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paytypeid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_order_paytypeid_rep message, length delimited. Does not implicitly {@link net.msg_set_order_paytypeid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {net.Imsg_set_order_paytypeid_rep} message msg_set_order_paytypeid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_order_paytypeid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_order_paytypeid_rep} msg_set_order_paytypeid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_order_paytypeid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                case 3:
                    message.paytype = reader.int32();
                    break;
                case 4:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_order_paytypeid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_order_paytypeid_rep} msg_set_order_paytypeid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_order_paytypeid_rep message.
         * @function verify
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_order_paytypeid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                if (!$util.isInteger(message.paytype))
                    return "paytype: integer expected";
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                if (!$util.isInteger(message.paytypeid))
                    return "paytypeid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_order_paytypeid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_order_paytypeid_rep} msg_set_order_paytypeid_rep
         */
        msg_set_order_paytypeid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_order_paytypeid_rep)
                return object;
            var message = new $root.net.msg_set_order_paytypeid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.paytype != null)
                message.paytype = object.paytype | 0;
            if (object.paytypeid != null)
                message.paytypeid = object.paytypeid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_order_paytypeid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {net.msg_set_order_paytypeid_rep} message msg_set_order_paytypeid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_order_paytypeid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                object.paytype = 0;
                object.paytypeid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.paytype != null && message.hasOwnProperty("paytype"))
                object.paytype = message.paytype;
            if (message.paytypeid != null && message.hasOwnProperty("paytypeid"))
                object.paytypeid = message.paytypeid;
            return object;
        };

        /**
         * Converts this msg_set_order_paytypeid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_order_paytypeid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_order_paytypeid_rep;
    })();

    net.msg_get_goods_byid = (function() {

        /**
         * Properties of a msg_get_goods_byid.
         * @memberof net
         * @interface Imsg_get_goods_byid
         * @property {number|Long|null} [goodsid] msg_get_goods_byid goodsid
         */

        /**
         * Constructs a new msg_get_goods_byid.
         * @memberof net
         * @classdesc Represents a msg_get_goods_byid.
         * @implements Imsg_get_goods_byid
         * @constructor
         * @param {net.Imsg_get_goods_byid=} [properties] Properties to set
         */
        function msg_get_goods_byid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_byid goodsid.
         * @member {number|Long} goodsid
         * @memberof net.msg_get_goods_byid
         * @instance
         */
        msg_get_goods_byid.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_get_goods_byid instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {net.Imsg_get_goods_byid=} [properties] Properties to set
         * @returns {net.msg_get_goods_byid} msg_get_goods_byid instance
         */
        msg_get_goods_byid.create = function create(properties) {
            return new msg_get_goods_byid(properties);
        };

        /**
         * Encodes the specified msg_get_goods_byid message. Does not implicitly {@link net.msg_get_goods_byid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {net.Imsg_get_goods_byid} message msg_get_goods_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.goodsid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_byid message, length delimited. Does not implicitly {@link net.msg_get_goods_byid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {net.Imsg_get_goods_byid} message msg_get_goods_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_byid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_byid} msg_get_goods_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_byid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_byid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_byid} msg_get_goods_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_byid message.
         * @function verify
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_byid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (!$util.isInteger(message.goodsid) && !(message.goodsid && $util.isInteger(message.goodsid.low) && $util.isInteger(message.goodsid.high)))
                    return "goodsid: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_get_goods_byid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_byid} msg_get_goods_byid
         */
        msg_get_goods_byid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_byid)
                return object;
            var message = new $root.net.msg_get_goods_byid();
            if (object.goodsid != null)
                if ($util.Long)
                    (message.goodsid = $util.Long.fromValue(object.goodsid)).unsigned = false;
                else if (typeof object.goodsid === "string")
                    message.goodsid = parseInt(object.goodsid, 10);
                else if (typeof object.goodsid === "number")
                    message.goodsid = object.goodsid;
                else if (typeof object.goodsid === "object")
                    message.goodsid = new $util.LongBits(object.goodsid.low >>> 0, object.goodsid.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods_byid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {net.msg_get_goods_byid} message msg_get_goods_byid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_byid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.goodsid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.goodsid = options.longs === String ? "0" : 0;
            if (message.goodsid != null && message.hasOwnProperty("goodsid"))
                if (typeof message.goodsid === "number")
                    object.goodsid = options.longs === String ? String(message.goodsid) : message.goodsid;
                else
                    object.goodsid = options.longs === String ? $util.Long.prototype.toString.call(message.goodsid) : options.longs === Number ? new $util.LongBits(message.goodsid.low >>> 0, message.goodsid.high >>> 0).toNumber() : message.goodsid;
            return object;
        };

        /**
         * Converts this msg_get_goods_byid to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_byid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_byid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_byid;
    })();

    net.msg_get_goods_byid_rep = (function() {

        /**
         * Properties of a msg_get_goods_byid_rep.
         * @memberof net
         * @interface Imsg_get_goods_byid_rep
         * @property {net.Igoods_info|null} [g_info] msg_get_goods_byid_rep g_info
         */

        /**
         * Constructs a new msg_get_goods_byid_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_byid_rep.
         * @implements Imsg_get_goods_byid_rep
         * @constructor
         * @param {net.Imsg_get_goods_byid_rep=} [properties] Properties to set
         */
        function msg_get_goods_byid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_byid_rep g_info.
         * @member {net.Igoods_info|null|undefined} g_info
         * @memberof net.msg_get_goods_byid_rep
         * @instance
         */
        msg_get_goods_byid_rep.prototype.g_info = null;

        /**
         * Creates a new msg_get_goods_byid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {net.Imsg_get_goods_byid_rep=} [properties] Properties to set
         * @returns {net.msg_get_goods_byid_rep} msg_get_goods_byid_rep instance
         */
        msg_get_goods_byid_rep.create = function create(properties) {
            return new msg_get_goods_byid_rep(properties);
        };

        /**
         * Encodes the specified msg_get_goods_byid_rep message. Does not implicitly {@link net.msg_get_goods_byid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {net.Imsg_get_goods_byid_rep} message msg_get_goods_byid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.g_info != null && Object.hasOwnProperty.call(message, "g_info"))
                $root.net.goods_info.encode(message.g_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_byid_rep message, length delimited. Does not implicitly {@link net.msg_get_goods_byid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {net.Imsg_get_goods_byid_rep} message msg_get_goods_byid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_byid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_byid_rep} msg_get_goods_byid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_byid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.g_info = $root.net.goods_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_byid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_byid_rep} msg_get_goods_byid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_byid_rep message.
         * @function verify
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_byid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.g_info != null && message.hasOwnProperty("g_info")) {
                var error = $root.net.goods_info.verify(message.g_info);
                if (error)
                    return "g_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_get_goods_byid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_byid_rep} msg_get_goods_byid_rep
         */
        msg_get_goods_byid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_byid_rep)
                return object;
            var message = new $root.net.msg_get_goods_byid_rep();
            if (object.g_info != null) {
                if (typeof object.g_info !== "object")
                    throw TypeError(".net.msg_get_goods_byid_rep.g_info: object expected");
                message.g_info = $root.net.goods_info.fromObject(object.g_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods_byid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {net.msg_get_goods_byid_rep} message msg_get_goods_byid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_byid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.g_info = null;
            if (message.g_info != null && message.hasOwnProperty("g_info"))
                object.g_info = $root.net.goods_info.toObject(message.g_info, options);
            return object;
        };

        /**
         * Converts this msg_get_goods_byid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_byid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_byid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_byid_rep;
    })();

    net.msg_withdraw_chatmsg = (function() {

        /**
         * Properties of a msg_withdraw_chatmsg.
         * @memberof net
         * @interface Imsg_withdraw_chatmsg
         * @property {number|Long|null} [chatkey] msg_withdraw_chatmsg chatkey
         * @property {number|null} [chatmsgno] msg_withdraw_chatmsg chatmsgno
         */

        /**
         * Constructs a new msg_withdraw_chatmsg.
         * @memberof net
         * @classdesc Represents a msg_withdraw_chatmsg.
         * @implements Imsg_withdraw_chatmsg
         * @constructor
         * @param {net.Imsg_withdraw_chatmsg=} [properties] Properties to set
         */
        function msg_withdraw_chatmsg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_withdraw_chatmsg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_withdraw_chatmsg
         * @instance
         */
        msg_withdraw_chatmsg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_withdraw_chatmsg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_withdraw_chatmsg
         * @instance
         */
        msg_withdraw_chatmsg.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_withdraw_chatmsg instance using the specified properties.
         * @function create
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {net.Imsg_withdraw_chatmsg=} [properties] Properties to set
         * @returns {net.msg_withdraw_chatmsg} msg_withdraw_chatmsg instance
         */
        msg_withdraw_chatmsg.create = function create(properties) {
            return new msg_withdraw_chatmsg(properties);
        };

        /**
         * Encodes the specified msg_withdraw_chatmsg message. Does not implicitly {@link net.msg_withdraw_chatmsg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {net.Imsg_withdraw_chatmsg} message msg_withdraw_chatmsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_withdraw_chatmsg message, length delimited. Does not implicitly {@link net.msg_withdraw_chatmsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {net.Imsg_withdraw_chatmsg} message msg_withdraw_chatmsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_withdraw_chatmsg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_withdraw_chatmsg} msg_withdraw_chatmsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_withdraw_chatmsg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_withdraw_chatmsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_withdraw_chatmsg} msg_withdraw_chatmsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_withdraw_chatmsg message.
         * @function verify
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_withdraw_chatmsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_withdraw_chatmsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_withdraw_chatmsg} msg_withdraw_chatmsg
         */
        msg_withdraw_chatmsg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_withdraw_chatmsg)
                return object;
            var message = new $root.net.msg_withdraw_chatmsg();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_withdraw_chatmsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {net.msg_withdraw_chatmsg} message msg_withdraw_chatmsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_withdraw_chatmsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_withdraw_chatmsg to JSON.
         * @function toJSON
         * @memberof net.msg_withdraw_chatmsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_withdraw_chatmsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_withdraw_chatmsg;
    })();

    net.msg_withdraw_chatmsg_rep = (function() {

        /**
         * Properties of a msg_withdraw_chatmsg_rep.
         * @memberof net
         * @interface Imsg_withdraw_chatmsg_rep
         * @property {number|Long|null} [chatkey] msg_withdraw_chatmsg_rep chatkey
         * @property {number|null} [chatmsgno] msg_withdraw_chatmsg_rep chatmsgno
         */

        /**
         * Constructs a new msg_withdraw_chatmsg_rep.
         * @memberof net
         * @classdesc Represents a msg_withdraw_chatmsg_rep.
         * @implements Imsg_withdraw_chatmsg_rep
         * @constructor
         * @param {net.Imsg_withdraw_chatmsg_rep=} [properties] Properties to set
         */
        function msg_withdraw_chatmsg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_withdraw_chatmsg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_withdraw_chatmsg_rep
         * @instance
         */
        msg_withdraw_chatmsg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_withdraw_chatmsg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_withdraw_chatmsg_rep
         * @instance
         */
        msg_withdraw_chatmsg_rep.prototype.chatmsgno = 0;

        /**
         * Creates a new msg_withdraw_chatmsg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {net.Imsg_withdraw_chatmsg_rep=} [properties] Properties to set
         * @returns {net.msg_withdraw_chatmsg_rep} msg_withdraw_chatmsg_rep instance
         */
        msg_withdraw_chatmsg_rep.create = function create(properties) {
            return new msg_withdraw_chatmsg_rep(properties);
        };

        /**
         * Encodes the specified msg_withdraw_chatmsg_rep message. Does not implicitly {@link net.msg_withdraw_chatmsg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {net.Imsg_withdraw_chatmsg_rep} message msg_withdraw_chatmsg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Encodes the specified msg_withdraw_chatmsg_rep message, length delimited. Does not implicitly {@link net.msg_withdraw_chatmsg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {net.Imsg_withdraw_chatmsg_rep} message msg_withdraw_chatmsg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_withdraw_chatmsg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_withdraw_chatmsg_rep} msg_withdraw_chatmsg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_withdraw_chatmsg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_withdraw_chatmsg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_withdraw_chatmsg_rep} msg_withdraw_chatmsg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_withdraw_chatmsg_rep message.
         * @function verify
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_withdraw_chatmsg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                if (!$util.isInteger(message.chatmsgno))
                    return "chatmsgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_withdraw_chatmsg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_withdraw_chatmsg_rep} msg_withdraw_chatmsg_rep
         */
        msg_withdraw_chatmsg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_withdraw_chatmsg_rep)
                return object;
            var message = new $root.net.msg_withdraw_chatmsg_rep();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.chatmsgno != null)
                message.chatmsgno = object.chatmsgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_withdraw_chatmsg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {net.msg_withdraw_chatmsg_rep} message msg_withdraw_chatmsg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_withdraw_chatmsg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.chatmsgno = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.chatmsgno != null && message.hasOwnProperty("chatmsgno"))
                object.chatmsgno = message.chatmsgno;
            return object;
        };

        /**
         * Converts this msg_withdraw_chatmsg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_withdraw_chatmsg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_withdraw_chatmsg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_withdraw_chatmsg_rep;
    })();

    net.msg_cancel_order = (function() {

        /**
         * Properties of a msg_cancel_order.
         * @memberof net
         * @interface Imsg_cancel_order
         * @property {number|Long|null} [orderid] msg_cancel_order orderid
         */

        /**
         * Constructs a new msg_cancel_order.
         * @memberof net
         * @classdesc Represents a msg_cancel_order.
         * @implements Imsg_cancel_order
         * @constructor
         * @param {net.Imsg_cancel_order=} [properties] Properties to set
         */
        function msg_cancel_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_cancel_order orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_cancel_order
         * @instance
         */
        msg_cancel_order.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_cancel_order instance using the specified properties.
         * @function create
         * @memberof net.msg_cancel_order
         * @static
         * @param {net.Imsg_cancel_order=} [properties] Properties to set
         * @returns {net.msg_cancel_order} msg_cancel_order instance
         */
        msg_cancel_order.create = function create(properties) {
            return new msg_cancel_order(properties);
        };

        /**
         * Encodes the specified msg_cancel_order message. Does not implicitly {@link net.msg_cancel_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_cancel_order
         * @static
         * @param {net.Imsg_cancel_order} message msg_cancel_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Encodes the specified msg_cancel_order message, length delimited. Does not implicitly {@link net.msg_cancel_order.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_cancel_order
         * @static
         * @param {net.Imsg_cancel_order} message msg_cancel_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_cancel_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_cancel_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_cancel_order} msg_cancel_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_cancel_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_cancel_order message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_cancel_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_cancel_order} msg_cancel_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_cancel_order message.
         * @function verify
         * @memberof net.msg_cancel_order
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_cancel_order.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_cancel_order message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_cancel_order
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_cancel_order} msg_cancel_order
         */
        msg_cancel_order.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_cancel_order)
                return object;
            var message = new $root.net.msg_cancel_order();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_cancel_order message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_cancel_order
         * @static
         * @param {net.msg_cancel_order} message msg_cancel_order
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_cancel_order.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            return object;
        };

        /**
         * Converts this msg_cancel_order to JSON.
         * @function toJSON
         * @memberof net.msg_cancel_order
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_cancel_order.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_cancel_order;
    })();

    net.msg_cancel_order_rep = (function() {

        /**
         * Properties of a msg_cancel_order_rep.
         * @memberof net
         * @interface Imsg_cancel_order_rep
         * @property {number|null} [result] msg_cancel_order_rep result
         * @property {number|Long|null} [orderid] msg_cancel_order_rep orderid
         * @property {number|null} [buyer] msg_cancel_order_rep buyer
         * @property {number|null} [seller] msg_cancel_order_rep seller
         */

        /**
         * Constructs a new msg_cancel_order_rep.
         * @memberof net
         * @classdesc Represents a msg_cancel_order_rep.
         * @implements Imsg_cancel_order_rep
         * @constructor
         * @param {net.Imsg_cancel_order_rep=} [properties] Properties to set
         */
        function msg_cancel_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_cancel_order_rep result.
         * @member {number} result
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.result = 0;

        /**
         * msg_cancel_order_rep orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_cancel_order_rep buyer.
         * @member {number} buyer
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.buyer = 0;

        /**
         * msg_cancel_order_rep seller.
         * @member {number} seller
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.seller = 0;

        /**
         * Creates a new msg_cancel_order_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {net.Imsg_cancel_order_rep=} [properties] Properties to set
         * @returns {net.msg_cancel_order_rep} msg_cancel_order_rep instance
         */
        msg_cancel_order_rep.create = function create(properties) {
            return new msg_cancel_order_rep(properties);
        };

        /**
         * Encodes the specified msg_cancel_order_rep message. Does not implicitly {@link net.msg_cancel_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {net.Imsg_cancel_order_rep} message msg_cancel_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.seller);
            return writer;
        };

        /**
         * Encodes the specified msg_cancel_order_rep message, length delimited. Does not implicitly {@link net.msg_cancel_order_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {net.Imsg_cancel_order_rep} message msg_cancel_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_cancel_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_cancel_order_rep} msg_cancel_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_cancel_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                case 3:
                    message.buyer = reader.int32();
                    break;
                case 4:
                    message.seller = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_cancel_order_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_cancel_order_rep} msg_cancel_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_cancel_order_rep message.
         * @function verify
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_cancel_order_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                if (!$util.isInteger(message.buyer))
                    return "buyer: integer expected";
            if (message.seller != null && message.hasOwnProperty("seller"))
                if (!$util.isInteger(message.seller))
                    return "seller: integer expected";
            return null;
        };

        /**
         * Creates a msg_cancel_order_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_cancel_order_rep} msg_cancel_order_rep
         */
        msg_cancel_order_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_cancel_order_rep)
                return object;
            var message = new $root.net.msg_cancel_order_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.buyer != null)
                message.buyer = object.buyer | 0;
            if (object.seller != null)
                message.seller = object.seller | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_cancel_order_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {net.msg_cancel_order_rep} message msg_cancel_order_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_cancel_order_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                object.buyer = 0;
                object.seller = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.buyer != null && message.hasOwnProperty("buyer"))
                object.buyer = message.buyer;
            if (message.seller != null && message.hasOwnProperty("seller"))
                object.seller = message.seller;
            return object;
        };

        /**
         * Converts this msg_cancel_order_rep to JSON.
         * @function toJSON
         * @memberof net.msg_cancel_order_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_cancel_order_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_cancel_order_rep;
    })();

    net.msg_get_group_nickname_list = (function() {

        /**
         * Properties of a msg_get_group_nickname_list.
         * @memberof net
         * @interface Imsg_get_group_nickname_list
         * @property {number|null} [groupkey] msg_get_group_nickname_list groupkey
         */

        /**
         * Constructs a new msg_get_group_nickname_list.
         * @memberof net
         * @classdesc Represents a msg_get_group_nickname_list.
         * @implements Imsg_get_group_nickname_list
         * @constructor
         * @param {net.Imsg_get_group_nickname_list=} [properties] Properties to set
         */
        function msg_get_group_nickname_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_nickname_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_nickname_list
         * @instance
         */
        msg_get_group_nickname_list.prototype.groupkey = 0;

        /**
         * Creates a new msg_get_group_nickname_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {net.Imsg_get_group_nickname_list=} [properties] Properties to set
         * @returns {net.msg_get_group_nickname_list} msg_get_group_nickname_list instance
         */
        msg_get_group_nickname_list.create = function create(properties) {
            return new msg_get_group_nickname_list(properties);
        };

        /**
         * Encodes the specified msg_get_group_nickname_list message. Does not implicitly {@link net.msg_get_group_nickname_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {net.Imsg_get_group_nickname_list} message msg_get_group_nickname_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_nickname_list message, length delimited. Does not implicitly {@link net.msg_get_group_nickname_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {net.Imsg_get_group_nickname_list} message msg_get_group_nickname_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_nickname_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_nickname_list} msg_get_group_nickname_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_nickname_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_nickname_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_nickname_list} msg_get_group_nickname_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_nickname_list message.
         * @function verify
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_nickname_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_nickname_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_nickname_list} msg_get_group_nickname_list
         */
        msg_get_group_nickname_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_nickname_list)
                return object;
            var message = new $root.net.msg_get_group_nickname_list();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_nickname_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {net.msg_get_group_nickname_list} message msg_get_group_nickname_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_nickname_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_get_group_nickname_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_nickname_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_nickname_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_nickname_list;
    })();

    net.msg_get_group_nickname_list_rep = (function() {

        /**
         * Properties of a msg_get_group_nickname_list_rep.
         * @memberof net
         * @interface Imsg_get_group_nickname_list_rep
         * @property {number|null} [groupkey] msg_get_group_nickname_list_rep groupkey
         * @property {Array.<net.Igroup_nickname_info>|null} [name_list] msg_get_group_nickname_list_rep name_list
         */

        /**
         * Constructs a new msg_get_group_nickname_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_nickname_list_rep.
         * @implements Imsg_get_group_nickname_list_rep
         * @constructor
         * @param {net.Imsg_get_group_nickname_list_rep=} [properties] Properties to set
         */
        function msg_get_group_nickname_list_rep(properties) {
            this.name_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_nickname_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_nickname_list_rep
         * @instance
         */
        msg_get_group_nickname_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_group_nickname_list_rep name_list.
         * @member {Array.<net.Igroup_nickname_info>} name_list
         * @memberof net.msg_get_group_nickname_list_rep
         * @instance
         */
        msg_get_group_nickname_list_rep.prototype.name_list = $util.emptyArray;

        /**
         * Creates a new msg_get_group_nickname_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {net.Imsg_get_group_nickname_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_group_nickname_list_rep} msg_get_group_nickname_list_rep instance
         */
        msg_get_group_nickname_list_rep.create = function create(properties) {
            return new msg_get_group_nickname_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_group_nickname_list_rep message. Does not implicitly {@link net.msg_get_group_nickname_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {net.Imsg_get_group_nickname_list_rep} message msg_get_group_nickname_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.name_list != null && message.name_list.length)
                for (var i = 0; i < message.name_list.length; ++i)
                    $root.net.group_nickname_info.encode(message.name_list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_nickname_list_rep message, length delimited. Does not implicitly {@link net.msg_get_group_nickname_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {net.Imsg_get_group_nickname_list_rep} message msg_get_group_nickname_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_nickname_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_nickname_list_rep} msg_get_group_nickname_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_nickname_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.name_list && message.name_list.length))
                        message.name_list = [];
                    message.name_list.push($root.net.group_nickname_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_nickname_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_nickname_list_rep} msg_get_group_nickname_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_nickname_list_rep message.
         * @function verify
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_nickname_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.name_list != null && message.hasOwnProperty("name_list")) {
                if (!Array.isArray(message.name_list))
                    return "name_list: array expected";
                for (var i = 0; i < message.name_list.length; ++i) {
                    var error = $root.net.group_nickname_info.verify(message.name_list[i]);
                    if (error)
                        return "name_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_group_nickname_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_nickname_list_rep} msg_get_group_nickname_list_rep
         */
        msg_get_group_nickname_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_nickname_list_rep)
                return object;
            var message = new $root.net.msg_get_group_nickname_list_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.name_list) {
                if (!Array.isArray(object.name_list))
                    throw TypeError(".net.msg_get_group_nickname_list_rep.name_list: array expected");
                message.name_list = [];
                for (var i = 0; i < object.name_list.length; ++i) {
                    if (typeof object.name_list[i] !== "object")
                        throw TypeError(".net.msg_get_group_nickname_list_rep.name_list: object expected");
                    message.name_list[i] = $root.net.group_nickname_info.fromObject(object.name_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_nickname_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {net.msg_get_group_nickname_list_rep} message msg_get_group_nickname_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_nickname_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.name_list = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.name_list && message.name_list.length) {
                object.name_list = [];
                for (var j = 0; j < message.name_list.length; ++j)
                    object.name_list[j] = $root.net.group_nickname_info.toObject(message.name_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_group_nickname_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_nickname_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_nickname_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_nickname_list_rep;
    })();

    net.msg_set_group_nickname = (function() {

        /**
         * Properties of a msg_set_group_nickname.
         * @memberof net
         * @interface Imsg_set_group_nickname
         * @property {number|null} [groupkey] msg_set_group_nickname groupkey
         * @property {Uint8Array|null} [nickname] msg_set_group_nickname nickname
         */

        /**
         * Constructs a new msg_set_group_nickname.
         * @memberof net
         * @classdesc Represents a msg_set_group_nickname.
         * @implements Imsg_set_group_nickname
         * @constructor
         * @param {net.Imsg_set_group_nickname=} [properties] Properties to set
         */
        function msg_set_group_nickname(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_nickname groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_nickname
         * @instance
         */
        msg_set_group_nickname.prototype.groupkey = 0;

        /**
         * msg_set_group_nickname nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_set_group_nickname
         * @instance
         */
        msg_set_group_nickname.prototype.nickname = $util.newBuffer([]);

        /**
         * Creates a new msg_set_group_nickname instance using the specified properties.
         * @function create
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {net.Imsg_set_group_nickname=} [properties] Properties to set
         * @returns {net.msg_set_group_nickname} msg_set_group_nickname instance
         */
        msg_set_group_nickname.create = function create(properties) {
            return new msg_set_group_nickname(properties);
        };

        /**
         * Encodes the specified msg_set_group_nickname message. Does not implicitly {@link net.msg_set_group_nickname.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {net.Imsg_set_group_nickname} message msg_set_group_nickname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            return writer;
        };

        /**
         * Encodes the specified msg_set_group_nickname message, length delimited. Does not implicitly {@link net.msg_set_group_nickname.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {net.Imsg_set_group_nickname} message msg_set_group_nickname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_group_nickname message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_nickname} msg_set_group_nickname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_nickname();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_group_nickname message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_group_nickname} msg_set_group_nickname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_group_nickname message.
         * @function verify
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_group_nickname.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_group_nickname message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_group_nickname} msg_set_group_nickname
         */
        msg_set_group_nickname.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_group_nickname)
                return object;
            var message = new $root.net.msg_set_group_nickname();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_group_nickname message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {net.msg_set_group_nickname} message msg_set_group_nickname
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_group_nickname.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            return object;
        };

        /**
         * Converts this msg_set_group_nickname to JSON.
         * @function toJSON
         * @memberof net.msg_set_group_nickname
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_group_nickname.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_group_nickname;
    })();

    net.msg_set_group_nickname_rep = (function() {

        /**
         * Properties of a msg_set_group_nickname_rep.
         * @memberof net
         * @interface Imsg_set_group_nickname_rep
         * @property {number|null} [groupkey] msg_set_group_nickname_rep groupkey
         * @property {Uint8Array|null} [nickname] msg_set_group_nickname_rep nickname
         * @property {number|null} [uid] msg_set_group_nickname_rep uid
         */

        /**
         * Constructs a new msg_set_group_nickname_rep.
         * @memberof net
         * @classdesc Represents a msg_set_group_nickname_rep.
         * @implements Imsg_set_group_nickname_rep
         * @constructor
         * @param {net.Imsg_set_group_nickname_rep=} [properties] Properties to set
         */
        function msg_set_group_nickname_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_nickname_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.groupkey = 0;

        /**
         * msg_set_group_nickname_rep nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.nickname = $util.newBuffer([]);

        /**
         * msg_set_group_nickname_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.uid = 0;

        /**
         * Creates a new msg_set_group_nickname_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {net.Imsg_set_group_nickname_rep=} [properties] Properties to set
         * @returns {net.msg_set_group_nickname_rep} msg_set_group_nickname_rep instance
         */
        msg_set_group_nickname_rep.create = function create(properties) {
            return new msg_set_group_nickname_rep(properties);
        };

        /**
         * Encodes the specified msg_set_group_nickname_rep message. Does not implicitly {@link net.msg_set_group_nickname_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {net.Imsg_set_group_nickname_rep} message msg_set_group_nickname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_group_nickname_rep message, length delimited. Does not implicitly {@link net.msg_set_group_nickname_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {net.Imsg_set_group_nickname_rep} message msg_set_group_nickname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_group_nickname_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_nickname_rep} msg_set_group_nickname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_nickname_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_group_nickname_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_group_nickname_rep} msg_set_group_nickname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_group_nickname_rep message.
         * @function verify
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_group_nickname_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!(message.nickname && typeof message.nickname.length === "number" || $util.isString(message.nickname)))
                    return "nickname: buffer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_group_nickname_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_group_nickname_rep} msg_set_group_nickname_rep
         */
        msg_set_group_nickname_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_group_nickname_rep)
                return object;
            var message = new $root.net.msg_set_group_nickname_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.nickname != null)
                if (typeof object.nickname === "string")
                    $util.base64.decode(object.nickname, message.nickname = $util.newBuffer($util.base64.length(object.nickname)), 0);
                else if (object.nickname.length)
                    message.nickname = object.nickname;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_group_nickname_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {net.msg_set_group_nickname_rep} message msg_set_group_nickname_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_group_nickname_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                if (options.bytes === String)
                    object.nickname = "";
                else {
                    object.nickname = [];
                    if (options.bytes !== Array)
                        object.nickname = $util.newBuffer(object.nickname);
                }
                object.uid = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = options.bytes === String ? $util.base64.encode(message.nickname, 0, message.nickname.length) : options.bytes === Array ? Array.prototype.slice.call(message.nickname) : message.nickname;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_set_group_nickname_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_group_nickname_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_group_nickname_rep;
    })();

    net.msg_get_goods_data = (function() {

        /**
         * Properties of a msg_get_goods_data.
         * @memberof net
         * @interface Imsg_get_goods_data
         */

        /**
         * Constructs a new msg_get_goods_data.
         * @memberof net
         * @classdesc Represents a msg_get_goods_data.
         * @implements Imsg_get_goods_data
         * @constructor
         * @param {net.Imsg_get_goods_data=} [properties] Properties to set
         */
        function msg_get_goods_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_goods_data instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_data
         * @static
         * @param {net.Imsg_get_goods_data=} [properties] Properties to set
         * @returns {net.msg_get_goods_data} msg_get_goods_data instance
         */
        msg_get_goods_data.create = function create(properties) {
            return new msg_get_goods_data(properties);
        };

        /**
         * Encodes the specified msg_get_goods_data message. Does not implicitly {@link net.msg_get_goods_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_data
         * @static
         * @param {net.Imsg_get_goods_data} message msg_get_goods_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_data message, length delimited. Does not implicitly {@link net.msg_get_goods_data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_data
         * @static
         * @param {net.Imsg_get_goods_data} message msg_get_goods_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_data} msg_get_goods_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_data} msg_get_goods_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_data message.
         * @function verify
         * @memberof net.msg_get_goods_data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_goods_data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_data} msg_get_goods_data
         */
        msg_get_goods_data.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_data)
                return object;
            return new $root.net.msg_get_goods_data();
        };

        /**
         * Creates a plain object from a msg_get_goods_data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_data
         * @static
         * @param {net.msg_get_goods_data} message msg_get_goods_data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_data.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_goods_data to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_data;
    })();

    net.msg_get_goods_data_rep = (function() {

        /**
         * Properties of a msg_get_goods_data_rep.
         * @memberof net
         * @interface Imsg_get_goods_data_rep
         * @property {Array.<net.Igoods_deal_data>|null} [datalist] msg_get_goods_data_rep datalist
         */

        /**
         * Constructs a new msg_get_goods_data_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_data_rep.
         * @implements Imsg_get_goods_data_rep
         * @constructor
         * @param {net.Imsg_get_goods_data_rep=} [properties] Properties to set
         */
        function msg_get_goods_data_rep(properties) {
            this.datalist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_data_rep datalist.
         * @member {Array.<net.Igoods_deal_data>} datalist
         * @memberof net.msg_get_goods_data_rep
         * @instance
         */
        msg_get_goods_data_rep.prototype.datalist = $util.emptyArray;

        /**
         * Creates a new msg_get_goods_data_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {net.Imsg_get_goods_data_rep=} [properties] Properties to set
         * @returns {net.msg_get_goods_data_rep} msg_get_goods_data_rep instance
         */
        msg_get_goods_data_rep.create = function create(properties) {
            return new msg_get_goods_data_rep(properties);
        };

        /**
         * Encodes the specified msg_get_goods_data_rep message. Does not implicitly {@link net.msg_get_goods_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {net.Imsg_get_goods_data_rep} message msg_get_goods_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.datalist != null && message.datalist.length)
                for (var i = 0; i < message.datalist.length; ++i)
                    $root.net.goods_deal_data.encode(message.datalist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_data_rep message, length delimited. Does not implicitly {@link net.msg_get_goods_data_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {net.Imsg_get_goods_data_rep} message msg_get_goods_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_data_rep} msg_get_goods_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.datalist && message.datalist.length))
                        message.datalist = [];
                    message.datalist.push($root.net.goods_deal_data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_data_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_data_rep} msg_get_goods_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_data_rep message.
         * @function verify
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_data_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.datalist != null && message.hasOwnProperty("datalist")) {
                if (!Array.isArray(message.datalist))
                    return "datalist: array expected";
                for (var i = 0; i < message.datalist.length; ++i) {
                    var error = $root.net.goods_deal_data.verify(message.datalist[i]);
                    if (error)
                        return "datalist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_goods_data_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_data_rep} msg_get_goods_data_rep
         */
        msg_get_goods_data_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_data_rep)
                return object;
            var message = new $root.net.msg_get_goods_data_rep();
            if (object.datalist) {
                if (!Array.isArray(object.datalist))
                    throw TypeError(".net.msg_get_goods_data_rep.datalist: array expected");
                message.datalist = [];
                for (var i = 0; i < object.datalist.length; ++i) {
                    if (typeof object.datalist[i] !== "object")
                        throw TypeError(".net.msg_get_goods_data_rep.datalist: object expected");
                    message.datalist[i] = $root.net.goods_deal_data.fromObject(object.datalist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods_data_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {net.msg_get_goods_data_rep} message msg_get_goods_data_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_data_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.datalist = [];
            if (message.datalist && message.datalist.length) {
                object.datalist = [];
                for (var j = 0; j < message.datalist.length; ++j)
                    object.datalist[j] = $root.net.goods_deal_data.toObject(message.datalist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_goods_data_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_data_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_data_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_data_rep;
    })();

    net.msg_get_goods_detail_data = (function() {

        /**
         * Properties of a msg_get_goods_detail_data.
         * @memberof net
         * @interface Imsg_get_goods_detail_data
         */

        /**
         * Constructs a new msg_get_goods_detail_data.
         * @memberof net
         * @classdesc Represents a msg_get_goods_detail_data.
         * @implements Imsg_get_goods_detail_data
         * @constructor
         * @param {net.Imsg_get_goods_detail_data=} [properties] Properties to set
         */
        function msg_get_goods_detail_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_goods_detail_data instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {net.Imsg_get_goods_detail_data=} [properties] Properties to set
         * @returns {net.msg_get_goods_detail_data} msg_get_goods_detail_data instance
         */
        msg_get_goods_detail_data.create = function create(properties) {
            return new msg_get_goods_detail_data(properties);
        };

        /**
         * Encodes the specified msg_get_goods_detail_data message. Does not implicitly {@link net.msg_get_goods_detail_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {net.Imsg_get_goods_detail_data} message msg_get_goods_detail_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_detail_data message, length delimited. Does not implicitly {@link net.msg_get_goods_detail_data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {net.Imsg_get_goods_detail_data} message msg_get_goods_detail_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_detail_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_detail_data} msg_get_goods_detail_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_detail_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_detail_data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_detail_data} msg_get_goods_detail_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_detail_data message.
         * @function verify
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_detail_data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_goods_detail_data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_detail_data} msg_get_goods_detail_data
         */
        msg_get_goods_detail_data.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_detail_data)
                return object;
            return new $root.net.msg_get_goods_detail_data();
        };

        /**
         * Creates a plain object from a msg_get_goods_detail_data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {net.msg_get_goods_detail_data} message msg_get_goods_detail_data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_detail_data.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_goods_detail_data to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_detail_data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_detail_data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_detail_data;
    })();

    net.msg_get_goods_detail_data_rep = (function() {

        /**
         * Properties of a msg_get_goods_detail_data_rep.
         * @memberof net
         * @interface Imsg_get_goods_detail_data_rep
         * @property {Array.<net.Imoney_change_info>|null} [bill_list] msg_get_goods_detail_data_rep bill_list
         */

        /**
         * Constructs a new msg_get_goods_detail_data_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_detail_data_rep.
         * @implements Imsg_get_goods_detail_data_rep
         * @constructor
         * @param {net.Imsg_get_goods_detail_data_rep=} [properties] Properties to set
         */
        function msg_get_goods_detail_data_rep(properties) {
            this.bill_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_detail_data_rep bill_list.
         * @member {Array.<net.Imoney_change_info>} bill_list
         * @memberof net.msg_get_goods_detail_data_rep
         * @instance
         */
        msg_get_goods_detail_data_rep.prototype.bill_list = $util.emptyArray;

        /**
         * Creates a new msg_get_goods_detail_data_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {net.Imsg_get_goods_detail_data_rep=} [properties] Properties to set
         * @returns {net.msg_get_goods_detail_data_rep} msg_get_goods_detail_data_rep instance
         */
        msg_get_goods_detail_data_rep.create = function create(properties) {
            return new msg_get_goods_detail_data_rep(properties);
        };

        /**
         * Encodes the specified msg_get_goods_detail_data_rep message. Does not implicitly {@link net.msg_get_goods_detail_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {net.Imsg_get_goods_detail_data_rep} message msg_get_goods_detail_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.bill_list != null && message.bill_list.length)
                for (var i = 0; i < message.bill_list.length; ++i)
                    $root.net.money_change_info.encode(message.bill_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_goods_detail_data_rep message, length delimited. Does not implicitly {@link net.msg_get_goods_detail_data_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {net.Imsg_get_goods_detail_data_rep} message msg_get_goods_detail_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_goods_detail_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_detail_data_rep} msg_get_goods_detail_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_detail_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.bill_list && message.bill_list.length))
                        message.bill_list = [];
                    message.bill_list.push($root.net.money_change_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_goods_detail_data_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_goods_detail_data_rep} msg_get_goods_detail_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_goods_detail_data_rep message.
         * @function verify
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_goods_detail_data_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.bill_list != null && message.hasOwnProperty("bill_list")) {
                if (!Array.isArray(message.bill_list))
                    return "bill_list: array expected";
                for (var i = 0; i < message.bill_list.length; ++i) {
                    var error = $root.net.money_change_info.verify(message.bill_list[i]);
                    if (error)
                        return "bill_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_goods_detail_data_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_goods_detail_data_rep} msg_get_goods_detail_data_rep
         */
        msg_get_goods_detail_data_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_goods_detail_data_rep)
                return object;
            var message = new $root.net.msg_get_goods_detail_data_rep();
            if (object.bill_list) {
                if (!Array.isArray(object.bill_list))
                    throw TypeError(".net.msg_get_goods_detail_data_rep.bill_list: array expected");
                message.bill_list = [];
                for (var i = 0; i < object.bill_list.length; ++i) {
                    if (typeof object.bill_list[i] !== "object")
                        throw TypeError(".net.msg_get_goods_detail_data_rep.bill_list: object expected");
                    message.bill_list[i] = $root.net.money_change_info.fromObject(object.bill_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_goods_detail_data_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {net.msg_get_goods_detail_data_rep} message msg_get_goods_detail_data_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_goods_detail_data_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bill_list = [];
            if (message.bill_list && message.bill_list.length) {
                object.bill_list = [];
                for (var j = 0; j < message.bill_list.length; ++j)
                    object.bill_list[j] = $root.net.money_change_info.toObject(message.bill_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_goods_detail_data_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_goods_detail_data_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_goods_detail_data_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_goods_detail_data_rep;
    })();

    net.msg_oper_shopcoin = (function() {

        /**
         * Properties of a msg_oper_shopcoin.
         * @memberof net
         * @interface Imsg_oper_shopcoin
         * @property {number|null} [opertype] msg_oper_shopcoin opertype
         * @property {number|null} [amount] msg_oper_shopcoin amount
         * @property {Uint8Array|null} [authcode] msg_oper_shopcoin authcode
         * @property {number|null} [cointype] msg_oper_shopcoin cointype
         */

        /**
         * Constructs a new msg_oper_shopcoin.
         * @memberof net
         * @classdesc Represents a msg_oper_shopcoin.
         * @implements Imsg_oper_shopcoin
         * @constructor
         * @param {net.Imsg_oper_shopcoin=} [properties] Properties to set
         */
        function msg_oper_shopcoin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_shopcoin opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.opertype = 0;

        /**
         * msg_oper_shopcoin amount.
         * @member {number} amount
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.amount = 0;

        /**
         * msg_oper_shopcoin authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.authcode = $util.newBuffer([]);

        /**
         * msg_oper_shopcoin cointype.
         * @member {number} cointype
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.cointype = 0;

        /**
         * Creates a new msg_oper_shopcoin instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {net.Imsg_oper_shopcoin=} [properties] Properties to set
         * @returns {net.msg_oper_shopcoin} msg_oper_shopcoin instance
         */
        msg_oper_shopcoin.create = function create(properties) {
            return new msg_oper_shopcoin(properties);
        };

        /**
         * Encodes the specified msg_oper_shopcoin message. Does not implicitly {@link net.msg_oper_shopcoin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {net.Imsg_oper_shopcoin} message msg_oper_shopcoin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opertype);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.amount);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.authcode);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.cointype);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_shopcoin message, length delimited. Does not implicitly {@link net.msg_oper_shopcoin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {net.Imsg_oper_shopcoin} message msg_oper_shopcoin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_shopcoin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_shopcoin} msg_oper_shopcoin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_shopcoin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.opertype = reader.int32();
                    break;
                case 2:
                    message.amount = reader.int32();
                    break;
                case 3:
                    message.authcode = reader.bytes();
                    break;
                case 4:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_shopcoin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_shopcoin} msg_oper_shopcoin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_shopcoin message.
         * @function verify
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_shopcoin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (!$util.isInteger(message.amount))
                    return "amount: integer expected";
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                if (!(message.authcode && typeof message.authcode.length === "number" || $util.isString(message.authcode)))
                    return "authcode: buffer expected";
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                if (!$util.isInteger(message.cointype))
                    return "cointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_shopcoin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_shopcoin} msg_oper_shopcoin
         */
        msg_oper_shopcoin.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_shopcoin)
                return object;
            var message = new $root.net.msg_oper_shopcoin();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            if (object.amount != null)
                message.amount = object.amount | 0;
            if (object.authcode != null)
                if (typeof object.authcode === "string")
                    $util.base64.decode(object.authcode, message.authcode = $util.newBuffer($util.base64.length(object.authcode)), 0);
                else if (object.authcode.length)
                    message.authcode = object.authcode;
            if (object.cointype != null)
                message.cointype = object.cointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_shopcoin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {net.msg_oper_shopcoin} message msg_oper_shopcoin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_shopcoin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.opertype = 0;
                object.amount = 0;
                if (options.bytes === String)
                    object.authcode = "";
                else {
                    object.authcode = [];
                    if (options.bytes !== Array)
                        object.authcode = $util.newBuffer(object.authcode);
                }
                object.cointype = 0;
            }
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = message.amount;
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                object.authcode = options.bytes === String ? $util.base64.encode(message.authcode, 0, message.authcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.authcode) : message.authcode;
            if (message.cointype != null && message.hasOwnProperty("cointype"))
                object.cointype = message.cointype;
            return object;
        };

        /**
         * Converts this msg_oper_shopcoin to JSON.
         * @function toJSON
         * @memberof net.msg_oper_shopcoin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_shopcoin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_shopcoin;
    })();

    net.msg_oper_shopcoin_rep = (function() {

        /**
         * Properties of a msg_oper_shopcoin_rep.
         * @memberof net
         * @interface Imsg_oper_shopcoin_rep
         * @property {number|null} [result] msg_oper_shopcoin_rep result
         */

        /**
         * Constructs a new msg_oper_shopcoin_rep.
         * @memberof net
         * @classdesc Represents a msg_oper_shopcoin_rep.
         * @implements Imsg_oper_shopcoin_rep
         * @constructor
         * @param {net.Imsg_oper_shopcoin_rep=} [properties] Properties to set
         */
        function msg_oper_shopcoin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_shopcoin_rep result.
         * @member {number} result
         * @memberof net.msg_oper_shopcoin_rep
         * @instance
         */
        msg_oper_shopcoin_rep.prototype.result = 0;

        /**
         * Creates a new msg_oper_shopcoin_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {net.Imsg_oper_shopcoin_rep=} [properties] Properties to set
         * @returns {net.msg_oper_shopcoin_rep} msg_oper_shopcoin_rep instance
         */
        msg_oper_shopcoin_rep.create = function create(properties) {
            return new msg_oper_shopcoin_rep(properties);
        };

        /**
         * Encodes the specified msg_oper_shopcoin_rep message. Does not implicitly {@link net.msg_oper_shopcoin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {net.Imsg_oper_shopcoin_rep} message msg_oper_shopcoin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_shopcoin_rep message, length delimited. Does not implicitly {@link net.msg_oper_shopcoin_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {net.Imsg_oper_shopcoin_rep} message msg_oper_shopcoin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_shopcoin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_shopcoin_rep} msg_oper_shopcoin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_shopcoin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_shopcoin_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_shopcoin_rep} msg_oper_shopcoin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_shopcoin_rep message.
         * @function verify
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_shopcoin_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_shopcoin_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_shopcoin_rep} msg_oper_shopcoin_rep
         */
        msg_oper_shopcoin_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_shopcoin_rep)
                return object;
            var message = new $root.net.msg_oper_shopcoin_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_shopcoin_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {net.msg_oper_shopcoin_rep} message msg_oper_shopcoin_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_shopcoin_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_oper_shopcoin_rep to JSON.
         * @function toJSON
         * @memberof net.msg_oper_shopcoin_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_shopcoin_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_shopcoin_rep;
    })();

    net.msg_set_snapchat = (function() {

        /**
         * Properties of a msg_set_snapchat.
         * @memberof net
         * @interface Imsg_set_snapchat
         * @property {number|Long|null} [chatkey] msg_set_snapchat chatkey
         * @property {number|null} [snaptime] msg_set_snapchat snaptime
         */

        /**
         * Constructs a new msg_set_snapchat.
         * @memberof net
         * @classdesc Represents a msg_set_snapchat.
         * @implements Imsg_set_snapchat
         * @constructor
         * @param {net.Imsg_set_snapchat=} [properties] Properties to set
         */
        function msg_set_snapchat(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_snapchat chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_snapchat
         * @instance
         */
        msg_set_snapchat.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_snapchat snaptime.
         * @member {number} snaptime
         * @memberof net.msg_set_snapchat
         * @instance
         */
        msg_set_snapchat.prototype.snaptime = 0;

        /**
         * Creates a new msg_set_snapchat instance using the specified properties.
         * @function create
         * @memberof net.msg_set_snapchat
         * @static
         * @param {net.Imsg_set_snapchat=} [properties] Properties to set
         * @returns {net.msg_set_snapchat} msg_set_snapchat instance
         */
        msg_set_snapchat.create = function create(properties) {
            return new msg_set_snapchat(properties);
        };

        /**
         * Encodes the specified msg_set_snapchat message. Does not implicitly {@link net.msg_set_snapchat.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_snapchat
         * @static
         * @param {net.Imsg_set_snapchat} message msg_set_snapchat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.snaptime);
            return writer;
        };

        /**
         * Encodes the specified msg_set_snapchat message, length delimited. Does not implicitly {@link net.msg_set_snapchat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_snapchat
         * @static
         * @param {net.Imsg_set_snapchat} message msg_set_snapchat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_snapchat message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_snapchat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_snapchat} msg_set_snapchat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_snapchat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_snapchat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_snapchat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_snapchat} msg_set_snapchat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_snapchat message.
         * @function verify
         * @memberof net.msg_set_snapchat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_snapchat.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                if (!$util.isInteger(message.snaptime))
                    return "snaptime: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_snapchat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_snapchat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_snapchat} msg_set_snapchat
         */
        msg_set_snapchat.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_snapchat)
                return object;
            var message = new $root.net.msg_set_snapchat();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.snaptime != null)
                message.snaptime = object.snaptime | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_snapchat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_snapchat
         * @static
         * @param {net.msg_set_snapchat} message msg_set_snapchat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_snapchat.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.snaptime = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                object.snaptime = message.snaptime;
            return object;
        };

        /**
         * Converts this msg_set_snapchat to JSON.
         * @function toJSON
         * @memberof net.msg_set_snapchat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_snapchat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_snapchat;
    })();

    net.msg_set_snapchat_rep = (function() {

        /**
         * Properties of a msg_set_snapchat_rep.
         * @memberof net
         * @interface Imsg_set_snapchat_rep
         * @property {number|null} [result] msg_set_snapchat_rep result
         * @property {number|Long|null} [chatkey] msg_set_snapchat_rep chatkey
         * @property {number|null} [snaptime] msg_set_snapchat_rep snaptime
         */

        /**
         * Constructs a new msg_set_snapchat_rep.
         * @memberof net
         * @classdesc Represents a msg_set_snapchat_rep.
         * @implements Imsg_set_snapchat_rep
         * @constructor
         * @param {net.Imsg_set_snapchat_rep=} [properties] Properties to set
         */
        function msg_set_snapchat_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_snapchat_rep result.
         * @member {number} result
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.result = 0;

        /**
         * msg_set_snapchat_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_snapchat_rep snaptime.
         * @member {number} snaptime
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.snaptime = 0;

        /**
         * Creates a new msg_set_snapchat_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {net.Imsg_set_snapchat_rep=} [properties] Properties to set
         * @returns {net.msg_set_snapchat_rep} msg_set_snapchat_rep instance
         */
        msg_set_snapchat_rep.create = function create(properties) {
            return new msg_set_snapchat_rep(properties);
        };

        /**
         * Encodes the specified msg_set_snapchat_rep message. Does not implicitly {@link net.msg_set_snapchat_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {net.Imsg_set_snapchat_rep} message msg_set_snapchat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.snaptime);
            return writer;
        };

        /**
         * Encodes the specified msg_set_snapchat_rep message, length delimited. Does not implicitly {@link net.msg_set_snapchat_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {net.Imsg_set_snapchat_rep} message msg_set_snapchat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_snapchat_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_snapchat_rep} msg_set_snapchat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_snapchat_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_snapchat_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_snapchat_rep} msg_set_snapchat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_snapchat_rep message.
         * @function verify
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_snapchat_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                if (!$util.isInteger(message.snaptime))
                    return "snaptime: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_snapchat_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_snapchat_rep} msg_set_snapchat_rep
         */
        msg_set_snapchat_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_snapchat_rep)
                return object;
            var message = new $root.net.msg_set_snapchat_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.snaptime != null)
                message.snaptime = object.snaptime | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_snapchat_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {net.msg_set_snapchat_rep} message msg_set_snapchat_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_snapchat_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.snaptime = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.snaptime != null && message.hasOwnProperty("snaptime"))
                object.snaptime = message.snaptime;
            return object;
        };

        /**
         * Converts this msg_set_snapchat_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_snapchat_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_snapchat_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_snapchat_rep;
    })();

    net.msg_get_snap_list = (function() {

        /**
         * Properties of a msg_get_snap_list.
         * @memberof net
         * @interface Imsg_get_snap_list
         */

        /**
         * Constructs a new msg_get_snap_list.
         * @memberof net
         * @classdesc Represents a msg_get_snap_list.
         * @implements Imsg_get_snap_list
         * @constructor
         * @param {net.Imsg_get_snap_list=} [properties] Properties to set
         */
        function msg_get_snap_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_snap_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_snap_list
         * @static
         * @param {net.Imsg_get_snap_list=} [properties] Properties to set
         * @returns {net.msg_get_snap_list} msg_get_snap_list instance
         */
        msg_get_snap_list.create = function create(properties) {
            return new msg_get_snap_list(properties);
        };

        /**
         * Encodes the specified msg_get_snap_list message. Does not implicitly {@link net.msg_get_snap_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_snap_list
         * @static
         * @param {net.Imsg_get_snap_list} message msg_get_snap_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_snap_list message, length delimited. Does not implicitly {@link net.msg_get_snap_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_snap_list
         * @static
         * @param {net.Imsg_get_snap_list} message msg_get_snap_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_snap_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_snap_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_snap_list} msg_get_snap_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_snap_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_snap_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_snap_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_snap_list} msg_get_snap_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_snap_list message.
         * @function verify
         * @memberof net.msg_get_snap_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_snap_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_snap_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_snap_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_snap_list} msg_get_snap_list
         */
        msg_get_snap_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_snap_list)
                return object;
            return new $root.net.msg_get_snap_list();
        };

        /**
         * Creates a plain object from a msg_get_snap_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_snap_list
         * @static
         * @param {net.msg_get_snap_list} message msg_get_snap_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_snap_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_snap_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_snap_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_snap_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_snap_list;
    })();

    net.msg_get_snap_list_rep = (function() {

        /**
         * Properties of a msg_get_snap_list_rep.
         * @memberof net
         * @interface Imsg_get_snap_list_rep
         * @property {Array.<net.Isnap_chatkey_info>|null} [snaplist] msg_get_snap_list_rep snaplist
         */

        /**
         * Constructs a new msg_get_snap_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_snap_list_rep.
         * @implements Imsg_get_snap_list_rep
         * @constructor
         * @param {net.Imsg_get_snap_list_rep=} [properties] Properties to set
         */
        function msg_get_snap_list_rep(properties) {
            this.snaplist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_snap_list_rep snaplist.
         * @member {Array.<net.Isnap_chatkey_info>} snaplist
         * @memberof net.msg_get_snap_list_rep
         * @instance
         */
        msg_get_snap_list_rep.prototype.snaplist = $util.emptyArray;

        /**
         * Creates a new msg_get_snap_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {net.Imsg_get_snap_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_snap_list_rep} msg_get_snap_list_rep instance
         */
        msg_get_snap_list_rep.create = function create(properties) {
            return new msg_get_snap_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_snap_list_rep message. Does not implicitly {@link net.msg_get_snap_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {net.Imsg_get_snap_list_rep} message msg_get_snap_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.snaplist != null && message.snaplist.length)
                for (var i = 0; i < message.snaplist.length; ++i)
                    $root.net.snap_chatkey_info.encode(message.snaplist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_snap_list_rep message, length delimited. Does not implicitly {@link net.msg_get_snap_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {net.Imsg_get_snap_list_rep} message msg_get_snap_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_snap_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_snap_list_rep} msg_get_snap_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_snap_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.snaplist && message.snaplist.length))
                        message.snaplist = [];
                    message.snaplist.push($root.net.snap_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_snap_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_snap_list_rep} msg_get_snap_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_snap_list_rep message.
         * @function verify
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_snap_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.snaplist != null && message.hasOwnProperty("snaplist")) {
                if (!Array.isArray(message.snaplist))
                    return "snaplist: array expected";
                for (var i = 0; i < message.snaplist.length; ++i) {
                    var error = $root.net.snap_chatkey_info.verify(message.snaplist[i]);
                    if (error)
                        return "snaplist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_snap_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_snap_list_rep} msg_get_snap_list_rep
         */
        msg_get_snap_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_snap_list_rep)
                return object;
            var message = new $root.net.msg_get_snap_list_rep();
            if (object.snaplist) {
                if (!Array.isArray(object.snaplist))
                    throw TypeError(".net.msg_get_snap_list_rep.snaplist: array expected");
                message.snaplist = [];
                for (var i = 0; i < object.snaplist.length; ++i) {
                    if (typeof object.snaplist[i] !== "object")
                        throw TypeError(".net.msg_get_snap_list_rep.snaplist: object expected");
                    message.snaplist[i] = $root.net.snap_chatkey_info.fromObject(object.snaplist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_snap_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {net.msg_get_snap_list_rep} message msg_get_snap_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_snap_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.snaplist = [];
            if (message.snaplist && message.snaplist.length) {
                object.snaplist = [];
                for (var j = 0; j < message.snaplist.length; ++j)
                    object.snaplist[j] = $root.net.snap_chatkey_info.toObject(message.snaplist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_snap_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_snap_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_snap_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_snap_list_rep;
    })();

    net.msg_get_screenshot = (function() {

        /**
         * Properties of a msg_get_screenshot.
         * @memberof net
         * @interface Imsg_get_screenshot
         * @property {number|Long|null} [chatkey] msg_get_screenshot chatkey
         */

        /**
         * Constructs a new msg_get_screenshot.
         * @memberof net
         * @classdesc Represents a msg_get_screenshot.
         * @implements Imsg_get_screenshot
         * @constructor
         * @param {net.Imsg_get_screenshot=} [properties] Properties to set
         */
        function msg_get_screenshot(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_screenshot chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_screenshot
         * @instance
         */
        msg_get_screenshot.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_get_screenshot instance using the specified properties.
         * @function create
         * @memberof net.msg_get_screenshot
         * @static
         * @param {net.Imsg_get_screenshot=} [properties] Properties to set
         * @returns {net.msg_get_screenshot} msg_get_screenshot instance
         */
        msg_get_screenshot.create = function create(properties) {
            return new msg_get_screenshot(properties);
        };

        /**
         * Encodes the specified msg_get_screenshot message. Does not implicitly {@link net.msg_get_screenshot.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_screenshot
         * @static
         * @param {net.Imsg_get_screenshot} message msg_get_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_screenshot message, length delimited. Does not implicitly {@link net.msg_get_screenshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_screenshot
         * @static
         * @param {net.Imsg_get_screenshot} message msg_get_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_screenshot message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_screenshot} msg_get_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_screenshot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_screenshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_screenshot} msg_get_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_screenshot message.
         * @function verify
         * @memberof net.msg_get_screenshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_screenshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_get_screenshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_screenshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_screenshot} msg_get_screenshot
         */
        msg_get_screenshot.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_screenshot)
                return object;
            var message = new $root.net.msg_get_screenshot();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_get_screenshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_screenshot
         * @static
         * @param {net.msg_get_screenshot} message msg_get_screenshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_screenshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            return object;
        };

        /**
         * Converts this msg_get_screenshot to JSON.
         * @function toJSON
         * @memberof net.msg_get_screenshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_screenshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_screenshot;
    })();

    net.msg_get_screenshot_rep = (function() {

        /**
         * Properties of a msg_get_screenshot_rep.
         * @memberof net
         * @interface Imsg_get_screenshot_rep
         * @property {number|Long|null} [chatkey] msg_get_screenshot_rep chatkey
         * @property {number|null} [screenshot] msg_get_screenshot_rep screenshot
         */

        /**
         * Constructs a new msg_get_screenshot_rep.
         * @memberof net
         * @classdesc Represents a msg_get_screenshot_rep.
         * @implements Imsg_get_screenshot_rep
         * @constructor
         * @param {net.Imsg_get_screenshot_rep=} [properties] Properties to set
         */
        function msg_get_screenshot_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_screenshot_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_screenshot_rep
         * @instance
         */
        msg_get_screenshot_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_screenshot_rep screenshot.
         * @member {number} screenshot
         * @memberof net.msg_get_screenshot_rep
         * @instance
         */
        msg_get_screenshot_rep.prototype.screenshot = 0;

        /**
         * Creates a new msg_get_screenshot_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {net.Imsg_get_screenshot_rep=} [properties] Properties to set
         * @returns {net.msg_get_screenshot_rep} msg_get_screenshot_rep instance
         */
        msg_get_screenshot_rep.create = function create(properties) {
            return new msg_get_screenshot_rep(properties);
        };

        /**
         * Encodes the specified msg_get_screenshot_rep message. Does not implicitly {@link net.msg_get_screenshot_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {net.Imsg_get_screenshot_rep} message msg_get_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.screenshot != null && Object.hasOwnProperty.call(message, "screenshot"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.screenshot);
            return writer;
        };

        /**
         * Encodes the specified msg_get_screenshot_rep message, length delimited. Does not implicitly {@link net.msg_get_screenshot_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {net.Imsg_get_screenshot_rep} message msg_get_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_screenshot_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_screenshot_rep} msg_get_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_screenshot_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.screenshot = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_screenshot_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_screenshot_rep} msg_get_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_screenshot_rep message.
         * @function verify
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_screenshot_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.screenshot != null && message.hasOwnProperty("screenshot"))
                if (!$util.isInteger(message.screenshot))
                    return "screenshot: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_screenshot_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_screenshot_rep} msg_get_screenshot_rep
         */
        msg_get_screenshot_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_screenshot_rep)
                return object;
            var message = new $root.net.msg_get_screenshot_rep();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.screenshot != null)
                message.screenshot = object.screenshot | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_screenshot_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {net.msg_get_screenshot_rep} message msg_get_screenshot_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_screenshot_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.screenshot = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.screenshot != null && message.hasOwnProperty("screenshot"))
                object.screenshot = message.screenshot;
            return object;
        };

        /**
         * Converts this msg_get_screenshot_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_screenshot_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_screenshot_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_screenshot_rep;
    })();

    net.msg_set_screenshot = (function() {

        /**
         * Properties of a msg_set_screenshot.
         * @memberof net
         * @interface Imsg_set_screenshot
         * @property {number|Long|null} [chatkey] msg_set_screenshot chatkey
         * @property {number|null} [flag] msg_set_screenshot flag
         */

        /**
         * Constructs a new msg_set_screenshot.
         * @memberof net
         * @classdesc Represents a msg_set_screenshot.
         * @implements Imsg_set_screenshot
         * @constructor
         * @param {net.Imsg_set_screenshot=} [properties] Properties to set
         */
        function msg_set_screenshot(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_screenshot chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_screenshot
         * @instance
         */
        msg_set_screenshot.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_screenshot flag.
         * @member {number} flag
         * @memberof net.msg_set_screenshot
         * @instance
         */
        msg_set_screenshot.prototype.flag = 0;

        /**
         * Creates a new msg_set_screenshot instance using the specified properties.
         * @function create
         * @memberof net.msg_set_screenshot
         * @static
         * @param {net.Imsg_set_screenshot=} [properties] Properties to set
         * @returns {net.msg_set_screenshot} msg_set_screenshot instance
         */
        msg_set_screenshot.create = function create(properties) {
            return new msg_set_screenshot(properties);
        };

        /**
         * Encodes the specified msg_set_screenshot message. Does not implicitly {@link net.msg_set_screenshot.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_screenshot
         * @static
         * @param {net.Imsg_set_screenshot} message msg_set_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.flag);
            return writer;
        };

        /**
         * Encodes the specified msg_set_screenshot message, length delimited. Does not implicitly {@link net.msg_set_screenshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_screenshot
         * @static
         * @param {net.Imsg_set_screenshot} message msg_set_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_screenshot message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_screenshot} msg_set_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_screenshot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.flag = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_screenshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_screenshot} msg_set_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_screenshot message.
         * @function verify
         * @memberof net.msg_set_screenshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_screenshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.flag != null && message.hasOwnProperty("flag"))
                if (!$util.isInteger(message.flag))
                    return "flag: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_screenshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_screenshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_screenshot} msg_set_screenshot
         */
        msg_set_screenshot.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_screenshot)
                return object;
            var message = new $root.net.msg_set_screenshot();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.flag != null)
                message.flag = object.flag | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_screenshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_screenshot
         * @static
         * @param {net.msg_set_screenshot} message msg_set_screenshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_screenshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.flag = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.flag != null && message.hasOwnProperty("flag"))
                object.flag = message.flag;
            return object;
        };

        /**
         * Converts this msg_set_screenshot to JSON.
         * @function toJSON
         * @memberof net.msg_set_screenshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_screenshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_screenshot;
    })();

    net.msg_set_screenshot_rep = (function() {

        /**
         * Properties of a msg_set_screenshot_rep.
         * @memberof net
         * @interface Imsg_set_screenshot_rep
         * @property {number|null} [result] msg_set_screenshot_rep result
         * @property {number|Long|null} [chatkey] msg_set_screenshot_rep chatkey
         * @property {number|null} [screenshot] msg_set_screenshot_rep screenshot
         * @property {number|null} [uid] msg_set_screenshot_rep uid
         */

        /**
         * Constructs a new msg_set_screenshot_rep.
         * @memberof net
         * @classdesc Represents a msg_set_screenshot_rep.
         * @implements Imsg_set_screenshot_rep
         * @constructor
         * @param {net.Imsg_set_screenshot_rep=} [properties] Properties to set
         */
        function msg_set_screenshot_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_screenshot_rep result.
         * @member {number} result
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.result = 0;

        /**
         * msg_set_screenshot_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_screenshot_rep screenshot.
         * @member {number} screenshot
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.screenshot = 0;

        /**
         * msg_set_screenshot_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.uid = 0;

        /**
         * Creates a new msg_set_screenshot_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {net.Imsg_set_screenshot_rep=} [properties] Properties to set
         * @returns {net.msg_set_screenshot_rep} msg_set_screenshot_rep instance
         */
        msg_set_screenshot_rep.create = function create(properties) {
            return new msg_set_screenshot_rep(properties);
        };

        /**
         * Encodes the specified msg_set_screenshot_rep message. Does not implicitly {@link net.msg_set_screenshot_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {net.Imsg_set_screenshot_rep} message msg_set_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.screenshot != null && Object.hasOwnProperty.call(message, "screenshot"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.screenshot);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_screenshot_rep message, length delimited. Does not implicitly {@link net.msg_set_screenshot_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {net.Imsg_set_screenshot_rep} message msg_set_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_screenshot_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_screenshot_rep} msg_set_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_screenshot_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.screenshot = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_screenshot_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_screenshot_rep} msg_set_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_screenshot_rep message.
         * @function verify
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_screenshot_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.screenshot != null && message.hasOwnProperty("screenshot"))
                if (!$util.isInteger(message.screenshot))
                    return "screenshot: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_screenshot_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_screenshot_rep} msg_set_screenshot_rep
         */
        msg_set_screenshot_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_screenshot_rep)
                return object;
            var message = new $root.net.msg_set_screenshot_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.screenshot != null)
                message.screenshot = object.screenshot | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_screenshot_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {net.msg_set_screenshot_rep} message msg_set_screenshot_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_screenshot_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.screenshot = 0;
                object.uid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.screenshot != null && message.hasOwnProperty("screenshot"))
                object.screenshot = message.screenshot;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_set_screenshot_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_screenshot_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_screenshot_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_screenshot_rep;
    })();

    net.msg_get_order_info_byid = (function() {

        /**
         * Properties of a msg_get_order_info_byid.
         * @memberof net
         * @interface Imsg_get_order_info_byid
         * @property {number|Long|null} [orderid] msg_get_order_info_byid orderid
         */

        /**
         * Constructs a new msg_get_order_info_byid.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_byid.
         * @implements Imsg_get_order_info_byid
         * @constructor
         * @param {net.Imsg_get_order_info_byid=} [properties] Properties to set
         */
        function msg_get_order_info_byid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_byid orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_get_order_info_byid
         * @instance
         */
        msg_get_order_info_byid.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_get_order_info_byid instance using the specified properties.
         * @function create
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {net.Imsg_get_order_info_byid=} [properties] Properties to set
         * @returns {net.msg_get_order_info_byid} msg_get_order_info_byid instance
         */
        msg_get_order_info_byid.create = function create(properties) {
            return new msg_get_order_info_byid(properties);
        };

        /**
         * Encodes the specified msg_get_order_info_byid message. Does not implicitly {@link net.msg_get_order_info_byid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {net.Imsg_get_order_info_byid} message msg_get_order_info_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_order_info_byid message, length delimited. Does not implicitly {@link net.msg_get_order_info_byid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {net.Imsg_get_order_info_byid} message msg_get_order_info_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_order_info_byid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_byid} msg_get_order_info_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_byid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_order_info_byid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_order_info_byid} msg_get_order_info_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_order_info_byid message.
         * @function verify
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_order_info_byid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_get_order_info_byid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_order_info_byid} msg_get_order_info_byid
         */
        msg_get_order_info_byid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_order_info_byid)
                return object;
            var message = new $root.net.msg_get_order_info_byid();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_get_order_info_byid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {net.msg_get_order_info_byid} message msg_get_order_info_byid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_order_info_byid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            return object;
        };

        /**
         * Converts this msg_get_order_info_byid to JSON.
         * @function toJSON
         * @memberof net.msg_get_order_info_byid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_order_info_byid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_order_info_byid;
    })();

    net.msg_get_order_info_byid_req = (function() {

        /**
         * Properties of a msg_get_order_info_byid_req.
         * @memberof net
         * @interface Imsg_get_order_info_byid_req
         * @property {number|null} [result] msg_get_order_info_byid_req result
         * @property {net.Iorder_info|null} [order] msg_get_order_info_byid_req order
         */

        /**
         * Constructs a new msg_get_order_info_byid_req.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_byid_req.
         * @implements Imsg_get_order_info_byid_req
         * @constructor
         * @param {net.Imsg_get_order_info_byid_req=} [properties] Properties to set
         */
        function msg_get_order_info_byid_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_byid_req result.
         * @member {number} result
         * @memberof net.msg_get_order_info_byid_req
         * @instance
         */
        msg_get_order_info_byid_req.prototype.result = 0;

        /**
         * msg_get_order_info_byid_req order.
         * @member {net.Iorder_info|null|undefined} order
         * @memberof net.msg_get_order_info_byid_req
         * @instance
         */
        msg_get_order_info_byid_req.prototype.order = null;

        /**
         * Creates a new msg_get_order_info_byid_req instance using the specified properties.
         * @function create
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {net.Imsg_get_order_info_byid_req=} [properties] Properties to set
         * @returns {net.msg_get_order_info_byid_req} msg_get_order_info_byid_req instance
         */
        msg_get_order_info_byid_req.create = function create(properties) {
            return new msg_get_order_info_byid_req(properties);
        };

        /**
         * Encodes the specified msg_get_order_info_byid_req message. Does not implicitly {@link net.msg_get_order_info_byid_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {net.Imsg_get_order_info_byid_req} message msg_get_order_info_byid_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                $root.net.order_info.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_order_info_byid_req message, length delimited. Does not implicitly {@link net.msg_get_order_info_byid_req.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {net.Imsg_get_order_info_byid_req} message msg_get_order_info_byid_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid_req.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_order_info_byid_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_byid_req} msg_get_order_info_byid_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_byid_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.order = $root.net.order_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_order_info_byid_req message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_order_info_byid_req} msg_get_order_info_byid_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid_req.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_order_info_byid_req message.
         * @function verify
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_order_info_byid_req.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.order != null && message.hasOwnProperty("order")) {
                var error = $root.net.order_info.verify(message.order);
                if (error)
                    return "order." + error;
            }
            return null;
        };

        /**
         * Creates a msg_get_order_info_byid_req message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_order_info_byid_req} msg_get_order_info_byid_req
         */
        msg_get_order_info_byid_req.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_order_info_byid_req)
                return object;
            var message = new $root.net.msg_get_order_info_byid_req();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.order != null) {
                if (typeof object.order !== "object")
                    throw TypeError(".net.msg_get_order_info_byid_req.order: object expected");
                message.order = $root.net.order_info.fromObject(object.order);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_order_info_byid_req message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {net.msg_get_order_info_byid_req} message msg_get_order_info_byid_req
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_order_info_byid_req.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.order = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = $root.net.order_info.toObject(message.order, options);
            return object;
        };

        /**
         * Converts this msg_get_order_info_byid_req to JSON.
         * @function toJSON
         * @memberof net.msg_get_order_info_byid_req
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_order_info_byid_req.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_order_info_byid_req;
    })();

    net.msg_get_black_list = (function() {

        /**
         * Properties of a msg_get_black_list.
         * @memberof net
         * @interface Imsg_get_black_list
         */

        /**
         * Constructs a new msg_get_black_list.
         * @memberof net
         * @classdesc Represents a msg_get_black_list.
         * @implements Imsg_get_black_list
         * @constructor
         * @param {net.Imsg_get_black_list=} [properties] Properties to set
         */
        function msg_get_black_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_black_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_black_list
         * @static
         * @param {net.Imsg_get_black_list=} [properties] Properties to set
         * @returns {net.msg_get_black_list} msg_get_black_list instance
         */
        msg_get_black_list.create = function create(properties) {
            return new msg_get_black_list(properties);
        };

        /**
         * Encodes the specified msg_get_black_list message. Does not implicitly {@link net.msg_get_black_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_black_list
         * @static
         * @param {net.Imsg_get_black_list} message msg_get_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_black_list message, length delimited. Does not implicitly {@link net.msg_get_black_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_black_list
         * @static
         * @param {net.Imsg_get_black_list} message msg_get_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_black_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_black_list} msg_get_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_black_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_black_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_black_list} msg_get_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_black_list message.
         * @function verify
         * @memberof net.msg_get_black_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_black_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_black_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_black_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_black_list} msg_get_black_list
         */
        msg_get_black_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_black_list)
                return object;
            return new $root.net.msg_get_black_list();
        };

        /**
         * Creates a plain object from a msg_get_black_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_black_list
         * @static
         * @param {net.msg_get_black_list} message msg_get_black_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_black_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_black_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_black_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_black_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_black_list;
    })();

    net.msg_get_black_list_rep = (function() {

        /**
         * Properties of a msg_get_black_list_rep.
         * @memberof net
         * @interface Imsg_get_black_list_rep
         * @property {Array.<net.Ibase_info>|null} [blacklist] msg_get_black_list_rep blacklist
         */

        /**
         * Constructs a new msg_get_black_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_black_list_rep.
         * @implements Imsg_get_black_list_rep
         * @constructor
         * @param {net.Imsg_get_black_list_rep=} [properties] Properties to set
         */
        function msg_get_black_list_rep(properties) {
            this.blacklist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_black_list_rep blacklist.
         * @member {Array.<net.Ibase_info>} blacklist
         * @memberof net.msg_get_black_list_rep
         * @instance
         */
        msg_get_black_list_rep.prototype.blacklist = $util.emptyArray;

        /**
         * Creates a new msg_get_black_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {net.Imsg_get_black_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_black_list_rep} msg_get_black_list_rep instance
         */
        msg_get_black_list_rep.create = function create(properties) {
            return new msg_get_black_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_black_list_rep message. Does not implicitly {@link net.msg_get_black_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {net.Imsg_get_black_list_rep} message msg_get_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.blacklist != null && message.blacklist.length)
                for (var i = 0; i < message.blacklist.length; ++i)
                    $root.net.base_info.encode(message.blacklist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_black_list_rep message, length delimited. Does not implicitly {@link net.msg_get_black_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {net.Imsg_get_black_list_rep} message msg_get_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_black_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_black_list_rep} msg_get_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_black_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.blacklist && message.blacklist.length))
                        message.blacklist = [];
                    message.blacklist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_black_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_black_list_rep} msg_get_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_black_list_rep message.
         * @function verify
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_black_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.blacklist != null && message.hasOwnProperty("blacklist")) {
                if (!Array.isArray(message.blacklist))
                    return "blacklist: array expected";
                for (var i = 0; i < message.blacklist.length; ++i) {
                    var error = $root.net.base_info.verify(message.blacklist[i]);
                    if (error)
                        return "blacklist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_black_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_black_list_rep} msg_get_black_list_rep
         */
        msg_get_black_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_black_list_rep)
                return object;
            var message = new $root.net.msg_get_black_list_rep();
            if (object.blacklist) {
                if (!Array.isArray(object.blacklist))
                    throw TypeError(".net.msg_get_black_list_rep.blacklist: array expected");
                message.blacklist = [];
                for (var i = 0; i < object.blacklist.length; ++i) {
                    if (typeof object.blacklist[i] !== "object")
                        throw TypeError(".net.msg_get_black_list_rep.blacklist: object expected");
                    message.blacklist[i] = $root.net.base_info.fromObject(object.blacklist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_black_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {net.msg_get_black_list_rep} message msg_get_black_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_black_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.blacklist = [];
            if (message.blacklist && message.blacklist.length) {
                object.blacklist = [];
                for (var j = 0; j < message.blacklist.length; ++j)
                    object.blacklist[j] = $root.net.base_info.toObject(message.blacklist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_black_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_black_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_black_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_black_list_rep;
    })();

    net.msg_set_black_list = (function() {

        /**
         * Properties of a msg_set_black_list.
         * @memberof net
         * @interface Imsg_set_black_list
         * @property {number|null} [otheruid] msg_set_black_list otheruid
         * @property {number|null} [opertype] msg_set_black_list opertype
         */

        /**
         * Constructs a new msg_set_black_list.
         * @memberof net
         * @classdesc Represents a msg_set_black_list.
         * @implements Imsg_set_black_list
         * @constructor
         * @param {net.Imsg_set_black_list=} [properties] Properties to set
         */
        function msg_set_black_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_black_list otheruid.
         * @member {number} otheruid
         * @memberof net.msg_set_black_list
         * @instance
         */
        msg_set_black_list.prototype.otheruid = 0;

        /**
         * msg_set_black_list opertype.
         * @member {number} opertype
         * @memberof net.msg_set_black_list
         * @instance
         */
        msg_set_black_list.prototype.opertype = 0;

        /**
         * Creates a new msg_set_black_list instance using the specified properties.
         * @function create
         * @memberof net.msg_set_black_list
         * @static
         * @param {net.Imsg_set_black_list=} [properties] Properties to set
         * @returns {net.msg_set_black_list} msg_set_black_list instance
         */
        msg_set_black_list.create = function create(properties) {
            return new msg_set_black_list(properties);
        };

        /**
         * Encodes the specified msg_set_black_list message. Does not implicitly {@link net.msg_set_black_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_black_list
         * @static
         * @param {net.Imsg_set_black_list} message msg_set_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_set_black_list message, length delimited. Does not implicitly {@link net.msg_set_black_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_black_list
         * @static
         * @param {net.Imsg_set_black_list} message msg_set_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_black_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_black_list} msg_set_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_black_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_black_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_black_list} msg_set_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_black_list message.
         * @function verify
         * @memberof net.msg_set_black_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_black_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_black_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_black_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_black_list} msg_set_black_list
         */
        msg_set_black_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_black_list)
                return object;
            var message = new $root.net.msg_set_black_list();
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_black_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_black_list
         * @static
         * @param {net.msg_set_black_list} message msg_set_black_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_black_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.otheruid = 0;
                object.opertype = 0;
            }
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_set_black_list to JSON.
         * @function toJSON
         * @memberof net.msg_set_black_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_black_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_black_list;
    })();

    net.msg_set_black_list_rep = (function() {

        /**
         * Properties of a msg_set_black_list_rep.
         * @memberof net
         * @interface Imsg_set_black_list_rep
         * @property {number|null} [result] msg_set_black_list_rep result
         * @property {number|null} [otheruid] msg_set_black_list_rep otheruid
         * @property {number|null} [opertype] msg_set_black_list_rep opertype
         */

        /**
         * Constructs a new msg_set_black_list_rep.
         * @memberof net
         * @classdesc Represents a msg_set_black_list_rep.
         * @implements Imsg_set_black_list_rep
         * @constructor
         * @param {net.Imsg_set_black_list_rep=} [properties] Properties to set
         */
        function msg_set_black_list_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_black_list_rep result.
         * @member {number} result
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.result = 0;

        /**
         * msg_set_black_list_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.otheruid = 0;

        /**
         * msg_set_black_list_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.opertype = 0;

        /**
         * Creates a new msg_set_black_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {net.Imsg_set_black_list_rep=} [properties] Properties to set
         * @returns {net.msg_set_black_list_rep} msg_set_black_list_rep instance
         */
        msg_set_black_list_rep.create = function create(properties) {
            return new msg_set_black_list_rep(properties);
        };

        /**
         * Encodes the specified msg_set_black_list_rep message. Does not implicitly {@link net.msg_set_black_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {net.Imsg_set_black_list_rep} message msg_set_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_set_black_list_rep message, length delimited. Does not implicitly {@link net.msg_set_black_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {net.Imsg_set_black_list_rep} message msg_set_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_black_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_black_list_rep} msg_set_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_black_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_black_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_black_list_rep} msg_set_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_black_list_rep message.
         * @function verify
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_black_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                if (!$util.isInteger(message.otheruid))
                    return "otheruid: integer expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_black_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_black_list_rep} msg_set_black_list_rep
         */
        msg_set_black_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_black_list_rep)
                return object;
            var message = new $root.net.msg_set_black_list_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.otheruid != null)
                message.otheruid = object.otheruid | 0;
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_black_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {net.msg_set_black_list_rep} message msg_set_black_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_black_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.otheruid = 0;
                object.opertype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.otheruid != null && message.hasOwnProperty("otheruid"))
                object.otheruid = message.otheruid;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_set_black_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_black_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_black_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_black_list_rep;
    })();

    net.msg_third_pay = (function() {

        /**
         * Properties of a msg_third_pay.
         * @memberof net
         * @interface Imsg_third_pay
         * @property {number|Long|null} [orderid] msg_third_pay orderid
         * @property {Uint8Array|null} [authcode] msg_third_pay authcode
         */

        /**
         * Constructs a new msg_third_pay.
         * @memberof net
         * @classdesc Represents a msg_third_pay.
         * @implements Imsg_third_pay
         * @constructor
         * @param {net.Imsg_third_pay=} [properties] Properties to set
         */
        function msg_third_pay(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_third_pay orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_third_pay
         * @instance
         */
        msg_third_pay.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_third_pay authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_third_pay
         * @instance
         */
        msg_third_pay.prototype.authcode = $util.newBuffer([]);

        /**
         * Creates a new msg_third_pay instance using the specified properties.
         * @function create
         * @memberof net.msg_third_pay
         * @static
         * @param {net.Imsg_third_pay=} [properties] Properties to set
         * @returns {net.msg_third_pay} msg_third_pay instance
         */
        msg_third_pay.create = function create(properties) {
            return new msg_third_pay(properties);
        };

        /**
         * Encodes the specified msg_third_pay message. Does not implicitly {@link net.msg_third_pay.verify|verify} messages.
         * @function encode
         * @memberof net.msg_third_pay
         * @static
         * @param {net.Imsg_third_pay} message msg_third_pay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.authcode);
            return writer;
        };

        /**
         * Encodes the specified msg_third_pay message, length delimited. Does not implicitly {@link net.msg_third_pay.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_third_pay
         * @static
         * @param {net.Imsg_third_pay} message msg_third_pay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_third_pay message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_third_pay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_third_pay} msg_third_pay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_third_pay();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_third_pay message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_third_pay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_third_pay} msg_third_pay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_third_pay message.
         * @function verify
         * @memberof net.msg_third_pay
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_third_pay.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                if (!(message.authcode && typeof message.authcode.length === "number" || $util.isString(message.authcode)))
                    return "authcode: buffer expected";
            return null;
        };

        /**
         * Creates a msg_third_pay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_third_pay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_third_pay} msg_third_pay
         */
        msg_third_pay.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_third_pay)
                return object;
            var message = new $root.net.msg_third_pay();
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            if (object.authcode != null)
                if (typeof object.authcode === "string")
                    $util.base64.decode(object.authcode, message.authcode = $util.newBuffer($util.base64.length(object.authcode)), 0);
                else if (object.authcode.length)
                    message.authcode = object.authcode;
            return message;
        };

        /**
         * Creates a plain object from a msg_third_pay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_third_pay
         * @static
         * @param {net.msg_third_pay} message msg_third_pay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_third_pay.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.authcode = "";
                else {
                    object.authcode = [];
                    if (options.bytes !== Array)
                        object.authcode = $util.newBuffer(object.authcode);
                }
            }
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            if (message.authcode != null && message.hasOwnProperty("authcode"))
                object.authcode = options.bytes === String ? $util.base64.encode(message.authcode, 0, message.authcode.length) : options.bytes === Array ? Array.prototype.slice.call(message.authcode) : message.authcode;
            return object;
        };

        /**
         * Converts this msg_third_pay to JSON.
         * @function toJSON
         * @memberof net.msg_third_pay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_third_pay.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_third_pay;
    })();

    net.msg_third_pay_rep = (function() {

        /**
         * Properties of a msg_third_pay_rep.
         * @memberof net
         * @interface Imsg_third_pay_rep
         * @property {number|null} [result] msg_third_pay_rep result
         */

        /**
         * Constructs a new msg_third_pay_rep.
         * @memberof net
         * @classdesc Represents a msg_third_pay_rep.
         * @implements Imsg_third_pay_rep
         * @constructor
         * @param {net.Imsg_third_pay_rep=} [properties] Properties to set
         */
        function msg_third_pay_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_third_pay_rep result.
         * @member {number} result
         * @memberof net.msg_third_pay_rep
         * @instance
         */
        msg_third_pay_rep.prototype.result = 0;

        /**
         * Creates a new msg_third_pay_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {net.Imsg_third_pay_rep=} [properties] Properties to set
         * @returns {net.msg_third_pay_rep} msg_third_pay_rep instance
         */
        msg_third_pay_rep.create = function create(properties) {
            return new msg_third_pay_rep(properties);
        };

        /**
         * Encodes the specified msg_third_pay_rep message. Does not implicitly {@link net.msg_third_pay_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {net.Imsg_third_pay_rep} message msg_third_pay_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_third_pay_rep message, length delimited. Does not implicitly {@link net.msg_third_pay_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {net.Imsg_third_pay_rep} message msg_third_pay_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_third_pay_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_third_pay_rep} msg_third_pay_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_third_pay_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_third_pay_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_third_pay_rep} msg_third_pay_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_third_pay_rep message.
         * @function verify
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_third_pay_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_third_pay_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_third_pay_rep} msg_third_pay_rep
         */
        msg_third_pay_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_third_pay_rep)
                return object;
            var message = new $root.net.msg_third_pay_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_third_pay_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {net.msg_third_pay_rep} message msg_third_pay_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_third_pay_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_third_pay_rep to JSON.
         * @function toJSON
         * @memberof net.msg_third_pay_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_third_pay_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_third_pay_rep;
    })();

    net.msg_pcauth = (function() {

        /**
         * Properties of a msg_pcauth.
         * @memberof net
         * @interface Imsg_pcauth
         * @property {number|null} [pcflow] msg_pcauth pcflow
         * @property {Uint8Array|null} [pckey] msg_pcauth pckey
         */

        /**
         * Constructs a new msg_pcauth.
         * @memberof net
         * @classdesc Represents a msg_pcauth.
         * @implements Imsg_pcauth
         * @constructor
         * @param {net.Imsg_pcauth=} [properties] Properties to set
         */
        function msg_pcauth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pcauth pcflow.
         * @member {number} pcflow
         * @memberof net.msg_pcauth
         * @instance
         */
        msg_pcauth.prototype.pcflow = 0;

        /**
         * msg_pcauth pckey.
         * @member {Uint8Array} pckey
         * @memberof net.msg_pcauth
         * @instance
         */
        msg_pcauth.prototype.pckey = $util.newBuffer([]);

        /**
         * Creates a new msg_pcauth instance using the specified properties.
         * @function create
         * @memberof net.msg_pcauth
         * @static
         * @param {net.Imsg_pcauth=} [properties] Properties to set
         * @returns {net.msg_pcauth} msg_pcauth instance
         */
        msg_pcauth.create = function create(properties) {
            return new msg_pcauth(properties);
        };

        /**
         * Encodes the specified msg_pcauth message. Does not implicitly {@link net.msg_pcauth.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pcauth
         * @static
         * @param {net.Imsg_pcauth} message msg_pcauth message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pcflow != null && Object.hasOwnProperty.call(message, "pcflow"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pcflow);
            if (message.pckey != null && Object.hasOwnProperty.call(message, "pckey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.pckey);
            return writer;
        };

        /**
         * Encodes the specified msg_pcauth message, length delimited. Does not implicitly {@link net.msg_pcauth.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pcauth
         * @static
         * @param {net.Imsg_pcauth} message msg_pcauth message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pcauth message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pcauth
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pcauth} msg_pcauth
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pcauth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pcflow = reader.int32();
                    break;
                case 2:
                    message.pckey = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pcauth message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pcauth
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pcauth} msg_pcauth
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pcauth message.
         * @function verify
         * @memberof net.msg_pcauth
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pcauth.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pcflow != null && message.hasOwnProperty("pcflow"))
                if (!$util.isInteger(message.pcflow))
                    return "pcflow: integer expected";
            if (message.pckey != null && message.hasOwnProperty("pckey"))
                if (!(message.pckey && typeof message.pckey.length === "number" || $util.isString(message.pckey)))
                    return "pckey: buffer expected";
            return null;
        };

        /**
         * Creates a msg_pcauth message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pcauth
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pcauth} msg_pcauth
         */
        msg_pcauth.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pcauth)
                return object;
            var message = new $root.net.msg_pcauth();
            if (object.pcflow != null)
                message.pcflow = object.pcflow | 0;
            if (object.pckey != null)
                if (typeof object.pckey === "string")
                    $util.base64.decode(object.pckey, message.pckey = $util.newBuffer($util.base64.length(object.pckey)), 0);
                else if (object.pckey.length)
                    message.pckey = object.pckey;
            return message;
        };

        /**
         * Creates a plain object from a msg_pcauth message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pcauth
         * @static
         * @param {net.msg_pcauth} message msg_pcauth
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pcauth.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pcflow = 0;
                if (options.bytes === String)
                    object.pckey = "";
                else {
                    object.pckey = [];
                    if (options.bytes !== Array)
                        object.pckey = $util.newBuffer(object.pckey);
                }
            }
            if (message.pcflow != null && message.hasOwnProperty("pcflow"))
                object.pcflow = message.pcflow;
            if (message.pckey != null && message.hasOwnProperty("pckey"))
                object.pckey = options.bytes === String ? $util.base64.encode(message.pckey, 0, message.pckey.length) : options.bytes === Array ? Array.prototype.slice.call(message.pckey) : message.pckey;
            return object;
        };

        /**
         * Converts this msg_pcauth to JSON.
         * @function toJSON
         * @memberof net.msg_pcauth
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pcauth.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pcauth;
    })();

    net.msg_pcauth_rep = (function() {

        /**
         * Properties of a msg_pcauth_rep.
         * @memberof net
         * @interface Imsg_pcauth_rep
         * @property {number|null} [result] msg_pcauth_rep result
         */

        /**
         * Constructs a new msg_pcauth_rep.
         * @memberof net
         * @classdesc Represents a msg_pcauth_rep.
         * @implements Imsg_pcauth_rep
         * @constructor
         * @param {net.Imsg_pcauth_rep=} [properties] Properties to set
         */
        function msg_pcauth_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pcauth_rep result.
         * @member {number} result
         * @memberof net.msg_pcauth_rep
         * @instance
         */
        msg_pcauth_rep.prototype.result = 0;

        /**
         * Creates a new msg_pcauth_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {net.Imsg_pcauth_rep=} [properties] Properties to set
         * @returns {net.msg_pcauth_rep} msg_pcauth_rep instance
         */
        msg_pcauth_rep.create = function create(properties) {
            return new msg_pcauth_rep(properties);
        };

        /**
         * Encodes the specified msg_pcauth_rep message. Does not implicitly {@link net.msg_pcauth_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {net.Imsg_pcauth_rep} message msg_pcauth_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_pcauth_rep message, length delimited. Does not implicitly {@link net.msg_pcauth_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {net.Imsg_pcauth_rep} message msg_pcauth_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pcauth_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pcauth_rep} msg_pcauth_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pcauth_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pcauth_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pcauth_rep} msg_pcauth_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pcauth_rep message.
         * @function verify
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pcauth_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_pcauth_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pcauth_rep} msg_pcauth_rep
         */
        msg_pcauth_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pcauth_rep)
                return object;
            var message = new $root.net.msg_pcauth_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_pcauth_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {net.msg_pcauth_rep} message msg_pcauth_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pcauth_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_pcauth_rep to JSON.
         * @function toJSON
         * @memberof net.msg_pcauth_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pcauth_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pcauth_rep;
    })();

    net.msg_pclogin_req = (function() {

        /**
         * Properties of a msg_pclogin_req.
         * @memberof net
         * @interface Imsg_pclogin_req
         * @property {number|null} [uid] msg_pclogin_req uid
         * @property {Uint8Array|null} [fastkey] msg_pclogin_req fastkey
         * @property {Uint8Array|null} [deviceid] msg_pclogin_req deviceid
         * @property {Uint8Array|null} [version] msg_pclogin_req version
         */

        /**
         * Constructs a new msg_pclogin_req.
         * @memberof net
         * @classdesc Represents a msg_pclogin_req.
         * @implements Imsg_pclogin_req
         * @constructor
         * @param {net.Imsg_pclogin_req=} [properties] Properties to set
         */
        function msg_pclogin_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pclogin_req uid.
         * @member {number} uid
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.uid = 0;

        /**
         * msg_pclogin_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_pclogin_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_pclogin_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.version = $util.newBuffer([]);

        /**
         * Creates a new msg_pclogin_req instance using the specified properties.
         * @function create
         * @memberof net.msg_pclogin_req
         * @static
         * @param {net.Imsg_pclogin_req=} [properties] Properties to set
         * @returns {net.msg_pclogin_req} msg_pclogin_req instance
         */
        msg_pclogin_req.create = function create(properties) {
            return new msg_pclogin_req(properties);
        };

        /**
         * Encodes the specified msg_pclogin_req message. Does not implicitly {@link net.msg_pclogin_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pclogin_req
         * @static
         * @param {net.Imsg_pclogin_req} message msg_pclogin_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_pclogin_req message, length delimited. Does not implicitly {@link net.msg_pclogin_req.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pclogin_req
         * @static
         * @param {net.Imsg_pclogin_req} message msg_pclogin_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_req.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pclogin_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pclogin_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pclogin_req} msg_pclogin_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pclogin_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.deviceid = reader.bytes();
                    break;
                case 4:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pclogin_req message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pclogin_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pclogin_req} msg_pclogin_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_req.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pclogin_req message.
         * @function verify
         * @memberof net.msg_pclogin_req
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pclogin_req.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                if (!(message.fastkey && typeof message.fastkey.length === "number" || $util.isString(message.fastkey)))
                    return "fastkey: buffer expected";
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (!(message.deviceid && typeof message.deviceid.length === "number" || $util.isString(message.deviceid)))
                    return "deviceid: buffer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!(message.version && typeof message.version.length === "number" || $util.isString(message.version)))
                    return "version: buffer expected";
            return null;
        };

        /**
         * Creates a msg_pclogin_req message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pclogin_req
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pclogin_req} msg_pclogin_req
         */
        msg_pclogin_req.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pclogin_req)
                return object;
            var message = new $root.net.msg_pclogin_req();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.fastkey != null)
                if (typeof object.fastkey === "string")
                    $util.base64.decode(object.fastkey, message.fastkey = $util.newBuffer($util.base64.length(object.fastkey)), 0);
                else if (object.fastkey.length)
                    message.fastkey = object.fastkey;
            if (object.deviceid != null)
                if (typeof object.deviceid === "string")
                    $util.base64.decode(object.deviceid, message.deviceid = $util.newBuffer($util.base64.length(object.deviceid)), 0);
                else if (object.deviceid.length)
                    message.deviceid = object.deviceid;
            if (object.version != null)
                if (typeof object.version === "string")
                    $util.base64.decode(object.version, message.version = $util.newBuffer($util.base64.length(object.version)), 0);
                else if (object.version.length)
                    message.version = object.version;
            return message;
        };

        /**
         * Creates a plain object from a msg_pclogin_req message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pclogin_req
         * @static
         * @param {net.msg_pclogin_req} message msg_pclogin_req
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pclogin_req.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.fastkey = "";
                else {
                    object.fastkey = [];
                    if (options.bytes !== Array)
                        object.fastkey = $util.newBuffer(object.fastkey);
                }
                if (options.bytes === String)
                    object.deviceid = "";
                else {
                    object.deviceid = [];
                    if (options.bytes !== Array)
                        object.deviceid = $util.newBuffer(object.deviceid);
                }
                if (options.bytes === String)
                    object.version = "";
                else {
                    object.version = [];
                    if (options.bytes !== Array)
                        object.version = $util.newBuffer(object.version);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                object.fastkey = options.bytes === String ? $util.base64.encode(message.fastkey, 0, message.fastkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.fastkey) : message.fastkey;
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                object.deviceid = options.bytes === String ? $util.base64.encode(message.deviceid, 0, message.deviceid.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceid) : message.deviceid;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = options.bytes === String ? $util.base64.encode(message.version, 0, message.version.length) : options.bytes === Array ? Array.prototype.slice.call(message.version) : message.version;
            return object;
        };

        /**
         * Converts this msg_pclogin_req to JSON.
         * @function toJSON
         * @memberof net.msg_pclogin_req
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pclogin_req.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pclogin_req;
    })();

    net.msg_pclogin_rep = (function() {

        /**
         * Properties of a msg_pclogin_rep.
         * @memberof net
         * @interface Imsg_pclogin_rep
         * @property {number|null} [result] msg_pclogin_rep result
         * @property {number|null} [server_time] msg_pclogin_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_pclogin_rep customer_list
         */

        /**
         * Constructs a new msg_pclogin_rep.
         * @memberof net
         * @classdesc Represents a msg_pclogin_rep.
         * @implements Imsg_pclogin_rep
         * @constructor
         * @param {net.Imsg_pclogin_rep=} [properties] Properties to set
         */
        function msg_pclogin_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pclogin_rep result.
         * @member {number} result
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.result = 0;

        /**
         * msg_pclogin_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.server_time = 0;

        /**
         * msg_pclogin_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.customer_list = $util.emptyArray;

        /**
         * Creates a new msg_pclogin_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {net.Imsg_pclogin_rep=} [properties] Properties to set
         * @returns {net.msg_pclogin_rep} msg_pclogin_rep instance
         */
        msg_pclogin_rep.create = function create(properties) {
            return new msg_pclogin_rep(properties);
        };

        /**
         * Encodes the specified msg_pclogin_rep message. Does not implicitly {@link net.msg_pclogin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {net.Imsg_pclogin_rep} message msg_pclogin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_pclogin_rep message, length delimited. Does not implicitly {@link net.msg_pclogin_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {net.Imsg_pclogin_rep} message msg_pclogin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pclogin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pclogin_rep} msg_pclogin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pclogin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pclogin_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pclogin_rep} msg_pclogin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pclogin_rep message.
         * @function verify
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pclogin_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                if (!$util.isInteger(message.server_time))
                    return "server_time: integer expected";
            if (message.customer_list != null && message.hasOwnProperty("customer_list")) {
                if (!Array.isArray(message.customer_list))
                    return "customer_list: array expected";
                for (var i = 0; i < message.customer_list.length; ++i) {
                    var error = $root.net.customer_info.verify(message.customer_list[i]);
                    if (error)
                        return "customer_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_pclogin_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pclogin_rep} msg_pclogin_rep
         */
        msg_pclogin_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pclogin_rep)
                return object;
            var message = new $root.net.msg_pclogin_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.server_time != null)
                message.server_time = object.server_time >>> 0;
            if (object.customer_list) {
                if (!Array.isArray(object.customer_list))
                    throw TypeError(".net.msg_pclogin_rep.customer_list: array expected");
                message.customer_list = [];
                for (var i = 0; i < object.customer_list.length; ++i) {
                    if (typeof object.customer_list[i] !== "object")
                        throw TypeError(".net.msg_pclogin_rep.customer_list: object expected");
                    message.customer_list[i] = $root.net.customer_info.fromObject(object.customer_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_pclogin_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {net.msg_pclogin_rep} message msg_pclogin_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pclogin_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.customer_list = [];
            if (options.defaults) {
                object.result = 0;
                object.server_time = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                object.server_time = message.server_time;
            if (message.customer_list && message.customer_list.length) {
                object.customer_list = [];
                for (var j = 0; j < message.customer_list.length; ++j)
                    object.customer_list[j] = $root.net.customer_info.toObject(message.customer_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_pclogin_rep to JSON.
         * @function toJSON
         * @memberof net.msg_pclogin_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pclogin_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pclogin_rep;
    })();

    net.msg_h5login_req = (function() {

        /**
         * Properties of a msg_h5login_req.
         * @memberof net
         * @interface Imsg_h5login_req
         * @property {number|null} [uid] msg_h5login_req uid
         * @property {Uint8Array|null} [fastkey] msg_h5login_req fastkey
         * @property {Uint8Array|null} [deviceid] msg_h5login_req deviceid
         * @property {Uint8Array|null} [version] msg_h5login_req version
         */

        /**
         * Constructs a new msg_h5login_req.
         * @memberof net
         * @classdesc Represents a msg_h5login_req.
         * @implements Imsg_h5login_req
         * @constructor
         * @param {net.Imsg_h5login_req=} [properties] Properties to set
         */
        function msg_h5login_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_h5login_req uid.
         * @member {number} uid
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.uid = 0;

        /**
         * msg_h5login_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_h5login_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_h5login_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.version = $util.newBuffer([]);

        /**
         * Creates a new msg_h5login_req instance using the specified properties.
         * @function create
         * @memberof net.msg_h5login_req
         * @static
         * @param {net.Imsg_h5login_req=} [properties] Properties to set
         * @returns {net.msg_h5login_req} msg_h5login_req instance
         */
        msg_h5login_req.create = function create(properties) {
            return new msg_h5login_req(properties);
        };

        /**
         * Encodes the specified msg_h5login_req message. Does not implicitly {@link net.msg_h5login_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_h5login_req
         * @static
         * @param {net.Imsg_h5login_req} message msg_h5login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_h5login_req message, length delimited. Does not implicitly {@link net.msg_h5login_req.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_h5login_req
         * @static
         * @param {net.Imsg_h5login_req} message msg_h5login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_req.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_h5login_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_h5login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_h5login_req} msg_h5login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_h5login_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.deviceid = reader.bytes();
                    break;
                case 4:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_h5login_req message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_h5login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_h5login_req} msg_h5login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_req.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_h5login_req message.
         * @function verify
         * @memberof net.msg_h5login_req
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_h5login_req.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                if (!(message.fastkey && typeof message.fastkey.length === "number" || $util.isString(message.fastkey)))
                    return "fastkey: buffer expected";
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (!(message.deviceid && typeof message.deviceid.length === "number" || $util.isString(message.deviceid)))
                    return "deviceid: buffer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!(message.version && typeof message.version.length === "number" || $util.isString(message.version)))
                    return "version: buffer expected";
            return null;
        };

        /**
         * Creates a msg_h5login_req message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_h5login_req
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_h5login_req} msg_h5login_req
         */
        msg_h5login_req.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_h5login_req)
                return object;
            var message = new $root.net.msg_h5login_req();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.fastkey != null)
                if (typeof object.fastkey === "string")
                    $util.base64.decode(object.fastkey, message.fastkey = $util.newBuffer($util.base64.length(object.fastkey)), 0);
                else if (object.fastkey.length)
                    message.fastkey = object.fastkey;
            if (object.deviceid != null)
                if (typeof object.deviceid === "string")
                    $util.base64.decode(object.deviceid, message.deviceid = $util.newBuffer($util.base64.length(object.deviceid)), 0);
                else if (object.deviceid.length)
                    message.deviceid = object.deviceid;
            if (object.version != null)
                if (typeof object.version === "string")
                    $util.base64.decode(object.version, message.version = $util.newBuffer($util.base64.length(object.version)), 0);
                else if (object.version.length)
                    message.version = object.version;
            return message;
        };

        /**
         * Creates a plain object from a msg_h5login_req message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_h5login_req
         * @static
         * @param {net.msg_h5login_req} message msg_h5login_req
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_h5login_req.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if (options.bytes === String)
                    object.fastkey = "";
                else {
                    object.fastkey = [];
                    if (options.bytes !== Array)
                        object.fastkey = $util.newBuffer(object.fastkey);
                }
                if (options.bytes === String)
                    object.deviceid = "";
                else {
                    object.deviceid = [];
                    if (options.bytes !== Array)
                        object.deviceid = $util.newBuffer(object.deviceid);
                }
                if (options.bytes === String)
                    object.version = "";
                else {
                    object.version = [];
                    if (options.bytes !== Array)
                        object.version = $util.newBuffer(object.version);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.fastkey != null && message.hasOwnProperty("fastkey"))
                object.fastkey = options.bytes === String ? $util.base64.encode(message.fastkey, 0, message.fastkey.length) : options.bytes === Array ? Array.prototype.slice.call(message.fastkey) : message.fastkey;
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                object.deviceid = options.bytes === String ? $util.base64.encode(message.deviceid, 0, message.deviceid.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceid) : message.deviceid;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = options.bytes === String ? $util.base64.encode(message.version, 0, message.version.length) : options.bytes === Array ? Array.prototype.slice.call(message.version) : message.version;
            return object;
        };

        /**
         * Converts this msg_h5login_req to JSON.
         * @function toJSON
         * @memberof net.msg_h5login_req
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_h5login_req.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_h5login_req;
    })();

    net.msg_h5login_rep = (function() {

        /**
         * Properties of a msg_h5login_rep.
         * @memberof net
         * @interface Imsg_h5login_rep
         * @property {number|null} [result] msg_h5login_rep result
         * @property {number|null} [server_time] msg_h5login_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_h5login_rep customer_list
         */

        /**
         * Constructs a new msg_h5login_rep.
         * @memberof net
         * @classdesc Represents a msg_h5login_rep.
         * @implements Imsg_h5login_rep
         * @constructor
         * @param {net.Imsg_h5login_rep=} [properties] Properties to set
         */
        function msg_h5login_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_h5login_rep result.
         * @member {number} result
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.result = 0;

        /**
         * msg_h5login_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.server_time = 0;

        /**
         * msg_h5login_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.customer_list = $util.emptyArray;

        /**
         * Creates a new msg_h5login_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_h5login_rep
         * @static
         * @param {net.Imsg_h5login_rep=} [properties] Properties to set
         * @returns {net.msg_h5login_rep} msg_h5login_rep instance
         */
        msg_h5login_rep.create = function create(properties) {
            return new msg_h5login_rep(properties);
        };

        /**
         * Encodes the specified msg_h5login_rep message. Does not implicitly {@link net.msg_h5login_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_h5login_rep
         * @static
         * @param {net.Imsg_h5login_rep} message msg_h5login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_h5login_rep message, length delimited. Does not implicitly {@link net.msg_h5login_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_h5login_rep
         * @static
         * @param {net.Imsg_h5login_rep} message msg_h5login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_h5login_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_h5login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_h5login_rep} msg_h5login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_h5login_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_h5login_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_h5login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_h5login_rep} msg_h5login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_h5login_rep message.
         * @function verify
         * @memberof net.msg_h5login_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_h5login_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                if (!$util.isInteger(message.server_time))
                    return "server_time: integer expected";
            if (message.customer_list != null && message.hasOwnProperty("customer_list")) {
                if (!Array.isArray(message.customer_list))
                    return "customer_list: array expected";
                for (var i = 0; i < message.customer_list.length; ++i) {
                    var error = $root.net.customer_info.verify(message.customer_list[i]);
                    if (error)
                        return "customer_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_h5login_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_h5login_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_h5login_rep} msg_h5login_rep
         */
        msg_h5login_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_h5login_rep)
                return object;
            var message = new $root.net.msg_h5login_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.server_time != null)
                message.server_time = object.server_time >>> 0;
            if (object.customer_list) {
                if (!Array.isArray(object.customer_list))
                    throw TypeError(".net.msg_h5login_rep.customer_list: array expected");
                message.customer_list = [];
                for (var i = 0; i < object.customer_list.length; ++i) {
                    if (typeof object.customer_list[i] !== "object")
                        throw TypeError(".net.msg_h5login_rep.customer_list: object expected");
                    message.customer_list[i] = $root.net.customer_info.fromObject(object.customer_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_h5login_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_h5login_rep
         * @static
         * @param {net.msg_h5login_rep} message msg_h5login_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_h5login_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.customer_list = [];
            if (options.defaults) {
                object.result = 0;
                object.server_time = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.server_time != null && message.hasOwnProperty("server_time"))
                object.server_time = message.server_time;
            if (message.customer_list && message.customer_list.length) {
                object.customer_list = [];
                for (var j = 0; j < message.customer_list.length; ++j)
                    object.customer_list[j] = $root.net.customer_info.toObject(message.customer_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_h5login_rep to JSON.
         * @function toJSON
         * @memberof net.msg_h5login_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_h5login_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_h5login_rep;
    })();

    net.msg_voice_call = (function() {

        /**
         * Properties of a msg_voice_call.
         * @memberof net
         * @interface Imsg_voice_call
         * @property {number|Long|null} [chatkey] msg_voice_call chatkey
         * @property {Uint8Array|null} [token] msg_voice_call token
         * @property {number|null} [calltype] msg_voice_call calltype
         */

        /**
         * Constructs a new msg_voice_call.
         * @memberof net
         * @classdesc Represents a msg_voice_call.
         * @implements Imsg_voice_call
         * @constructor
         * @param {net.Imsg_voice_call=} [properties] Properties to set
         */
        function msg_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_call
         * @instance
         */
        msg_voice_call.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_call token.
         * @member {Uint8Array} token
         * @memberof net.msg_voice_call
         * @instance
         */
        msg_voice_call.prototype.token = $util.newBuffer([]);

        /**
         * msg_voice_call calltype.
         * @member {number} calltype
         * @memberof net.msg_voice_call
         * @instance
         */
        msg_voice_call.prototype.calltype = 0;

        /**
         * Creates a new msg_voice_call instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_call
         * @static
         * @param {net.Imsg_voice_call=} [properties] Properties to set
         * @returns {net.msg_voice_call} msg_voice_call instance
         */
        msg_voice_call.create = function create(properties) {
            return new msg_voice_call(properties);
        };

        /**
         * Encodes the specified msg_voice_call message. Does not implicitly {@link net.msg_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call
         * @static
         * @param {net.Imsg_voice_call} message msg_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
            if (message.calltype != null && Object.hasOwnProperty.call(message, "calltype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.calltype);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_call message, length delimited. Does not implicitly {@link net.msg_voice_call.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_call
         * @static
         * @param {net.Imsg_voice_call} message msg_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call} msg_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.token = reader.bytes();
                    break;
                case 3:
                    message.calltype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_call message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_call} msg_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_call message.
         * @function verify
         * @memberof net.msg_voice_call
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_call.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            if (message.calltype != null && message.hasOwnProperty("calltype"))
                if (!$util.isInteger(message.calltype))
                    return "calltype: integer expected";
            return null;
        };

        /**
         * Creates a msg_voice_call message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_call
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_call} msg_voice_call
         */
        msg_voice_call.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_call)
                return object;
            var message = new $root.net.msg_voice_call();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length)
                    message.token = object.token;
            if (object.calltype != null)
                message.calltype = object.calltype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_call message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_call
         * @static
         * @param {net.msg_voice_call} message msg_voice_call
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_call.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
                object.calltype = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            if (message.calltype != null && message.hasOwnProperty("calltype"))
                object.calltype = message.calltype;
            return object;
        };

        /**
         * Converts this msg_voice_call to JSON.
         * @function toJSON
         * @memberof net.msg_voice_call
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_call.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_call;
    })();

    net.msg_voice_call_rep = (function() {

        /**
         * Properties of a msg_voice_call_rep.
         * @memberof net
         * @interface Imsg_voice_call_rep
         * @property {number|null} [result] msg_voice_call_rep result
         */

        /**
         * Constructs a new msg_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_voice_call_rep.
         * @implements Imsg_voice_call_rep
         * @constructor
         * @param {net.Imsg_voice_call_rep=} [properties] Properties to set
         */
        function msg_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_voice_call_rep
         * @instance
         */
        msg_voice_call_rep.prototype.result = 0;

        /**
         * Creates a new msg_voice_call_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {net.Imsg_voice_call_rep=} [properties] Properties to set
         * @returns {net.msg_voice_call_rep} msg_voice_call_rep instance
         */
        msg_voice_call_rep.create = function create(properties) {
            return new msg_voice_call_rep(properties);
        };

        /**
         * Encodes the specified msg_voice_call_rep message. Does not implicitly {@link net.msg_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {net.Imsg_voice_call_rep} message msg_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_call_rep message, length delimited. Does not implicitly {@link net.msg_voice_call_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {net.Imsg_voice_call_rep} message msg_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call_rep} msg_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_call_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_call_rep} msg_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_call_rep message.
         * @function verify
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_call_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_voice_call_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_call_rep} msg_voice_call_rep
         */
        msg_voice_call_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_call_rep)
                return object;
            var message = new $root.net.msg_voice_call_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_call_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {net.msg_voice_call_rep} message msg_voice_call_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_call_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_voice_call_rep to JSON.
         * @function toJSON
         * @memberof net.msg_voice_call_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_call_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_call_rep;
    })();

    net.msg_oper_voice_call = (function() {

        /**
         * Properties of a msg_oper_voice_call.
         * @memberof net
         * @interface Imsg_oper_voice_call
         * @property {number|Long|null} [chatkey] msg_oper_voice_call chatkey
         * @property {number|null} [opertype] msg_oper_voice_call opertype
         */

        /**
         * Constructs a new msg_oper_voice_call.
         * @memberof net
         * @classdesc Represents a msg_oper_voice_call.
         * @implements Imsg_oper_voice_call
         * @constructor
         * @param {net.Imsg_oper_voice_call=} [properties] Properties to set
         */
        function msg_oper_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_voice_call chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_oper_voice_call
         * @instance
         */
        msg_oper_voice_call.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_oper_voice_call opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_voice_call
         * @instance
         */
        msg_oper_voice_call.prototype.opertype = 0;

        /**
         * Creates a new msg_oper_voice_call instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {net.Imsg_oper_voice_call=} [properties] Properties to set
         * @returns {net.msg_oper_voice_call} msg_oper_voice_call instance
         */
        msg_oper_voice_call.create = function create(properties) {
            return new msg_oper_voice_call(properties);
        };

        /**
         * Encodes the specified msg_oper_voice_call message. Does not implicitly {@link net.msg_oper_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {net.Imsg_oper_voice_call} message msg_oper_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_voice_call message, length delimited. Does not implicitly {@link net.msg_oper_voice_call.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {net.Imsg_oper_voice_call} message msg_oper_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_voice_call} msg_oper_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_voice_call message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_voice_call} msg_oper_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_voice_call message.
         * @function verify
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_voice_call.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_voice_call message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_voice_call} msg_oper_voice_call
         */
        msg_oper_voice_call.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_voice_call)
                return object;
            var message = new $root.net.msg_oper_voice_call();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_voice_call message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {net.msg_oper_voice_call} message msg_oper_voice_call
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_voice_call.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_oper_voice_call to JSON.
         * @function toJSON
         * @memberof net.msg_oper_voice_call
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_voice_call.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_voice_call;
    })();

    net.msg_oper_voice_call_rep = (function() {

        /**
         * Properties of a msg_oper_voice_call_rep.
         * @memberof net
         * @interface Imsg_oper_voice_call_rep
         * @property {number|null} [result] msg_oper_voice_call_rep result
         * @property {number|Long|null} [chatkey] msg_oper_voice_call_rep chatkey
         * @property {number|null} [opertype] msg_oper_voice_call_rep opertype
         */

        /**
         * Constructs a new msg_oper_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_oper_voice_call_rep.
         * @implements Imsg_oper_voice_call_rep
         * @constructor
         * @param {net.Imsg_oper_voice_call_rep=} [properties] Properties to set
         */
        function msg_oper_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.result = 0;

        /**
         * msg_oper_voice_call_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_oper_voice_call_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.opertype = 0;

        /**
         * Creates a new msg_oper_voice_call_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {net.Imsg_oper_voice_call_rep=} [properties] Properties to set
         * @returns {net.msg_oper_voice_call_rep} msg_oper_voice_call_rep instance
         */
        msg_oper_voice_call_rep.create = function create(properties) {
            return new msg_oper_voice_call_rep(properties);
        };

        /**
         * Encodes the specified msg_oper_voice_call_rep message. Does not implicitly {@link net.msg_oper_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {net.Imsg_oper_voice_call_rep} message msg_oper_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_voice_call_rep message, length delimited. Does not implicitly {@link net.msg_oper_voice_call_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {net.Imsg_oper_voice_call_rep} message msg_oper_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_voice_call_rep} msg_oper_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_voice_call_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_voice_call_rep} msg_oper_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_voice_call_rep message.
         * @function verify
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_voice_call_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_voice_call_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_voice_call_rep} msg_oper_voice_call_rep
         */
        msg_oper_voice_call_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_voice_call_rep)
                return object;
            var message = new $root.net.msg_oper_voice_call_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_voice_call_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {net.msg_oper_voice_call_rep} message msg_oper_voice_call_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_voice_call_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                object.opertype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_oper_voice_call_rep to JSON.
         * @function toJSON
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_voice_call_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_voice_call_rep;
    })();

    net.msg_voice_data = (function() {

        /**
         * Properties of a msg_voice_data.
         * @memberof net
         * @interface Imsg_voice_data
         * @property {number|Long|null} [chatkey] msg_voice_data chatkey
         * @property {Uint8Array|null} [voice_data] msg_voice_data voice_data
         * @property {number|Long|null} [ptime] msg_voice_data ptime
         */

        /**
         * Constructs a new msg_voice_data.
         * @memberof net
         * @classdesc Represents a msg_voice_data.
         * @implements Imsg_voice_data
         * @constructor
         * @param {net.Imsg_voice_data=} [properties] Properties to set
         */
        function msg_voice_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_data voice_data.
         * @member {Uint8Array} voice_data
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.voice_data = $util.newBuffer([]);

        /**
         * msg_voice_data ptime.
         * @member {number|Long} ptime
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.ptime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_voice_data instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_data
         * @static
         * @param {net.Imsg_voice_data=} [properties] Properties to set
         * @returns {net.msg_voice_data} msg_voice_data instance
         */
        msg_voice_data.create = function create(properties) {
            return new msg_voice_data(properties);
        };

        /**
         * Encodes the specified msg_voice_data message. Does not implicitly {@link net.msg_voice_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data
         * @static
         * @param {net.Imsg_voice_data} message msg_voice_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.voice_data != null && Object.hasOwnProperty.call(message, "voice_data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.voice_data);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ptime);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_data message, length delimited. Does not implicitly {@link net.msg_voice_data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_data
         * @static
         * @param {net.Imsg_voice_data} message msg_voice_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data} msg_voice_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.voice_data = reader.bytes();
                    break;
                case 3:
                    message.ptime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_data} msg_voice_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_data message.
         * @function verify
         * @memberof net.msg_voice_data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.voice_data != null && message.hasOwnProperty("voice_data"))
                if (!(message.voice_data && typeof message.voice_data.length === "number" || $util.isString(message.voice_data)))
                    return "voice_data: buffer expected";
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (!$util.isInteger(message.ptime) && !(message.ptime && $util.isInteger(message.ptime.low) && $util.isInteger(message.ptime.high)))
                    return "ptime: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_voice_data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_data} msg_voice_data
         */
        msg_voice_data.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_data)
                return object;
            var message = new $root.net.msg_voice_data();
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.voice_data != null)
                if (typeof object.voice_data === "string")
                    $util.base64.decode(object.voice_data, message.voice_data = $util.newBuffer($util.base64.length(object.voice_data)), 0);
                else if (object.voice_data.length)
                    message.voice_data = object.voice_data;
            if (object.ptime != null)
                if ($util.Long)
                    (message.ptime = $util.Long.fromValue(object.ptime)).unsigned = false;
                else if (typeof object.ptime === "string")
                    message.ptime = parseInt(object.ptime, 10);
                else if (typeof object.ptime === "number")
                    message.ptime = object.ptime;
                else if (typeof object.ptime === "object")
                    message.ptime = new $util.LongBits(object.ptime.low >>> 0, object.ptime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_data
         * @static
         * @param {net.msg_voice_data} message msg_voice_data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_data.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.voice_data = "";
                else {
                    object.voice_data = [];
                    if (options.bytes !== Array)
                        object.voice_data = $util.newBuffer(object.voice_data);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.ptime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ptime = options.longs === String ? "0" : 0;
            }
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.voice_data != null && message.hasOwnProperty("voice_data"))
                object.voice_data = options.bytes === String ? $util.base64.encode(message.voice_data, 0, message.voice_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.voice_data) : message.voice_data;
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (typeof message.ptime === "number")
                    object.ptime = options.longs === String ? String(message.ptime) : message.ptime;
                else
                    object.ptime = options.longs === String ? $util.Long.prototype.toString.call(message.ptime) : options.longs === Number ? new $util.LongBits(message.ptime.low >>> 0, message.ptime.high >>> 0).toNumber() : message.ptime;
            return object;
        };

        /**
         * Converts this msg_voice_data to JSON.
         * @function toJSON
         * @memberof net.msg_voice_data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_data;
    })();

    net.msg_voice_data_rep = (function() {

        /**
         * Properties of a msg_voice_data_rep.
         * @memberof net
         * @interface Imsg_voice_data_rep
         * @property {number|null} [result] msg_voice_data_rep result
         */

        /**
         * Constructs a new msg_voice_data_rep.
         * @memberof net
         * @classdesc Represents a msg_voice_data_rep.
         * @implements Imsg_voice_data_rep
         * @constructor
         * @param {net.Imsg_voice_data_rep=} [properties] Properties to set
         */
        function msg_voice_data_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data_rep result.
         * @member {number} result
         * @memberof net.msg_voice_data_rep
         * @instance
         */
        msg_voice_data_rep.prototype.result = 0;

        /**
         * Creates a new msg_voice_data_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {net.Imsg_voice_data_rep=} [properties] Properties to set
         * @returns {net.msg_voice_data_rep} msg_voice_data_rep instance
         */
        msg_voice_data_rep.create = function create(properties) {
            return new msg_voice_data_rep(properties);
        };

        /**
         * Encodes the specified msg_voice_data_rep message. Does not implicitly {@link net.msg_voice_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {net.Imsg_voice_data_rep} message msg_voice_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_data_rep message, length delimited. Does not implicitly {@link net.msg_voice_data_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {net.Imsg_voice_data_rep} message msg_voice_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data_rep} msg_voice_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_data_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_data_rep} msg_voice_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_data_rep message.
         * @function verify
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_data_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_voice_data_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_data_rep} msg_voice_data_rep
         */
        msg_voice_data_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_data_rep)
                return object;
            var message = new $root.net.msg_voice_data_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_data_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {net.msg_voice_data_rep} message msg_voice_data_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_data_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_voice_data_rep to JSON.
         * @function toJSON
         * @memberof net.msg_voice_data_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_data_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_data_rep;
    })();

    net.msg_need_read_group_notify = (function() {

        /**
         * Properties of a msg_need_read_group_notify.
         * @memberof net
         * @interface Imsg_need_read_group_notify
         * @property {number|null} [groupkey] msg_need_read_group_notify groupkey
         */

        /**
         * Constructs a new msg_need_read_group_notify.
         * @memberof net
         * @classdesc Represents a msg_need_read_group_notify.
         * @implements Imsg_need_read_group_notify
         * @constructor
         * @param {net.Imsg_need_read_group_notify=} [properties] Properties to set
         */
        function msg_need_read_group_notify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_need_read_group_notify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_need_read_group_notify
         * @instance
         */
        msg_need_read_group_notify.prototype.groupkey = 0;

        /**
         * Creates a new msg_need_read_group_notify instance using the specified properties.
         * @function create
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {net.Imsg_need_read_group_notify=} [properties] Properties to set
         * @returns {net.msg_need_read_group_notify} msg_need_read_group_notify instance
         */
        msg_need_read_group_notify.create = function create(properties) {
            return new msg_need_read_group_notify(properties);
        };

        /**
         * Encodes the specified msg_need_read_group_notify message. Does not implicitly {@link net.msg_need_read_group_notify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {net.Imsg_need_read_group_notify} message msg_need_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_need_read_group_notify message, length delimited. Does not implicitly {@link net.msg_need_read_group_notify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {net.Imsg_need_read_group_notify} message msg_need_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_need_read_group_notify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_need_read_group_notify} msg_need_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_need_read_group_notify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_need_read_group_notify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_need_read_group_notify} msg_need_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_need_read_group_notify message.
         * @function verify
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_need_read_group_notify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_need_read_group_notify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_need_read_group_notify} msg_need_read_group_notify
         */
        msg_need_read_group_notify.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_need_read_group_notify)
                return object;
            var message = new $root.net.msg_need_read_group_notify();
            if (object.groupkey != null)
                message.groupkey = object.groupkey >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_need_read_group_notify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {net.msg_need_read_group_notify} message msg_need_read_group_notify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_need_read_group_notify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_need_read_group_notify to JSON.
         * @function toJSON
         * @memberof net.msg_need_read_group_notify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_need_read_group_notify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_need_read_group_notify;
    })();

    net.msg_need_read_group_notify_rep = (function() {

        /**
         * Properties of a msg_need_read_group_notify_rep.
         * @memberof net
         * @interface Imsg_need_read_group_notify_rep
         * @property {number|null} [is_need] msg_need_read_group_notify_rep is_need
         */

        /**
         * Constructs a new msg_need_read_group_notify_rep.
         * @memberof net
         * @classdesc Represents a msg_need_read_group_notify_rep.
         * @implements Imsg_need_read_group_notify_rep
         * @constructor
         * @param {net.Imsg_need_read_group_notify_rep=} [properties] Properties to set
         */
        function msg_need_read_group_notify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_need_read_group_notify_rep is_need.
         * @member {number} is_need
         * @memberof net.msg_need_read_group_notify_rep
         * @instance
         */
        msg_need_read_group_notify_rep.prototype.is_need = 0;

        /**
         * Creates a new msg_need_read_group_notify_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {net.Imsg_need_read_group_notify_rep=} [properties] Properties to set
         * @returns {net.msg_need_read_group_notify_rep} msg_need_read_group_notify_rep instance
         */
        msg_need_read_group_notify_rep.create = function create(properties) {
            return new msg_need_read_group_notify_rep(properties);
        };

        /**
         * Encodes the specified msg_need_read_group_notify_rep message. Does not implicitly {@link net.msg_need_read_group_notify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {net.Imsg_need_read_group_notify_rep} message msg_need_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.is_need != null && Object.hasOwnProperty.call(message, "is_need"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.is_need);
            return writer;
        };

        /**
         * Encodes the specified msg_need_read_group_notify_rep message, length delimited. Does not implicitly {@link net.msg_need_read_group_notify_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {net.Imsg_need_read_group_notify_rep} message msg_need_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_need_read_group_notify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_need_read_group_notify_rep} msg_need_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_need_read_group_notify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.is_need = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_need_read_group_notify_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_need_read_group_notify_rep} msg_need_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_need_read_group_notify_rep message.
         * @function verify
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_need_read_group_notify_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.is_need != null && message.hasOwnProperty("is_need"))
                if (!$util.isInteger(message.is_need))
                    return "is_need: integer expected";
            return null;
        };

        /**
         * Creates a msg_need_read_group_notify_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_need_read_group_notify_rep} msg_need_read_group_notify_rep
         */
        msg_need_read_group_notify_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_need_read_group_notify_rep)
                return object;
            var message = new $root.net.msg_need_read_group_notify_rep();
            if (object.is_need != null)
                message.is_need = object.is_need >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_need_read_group_notify_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {net.msg_need_read_group_notify_rep} message msg_need_read_group_notify_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_need_read_group_notify_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.is_need = 0;
            if (message.is_need != null && message.hasOwnProperty("is_need"))
                object.is_need = message.is_need;
            return object;
        };

        /**
         * Converts this msg_need_read_group_notify_rep to JSON.
         * @function toJSON
         * @memberof net.msg_need_read_group_notify_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_need_read_group_notify_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_need_read_group_notify_rep;
    })();

    net.msg_read_group_notify = (function() {

        /**
         * Properties of a msg_read_group_notify.
         * @memberof net
         * @interface Imsg_read_group_notify
         * @property {number|null} [groupkey] msg_read_group_notify groupkey
         * @property {number|null} [notifyversion] msg_read_group_notify notifyversion
         */

        /**
         * Constructs a new msg_read_group_notify.
         * @memberof net
         * @classdesc Represents a msg_read_group_notify.
         * @implements Imsg_read_group_notify
         * @constructor
         * @param {net.Imsg_read_group_notify=} [properties] Properties to set
         */
        function msg_read_group_notify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_read_group_notify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_read_group_notify
         * @instance
         */
        msg_read_group_notify.prototype.groupkey = 0;

        /**
         * msg_read_group_notify notifyversion.
         * @member {number} notifyversion
         * @memberof net.msg_read_group_notify
         * @instance
         */
        msg_read_group_notify.prototype.notifyversion = 0;

        /**
         * Creates a new msg_read_group_notify instance using the specified properties.
         * @function create
         * @memberof net.msg_read_group_notify
         * @static
         * @param {net.Imsg_read_group_notify=} [properties] Properties to set
         * @returns {net.msg_read_group_notify} msg_read_group_notify instance
         */
        msg_read_group_notify.create = function create(properties) {
            return new msg_read_group_notify(properties);
        };

        /**
         * Encodes the specified msg_read_group_notify message. Does not implicitly {@link net.msg_read_group_notify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_read_group_notify
         * @static
         * @param {net.Imsg_read_group_notify} message msg_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            if (message.notifyversion != null && Object.hasOwnProperty.call(message, "notifyversion"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.notifyversion);
            return writer;
        };

        /**
         * Encodes the specified msg_read_group_notify message, length delimited. Does not implicitly {@link net.msg_read_group_notify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_read_group_notify
         * @static
         * @param {net.Imsg_read_group_notify} message msg_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_read_group_notify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_read_group_notify} msg_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_read_group_notify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                case 2:
                    message.notifyversion = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_read_group_notify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_read_group_notify} msg_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_read_group_notify message.
         * @function verify
         * @memberof net.msg_read_group_notify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_read_group_notify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.notifyversion != null && message.hasOwnProperty("notifyversion"))
                if (!$util.isInteger(message.notifyversion))
                    return "notifyversion: integer expected";
            return null;
        };

        /**
         * Creates a msg_read_group_notify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_read_group_notify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_read_group_notify} msg_read_group_notify
         */
        msg_read_group_notify.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_read_group_notify)
                return object;
            var message = new $root.net.msg_read_group_notify();
            if (object.groupkey != null)
                message.groupkey = object.groupkey >>> 0;
            if (object.notifyversion != null)
                message.notifyversion = object.notifyversion >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_read_group_notify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_read_group_notify
         * @static
         * @param {net.msg_read_group_notify} message msg_read_group_notify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_read_group_notify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.notifyversion = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.notifyversion != null && message.hasOwnProperty("notifyversion"))
                object.notifyversion = message.notifyversion;
            return object;
        };

        /**
         * Converts this msg_read_group_notify to JSON.
         * @function toJSON
         * @memberof net.msg_read_group_notify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_read_group_notify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_read_group_notify;
    })();

    net.msg_read_group_notify_rep = (function() {

        /**
         * Properties of a msg_read_group_notify_rep.
         * @memberof net
         * @interface Imsg_read_group_notify_rep
         * @property {number|null} [result] msg_read_group_notify_rep result
         */

        /**
         * Constructs a new msg_read_group_notify_rep.
         * @memberof net
         * @classdesc Represents a msg_read_group_notify_rep.
         * @implements Imsg_read_group_notify_rep
         * @constructor
         * @param {net.Imsg_read_group_notify_rep=} [properties] Properties to set
         */
        function msg_read_group_notify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_read_group_notify_rep result.
         * @member {number} result
         * @memberof net.msg_read_group_notify_rep
         * @instance
         */
        msg_read_group_notify_rep.prototype.result = 0;

        /**
         * Creates a new msg_read_group_notify_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {net.Imsg_read_group_notify_rep=} [properties] Properties to set
         * @returns {net.msg_read_group_notify_rep} msg_read_group_notify_rep instance
         */
        msg_read_group_notify_rep.create = function create(properties) {
            return new msg_read_group_notify_rep(properties);
        };

        /**
         * Encodes the specified msg_read_group_notify_rep message. Does not implicitly {@link net.msg_read_group_notify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {net.Imsg_read_group_notify_rep} message msg_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_read_group_notify_rep message, length delimited. Does not implicitly {@link net.msg_read_group_notify_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {net.Imsg_read_group_notify_rep} message msg_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_read_group_notify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_read_group_notify_rep} msg_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_read_group_notify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_read_group_notify_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_read_group_notify_rep} msg_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_read_group_notify_rep message.
         * @function verify
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_read_group_notify_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_read_group_notify_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_read_group_notify_rep} msg_read_group_notify_rep
         */
        msg_read_group_notify_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_read_group_notify_rep)
                return object;
            var message = new $root.net.msg_read_group_notify_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_read_group_notify_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {net.msg_read_group_notify_rep} message msg_read_group_notify_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_read_group_notify_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_read_group_notify_rep to JSON.
         * @function toJSON
         * @memberof net.msg_read_group_notify_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_read_group_notify_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_read_group_notify_rep;
    })();

    net.msg_set_forbid_tm = (function() {

        /**
         * Properties of a msg_set_forbid_tm.
         * @memberof net
         * @interface Imsg_set_forbid_tm
         * @property {number|null} [groupkey] msg_set_forbid_tm groupkey
         * @property {number|null} [forbidbegintm] msg_set_forbid_tm forbidbegintm
         * @property {number|null} [forbidendtm] msg_set_forbid_tm forbidendtm
         * @property {number|null} [isforbid] msg_set_forbid_tm isforbid
         */

        /**
         * Constructs a new msg_set_forbid_tm.
         * @memberof net
         * @classdesc Represents a msg_set_forbid_tm.
         * @implements Imsg_set_forbid_tm
         * @constructor
         * @param {net.Imsg_set_forbid_tm=} [properties] Properties to set
         */
        function msg_set_forbid_tm(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_forbid_tm groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.groupkey = 0;

        /**
         * msg_set_forbid_tm forbidbegintm.
         * @member {number} forbidbegintm
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.forbidbegintm = 0;

        /**
         * msg_set_forbid_tm forbidendtm.
         * @member {number} forbidendtm
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.forbidendtm = 0;

        /**
         * msg_set_forbid_tm isforbid.
         * @member {number} isforbid
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.isforbid = 0;

        /**
         * Creates a new msg_set_forbid_tm instance using the specified properties.
         * @function create
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {net.Imsg_set_forbid_tm=} [properties] Properties to set
         * @returns {net.msg_set_forbid_tm} msg_set_forbid_tm instance
         */
        msg_set_forbid_tm.create = function create(properties) {
            return new msg_set_forbid_tm(properties);
        };

        /**
         * Encodes the specified msg_set_forbid_tm message. Does not implicitly {@link net.msg_set_forbid_tm.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {net.Imsg_set_forbid_tm} message msg_set_forbid_tm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            if (message.forbidbegintm != null && Object.hasOwnProperty.call(message, "forbidbegintm"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.forbidbegintm);
            if (message.forbidendtm != null && Object.hasOwnProperty.call(message, "forbidendtm"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.forbidendtm);
            if (message.isforbid != null && Object.hasOwnProperty.call(message, "isforbid"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.isforbid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_forbid_tm message, length delimited. Does not implicitly {@link net.msg_set_forbid_tm.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {net.Imsg_set_forbid_tm} message msg_set_forbid_tm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_forbid_tm message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_forbid_tm} msg_set_forbid_tm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_forbid_tm();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                case 2:
                    message.forbidbegintm = reader.uint32();
                    break;
                case 3:
                    message.forbidendtm = reader.uint32();
                    break;
                case 4:
                    message.isforbid = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_forbid_tm message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_forbid_tm} msg_set_forbid_tm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_forbid_tm message.
         * @function verify
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_forbid_tm.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.forbidbegintm != null && message.hasOwnProperty("forbidbegintm"))
                if (!$util.isInteger(message.forbidbegintm))
                    return "forbidbegintm: integer expected";
            if (message.forbidendtm != null && message.hasOwnProperty("forbidendtm"))
                if (!$util.isInteger(message.forbidendtm))
                    return "forbidendtm: integer expected";
            if (message.isforbid != null && message.hasOwnProperty("isforbid"))
                if (!$util.isInteger(message.isforbid))
                    return "isforbid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_forbid_tm message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_forbid_tm} msg_set_forbid_tm
         */
        msg_set_forbid_tm.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_forbid_tm)
                return object;
            var message = new $root.net.msg_set_forbid_tm();
            if (object.groupkey != null)
                message.groupkey = object.groupkey >>> 0;
            if (object.forbidbegintm != null)
                message.forbidbegintm = object.forbidbegintm >>> 0;
            if (object.forbidendtm != null)
                message.forbidendtm = object.forbidendtm >>> 0;
            if (object.isforbid != null)
                message.isforbid = object.isforbid >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_forbid_tm message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {net.msg_set_forbid_tm} message msg_set_forbid_tm
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_forbid_tm.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.forbidbegintm = 0;
                object.forbidendtm = 0;
                object.isforbid = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.forbidbegintm != null && message.hasOwnProperty("forbidbegintm"))
                object.forbidbegintm = message.forbidbegintm;
            if (message.forbidendtm != null && message.hasOwnProperty("forbidendtm"))
                object.forbidendtm = message.forbidendtm;
            if (message.isforbid != null && message.hasOwnProperty("isforbid"))
                object.isforbid = message.isforbid;
            return object;
        };

        /**
         * Converts this msg_set_forbid_tm to JSON.
         * @function toJSON
         * @memberof net.msg_set_forbid_tm
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_forbid_tm.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_forbid_tm;
    })();

    net.msg_set_forbid_tm_rep = (function() {

        /**
         * Properties of a msg_set_forbid_tm_rep.
         * @memberof net
         * @interface Imsg_set_forbid_tm_rep
         * @property {number|null} [result] msg_set_forbid_tm_rep result
         */

        /**
         * Constructs a new msg_set_forbid_tm_rep.
         * @memberof net
         * @classdesc Represents a msg_set_forbid_tm_rep.
         * @implements Imsg_set_forbid_tm_rep
         * @constructor
         * @param {net.Imsg_set_forbid_tm_rep=} [properties] Properties to set
         */
        function msg_set_forbid_tm_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_forbid_tm_rep result.
         * @member {number} result
         * @memberof net.msg_set_forbid_tm_rep
         * @instance
         */
        msg_set_forbid_tm_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_forbid_tm_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {net.Imsg_set_forbid_tm_rep=} [properties] Properties to set
         * @returns {net.msg_set_forbid_tm_rep} msg_set_forbid_tm_rep instance
         */
        msg_set_forbid_tm_rep.create = function create(properties) {
            return new msg_set_forbid_tm_rep(properties);
        };

        /**
         * Encodes the specified msg_set_forbid_tm_rep message. Does not implicitly {@link net.msg_set_forbid_tm_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {net.Imsg_set_forbid_tm_rep} message msg_set_forbid_tm_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_forbid_tm_rep message, length delimited. Does not implicitly {@link net.msg_set_forbid_tm_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {net.Imsg_set_forbid_tm_rep} message msg_set_forbid_tm_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_forbid_tm_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_forbid_tm_rep} msg_set_forbid_tm_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_forbid_tm_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_forbid_tm_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_forbid_tm_rep} msg_set_forbid_tm_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_forbid_tm_rep message.
         * @function verify
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_forbid_tm_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_forbid_tm_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_forbid_tm_rep} msg_set_forbid_tm_rep
         */
        msg_set_forbid_tm_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_forbid_tm_rep)
                return object;
            var message = new $root.net.msg_set_forbid_tm_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_forbid_tm_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {net.msg_set_forbid_tm_rep} message msg_set_forbid_tm_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_forbid_tm_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_forbid_tm_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_forbid_tm_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_forbid_tm_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_forbid_tm_rep;
    })();

    net.msg_get_group_member_list = (function() {

        /**
         * Properties of a msg_get_group_member_list.
         * @memberof net
         * @interface Imsg_get_group_member_list
         * @property {number|null} [groupkey] msg_get_group_member_list groupkey
         */

        /**
         * Constructs a new msg_get_group_member_list.
         * @memberof net
         * @classdesc Represents a msg_get_group_member_list.
         * @implements Imsg_get_group_member_list
         * @constructor
         * @param {net.Imsg_get_group_member_list=} [properties] Properties to set
         */
        function msg_get_group_member_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_member_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_member_list
         * @instance
         */
        msg_get_group_member_list.prototype.groupkey = 0;

        /**
         * Creates a new msg_get_group_member_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {net.Imsg_get_group_member_list=} [properties] Properties to set
         * @returns {net.msg_get_group_member_list} msg_get_group_member_list instance
         */
        msg_get_group_member_list.create = function create(properties) {
            return new msg_get_group_member_list(properties);
        };

        /**
         * Encodes the specified msg_get_group_member_list message. Does not implicitly {@link net.msg_get_group_member_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {net.Imsg_get_group_member_list} message msg_get_group_member_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_member_list message, length delimited. Does not implicitly {@link net.msg_get_group_member_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {net.Imsg_get_group_member_list} message msg_get_group_member_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_member_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_member_list} msg_get_group_member_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_member_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_member_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_member_list} msg_get_group_member_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_member_list message.
         * @function verify
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_member_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_member_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_member_list} msg_get_group_member_list
         */
        msg_get_group_member_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_member_list)
                return object;
            var message = new $root.net.msg_get_group_member_list();
            if (object.groupkey != null)
                message.groupkey = object.groupkey >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_member_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {net.msg_get_group_member_list} message msg_get_group_member_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_member_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_get_group_member_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_member_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_member_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_member_list;
    })();

    net.msg_get_group_member_list_rep = (function() {

        /**
         * Properties of a msg_get_group_member_list_rep.
         * @memberof net
         * @interface Imsg_get_group_member_list_rep
         * @property {number|null} [groupkey] msg_get_group_member_list_rep groupkey
         * @property {number|null} [isfirst] msg_get_group_member_list_rep isfirst
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_group_member_list_rep users
         * @property {number|null} [isend] msg_get_group_member_list_rep isend
         */

        /**
         * Constructs a new msg_get_group_member_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_member_list_rep.
         * @implements Imsg_get_group_member_list_rep
         * @constructor
         * @param {net.Imsg_get_group_member_list_rep=} [properties] Properties to set
         */
        function msg_get_group_member_list_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_member_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_group_member_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.isfirst = 0;

        /**
         * msg_get_group_member_list_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_group_member_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.isend = 0;

        /**
         * Creates a new msg_get_group_member_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {net.Imsg_get_group_member_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_group_member_list_rep} msg_get_group_member_list_rep instance
         */
        msg_get_group_member_list_rep.create = function create(properties) {
            return new msg_get_group_member_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_group_member_list_rep message. Does not implicitly {@link net.msg_get_group_member_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {net.Imsg_get_group_member_list_rep} message msg_get_group_member_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.isend);
            return writer;
        };

        /**
         * Encodes the specified msg_get_group_member_list_rep message, length delimited. Does not implicitly {@link net.msg_get_group_member_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {net.Imsg_get_group_member_list_rep} message msg_get_group_member_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_group_member_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_member_list_rep} msg_get_group_member_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_member_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.isend = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_group_member_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_group_member_list_rep} msg_get_group_member_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_group_member_list_rep message.
         * @function verify
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_group_member_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                if (!$util.isInteger(message.isfirst))
                    return "isfirst: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            if (message.isend != null && message.hasOwnProperty("isend"))
                if (!$util.isInteger(message.isend))
                    return "isend: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_group_member_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_group_member_list_rep} msg_get_group_member_list_rep
         */
        msg_get_group_member_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_group_member_list_rep)
                return object;
            var message = new $root.net.msg_get_group_member_list_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.isfirst != null)
                message.isfirst = object.isfirst | 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_group_member_list_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_group_member_list_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            if (object.isend != null)
                message.isend = object.isend | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_group_member_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {net.msg_get_group_member_list_rep} message msg_get_group_member_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_group_member_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.groupkey = 0;
                object.isfirst = 0;
                object.isend = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                object.isfirst = message.isfirst;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            if (message.isend != null && message.hasOwnProperty("isend"))
                object.isend = message.isend;
            return object;
        };

        /**
         * Converts this msg_get_group_member_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_group_member_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_group_member_list_rep;
    })();

    net.msg_get_friend_incr_list = (function() {

        /**
         * Properties of a msg_get_friend_incr_list.
         * @memberof net
         * @interface Imsg_get_friend_incr_list
         * @property {number|null} [version] msg_get_friend_incr_list version
         */

        /**
         * Constructs a new msg_get_friend_incr_list.
         * @memberof net
         * @classdesc Represents a msg_get_friend_incr_list.
         * @implements Imsg_get_friend_incr_list
         * @constructor
         * @param {net.Imsg_get_friend_incr_list=} [properties] Properties to set
         */
        function msg_get_friend_incr_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_friend_incr_list version.
         * @member {number} version
         * @memberof net.msg_get_friend_incr_list
         * @instance
         */
        msg_get_friend_incr_list.prototype.version = 0;

        /**
         * Creates a new msg_get_friend_incr_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {net.Imsg_get_friend_incr_list=} [properties] Properties to set
         * @returns {net.msg_get_friend_incr_list} msg_get_friend_incr_list instance
         */
        msg_get_friend_incr_list.create = function create(properties) {
            return new msg_get_friend_incr_list(properties);
        };

        /**
         * Encodes the specified msg_get_friend_incr_list message. Does not implicitly {@link net.msg_get_friend_incr_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {net.Imsg_get_friend_incr_list} message msg_get_friend_incr_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_get_friend_incr_list message, length delimited. Does not implicitly {@link net.msg_get_friend_incr_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {net.Imsg_get_friend_incr_list} message msg_get_friend_incr_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_friend_incr_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_friend_incr_list} msg_get_friend_incr_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_friend_incr_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_friend_incr_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_friend_incr_list} msg_get_friend_incr_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_friend_incr_list message.
         * @function verify
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_friend_incr_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_friend_incr_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_friend_incr_list} msg_get_friend_incr_list
         */
        msg_get_friend_incr_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_friend_incr_list)
                return object;
            var message = new $root.net.msg_get_friend_incr_list();
            if (object.version != null)
                message.version = object.version | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_friend_incr_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {net.msg_get_friend_incr_list} message msg_get_friend_incr_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_friend_incr_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.version = 0;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this msg_get_friend_incr_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_friend_incr_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_friend_incr_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_friend_incr_list;
    })();

    net.msg_get_friend_incr_list_rep = (function() {

        /**
         * Properties of a msg_get_friend_incr_list_rep.
         * @memberof net
         * @interface Imsg_get_friend_incr_list_rep
         * @property {Array.<net.Ibase_info>|null} [addlist] msg_get_friend_incr_list_rep addlist
         * @property {Array.<number>|null} [dellist] msg_get_friend_incr_list_rep dellist
         * @property {number|null} [isfirst] msg_get_friend_incr_list_rep isfirst
         * @property {number|null} [isend] msg_get_friend_incr_list_rep isend
         * @property {number|null} [version] msg_get_friend_incr_list_rep version
         */

        /**
         * Constructs a new msg_get_friend_incr_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_friend_incr_list_rep.
         * @implements Imsg_get_friend_incr_list_rep
         * @constructor
         * @param {net.Imsg_get_friend_incr_list_rep=} [properties] Properties to set
         */
        function msg_get_friend_incr_list_rep(properties) {
            this.addlist = [];
            this.dellist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_friend_incr_list_rep addlist.
         * @member {Array.<net.Ibase_info>} addlist
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.addlist = $util.emptyArray;

        /**
         * msg_get_friend_incr_list_rep dellist.
         * @member {Array.<number>} dellist
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.dellist = $util.emptyArray;

        /**
         * msg_get_friend_incr_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.isfirst = 0;

        /**
         * msg_get_friend_incr_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.isend = 0;

        /**
         * msg_get_friend_incr_list_rep version.
         * @member {number} version
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.version = 0;

        /**
         * Creates a new msg_get_friend_incr_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {net.Imsg_get_friend_incr_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_friend_incr_list_rep} msg_get_friend_incr_list_rep instance
         */
        msg_get_friend_incr_list_rep.create = function create(properties) {
            return new msg_get_friend_incr_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_friend_incr_list_rep message. Does not implicitly {@link net.msg_get_friend_incr_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {net.Imsg_get_friend_incr_list_rep} message msg_get_friend_incr_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addlist != null && message.addlist.length)
                for (var i = 0; i < message.addlist.length; ++i)
                    $root.net.base_info.encode(message.addlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.dellist != null && message.dellist.length)
                for (var i = 0; i < message.dellist.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dellist[i]);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.isend);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
            return writer;
        };

        /**
         * Encodes the specified msg_get_friend_incr_list_rep message, length delimited. Does not implicitly {@link net.msg_get_friend_incr_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {net.Imsg_get_friend_incr_list_rep} message msg_get_friend_incr_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_friend_incr_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_friend_incr_list_rep} msg_get_friend_incr_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_friend_incr_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.addlist && message.addlist.length))
                        message.addlist = [];
                    message.addlist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.dellist && message.dellist.length))
                        message.dellist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.dellist.push(reader.int32());
                    } else
                        message.dellist.push(reader.int32());
                    break;
                case 3:
                    message.isfirst = reader.int32();
                    break;
                case 4:
                    message.isend = reader.int32();
                    break;
                case 5:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_friend_incr_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_friend_incr_list_rep} msg_get_friend_incr_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_friend_incr_list_rep message.
         * @function verify
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_friend_incr_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.addlist != null && message.hasOwnProperty("addlist")) {
                if (!Array.isArray(message.addlist))
                    return "addlist: array expected";
                for (var i = 0; i < message.addlist.length; ++i) {
                    var error = $root.net.base_info.verify(message.addlist[i]);
                    if (error)
                        return "addlist." + error;
                }
            }
            if (message.dellist != null && message.hasOwnProperty("dellist")) {
                if (!Array.isArray(message.dellist))
                    return "dellist: array expected";
                for (var i = 0; i < message.dellist.length; ++i)
                    if (!$util.isInteger(message.dellist[i]))
                        return "dellist: integer[] expected";
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                if (!$util.isInteger(message.isfirst))
                    return "isfirst: integer expected";
            if (message.isend != null && message.hasOwnProperty("isend"))
                if (!$util.isInteger(message.isend))
                    return "isend: integer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_friend_incr_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_friend_incr_list_rep} msg_get_friend_incr_list_rep
         */
        msg_get_friend_incr_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_friend_incr_list_rep)
                return object;
            var message = new $root.net.msg_get_friend_incr_list_rep();
            if (object.addlist) {
                if (!Array.isArray(object.addlist))
                    throw TypeError(".net.msg_get_friend_incr_list_rep.addlist: array expected");
                message.addlist = [];
                for (var i = 0; i < object.addlist.length; ++i) {
                    if (typeof object.addlist[i] !== "object")
                        throw TypeError(".net.msg_get_friend_incr_list_rep.addlist: object expected");
                    message.addlist[i] = $root.net.base_info.fromObject(object.addlist[i]);
                }
            }
            if (object.dellist) {
                if (!Array.isArray(object.dellist))
                    throw TypeError(".net.msg_get_friend_incr_list_rep.dellist: array expected");
                message.dellist = [];
                for (var i = 0; i < object.dellist.length; ++i)
                    message.dellist[i] = object.dellist[i] | 0;
            }
            if (object.isfirst != null)
                message.isfirst = object.isfirst | 0;
            if (object.isend != null)
                message.isend = object.isend | 0;
            if (object.version != null)
                message.version = object.version | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_friend_incr_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {net.msg_get_friend_incr_list_rep} message msg_get_friend_incr_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_friend_incr_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.addlist = [];
                object.dellist = [];
            }
            if (options.defaults) {
                object.isfirst = 0;
                object.isend = 0;
                object.version = 0;
            }
            if (message.addlist && message.addlist.length) {
                object.addlist = [];
                for (var j = 0; j < message.addlist.length; ++j)
                    object.addlist[j] = $root.net.base_info.toObject(message.addlist[j], options);
            }
            if (message.dellist && message.dellist.length) {
                object.dellist = [];
                for (var j = 0; j < message.dellist.length; ++j)
                    object.dellist[j] = message.dellist[j];
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                object.isfirst = message.isfirst;
            if (message.isend != null && message.hasOwnProperty("isend"))
                object.isend = message.isend;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this msg_get_friend_incr_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_friend_incr_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_friend_incr_list_rep;
    })();

    net.msg_bind_openid = (function() {

        /**
         * Properties of a msg_bind_openid.
         * @memberof net
         * @interface Imsg_bind_openid
         * @property {number|null} [channel] msg_bind_openid channel
         * @property {number|null} [thirduid] msg_bind_openid thirduid
         */

        /**
         * Constructs a new msg_bind_openid.
         * @memberof net
         * @classdesc Represents a msg_bind_openid.
         * @implements Imsg_bind_openid
         * @constructor
         * @param {net.Imsg_bind_openid=} [properties] Properties to set
         */
        function msg_bind_openid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_bind_openid channel.
         * @member {number} channel
         * @memberof net.msg_bind_openid
         * @instance
         */
        msg_bind_openid.prototype.channel = 0;

        /**
         * msg_bind_openid thirduid.
         * @member {number} thirduid
         * @memberof net.msg_bind_openid
         * @instance
         */
        msg_bind_openid.prototype.thirduid = 0;

        /**
         * Creates a new msg_bind_openid instance using the specified properties.
         * @function create
         * @memberof net.msg_bind_openid
         * @static
         * @param {net.Imsg_bind_openid=} [properties] Properties to set
         * @returns {net.msg_bind_openid} msg_bind_openid instance
         */
        msg_bind_openid.create = function create(properties) {
            return new msg_bind_openid(properties);
        };

        /**
         * Encodes the specified msg_bind_openid message. Does not implicitly {@link net.msg_bind_openid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_bind_openid
         * @static
         * @param {net.Imsg_bind_openid} message msg_bind_openid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.thirduid);
            return writer;
        };

        /**
         * Encodes the specified msg_bind_openid message, length delimited. Does not implicitly {@link net.msg_bind_openid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_bind_openid
         * @static
         * @param {net.Imsg_bind_openid} message msg_bind_openid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_bind_openid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_bind_openid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_bind_openid} msg_bind_openid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_bind_openid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.channel = reader.uint32();
                    break;
                case 2:
                    message.thirduid = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_bind_openid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_bind_openid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_bind_openid} msg_bind_openid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_bind_openid message.
         * @function verify
         * @memberof net.msg_bind_openid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_bind_openid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.channel != null && message.hasOwnProperty("channel"))
                if (!$util.isInteger(message.channel))
                    return "channel: integer expected";
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                if (!$util.isInteger(message.thirduid))
                    return "thirduid: integer expected";
            return null;
        };

        /**
         * Creates a msg_bind_openid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_bind_openid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_bind_openid} msg_bind_openid
         */
        msg_bind_openid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_bind_openid)
                return object;
            var message = new $root.net.msg_bind_openid();
            if (object.channel != null)
                message.channel = object.channel >>> 0;
            if (object.thirduid != null)
                message.thirduid = object.thirduid >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_bind_openid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_bind_openid
         * @static
         * @param {net.msg_bind_openid} message msg_bind_openid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_bind_openid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.channel = 0;
                object.thirduid = 0;
            }
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            if (message.thirduid != null && message.hasOwnProperty("thirduid"))
                object.thirduid = message.thirduid;
            return object;
        };

        /**
         * Converts this msg_bind_openid to JSON.
         * @function toJSON
         * @memberof net.msg_bind_openid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_bind_openid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_bind_openid;
    })();

    net.msg_bind_openid_rep = (function() {

        /**
         * Properties of a msg_bind_openid_rep.
         * @memberof net
         * @interface Imsg_bind_openid_rep
         * @property {number|null} [result] msg_bind_openid_rep result
         */

        /**
         * Constructs a new msg_bind_openid_rep.
         * @memberof net
         * @classdesc Represents a msg_bind_openid_rep.
         * @implements Imsg_bind_openid_rep
         * @constructor
         * @param {net.Imsg_bind_openid_rep=} [properties] Properties to set
         */
        function msg_bind_openid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_bind_openid_rep result.
         * @member {number} result
         * @memberof net.msg_bind_openid_rep
         * @instance
         */
        msg_bind_openid_rep.prototype.result = 0;

        /**
         * Creates a new msg_bind_openid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {net.Imsg_bind_openid_rep=} [properties] Properties to set
         * @returns {net.msg_bind_openid_rep} msg_bind_openid_rep instance
         */
        msg_bind_openid_rep.create = function create(properties) {
            return new msg_bind_openid_rep(properties);
        };

        /**
         * Encodes the specified msg_bind_openid_rep message. Does not implicitly {@link net.msg_bind_openid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {net.Imsg_bind_openid_rep} message msg_bind_openid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_bind_openid_rep message, length delimited. Does not implicitly {@link net.msg_bind_openid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {net.Imsg_bind_openid_rep} message msg_bind_openid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_bind_openid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_bind_openid_rep} msg_bind_openid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_bind_openid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_bind_openid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_bind_openid_rep} msg_bind_openid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_bind_openid_rep message.
         * @function verify
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_bind_openid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_bind_openid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_bind_openid_rep} msg_bind_openid_rep
         */
        msg_bind_openid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_bind_openid_rep)
                return object;
            var message = new $root.net.msg_bind_openid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_bind_openid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {net.msg_bind_openid_rep} message msg_bind_openid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_bind_openid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_bind_openid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_bind_openid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_bind_openid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_bind_openid_rep;
    })();

    net.msg_add_friend_byfid = (function() {

        /**
         * Properties of a msg_add_friend_byfid.
         * @memberof net
         * @interface Imsg_add_friend_byfid
         * @property {number|null} [fid] msg_add_friend_byfid fid
         * @property {Uint8Array|null} [hellomsg] msg_add_friend_byfid hellomsg
         */

        /**
         * Constructs a new msg_add_friend_byfid.
         * @memberof net
         * @classdesc Represents a msg_add_friend_byfid.
         * @implements Imsg_add_friend_byfid
         * @constructor
         * @param {net.Imsg_add_friend_byfid=} [properties] Properties to set
         */
        function msg_add_friend_byfid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_byfid fid.
         * @member {number} fid
         * @memberof net.msg_add_friend_byfid
         * @instance
         */
        msg_add_friend_byfid.prototype.fid = 0;

        /**
         * msg_add_friend_byfid hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.msg_add_friend_byfid
         * @instance
         */
        msg_add_friend_byfid.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Creates a new msg_add_friend_byfid instance using the specified properties.
         * @function create
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {net.Imsg_add_friend_byfid=} [properties] Properties to set
         * @returns {net.msg_add_friend_byfid} msg_add_friend_byfid instance
         */
        msg_add_friend_byfid.create = function create(properties) {
            return new msg_add_friend_byfid(properties);
        };

        /**
         * Encodes the specified msg_add_friend_byfid message. Does not implicitly {@link net.msg_add_friend_byfid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {net.Imsg_add_friend_byfid} message msg_add_friend_byfid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fid);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Encodes the specified msg_add_friend_byfid message, length delimited. Does not implicitly {@link net.msg_add_friend_byfid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {net.Imsg_add_friend_byfid} message msg_add_friend_byfid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_friend_byfid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_byfid} msg_add_friend_byfid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_byfid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fid = reader.int32();
                    break;
                case 2:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_friend_byfid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_friend_byfid} msg_add_friend_byfid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_friend_byfid message.
         * @function verify
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_friend_byfid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fid != null && message.hasOwnProperty("fid"))
                if (!$util.isInteger(message.fid))
                    return "fid: integer expected";
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                if (!(message.hellomsg && typeof message.hellomsg.length === "number" || $util.isString(message.hellomsg)))
                    return "hellomsg: buffer expected";
            return null;
        };

        /**
         * Creates a msg_add_friend_byfid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_friend_byfid} msg_add_friend_byfid
         */
        msg_add_friend_byfid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_friend_byfid)
                return object;
            var message = new $root.net.msg_add_friend_byfid();
            if (object.fid != null)
                message.fid = object.fid | 0;
            if (object.hellomsg != null)
                if (typeof object.hellomsg === "string")
                    $util.base64.decode(object.hellomsg, message.hellomsg = $util.newBuffer($util.base64.length(object.hellomsg)), 0);
                else if (object.hellomsg.length)
                    message.hellomsg = object.hellomsg;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_friend_byfid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {net.msg_add_friend_byfid} message msg_add_friend_byfid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_friend_byfid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fid = 0;
                if (options.bytes === String)
                    object.hellomsg = "";
                else {
                    object.hellomsg = [];
                    if (options.bytes !== Array)
                        object.hellomsg = $util.newBuffer(object.hellomsg);
                }
            }
            if (message.fid != null && message.hasOwnProperty("fid"))
                object.fid = message.fid;
            if (message.hellomsg != null && message.hasOwnProperty("hellomsg"))
                object.hellomsg = options.bytes === String ? $util.base64.encode(message.hellomsg, 0, message.hellomsg.length) : options.bytes === Array ? Array.prototype.slice.call(message.hellomsg) : message.hellomsg;
            return object;
        };

        /**
         * Converts this msg_add_friend_byfid to JSON.
         * @function toJSON
         * @memberof net.msg_add_friend_byfid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_friend_byfid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_friend_byfid;
    })();

    net.msg_add_friend_byfid_rep = (function() {

        /**
         * Properties of a msg_add_friend_byfid_rep.
         * @memberof net
         * @interface Imsg_add_friend_byfid_rep
         * @property {number|null} [result] msg_add_friend_byfid_rep result
         */

        /**
         * Constructs a new msg_add_friend_byfid_rep.
         * @memberof net
         * @classdesc Represents a msg_add_friend_byfid_rep.
         * @implements Imsg_add_friend_byfid_rep
         * @constructor
         * @param {net.Imsg_add_friend_byfid_rep=} [properties] Properties to set
         */
        function msg_add_friend_byfid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_byfid_rep result.
         * @member {number} result
         * @memberof net.msg_add_friend_byfid_rep
         * @instance
         */
        msg_add_friend_byfid_rep.prototype.result = 0;

        /**
         * Creates a new msg_add_friend_byfid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {net.Imsg_add_friend_byfid_rep=} [properties] Properties to set
         * @returns {net.msg_add_friend_byfid_rep} msg_add_friend_byfid_rep instance
         */
        msg_add_friend_byfid_rep.create = function create(properties) {
            return new msg_add_friend_byfid_rep(properties);
        };

        /**
         * Encodes the specified msg_add_friend_byfid_rep message. Does not implicitly {@link net.msg_add_friend_byfid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {net.Imsg_add_friend_byfid_rep} message msg_add_friend_byfid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_add_friend_byfid_rep message, length delimited. Does not implicitly {@link net.msg_add_friend_byfid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {net.Imsg_add_friend_byfid_rep} message msg_add_friend_byfid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_add_friend_byfid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_byfid_rep} msg_add_friend_byfid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_byfid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_add_friend_byfid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_add_friend_byfid_rep} msg_add_friend_byfid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_add_friend_byfid_rep message.
         * @function verify
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_add_friend_byfid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_add_friend_byfid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_add_friend_byfid_rep} msg_add_friend_byfid_rep
         */
        msg_add_friend_byfid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_add_friend_byfid_rep)
                return object;
            var message = new $root.net.msg_add_friend_byfid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_add_friend_byfid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {net.msg_add_friend_byfid_rep} message msg_add_friend_byfid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_add_friend_byfid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_add_friend_byfid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_add_friend_byfid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_add_friend_byfid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_add_friend_byfid_rep;
    })();

    net.msg_set_complete_name = (function() {

        /**
         * Properties of a msg_set_complete_name.
         * @memberof net
         * @interface Imsg_set_complete_name
         * @property {Uint8Array|null} [firstname] msg_set_complete_name firstname
         * @property {Uint8Array|null} [lastname] msg_set_complete_name lastname
         */

        /**
         * Constructs a new msg_set_complete_name.
         * @memberof net
         * @classdesc Represents a msg_set_complete_name.
         * @implements Imsg_set_complete_name
         * @constructor
         * @param {net.Imsg_set_complete_name=} [properties] Properties to set
         */
        function msg_set_complete_name(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_complete_name firstname.
         * @member {Uint8Array} firstname
         * @memberof net.msg_set_complete_name
         * @instance
         */
        msg_set_complete_name.prototype.firstname = $util.newBuffer([]);

        /**
         * msg_set_complete_name lastname.
         * @member {Uint8Array} lastname
         * @memberof net.msg_set_complete_name
         * @instance
         */
        msg_set_complete_name.prototype.lastname = $util.newBuffer([]);

        /**
         * Creates a new msg_set_complete_name instance using the specified properties.
         * @function create
         * @memberof net.msg_set_complete_name
         * @static
         * @param {net.Imsg_set_complete_name=} [properties] Properties to set
         * @returns {net.msg_set_complete_name} msg_set_complete_name instance
         */
        msg_set_complete_name.create = function create(properties) {
            return new msg_set_complete_name(properties);
        };

        /**
         * Encodes the specified msg_set_complete_name message. Does not implicitly {@link net.msg_set_complete_name.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_complete_name
         * @static
         * @param {net.Imsg_set_complete_name} message msg_set_complete_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.lastname);
            return writer;
        };

        /**
         * Encodes the specified msg_set_complete_name message, length delimited. Does not implicitly {@link net.msg_set_complete_name.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_complete_name
         * @static
         * @param {net.Imsg_set_complete_name} message msg_set_complete_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_complete_name message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_complete_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_complete_name} msg_set_complete_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_complete_name();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.firstname = reader.bytes();
                    break;
                case 2:
                    message.lastname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_complete_name message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_complete_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_complete_name} msg_set_complete_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_complete_name message.
         * @function verify
         * @memberof net.msg_set_complete_name
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_complete_name.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!(message.firstname && typeof message.firstname.length === "number" || $util.isString(message.firstname)))
                    return "firstname: buffer expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!(message.lastname && typeof message.lastname.length === "number" || $util.isString(message.lastname)))
                    return "lastname: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_complete_name message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_complete_name
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_complete_name} msg_set_complete_name
         */
        msg_set_complete_name.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_complete_name)
                return object;
            var message = new $root.net.msg_set_complete_name();
            if (object.firstname != null)
                if (typeof object.firstname === "string")
                    $util.base64.decode(object.firstname, message.firstname = $util.newBuffer($util.base64.length(object.firstname)), 0);
                else if (object.firstname.length)
                    message.firstname = object.firstname;
            if (object.lastname != null)
                if (typeof object.lastname === "string")
                    $util.base64.decode(object.lastname, message.lastname = $util.newBuffer($util.base64.length(object.lastname)), 0);
                else if (object.lastname.length)
                    message.lastname = object.lastname;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_complete_name message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_complete_name
         * @static
         * @param {net.msg_set_complete_name} message msg_set_complete_name
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_complete_name.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.firstname = "";
                else {
                    object.firstname = [];
                    if (options.bytes !== Array)
                        object.firstname = $util.newBuffer(object.firstname);
                }
                if (options.bytes === String)
                    object.lastname = "";
                else {
                    object.lastname = [];
                    if (options.bytes !== Array)
                        object.lastname = $util.newBuffer(object.lastname);
                }
            }
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = options.bytes === String ? $util.base64.encode(message.firstname, 0, message.firstname.length) : options.bytes === Array ? Array.prototype.slice.call(message.firstname) : message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = options.bytes === String ? $util.base64.encode(message.lastname, 0, message.lastname.length) : options.bytes === Array ? Array.prototype.slice.call(message.lastname) : message.lastname;
            return object;
        };

        /**
         * Converts this msg_set_complete_name to JSON.
         * @function toJSON
         * @memberof net.msg_set_complete_name
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_complete_name.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_complete_name;
    })();

    net.msg_set_complete_name_rep = (function() {

        /**
         * Properties of a msg_set_complete_name_rep.
         * @memberof net
         * @interface Imsg_set_complete_name_rep
         * @property {number|null} [result] msg_set_complete_name_rep result
         * @property {Uint8Array|null} [firstname] msg_set_complete_name_rep firstname
         * @property {Uint8Array|null} [lastname] msg_set_complete_name_rep lastname
         */

        /**
         * Constructs a new msg_set_complete_name_rep.
         * @memberof net
         * @classdesc Represents a msg_set_complete_name_rep.
         * @implements Imsg_set_complete_name_rep
         * @constructor
         * @param {net.Imsg_set_complete_name_rep=} [properties] Properties to set
         */
        function msg_set_complete_name_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_complete_name_rep result.
         * @member {number} result
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.result = 0;

        /**
         * msg_set_complete_name_rep firstname.
         * @member {Uint8Array} firstname
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.firstname = $util.newBuffer([]);

        /**
         * msg_set_complete_name_rep lastname.
         * @member {Uint8Array} lastname
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.lastname = $util.newBuffer([]);

        /**
         * Creates a new msg_set_complete_name_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {net.Imsg_set_complete_name_rep=} [properties] Properties to set
         * @returns {net.msg_set_complete_name_rep} msg_set_complete_name_rep instance
         */
        msg_set_complete_name_rep.create = function create(properties) {
            return new msg_set_complete_name_rep(properties);
        };

        /**
         * Encodes the specified msg_set_complete_name_rep message. Does not implicitly {@link net.msg_set_complete_name_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {net.Imsg_set_complete_name_rep} message msg_set_complete_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.lastname);
            return writer;
        };

        /**
         * Encodes the specified msg_set_complete_name_rep message, length delimited. Does not implicitly {@link net.msg_set_complete_name_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {net.Imsg_set_complete_name_rep} message msg_set_complete_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_complete_name_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_complete_name_rep} msg_set_complete_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_complete_name_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.firstname = reader.bytes();
                    break;
                case 3:
                    message.lastname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_complete_name_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_complete_name_rep} msg_set_complete_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_complete_name_rep message.
         * @function verify
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_complete_name_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!(message.firstname && typeof message.firstname.length === "number" || $util.isString(message.firstname)))
                    return "firstname: buffer expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!(message.lastname && typeof message.lastname.length === "number" || $util.isString(message.lastname)))
                    return "lastname: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_complete_name_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_complete_name_rep} msg_set_complete_name_rep
         */
        msg_set_complete_name_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_complete_name_rep)
                return object;
            var message = new $root.net.msg_set_complete_name_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.firstname != null)
                if (typeof object.firstname === "string")
                    $util.base64.decode(object.firstname, message.firstname = $util.newBuffer($util.base64.length(object.firstname)), 0);
                else if (object.firstname.length)
                    message.firstname = object.firstname;
            if (object.lastname != null)
                if (typeof object.lastname === "string")
                    $util.base64.decode(object.lastname, message.lastname = $util.newBuffer($util.base64.length(object.lastname)), 0);
                else if (object.lastname.length)
                    message.lastname = object.lastname;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_complete_name_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {net.msg_set_complete_name_rep} message msg_set_complete_name_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_complete_name_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.firstname = "";
                else {
                    object.firstname = [];
                    if (options.bytes !== Array)
                        object.firstname = $util.newBuffer(object.firstname);
                }
                if (options.bytes === String)
                    object.lastname = "";
                else {
                    object.lastname = [];
                    if (options.bytes !== Array)
                        object.lastname = $util.newBuffer(object.lastname);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = options.bytes === String ? $util.base64.encode(message.firstname, 0, message.firstname.length) : options.bytes === Array ? Array.prototype.slice.call(message.firstname) : message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = options.bytes === String ? $util.base64.encode(message.lastname, 0, message.lastname.length) : options.bytes === Array ? Array.prototype.slice.call(message.lastname) : message.lastname;
            return object;
        };

        /**
         * Converts this msg_set_complete_name_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_complete_name_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_complete_name_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_complete_name_rep;
    })();

    net.msg_set_phonenum = (function() {

        /**
         * Properties of a msg_set_phonenum.
         * @memberof net
         * @interface Imsg_set_phonenum
         * @property {Uint8Array|null} [zone] msg_set_phonenum zone
         * @property {Uint8Array|null} [phonenum] msg_set_phonenum phonenum
         * @property {Uint8Array|null} [verifycode] msg_set_phonenum verifycode
         */

        /**
         * Constructs a new msg_set_phonenum.
         * @memberof net
         * @classdesc Represents a msg_set_phonenum.
         * @implements Imsg_set_phonenum
         * @constructor
         * @param {net.Imsg_set_phonenum=} [properties] Properties to set
         */
        function msg_set_phonenum(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_phonenum zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.zone = $util.newBuffer([]);

        /**
         * msg_set_phonenum phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_set_phonenum verifycode.
         * @member {Uint8Array} verifycode
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.verifycode = $util.newBuffer([]);

        /**
         * Creates a new msg_set_phonenum instance using the specified properties.
         * @function create
         * @memberof net.msg_set_phonenum
         * @static
         * @param {net.Imsg_set_phonenum=} [properties] Properties to set
         * @returns {net.msg_set_phonenum} msg_set_phonenum instance
         */
        msg_set_phonenum.create = function create(properties) {
            return new msg_set_phonenum(properties);
        };

        /**
         * Encodes the specified msg_set_phonenum message. Does not implicitly {@link net.msg_set_phonenum.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_phonenum
         * @static
         * @param {net.Imsg_set_phonenum} message msg_set_phonenum message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.zone);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.phonenum);
            if (message.verifycode != null && Object.hasOwnProperty.call(message, "verifycode"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.verifycode);
            return writer;
        };

        /**
         * Encodes the specified msg_set_phonenum message, length delimited. Does not implicitly {@link net.msg_set_phonenum.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_phonenum
         * @static
         * @param {net.Imsg_set_phonenum} message msg_set_phonenum message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_phonenum message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_phonenum
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_phonenum} msg_set_phonenum
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_phonenum();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.zone = reader.bytes();
                    break;
                case 2:
                    message.phonenum = reader.bytes();
                    break;
                case 3:
                    message.verifycode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_phonenum message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_phonenum
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_phonenum} msg_set_phonenum
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_phonenum message.
         * @function verify
         * @memberof net.msg_set_phonenum
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_phonenum.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.zone != null && message.hasOwnProperty("zone"))
                if (!(message.zone && typeof message.zone.length === "number" || $util.isString(message.zone)))
                    return "zone: buffer expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            if (message.verifycode != null && message.hasOwnProperty("verifycode"))
                if (!(message.verifycode && typeof message.verifycode.length === "number" || $util.isString(message.verifycode)))
                    return "verifycode: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_phonenum message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_phonenum
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_phonenum} msg_set_phonenum
         */
        msg_set_phonenum.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_phonenum)
                return object;
            var message = new $root.net.msg_set_phonenum();
            if (object.zone != null)
                if (typeof object.zone === "string")
                    $util.base64.decode(object.zone, message.zone = $util.newBuffer($util.base64.length(object.zone)), 0);
                else if (object.zone.length)
                    message.zone = object.zone;
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            if (object.verifycode != null)
                if (typeof object.verifycode === "string")
                    $util.base64.decode(object.verifycode, message.verifycode = $util.newBuffer($util.base64.length(object.verifycode)), 0);
                else if (object.verifycode.length)
                    message.verifycode = object.verifycode;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_phonenum message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_phonenum
         * @static
         * @param {net.msg_set_phonenum} message msg_set_phonenum
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_phonenum.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.zone = "";
                else {
                    object.zone = [];
                    if (options.bytes !== Array)
                        object.zone = $util.newBuffer(object.zone);
                }
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
                if (options.bytes === String)
                    object.verifycode = "";
                else {
                    object.verifycode = [];
                    if (options.bytes !== Array)
                        object.verifycode = $util.newBuffer(object.verifycode);
                }
            }
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = options.bytes === String ? $util.base64.encode(message.zone, 0, message.zone.length) : options.bytes === Array ? Array.prototype.slice.call(message.zone) : message.zone;
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            if (message.verifycode != null && message.hasOwnProperty("verifycode"))
                object.verifycode = options.bytes === String ? $util.base64.encode(message.verifycode, 0, message.verifycode.length) : options.bytes === Array ? Array.prototype.slice.call(message.verifycode) : message.verifycode;
            return object;
        };

        /**
         * Converts this msg_set_phonenum to JSON.
         * @function toJSON
         * @memberof net.msg_set_phonenum
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_phonenum.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_phonenum;
    })();

    net.msg_set_phonenum_rep = (function() {

        /**
         * Properties of a msg_set_phonenum_rep.
         * @memberof net
         * @interface Imsg_set_phonenum_rep
         * @property {number|null} [result] msg_set_phonenum_rep result
         * @property {Uint8Array|null} [zone] msg_set_phonenum_rep zone
         * @property {Uint8Array|null} [phonenum] msg_set_phonenum_rep phonenum
         */

        /**
         * Constructs a new msg_set_phonenum_rep.
         * @memberof net
         * @classdesc Represents a msg_set_phonenum_rep.
         * @implements Imsg_set_phonenum_rep
         * @constructor
         * @param {net.Imsg_set_phonenum_rep=} [properties] Properties to set
         */
        function msg_set_phonenum_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_phonenum_rep result.
         * @member {number} result
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.result = 0;

        /**
         * msg_set_phonenum_rep zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.zone = $util.newBuffer([]);

        /**
         * msg_set_phonenum_rep phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.phonenum = $util.newBuffer([]);

        /**
         * Creates a new msg_set_phonenum_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {net.Imsg_set_phonenum_rep=} [properties] Properties to set
         * @returns {net.msg_set_phonenum_rep} msg_set_phonenum_rep instance
         */
        msg_set_phonenum_rep.create = function create(properties) {
            return new msg_set_phonenum_rep(properties);
        };

        /**
         * Encodes the specified msg_set_phonenum_rep message. Does not implicitly {@link net.msg_set_phonenum_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {net.Imsg_set_phonenum_rep} message msg_set_phonenum_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.zone);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            return writer;
        };

        /**
         * Encodes the specified msg_set_phonenum_rep message, length delimited. Does not implicitly {@link net.msg_set_phonenum_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {net.Imsg_set_phonenum_rep} message msg_set_phonenum_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_phonenum_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_phonenum_rep} msg_set_phonenum_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_phonenum_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.zone = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_phonenum_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_phonenum_rep} msg_set_phonenum_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_phonenum_rep message.
         * @function verify
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_phonenum_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.zone != null && message.hasOwnProperty("zone"))
                if (!(message.zone && typeof message.zone.length === "number" || $util.isString(message.zone)))
                    return "zone: buffer expected";
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                if (!(message.phonenum && typeof message.phonenum.length === "number" || $util.isString(message.phonenum)))
                    return "phonenum: buffer expected";
            return null;
        };

        /**
         * Creates a msg_set_phonenum_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_phonenum_rep} msg_set_phonenum_rep
         */
        msg_set_phonenum_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_phonenum_rep)
                return object;
            var message = new $root.net.msg_set_phonenum_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.zone != null)
                if (typeof object.zone === "string")
                    $util.base64.decode(object.zone, message.zone = $util.newBuffer($util.base64.length(object.zone)), 0);
                else if (object.zone.length)
                    message.zone = object.zone;
            if (object.phonenum != null)
                if (typeof object.phonenum === "string")
                    $util.base64.decode(object.phonenum, message.phonenum = $util.newBuffer($util.base64.length(object.phonenum)), 0);
                else if (object.phonenum.length)
                    message.phonenum = object.phonenum;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_phonenum_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {net.msg_set_phonenum_rep} message msg_set_phonenum_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_phonenum_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.zone = "";
                else {
                    object.zone = [];
                    if (options.bytes !== Array)
                        object.zone = $util.newBuffer(object.zone);
                }
                if (options.bytes === String)
                    object.phonenum = "";
                else {
                    object.phonenum = [];
                    if (options.bytes !== Array)
                        object.phonenum = $util.newBuffer(object.phonenum);
                }
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = options.bytes === String ? $util.base64.encode(message.zone, 0, message.zone.length) : options.bytes === Array ? Array.prototype.slice.call(message.zone) : message.zone;
            if (message.phonenum != null && message.hasOwnProperty("phonenum"))
                object.phonenum = options.bytes === String ? $util.base64.encode(message.phonenum, 0, message.phonenum.length) : options.bytes === Array ? Array.prototype.slice.call(message.phonenum) : message.phonenum;
            return object;
        };

        /**
         * Converts this msg_set_phonenum_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_phonenum_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_phonenum_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_phonenum_rep;
    })();

    net.msg_set_privacy = (function() {

        /**
         * Properties of a msg_set_privacy.
         * @memberof net
         * @interface Imsg_set_privacy
         * @property {number|null} [ptype] msg_set_privacy ptype
         * @property {number|null} [flagval] msg_set_privacy flagval
         */

        /**
         * Constructs a new msg_set_privacy.
         * @memberof net
         * @classdesc Represents a msg_set_privacy.
         * @implements Imsg_set_privacy
         * @constructor
         * @param {net.Imsg_set_privacy=} [properties] Properties to set
         */
        function msg_set_privacy(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_privacy ptype.
         * @member {number} ptype
         * @memberof net.msg_set_privacy
         * @instance
         */
        msg_set_privacy.prototype.ptype = 0;

        /**
         * msg_set_privacy flagval.
         * @member {number} flagval
         * @memberof net.msg_set_privacy
         * @instance
         */
        msg_set_privacy.prototype.flagval = 0;

        /**
         * Creates a new msg_set_privacy instance using the specified properties.
         * @function create
         * @memberof net.msg_set_privacy
         * @static
         * @param {net.Imsg_set_privacy=} [properties] Properties to set
         * @returns {net.msg_set_privacy} msg_set_privacy instance
         */
        msg_set_privacy.create = function create(properties) {
            return new msg_set_privacy(properties);
        };

        /**
         * Encodes the specified msg_set_privacy message. Does not implicitly {@link net.msg_set_privacy.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_privacy
         * @static
         * @param {net.Imsg_set_privacy} message msg_set_privacy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ptype != null && Object.hasOwnProperty.call(message, "ptype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ptype);
            if (message.flagval != null && Object.hasOwnProperty.call(message, "flagval"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.flagval);
            return writer;
        };

        /**
         * Encodes the specified msg_set_privacy message, length delimited. Does not implicitly {@link net.msg_set_privacy.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_privacy
         * @static
         * @param {net.Imsg_set_privacy} message msg_set_privacy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_privacy message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_privacy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_privacy} msg_set_privacy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_privacy();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ptype = reader.int32();
                    break;
                case 2:
                    message.flagval = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_privacy message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_privacy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_privacy} msg_set_privacy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_privacy message.
         * @function verify
         * @memberof net.msg_set_privacy
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_privacy.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ptype != null && message.hasOwnProperty("ptype"))
                if (!$util.isInteger(message.ptype))
                    return "ptype: integer expected";
            if (message.flagval != null && message.hasOwnProperty("flagval"))
                if (!$util.isInteger(message.flagval))
                    return "flagval: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_privacy message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_privacy
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_privacy} msg_set_privacy
         */
        msg_set_privacy.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_privacy)
                return object;
            var message = new $root.net.msg_set_privacy();
            if (object.ptype != null)
                message.ptype = object.ptype | 0;
            if (object.flagval != null)
                message.flagval = object.flagval | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_privacy message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_privacy
         * @static
         * @param {net.msg_set_privacy} message msg_set_privacy
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_privacy.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ptype = 0;
                object.flagval = 0;
            }
            if (message.ptype != null && message.hasOwnProperty("ptype"))
                object.ptype = message.ptype;
            if (message.flagval != null && message.hasOwnProperty("flagval"))
                object.flagval = message.flagval;
            return object;
        };

        /**
         * Converts this msg_set_privacy to JSON.
         * @function toJSON
         * @memberof net.msg_set_privacy
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_privacy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_privacy;
    })();

    net.msg_set_privacy_rep = (function() {

        /**
         * Properties of a msg_set_privacy_rep.
         * @memberof net
         * @interface Imsg_set_privacy_rep
         * @property {number|null} [result] msg_set_privacy_rep result
         * @property {number|null} [ptype] msg_set_privacy_rep ptype
         * @property {number|null} [flagval] msg_set_privacy_rep flagval
         * @property {number|Long|null} [privacy] msg_set_privacy_rep privacy
         */

        /**
         * Constructs a new msg_set_privacy_rep.
         * @memberof net
         * @classdesc Represents a msg_set_privacy_rep.
         * @implements Imsg_set_privacy_rep
         * @constructor
         * @param {net.Imsg_set_privacy_rep=} [properties] Properties to set
         */
        function msg_set_privacy_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_privacy_rep result.
         * @member {number} result
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.result = 0;

        /**
         * msg_set_privacy_rep ptype.
         * @member {number} ptype
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.ptype = 0;

        /**
         * msg_set_privacy_rep flagval.
         * @member {number} flagval
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.flagval = 0;

        /**
         * msg_set_privacy_rep privacy.
         * @member {number|Long} privacy
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.privacy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_set_privacy_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {net.Imsg_set_privacy_rep=} [properties] Properties to set
         * @returns {net.msg_set_privacy_rep} msg_set_privacy_rep instance
         */
        msg_set_privacy_rep.create = function create(properties) {
            return new msg_set_privacy_rep(properties);
        };

        /**
         * Encodes the specified msg_set_privacy_rep message. Does not implicitly {@link net.msg_set_privacy_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {net.Imsg_set_privacy_rep} message msg_set_privacy_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.ptype != null && Object.hasOwnProperty.call(message, "ptype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ptype);
            if (message.flagval != null && Object.hasOwnProperty.call(message, "flagval"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.flagval);
            if (message.privacy != null && Object.hasOwnProperty.call(message, "privacy"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.privacy);
            return writer;
        };

        /**
         * Encodes the specified msg_set_privacy_rep message, length delimited. Does not implicitly {@link net.msg_set_privacy_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {net.Imsg_set_privacy_rep} message msg_set_privacy_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_privacy_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_privacy_rep} msg_set_privacy_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_privacy_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.ptype = reader.int32();
                    break;
                case 3:
                    message.flagval = reader.int32();
                    break;
                case 4:
                    message.privacy = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_privacy_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_privacy_rep} msg_set_privacy_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_privacy_rep message.
         * @function verify
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_privacy_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.ptype != null && message.hasOwnProperty("ptype"))
                if (!$util.isInteger(message.ptype))
                    return "ptype: integer expected";
            if (message.flagval != null && message.hasOwnProperty("flagval"))
                if (!$util.isInteger(message.flagval))
                    return "flagval: integer expected";
            if (message.privacy != null && message.hasOwnProperty("privacy"))
                if (!$util.isInteger(message.privacy) && !(message.privacy && $util.isInteger(message.privacy.low) && $util.isInteger(message.privacy.high)))
                    return "privacy: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_set_privacy_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_privacy_rep} msg_set_privacy_rep
         */
        msg_set_privacy_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_privacy_rep)
                return object;
            var message = new $root.net.msg_set_privacy_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.ptype != null)
                message.ptype = object.ptype | 0;
            if (object.flagval != null)
                message.flagval = object.flagval | 0;
            if (object.privacy != null)
                if ($util.Long)
                    (message.privacy = $util.Long.fromValue(object.privacy)).unsigned = false;
                else if (typeof object.privacy === "string")
                    message.privacy = parseInt(object.privacy, 10);
                else if (typeof object.privacy === "number")
                    message.privacy = object.privacy;
                else if (typeof object.privacy === "object")
                    message.privacy = new $util.LongBits(object.privacy.low >>> 0, object.privacy.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_set_privacy_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {net.msg_set_privacy_rep} message msg_set_privacy_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_privacy_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.ptype = 0;
                object.flagval = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.privacy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.privacy = options.longs === String ? "0" : 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.ptype != null && message.hasOwnProperty("ptype"))
                object.ptype = message.ptype;
            if (message.flagval != null && message.hasOwnProperty("flagval"))
                object.flagval = message.flagval;
            if (message.privacy != null && message.hasOwnProperty("privacy"))
                if (typeof message.privacy === "number")
                    object.privacy = options.longs === String ? String(message.privacy) : message.privacy;
                else
                    object.privacy = options.longs === String ? $util.Long.prototype.toString.call(message.privacy) : options.longs === Number ? new $util.LongBits(message.privacy.low >>> 0, message.privacy.high >>> 0).toNumber() : message.privacy;
            return object;
        };

        /**
         * Converts this msg_set_privacy_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_privacy_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_privacy_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_privacy_rep;
    })();

    net.msg_group_voice_call = (function() {

        /**
         * Properties of a msg_group_voice_call.
         * @memberof net
         * @interface Imsg_group_voice_call
         * @property {number|null} [groupkey] msg_group_voice_call groupkey
         * @property {Array.<number>|null} [uids] msg_group_voice_call uids
         * @property {Uint8Array|null} [token] msg_group_voice_call token
         */

        /**
         * Constructs a new msg_group_voice_call.
         * @memberof net
         * @classdesc Represents a msg_group_voice_call.
         * @implements Imsg_group_voice_call
         * @constructor
         * @param {net.Imsg_group_voice_call=} [properties] Properties to set
         */
        function msg_group_voice_call(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_voice_call groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_voice_call
         * @instance
         */
        msg_group_voice_call.prototype.groupkey = 0;

        /**
         * msg_group_voice_call uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_group_voice_call
         * @instance
         */
        msg_group_voice_call.prototype.uids = $util.emptyArray;

        /**
         * msg_group_voice_call token.
         * @member {Uint8Array} token
         * @memberof net.msg_group_voice_call
         * @instance
         */
        msg_group_voice_call.prototype.token = $util.newBuffer([]);

        /**
         * Creates a new msg_group_voice_call instance using the specified properties.
         * @function create
         * @memberof net.msg_group_voice_call
         * @static
         * @param {net.Imsg_group_voice_call=} [properties] Properties to set
         * @returns {net.msg_group_voice_call} msg_group_voice_call instance
         */
        msg_group_voice_call.create = function create(properties) {
            return new msg_group_voice_call(properties);
        };

        /**
         * Encodes the specified msg_group_voice_call message. Does not implicitly {@link net.msg_group_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_voice_call
         * @static
         * @param {net.Imsg_group_voice_call} message msg_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uids[i]);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.token);
            return writer;
        };

        /**
         * Encodes the specified msg_group_voice_call message, length delimited. Does not implicitly {@link net.msg_group_voice_call.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_voice_call
         * @static
         * @param {net.Imsg_group_voice_call} message msg_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_voice_call} msg_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 3:
                    message.token = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_voice_call message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_voice_call} msg_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_voice_call message.
         * @function verify
         * @memberof net.msg_group_voice_call
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_voice_call.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.uids != null && message.hasOwnProperty("uids")) {
                if (!Array.isArray(message.uids))
                    return "uids: array expected";
                for (var i = 0; i < message.uids.length; ++i)
                    if (!$util.isInteger(message.uids[i]))
                        return "uids: integer[] expected";
            }
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            return null;
        };

        /**
         * Creates a msg_group_voice_call message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_voice_call
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_voice_call} msg_group_voice_call
         */
        msg_group_voice_call.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_voice_call)
                return object;
            var message = new $root.net.msg_group_voice_call();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.uids) {
                if (!Array.isArray(object.uids))
                    throw TypeError(".net.msg_group_voice_call.uids: array expected");
                message.uids = [];
                for (var i = 0; i < object.uids.length; ++i)
                    message.uids[i] = object.uids[i] | 0;
            }
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length)
                    message.token = object.token;
            return message;
        };

        /**
         * Creates a plain object from a msg_group_voice_call message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_voice_call
         * @static
         * @param {net.msg_group_voice_call} message msg_group_voice_call
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_voice_call.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.uids = [];
            if (options.defaults) {
                object.groupkey = 0;
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.uids && message.uids.length) {
                object.uids = [];
                for (var j = 0; j < message.uids.length; ++j)
                    object.uids[j] = message.uids[j];
            }
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            return object;
        };

        /**
         * Converts this msg_group_voice_call to JSON.
         * @function toJSON
         * @memberof net.msg_group_voice_call
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_voice_call.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_voice_call;
    })();

    net.msg_group_voice_call_rep = (function() {

        /**
         * Properties of a msg_group_voice_call_rep.
         * @memberof net
         * @interface Imsg_group_voice_call_rep
         * @property {number|null} [result] msg_group_voice_call_rep result
         */

        /**
         * Constructs a new msg_group_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_group_voice_call_rep.
         * @implements Imsg_group_voice_call_rep
         * @constructor
         * @param {net.Imsg_group_voice_call_rep=} [properties] Properties to set
         */
        function msg_group_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_group_voice_call_rep
         * @instance
         */
        msg_group_voice_call_rep.prototype.result = 0;

        /**
         * Creates a new msg_group_voice_call_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {net.Imsg_group_voice_call_rep=} [properties] Properties to set
         * @returns {net.msg_group_voice_call_rep} msg_group_voice_call_rep instance
         */
        msg_group_voice_call_rep.create = function create(properties) {
            return new msg_group_voice_call_rep(properties);
        };

        /**
         * Encodes the specified msg_group_voice_call_rep message. Does not implicitly {@link net.msg_group_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {net.Imsg_group_voice_call_rep} message msg_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_group_voice_call_rep message, length delimited. Does not implicitly {@link net.msg_group_voice_call_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {net.Imsg_group_voice_call_rep} message msg_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_voice_call_rep} msg_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_voice_call_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_voice_call_rep} msg_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_voice_call_rep message.
         * @function verify
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_voice_call_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_group_voice_call_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_voice_call_rep} msg_group_voice_call_rep
         */
        msg_group_voice_call_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_voice_call_rep)
                return object;
            var message = new $root.net.msg_group_voice_call_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_group_voice_call_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_voice_call_rep
         * @static
         * @param {net.msg_group_voice_call_rep} message msg_group_voice_call_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_voice_call_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_group_voice_call_rep to JSON.
         * @function toJSON
         * @memberof net.msg_group_voice_call_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_voice_call_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_voice_call_rep;
    })();

    net.msg_join_group_voice_call = (function() {

        /**
         * Properties of a msg_join_group_voice_call.
         * @memberof net
         * @interface Imsg_join_group_voice_call
         * @property {number|null} [groupkey] msg_join_group_voice_call groupkey
         * @property {number|null} [jointype] msg_join_group_voice_call jointype
         */

        /**
         * Constructs a new msg_join_group_voice_call.
         * @memberof net
         * @classdesc Represents a msg_join_group_voice_call.
         * @implements Imsg_join_group_voice_call
         * @constructor
         * @param {net.Imsg_join_group_voice_call=} [properties] Properties to set
         */
        function msg_join_group_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_group_voice_call groupkey.
         * @member {number} groupkey
         * @memberof net.msg_join_group_voice_call
         * @instance
         */
        msg_join_group_voice_call.prototype.groupkey = 0;

        /**
         * msg_join_group_voice_call jointype.
         * @member {number} jointype
         * @memberof net.msg_join_group_voice_call
         * @instance
         */
        msg_join_group_voice_call.prototype.jointype = 0;

        /**
         * Creates a new msg_join_group_voice_call instance using the specified properties.
         * @function create
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {net.Imsg_join_group_voice_call=} [properties] Properties to set
         * @returns {net.msg_join_group_voice_call} msg_join_group_voice_call instance
         */
        msg_join_group_voice_call.create = function create(properties) {
            return new msg_join_group_voice_call(properties);
        };

        /**
         * Encodes the specified msg_join_group_voice_call message. Does not implicitly {@link net.msg_join_group_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {net.Imsg_join_group_voice_call} message msg_join_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_group_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.jointype != null && Object.hasOwnProperty.call(message, "jointype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.jointype);
            return writer;
        };

        /**
         * Encodes the specified msg_join_group_voice_call message, length delimited. Does not implicitly {@link net.msg_join_group_voice_call.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {net.Imsg_join_group_voice_call} message msg_join_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_group_voice_call.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_join_group_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_group_voice_call} msg_join_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_group_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_group_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.jointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_join_group_voice_call message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_join_group_voice_call} msg_join_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_group_voice_call.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_join_group_voice_call message.
         * @function verify
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_join_group_voice_call.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.jointype != null && message.hasOwnProperty("jointype"))
                if (!$util.isInteger(message.jointype))
                    return "jointype: integer expected";
            return null;
        };

        /**
         * Creates a msg_join_group_voice_call message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_join_group_voice_call} msg_join_group_voice_call
         */
        msg_join_group_voice_call.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_join_group_voice_call)
                return object;
            var message = new $root.net.msg_join_group_voice_call();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.jointype != null)
                message.jointype = object.jointype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_join_group_voice_call message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_join_group_voice_call
         * @static
         * @param {net.msg_join_group_voice_call} message msg_join_group_voice_call
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_join_group_voice_call.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.jointype = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.jointype != null && message.hasOwnProperty("jointype"))
                object.jointype = message.jointype;
            return object;
        };

        /**
         * Converts this msg_join_group_voice_call to JSON.
         * @function toJSON
         * @memberof net.msg_join_group_voice_call
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_join_group_voice_call.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_join_group_voice_call;
    })();

    net.msg_join_group_voice_call_rep = (function() {

        /**
         * Properties of a msg_join_group_voice_call_rep.
         * @memberof net
         * @interface Imsg_join_group_voice_call_rep
         * @property {number|null} [result] msg_join_group_voice_call_rep result
         * @property {number|null} [groupkey] msg_join_group_voice_call_rep groupkey
         */

        /**
         * Constructs a new msg_join_group_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_join_group_voice_call_rep.
         * @implements Imsg_join_group_voice_call_rep
         * @constructor
         * @param {net.Imsg_join_group_voice_call_rep=} [properties] Properties to set
         */
        function msg_join_group_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_group_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_join_group_voice_call_rep
         * @instance
         */
        msg_join_group_voice_call_rep.prototype.result = 0;

        /**
         * msg_join_group_voice_call_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_join_group_voice_call_rep
         * @instance
         */
        msg_join_group_voice_call_rep.prototype.groupkey = 0;

        /**
         * Creates a new msg_join_group_voice_call_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {net.Imsg_join_group_voice_call_rep=} [properties] Properties to set
         * @returns {net.msg_join_group_voice_call_rep} msg_join_group_voice_call_rep instance
         */
        msg_join_group_voice_call_rep.create = function create(properties) {
            return new msg_join_group_voice_call_rep(properties);
        };

        /**
         * Encodes the specified msg_join_group_voice_call_rep message. Does not implicitly {@link net.msg_join_group_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {net.Imsg_join_group_voice_call_rep} message msg_join_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_group_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_join_group_voice_call_rep message, length delimited. Does not implicitly {@link net.msg_join_group_voice_call_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {net.Imsg_join_group_voice_call_rep} message msg_join_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_group_voice_call_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_join_group_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_group_voice_call_rep} msg_join_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_group_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_group_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_join_group_voice_call_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_join_group_voice_call_rep} msg_join_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_group_voice_call_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_join_group_voice_call_rep message.
         * @function verify
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_join_group_voice_call_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_join_group_voice_call_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_join_group_voice_call_rep} msg_join_group_voice_call_rep
         */
        msg_join_group_voice_call_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_join_group_voice_call_rep)
                return object;
            var message = new $root.net.msg_join_group_voice_call_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_join_group_voice_call_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_join_group_voice_call_rep
         * @static
         * @param {net.msg_join_group_voice_call_rep} message msg_join_group_voice_call_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_join_group_voice_call_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.groupkey = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_join_group_voice_call_rep to JSON.
         * @function toJSON
         * @memberof net.msg_join_group_voice_call_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_join_group_voice_call_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_join_group_voice_call_rep;
    })();

    net.msg_oper_group_voice_call = (function() {

        /**
         * Properties of a msg_oper_group_voice_call.
         * @memberof net
         * @interface Imsg_oper_group_voice_call
         * @property {number|null} [groupkey] msg_oper_group_voice_call groupkey
         * @property {number|null} [voicestate] msg_oper_group_voice_call voicestate
         * @property {number|null} [videostate] msg_oper_group_voice_call videostate
         */

        /**
         * Constructs a new msg_oper_group_voice_call.
         * @memberof net
         * @classdesc Represents a msg_oper_group_voice_call.
         * @implements Imsg_oper_group_voice_call
         * @constructor
         * @param {net.Imsg_oper_group_voice_call=} [properties] Properties to set
         */
        function msg_oper_group_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_group_voice_call groupkey.
         * @member {number} groupkey
         * @memberof net.msg_oper_group_voice_call
         * @instance
         */
        msg_oper_group_voice_call.prototype.groupkey = 0;

        /**
         * msg_oper_group_voice_call voicestate.
         * @member {number} voicestate
         * @memberof net.msg_oper_group_voice_call
         * @instance
         */
        msg_oper_group_voice_call.prototype.voicestate = 0;

        /**
         * msg_oper_group_voice_call videostate.
         * @member {number} videostate
         * @memberof net.msg_oper_group_voice_call
         * @instance
         */
        msg_oper_group_voice_call.prototype.videostate = 0;

        /**
         * Creates a new msg_oper_group_voice_call instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {net.Imsg_oper_group_voice_call=} [properties] Properties to set
         * @returns {net.msg_oper_group_voice_call} msg_oper_group_voice_call instance
         */
        msg_oper_group_voice_call.create = function create(properties) {
            return new msg_oper_group_voice_call(properties);
        };

        /**
         * Encodes the specified msg_oper_group_voice_call message. Does not implicitly {@link net.msg_oper_group_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {net.Imsg_oper_group_voice_call} message msg_oper_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_group_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.voicestate != null && Object.hasOwnProperty.call(message, "voicestate"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.voicestate);
            if (message.videostate != null && Object.hasOwnProperty.call(message, "videostate"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.videostate);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_group_voice_call message, length delimited. Does not implicitly {@link net.msg_oper_group_voice_call.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {net.Imsg_oper_group_voice_call} message msg_oper_group_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_group_voice_call.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_group_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_group_voice_call} msg_oper_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_group_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_group_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.voicestate = reader.int32();
                    break;
                case 3:
                    message.videostate = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_group_voice_call message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_group_voice_call} msg_oper_group_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_group_voice_call.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_group_voice_call message.
         * @function verify
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_group_voice_call.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                if (!$util.isInteger(message.voicestate))
                    return "voicestate: integer expected";
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                if (!$util.isInteger(message.videostate))
                    return "videostate: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_group_voice_call message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_group_voice_call} msg_oper_group_voice_call
         */
        msg_oper_group_voice_call.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_group_voice_call)
                return object;
            var message = new $root.net.msg_oper_group_voice_call();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.voicestate != null)
                message.voicestate = object.voicestate | 0;
            if (object.videostate != null)
                message.videostate = object.videostate | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_group_voice_call message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_group_voice_call
         * @static
         * @param {net.msg_oper_group_voice_call} message msg_oper_group_voice_call
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_group_voice_call.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.voicestate = 0;
                object.videostate = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                object.voicestate = message.voicestate;
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                object.videostate = message.videostate;
            return object;
        };

        /**
         * Converts this msg_oper_group_voice_call to JSON.
         * @function toJSON
         * @memberof net.msg_oper_group_voice_call
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_group_voice_call.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_group_voice_call;
    })();

    net.msg_oper_group_voice_call_rep = (function() {

        /**
         * Properties of a msg_oper_group_voice_call_rep.
         * @memberof net
         * @interface Imsg_oper_group_voice_call_rep
         * @property {number|null} [groupkey] msg_oper_group_voice_call_rep groupkey
         * @property {number|null} [voicestate] msg_oper_group_voice_call_rep voicestate
         * @property {number|null} [videostate] msg_oper_group_voice_call_rep videostate
         */

        /**
         * Constructs a new msg_oper_group_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_oper_group_voice_call_rep.
         * @implements Imsg_oper_group_voice_call_rep
         * @constructor
         * @param {net.Imsg_oper_group_voice_call_rep=} [properties] Properties to set
         */
        function msg_oper_group_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_group_voice_call_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_oper_group_voice_call_rep
         * @instance
         */
        msg_oper_group_voice_call_rep.prototype.groupkey = 0;

        /**
         * msg_oper_group_voice_call_rep voicestate.
         * @member {number} voicestate
         * @memberof net.msg_oper_group_voice_call_rep
         * @instance
         */
        msg_oper_group_voice_call_rep.prototype.voicestate = 0;

        /**
         * msg_oper_group_voice_call_rep videostate.
         * @member {number} videostate
         * @memberof net.msg_oper_group_voice_call_rep
         * @instance
         */
        msg_oper_group_voice_call_rep.prototype.videostate = 0;

        /**
         * Creates a new msg_oper_group_voice_call_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {net.Imsg_oper_group_voice_call_rep=} [properties] Properties to set
         * @returns {net.msg_oper_group_voice_call_rep} msg_oper_group_voice_call_rep instance
         */
        msg_oper_group_voice_call_rep.create = function create(properties) {
            return new msg_oper_group_voice_call_rep(properties);
        };

        /**
         * Encodes the specified msg_oper_group_voice_call_rep message. Does not implicitly {@link net.msg_oper_group_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {net.Imsg_oper_group_voice_call_rep} message msg_oper_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_group_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.voicestate != null && Object.hasOwnProperty.call(message, "voicestate"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.voicestate);
            if (message.videostate != null && Object.hasOwnProperty.call(message, "videostate"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.videostate);
            return writer;
        };

        /**
         * Encodes the specified msg_oper_group_voice_call_rep message, length delimited. Does not implicitly {@link net.msg_oper_group_voice_call_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {net.Imsg_oper_group_voice_call_rep} message msg_oper_group_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_group_voice_call_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_oper_group_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_group_voice_call_rep} msg_oper_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_group_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_group_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.voicestate = reader.int32();
                    break;
                case 3:
                    message.videostate = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_oper_group_voice_call_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_oper_group_voice_call_rep} msg_oper_group_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_group_voice_call_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_oper_group_voice_call_rep message.
         * @function verify
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_oper_group_voice_call_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                if (!$util.isInteger(message.voicestate))
                    return "voicestate: integer expected";
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                if (!$util.isInteger(message.videostate))
                    return "videostate: integer expected";
            return null;
        };

        /**
         * Creates a msg_oper_group_voice_call_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_oper_group_voice_call_rep} msg_oper_group_voice_call_rep
         */
        msg_oper_group_voice_call_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_oper_group_voice_call_rep)
                return object;
            var message = new $root.net.msg_oper_group_voice_call_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.voicestate != null)
                message.voicestate = object.voicestate | 0;
            if (object.videostate != null)
                message.videostate = object.videostate | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_oper_group_voice_call_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_oper_group_voice_call_rep
         * @static
         * @param {net.msg_oper_group_voice_call_rep} message msg_oper_group_voice_call_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_oper_group_voice_call_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.voicestate = 0;
                object.videostate = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.voicestate != null && message.hasOwnProperty("voicestate"))
                object.voicestate = message.voicestate;
            if (message.videostate != null && message.hasOwnProperty("videostate"))
                object.videostate = message.videostate;
            return object;
        };

        /**
         * Converts this msg_oper_group_voice_call_rep to JSON.
         * @function toJSON
         * @memberof net.msg_oper_group_voice_call_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_oper_group_voice_call_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_oper_group_voice_call_rep;
    })();

    net.msg_set_groupforbid = (function() {

        /**
         * Properties of a msg_set_groupforbid.
         * @memberof net
         * @interface Imsg_set_groupforbid
         * @property {number|null} [groupkey] msg_set_groupforbid groupkey
         * @property {number|null} [is_set] msg_set_groupforbid is_set
         * @property {Array.<number>|null} [forbiduids] msg_set_groupforbid forbiduids
         */

        /**
         * Constructs a new msg_set_groupforbid.
         * @memberof net
         * @classdesc Represents a msg_set_groupforbid.
         * @implements Imsg_set_groupforbid
         * @constructor
         * @param {net.Imsg_set_groupforbid=} [properties] Properties to set
         */
        function msg_set_groupforbid(properties) {
            this.forbiduids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupforbid groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupforbid
         * @instance
         */
        msg_set_groupforbid.prototype.groupkey = 0;

        /**
         * msg_set_groupforbid is_set.
         * @member {number} is_set
         * @memberof net.msg_set_groupforbid
         * @instance
         */
        msg_set_groupforbid.prototype.is_set = 0;

        /**
         * msg_set_groupforbid forbiduids.
         * @member {Array.<number>} forbiduids
         * @memberof net.msg_set_groupforbid
         * @instance
         */
        msg_set_groupforbid.prototype.forbiduids = $util.emptyArray;

        /**
         * Creates a new msg_set_groupforbid instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {net.Imsg_set_groupforbid=} [properties] Properties to set
         * @returns {net.msg_set_groupforbid} msg_set_groupforbid instance
         */
        msg_set_groupforbid.create = function create(properties) {
            return new msg_set_groupforbid(properties);
        };

        /**
         * Encodes the specified msg_set_groupforbid message. Does not implicitly {@link net.msg_set_groupforbid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {net.Imsg_set_groupforbid} message msg_set_groupforbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupforbid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_set);
            if (message.forbiduids != null && message.forbiduids.length)
                for (var i = 0; i < message.forbiduids.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.forbiduids[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupforbid message, length delimited. Does not implicitly {@link net.msg_set_groupforbid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {net.Imsg_set_groupforbid} message msg_set_groupforbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupforbid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupforbid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupforbid} msg_set_groupforbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupforbid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupforbid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.is_set = reader.int32();
                    break;
                case 3:
                    if (!(message.forbiduids && message.forbiduids.length))
                        message.forbiduids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.forbiduids.push(reader.int32());
                    } else
                        message.forbiduids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupforbid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupforbid} msg_set_groupforbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupforbid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupforbid message.
         * @function verify
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupforbid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                if (!$util.isInteger(message.is_set))
                    return "is_set: integer expected";
            if (message.forbiduids != null && message.hasOwnProperty("forbiduids")) {
                if (!Array.isArray(message.forbiduids))
                    return "forbiduids: array expected";
                for (var i = 0; i < message.forbiduids.length; ++i)
                    if (!$util.isInteger(message.forbiduids[i]))
                        return "forbiduids: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_set_groupforbid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupforbid} msg_set_groupforbid
         */
        msg_set_groupforbid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupforbid)
                return object;
            var message = new $root.net.msg_set_groupforbid();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.is_set != null)
                message.is_set = object.is_set | 0;
            if (object.forbiduids) {
                if (!Array.isArray(object.forbiduids))
                    throw TypeError(".net.msg_set_groupforbid.forbiduids: array expected");
                message.forbiduids = [];
                for (var i = 0; i < object.forbiduids.length; ++i)
                    message.forbiduids[i] = object.forbiduids[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupforbid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupforbid
         * @static
         * @param {net.msg_set_groupforbid} message msg_set_groupforbid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupforbid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.forbiduids = [];
            if (options.defaults) {
                object.groupkey = 0;
                object.is_set = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                object.is_set = message.is_set;
            if (message.forbiduids && message.forbiduids.length) {
                object.forbiduids = [];
                for (var j = 0; j < message.forbiduids.length; ++j)
                    object.forbiduids[j] = message.forbiduids[j];
            }
            return object;
        };

        /**
         * Converts this msg_set_groupforbid to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupforbid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupforbid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupforbid;
    })();

    net.msg_set_groupforbid_rep = (function() {

        /**
         * Properties of a msg_set_groupforbid_rep.
         * @memberof net
         * @interface Imsg_set_groupforbid_rep
         * @property {number|null} [result] msg_set_groupforbid_rep result
         */

        /**
         * Constructs a new msg_set_groupforbid_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupforbid_rep.
         * @implements Imsg_set_groupforbid_rep
         * @constructor
         * @param {net.Imsg_set_groupforbid_rep=} [properties] Properties to set
         */
        function msg_set_groupforbid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupforbid_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupforbid_rep
         * @instance
         */
        msg_set_groupforbid_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupforbid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {net.Imsg_set_groupforbid_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupforbid_rep} msg_set_groupforbid_rep instance
         */
        msg_set_groupforbid_rep.create = function create(properties) {
            return new msg_set_groupforbid_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupforbid_rep message. Does not implicitly {@link net.msg_set_groupforbid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {net.Imsg_set_groupforbid_rep} message msg_set_groupforbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupforbid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupforbid_rep message, length delimited. Does not implicitly {@link net.msg_set_groupforbid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {net.Imsg_set_groupforbid_rep} message msg_set_groupforbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupforbid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupforbid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupforbid_rep} msg_set_groupforbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupforbid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupforbid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupforbid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupforbid_rep} msg_set_groupforbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupforbid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupforbid_rep message.
         * @function verify
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupforbid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupforbid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupforbid_rep} msg_set_groupforbid_rep
         */
        msg_set_groupforbid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupforbid_rep)
                return object;
            var message = new $root.net.msg_set_groupforbid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupforbid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupforbid_rep
         * @static
         * @param {net.msg_set_groupforbid_rep} message msg_set_groupforbid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupforbid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupforbid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupforbid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupforbid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupforbid_rep;
    })();

    net.msg_get_groupforbid_list = (function() {

        /**
         * Properties of a msg_get_groupforbid_list.
         * @memberof net
         * @interface Imsg_get_groupforbid_list
         * @property {number|null} [groupkey] msg_get_groupforbid_list groupkey
         */

        /**
         * Constructs a new msg_get_groupforbid_list.
         * @memberof net
         * @classdesc Represents a msg_get_groupforbid_list.
         * @implements Imsg_get_groupforbid_list
         * @constructor
         * @param {net.Imsg_get_groupforbid_list=} [properties] Properties to set
         */
        function msg_get_groupforbid_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_groupforbid_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_groupforbid_list
         * @instance
         */
        msg_get_groupforbid_list.prototype.groupkey = 0;

        /**
         * Creates a new msg_get_groupforbid_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {net.Imsg_get_groupforbid_list=} [properties] Properties to set
         * @returns {net.msg_get_groupforbid_list} msg_get_groupforbid_list instance
         */
        msg_get_groupforbid_list.create = function create(properties) {
            return new msg_get_groupforbid_list(properties);
        };

        /**
         * Encodes the specified msg_get_groupforbid_list message. Does not implicitly {@link net.msg_get_groupforbid_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {net.Imsg_get_groupforbid_list} message msg_get_groupforbid_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupforbid_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_groupforbid_list message, length delimited. Does not implicitly {@link net.msg_get_groupforbid_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {net.Imsg_get_groupforbid_list} message msg_get_groupforbid_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupforbid_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_groupforbid_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_groupforbid_list} msg_get_groupforbid_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupforbid_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_groupforbid_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_groupforbid_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_groupforbid_list} msg_get_groupforbid_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupforbid_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_groupforbid_list message.
         * @function verify
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_groupforbid_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_groupforbid_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_groupforbid_list} msg_get_groupforbid_list
         */
        msg_get_groupforbid_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_groupforbid_list)
                return object;
            var message = new $root.net.msg_get_groupforbid_list();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_groupforbid_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_groupforbid_list
         * @static
         * @param {net.msg_get_groupforbid_list} message msg_get_groupforbid_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_groupforbid_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_get_groupforbid_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_groupforbid_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_groupforbid_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_groupforbid_list;
    })();

    net.msg_get_groupforbid_list_rep = (function() {

        /**
         * Properties of a msg_get_groupforbid_list_rep.
         * @memberof net
         * @interface Imsg_get_groupforbid_list_rep
         * @property {number|null} [groupkey] msg_get_groupforbid_list_rep groupkey
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_groupforbid_list_rep users
         */

        /**
         * Constructs a new msg_get_groupforbid_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_groupforbid_list_rep.
         * @implements Imsg_get_groupforbid_list_rep
         * @constructor
         * @param {net.Imsg_get_groupforbid_list_rep=} [properties] Properties to set
         */
        function msg_get_groupforbid_list_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_groupforbid_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_groupforbid_list_rep
         * @instance
         */
        msg_get_groupforbid_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_groupforbid_list_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_groupforbid_list_rep
         * @instance
         */
        msg_get_groupforbid_list_rep.prototype.users = $util.emptyArray;

        /**
         * Creates a new msg_get_groupforbid_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {net.Imsg_get_groupforbid_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_groupforbid_list_rep} msg_get_groupforbid_list_rep instance
         */
        msg_get_groupforbid_list_rep.create = function create(properties) {
            return new msg_get_groupforbid_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_groupforbid_list_rep message. Does not implicitly {@link net.msg_get_groupforbid_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {net.Imsg_get_groupforbid_list_rep} message msg_get_groupforbid_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupforbid_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_groupforbid_list_rep message, length delimited. Does not implicitly {@link net.msg_get_groupforbid_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {net.Imsg_get_groupforbid_list_rep} message msg_get_groupforbid_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupforbid_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_groupforbid_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_groupforbid_list_rep} msg_get_groupforbid_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupforbid_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_groupforbid_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_groupforbid_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_groupforbid_list_rep} msg_get_groupforbid_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupforbid_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_groupforbid_list_rep message.
         * @function verify
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_groupforbid_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_groupforbid_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_groupforbid_list_rep} msg_get_groupforbid_list_rep
         */
        msg_get_groupforbid_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_groupforbid_list_rep)
                return object;
            var message = new $root.net.msg_get_groupforbid_list_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_groupforbid_list_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_groupforbid_list_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_groupforbid_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_groupforbid_list_rep
         * @static
         * @param {net.msg_get_groupforbid_list_rep} message msg_get_groupforbid_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_groupforbid_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_groupforbid_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_groupforbid_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_groupforbid_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_groupforbid_list_rep;
    })();

    net.msg_set_groupwhite = (function() {

        /**
         * Properties of a msg_set_groupwhite.
         * @memberof net
         * @interface Imsg_set_groupwhite
         * @property {number|null} [groupkey] msg_set_groupwhite groupkey
         * @property {number|null} [is_set] msg_set_groupwhite is_set
         * @property {Array.<number>|null} [whiteuids] msg_set_groupwhite whiteuids
         */

        /**
         * Constructs a new msg_set_groupwhite.
         * @memberof net
         * @classdesc Represents a msg_set_groupwhite.
         * @implements Imsg_set_groupwhite
         * @constructor
         * @param {net.Imsg_set_groupwhite=} [properties] Properties to set
         */
        function msg_set_groupwhite(properties) {
            this.whiteuids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupwhite groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupwhite
         * @instance
         */
        msg_set_groupwhite.prototype.groupkey = 0;

        /**
         * msg_set_groupwhite is_set.
         * @member {number} is_set
         * @memberof net.msg_set_groupwhite
         * @instance
         */
        msg_set_groupwhite.prototype.is_set = 0;

        /**
         * msg_set_groupwhite whiteuids.
         * @member {Array.<number>} whiteuids
         * @memberof net.msg_set_groupwhite
         * @instance
         */
        msg_set_groupwhite.prototype.whiteuids = $util.emptyArray;

        /**
         * Creates a new msg_set_groupwhite instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {net.Imsg_set_groupwhite=} [properties] Properties to set
         * @returns {net.msg_set_groupwhite} msg_set_groupwhite instance
         */
        msg_set_groupwhite.create = function create(properties) {
            return new msg_set_groupwhite(properties);
        };

        /**
         * Encodes the specified msg_set_groupwhite message. Does not implicitly {@link net.msg_set_groupwhite.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {net.Imsg_set_groupwhite} message msg_set_groupwhite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupwhite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_set);
            if (message.whiteuids != null && message.whiteuids.length)
                for (var i = 0; i < message.whiteuids.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.whiteuids[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupwhite message, length delimited. Does not implicitly {@link net.msg_set_groupwhite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {net.Imsg_set_groupwhite} message msg_set_groupwhite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupwhite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupwhite message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupwhite} msg_set_groupwhite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupwhite.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupwhite();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.is_set = reader.int32();
                    break;
                case 3:
                    if (!(message.whiteuids && message.whiteuids.length))
                        message.whiteuids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.whiteuids.push(reader.int32());
                    } else
                        message.whiteuids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupwhite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupwhite} msg_set_groupwhite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupwhite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupwhite message.
         * @function verify
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupwhite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                if (!$util.isInteger(message.is_set))
                    return "is_set: integer expected";
            if (message.whiteuids != null && message.hasOwnProperty("whiteuids")) {
                if (!Array.isArray(message.whiteuids))
                    return "whiteuids: array expected";
                for (var i = 0; i < message.whiteuids.length; ++i)
                    if (!$util.isInteger(message.whiteuids[i]))
                        return "whiteuids: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_set_groupwhite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupwhite} msg_set_groupwhite
         */
        msg_set_groupwhite.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupwhite)
                return object;
            var message = new $root.net.msg_set_groupwhite();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.is_set != null)
                message.is_set = object.is_set | 0;
            if (object.whiteuids) {
                if (!Array.isArray(object.whiteuids))
                    throw TypeError(".net.msg_set_groupwhite.whiteuids: array expected");
                message.whiteuids = [];
                for (var i = 0; i < object.whiteuids.length; ++i)
                    message.whiteuids[i] = object.whiteuids[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupwhite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupwhite
         * @static
         * @param {net.msg_set_groupwhite} message msg_set_groupwhite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupwhite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.whiteuids = [];
            if (options.defaults) {
                object.groupkey = 0;
                object.is_set = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                object.is_set = message.is_set;
            if (message.whiteuids && message.whiteuids.length) {
                object.whiteuids = [];
                for (var j = 0; j < message.whiteuids.length; ++j)
                    object.whiteuids[j] = message.whiteuids[j];
            }
            return object;
        };

        /**
         * Converts this msg_set_groupwhite to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupwhite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupwhite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupwhite;
    })();

    net.msg_set_groupwhite_rep = (function() {

        /**
         * Properties of a msg_set_groupwhite_rep.
         * @memberof net
         * @interface Imsg_set_groupwhite_rep
         * @property {number|null} [result] msg_set_groupwhite_rep result
         */

        /**
         * Constructs a new msg_set_groupwhite_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupwhite_rep.
         * @implements Imsg_set_groupwhite_rep
         * @constructor
         * @param {net.Imsg_set_groupwhite_rep=} [properties] Properties to set
         */
        function msg_set_groupwhite_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupwhite_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupwhite_rep
         * @instance
         */
        msg_set_groupwhite_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_groupwhite_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {net.Imsg_set_groupwhite_rep=} [properties] Properties to set
         * @returns {net.msg_set_groupwhite_rep} msg_set_groupwhite_rep instance
         */
        msg_set_groupwhite_rep.create = function create(properties) {
            return new msg_set_groupwhite_rep(properties);
        };

        /**
         * Encodes the specified msg_set_groupwhite_rep message. Does not implicitly {@link net.msg_set_groupwhite_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {net.Imsg_set_groupwhite_rep} message msg_set_groupwhite_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupwhite_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_groupwhite_rep message, length delimited. Does not implicitly {@link net.msg_set_groupwhite_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {net.Imsg_set_groupwhite_rep} message msg_set_groupwhite_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupwhite_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_groupwhite_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupwhite_rep} msg_set_groupwhite_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupwhite_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupwhite_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_groupwhite_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_groupwhite_rep} msg_set_groupwhite_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupwhite_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_groupwhite_rep message.
         * @function verify
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_groupwhite_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_groupwhite_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_groupwhite_rep} msg_set_groupwhite_rep
         */
        msg_set_groupwhite_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_groupwhite_rep)
                return object;
            var message = new $root.net.msg_set_groupwhite_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_groupwhite_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_groupwhite_rep
         * @static
         * @param {net.msg_set_groupwhite_rep} message msg_set_groupwhite_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_groupwhite_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_groupwhite_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_groupwhite_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_groupwhite_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_groupwhite_rep;
    })();

    net.msg_get_groupwhite_list = (function() {

        /**
         * Properties of a msg_get_groupwhite_list.
         * @memberof net
         * @interface Imsg_get_groupwhite_list
         * @property {number|null} [groupkey] msg_get_groupwhite_list groupkey
         */

        /**
         * Constructs a new msg_get_groupwhite_list.
         * @memberof net
         * @classdesc Represents a msg_get_groupwhite_list.
         * @implements Imsg_get_groupwhite_list
         * @constructor
         * @param {net.Imsg_get_groupwhite_list=} [properties] Properties to set
         */
        function msg_get_groupwhite_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_groupwhite_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_groupwhite_list
         * @instance
         */
        msg_get_groupwhite_list.prototype.groupkey = 0;

        /**
         * Creates a new msg_get_groupwhite_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {net.Imsg_get_groupwhite_list=} [properties] Properties to set
         * @returns {net.msg_get_groupwhite_list} msg_get_groupwhite_list instance
         */
        msg_get_groupwhite_list.create = function create(properties) {
            return new msg_get_groupwhite_list(properties);
        };

        /**
         * Encodes the specified msg_get_groupwhite_list message. Does not implicitly {@link net.msg_get_groupwhite_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {net.Imsg_get_groupwhite_list} message msg_get_groupwhite_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupwhite_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_groupwhite_list message, length delimited. Does not implicitly {@link net.msg_get_groupwhite_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {net.Imsg_get_groupwhite_list} message msg_get_groupwhite_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupwhite_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_groupwhite_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_groupwhite_list} msg_get_groupwhite_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupwhite_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_groupwhite_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_groupwhite_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_groupwhite_list} msg_get_groupwhite_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupwhite_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_groupwhite_list message.
         * @function verify
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_groupwhite_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_groupwhite_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_groupwhite_list} msg_get_groupwhite_list
         */
        msg_get_groupwhite_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_groupwhite_list)
                return object;
            var message = new $root.net.msg_get_groupwhite_list();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_groupwhite_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_groupwhite_list
         * @static
         * @param {net.msg_get_groupwhite_list} message msg_get_groupwhite_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_groupwhite_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_get_groupwhite_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_groupwhite_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_groupwhite_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_groupwhite_list;
    })();

    net.msg_get_groupwhite_list_rep = (function() {

        /**
         * Properties of a msg_get_groupwhite_list_rep.
         * @memberof net
         * @interface Imsg_get_groupwhite_list_rep
         * @property {number|null} [groupkey] msg_get_groupwhite_list_rep groupkey
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_groupwhite_list_rep users
         */

        /**
         * Constructs a new msg_get_groupwhite_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_groupwhite_list_rep.
         * @implements Imsg_get_groupwhite_list_rep
         * @constructor
         * @param {net.Imsg_get_groupwhite_list_rep=} [properties] Properties to set
         */
        function msg_get_groupwhite_list_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_groupwhite_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_groupwhite_list_rep
         * @instance
         */
        msg_get_groupwhite_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_groupwhite_list_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_groupwhite_list_rep
         * @instance
         */
        msg_get_groupwhite_list_rep.prototype.users = $util.emptyArray;

        /**
         * Creates a new msg_get_groupwhite_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {net.Imsg_get_groupwhite_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_groupwhite_list_rep} msg_get_groupwhite_list_rep instance
         */
        msg_get_groupwhite_list_rep.create = function create(properties) {
            return new msg_get_groupwhite_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_groupwhite_list_rep message. Does not implicitly {@link net.msg_get_groupwhite_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {net.Imsg_get_groupwhite_list_rep} message msg_get_groupwhite_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupwhite_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_groupwhite_list_rep message, length delimited. Does not implicitly {@link net.msg_get_groupwhite_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {net.Imsg_get_groupwhite_list_rep} message msg_get_groupwhite_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_groupwhite_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_groupwhite_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_groupwhite_list_rep} msg_get_groupwhite_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupwhite_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_groupwhite_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_groupwhite_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_groupwhite_list_rep} msg_get_groupwhite_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_groupwhite_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_groupwhite_list_rep message.
         * @function verify
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_groupwhite_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_groupwhite_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_groupwhite_list_rep} msg_get_groupwhite_list_rep
         */
        msg_get_groupwhite_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_groupwhite_list_rep)
                return object;
            var message = new $root.net.msg_get_groupwhite_list_rep();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_groupwhite_list_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_groupwhite_list_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_groupwhite_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_groupwhite_list_rep
         * @static
         * @param {net.msg_get_groupwhite_list_rep} message msg_get_groupwhite_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_groupwhite_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_groupwhite_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_groupwhite_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_groupwhite_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_groupwhite_list_rep;
    })();

    net.msg_set_bty_register = (function() {

        /**
         * Properties of a msg_set_bty_register.
         * @memberof net
         * @interface Imsg_set_bty_register
         * @property {number|null} [setuid] msg_set_bty_register setuid
         */

        /**
         * Constructs a new msg_set_bty_register.
         * @memberof net
         * @classdesc Represents a msg_set_bty_register.
         * @implements Imsg_set_bty_register
         * @constructor
         * @param {net.Imsg_set_bty_register=} [properties] Properties to set
         */
        function msg_set_bty_register(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_bty_register setuid.
         * @member {number} setuid
         * @memberof net.msg_set_bty_register
         * @instance
         */
        msg_set_bty_register.prototype.setuid = 0;

        /**
         * Creates a new msg_set_bty_register instance using the specified properties.
         * @function create
         * @memberof net.msg_set_bty_register
         * @static
         * @param {net.Imsg_set_bty_register=} [properties] Properties to set
         * @returns {net.msg_set_bty_register} msg_set_bty_register instance
         */
        msg_set_bty_register.create = function create(properties) {
            return new msg_set_bty_register(properties);
        };

        /**
         * Encodes the specified msg_set_bty_register message. Does not implicitly {@link net.msg_set_bty_register.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_bty_register
         * @static
         * @param {net.Imsg_set_bty_register} message msg_set_bty_register message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_register.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.setuid != null && Object.hasOwnProperty.call(message, "setuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.setuid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_bty_register message, length delimited. Does not implicitly {@link net.msg_set_bty_register.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_bty_register
         * @static
         * @param {net.Imsg_set_bty_register} message msg_set_bty_register message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_register.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_bty_register message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_bty_register
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_bty_register} msg_set_bty_register
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_register.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_bty_register();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.setuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_bty_register message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_bty_register
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_bty_register} msg_set_bty_register
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_register.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_bty_register message.
         * @function verify
         * @memberof net.msg_set_bty_register
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_bty_register.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.setuid != null && message.hasOwnProperty("setuid"))
                if (!$util.isInteger(message.setuid))
                    return "setuid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_bty_register message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_bty_register
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_bty_register} msg_set_bty_register
         */
        msg_set_bty_register.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_bty_register)
                return object;
            var message = new $root.net.msg_set_bty_register();
            if (object.setuid != null)
                message.setuid = object.setuid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_bty_register message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_bty_register
         * @static
         * @param {net.msg_set_bty_register} message msg_set_bty_register
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_bty_register.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.setuid = 0;
            if (message.setuid != null && message.hasOwnProperty("setuid"))
                object.setuid = message.setuid;
            return object;
        };

        /**
         * Converts this msg_set_bty_register to JSON.
         * @function toJSON
         * @memberof net.msg_set_bty_register
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_bty_register.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_bty_register;
    })();

    net.msg_set_bty_register_rep = (function() {

        /**
         * Properties of a msg_set_bty_register_rep.
         * @memberof net
         * @interface Imsg_set_bty_register_rep
         * @property {number|null} [result] msg_set_bty_register_rep result
         */

        /**
         * Constructs a new msg_set_bty_register_rep.
         * @memberof net
         * @classdesc Represents a msg_set_bty_register_rep.
         * @implements Imsg_set_bty_register_rep
         * @constructor
         * @param {net.Imsg_set_bty_register_rep=} [properties] Properties to set
         */
        function msg_set_bty_register_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_bty_register_rep result.
         * @member {number} result
         * @memberof net.msg_set_bty_register_rep
         * @instance
         */
        msg_set_bty_register_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_bty_register_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {net.Imsg_set_bty_register_rep=} [properties] Properties to set
         * @returns {net.msg_set_bty_register_rep} msg_set_bty_register_rep instance
         */
        msg_set_bty_register_rep.create = function create(properties) {
            return new msg_set_bty_register_rep(properties);
        };

        /**
         * Encodes the specified msg_set_bty_register_rep message. Does not implicitly {@link net.msg_set_bty_register_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {net.Imsg_set_bty_register_rep} message msg_set_bty_register_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_register_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_bty_register_rep message, length delimited. Does not implicitly {@link net.msg_set_bty_register_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {net.Imsg_set_bty_register_rep} message msg_set_bty_register_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_register_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_bty_register_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_bty_register_rep} msg_set_bty_register_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_register_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_bty_register_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_bty_register_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_bty_register_rep} msg_set_bty_register_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_register_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_bty_register_rep message.
         * @function verify
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_bty_register_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_bty_register_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_bty_register_rep} msg_set_bty_register_rep
         */
        msg_set_bty_register_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_bty_register_rep)
                return object;
            var message = new $root.net.msg_set_bty_register_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_bty_register_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_bty_register_rep
         * @static
         * @param {net.msg_set_bty_register_rep} message msg_set_bty_register_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_bty_register_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_bty_register_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_bty_register_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_bty_register_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_bty_register_rep;
    })();

    net.msg_set_bty_topup = (function() {

        /**
         * Properties of a msg_set_bty_topup.
         * @memberof net
         * @interface Imsg_set_bty_topup
         * @property {number|null} [setuid] msg_set_bty_topup setuid
         */

        /**
         * Constructs a new msg_set_bty_topup.
         * @memberof net
         * @classdesc Represents a msg_set_bty_topup.
         * @implements Imsg_set_bty_topup
         * @constructor
         * @param {net.Imsg_set_bty_topup=} [properties] Properties to set
         */
        function msg_set_bty_topup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_bty_topup setuid.
         * @member {number} setuid
         * @memberof net.msg_set_bty_topup
         * @instance
         */
        msg_set_bty_topup.prototype.setuid = 0;

        /**
         * Creates a new msg_set_bty_topup instance using the specified properties.
         * @function create
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {net.Imsg_set_bty_topup=} [properties] Properties to set
         * @returns {net.msg_set_bty_topup} msg_set_bty_topup instance
         */
        msg_set_bty_topup.create = function create(properties) {
            return new msg_set_bty_topup(properties);
        };

        /**
         * Encodes the specified msg_set_bty_topup message. Does not implicitly {@link net.msg_set_bty_topup.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {net.Imsg_set_bty_topup} message msg_set_bty_topup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_topup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.setuid != null && Object.hasOwnProperty.call(message, "setuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.setuid);
            return writer;
        };

        /**
         * Encodes the specified msg_set_bty_topup message, length delimited. Does not implicitly {@link net.msg_set_bty_topup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {net.Imsg_set_bty_topup} message msg_set_bty_topup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_topup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_bty_topup message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_bty_topup} msg_set_bty_topup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_topup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_bty_topup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.setuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_bty_topup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_bty_topup} msg_set_bty_topup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_topup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_bty_topup message.
         * @function verify
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_bty_topup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.setuid != null && message.hasOwnProperty("setuid"))
                if (!$util.isInteger(message.setuid))
                    return "setuid: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_bty_topup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_bty_topup} msg_set_bty_topup
         */
        msg_set_bty_topup.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_bty_topup)
                return object;
            var message = new $root.net.msg_set_bty_topup();
            if (object.setuid != null)
                message.setuid = object.setuid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_bty_topup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_bty_topup
         * @static
         * @param {net.msg_set_bty_topup} message msg_set_bty_topup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_bty_topup.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.setuid = 0;
            if (message.setuid != null && message.hasOwnProperty("setuid"))
                object.setuid = message.setuid;
            return object;
        };

        /**
         * Converts this msg_set_bty_topup to JSON.
         * @function toJSON
         * @memberof net.msg_set_bty_topup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_bty_topup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_bty_topup;
    })();

    net.msg_set_bty_topup_rep = (function() {

        /**
         * Properties of a msg_set_bty_topup_rep.
         * @memberof net
         * @interface Imsg_set_bty_topup_rep
         * @property {number|null} [result] msg_set_bty_topup_rep result
         */

        /**
         * Constructs a new msg_set_bty_topup_rep.
         * @memberof net
         * @classdesc Represents a msg_set_bty_topup_rep.
         * @implements Imsg_set_bty_topup_rep
         * @constructor
         * @param {net.Imsg_set_bty_topup_rep=} [properties] Properties to set
         */
        function msg_set_bty_topup_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_bty_topup_rep result.
         * @member {number} result
         * @memberof net.msg_set_bty_topup_rep
         * @instance
         */
        msg_set_bty_topup_rep.prototype.result = 0;

        /**
         * Creates a new msg_set_bty_topup_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {net.Imsg_set_bty_topup_rep=} [properties] Properties to set
         * @returns {net.msg_set_bty_topup_rep} msg_set_bty_topup_rep instance
         */
        msg_set_bty_topup_rep.create = function create(properties) {
            return new msg_set_bty_topup_rep(properties);
        };

        /**
         * Encodes the specified msg_set_bty_topup_rep message. Does not implicitly {@link net.msg_set_bty_topup_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {net.Imsg_set_bty_topup_rep} message msg_set_bty_topup_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_topup_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_set_bty_topup_rep message, length delimited. Does not implicitly {@link net.msg_set_bty_topup_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {net.Imsg_set_bty_topup_rep} message msg_set_bty_topup_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_bty_topup_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_set_bty_topup_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_bty_topup_rep} msg_set_bty_topup_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_topup_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_bty_topup_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_set_bty_topup_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_set_bty_topup_rep} msg_set_bty_topup_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_bty_topup_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_set_bty_topup_rep message.
         * @function verify
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_set_bty_topup_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_set_bty_topup_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_set_bty_topup_rep} msg_set_bty_topup_rep
         */
        msg_set_bty_topup_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_set_bty_topup_rep)
                return object;
            var message = new $root.net.msg_set_bty_topup_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_set_bty_topup_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_set_bty_topup_rep
         * @static
         * @param {net.msg_set_bty_topup_rep} message msg_set_bty_topup_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_set_bty_topup_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_set_bty_topup_rep to JSON.
         * @function toJSON
         * @memberof net.msg_set_bty_topup_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_set_bty_topup_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_set_bty_topup_rep;
    })();

    net.msg_get_forbidmsg_list = (function() {

        /**
         * Properties of a msg_get_forbidmsg_list.
         * @memberof net
         * @interface Imsg_get_forbidmsg_list
         */

        /**
         * Constructs a new msg_get_forbidmsg_list.
         * @memberof net
         * @classdesc Represents a msg_get_forbidmsg_list.
         * @implements Imsg_get_forbidmsg_list
         * @constructor
         * @param {net.Imsg_get_forbidmsg_list=} [properties] Properties to set
         */
        function msg_get_forbidmsg_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_forbidmsg_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {net.Imsg_get_forbidmsg_list=} [properties] Properties to set
         * @returns {net.msg_get_forbidmsg_list} msg_get_forbidmsg_list instance
         */
        msg_get_forbidmsg_list.create = function create(properties) {
            return new msg_get_forbidmsg_list(properties);
        };

        /**
         * Encodes the specified msg_get_forbidmsg_list message. Does not implicitly {@link net.msg_get_forbidmsg_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {net.Imsg_get_forbidmsg_list} message msg_get_forbidmsg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbidmsg_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_forbidmsg_list message, length delimited. Does not implicitly {@link net.msg_get_forbidmsg_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {net.Imsg_get_forbidmsg_list} message msg_get_forbidmsg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbidmsg_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_forbidmsg_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_forbidmsg_list} msg_get_forbidmsg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbidmsg_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_forbidmsg_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_forbidmsg_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_forbidmsg_list} msg_get_forbidmsg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbidmsg_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_forbidmsg_list message.
         * @function verify
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_forbidmsg_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_forbidmsg_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_forbidmsg_list} msg_get_forbidmsg_list
         */
        msg_get_forbidmsg_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_forbidmsg_list)
                return object;
            return new $root.net.msg_get_forbidmsg_list();
        };

        /**
         * Creates a plain object from a msg_get_forbidmsg_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_forbidmsg_list
         * @static
         * @param {net.msg_get_forbidmsg_list} message msg_get_forbidmsg_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_forbidmsg_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_forbidmsg_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_forbidmsg_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_forbidmsg_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_forbidmsg_list;
    })();

    net.msg_get_forbidmsg_list_rep = (function() {

        /**
         * Properties of a msg_get_forbidmsg_list_rep.
         * @memberof net
         * @interface Imsg_get_forbidmsg_list_rep
         * @property {Array.<Uint8Array>|null} [forbidlist] msg_get_forbidmsg_list_rep forbidlist
         */

        /**
         * Constructs a new msg_get_forbidmsg_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_forbidmsg_list_rep.
         * @implements Imsg_get_forbidmsg_list_rep
         * @constructor
         * @param {net.Imsg_get_forbidmsg_list_rep=} [properties] Properties to set
         */
        function msg_get_forbidmsg_list_rep(properties) {
            this.forbidlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_forbidmsg_list_rep forbidlist.
         * @member {Array.<Uint8Array>} forbidlist
         * @memberof net.msg_get_forbidmsg_list_rep
         * @instance
         */
        msg_get_forbidmsg_list_rep.prototype.forbidlist = $util.emptyArray;

        /**
         * Creates a new msg_get_forbidmsg_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_get_forbidmsg_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_forbidmsg_list_rep} msg_get_forbidmsg_list_rep instance
         */
        msg_get_forbidmsg_list_rep.create = function create(properties) {
            return new msg_get_forbidmsg_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_forbidmsg_list_rep message. Does not implicitly {@link net.msg_get_forbidmsg_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_get_forbidmsg_list_rep} message msg_get_forbidmsg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbidmsg_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.forbidlist != null && message.forbidlist.length)
                for (var i = 0; i < message.forbidlist.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.forbidlist[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_get_forbidmsg_list_rep message, length delimited. Does not implicitly {@link net.msg_get_forbidmsg_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_get_forbidmsg_list_rep} message msg_get_forbidmsg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbidmsg_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_forbidmsg_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_forbidmsg_list_rep} msg_get_forbidmsg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbidmsg_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_forbidmsg_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.forbidlist && message.forbidlist.length))
                        message.forbidlist = [];
                    message.forbidlist.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_forbidmsg_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_forbidmsg_list_rep} msg_get_forbidmsg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbidmsg_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_forbidmsg_list_rep message.
         * @function verify
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_forbidmsg_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.forbidlist != null && message.hasOwnProperty("forbidlist")) {
                if (!Array.isArray(message.forbidlist))
                    return "forbidlist: array expected";
                for (var i = 0; i < message.forbidlist.length; ++i)
                    if (!(message.forbidlist[i] && typeof message.forbidlist[i].length === "number" || $util.isString(message.forbidlist[i])))
                        return "forbidlist: buffer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_get_forbidmsg_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_forbidmsg_list_rep} msg_get_forbidmsg_list_rep
         */
        msg_get_forbidmsg_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_forbidmsg_list_rep)
                return object;
            var message = new $root.net.msg_get_forbidmsg_list_rep();
            if (object.forbidlist) {
                if (!Array.isArray(object.forbidlist))
                    throw TypeError(".net.msg_get_forbidmsg_list_rep.forbidlist: array expected");
                message.forbidlist = [];
                for (var i = 0; i < object.forbidlist.length; ++i)
                    if (typeof object.forbidlist[i] === "string")
                        $util.base64.decode(object.forbidlist[i], message.forbidlist[i] = $util.newBuffer($util.base64.length(object.forbidlist[i])), 0);
                    else if (object.forbidlist[i].length)
                        message.forbidlist[i] = object.forbidlist[i];
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_forbidmsg_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_forbidmsg_list_rep
         * @static
         * @param {net.msg_get_forbidmsg_list_rep} message msg_get_forbidmsg_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_forbidmsg_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.forbidlist = [];
            if (message.forbidlist && message.forbidlist.length) {
                object.forbidlist = [];
                for (var j = 0; j < message.forbidlist.length; ++j)
                    object.forbidlist[j] = options.bytes === String ? $util.base64.encode(message.forbidlist[j], 0, message.forbidlist[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.forbidlist[j]) : message.forbidlist[j];
            }
            return object;
        };

        /**
         * Converts this msg_get_forbidmsg_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_forbidmsg_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_forbidmsg_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_forbidmsg_list_rep;
    })();

    net.msg_modify_forbidmsg_list = (function() {

        /**
         * Properties of a msg_modify_forbidmsg_list.
         * @memberof net
         * @interface Imsg_modify_forbidmsg_list
         * @property {Uint8Array|null} [content] msg_modify_forbidmsg_list content
         * @property {number|null} [optype] msg_modify_forbidmsg_list optype
         */

        /**
         * Constructs a new msg_modify_forbidmsg_list.
         * @memberof net
         * @classdesc Represents a msg_modify_forbidmsg_list.
         * @implements Imsg_modify_forbidmsg_list
         * @constructor
         * @param {net.Imsg_modify_forbidmsg_list=} [properties] Properties to set
         */
        function msg_modify_forbidmsg_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_forbidmsg_list content.
         * @member {Uint8Array} content
         * @memberof net.msg_modify_forbidmsg_list
         * @instance
         */
        msg_modify_forbidmsg_list.prototype.content = $util.newBuffer([]);

        /**
         * msg_modify_forbidmsg_list optype.
         * @member {number} optype
         * @memberof net.msg_modify_forbidmsg_list
         * @instance
         */
        msg_modify_forbidmsg_list.prototype.optype = 0;

        /**
         * Creates a new msg_modify_forbidmsg_list instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {net.Imsg_modify_forbidmsg_list=} [properties] Properties to set
         * @returns {net.msg_modify_forbidmsg_list} msg_modify_forbidmsg_list instance
         */
        msg_modify_forbidmsg_list.create = function create(properties) {
            return new msg_modify_forbidmsg_list(properties);
        };

        /**
         * Encodes the specified msg_modify_forbidmsg_list message. Does not implicitly {@link net.msg_modify_forbidmsg_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {net.Imsg_modify_forbidmsg_list} message msg_modify_forbidmsg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_forbidmsg_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
            if (message.optype != null && Object.hasOwnProperty.call(message, "optype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.optype);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_forbidmsg_list message, length delimited. Does not implicitly {@link net.msg_modify_forbidmsg_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {net.Imsg_modify_forbidmsg_list} message msg_modify_forbidmsg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_forbidmsg_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_forbidmsg_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_forbidmsg_list} msg_modify_forbidmsg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_forbidmsg_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_forbidmsg_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.content = reader.bytes();
                    break;
                case 2:
                    message.optype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_forbidmsg_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_forbidmsg_list} msg_modify_forbidmsg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_forbidmsg_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_forbidmsg_list message.
         * @function verify
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_forbidmsg_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.optype != null && message.hasOwnProperty("optype"))
                if (!$util.isInteger(message.optype))
                    return "optype: integer expected";
            return null;
        };

        /**
         * Creates a msg_modify_forbidmsg_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_forbidmsg_list} msg_modify_forbidmsg_list
         */
        msg_modify_forbidmsg_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_forbidmsg_list)
                return object;
            var message = new $root.net.msg_modify_forbidmsg_list();
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.optype != null)
                message.optype = object.optype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_forbidmsg_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_forbidmsg_list
         * @static
         * @param {net.msg_modify_forbidmsg_list} message msg_modify_forbidmsg_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_forbidmsg_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                object.optype = 0;
            }
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.optype != null && message.hasOwnProperty("optype"))
                object.optype = message.optype;
            return object;
        };

        /**
         * Converts this msg_modify_forbidmsg_list to JSON.
         * @function toJSON
         * @memberof net.msg_modify_forbidmsg_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_forbidmsg_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_forbidmsg_list;
    })();

    net.msg_modify_forbidmsg_list_rep = (function() {

        /**
         * Properties of a msg_modify_forbidmsg_list_rep.
         * @memberof net
         * @interface Imsg_modify_forbidmsg_list_rep
         * @property {number|null} [result] msg_modify_forbidmsg_list_rep result
         * @property {Uint8Array|null} [content] msg_modify_forbidmsg_list_rep content
         * @property {number|null} [optype] msg_modify_forbidmsg_list_rep optype
         */

        /**
         * Constructs a new msg_modify_forbidmsg_list_rep.
         * @memberof net
         * @classdesc Represents a msg_modify_forbidmsg_list_rep.
         * @implements Imsg_modify_forbidmsg_list_rep
         * @constructor
         * @param {net.Imsg_modify_forbidmsg_list_rep=} [properties] Properties to set
         */
        function msg_modify_forbidmsg_list_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_forbidmsg_list_rep result.
         * @member {number} result
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @instance
         */
        msg_modify_forbidmsg_list_rep.prototype.result = 0;

        /**
         * msg_modify_forbidmsg_list_rep content.
         * @member {Uint8Array} content
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @instance
         */
        msg_modify_forbidmsg_list_rep.prototype.content = $util.newBuffer([]);

        /**
         * msg_modify_forbidmsg_list_rep optype.
         * @member {number} optype
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @instance
         */
        msg_modify_forbidmsg_list_rep.prototype.optype = 0;

        /**
         * Creates a new msg_modify_forbidmsg_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_modify_forbidmsg_list_rep=} [properties] Properties to set
         * @returns {net.msg_modify_forbidmsg_list_rep} msg_modify_forbidmsg_list_rep instance
         */
        msg_modify_forbidmsg_list_rep.create = function create(properties) {
            return new msg_modify_forbidmsg_list_rep(properties);
        };

        /**
         * Encodes the specified msg_modify_forbidmsg_list_rep message. Does not implicitly {@link net.msg_modify_forbidmsg_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_modify_forbidmsg_list_rep} message msg_modify_forbidmsg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_forbidmsg_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            if (message.optype != null && Object.hasOwnProperty.call(message, "optype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.optype);
            return writer;
        };

        /**
         * Encodes the specified msg_modify_forbidmsg_list_rep message, length delimited. Does not implicitly {@link net.msg_modify_forbidmsg_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {net.Imsg_modify_forbidmsg_list_rep} message msg_modify_forbidmsg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_forbidmsg_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_modify_forbidmsg_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_forbidmsg_list_rep} msg_modify_forbidmsg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_forbidmsg_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_forbidmsg_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                case 3:
                    message.optype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_modify_forbidmsg_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_modify_forbidmsg_list_rep} msg_modify_forbidmsg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_forbidmsg_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_modify_forbidmsg_list_rep message.
         * @function verify
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_modify_forbidmsg_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.optype != null && message.hasOwnProperty("optype"))
                if (!$util.isInteger(message.optype))
                    return "optype: integer expected";
            return null;
        };

        /**
         * Creates a msg_modify_forbidmsg_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_modify_forbidmsg_list_rep} msg_modify_forbidmsg_list_rep
         */
        msg_modify_forbidmsg_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_modify_forbidmsg_list_rep)
                return object;
            var message = new $root.net.msg_modify_forbidmsg_list_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.optype != null)
                message.optype = object.optype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_modify_forbidmsg_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @static
         * @param {net.msg_modify_forbidmsg_list_rep} message msg_modify_forbidmsg_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_modify_forbidmsg_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                object.optype = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.optype != null && message.hasOwnProperty("optype"))
                object.optype = message.optype;
            return object;
        };

        /**
         * Converts this msg_modify_forbidmsg_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_modify_forbidmsg_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_modify_forbidmsg_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_modify_forbidmsg_list_rep;
    })();

    net.msg_apply_friend_need_verify = (function() {

        /**
         * Properties of a msg_apply_friend_need_verify.
         * @memberof net
         * @interface Imsg_apply_friend_need_verify
         * @property {number|null} [need] msg_apply_friend_need_verify need
         */

        /**
         * Constructs a new msg_apply_friend_need_verify.
         * @memberof net
         * @classdesc Represents a msg_apply_friend_need_verify.
         * @implements Imsg_apply_friend_need_verify
         * @constructor
         * @param {net.Imsg_apply_friend_need_verify=} [properties] Properties to set
         */
        function msg_apply_friend_need_verify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_apply_friend_need_verify need.
         * @member {number} need
         * @memberof net.msg_apply_friend_need_verify
         * @instance
         */
        msg_apply_friend_need_verify.prototype.need = 0;

        /**
         * Creates a new msg_apply_friend_need_verify instance using the specified properties.
         * @function create
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {net.Imsg_apply_friend_need_verify=} [properties] Properties to set
         * @returns {net.msg_apply_friend_need_verify} msg_apply_friend_need_verify instance
         */
        msg_apply_friend_need_verify.create = function create(properties) {
            return new msg_apply_friend_need_verify(properties);
        };

        /**
         * Encodes the specified msg_apply_friend_need_verify message. Does not implicitly {@link net.msg_apply_friend_need_verify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {net.Imsg_apply_friend_need_verify} message msg_apply_friend_need_verify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_apply_friend_need_verify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.need != null && Object.hasOwnProperty.call(message, "need"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.need);
            return writer;
        };

        /**
         * Encodes the specified msg_apply_friend_need_verify message, length delimited. Does not implicitly {@link net.msg_apply_friend_need_verify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {net.Imsg_apply_friend_need_verify} message msg_apply_friend_need_verify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_apply_friend_need_verify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_apply_friend_need_verify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_apply_friend_need_verify} msg_apply_friend_need_verify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_apply_friend_need_verify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_apply_friend_need_verify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.need = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_apply_friend_need_verify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_apply_friend_need_verify} msg_apply_friend_need_verify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_apply_friend_need_verify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_apply_friend_need_verify message.
         * @function verify
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_apply_friend_need_verify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.need != null && message.hasOwnProperty("need"))
                if (!$util.isInteger(message.need))
                    return "need: integer expected";
            return null;
        };

        /**
         * Creates a msg_apply_friend_need_verify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_apply_friend_need_verify} msg_apply_friend_need_verify
         */
        msg_apply_friend_need_verify.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_apply_friend_need_verify)
                return object;
            var message = new $root.net.msg_apply_friend_need_verify();
            if (object.need != null)
                message.need = object.need | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_apply_friend_need_verify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_apply_friend_need_verify
         * @static
         * @param {net.msg_apply_friend_need_verify} message msg_apply_friend_need_verify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_apply_friend_need_verify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.need = 0;
            if (message.need != null && message.hasOwnProperty("need"))
                object.need = message.need;
            return object;
        };

        /**
         * Converts this msg_apply_friend_need_verify to JSON.
         * @function toJSON
         * @memberof net.msg_apply_friend_need_verify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_apply_friend_need_verify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_apply_friend_need_verify;
    })();

    net.msg_apply_friend_need_verify_rep = (function() {

        /**
         * Properties of a msg_apply_friend_need_verify_rep.
         * @memberof net
         * @interface Imsg_apply_friend_need_verify_rep
         * @property {number|null} [result] msg_apply_friend_need_verify_rep result
         * @property {number|null} [need] msg_apply_friend_need_verify_rep need
         */

        /**
         * Constructs a new msg_apply_friend_need_verify_rep.
         * @memberof net
         * @classdesc Represents a msg_apply_friend_need_verify_rep.
         * @implements Imsg_apply_friend_need_verify_rep
         * @constructor
         * @param {net.Imsg_apply_friend_need_verify_rep=} [properties] Properties to set
         */
        function msg_apply_friend_need_verify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_apply_friend_need_verify_rep result.
         * @member {number} result
         * @memberof net.msg_apply_friend_need_verify_rep
         * @instance
         */
        msg_apply_friend_need_verify_rep.prototype.result = 0;

        /**
         * msg_apply_friend_need_verify_rep need.
         * @member {number} need
         * @memberof net.msg_apply_friend_need_verify_rep
         * @instance
         */
        msg_apply_friend_need_verify_rep.prototype.need = 0;

        /**
         * Creates a new msg_apply_friend_need_verify_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {net.Imsg_apply_friend_need_verify_rep=} [properties] Properties to set
         * @returns {net.msg_apply_friend_need_verify_rep} msg_apply_friend_need_verify_rep instance
         */
        msg_apply_friend_need_verify_rep.create = function create(properties) {
            return new msg_apply_friend_need_verify_rep(properties);
        };

        /**
         * Encodes the specified msg_apply_friend_need_verify_rep message. Does not implicitly {@link net.msg_apply_friend_need_verify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {net.Imsg_apply_friend_need_verify_rep} message msg_apply_friend_need_verify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_apply_friend_need_verify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.need != null && Object.hasOwnProperty.call(message, "need"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.need);
            return writer;
        };

        /**
         * Encodes the specified msg_apply_friend_need_verify_rep message, length delimited. Does not implicitly {@link net.msg_apply_friend_need_verify_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {net.Imsg_apply_friend_need_verify_rep} message msg_apply_friend_need_verify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_apply_friend_need_verify_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_apply_friend_need_verify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_apply_friend_need_verify_rep} msg_apply_friend_need_verify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_apply_friend_need_verify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_apply_friend_need_verify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.need = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_apply_friend_need_verify_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_apply_friend_need_verify_rep} msg_apply_friend_need_verify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_apply_friend_need_verify_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_apply_friend_need_verify_rep message.
         * @function verify
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_apply_friend_need_verify_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.need != null && message.hasOwnProperty("need"))
                if (!$util.isInteger(message.need))
                    return "need: integer expected";
            return null;
        };

        /**
         * Creates a msg_apply_friend_need_verify_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_apply_friend_need_verify_rep} msg_apply_friend_need_verify_rep
         */
        msg_apply_friend_need_verify_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_apply_friend_need_verify_rep)
                return object;
            var message = new $root.net.msg_apply_friend_need_verify_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.need != null)
                message.need = object.need | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_apply_friend_need_verify_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_apply_friend_need_verify_rep
         * @static
         * @param {net.msg_apply_friend_need_verify_rep} message msg_apply_friend_need_verify_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_apply_friend_need_verify_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.need = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.need != null && message.hasOwnProperty("need"))
                object.need = message.need;
            return object;
        };

        /**
         * Converts this msg_apply_friend_need_verify_rep to JSON.
         * @function toJSON
         * @memberof net.msg_apply_friend_need_verify_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_apply_friend_need_verify_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_apply_friend_need_verify_rep;
    })();

    net.msg_red_nty = (function() {

        /**
         * Properties of a msg_red_nty.
         * @memberof net
         * @interface Imsg_red_nty
         * @property {net.Ired_info|null} [red] msg_red_nty red
         */

        /**
         * Constructs a new msg_red_nty.
         * @memberof net
         * @classdesc Represents a msg_red_nty.
         * @implements Imsg_red_nty
         * @constructor
         * @param {net.Imsg_red_nty=} [properties] Properties to set
         */
        function msg_red_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_red_nty red.
         * @member {net.Ired_info|null|undefined} red
         * @memberof net.msg_red_nty
         * @instance
         */
        msg_red_nty.prototype.red = null;

        /**
         * Creates a new msg_red_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_red_nty
         * @static
         * @param {net.Imsg_red_nty=} [properties] Properties to set
         * @returns {net.msg_red_nty} msg_red_nty instance
         */
        msg_red_nty.create = function create(properties) {
            return new msg_red_nty(properties);
        };

        /**
         * Encodes the specified msg_red_nty message. Does not implicitly {@link net.msg_red_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_red_nty
         * @static
         * @param {net.Imsg_red_nty} message msg_red_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_red_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.red != null && Object.hasOwnProperty.call(message, "red"))
                $root.net.red_info.encode(message.red, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_red_nty message, length delimited. Does not implicitly {@link net.msg_red_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_red_nty
         * @static
         * @param {net.Imsg_red_nty} message msg_red_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_red_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_red_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_red_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_red_nty} msg_red_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_red_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_red_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.red = $root.net.red_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_red_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_red_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_red_nty} msg_red_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_red_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_red_nty message.
         * @function verify
         * @memberof net.msg_red_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_red_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.red != null && message.hasOwnProperty("red")) {
                var error = $root.net.red_info.verify(message.red);
                if (error)
                    return "red." + error;
            }
            return null;
        };

        /**
         * Creates a msg_red_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_red_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_red_nty} msg_red_nty
         */
        msg_red_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_red_nty)
                return object;
            var message = new $root.net.msg_red_nty();
            if (object.red != null) {
                if (typeof object.red !== "object")
                    throw TypeError(".net.msg_red_nty.red: object expected");
                message.red = $root.net.red_info.fromObject(object.red);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_red_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_red_nty
         * @static
         * @param {net.msg_red_nty} message msg_red_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_red_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.red = null;
            if (message.red != null && message.hasOwnProperty("red"))
                object.red = $root.net.red_info.toObject(message.red, options);
            return object;
        };

        /**
         * Converts this msg_red_nty to JSON.
         * @function toJSON
         * @memberof net.msg_red_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_red_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_red_nty;
    })();

    net.msg_login_other_nty = (function() {

        /**
         * Properties of a msg_login_other_nty.
         * @memberof net
         * @interface Imsg_login_other_nty
         * @property {Uint8Array|null} [deviceid] msg_login_other_nty deviceid
         */

        /**
         * Constructs a new msg_login_other_nty.
         * @memberof net
         * @classdesc Represents a msg_login_other_nty.
         * @implements Imsg_login_other_nty
         * @constructor
         * @param {net.Imsg_login_other_nty=} [properties] Properties to set
         */
        function msg_login_other_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_other_nty deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_login_other_nty
         * @instance
         */
        msg_login_other_nty.prototype.deviceid = $util.newBuffer([]);

        /**
         * Creates a new msg_login_other_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_login_other_nty
         * @static
         * @param {net.Imsg_login_other_nty=} [properties] Properties to set
         * @returns {net.msg_login_other_nty} msg_login_other_nty instance
         */
        msg_login_other_nty.create = function create(properties) {
            return new msg_login_other_nty(properties);
        };

        /**
         * Encodes the specified msg_login_other_nty message. Does not implicitly {@link net.msg_login_other_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_other_nty
         * @static
         * @param {net.Imsg_login_other_nty} message msg_login_other_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_other_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.deviceid);
            return writer;
        };

        /**
         * Encodes the specified msg_login_other_nty message, length delimited. Does not implicitly {@link net.msg_login_other_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_login_other_nty
         * @static
         * @param {net.Imsg_login_other_nty} message msg_login_other_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_other_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_login_other_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_other_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_other_nty} msg_login_other_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_other_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_other_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.deviceid = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_login_other_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_login_other_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_login_other_nty} msg_login_other_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_other_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_login_other_nty message.
         * @function verify
         * @memberof net.msg_login_other_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_login_other_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (!(message.deviceid && typeof message.deviceid.length === "number" || $util.isString(message.deviceid)))
                    return "deviceid: buffer expected";
            return null;
        };

        /**
         * Creates a msg_login_other_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_login_other_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_login_other_nty} msg_login_other_nty
         */
        msg_login_other_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_login_other_nty)
                return object;
            var message = new $root.net.msg_login_other_nty();
            if (object.deviceid != null)
                if (typeof object.deviceid === "string")
                    $util.base64.decode(object.deviceid, message.deviceid = $util.newBuffer($util.base64.length(object.deviceid)), 0);
                else if (object.deviceid.length)
                    message.deviceid = object.deviceid;
            return message;
        };

        /**
         * Creates a plain object from a msg_login_other_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_login_other_nty
         * @static
         * @param {net.msg_login_other_nty} message msg_login_other_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_login_other_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.deviceid = "";
                else {
                    object.deviceid = [];
                    if (options.bytes !== Array)
                        object.deviceid = $util.newBuffer(object.deviceid);
                }
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                object.deviceid = options.bytes === String ? $util.base64.encode(message.deviceid, 0, message.deviceid.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceid) : message.deviceid;
            return object;
        };

        /**
         * Converts this msg_login_other_nty to JSON.
         * @function toJSON
         * @memberof net.msg_login_other_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_login_other_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_login_other_nty;
    })();

    net.msg_group_base_nty = (function() {

        /**
         * Properties of a msg_group_base_nty.
         * @memberof net
         * @interface Imsg_group_base_nty
         * @property {Array.<net.Igroup_base_info>|null} [grouplist] msg_group_base_nty grouplist
         */

        /**
         * Constructs a new msg_group_base_nty.
         * @memberof net
         * @classdesc Represents a msg_group_base_nty.
         * @implements Imsg_group_base_nty
         * @constructor
         * @param {net.Imsg_group_base_nty=} [properties] Properties to set
         */
        function msg_group_base_nty(properties) {
            this.grouplist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_base_nty grouplist.
         * @member {Array.<net.Igroup_base_info>} grouplist
         * @memberof net.msg_group_base_nty
         * @instance
         */
        msg_group_base_nty.prototype.grouplist = $util.emptyArray;

        /**
         * Creates a new msg_group_base_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_group_base_nty
         * @static
         * @param {net.Imsg_group_base_nty=} [properties] Properties to set
         * @returns {net.msg_group_base_nty} msg_group_base_nty instance
         */
        msg_group_base_nty.create = function create(properties) {
            return new msg_group_base_nty(properties);
        };

        /**
         * Encodes the specified msg_group_base_nty message. Does not implicitly {@link net.msg_group_base_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_base_nty
         * @static
         * @param {net.Imsg_group_base_nty} message msg_group_base_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_base_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.grouplist != null && message.grouplist.length)
                for (var i = 0; i < message.grouplist.length; ++i)
                    $root.net.group_base_info.encode(message.grouplist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_group_base_nty message, length delimited. Does not implicitly {@link net.msg_group_base_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_base_nty
         * @static
         * @param {net.Imsg_group_base_nty} message msg_group_base_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_base_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_base_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_base_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_base_nty} msg_group_base_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_base_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_base_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.grouplist && message.grouplist.length))
                        message.grouplist = [];
                    message.grouplist.push($root.net.group_base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_base_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_base_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_base_nty} msg_group_base_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_base_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_base_nty message.
         * @function verify
         * @memberof net.msg_group_base_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_base_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.grouplist != null && message.hasOwnProperty("grouplist")) {
                if (!Array.isArray(message.grouplist))
                    return "grouplist: array expected";
                for (var i = 0; i < message.grouplist.length; ++i) {
                    var error = $root.net.group_base_info.verify(message.grouplist[i]);
                    if (error)
                        return "grouplist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_group_base_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_base_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_base_nty} msg_group_base_nty
         */
        msg_group_base_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_base_nty)
                return object;
            var message = new $root.net.msg_group_base_nty();
            if (object.grouplist) {
                if (!Array.isArray(object.grouplist))
                    throw TypeError(".net.msg_group_base_nty.grouplist: array expected");
                message.grouplist = [];
                for (var i = 0; i < object.grouplist.length; ++i) {
                    if (typeof object.grouplist[i] !== "object")
                        throw TypeError(".net.msg_group_base_nty.grouplist: object expected");
                    message.grouplist[i] = $root.net.group_base_info.fromObject(object.grouplist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_group_base_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_base_nty
         * @static
         * @param {net.msg_group_base_nty} message msg_group_base_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_base_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.grouplist = [];
            if (message.grouplist && message.grouplist.length) {
                object.grouplist = [];
                for (var j = 0; j < message.grouplist.length; ++j)
                    object.grouplist[j] = $root.net.group_base_info.toObject(message.grouplist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_group_base_nty to JSON.
         * @function toJSON
         * @memberof net.msg_group_base_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_base_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_base_nty;
    })();

    net.msg_group_oper_nty = (function() {

        /**
         * Properties of a msg_group_oper_nty.
         * @memberof net
         * @interface Imsg_group_oper_nty
         * @property {number|null} [groupkey] msg_group_oper_nty groupkey
         * @property {number|null} [opertype] msg_group_oper_nty opertype
         */

        /**
         * Constructs a new msg_group_oper_nty.
         * @memberof net
         * @classdesc Represents a msg_group_oper_nty.
         * @implements Imsg_group_oper_nty
         * @constructor
         * @param {net.Imsg_group_oper_nty=} [properties] Properties to set
         */
        function msg_group_oper_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_oper_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_oper_nty
         * @instance
         */
        msg_group_oper_nty.prototype.groupkey = 0;

        /**
         * msg_group_oper_nty opertype.
         * @member {number} opertype
         * @memberof net.msg_group_oper_nty
         * @instance
         */
        msg_group_oper_nty.prototype.opertype = 0;

        /**
         * Creates a new msg_group_oper_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {net.Imsg_group_oper_nty=} [properties] Properties to set
         * @returns {net.msg_group_oper_nty} msg_group_oper_nty instance
         */
        msg_group_oper_nty.create = function create(properties) {
            return new msg_group_oper_nty(properties);
        };

        /**
         * Encodes the specified msg_group_oper_nty message. Does not implicitly {@link net.msg_group_oper_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {net.Imsg_group_oper_nty} message msg_group_oper_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_oper_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Encodes the specified msg_group_oper_nty message, length delimited. Does not implicitly {@link net.msg_group_oper_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {net.Imsg_group_oper_nty} message msg_group_oper_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_oper_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_oper_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_oper_nty} msg_group_oper_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_oper_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_oper_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_oper_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_oper_nty} msg_group_oper_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_oper_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_oper_nty message.
         * @function verify
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_oper_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                if (!$util.isInteger(message.opertype))
                    return "opertype: integer expected";
            return null;
        };

        /**
         * Creates a msg_group_oper_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_oper_nty} msg_group_oper_nty
         */
        msg_group_oper_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_oper_nty)
                return object;
            var message = new $root.net.msg_group_oper_nty();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.opertype != null)
                message.opertype = object.opertype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_group_oper_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {net.msg_group_oper_nty} message msg_group_oper_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_oper_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.groupkey = 0;
                object.opertype = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.opertype != null && message.hasOwnProperty("opertype"))
                object.opertype = message.opertype;
            return object;
        };

        /**
         * Converts this msg_group_oper_nty to JSON.
         * @function toJSON
         * @memberof net.msg_group_oper_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_oper_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_oper_nty;
    })();

    net.msg_handle_friend_nty = (function() {

        /**
         * Properties of a msg_handle_friend_nty.
         * @memberof net
         * @interface Imsg_handle_friend_nty
         * @property {net.Ibase_info|null} [friend_info] msg_handle_friend_nty friend_info
         */

        /**
         * Constructs a new msg_handle_friend_nty.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_nty.
         * @implements Imsg_handle_friend_nty
         * @constructor
         * @param {net.Imsg_handle_friend_nty=} [properties] Properties to set
         */
        function msg_handle_friend_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_nty friend_info.
         * @member {net.Ibase_info|null|undefined} friend_info
         * @memberof net.msg_handle_friend_nty
         * @instance
         */
        msg_handle_friend_nty.prototype.friend_info = null;

        /**
         * Creates a new msg_handle_friend_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {net.Imsg_handle_friend_nty=} [properties] Properties to set
         * @returns {net.msg_handle_friend_nty} msg_handle_friend_nty instance
         */
        msg_handle_friend_nty.create = function create(properties) {
            return new msg_handle_friend_nty(properties);
        };

        /**
         * Encodes the specified msg_handle_friend_nty message. Does not implicitly {@link net.msg_handle_friend_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {net.Imsg_handle_friend_nty} message msg_handle_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.friend_info != null && Object.hasOwnProperty.call(message, "friend_info"))
                $root.net.base_info.encode(message.friend_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_handle_friend_nty message, length delimited. Does not implicitly {@link net.msg_handle_friend_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {net.Imsg_handle_friend_nty} message msg_handle_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_handle_friend_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_nty} msg_handle_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.friend_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_handle_friend_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_handle_friend_nty} msg_handle_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_handle_friend_nty message.
         * @function verify
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_handle_friend_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.friend_info != null && message.hasOwnProperty("friend_info")) {
                var error = $root.net.base_info.verify(message.friend_info);
                if (error)
                    return "friend_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_handle_friend_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_handle_friend_nty} msg_handle_friend_nty
         */
        msg_handle_friend_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_handle_friend_nty)
                return object;
            var message = new $root.net.msg_handle_friend_nty();
            if (object.friend_info != null) {
                if (typeof object.friend_info !== "object")
                    throw TypeError(".net.msg_handle_friend_nty.friend_info: object expected");
                message.friend_info = $root.net.base_info.fromObject(object.friend_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_handle_friend_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {net.msg_handle_friend_nty} message msg_handle_friend_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_handle_friend_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.friend_info = null;
            if (message.friend_info != null && message.hasOwnProperty("friend_info"))
                object.friend_info = $root.net.base_info.toObject(message.friend_info, options);
            return object;
        };

        /**
         * Converts this msg_handle_friend_nty to JSON.
         * @function toJSON
         * @memberof net.msg_handle_friend_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_handle_friend_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_handle_friend_nty;
    })();

    net.msg_new_order_nty = (function() {

        /**
         * Properties of a msg_new_order_nty.
         * @memberof net
         * @interface Imsg_new_order_nty
         * @property {number|null} [uid] msg_new_order_nty uid
         * @property {number|Long|null} [orderid] msg_new_order_nty orderid
         */

        /**
         * Constructs a new msg_new_order_nty.
         * @memberof net
         * @classdesc Represents a msg_new_order_nty.
         * @implements Imsg_new_order_nty
         * @constructor
         * @param {net.Imsg_new_order_nty=} [properties] Properties to set
         */
        function msg_new_order_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_new_order_nty uid.
         * @member {number} uid
         * @memberof net.msg_new_order_nty
         * @instance
         */
        msg_new_order_nty.prototype.uid = 0;

        /**
         * msg_new_order_nty orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_new_order_nty
         * @instance
         */
        msg_new_order_nty.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_new_order_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_new_order_nty
         * @static
         * @param {net.Imsg_new_order_nty=} [properties] Properties to set
         * @returns {net.msg_new_order_nty} msg_new_order_nty instance
         */
        msg_new_order_nty.create = function create(properties) {
            return new msg_new_order_nty(properties);
        };

        /**
         * Encodes the specified msg_new_order_nty message. Does not implicitly {@link net.msg_new_order_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_new_order_nty
         * @static
         * @param {net.Imsg_new_order_nty} message msg_new_order_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_new_order_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            return writer;
        };

        /**
         * Encodes the specified msg_new_order_nty message, length delimited. Does not implicitly {@link net.msg_new_order_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_new_order_nty
         * @static
         * @param {net.Imsg_new_order_nty} message msg_new_order_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_new_order_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_new_order_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_new_order_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_new_order_nty} msg_new_order_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_new_order_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_new_order_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_new_order_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_new_order_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_new_order_nty} msg_new_order_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_new_order_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_new_order_nty message.
         * @function verify
         * @memberof net.msg_new_order_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_new_order_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (!$util.isInteger(message.orderid) && !(message.orderid && $util.isInteger(message.orderid.low) && $util.isInteger(message.orderid.high)))
                    return "orderid: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_new_order_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_new_order_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_new_order_nty} msg_new_order_nty
         */
        msg_new_order_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_new_order_nty)
                return object;
            var message = new $root.net.msg_new_order_nty();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.orderid != null)
                if ($util.Long)
                    (message.orderid = $util.Long.fromValue(object.orderid)).unsigned = false;
                else if (typeof object.orderid === "string")
                    message.orderid = parseInt(object.orderid, 10);
                else if (typeof object.orderid === "number")
                    message.orderid = object.orderid;
                else if (typeof object.orderid === "object")
                    message.orderid = new $util.LongBits(object.orderid.low >>> 0, object.orderid.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_new_order_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_new_order_nty
         * @static
         * @param {net.msg_new_order_nty} message msg_new_order_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_new_order_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.orderid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderid = options.longs === String ? "0" : 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.orderid != null && message.hasOwnProperty("orderid"))
                if (typeof message.orderid === "number")
                    object.orderid = options.longs === String ? String(message.orderid) : message.orderid;
                else
                    object.orderid = options.longs === String ? $util.Long.prototype.toString.call(message.orderid) : options.longs === Number ? new $util.LongBits(message.orderid.low >>> 0, message.orderid.high >>> 0).toNumber() : message.orderid;
            return object;
        };

        /**
         * Converts this msg_new_order_nty to JSON.
         * @function toJSON
         * @memberof net.msg_new_order_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_new_order_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_new_order_nty;
    })();

    net.msg_group_member_list_nty = (function() {

        /**
         * Properties of a msg_group_member_list_nty.
         * @memberof net
         * @interface Imsg_group_member_list_nty
         * @property {number|null} [groupkey] msg_group_member_list_nty groupkey
         * @property {number|null} [isfirst] msg_group_member_list_nty isfirst
         * @property {Array.<net.Ibase_info>|null} [users] msg_group_member_list_nty users
         */

        /**
         * Constructs a new msg_group_member_list_nty.
         * @memberof net
         * @classdesc Represents a msg_group_member_list_nty.
         * @implements Imsg_group_member_list_nty
         * @constructor
         * @param {net.Imsg_group_member_list_nty=} [properties] Properties to set
         */
        function msg_group_member_list_nty(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_member_list_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.groupkey = 0;

        /**
         * msg_group_member_list_nty isfirst.
         * @member {number} isfirst
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.isfirst = 0;

        /**
         * msg_group_member_list_nty users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.users = $util.emptyArray;

        /**
         * Creates a new msg_group_member_list_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {net.Imsg_group_member_list_nty=} [properties] Properties to set
         * @returns {net.msg_group_member_list_nty} msg_group_member_list_nty instance
         */
        msg_group_member_list_nty.create = function create(properties) {
            return new msg_group_member_list_nty(properties);
        };

        /**
         * Encodes the specified msg_group_member_list_nty message. Does not implicitly {@link net.msg_group_member_list_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {net.Imsg_group_member_list_nty} message msg_group_member_list_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_member_list_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_group_member_list_nty message, length delimited. Does not implicitly {@link net.msg_group_member_list_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {net.Imsg_group_member_list_nty} message msg_group_member_list_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_member_list_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_member_list_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_member_list_nty} msg_group_member_list_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_member_list_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_member_list_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_member_list_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_member_list_nty} msg_group_member_list_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_member_list_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_member_list_nty message.
         * @function verify
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_member_list_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                if (!$util.isInteger(message.isfirst))
                    return "isfirst: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_group_member_list_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_member_list_nty} msg_group_member_list_nty
         */
        msg_group_member_list_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_member_list_nty)
                return object;
            var message = new $root.net.msg_group_member_list_nty();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.isfirst != null)
                message.isfirst = object.isfirst | 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_group_member_list_nty.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_group_member_list_nty.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_group_member_list_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {net.msg_group_member_list_nty} message msg_group_member_list_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_member_list_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.groupkey = 0;
                object.isfirst = 0;
            }
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                object.isfirst = message.isfirst;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_group_member_list_nty to JSON.
         * @function toJSON
         * @memberof net.msg_group_member_list_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_member_list_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_member_list_nty;
    })();

    net.msg_rate_nty = (function() {

        /**
         * Properties of a msg_rate_nty.
         * @memberof net
         * @interface Imsg_rate_nty
         * @property {Array.<net.Irate_info>|null} [ratelist] msg_rate_nty ratelist
         */

        /**
         * Constructs a new msg_rate_nty.
         * @memberof net
         * @classdesc Represents a msg_rate_nty.
         * @implements Imsg_rate_nty
         * @constructor
         * @param {net.Imsg_rate_nty=} [properties] Properties to set
         */
        function msg_rate_nty(properties) {
            this.ratelist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_rate_nty ratelist.
         * @member {Array.<net.Irate_info>} ratelist
         * @memberof net.msg_rate_nty
         * @instance
         */
        msg_rate_nty.prototype.ratelist = $util.emptyArray;

        /**
         * Creates a new msg_rate_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_rate_nty
         * @static
         * @param {net.Imsg_rate_nty=} [properties] Properties to set
         * @returns {net.msg_rate_nty} msg_rate_nty instance
         */
        msg_rate_nty.create = function create(properties) {
            return new msg_rate_nty(properties);
        };

        /**
         * Encodes the specified msg_rate_nty message. Does not implicitly {@link net.msg_rate_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_rate_nty
         * @static
         * @param {net.Imsg_rate_nty} message msg_rate_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_rate_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ratelist != null && message.ratelist.length)
                for (var i = 0; i < message.ratelist.length; ++i)
                    $root.net.rate_info.encode(message.ratelist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_rate_nty message, length delimited. Does not implicitly {@link net.msg_rate_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_rate_nty
         * @static
         * @param {net.Imsg_rate_nty} message msg_rate_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_rate_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_rate_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_rate_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_rate_nty} msg_rate_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_rate_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_rate_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ratelist && message.ratelist.length))
                        message.ratelist = [];
                    message.ratelist.push($root.net.rate_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_rate_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_rate_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_rate_nty} msg_rate_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_rate_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_rate_nty message.
         * @function verify
         * @memberof net.msg_rate_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_rate_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ratelist != null && message.hasOwnProperty("ratelist")) {
                if (!Array.isArray(message.ratelist))
                    return "ratelist: array expected";
                for (var i = 0; i < message.ratelist.length; ++i) {
                    var error = $root.net.rate_info.verify(message.ratelist[i]);
                    if (error)
                        return "ratelist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_rate_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_rate_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_rate_nty} msg_rate_nty
         */
        msg_rate_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_rate_nty)
                return object;
            var message = new $root.net.msg_rate_nty();
            if (object.ratelist) {
                if (!Array.isArray(object.ratelist))
                    throw TypeError(".net.msg_rate_nty.ratelist: array expected");
                message.ratelist = [];
                for (var i = 0; i < object.ratelist.length; ++i) {
                    if (typeof object.ratelist[i] !== "object")
                        throw TypeError(".net.msg_rate_nty.ratelist: object expected");
                    message.ratelist[i] = $root.net.rate_info.fromObject(object.ratelist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_rate_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_rate_nty
         * @static
         * @param {net.msg_rate_nty} message msg_rate_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_rate_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ratelist = [];
            if (message.ratelist && message.ratelist.length) {
                object.ratelist = [];
                for (var j = 0; j < message.ratelist.length; ++j)
                    object.ratelist[j] = $root.net.rate_info.toObject(message.ratelist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_rate_nty to JSON.
         * @function toJSON
         * @memberof net.msg_rate_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_rate_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_rate_nty;
    })();

    net.msg_pc_flow_nty = (function() {

        /**
         * Properties of a msg_pc_flow_nty.
         * @memberof net
         * @interface Imsg_pc_flow_nty
         * @property {number|null} [pcflow] msg_pc_flow_nty pcflow
         */

        /**
         * Constructs a new msg_pc_flow_nty.
         * @memberof net
         * @classdesc Represents a msg_pc_flow_nty.
         * @implements Imsg_pc_flow_nty
         * @constructor
         * @param {net.Imsg_pc_flow_nty=} [properties] Properties to set
         */
        function msg_pc_flow_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pc_flow_nty pcflow.
         * @member {number} pcflow
         * @memberof net.msg_pc_flow_nty
         * @instance
         */
        msg_pc_flow_nty.prototype.pcflow = 0;

        /**
         * Creates a new msg_pc_flow_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {net.Imsg_pc_flow_nty=} [properties] Properties to set
         * @returns {net.msg_pc_flow_nty} msg_pc_flow_nty instance
         */
        msg_pc_flow_nty.create = function create(properties) {
            return new msg_pc_flow_nty(properties);
        };

        /**
         * Encodes the specified msg_pc_flow_nty message. Does not implicitly {@link net.msg_pc_flow_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {net.Imsg_pc_flow_nty} message msg_pc_flow_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_flow_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pcflow != null && Object.hasOwnProperty.call(message, "pcflow"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pcflow);
            return writer;
        };

        /**
         * Encodes the specified msg_pc_flow_nty message, length delimited. Does not implicitly {@link net.msg_pc_flow_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {net.Imsg_pc_flow_nty} message msg_pc_flow_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_flow_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pc_flow_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pc_flow_nty} msg_pc_flow_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_flow_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pc_flow_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pcflow = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pc_flow_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pc_flow_nty} msg_pc_flow_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_flow_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pc_flow_nty message.
         * @function verify
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pc_flow_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pcflow != null && message.hasOwnProperty("pcflow"))
                if (!$util.isInteger(message.pcflow))
                    return "pcflow: integer expected";
            return null;
        };

        /**
         * Creates a msg_pc_flow_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pc_flow_nty} msg_pc_flow_nty
         */
        msg_pc_flow_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pc_flow_nty)
                return object;
            var message = new $root.net.msg_pc_flow_nty();
            if (object.pcflow != null)
                message.pcflow = object.pcflow | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_pc_flow_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {net.msg_pc_flow_nty} message msg_pc_flow_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pc_flow_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pcflow = 0;
            if (message.pcflow != null && message.hasOwnProperty("pcflow"))
                object.pcflow = message.pcflow;
            return object;
        };

        /**
         * Converts this msg_pc_flow_nty to JSON.
         * @function toJSON
         * @memberof net.msg_pc_flow_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pc_flow_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pc_flow_nty;
    })();

    net.msg_pc_data_nty = (function() {

        /**
         * Properties of a msg_pc_data_nty.
         * @memberof net
         * @interface Imsg_pc_data_nty
         * @property {number|null} [uid] msg_pc_data_nty uid
         */

        /**
         * Constructs a new msg_pc_data_nty.
         * @memberof net
         * @classdesc Represents a msg_pc_data_nty.
         * @implements Imsg_pc_data_nty
         * @constructor
         * @param {net.Imsg_pc_data_nty=} [properties] Properties to set
         */
        function msg_pc_data_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pc_data_nty uid.
         * @member {number} uid
         * @memberof net.msg_pc_data_nty
         * @instance
         */
        msg_pc_data_nty.prototype.uid = 0;

        /**
         * Creates a new msg_pc_data_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {net.Imsg_pc_data_nty=} [properties] Properties to set
         * @returns {net.msg_pc_data_nty} msg_pc_data_nty instance
         */
        msg_pc_data_nty.create = function create(properties) {
            return new msg_pc_data_nty(properties);
        };

        /**
         * Encodes the specified msg_pc_data_nty message. Does not implicitly {@link net.msg_pc_data_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {net.Imsg_pc_data_nty} message msg_pc_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_data_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_pc_data_nty message, length delimited. Does not implicitly {@link net.msg_pc_data_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {net.Imsg_pc_data_nty} message msg_pc_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_data_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_pc_data_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pc_data_nty} msg_pc_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_data_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pc_data_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_pc_data_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_pc_data_nty} msg_pc_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_data_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_pc_data_nty message.
         * @function verify
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_pc_data_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_pc_data_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_pc_data_nty} msg_pc_data_nty
         */
        msg_pc_data_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_pc_data_nty)
                return object;
            var message = new $root.net.msg_pc_data_nty();
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_pc_data_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {net.msg_pc_data_nty} message msg_pc_data_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_pc_data_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = 0;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_pc_data_nty to JSON.
         * @function toJSON
         * @memberof net.msg_pc_data_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_pc_data_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_pc_data_nty;
    })();

    net.msg_voice_call_nty = (function() {

        /**
         * Properties of a msg_voice_call_nty.
         * @memberof net
         * @interface Imsg_voice_call_nty
         * @property {number|null} [srcuid] msg_voice_call_nty srcuid
         * @property {number|null} [destuid] msg_voice_call_nty destuid
         * @property {number|null} [state] msg_voice_call_nty state
         * @property {number|Long|null} [chatkey] msg_voice_call_nty chatkey
         * @property {Uint8Array|null} [token] msg_voice_call_nty token
         * @property {number|null} [calltype] msg_voice_call_nty calltype
         */

        /**
         * Constructs a new msg_voice_call_nty.
         * @memberof net
         * @classdesc Represents a msg_voice_call_nty.
         * @implements Imsg_voice_call_nty
         * @constructor
         * @param {net.Imsg_voice_call_nty=} [properties] Properties to set
         */
        function msg_voice_call_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call_nty srcuid.
         * @member {number} srcuid
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.srcuid = 0;

        /**
         * msg_voice_call_nty destuid.
         * @member {number} destuid
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.destuid = 0;

        /**
         * msg_voice_call_nty state.
         * @member {number} state
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.state = 0;

        /**
         * msg_voice_call_nty chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_call_nty token.
         * @member {Uint8Array} token
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.token = $util.newBuffer([]);

        /**
         * msg_voice_call_nty calltype.
         * @member {number} calltype
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.calltype = 0;

        /**
         * Creates a new msg_voice_call_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {net.Imsg_voice_call_nty=} [properties] Properties to set
         * @returns {net.msg_voice_call_nty} msg_voice_call_nty instance
         */
        msg_voice_call_nty.create = function create(properties) {
            return new msg_voice_call_nty(properties);
        };

        /**
         * Encodes the specified msg_voice_call_nty message. Does not implicitly {@link net.msg_voice_call_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {net.Imsg_voice_call_nty} message msg_voice_call_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.srcuid != null && Object.hasOwnProperty.call(message, "srcuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.srcuid);
            if (message.destuid != null && Object.hasOwnProperty.call(message, "destuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.destuid);
            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.chatkey);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.token);
            if (message.calltype != null && Object.hasOwnProperty.call(message, "calltype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.calltype);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_call_nty message, length delimited. Does not implicitly {@link net.msg_voice_call_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {net.Imsg_voice_call_nty} message msg_voice_call_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_call_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call_nty} msg_voice_call_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.srcuid = reader.int32();
                    break;
                case 2:
                    message.destuid = reader.int32();
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.chatkey = reader.int64();
                    break;
                case 5:
                    message.token = reader.bytes();
                    break;
                case 6:
                    message.calltype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_call_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_call_nty} msg_voice_call_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_call_nty message.
         * @function verify
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_call_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.srcuid != null && message.hasOwnProperty("srcuid"))
                if (!$util.isInteger(message.srcuid))
                    return "srcuid: integer expected";
            if (message.destuid != null && message.hasOwnProperty("destuid"))
                if (!$util.isInteger(message.destuid))
                    return "destuid: integer expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            if (message.calltype != null && message.hasOwnProperty("calltype"))
                if (!$util.isInteger(message.calltype))
                    return "calltype: integer expected";
            return null;
        };

        /**
         * Creates a msg_voice_call_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_call_nty} msg_voice_call_nty
         */
        msg_voice_call_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_call_nty)
                return object;
            var message = new $root.net.msg_voice_call_nty();
            if (object.srcuid != null)
                message.srcuid = object.srcuid | 0;
            if (object.destuid != null)
                message.destuid = object.destuid | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length)
                    message.token = object.token;
            if (object.calltype != null)
                message.calltype = object.calltype | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_call_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {net.msg_voice_call_nty} message msg_voice_call_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_call_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.srcuid = 0;
                object.destuid = 0;
                object.state = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
                object.calltype = 0;
            }
            if (message.srcuid != null && message.hasOwnProperty("srcuid"))
                object.srcuid = message.srcuid;
            if (message.destuid != null && message.hasOwnProperty("destuid"))
                object.destuid = message.destuid;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            if (message.calltype != null && message.hasOwnProperty("calltype"))
                object.calltype = message.calltype;
            return object;
        };

        /**
         * Converts this msg_voice_call_nty to JSON.
         * @function toJSON
         * @memberof net.msg_voice_call_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_call_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_call_nty;
    })();

    net.msg_voice_data_nty = (function() {

        /**
         * Properties of a msg_voice_data_nty.
         * @memberof net
         * @interface Imsg_voice_data_nty
         * @property {number|null} [srcuid] msg_voice_data_nty srcuid
         * @property {number|Long|null} [chatkey] msg_voice_data_nty chatkey
         * @property {Uint8Array|null} [voice_data] msg_voice_data_nty voice_data
         * @property {number|Long|null} [ptime] msg_voice_data_nty ptime
         */

        /**
         * Constructs a new msg_voice_data_nty.
         * @memberof net
         * @classdesc Represents a msg_voice_data_nty.
         * @implements Imsg_voice_data_nty
         * @constructor
         * @param {net.Imsg_voice_data_nty=} [properties] Properties to set
         */
        function msg_voice_data_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data_nty srcuid.
         * @member {number} srcuid
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.srcuid = 0;

        /**
         * msg_voice_data_nty chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_data_nty voice_data.
         * @member {Uint8Array} voice_data
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.voice_data = $util.newBuffer([]);

        /**
         * msg_voice_data_nty ptime.
         * @member {number|Long} ptime
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.ptime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new msg_voice_data_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {net.Imsg_voice_data_nty=} [properties] Properties to set
         * @returns {net.msg_voice_data_nty} msg_voice_data_nty instance
         */
        msg_voice_data_nty.create = function create(properties) {
            return new msg_voice_data_nty(properties);
        };

        /**
         * Encodes the specified msg_voice_data_nty message. Does not implicitly {@link net.msg_voice_data_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {net.Imsg_voice_data_nty} message msg_voice_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.srcuid != null && Object.hasOwnProperty.call(message, "srcuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.srcuid);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.voice_data != null && Object.hasOwnProperty.call(message, "voice_data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.voice_data);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ptime);
            return writer;
        };

        /**
         * Encodes the specified msg_voice_data_nty message, length delimited. Does not implicitly {@link net.msg_voice_data_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {net.Imsg_voice_data_nty} message msg_voice_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_voice_data_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data_nty} msg_voice_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.srcuid = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.voice_data = reader.bytes();
                    break;
                case 4:
                    message.ptime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_voice_data_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_voice_data_nty} msg_voice_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_voice_data_nty message.
         * @function verify
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_voice_data_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.srcuid != null && message.hasOwnProperty("srcuid"))
                if (!$util.isInteger(message.srcuid))
                    return "srcuid: integer expected";
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (!$util.isInteger(message.chatkey) && !(message.chatkey && $util.isInteger(message.chatkey.low) && $util.isInteger(message.chatkey.high)))
                    return "chatkey: integer|Long expected";
            if (message.voice_data != null && message.hasOwnProperty("voice_data"))
                if (!(message.voice_data && typeof message.voice_data.length === "number" || $util.isString(message.voice_data)))
                    return "voice_data: buffer expected";
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (!$util.isInteger(message.ptime) && !(message.ptime && $util.isInteger(message.ptime.low) && $util.isInteger(message.ptime.high)))
                    return "ptime: integer|Long expected";
            return null;
        };

        /**
         * Creates a msg_voice_data_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_voice_data_nty} msg_voice_data_nty
         */
        msg_voice_data_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_voice_data_nty)
                return object;
            var message = new $root.net.msg_voice_data_nty();
            if (object.srcuid != null)
                message.srcuid = object.srcuid | 0;
            if (object.chatkey != null)
                if ($util.Long)
                    (message.chatkey = $util.Long.fromValue(object.chatkey)).unsigned = false;
                else if (typeof object.chatkey === "string")
                    message.chatkey = parseInt(object.chatkey, 10);
                else if (typeof object.chatkey === "number")
                    message.chatkey = object.chatkey;
                else if (typeof object.chatkey === "object")
                    message.chatkey = new $util.LongBits(object.chatkey.low >>> 0, object.chatkey.high >>> 0).toNumber();
            if (object.voice_data != null)
                if (typeof object.voice_data === "string")
                    $util.base64.decode(object.voice_data, message.voice_data = $util.newBuffer($util.base64.length(object.voice_data)), 0);
                else if (object.voice_data.length)
                    message.voice_data = object.voice_data;
            if (object.ptime != null)
                if ($util.Long)
                    (message.ptime = $util.Long.fromValue(object.ptime)).unsigned = false;
                else if (typeof object.ptime === "string")
                    message.ptime = parseInt(object.ptime, 10);
                else if (typeof object.ptime === "number")
                    message.ptime = object.ptime;
                else if (typeof object.ptime === "object")
                    message.ptime = new $util.LongBits(object.ptime.low >>> 0, object.ptime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a msg_voice_data_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {net.msg_voice_data_nty} message msg_voice_data_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_voice_data_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.srcuid = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.chatkey = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chatkey = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.voice_data = "";
                else {
                    object.voice_data = [];
                    if (options.bytes !== Array)
                        object.voice_data = $util.newBuffer(object.voice_data);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.ptime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ptime = options.longs === String ? "0" : 0;
            }
            if (message.srcuid != null && message.hasOwnProperty("srcuid"))
                object.srcuid = message.srcuid;
            if (message.chatkey != null && message.hasOwnProperty("chatkey"))
                if (typeof message.chatkey === "number")
                    object.chatkey = options.longs === String ? String(message.chatkey) : message.chatkey;
                else
                    object.chatkey = options.longs === String ? $util.Long.prototype.toString.call(message.chatkey) : options.longs === Number ? new $util.LongBits(message.chatkey.low >>> 0, message.chatkey.high >>> 0).toNumber() : message.chatkey;
            if (message.voice_data != null && message.hasOwnProperty("voice_data"))
                object.voice_data = options.bytes === String ? $util.base64.encode(message.voice_data, 0, message.voice_data.length) : options.bytes === Array ? Array.prototype.slice.call(message.voice_data) : message.voice_data;
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (typeof message.ptime === "number")
                    object.ptime = options.longs === String ? String(message.ptime) : message.ptime;
                else
                    object.ptime = options.longs === String ? $util.Long.prototype.toString.call(message.ptime) : options.longs === Number ? new $util.LongBits(message.ptime.low >>> 0, message.ptime.high >>> 0).toNumber() : message.ptime;
            return object;
        };

        /**
         * Converts this msg_voice_data_nty to JSON.
         * @function toJSON
         * @memberof net.msg_voice_data_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_voice_data_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_voice_data_nty;
    })();

    net.msg_friend_state_nty = (function() {

        /**
         * Properties of a msg_friend_state_nty.
         * @memberof net
         * @interface Imsg_friend_state_nty
         * @property {Array.<net.Ifriend_state_info>|null} [flist] msg_friend_state_nty flist
         * @property {number|null} [isfirst] msg_friend_state_nty isfirst
         * @property {number|null} [isend] msg_friend_state_nty isend
         */

        /**
         * Constructs a new msg_friend_state_nty.
         * @memberof net
         * @classdesc Represents a msg_friend_state_nty.
         * @implements Imsg_friend_state_nty
         * @constructor
         * @param {net.Imsg_friend_state_nty=} [properties] Properties to set
         */
        function msg_friend_state_nty(properties) {
            this.flist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_state_nty flist.
         * @member {Array.<net.Ifriend_state_info>} flist
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.flist = $util.emptyArray;

        /**
         * msg_friend_state_nty isfirst.
         * @member {number} isfirst
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.isfirst = 0;

        /**
         * msg_friend_state_nty isend.
         * @member {number} isend
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.isend = 0;

        /**
         * Creates a new msg_friend_state_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {net.Imsg_friend_state_nty=} [properties] Properties to set
         * @returns {net.msg_friend_state_nty} msg_friend_state_nty instance
         */
        msg_friend_state_nty.create = function create(properties) {
            return new msg_friend_state_nty(properties);
        };

        /**
         * Encodes the specified msg_friend_state_nty message. Does not implicitly {@link net.msg_friend_state_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {net.Imsg_friend_state_nty} message msg_friend_state_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_state_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flist != null && message.flist.length)
                for (var i = 0; i < message.flist.length; ++i)
                    $root.net.friend_state_info.encode(message.flist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isend);
            return writer;
        };

        /**
         * Encodes the specified msg_friend_state_nty message, length delimited. Does not implicitly {@link net.msg_friend_state_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {net.Imsg_friend_state_nty} message msg_friend_state_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_state_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_friend_state_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_state_nty} msg_friend_state_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_state_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_state_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.flist && message.flist.length))
                        message.flist = [];
                    message.flist.push($root.net.friend_state_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    message.isend = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_friend_state_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_friend_state_nty} msg_friend_state_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_state_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_friend_state_nty message.
         * @function verify
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_friend_state_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.flist != null && message.hasOwnProperty("flist")) {
                if (!Array.isArray(message.flist))
                    return "flist: array expected";
                for (var i = 0; i < message.flist.length; ++i) {
                    var error = $root.net.friend_state_info.verify(message.flist[i]);
                    if (error)
                        return "flist." + error;
                }
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                if (!$util.isInteger(message.isfirst))
                    return "isfirst: integer expected";
            if (message.isend != null && message.hasOwnProperty("isend"))
                if (!$util.isInteger(message.isend))
                    return "isend: integer expected";
            return null;
        };

        /**
         * Creates a msg_friend_state_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_friend_state_nty} msg_friend_state_nty
         */
        msg_friend_state_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_friend_state_nty)
                return object;
            var message = new $root.net.msg_friend_state_nty();
            if (object.flist) {
                if (!Array.isArray(object.flist))
                    throw TypeError(".net.msg_friend_state_nty.flist: array expected");
                message.flist = [];
                for (var i = 0; i < object.flist.length; ++i) {
                    if (typeof object.flist[i] !== "object")
                        throw TypeError(".net.msg_friend_state_nty.flist: object expected");
                    message.flist[i] = $root.net.friend_state_info.fromObject(object.flist[i]);
                }
            }
            if (object.isfirst != null)
                message.isfirst = object.isfirst | 0;
            if (object.isend != null)
                message.isend = object.isend | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_friend_state_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {net.msg_friend_state_nty} message msg_friend_state_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_friend_state_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.flist = [];
            if (options.defaults) {
                object.isfirst = 0;
                object.isend = 0;
            }
            if (message.flist && message.flist.length) {
                object.flist = [];
                for (var j = 0; j < message.flist.length; ++j)
                    object.flist[j] = $root.net.friend_state_info.toObject(message.flist[j], options);
            }
            if (message.isfirst != null && message.hasOwnProperty("isfirst"))
                object.isfirst = message.isfirst;
            if (message.isend != null && message.hasOwnProperty("isend"))
                object.isend = message.isend;
            return object;
        };

        /**
         * Converts this msg_friend_state_nty to JSON.
         * @function toJSON
         * @memberof net.msg_friend_state_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_friend_state_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_friend_state_nty;
    })();

    net.msg_group_voice_call_nty = (function() {

        /**
         * Properties of a msg_group_voice_call_nty.
         * @memberof net
         * @interface Imsg_group_voice_call_nty
         * @property {number|null} [uid] msg_group_voice_call_nty uid
         * @property {number|null} [ptime] msg_group_voice_call_nty ptime
         * @property {number|null} [groupkey] msg_group_voice_call_nty groupkey
         * @property {Uint8Array|null} [token] msg_group_voice_call_nty token
         */

        /**
         * Constructs a new msg_group_voice_call_nty.
         * @memberof net
         * @classdesc Represents a msg_group_voice_call_nty.
         * @implements Imsg_group_voice_call_nty
         * @constructor
         * @param {net.Imsg_group_voice_call_nty=} [properties] Properties to set
         */
        function msg_group_voice_call_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_voice_call_nty uid.
         * @member {number} uid
         * @memberof net.msg_group_voice_call_nty
         * @instance
         */
        msg_group_voice_call_nty.prototype.uid = 0;

        /**
         * msg_group_voice_call_nty ptime.
         * @member {number} ptime
         * @memberof net.msg_group_voice_call_nty
         * @instance
         */
        msg_group_voice_call_nty.prototype.ptime = 0;

        /**
         * msg_group_voice_call_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_voice_call_nty
         * @instance
         */
        msg_group_voice_call_nty.prototype.groupkey = 0;

        /**
         * msg_group_voice_call_nty token.
         * @member {Uint8Array} token
         * @memberof net.msg_group_voice_call_nty
         * @instance
         */
        msg_group_voice_call_nty.prototype.token = $util.newBuffer([]);

        /**
         * Creates a new msg_group_voice_call_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {net.Imsg_group_voice_call_nty=} [properties] Properties to set
         * @returns {net.msg_group_voice_call_nty} msg_group_voice_call_nty instance
         */
        msg_group_voice_call_nty.create = function create(properties) {
            return new msg_group_voice_call_nty(properties);
        };

        /**
         * Encodes the specified msg_group_voice_call_nty message. Does not implicitly {@link net.msg_group_voice_call_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {net.Imsg_group_voice_call_nty} message msg_group_voice_call_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ptime);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.groupkey);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.token);
            return writer;
        };

        /**
         * Encodes the specified msg_group_voice_call_nty message, length delimited. Does not implicitly {@link net.msg_group_voice_call_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {net.Imsg_group_voice_call_nty} message msg_group_voice_call_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_voice_call_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_voice_call_nty} msg_group_voice_call_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_voice_call_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.ptime = reader.int32();
                    break;
                case 3:
                    message.groupkey = reader.int32();
                    break;
                case 4:
                    message.token = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_voice_call_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_voice_call_nty} msg_group_voice_call_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_voice_call_nty message.
         * @function verify
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_voice_call_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                if (!$util.isInteger(message.ptime))
                    return "ptime: integer expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            return null;
        };

        /**
         * Creates a msg_group_voice_call_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_voice_call_nty} msg_group_voice_call_nty
         */
        msg_group_voice_call_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_voice_call_nty)
                return object;
            var message = new $root.net.msg_group_voice_call_nty();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.ptime != null)
                message.ptime = object.ptime | 0;
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length)
                    message.token = object.token;
            return message;
        };

        /**
         * Creates a plain object from a msg_group_voice_call_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_voice_call_nty
         * @static
         * @param {net.msg_group_voice_call_nty} message msg_group_voice_call_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_voice_call_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.ptime = 0;
                object.groupkey = 0;
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.ptime != null && message.hasOwnProperty("ptime"))
                object.ptime = message.ptime;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            return object;
        };

        /**
         * Converts this msg_group_voice_call_nty to JSON.
         * @function toJSON
         * @memberof net.msg_group_voice_call_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_voice_call_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_voice_call_nty;
    })();

    net.msg_group_voice_call_state_nty = (function() {

        /**
         * Properties of a msg_group_voice_call_state_nty.
         * @memberof net
         * @interface Imsg_group_voice_call_state_nty
         * @property {number|null} [groupkey] msg_group_voice_call_state_nty groupkey
         */

        /**
         * Constructs a new msg_group_voice_call_state_nty.
         * @memberof net
         * @classdesc Represents a msg_group_voice_call_state_nty.
         * @implements Imsg_group_voice_call_state_nty
         * @constructor
         * @param {net.Imsg_group_voice_call_state_nty=} [properties] Properties to set
         */
        function msg_group_voice_call_state_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_voice_call_state_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_voice_call_state_nty
         * @instance
         */
        msg_group_voice_call_state_nty.prototype.groupkey = 0;

        /**
         * Creates a new msg_group_voice_call_state_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {net.Imsg_group_voice_call_state_nty=} [properties] Properties to set
         * @returns {net.msg_group_voice_call_state_nty} msg_group_voice_call_state_nty instance
         */
        msg_group_voice_call_state_nty.create = function create(properties) {
            return new msg_group_voice_call_state_nty(properties);
        };

        /**
         * Encodes the specified msg_group_voice_call_state_nty message. Does not implicitly {@link net.msg_group_voice_call_state_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {net.Imsg_group_voice_call_state_nty} message msg_group_voice_call_state_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_state_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Encodes the specified msg_group_voice_call_state_nty message, length delimited. Does not implicitly {@link net.msg_group_voice_call_state_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {net.Imsg_group_voice_call_state_nty} message msg_group_voice_call_state_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_voice_call_state_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_group_voice_call_state_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_voice_call_state_nty} msg_group_voice_call_state_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_state_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_voice_call_state_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_group_voice_call_state_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_group_voice_call_state_nty} msg_group_voice_call_state_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_voice_call_state_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_group_voice_call_state_nty message.
         * @function verify
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_group_voice_call_state_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                if (!$util.isInteger(message.groupkey))
                    return "groupkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_group_voice_call_state_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_group_voice_call_state_nty} msg_group_voice_call_state_nty
         */
        msg_group_voice_call_state_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_group_voice_call_state_nty)
                return object;
            var message = new $root.net.msg_group_voice_call_state_nty();
            if (object.groupkey != null)
                message.groupkey = object.groupkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_group_voice_call_state_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_group_voice_call_state_nty
         * @static
         * @param {net.msg_group_voice_call_state_nty} message msg_group_voice_call_state_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_group_voice_call_state_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.groupkey = 0;
            if (message.groupkey != null && message.hasOwnProperty("groupkey"))
                object.groupkey = message.groupkey;
            return object;
        };

        /**
         * Converts this msg_group_voice_call_state_nty to JSON.
         * @function toJSON
         * @memberof net.msg_group_voice_call_state_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_group_voice_call_state_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_group_voice_call_state_nty;
    })();

    net.msg_php_msgbox_nty = (function() {

        /**
         * Properties of a msg_php_msgbox_nty.
         * @memberof net
         * @interface Imsg_php_msgbox_nty
         * @property {Uint8Array|null} [content] msg_php_msgbox_nty content
         */

        /**
         * Constructs a new msg_php_msgbox_nty.
         * @memberof net
         * @classdesc Represents a msg_php_msgbox_nty.
         * @implements Imsg_php_msgbox_nty
         * @constructor
         * @param {net.Imsg_php_msgbox_nty=} [properties] Properties to set
         */
        function msg_php_msgbox_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_php_msgbox_nty content.
         * @member {Uint8Array} content
         * @memberof net.msg_php_msgbox_nty
         * @instance
         */
        msg_php_msgbox_nty.prototype.content = $util.newBuffer([]);

        /**
         * Creates a new msg_php_msgbox_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {net.Imsg_php_msgbox_nty=} [properties] Properties to set
         * @returns {net.msg_php_msgbox_nty} msg_php_msgbox_nty instance
         */
        msg_php_msgbox_nty.create = function create(properties) {
            return new msg_php_msgbox_nty(properties);
        };

        /**
         * Encodes the specified msg_php_msgbox_nty message. Does not implicitly {@link net.msg_php_msgbox_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {net.Imsg_php_msgbox_nty} message msg_php_msgbox_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_php_msgbox_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
            return writer;
        };

        /**
         * Encodes the specified msg_php_msgbox_nty message, length delimited. Does not implicitly {@link net.msg_php_msgbox_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {net.Imsg_php_msgbox_nty} message msg_php_msgbox_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_php_msgbox_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_php_msgbox_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_php_msgbox_nty} msg_php_msgbox_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_php_msgbox_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_php_msgbox_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_php_msgbox_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_php_msgbox_nty} msg_php_msgbox_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_php_msgbox_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_php_msgbox_nty message.
         * @function verify
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_php_msgbox_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            return null;
        };

        /**
         * Creates a msg_php_msgbox_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_php_msgbox_nty} msg_php_msgbox_nty
         */
        msg_php_msgbox_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_php_msgbox_nty)
                return object;
            var message = new $root.net.msg_php_msgbox_nty();
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            return message;
        };

        /**
         * Creates a plain object from a msg_php_msgbox_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_php_msgbox_nty
         * @static
         * @param {net.msg_php_msgbox_nty} message msg_php_msgbox_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_php_msgbox_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            return object;
        };

        /**
         * Converts this msg_php_msgbox_nty to JSON.
         * @function toJSON
         * @memberof net.msg_php_msgbox_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_php_msgbox_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_php_msgbox_nty;
    })();

    net.msg_get_chatroom_list = (function() {

        /**
         * Properties of a msg_get_chatroom_list.
         * @memberof net
         * @interface Imsg_get_chatroom_list
         */

        /**
         * Constructs a new msg_get_chatroom_list.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_list.
         * @implements Imsg_get_chatroom_list
         * @constructor
         * @param {net.Imsg_get_chatroom_list=} [properties] Properties to set
         */
        function msg_get_chatroom_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new msg_get_chatroom_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {net.Imsg_get_chatroom_list=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_list} msg_get_chatroom_list instance
         */
        msg_get_chatroom_list.create = function create(properties) {
            return new msg_get_chatroom_list(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_list message. Does not implicitly {@link net.msg_get_chatroom_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {net.Imsg_get_chatroom_list} message msg_get_chatroom_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_list message, length delimited. Does not implicitly {@link net.msg_get_chatroom_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {net.Imsg_get_chatroom_list} message msg_get_chatroom_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_list} msg_get_chatroom_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_list} msg_get_chatroom_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_list message.
         * @function verify
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a msg_get_chatroom_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_list} msg_get_chatroom_list
         */
        msg_get_chatroom_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_list)
                return object;
            return new $root.net.msg_get_chatroom_list();
        };

        /**
         * Creates a plain object from a msg_get_chatroom_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {net.msg_get_chatroom_list} message msg_get_chatroom_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_list.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this msg_get_chatroom_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_list;
    })();

    net.msg_get_chatroom_list_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_list_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_list_rep
         * @property {Array.<net.Ichat_room_info>|null} [roomlist] msg_get_chatroom_list_rep roomlist
         */

        /**
         * Constructs a new msg_get_chatroom_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_list_rep.
         * @implements Imsg_get_chatroom_list_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_list_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_list_rep(properties) {
            this.roomlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_list_rep roomlist.
         * @member {Array.<net.Ichat_room_info>} roomlist
         * @memberof net.msg_get_chatroom_list_rep
         * @instance
         */
        msg_get_chatroom_list_rep.prototype.roomlist = $util.emptyArray;

        /**
         * Creates a new msg_get_chatroom_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_list_rep} msg_get_chatroom_list_rep instance
         */
        msg_get_chatroom_list_rep.create = function create(properties) {
            return new msg_get_chatroom_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_list_rep message. Does not implicitly {@link net.msg_get_chatroom_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_list_rep} message msg_get_chatroom_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomlist != null && message.roomlist.length)
                for (var i = 0; i < message.roomlist.length; ++i)
                    $root.net.chat_room_info.encode(message.roomlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_list_rep message, length delimited. Does not implicitly {@link net.msg_get_chatroom_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_list_rep} message msg_get_chatroom_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_list_rep} msg_get_chatroom_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.roomlist && message.roomlist.length))
                        message.roomlist = [];
                    message.roomlist.push($root.net.chat_room_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_list_rep} msg_get_chatroom_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_list_rep message.
         * @function verify
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomlist != null && message.hasOwnProperty("roomlist")) {
                if (!Array.isArray(message.roomlist))
                    return "roomlist: array expected";
                for (var i = 0; i < message.roomlist.length; ++i) {
                    var error = $root.net.chat_room_info.verify(message.roomlist[i]);
                    if (error)
                        return "roomlist." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_chatroom_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_list_rep} msg_get_chatroom_list_rep
         */
        msg_get_chatroom_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_list_rep)
                return object;
            var message = new $root.net.msg_get_chatroom_list_rep();
            if (object.roomlist) {
                if (!Array.isArray(object.roomlist))
                    throw TypeError(".net.msg_get_chatroom_list_rep.roomlist: array expected");
                message.roomlist = [];
                for (var i = 0; i < object.roomlist.length; ++i) {
                    if (typeof object.roomlist[i] !== "object")
                        throw TypeError(".net.msg_get_chatroom_list_rep.roomlist: object expected");
                    message.roomlist[i] = $root.net.chat_room_info.fromObject(object.roomlist[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {net.msg_get_chatroom_list_rep} message msg_get_chatroom_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.roomlist = [];
            if (message.roomlist && message.roomlist.length) {
                object.roomlist = [];
                for (var j = 0; j < message.roomlist.length; ++j)
                    object.roomlist[j] = $root.net.chat_room_info.toObject(message.roomlist[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_chatroom_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_list_rep;
    })();

    net.msg_get_chatroom_members = (function() {

        /**
         * Properties of a msg_get_chatroom_members.
         * @memberof net
         * @interface Imsg_get_chatroom_members
         * @property {number|null} [roomkey] msg_get_chatroom_members roomkey
         * @property {number|null} [page] msg_get_chatroom_members page
         * @property {number|null} [limit] msg_get_chatroom_members limit
         */

        /**
         * Constructs a new msg_get_chatroom_members.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_members.
         * @implements Imsg_get_chatroom_members
         * @constructor
         * @param {net.Imsg_get_chatroom_members=} [properties] Properties to set
         */
        function msg_get_chatroom_members(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_members roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.roomkey = 0;

        /**
         * msg_get_chatroom_members page.
         * @member {number} page
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.page = 0;

        /**
         * msg_get_chatroom_members limit.
         * @member {number} limit
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.limit = 0;

        /**
         * Creates a new msg_get_chatroom_members instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {net.Imsg_get_chatroom_members=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_members} msg_get_chatroom_members instance
         */
        msg_get_chatroom_members.create = function create(properties) {
            return new msg_get_chatroom_members(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_members message. Does not implicitly {@link net.msg_get_chatroom_members.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {net.Imsg_get_chatroom_members} message msg_get_chatroom_members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.page);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.limit);
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_members message, length delimited. Does not implicitly {@link net.msg_get_chatroom_members.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {net.Imsg_get_chatroom_members} message msg_get_chatroom_members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_members message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_members} msg_get_chatroom_members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_members();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.page = reader.int32();
                    break;
                case 3:
                    message.limit = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_members message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_members} msg_get_chatroom_members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_members message.
         * @function verify
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_members.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.page != null && message.hasOwnProperty("page"))
                if (!$util.isInteger(message.page))
                    return "page: integer expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_chatroom_members message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_members} msg_get_chatroom_members
         */
        msg_get_chatroom_members.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_members)
                return object;
            var message = new $root.net.msg_get_chatroom_members();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.page != null)
                message.page = object.page | 0;
            if (object.limit != null)
                message.limit = object.limit | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_members message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {net.msg_get_chatroom_members} message msg_get_chatroom_members
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_members.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.page = 0;
                object.limit = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.page != null && message.hasOwnProperty("page"))
                object.page = message.page;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this msg_get_chatroom_members to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_members
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_members.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_members;
    })();

    net.msg_get_chatroom_members_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_members_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_members_rep
         * @property {number|null} [result] msg_get_chatroom_members_rep result
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_chatroom_members_rep users
         * @property {number|null} [usercnt] msg_get_chatroom_members_rep usercnt
         */

        /**
         * Constructs a new msg_get_chatroom_members_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_members_rep.
         * @implements Imsg_get_chatroom_members_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_members_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_members_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_members_rep result.
         * @member {number} result
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.result = 0;

        /**
         * msg_get_chatroom_members_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_chatroom_members_rep usercnt.
         * @member {number} usercnt
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.usercnt = 0;

        /**
         * Creates a new msg_get_chatroom_members_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {net.Imsg_get_chatroom_members_rep=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_members_rep} msg_get_chatroom_members_rep instance
         */
        msg_get_chatroom_members_rep.create = function create(properties) {
            return new msg_get_chatroom_members_rep(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_members_rep message. Does not implicitly {@link net.msg_get_chatroom_members_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {net.Imsg_get_chatroom_members_rep} message msg_get_chatroom_members_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.usercnt != null && Object.hasOwnProperty.call(message, "usercnt"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.usercnt);
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_members_rep message, length delimited. Does not implicitly {@link net.msg_get_chatroom_members_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {net.Imsg_get_chatroom_members_rep} message msg_get_chatroom_members_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_members_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_members_rep} msg_get_chatroom_members_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_members_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.usercnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_members_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_members_rep} msg_get_chatroom_members_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_members_rep message.
         * @function verify
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_members_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            if (message.usercnt != null && message.hasOwnProperty("usercnt"))
                if (!$util.isInteger(message.usercnt))
                    return "usercnt: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_chatroom_members_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_members_rep} msg_get_chatroom_members_rep
         */
        msg_get_chatroom_members_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_members_rep)
                return object;
            var message = new $root.net.msg_get_chatroom_members_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_chatroom_members_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_chatroom_members_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            if (object.usercnt != null)
                message.usercnt = object.usercnt | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_members_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {net.msg_get_chatroom_members_rep} message msg_get_chatroom_members_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_members_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.result = 0;
                object.usercnt = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            if (message.usercnt != null && message.hasOwnProperty("usercnt"))
                object.usercnt = message.usercnt;
            return object;
        };

        /**
         * Converts this msg_get_chatroom_members_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_members_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_members_rep;
    })();

    net.msg_join_chatroom = (function() {

        /**
         * Properties of a msg_join_chatroom.
         * @memberof net
         * @interface Imsg_join_chatroom
         * @property {number|null} [roomkey] msg_join_chatroom roomkey
         */

        /**
         * Constructs a new msg_join_chatroom.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom.
         * @implements Imsg_join_chatroom
         * @constructor
         * @param {net.Imsg_join_chatroom=} [properties] Properties to set
         */
        function msg_join_chatroom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom roomkey.
         * @member {number} roomkey
         * @memberof net.msg_join_chatroom
         * @instance
         */
        msg_join_chatroom.prototype.roomkey = 0;

        /**
         * Creates a new msg_join_chatroom instance using the specified properties.
         * @function create
         * @memberof net.msg_join_chatroom
         * @static
         * @param {net.Imsg_join_chatroom=} [properties] Properties to set
         * @returns {net.msg_join_chatroom} msg_join_chatroom instance
         */
        msg_join_chatroom.create = function create(properties) {
            return new msg_join_chatroom(properties);
        };

        /**
         * Encodes the specified msg_join_chatroom message. Does not implicitly {@link net.msg_join_chatroom.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom
         * @static
         * @param {net.Imsg_join_chatroom} message msg_join_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Encodes the specified msg_join_chatroom message, length delimited. Does not implicitly {@link net.msg_join_chatroom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_join_chatroom
         * @static
         * @param {net.Imsg_join_chatroom} message msg_join_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_join_chatroom message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom} msg_join_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_join_chatroom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_join_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_join_chatroom} msg_join_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_join_chatroom message.
         * @function verify
         * @memberof net.msg_join_chatroom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_join_chatroom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_join_chatroom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_join_chatroom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_join_chatroom} msg_join_chatroom
         */
        msg_join_chatroom.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_join_chatroom)
                return object;
            var message = new $root.net.msg_join_chatroom();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_join_chatroom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_join_chatroom
         * @static
         * @param {net.msg_join_chatroom} message msg_join_chatroom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_join_chatroom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            return object;
        };

        /**
         * Converts this msg_join_chatroom to JSON.
         * @function toJSON
         * @memberof net.msg_join_chatroom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_join_chatroom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_join_chatroom;
    })();

    net.msg_join_chatroom_rep = (function() {

        /**
         * Properties of a msg_join_chatroom_rep.
         * @memberof net
         * @interface Imsg_join_chatroom_rep
         * @property {number|null} [result] msg_join_chatroom_rep result
         * @property {net.Ichat_room_info|null} [room_info] msg_join_chatroom_rep room_info
         */

        /**
         * Constructs a new msg_join_chatroom_rep.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom_rep.
         * @implements Imsg_join_chatroom_rep
         * @constructor
         * @param {net.Imsg_join_chatroom_rep=} [properties] Properties to set
         */
        function msg_join_chatroom_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom_rep result.
         * @member {number} result
         * @memberof net.msg_join_chatroom_rep
         * @instance
         */
        msg_join_chatroom_rep.prototype.result = 0;

        /**
         * msg_join_chatroom_rep room_info.
         * @member {net.Ichat_room_info|null|undefined} room_info
         * @memberof net.msg_join_chatroom_rep
         * @instance
         */
        msg_join_chatroom_rep.prototype.room_info = null;

        /**
         * Creates a new msg_join_chatroom_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {net.Imsg_join_chatroom_rep=} [properties] Properties to set
         * @returns {net.msg_join_chatroom_rep} msg_join_chatroom_rep instance
         */
        msg_join_chatroom_rep.create = function create(properties) {
            return new msg_join_chatroom_rep(properties);
        };

        /**
         * Encodes the specified msg_join_chatroom_rep message. Does not implicitly {@link net.msg_join_chatroom_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {net.Imsg_join_chatroom_rep} message msg_join_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.room_info != null && Object.hasOwnProperty.call(message, "room_info"))
                $root.net.chat_room_info.encode(message.room_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_join_chatroom_rep message, length delimited. Does not implicitly {@link net.msg_join_chatroom_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {net.Imsg_join_chatroom_rep} message msg_join_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_join_chatroom_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom_rep} msg_join_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.room_info = $root.net.chat_room_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_join_chatroom_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_join_chatroom_rep} msg_join_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_join_chatroom_rep message.
         * @function verify
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_join_chatroom_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.room_info != null && message.hasOwnProperty("room_info")) {
                var error = $root.net.chat_room_info.verify(message.room_info);
                if (error)
                    return "room_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_join_chatroom_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_join_chatroom_rep} msg_join_chatroom_rep
         */
        msg_join_chatroom_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_join_chatroom_rep)
                return object;
            var message = new $root.net.msg_join_chatroom_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.room_info != null) {
                if (typeof object.room_info !== "object")
                    throw TypeError(".net.msg_join_chatroom_rep.room_info: object expected");
                message.room_info = $root.net.chat_room_info.fromObject(object.room_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_join_chatroom_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {net.msg_join_chatroom_rep} message msg_join_chatroom_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_join_chatroom_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.room_info = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.room_info != null && message.hasOwnProperty("room_info"))
                object.room_info = $root.net.chat_room_info.toObject(message.room_info, options);
            return object;
        };

        /**
         * Converts this msg_join_chatroom_rep to JSON.
         * @function toJSON
         * @memberof net.msg_join_chatroom_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_join_chatroom_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_join_chatroom_rep;
    })();

    net.msg_quit_chatroom = (function() {

        /**
         * Properties of a msg_quit_chatroom.
         * @memberof net
         * @interface Imsg_quit_chatroom
         * @property {number|null} [roomkey] msg_quit_chatroom roomkey
         */

        /**
         * Constructs a new msg_quit_chatroom.
         * @memberof net
         * @classdesc Represents a msg_quit_chatroom.
         * @implements Imsg_quit_chatroom
         * @constructor
         * @param {net.Imsg_quit_chatroom=} [properties] Properties to set
         */
        function msg_quit_chatroom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_quit_chatroom roomkey.
         * @member {number} roomkey
         * @memberof net.msg_quit_chatroom
         * @instance
         */
        msg_quit_chatroom.prototype.roomkey = 0;

        /**
         * Creates a new msg_quit_chatroom instance using the specified properties.
         * @function create
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {net.Imsg_quit_chatroom=} [properties] Properties to set
         * @returns {net.msg_quit_chatroom} msg_quit_chatroom instance
         */
        msg_quit_chatroom.create = function create(properties) {
            return new msg_quit_chatroom(properties);
        };

        /**
         * Encodes the specified msg_quit_chatroom message. Does not implicitly {@link net.msg_quit_chatroom.verify|verify} messages.
         * @function encode
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {net.Imsg_quit_chatroom} message msg_quit_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Encodes the specified msg_quit_chatroom message, length delimited. Does not implicitly {@link net.msg_quit_chatroom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {net.Imsg_quit_chatroom} message msg_quit_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_quit_chatroom message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_quit_chatroom} msg_quit_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_quit_chatroom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_quit_chatroom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_quit_chatroom} msg_quit_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_quit_chatroom message.
         * @function verify
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_quit_chatroom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_quit_chatroom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_quit_chatroom} msg_quit_chatroom
         */
        msg_quit_chatroom.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_quit_chatroom)
                return object;
            var message = new $root.net.msg_quit_chatroom();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_quit_chatroom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {net.msg_quit_chatroom} message msg_quit_chatroom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_quit_chatroom.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            return object;
        };

        /**
         * Converts this msg_quit_chatroom to JSON.
         * @function toJSON
         * @memberof net.msg_quit_chatroom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_quit_chatroom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_quit_chatroom;
    })();

    net.msg_quit_chatroom_rep = (function() {

        /**
         * Properties of a msg_quit_chatroom_rep.
         * @memberof net
         * @interface Imsg_quit_chatroom_rep
         * @property {number|null} [result] msg_quit_chatroom_rep result
         */

        /**
         * Constructs a new msg_quit_chatroom_rep.
         * @memberof net
         * @classdesc Represents a msg_quit_chatroom_rep.
         * @implements Imsg_quit_chatroom_rep
         * @constructor
         * @param {net.Imsg_quit_chatroom_rep=} [properties] Properties to set
         */
        function msg_quit_chatroom_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_quit_chatroom_rep result.
         * @member {number} result
         * @memberof net.msg_quit_chatroom_rep
         * @instance
         */
        msg_quit_chatroom_rep.prototype.result = 0;

        /**
         * Creates a new msg_quit_chatroom_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {net.Imsg_quit_chatroom_rep=} [properties] Properties to set
         * @returns {net.msg_quit_chatroom_rep} msg_quit_chatroom_rep instance
         */
        msg_quit_chatroom_rep.create = function create(properties) {
            return new msg_quit_chatroom_rep(properties);
        };

        /**
         * Encodes the specified msg_quit_chatroom_rep message. Does not implicitly {@link net.msg_quit_chatroom_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {net.Imsg_quit_chatroom_rep} message msg_quit_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_quit_chatroom_rep message, length delimited. Does not implicitly {@link net.msg_quit_chatroom_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {net.Imsg_quit_chatroom_rep} message msg_quit_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_quit_chatroom_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_quit_chatroom_rep} msg_quit_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_quit_chatroom_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_quit_chatroom_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_quit_chatroom_rep} msg_quit_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_quit_chatroom_rep message.
         * @function verify
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_quit_chatroom_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_quit_chatroom_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_quit_chatroom_rep} msg_quit_chatroom_rep
         */
        msg_quit_chatroom_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_quit_chatroom_rep)
                return object;
            var message = new $root.net.msg_quit_chatroom_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_quit_chatroom_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {net.msg_quit_chatroom_rep} message msg_quit_chatroom_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_quit_chatroom_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_quit_chatroom_rep to JSON.
         * @function toJSON
         * @memberof net.msg_quit_chatroom_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_quit_chatroom_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_quit_chatroom_rep;
    })();

    net.msg_send_chatroom_msg = (function() {

        /**
         * Properties of a msg_send_chatroom_msg.
         * @memberof net
         * @interface Imsg_send_chatroom_msg
         * @property {number|null} [roomkey] msg_send_chatroom_msg roomkey
         * @property {number|null} [msg_type] msg_send_chatroom_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_chatroom_msg content
         */

        /**
         * Constructs a new msg_send_chatroom_msg.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_msg.
         * @implements Imsg_send_chatroom_msg
         * @constructor
         * @param {net.Imsg_send_chatroom_msg=} [properties] Properties to set
         */
        function msg_send_chatroom_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.msg_type = 0;

        /**
         * msg_send_chatroom_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.content = $util.newBuffer([]);

        /**
         * Creates a new msg_send_chatroom_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {net.Imsg_send_chatroom_msg=} [properties] Properties to set
         * @returns {net.msg_send_chatroom_msg} msg_send_chatroom_msg instance
         */
        msg_send_chatroom_msg.create = function create(properties) {
            return new msg_send_chatroom_msg(properties);
        };

        /**
         * Encodes the specified msg_send_chatroom_msg message. Does not implicitly {@link net.msg_send_chatroom_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {net.Imsg_send_chatroom_msg} message msg_send_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            return writer;
        };

        /**
         * Encodes the specified msg_send_chatroom_msg message, length delimited. Does not implicitly {@link net.msg_send_chatroom_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {net.Imsg_send_chatroom_msg} message msg_send_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_chatroom_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_msg} msg_send_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_chatroom_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_chatroom_msg} msg_send_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_chatroom_msg message.
         * @function verify
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_chatroom_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                if (!$util.isInteger(message.msg_type))
                    return "msg_type: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            return null;
        };

        /**
         * Creates a msg_send_chatroom_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_chatroom_msg} msg_send_chatroom_msg
         */
        msg_send_chatroom_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_chatroom_msg)
                return object;
            var message = new $root.net.msg_send_chatroom_msg();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.msg_type != null)
                message.msg_type = object.msg_type | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            return message;
        };

        /**
         * Creates a plain object from a msg_send_chatroom_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {net.msg_send_chatroom_msg} message msg_send_chatroom_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_chatroom_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.msg_type = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.msg_type != null && message.hasOwnProperty("msg_type"))
                object.msg_type = message.msg_type;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            return object;
        };

        /**
         * Converts this msg_send_chatroom_msg to JSON.
         * @function toJSON
         * @memberof net.msg_send_chatroom_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_chatroom_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_chatroom_msg;
    })();

    net.msg_send_chatroom_msg_rep = (function() {

        /**
         * Properties of a msg_send_chatroom_msg_rep.
         * @memberof net
         * @interface Imsg_send_chatroom_msg_rep
         * @property {number|null} [result] msg_send_chatroom_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_chatroom_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_chatroom_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_msg_rep.
         * @implements Imsg_send_chatroom_msg_rep
         * @constructor
         * @param {net.Imsg_send_chatroom_msg_rep=} [properties] Properties to set
         */
        function msg_send_chatroom_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_chatroom_msg_rep
         * @instance
         */
        msg_send_chatroom_msg_rep.prototype.result = 0;

        /**
         * msg_send_chatroom_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_chatroom_msg_rep
         * @instance
         */
        msg_send_chatroom_msg_rep.prototype.msg_info = null;

        /**
         * Creates a new msg_send_chatroom_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {net.Imsg_send_chatroom_msg_rep=} [properties] Properties to set
         * @returns {net.msg_send_chatroom_msg_rep} msg_send_chatroom_msg_rep instance
         */
        msg_send_chatroom_msg_rep.create = function create(properties) {
            return new msg_send_chatroom_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_send_chatroom_msg_rep message. Does not implicitly {@link net.msg_send_chatroom_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {net.Imsg_send_chatroom_msg_rep} message msg_send_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_send_chatroom_msg_rep message, length delimited. Does not implicitly {@link net.msg_send_chatroom_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {net.Imsg_send_chatroom_msg_rep} message msg_send_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_chatroom_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_msg_rep} msg_send_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_chatroom_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_chatroom_msg_rep} msg_send_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_chatroom_msg_rep message.
         * @function verify
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_chatroom_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.msg_info != null && message.hasOwnProperty("msg_info")) {
                var error = $root.net.chat_msg.verify(message.msg_info);
                if (error)
                    return "msg_info." + error;
            }
            return null;
        };

        /**
         * Creates a msg_send_chatroom_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_chatroom_msg_rep} msg_send_chatroom_msg_rep
         */
        msg_send_chatroom_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_chatroom_msg_rep)
                return object;
            var message = new $root.net.msg_send_chatroom_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.msg_info != null) {
                if (typeof object.msg_info !== "object")
                    throw TypeError(".net.msg_send_chatroom_msg_rep.msg_info: object expected");
                message.msg_info = $root.net.chat_msg.fromObject(object.msg_info);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_send_chatroom_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {net.msg_send_chatroom_msg_rep} message msg_send_chatroom_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_chatroom_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.msg_info = null;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.msg_info != null && message.hasOwnProperty("msg_info"))
                object.msg_info = $root.net.chat_msg.toObject(message.msg_info, options);
            return object;
        };

        /**
         * Converts this msg_send_chatroom_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_send_chatroom_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_chatroom_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_chatroom_msg_rep;
    })();

    net.msg_chatroom_kickout = (function() {

        /**
         * Properties of a msg_chatroom_kickout.
         * @memberof net
         * @interface Imsg_chatroom_kickout
         * @property {number|null} [roomkey] msg_chatroom_kickout roomkey
         * @property {number|null} [kickuid] msg_chatroom_kickout kickuid
         */

        /**
         * Constructs a new msg_chatroom_kickout.
         * @memberof net
         * @classdesc Represents a msg_chatroom_kickout.
         * @implements Imsg_chatroom_kickout
         * @constructor
         * @param {net.Imsg_chatroom_kickout=} [properties] Properties to set
         */
        function msg_chatroom_kickout(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_kickout roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_kickout
         * @instance
         */
        msg_chatroom_kickout.prototype.roomkey = 0;

        /**
         * msg_chatroom_kickout kickuid.
         * @member {number} kickuid
         * @memberof net.msg_chatroom_kickout
         * @instance
         */
        msg_chatroom_kickout.prototype.kickuid = 0;

        /**
         * Creates a new msg_chatroom_kickout instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {net.Imsg_chatroom_kickout=} [properties] Properties to set
         * @returns {net.msg_chatroom_kickout} msg_chatroom_kickout instance
         */
        msg_chatroom_kickout.create = function create(properties) {
            return new msg_chatroom_kickout(properties);
        };

        /**
         * Encodes the specified msg_chatroom_kickout message. Does not implicitly {@link net.msg_chatroom_kickout.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {net.Imsg_chatroom_kickout} message msg_chatroom_kickout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.kickuid != null && Object.hasOwnProperty.call(message, "kickuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.kickuid);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_kickout message, length delimited. Does not implicitly {@link net.msg_chatroom_kickout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {net.Imsg_chatroom_kickout} message msg_chatroom_kickout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_kickout message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_kickout} msg_chatroom_kickout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_kickout();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.kickuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_kickout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_kickout} msg_chatroom_kickout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_kickout message.
         * @function verify
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_kickout.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.kickuid != null && message.hasOwnProperty("kickuid"))
                if (!$util.isInteger(message.kickuid))
                    return "kickuid: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_kickout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_kickout} msg_chatroom_kickout
         */
        msg_chatroom_kickout.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_kickout)
                return object;
            var message = new $root.net.msg_chatroom_kickout();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.kickuid != null)
                message.kickuid = object.kickuid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_kickout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {net.msg_chatroom_kickout} message msg_chatroom_kickout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_kickout.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.kickuid = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.kickuid != null && message.hasOwnProperty("kickuid"))
                object.kickuid = message.kickuid;
            return object;
        };

        /**
         * Converts this msg_chatroom_kickout to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_kickout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_kickout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_kickout;
    })();

    net.msg_chatroom_kickout_rep = (function() {

        /**
         * Properties of a msg_chatroom_kickout_rep.
         * @memberof net
         * @interface Imsg_chatroom_kickout_rep
         * @property {number|null} [result] msg_chatroom_kickout_rep result
         * @property {number|null} [kickuid] msg_chatroom_kickout_rep kickuid
         */

        /**
         * Constructs a new msg_chatroom_kickout_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_kickout_rep.
         * @implements Imsg_chatroom_kickout_rep
         * @constructor
         * @param {net.Imsg_chatroom_kickout_rep=} [properties] Properties to set
         */
        function msg_chatroom_kickout_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_kickout_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_kickout_rep
         * @instance
         */
        msg_chatroom_kickout_rep.prototype.result = 0;

        /**
         * msg_chatroom_kickout_rep kickuid.
         * @member {number} kickuid
         * @memberof net.msg_chatroom_kickout_rep
         * @instance
         */
        msg_chatroom_kickout_rep.prototype.kickuid = 0;

        /**
         * Creates a new msg_chatroom_kickout_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {net.Imsg_chatroom_kickout_rep=} [properties] Properties to set
         * @returns {net.msg_chatroom_kickout_rep} msg_chatroom_kickout_rep instance
         */
        msg_chatroom_kickout_rep.create = function create(properties) {
            return new msg_chatroom_kickout_rep(properties);
        };

        /**
         * Encodes the specified msg_chatroom_kickout_rep message. Does not implicitly {@link net.msg_chatroom_kickout_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {net.Imsg_chatroom_kickout_rep} message msg_chatroom_kickout_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.kickuid != null && Object.hasOwnProperty.call(message, "kickuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.kickuid);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_kickout_rep message, length delimited. Does not implicitly {@link net.msg_chatroom_kickout_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {net.Imsg_chatroom_kickout_rep} message msg_chatroom_kickout_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_kickout_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_kickout_rep} msg_chatroom_kickout_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_kickout_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.kickuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_kickout_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_kickout_rep} msg_chatroom_kickout_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_kickout_rep message.
         * @function verify
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_kickout_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.kickuid != null && message.hasOwnProperty("kickuid"))
                if (!$util.isInteger(message.kickuid))
                    return "kickuid: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_kickout_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_kickout_rep} msg_chatroom_kickout_rep
         */
        msg_chatroom_kickout_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_kickout_rep)
                return object;
            var message = new $root.net.msg_chatroom_kickout_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.kickuid != null)
                message.kickuid = object.kickuid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_kickout_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {net.msg_chatroom_kickout_rep} message msg_chatroom_kickout_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_kickout_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.kickuid = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.kickuid != null && message.hasOwnProperty("kickuid"))
                object.kickuid = message.kickuid;
            return object;
        };

        /**
         * Converts this msg_chatroom_kickout_rep to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_kickout_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_kickout_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_kickout_rep;
    })();

    net.msg_chatroom_forbid = (function() {

        /**
         * Properties of a msg_chatroom_forbid.
         * @memberof net
         * @interface Imsg_chatroom_forbid
         * @property {number|null} [roomkey] msg_chatroom_forbid roomkey
         * @property {number|null} [uid] msg_chatroom_forbid uid
         * @property {number|null} [is_set] msg_chatroom_forbid is_set
         */

        /**
         * Constructs a new msg_chatroom_forbid.
         * @memberof net
         * @classdesc Represents a msg_chatroom_forbid.
         * @implements Imsg_chatroom_forbid
         * @constructor
         * @param {net.Imsg_chatroom_forbid=} [properties] Properties to set
         */
        function msg_chatroom_forbid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_forbid roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.roomkey = 0;

        /**
         * msg_chatroom_forbid uid.
         * @member {number} uid
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.uid = 0;

        /**
         * msg_chatroom_forbid is_set.
         * @member {number} is_set
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.is_set = 0;

        /**
         * Creates a new msg_chatroom_forbid instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {net.Imsg_chatroom_forbid=} [properties] Properties to set
         * @returns {net.msg_chatroom_forbid} msg_chatroom_forbid instance
         */
        msg_chatroom_forbid.create = function create(properties) {
            return new msg_chatroom_forbid(properties);
        };

        /**
         * Encodes the specified msg_chatroom_forbid message. Does not implicitly {@link net.msg_chatroom_forbid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {net.Imsg_chatroom_forbid} message msg_chatroom_forbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_set);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_forbid message, length delimited. Does not implicitly {@link net.msg_chatroom_forbid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {net.Imsg_chatroom_forbid} message msg_chatroom_forbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_forbid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_forbid} msg_chatroom_forbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_forbid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.is_set = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_forbid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_forbid} msg_chatroom_forbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_forbid message.
         * @function verify
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_forbid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                if (!$util.isInteger(message.is_set))
                    return "is_set: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_forbid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_forbid} msg_chatroom_forbid
         */
        msg_chatroom_forbid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_forbid)
                return object;
            var message = new $root.net.msg_chatroom_forbid();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.is_set != null)
                message.is_set = object.is_set | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_forbid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {net.msg_chatroom_forbid} message msg_chatroom_forbid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_forbid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.uid = 0;
                object.is_set = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                object.is_set = message.is_set;
            return object;
        };

        /**
         * Converts this msg_chatroom_forbid to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_forbid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_forbid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_forbid;
    })();

    net.msg_chatroom_forbid_rep = (function() {

        /**
         * Properties of a msg_chatroom_forbid_rep.
         * @memberof net
         * @interface Imsg_chatroom_forbid_rep
         * @property {number|null} [result] msg_chatroom_forbid_rep result
         */

        /**
         * Constructs a new msg_chatroom_forbid_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_forbid_rep.
         * @implements Imsg_chatroom_forbid_rep
         * @constructor
         * @param {net.Imsg_chatroom_forbid_rep=} [properties] Properties to set
         */
        function msg_chatroom_forbid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_forbid_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_forbid_rep
         * @instance
         */
        msg_chatroom_forbid_rep.prototype.result = 0;

        /**
         * Creates a new msg_chatroom_forbid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {net.Imsg_chatroom_forbid_rep=} [properties] Properties to set
         * @returns {net.msg_chatroom_forbid_rep} msg_chatroom_forbid_rep instance
         */
        msg_chatroom_forbid_rep.create = function create(properties) {
            return new msg_chatroom_forbid_rep(properties);
        };

        /**
         * Encodes the specified msg_chatroom_forbid_rep message. Does not implicitly {@link net.msg_chatroom_forbid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {net.Imsg_chatroom_forbid_rep} message msg_chatroom_forbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_forbid_rep message, length delimited. Does not implicitly {@link net.msg_chatroom_forbid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {net.Imsg_chatroom_forbid_rep} message msg_chatroom_forbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_forbid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_forbid_rep} msg_chatroom_forbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_forbid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_forbid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_forbid_rep} msg_chatroom_forbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_forbid_rep message.
         * @function verify
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_forbid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_forbid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_forbid_rep} msg_chatroom_forbid_rep
         */
        msg_chatroom_forbid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_forbid_rep)
                return object;
            var message = new $root.net.msg_chatroom_forbid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_forbid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {net.msg_chatroom_forbid_rep} message msg_chatroom_forbid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_forbid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_chatroom_forbid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_forbid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_forbid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_forbid_rep;
    })();

    net.msg_chatroom_admin = (function() {

        /**
         * Properties of a msg_chatroom_admin.
         * @memberof net
         * @interface Imsg_chatroom_admin
         * @property {number|null} [roomkey] msg_chatroom_admin roomkey
         * @property {number|null} [uid] msg_chatroom_admin uid
         * @property {number|null} [is_set] msg_chatroom_admin is_set
         */

        /**
         * Constructs a new msg_chatroom_admin.
         * @memberof net
         * @classdesc Represents a msg_chatroom_admin.
         * @implements Imsg_chatroom_admin
         * @constructor
         * @param {net.Imsg_chatroom_admin=} [properties] Properties to set
         */
        function msg_chatroom_admin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_admin roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.roomkey = 0;

        /**
         * msg_chatroom_admin uid.
         * @member {number} uid
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.uid = 0;

        /**
         * msg_chatroom_admin is_set.
         * @member {number} is_set
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.is_set = 0;

        /**
         * Creates a new msg_chatroom_admin instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {net.Imsg_chatroom_admin=} [properties] Properties to set
         * @returns {net.msg_chatroom_admin} msg_chatroom_admin instance
         */
        msg_chatroom_admin.create = function create(properties) {
            return new msg_chatroom_admin(properties);
        };

        /**
         * Encodes the specified msg_chatroom_admin message. Does not implicitly {@link net.msg_chatroom_admin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {net.Imsg_chatroom_admin} message msg_chatroom_admin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_set);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_admin message, length delimited. Does not implicitly {@link net.msg_chatroom_admin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {net.Imsg_chatroom_admin} message msg_chatroom_admin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_admin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_admin} msg_chatroom_admin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_admin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.is_set = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_admin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_admin} msg_chatroom_admin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_admin message.
         * @function verify
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_admin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                if (!$util.isInteger(message.is_set))
                    return "is_set: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_admin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_admin} msg_chatroom_admin
         */
        msg_chatroom_admin.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_admin)
                return object;
            var message = new $root.net.msg_chatroom_admin();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.is_set != null)
                message.is_set = object.is_set | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_admin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {net.msg_chatroom_admin} message msg_chatroom_admin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_admin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.uid = 0;
                object.is_set = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                object.is_set = message.is_set;
            return object;
        };

        /**
         * Converts this msg_chatroom_admin to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_admin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_admin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_admin;
    })();

    net.msg_chatroom_admin_rep = (function() {

        /**
         * Properties of a msg_chatroom_admin_rep.
         * @memberof net
         * @interface Imsg_chatroom_admin_rep
         * @property {number|null} [result] msg_chatroom_admin_rep result
         */

        /**
         * Constructs a new msg_chatroom_admin_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_admin_rep.
         * @implements Imsg_chatroom_admin_rep
         * @constructor
         * @param {net.Imsg_chatroom_admin_rep=} [properties] Properties to set
         */
        function msg_chatroom_admin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_admin_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_admin_rep
         * @instance
         */
        msg_chatroom_admin_rep.prototype.result = 0;

        /**
         * Creates a new msg_chatroom_admin_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {net.Imsg_chatroom_admin_rep=} [properties] Properties to set
         * @returns {net.msg_chatroom_admin_rep} msg_chatroom_admin_rep instance
         */
        msg_chatroom_admin_rep.create = function create(properties) {
            return new msg_chatroom_admin_rep(properties);
        };

        /**
         * Encodes the specified msg_chatroom_admin_rep message. Does not implicitly {@link net.msg_chatroom_admin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {net.Imsg_chatroom_admin_rep} message msg_chatroom_admin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_admin_rep message, length delimited. Does not implicitly {@link net.msg_chatroom_admin_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {net.Imsg_chatroom_admin_rep} message msg_chatroom_admin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_admin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_admin_rep} msg_chatroom_admin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_admin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_admin_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_admin_rep} msg_chatroom_admin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_admin_rep message.
         * @function verify
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_admin_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_admin_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_admin_rep} msg_chatroom_admin_rep
         */
        msg_chatroom_admin_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_admin_rep)
                return object;
            var message = new $root.net.msg_chatroom_admin_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_admin_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {net.msg_chatroom_admin_rep} message msg_chatroom_admin_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_admin_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_chatroom_admin_rep to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_admin_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_admin_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_admin_rep;
    })();

    net.msg_del_chatroom_msg = (function() {

        /**
         * Properties of a msg_del_chatroom_msg.
         * @memberof net
         * @interface Imsg_del_chatroom_msg
         * @property {number|null} [roomkey] msg_del_chatroom_msg roomkey
         * @property {number|null} [msgno] msg_del_chatroom_msg msgno
         */

        /**
         * Constructs a new msg_del_chatroom_msg.
         * @memberof net
         * @classdesc Represents a msg_del_chatroom_msg.
         * @implements Imsg_del_chatroom_msg
         * @constructor
         * @param {net.Imsg_del_chatroom_msg=} [properties] Properties to set
         */
        function msg_del_chatroom_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chatroom_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_del_chatroom_msg
         * @instance
         */
        msg_del_chatroom_msg.prototype.roomkey = 0;

        /**
         * msg_del_chatroom_msg msgno.
         * @member {number} msgno
         * @memberof net.msg_del_chatroom_msg
         * @instance
         */
        msg_del_chatroom_msg.prototype.msgno = 0;

        /**
         * Creates a new msg_del_chatroom_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {net.Imsg_del_chatroom_msg=} [properties] Properties to set
         * @returns {net.msg_del_chatroom_msg} msg_del_chatroom_msg instance
         */
        msg_del_chatroom_msg.create = function create(properties) {
            return new msg_del_chatroom_msg(properties);
        };

        /**
         * Encodes the specified msg_del_chatroom_msg message. Does not implicitly {@link net.msg_del_chatroom_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {net.Imsg_del_chatroom_msg} message msg_del_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msgno != null && Object.hasOwnProperty.call(message, "msgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msgno);
            return writer;
        };

        /**
         * Encodes the specified msg_del_chatroom_msg message, length delimited. Does not implicitly {@link net.msg_del_chatroom_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {net.Imsg_del_chatroom_msg} message msg_del_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_chatroom_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chatroom_msg} msg_del_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chatroom_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.msgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_chatroom_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_chatroom_msg} msg_del_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_chatroom_msg message.
         * @function verify
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_chatroom_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.msgno != null && message.hasOwnProperty("msgno"))
                if (!$util.isInteger(message.msgno))
                    return "msgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_del_chatroom_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_chatroom_msg} msg_del_chatroom_msg
         */
        msg_del_chatroom_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_chatroom_msg)
                return object;
            var message = new $root.net.msg_del_chatroom_msg();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.msgno != null)
                message.msgno = object.msgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_del_chatroom_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {net.msg_del_chatroom_msg} message msg_del_chatroom_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_chatroom_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.msgno = 0;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.msgno != null && message.hasOwnProperty("msgno"))
                object.msgno = message.msgno;
            return object;
        };

        /**
         * Converts this msg_del_chatroom_msg to JSON.
         * @function toJSON
         * @memberof net.msg_del_chatroom_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_chatroom_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_chatroom_msg;
    })();

    net.msg_del_chatroom_msg_rep = (function() {

        /**
         * Properties of a msg_del_chatroom_msg_rep.
         * @memberof net
         * @interface Imsg_del_chatroom_msg_rep
         * @property {number|null} [result] msg_del_chatroom_msg_rep result
         * @property {number|null} [roomkey] msg_del_chatroom_msg_rep roomkey
         * @property {number|null} [msgno] msg_del_chatroom_msg_rep msgno
         */

        /**
         * Constructs a new msg_del_chatroom_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_del_chatroom_msg_rep.
         * @implements Imsg_del_chatroom_msg_rep
         * @constructor
         * @param {net.Imsg_del_chatroom_msg_rep=} [properties] Properties to set
         */
        function msg_del_chatroom_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chatroom_msg_rep result.
         * @member {number} result
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.result = 0;

        /**
         * msg_del_chatroom_msg_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.roomkey = 0;

        /**
         * msg_del_chatroom_msg_rep msgno.
         * @member {number} msgno
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.msgno = 0;

        /**
         * Creates a new msg_del_chatroom_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {net.Imsg_del_chatroom_msg_rep=} [properties] Properties to set
         * @returns {net.msg_del_chatroom_msg_rep} msg_del_chatroom_msg_rep instance
         */
        msg_del_chatroom_msg_rep.create = function create(properties) {
            return new msg_del_chatroom_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_del_chatroom_msg_rep message. Does not implicitly {@link net.msg_del_chatroom_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {net.Imsg_del_chatroom_msg_rep} message msg_del_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roomkey);
            if (message.msgno != null && Object.hasOwnProperty.call(message, "msgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.msgno);
            return writer;
        };

        /**
         * Encodes the specified msg_del_chatroom_msg_rep message, length delimited. Does not implicitly {@link net.msg_del_chatroom_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {net.Imsg_del_chatroom_msg_rep} message msg_del_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_del_chatroom_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chatroom_msg_rep} msg_del_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chatroom_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.roomkey = reader.int32();
                    break;
                case 3:
                    message.msgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_del_chatroom_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_del_chatroom_msg_rep} msg_del_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_del_chatroom_msg_rep message.
         * @function verify
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_del_chatroom_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.msgno != null && message.hasOwnProperty("msgno"))
                if (!$util.isInteger(message.msgno))
                    return "msgno: integer expected";
            return null;
        };

        /**
         * Creates a msg_del_chatroom_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_del_chatroom_msg_rep} msg_del_chatroom_msg_rep
         */
        msg_del_chatroom_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_del_chatroom_msg_rep)
                return object;
            var message = new $root.net.msg_del_chatroom_msg_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.msgno != null)
                message.msgno = object.msgno | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_del_chatroom_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {net.msg_del_chatroom_msg_rep} message msg_del_chatroom_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_del_chatroom_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.result = 0;
                object.roomkey = 0;
                object.msgno = 0;
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.msgno != null && message.hasOwnProperty("msgno"))
                object.msgno = message.msgno;
            return object;
        };

        /**
         * Converts this msg_del_chatroom_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_del_chatroom_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_del_chatroom_msg_rep;
    })();

    net.msg_get_chatroom_history_msg = (function() {

        /**
         * Properties of a msg_get_chatroom_history_msg.
         * @memberof net
         * @interface Imsg_get_chatroom_history_msg
         * @property {number|null} [roomkey] msg_get_chatroom_history_msg roomkey
         */

        /**
         * Constructs a new msg_get_chatroom_history_msg.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_history_msg.
         * @implements Imsg_get_chatroom_history_msg
         * @constructor
         * @param {net.Imsg_get_chatroom_history_msg=} [properties] Properties to set
         */
        function msg_get_chatroom_history_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_history_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_history_msg
         * @instance
         */
        msg_get_chatroom_history_msg.prototype.roomkey = 0;

        /**
         * Creates a new msg_get_chatroom_history_msg instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {net.Imsg_get_chatroom_history_msg=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_history_msg} msg_get_chatroom_history_msg instance
         */
        msg_get_chatroom_history_msg.create = function create(properties) {
            return new msg_get_chatroom_history_msg(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_history_msg message. Does not implicitly {@link net.msg_get_chatroom_history_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {net.Imsg_get_chatroom_history_msg} message msg_get_chatroom_history_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_history_msg message, length delimited. Does not implicitly {@link net.msg_get_chatroom_history_msg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {net.Imsg_get_chatroom_history_msg} message msg_get_chatroom_history_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_history_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_history_msg} msg_get_chatroom_history_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_history_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_history_msg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_history_msg} msg_get_chatroom_history_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_history_msg message.
         * @function verify
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_history_msg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_chatroom_history_msg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_history_msg} msg_get_chatroom_history_msg
         */
        msg_get_chatroom_history_msg.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_history_msg)
                return object;
            var message = new $root.net.msg_get_chatroom_history_msg();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_history_msg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {net.msg_get_chatroom_history_msg} message msg_get_chatroom_history_msg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_history_msg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            return object;
        };

        /**
         * Converts this msg_get_chatroom_history_msg to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_history_msg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_history_msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_history_msg;
    })();

    net.msg_get_chatroom_history_msg_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_history_msg_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_history_msg_rep
         * @property {number|null} [roomkey] msg_get_chatroom_history_msg_rep roomkey
         * @property {Array.<net.Ichat_msg>|null} [msg_list] msg_get_chatroom_history_msg_rep msg_list
         */

        /**
         * Constructs a new msg_get_chatroom_history_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_history_msg_rep.
         * @implements Imsg_get_chatroom_history_msg_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_history_msg_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_history_msg_rep(properties) {
            this.msg_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_history_msg_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @instance
         */
        msg_get_chatroom_history_msg_rep.prototype.roomkey = 0;

        /**
         * msg_get_chatroom_history_msg_rep msg_list.
         * @member {Array.<net.Ichat_msg>} msg_list
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @instance
         */
        msg_get_chatroom_history_msg_rep.prototype.msg_list = $util.emptyArray;

        /**
         * Creates a new msg_get_chatroom_history_msg_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {net.Imsg_get_chatroom_history_msg_rep=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_history_msg_rep} msg_get_chatroom_history_msg_rep instance
         */
        msg_get_chatroom_history_msg_rep.create = function create(properties) {
            return new msg_get_chatroom_history_msg_rep(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_history_msg_rep message. Does not implicitly {@link net.msg_get_chatroom_history_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {net.Imsg_get_chatroom_history_msg_rep} message msg_get_chatroom_history_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msg_list != null && message.msg_list.length)
                for (var i = 0; i < message.msg_list.length; ++i)
                    $root.net.chat_msg.encode(message.msg_list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_history_msg_rep message, length delimited. Does not implicitly {@link net.msg_get_chatroom_history_msg_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {net.Imsg_get_chatroom_history_msg_rep} message msg_get_chatroom_history_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_history_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_history_msg_rep} msg_get_chatroom_history_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_history_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    if (!(message.msg_list && message.msg_list.length))
                        message.msg_list = [];
                    message.msg_list.push($root.net.chat_msg.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_history_msg_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_history_msg_rep} msg_get_chatroom_history_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_history_msg_rep message.
         * @function verify
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_history_msg_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.msg_list != null && message.hasOwnProperty("msg_list")) {
                if (!Array.isArray(message.msg_list))
                    return "msg_list: array expected";
                for (var i = 0; i < message.msg_list.length; ++i) {
                    var error = $root.net.chat_msg.verify(message.msg_list[i]);
                    if (error)
                        return "msg_list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_chatroom_history_msg_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_history_msg_rep} msg_get_chatroom_history_msg_rep
         */
        msg_get_chatroom_history_msg_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_history_msg_rep)
                return object;
            var message = new $root.net.msg_get_chatroom_history_msg_rep();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.msg_list) {
                if (!Array.isArray(object.msg_list))
                    throw TypeError(".net.msg_get_chatroom_history_msg_rep.msg_list: array expected");
                message.msg_list = [];
                for (var i = 0; i < object.msg_list.length; ++i) {
                    if (typeof object.msg_list[i] !== "object")
                        throw TypeError(".net.msg_get_chatroom_history_msg_rep.msg_list: object expected");
                    message.msg_list[i] = $root.net.chat_msg.fromObject(object.msg_list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_history_msg_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {net.msg_get_chatroom_history_msg_rep} message msg_get_chatroom_history_msg_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_history_msg_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.msg_list = [];
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.msg_list && message.msg_list.length) {
                object.msg_list = [];
                for (var j = 0; j < message.msg_list.length; ++j)
                    object.msg_list[j] = $root.net.chat_msg.toObject(message.msg_list[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_chatroom_history_msg_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_history_msg_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_history_msg_rep;
    })();

    net.msg_join_chatroom_nty = (function() {

        /**
         * Properties of a msg_join_chatroom_nty.
         * @memberof net
         * @interface Imsg_join_chatroom_nty
         * @property {number|null} [roomkey] msg_join_chatroom_nty roomkey
         * @property {net.Ibase_info|null} [base_data] msg_join_chatroom_nty base_data
         */

        /**
         * Constructs a new msg_join_chatroom_nty.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom_nty.
         * @implements Imsg_join_chatroom_nty
         * @constructor
         * @param {net.Imsg_join_chatroom_nty=} [properties] Properties to set
         */
        function msg_join_chatroom_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom_nty roomkey.
         * @member {number} roomkey
         * @memberof net.msg_join_chatroom_nty
         * @instance
         */
        msg_join_chatroom_nty.prototype.roomkey = 0;

        /**
         * msg_join_chatroom_nty base_data.
         * @member {net.Ibase_info|null|undefined} base_data
         * @memberof net.msg_join_chatroom_nty
         * @instance
         */
        msg_join_chatroom_nty.prototype.base_data = null;

        /**
         * Creates a new msg_join_chatroom_nty instance using the specified properties.
         * @function create
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {net.Imsg_join_chatroom_nty=} [properties] Properties to set
         * @returns {net.msg_join_chatroom_nty} msg_join_chatroom_nty instance
         */
        msg_join_chatroom_nty.create = function create(properties) {
            return new msg_join_chatroom_nty(properties);
        };

        /**
         * Encodes the specified msg_join_chatroom_nty message. Does not implicitly {@link net.msg_join_chatroom_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {net.Imsg_join_chatroom_nty} message msg_join_chatroom_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.base_data != null && Object.hasOwnProperty.call(message, "base_data"))
                $root.net.base_info.encode(message.base_data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_join_chatroom_nty message, length delimited. Does not implicitly {@link net.msg_join_chatroom_nty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {net.Imsg_join_chatroom_nty} message msg_join_chatroom_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_nty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_join_chatroom_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom_nty} msg_join_chatroom_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.base_data = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_join_chatroom_nty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_join_chatroom_nty} msg_join_chatroom_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_nty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_join_chatroom_nty message.
         * @function verify
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_join_chatroom_nty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.base_data != null && message.hasOwnProperty("base_data")) {
                var error = $root.net.base_info.verify(message.base_data);
                if (error)
                    return "base_data." + error;
            }
            return null;
        };

        /**
         * Creates a msg_join_chatroom_nty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_join_chatroom_nty} msg_join_chatroom_nty
         */
        msg_join_chatroom_nty.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_join_chatroom_nty)
                return object;
            var message = new $root.net.msg_join_chatroom_nty();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.base_data != null) {
                if (typeof object.base_data !== "object")
                    throw TypeError(".net.msg_join_chatroom_nty.base_data: object expected");
                message.base_data = $root.net.base_info.fromObject(object.base_data);
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_join_chatroom_nty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {net.msg_join_chatroom_nty} message msg_join_chatroom_nty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_join_chatroom_nty.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                object.base_data = null;
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.base_data != null && message.hasOwnProperty("base_data"))
                object.base_data = $root.net.base_info.toObject(message.base_data, options);
            return object;
        };

        /**
         * Converts this msg_join_chatroom_nty to JSON.
         * @function toJSON
         * @memberof net.msg_join_chatroom_nty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_join_chatroom_nty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_join_chatroom_nty;
    })();

    net.msg_chatroom_nty_msg_toall = (function() {

        /**
         * Properties of a msg_chatroom_nty_msg_toall.
         * @memberof net
         * @interface Imsg_chatroom_nty_msg_toall
         * @property {number|null} [roomkey] msg_chatroom_nty_msg_toall roomkey
         * @property {Uint8Array|null} [content] msg_chatroom_nty_msg_toall content
         */

        /**
         * Constructs a new msg_chatroom_nty_msg_toall.
         * @memberof net
         * @classdesc Represents a msg_chatroom_nty_msg_toall.
         * @implements Imsg_chatroom_nty_msg_toall
         * @constructor
         * @param {net.Imsg_chatroom_nty_msg_toall=} [properties] Properties to set
         */
        function msg_chatroom_nty_msg_toall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_nty_msg_toall roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_nty_msg_toall
         * @instance
         */
        msg_chatroom_nty_msg_toall.prototype.roomkey = 0;

        /**
         * msg_chatroom_nty_msg_toall content.
         * @member {Uint8Array} content
         * @memberof net.msg_chatroom_nty_msg_toall
         * @instance
         */
        msg_chatroom_nty_msg_toall.prototype.content = $util.newBuffer([]);

        /**
         * Creates a new msg_chatroom_nty_msg_toall instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall=} [properties] Properties to set
         * @returns {net.msg_chatroom_nty_msg_toall} msg_chatroom_nty_msg_toall instance
         */
        msg_chatroom_nty_msg_toall.create = function create(properties) {
            return new msg_chatroom_nty_msg_toall(properties);
        };

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall message. Does not implicitly {@link net.msg_chatroom_nty_msg_toall.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall} message msg_chatroom_nty_msg_toall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall message, length delimited. Does not implicitly {@link net.msg_chatroom_nty_msg_toall.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall} message msg_chatroom_nty_msg_toall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_nty_msg_toall} msg_chatroom_nty_msg_toall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_nty_msg_toall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_nty_msg_toall} msg_chatroom_nty_msg_toall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_nty_msg_toall message.
         * @function verify
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_nty_msg_toall.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_nty_msg_toall message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_nty_msg_toall} msg_chatroom_nty_msg_toall
         */
        msg_chatroom_nty_msg_toall.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_nty_msg_toall)
                return object;
            var message = new $root.net.msg_chatroom_nty_msg_toall();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_nty_msg_toall message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {net.msg_chatroom_nty_msg_toall} message msg_chatroom_nty_msg_toall
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_nty_msg_toall.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            return object;
        };

        /**
         * Converts this msg_chatroom_nty_msg_toall to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_nty_msg_toall
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_nty_msg_toall.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_nty_msg_toall;
    })();

    net.msg_chatroom_nty_msg_toall_rep = (function() {

        /**
         * Properties of a msg_chatroom_nty_msg_toall_rep.
         * @memberof net
         * @interface Imsg_chatroom_nty_msg_toall_rep
         * @property {number|null} [result] msg_chatroom_nty_msg_toall_rep result
         */

        /**
         * Constructs a new msg_chatroom_nty_msg_toall_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_nty_msg_toall_rep.
         * @implements Imsg_chatroom_nty_msg_toall_rep
         * @constructor
         * @param {net.Imsg_chatroom_nty_msg_toall_rep=} [properties] Properties to set
         */
        function msg_chatroom_nty_msg_toall_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_nty_msg_toall_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @instance
         */
        msg_chatroom_nty_msg_toall_rep.prototype.result = 0;

        /**
         * Creates a new msg_chatroom_nty_msg_toall_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall_rep=} [properties] Properties to set
         * @returns {net.msg_chatroom_nty_msg_toall_rep} msg_chatroom_nty_msg_toall_rep instance
         */
        msg_chatroom_nty_msg_toall_rep.create = function create(properties) {
            return new msg_chatroom_nty_msg_toall_rep(properties);
        };

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall_rep message. Does not implicitly {@link net.msg_chatroom_nty_msg_toall_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall_rep} message msg_chatroom_nty_msg_toall_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall_rep message, length delimited. Does not implicitly {@link net.msg_chatroom_nty_msg_toall_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall_rep} message msg_chatroom_nty_msg_toall_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_nty_msg_toall_rep} msg_chatroom_nty_msg_toall_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_nty_msg_toall_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_chatroom_nty_msg_toall_rep} msg_chatroom_nty_msg_toall_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_chatroom_nty_msg_toall_rep message.
         * @function verify
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_chatroom_nty_msg_toall_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_chatroom_nty_msg_toall_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_chatroom_nty_msg_toall_rep} msg_chatroom_nty_msg_toall_rep
         */
        msg_chatroom_nty_msg_toall_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_chatroom_nty_msg_toall_rep)
                return object;
            var message = new $root.net.msg_chatroom_nty_msg_toall_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_chatroom_nty_msg_toall_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {net.msg_chatroom_nty_msg_toall_rep} message msg_chatroom_nty_msg_toall_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_chatroom_nty_msg_toall_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_chatroom_nty_msg_toall_rep to JSON.
         * @function toJSON
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_chatroom_nty_msg_toall_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_chatroom_nty_msg_toall_rep;
    })();

    net.msg_send_chatroom_ad = (function() {

        /**
         * Properties of a msg_send_chatroom_ad.
         * @memberof net
         * @interface Imsg_send_chatroom_ad
         * @property {number|null} [roomkey] msg_send_chatroom_ad roomkey
         * @property {Uint8Array|null} [content] msg_send_chatroom_ad content
         * @property {Array.<number>|null} [channels] msg_send_chatroom_ad channels
         */

        /**
         * Constructs a new msg_send_chatroom_ad.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_ad.
         * @implements Imsg_send_chatroom_ad
         * @constructor
         * @param {net.Imsg_send_chatroom_ad=} [properties] Properties to set
         */
        function msg_send_chatroom_ad(properties) {
            this.channels = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_ad roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_ad
         * @instance
         */
        msg_send_chatroom_ad.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_ad content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_ad
         * @instance
         */
        msg_send_chatroom_ad.prototype.content = $util.newBuffer([]);

        /**
         * msg_send_chatroom_ad channels.
         * @member {Array.<number>} channels
         * @memberof net.msg_send_chatroom_ad
         * @instance
         */
        msg_send_chatroom_ad.prototype.channels = $util.emptyArray;

        /**
         * Creates a new msg_send_chatroom_ad instance using the specified properties.
         * @function create
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {net.Imsg_send_chatroom_ad=} [properties] Properties to set
         * @returns {net.msg_send_chatroom_ad} msg_send_chatroom_ad instance
         */
        msg_send_chatroom_ad.create = function create(properties) {
            return new msg_send_chatroom_ad(properties);
        };

        /**
         * Encodes the specified msg_send_chatroom_ad message. Does not implicitly {@link net.msg_send_chatroom_ad.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {net.Imsg_send_chatroom_ad} message msg_send_chatroom_ad message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            if (message.channels != null && message.channels.length)
                for (var i = 0; i < message.channels.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.channels[i]);
            return writer;
        };

        /**
         * Encodes the specified msg_send_chatroom_ad message, length delimited. Does not implicitly {@link net.msg_send_chatroom_ad.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {net.Imsg_send_chatroom_ad} message msg_send_chatroom_ad message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_chatroom_ad message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_ad} msg_send_chatroom_ad
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_ad();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                case 3:
                    if (!(message.channels && message.channels.length))
                        message.channels = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.channels.push(reader.int32());
                    } else
                        message.channels.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_chatroom_ad message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_chatroom_ad} msg_send_chatroom_ad
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_chatroom_ad message.
         * @function verify
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_chatroom_ad.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.channels != null && message.hasOwnProperty("channels")) {
                if (!Array.isArray(message.channels))
                    return "channels: array expected";
                for (var i = 0; i < message.channels.length; ++i)
                    if (!$util.isInteger(message.channels[i]))
                        return "channels: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a msg_send_chatroom_ad message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_chatroom_ad} msg_send_chatroom_ad
         */
        msg_send_chatroom_ad.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_chatroom_ad)
                return object;
            var message = new $root.net.msg_send_chatroom_ad();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.channels) {
                if (!Array.isArray(object.channels))
                    throw TypeError(".net.msg_send_chatroom_ad.channels: array expected");
                message.channels = [];
                for (var i = 0; i < object.channels.length; ++i)
                    message.channels[i] = object.channels[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_send_chatroom_ad message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {net.msg_send_chatroom_ad} message msg_send_chatroom_ad
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_chatroom_ad.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.channels = [];
            if (options.defaults) {
                object.roomkey = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.channels && message.channels.length) {
                object.channels = [];
                for (var j = 0; j < message.channels.length; ++j)
                    object.channels[j] = message.channels[j];
            }
            return object;
        };

        /**
         * Converts this msg_send_chatroom_ad to JSON.
         * @function toJSON
         * @memberof net.msg_send_chatroom_ad
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_chatroom_ad.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_chatroom_ad;
    })();

    net.msg_send_chatroom_ad_rep = (function() {

        /**
         * Properties of a msg_send_chatroom_ad_rep.
         * @memberof net
         * @interface Imsg_send_chatroom_ad_rep
         * @property {number|null} [roomkey] msg_send_chatroom_ad_rep roomkey
         * @property {Uint8Array|null} [content] msg_send_chatroom_ad_rep content
         */

        /**
         * Constructs a new msg_send_chatroom_ad_rep.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_ad_rep.
         * @implements Imsg_send_chatroom_ad_rep
         * @constructor
         * @param {net.Imsg_send_chatroom_ad_rep=} [properties] Properties to set
         */
        function msg_send_chatroom_ad_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_ad_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_ad_rep
         * @instance
         */
        msg_send_chatroom_ad_rep.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_ad_rep content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_ad_rep
         * @instance
         */
        msg_send_chatroom_ad_rep.prototype.content = $util.newBuffer([]);

        /**
         * Creates a new msg_send_chatroom_ad_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {net.Imsg_send_chatroom_ad_rep=} [properties] Properties to set
         * @returns {net.msg_send_chatroom_ad_rep} msg_send_chatroom_ad_rep instance
         */
        msg_send_chatroom_ad_rep.create = function create(properties) {
            return new msg_send_chatroom_ad_rep(properties);
        };

        /**
         * Encodes the specified msg_send_chatroom_ad_rep message. Does not implicitly {@link net.msg_send_chatroom_ad_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {net.Imsg_send_chatroom_ad_rep} message msg_send_chatroom_ad_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            return writer;
        };

        /**
         * Encodes the specified msg_send_chatroom_ad_rep message, length delimited. Does not implicitly {@link net.msg_send_chatroom_ad_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {net.Imsg_send_chatroom_ad_rep} message msg_send_chatroom_ad_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_send_chatroom_ad_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_ad_rep} msg_send_chatroom_ad_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_ad_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_send_chatroom_ad_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_send_chatroom_ad_rep} msg_send_chatroom_ad_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_send_chatroom_ad_rep message.
         * @function verify
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_send_chatroom_ad_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            return null;
        };

        /**
         * Creates a msg_send_chatroom_ad_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_send_chatroom_ad_rep} msg_send_chatroom_ad_rep
         */
        msg_send_chatroom_ad_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_send_chatroom_ad_rep)
                return object;
            var message = new $root.net.msg_send_chatroom_ad_rep();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            return message;
        };

        /**
         * Creates a plain object from a msg_send_chatroom_ad_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {net.msg_send_chatroom_ad_rep} message msg_send_chatroom_ad_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_send_chatroom_ad_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomkey = 0;
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
            }
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            return object;
        };

        /**
         * Converts this msg_send_chatroom_ad_rep to JSON.
         * @function toJSON
         * @memberof net.msg_send_chatroom_ad_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_send_chatroom_ad_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_send_chatroom_ad_rep;
    })();

    net.msg_allchatroom_forbid = (function() {

        /**
         * Properties of a msg_allchatroom_forbid.
         * @memberof net
         * @interface Imsg_allchatroom_forbid
         * @property {number|null} [uid] msg_allchatroom_forbid uid
         * @property {number|null} [is_set] msg_allchatroom_forbid is_set
         */

        /**
         * Constructs a new msg_allchatroom_forbid.
         * @memberof net
         * @classdesc Represents a msg_allchatroom_forbid.
         * @implements Imsg_allchatroom_forbid
         * @constructor
         * @param {net.Imsg_allchatroom_forbid=} [properties] Properties to set
         */
        function msg_allchatroom_forbid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_allchatroom_forbid uid.
         * @member {number} uid
         * @memberof net.msg_allchatroom_forbid
         * @instance
         */
        msg_allchatroom_forbid.prototype.uid = 0;

        /**
         * msg_allchatroom_forbid is_set.
         * @member {number} is_set
         * @memberof net.msg_allchatroom_forbid
         * @instance
         */
        msg_allchatroom_forbid.prototype.is_set = 0;

        /**
         * Creates a new msg_allchatroom_forbid instance using the specified properties.
         * @function create
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {net.Imsg_allchatroom_forbid=} [properties] Properties to set
         * @returns {net.msg_allchatroom_forbid} msg_allchatroom_forbid instance
         */
        msg_allchatroom_forbid.create = function create(properties) {
            return new msg_allchatroom_forbid(properties);
        };

        /**
         * Encodes the specified msg_allchatroom_forbid message. Does not implicitly {@link net.msg_allchatroom_forbid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {net.Imsg_allchatroom_forbid} message msg_allchatroom_forbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_allchatroom_forbid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_set);
            return writer;
        };

        /**
         * Encodes the specified msg_allchatroom_forbid message, length delimited. Does not implicitly {@link net.msg_allchatroom_forbid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {net.Imsg_allchatroom_forbid} message msg_allchatroom_forbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_allchatroom_forbid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_allchatroom_forbid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_allchatroom_forbid} msg_allchatroom_forbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_allchatroom_forbid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_allchatroom_forbid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.is_set = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_allchatroom_forbid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_allchatroom_forbid} msg_allchatroom_forbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_allchatroom_forbid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_allchatroom_forbid message.
         * @function verify
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_allchatroom_forbid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                if (!$util.isInteger(message.is_set))
                    return "is_set: integer expected";
            return null;
        };

        /**
         * Creates a msg_allchatroom_forbid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_allchatroom_forbid} msg_allchatroom_forbid
         */
        msg_allchatroom_forbid.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_allchatroom_forbid)
                return object;
            var message = new $root.net.msg_allchatroom_forbid();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.is_set != null)
                message.is_set = object.is_set | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_allchatroom_forbid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_allchatroom_forbid
         * @static
         * @param {net.msg_allchatroom_forbid} message msg_allchatroom_forbid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_allchatroom_forbid.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.is_set = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.is_set != null && message.hasOwnProperty("is_set"))
                object.is_set = message.is_set;
            return object;
        };

        /**
         * Converts this msg_allchatroom_forbid to JSON.
         * @function toJSON
         * @memberof net.msg_allchatroom_forbid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_allchatroom_forbid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_allchatroom_forbid;
    })();

    net.msg_allchatroom_forbid_rep = (function() {

        /**
         * Properties of a msg_allchatroom_forbid_rep.
         * @memberof net
         * @interface Imsg_allchatroom_forbid_rep
         * @property {number|null} [result] msg_allchatroom_forbid_rep result
         */

        /**
         * Constructs a new msg_allchatroom_forbid_rep.
         * @memberof net
         * @classdesc Represents a msg_allchatroom_forbid_rep.
         * @implements Imsg_allchatroom_forbid_rep
         * @constructor
         * @param {net.Imsg_allchatroom_forbid_rep=} [properties] Properties to set
         */
        function msg_allchatroom_forbid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_allchatroom_forbid_rep result.
         * @member {number} result
         * @memberof net.msg_allchatroom_forbid_rep
         * @instance
         */
        msg_allchatroom_forbid_rep.prototype.result = 0;

        /**
         * Creates a new msg_allchatroom_forbid_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {net.Imsg_allchatroom_forbid_rep=} [properties] Properties to set
         * @returns {net.msg_allchatroom_forbid_rep} msg_allchatroom_forbid_rep instance
         */
        msg_allchatroom_forbid_rep.create = function create(properties) {
            return new msg_allchatroom_forbid_rep(properties);
        };

        /**
         * Encodes the specified msg_allchatroom_forbid_rep message. Does not implicitly {@link net.msg_allchatroom_forbid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {net.Imsg_allchatroom_forbid_rep} message msg_allchatroom_forbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_allchatroom_forbid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_allchatroom_forbid_rep message, length delimited. Does not implicitly {@link net.msg_allchatroom_forbid_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {net.Imsg_allchatroom_forbid_rep} message msg_allchatroom_forbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_allchatroom_forbid_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_allchatroom_forbid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_allchatroom_forbid_rep} msg_allchatroom_forbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_allchatroom_forbid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_allchatroom_forbid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_allchatroom_forbid_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_allchatroom_forbid_rep} msg_allchatroom_forbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_allchatroom_forbid_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_allchatroom_forbid_rep message.
         * @function verify
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_allchatroom_forbid_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_allchatroom_forbid_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_allchatroom_forbid_rep} msg_allchatroom_forbid_rep
         */
        msg_allchatroom_forbid_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_allchatroom_forbid_rep)
                return object;
            var message = new $root.net.msg_allchatroom_forbid_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_allchatroom_forbid_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_allchatroom_forbid_rep
         * @static
         * @param {net.msg_allchatroom_forbid_rep} message msg_allchatroom_forbid_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_allchatroom_forbid_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_allchatroom_forbid_rep to JSON.
         * @function toJSON
         * @memberof net.msg_allchatroom_forbid_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_allchatroom_forbid_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_allchatroom_forbid_rep;
    })();

    net.msg_get_forbid_state = (function() {

        /**
         * Properties of a msg_get_forbid_state.
         * @memberof net
         * @interface Imsg_get_forbid_state
         * @property {number|null} [uid] msg_get_forbid_state uid
         */

        /**
         * Constructs a new msg_get_forbid_state.
         * @memberof net
         * @classdesc Represents a msg_get_forbid_state.
         * @implements Imsg_get_forbid_state
         * @constructor
         * @param {net.Imsg_get_forbid_state=} [properties] Properties to set
         */
        function msg_get_forbid_state(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_forbid_state uid.
         * @member {number} uid
         * @memberof net.msg_get_forbid_state
         * @instance
         */
        msg_get_forbid_state.prototype.uid = 0;

        /**
         * Creates a new msg_get_forbid_state instance using the specified properties.
         * @function create
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {net.Imsg_get_forbid_state=} [properties] Properties to set
         * @returns {net.msg_get_forbid_state} msg_get_forbid_state instance
         */
        msg_get_forbid_state.create = function create(properties) {
            return new msg_get_forbid_state(properties);
        };

        /**
         * Encodes the specified msg_get_forbid_state message. Does not implicitly {@link net.msg_get_forbid_state.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {net.Imsg_get_forbid_state} message msg_get_forbid_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbid_state.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_forbid_state message, length delimited. Does not implicitly {@link net.msg_get_forbid_state.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {net.Imsg_get_forbid_state} message msg_get_forbid_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbid_state.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_forbid_state message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_forbid_state} msg_get_forbid_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbid_state.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_forbid_state();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_forbid_state message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_forbid_state} msg_get_forbid_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbid_state.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_forbid_state message.
         * @function verify
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_forbid_state.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_forbid_state message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_forbid_state} msg_get_forbid_state
         */
        msg_get_forbid_state.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_forbid_state)
                return object;
            var message = new $root.net.msg_get_forbid_state();
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_forbid_state message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_forbid_state
         * @static
         * @param {net.msg_get_forbid_state} message msg_get_forbid_state
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_forbid_state.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = 0;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_get_forbid_state to JSON.
         * @function toJSON
         * @memberof net.msg_get_forbid_state
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_forbid_state.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_forbid_state;
    })();

    net.msg_get_forbid_state_rep = (function() {

        /**
         * Properties of a msg_get_forbid_state_rep.
         * @memberof net
         * @interface Imsg_get_forbid_state_rep
         * @property {number|null} [uid] msg_get_forbid_state_rep uid
         * @property {number|null} [is_forbid] msg_get_forbid_state_rep is_forbid
         */

        /**
         * Constructs a new msg_get_forbid_state_rep.
         * @memberof net
         * @classdesc Represents a msg_get_forbid_state_rep.
         * @implements Imsg_get_forbid_state_rep
         * @constructor
         * @param {net.Imsg_get_forbid_state_rep=} [properties] Properties to set
         */
        function msg_get_forbid_state_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_forbid_state_rep uid.
         * @member {number} uid
         * @memberof net.msg_get_forbid_state_rep
         * @instance
         */
        msg_get_forbid_state_rep.prototype.uid = 0;

        /**
         * msg_get_forbid_state_rep is_forbid.
         * @member {number} is_forbid
         * @memberof net.msg_get_forbid_state_rep
         * @instance
         */
        msg_get_forbid_state_rep.prototype.is_forbid = 0;

        /**
         * Creates a new msg_get_forbid_state_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {net.Imsg_get_forbid_state_rep=} [properties] Properties to set
         * @returns {net.msg_get_forbid_state_rep} msg_get_forbid_state_rep instance
         */
        msg_get_forbid_state_rep.create = function create(properties) {
            return new msg_get_forbid_state_rep(properties);
        };

        /**
         * Encodes the specified msg_get_forbid_state_rep message. Does not implicitly {@link net.msg_get_forbid_state_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {net.Imsg_get_forbid_state_rep} message msg_get_forbid_state_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbid_state_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.is_forbid != null && Object.hasOwnProperty.call(message, "is_forbid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_forbid);
            return writer;
        };

        /**
         * Encodes the specified msg_get_forbid_state_rep message, length delimited. Does not implicitly {@link net.msg_get_forbid_state_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {net.Imsg_get_forbid_state_rep} message msg_get_forbid_state_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_forbid_state_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_forbid_state_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_forbid_state_rep} msg_get_forbid_state_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbid_state_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_forbid_state_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.is_forbid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_forbid_state_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_forbid_state_rep} msg_get_forbid_state_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_forbid_state_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_forbid_state_rep message.
         * @function verify
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_forbid_state_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            if (message.is_forbid != null && message.hasOwnProperty("is_forbid"))
                if (!$util.isInteger(message.is_forbid))
                    return "is_forbid: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_forbid_state_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_forbid_state_rep} msg_get_forbid_state_rep
         */
        msg_get_forbid_state_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_forbid_state_rep)
                return object;
            var message = new $root.net.msg_get_forbid_state_rep();
            if (object.uid != null)
                message.uid = object.uid | 0;
            if (object.is_forbid != null)
                message.is_forbid = object.is_forbid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_forbid_state_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_forbid_state_rep
         * @static
         * @param {net.msg_get_forbid_state_rep} message msg_get_forbid_state_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_forbid_state_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = 0;
                object.is_forbid = 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.is_forbid != null && message.hasOwnProperty("is_forbid"))
                object.is_forbid = message.is_forbid;
            return object;
        };

        /**
         * Converts this msg_get_forbid_state_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_forbid_state_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_forbid_state_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_forbid_state_rep;
    })();

    net.msg_forbid_content = (function() {

        /**
         * Properties of a msg_forbid_content.
         * @memberof net
         * @interface Imsg_forbid_content
         * @property {Uint8Array|null} [content] msg_forbid_content content
         * @property {number|null} [uid] msg_forbid_content uid
         */

        /**
         * Constructs a new msg_forbid_content.
         * @memberof net
         * @classdesc Represents a msg_forbid_content.
         * @implements Imsg_forbid_content
         * @constructor
         * @param {net.Imsg_forbid_content=} [properties] Properties to set
         */
        function msg_forbid_content(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_forbid_content content.
         * @member {Uint8Array} content
         * @memberof net.msg_forbid_content
         * @instance
         */
        msg_forbid_content.prototype.content = $util.newBuffer([]);

        /**
         * msg_forbid_content uid.
         * @member {number} uid
         * @memberof net.msg_forbid_content
         * @instance
         */
        msg_forbid_content.prototype.uid = 0;

        /**
         * Creates a new msg_forbid_content instance using the specified properties.
         * @function create
         * @memberof net.msg_forbid_content
         * @static
         * @param {net.Imsg_forbid_content=} [properties] Properties to set
         * @returns {net.msg_forbid_content} msg_forbid_content instance
         */
        msg_forbid_content.create = function create(properties) {
            return new msg_forbid_content(properties);
        };

        /**
         * Encodes the specified msg_forbid_content message. Does not implicitly {@link net.msg_forbid_content.verify|verify} messages.
         * @function encode
         * @memberof net.msg_forbid_content
         * @static
         * @param {net.Imsg_forbid_content} message msg_forbid_content message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_forbid_content.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            return writer;
        };

        /**
         * Encodes the specified msg_forbid_content message, length delimited. Does not implicitly {@link net.msg_forbid_content.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_forbid_content
         * @static
         * @param {net.Imsg_forbid_content} message msg_forbid_content message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_forbid_content.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_forbid_content message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_forbid_content
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_forbid_content} msg_forbid_content
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_forbid_content.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_forbid_content();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.content = reader.bytes();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_forbid_content message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_forbid_content
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_forbid_content} msg_forbid_content
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_forbid_content.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_forbid_content message.
         * @function verify
         * @memberof net.msg_forbid_content
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_forbid_content.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                    return "content: buffer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid))
                    return "uid: integer expected";
            return null;
        };

        /**
         * Creates a msg_forbid_content message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_forbid_content
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_forbid_content} msg_forbid_content
         */
        msg_forbid_content.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_forbid_content)
                return object;
            var message = new $root.net.msg_forbid_content();
            if (object.content != null)
                if (typeof object.content === "string")
                    $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                else if (object.content.length)
                    message.content = object.content;
            if (object.uid != null)
                message.uid = object.uid | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_forbid_content message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_forbid_content
         * @static
         * @param {net.msg_forbid_content} message msg_forbid_content
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_forbid_content.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.content = "";
                else {
                    object.content = [];
                    if (options.bytes !== Array)
                        object.content = $util.newBuffer(object.content);
                }
                object.uid = 0;
            }
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this msg_forbid_content to JSON.
         * @function toJSON
         * @memberof net.msg_forbid_content
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_forbid_content.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_forbid_content;
    })();

    net.msg_forbid_content_rep = (function() {

        /**
         * Properties of a msg_forbid_content_rep.
         * @memberof net
         * @interface Imsg_forbid_content_rep
         * @property {number|null} [result] msg_forbid_content_rep result
         */

        /**
         * Constructs a new msg_forbid_content_rep.
         * @memberof net
         * @classdesc Represents a msg_forbid_content_rep.
         * @implements Imsg_forbid_content_rep
         * @constructor
         * @param {net.Imsg_forbid_content_rep=} [properties] Properties to set
         */
        function msg_forbid_content_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_forbid_content_rep result.
         * @member {number} result
         * @memberof net.msg_forbid_content_rep
         * @instance
         */
        msg_forbid_content_rep.prototype.result = 0;

        /**
         * Creates a new msg_forbid_content_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {net.Imsg_forbid_content_rep=} [properties] Properties to set
         * @returns {net.msg_forbid_content_rep} msg_forbid_content_rep instance
         */
        msg_forbid_content_rep.create = function create(properties) {
            return new msg_forbid_content_rep(properties);
        };

        /**
         * Encodes the specified msg_forbid_content_rep message. Does not implicitly {@link net.msg_forbid_content_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {net.Imsg_forbid_content_rep} message msg_forbid_content_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_forbid_content_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Encodes the specified msg_forbid_content_rep message, length delimited. Does not implicitly {@link net.msg_forbid_content_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {net.Imsg_forbid_content_rep} message msg_forbid_content_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_forbid_content_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_forbid_content_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_forbid_content_rep} msg_forbid_content_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_forbid_content_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_forbid_content_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_forbid_content_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_forbid_content_rep} msg_forbid_content_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_forbid_content_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_forbid_content_rep message.
         * @function verify
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_forbid_content_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result"))
                if (!$util.isInteger(message.result))
                    return "result: integer expected";
            return null;
        };

        /**
         * Creates a msg_forbid_content_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_forbid_content_rep} msg_forbid_content_rep
         */
        msg_forbid_content_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_forbid_content_rep)
                return object;
            var message = new $root.net.msg_forbid_content_rep();
            if (object.result != null)
                message.result = object.result >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_forbid_content_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_forbid_content_rep
         * @static
         * @param {net.msg_forbid_content_rep} message msg_forbid_content_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_forbid_content_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.result = 0;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this msg_forbid_content_rep to JSON.
         * @function toJSON
         * @memberof net.msg_forbid_content_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_forbid_content_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_forbid_content_rep;
    })();

    net.msg_get_chatroom_admin_list = (function() {

        /**
         * Properties of a msg_get_chatroom_admin_list.
         * @memberof net
         * @interface Imsg_get_chatroom_admin_list
         * @property {number|null} [roomkey] msg_get_chatroom_admin_list roomkey
         */

        /**
         * Constructs a new msg_get_chatroom_admin_list.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_admin_list.
         * @implements Imsg_get_chatroom_admin_list
         * @constructor
         * @param {net.Imsg_get_chatroom_admin_list=} [properties] Properties to set
         */
        function msg_get_chatroom_admin_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_admin_list roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_admin_list
         * @instance
         */
        msg_get_chatroom_admin_list.prototype.roomkey = 0;

        /**
         * Creates a new msg_get_chatroom_admin_list instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {net.Imsg_get_chatroom_admin_list=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_admin_list} msg_get_chatroom_admin_list instance
         */
        msg_get_chatroom_admin_list.create = function create(properties) {
            return new msg_get_chatroom_admin_list(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_admin_list message. Does not implicitly {@link net.msg_get_chatroom_admin_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {net.Imsg_get_chatroom_admin_list} message msg_get_chatroom_admin_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_admin_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_admin_list message, length delimited. Does not implicitly {@link net.msg_get_chatroom_admin_list.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {net.Imsg_get_chatroom_admin_list} message msg_get_chatroom_admin_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_admin_list.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_admin_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_admin_list} msg_get_chatroom_admin_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_admin_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_admin_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_admin_list message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_admin_list} msg_get_chatroom_admin_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_admin_list.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_admin_list message.
         * @function verify
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_admin_list.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            return null;
        };

        /**
         * Creates a msg_get_chatroom_admin_list message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_admin_list} msg_get_chatroom_admin_list
         */
        msg_get_chatroom_admin_list.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_admin_list)
                return object;
            var message = new $root.net.msg_get_chatroom_admin_list();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_admin_list message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_admin_list
         * @static
         * @param {net.msg_get_chatroom_admin_list} message msg_get_chatroom_admin_list
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_admin_list.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            return object;
        };

        /**
         * Converts this msg_get_chatroom_admin_list to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_admin_list
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_admin_list.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_admin_list;
    })();

    net.msg_get_chatroom_admin_list_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_admin_list_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_admin_list_rep
         * @property {number|null} [roomkey] msg_get_chatroom_admin_list_rep roomkey
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_chatroom_admin_list_rep users
         */

        /**
         * Constructs a new msg_get_chatroom_admin_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_admin_list_rep.
         * @implements Imsg_get_chatroom_admin_list_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_admin_list_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_admin_list_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_admin_list_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @instance
         */
        msg_get_chatroom_admin_list_rep.prototype.roomkey = 0;

        /**
         * msg_get_chatroom_admin_list_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @instance
         */
        msg_get_chatroom_admin_list_rep.prototype.users = $util.emptyArray;

        /**
         * Creates a new msg_get_chatroom_admin_list_rep instance using the specified properties.
         * @function create
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_admin_list_rep=} [properties] Properties to set
         * @returns {net.msg_get_chatroom_admin_list_rep} msg_get_chatroom_admin_list_rep instance
         */
        msg_get_chatroom_admin_list_rep.create = function create(properties) {
            return new msg_get_chatroom_admin_list_rep(properties);
        };

        /**
         * Encodes the specified msg_get_chatroom_admin_list_rep message. Does not implicitly {@link net.msg_get_chatroom_admin_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_admin_list_rep} message msg_get_chatroom_admin_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_admin_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified msg_get_chatroom_admin_list_rep message, length delimited. Does not implicitly {@link net.msg_get_chatroom_admin_list_rep.verify|verify} messages.
         * @function encodeDelimited
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_admin_list_rep} message msg_get_chatroom_admin_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_admin_list_rep.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a msg_get_chatroom_admin_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_admin_list_rep} msg_get_chatroom_admin_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_admin_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_admin_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a msg_get_chatroom_admin_list_rep message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {net.msg_get_chatroom_admin_list_rep} msg_get_chatroom_admin_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_admin_list_rep.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a msg_get_chatroom_admin_list_rep message.
         * @function verify
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        msg_get_chatroom_admin_list_rep.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                if (!$util.isInteger(message.roomkey))
                    return "roomkey: integer expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.net.base_info.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            return null;
        };

        /**
         * Creates a msg_get_chatroom_admin_list_rep message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {net.msg_get_chatroom_admin_list_rep} msg_get_chatroom_admin_list_rep
         */
        msg_get_chatroom_admin_list_rep.fromObject = function fromObject(object) {
            if (object instanceof $root.net.msg_get_chatroom_admin_list_rep)
                return object;
            var message = new $root.net.msg_get_chatroom_admin_list_rep();
            if (object.roomkey != null)
                message.roomkey = object.roomkey | 0;
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".net.msg_get_chatroom_admin_list_rep.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".net.msg_get_chatroom_admin_list_rep.users: object expected");
                    message.users[i] = $root.net.base_info.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a msg_get_chatroom_admin_list_rep message. Also converts values to other types if specified.
         * @function toObject
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @static
         * @param {net.msg_get_chatroom_admin_list_rep} message msg_get_chatroom_admin_list_rep
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        msg_get_chatroom_admin_list_rep.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults)
                object.roomkey = 0;
            if (message.roomkey != null && message.hasOwnProperty("roomkey"))
                object.roomkey = message.roomkey;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.net.base_info.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this msg_get_chatroom_admin_list_rep to JSON.
         * @function toJSON
         * @memberof net.msg_get_chatroom_admin_list_rep
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        msg_get_chatroom_admin_list_rep.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return msg_get_chatroom_admin_list_rep;
    })();

    /**
     * RESULT_CODE enum.
     * @name net.RESULT_CODE
     * @enum {number}
     * @property {number} RESULT_CODE_FAIL=0 RESULT_CODE_FAIL value
     * @property {number} RESULT_CODE_SUCCESS=1 RESULT_CODE_SUCCESS value
     * @property {number} RESULT_CODE_INVALID_PHONENUM=2 RESULT_CODE_INVALID_PHONENUM value
     * @property {number} RESULT_CODE_PHONENUM_ERROR=3 RESULT_CODE_PHONENUM_ERROR value
     * @property {number} RESULT_CODE_REDBAG_EMPTY=4 RESULT_CODE_REDBAG_EMPTY value
     * @property {number} RESULT_CODE_ALREADY_GET_REDBAG=5 RESULT_CODE_ALREADY_GET_REDBAG value
     * @property {number} RESULT_CODE_NOT_YOUR_FRIEND=6 RESULT_CODE_NOT_YOUR_FRIEND value
     * @property {number} RESULT_CODE_INVALID_NICKNANME=7 RESULT_CODE_INVALID_NICKNANME value
     * @property {number} RESULT_CODE_EXPIRE_REDBAG=8 RESULT_CODE_EXPIRE_REDBAG value
     * @property {number} RESULT_CODE_FASTKEY_ERROR=9 RESULT_CODE_FASTKEY_ERROR value
     * @property {number} RESULT_CODE_MONEY_NOT_ENOUGH=10 RESULT_CODE_MONEY_NOT_ENOUGH value
     * @property {number} RESULT_CODE_PWD_ERROR=11 RESULT_CODE_PWD_ERROR value
     * @property {number} RESULT_CODE_INVALID_AUTHCODE=12 RESULT_CODE_INVALID_AUTHCODE value
     * @property {number} RESULT_CODE_PWD_NOT_SET=13 RESULT_CODE_PWD_NOT_SET value
     * @property {number} RESULT_CODE_GROUP_NEED_VERIFY=14 RESULT_CODE_GROUP_NEED_VERIFY value
     * @property {number} RESULT_CODE_CANT_DEAL_WITHSELF=15 RESULT_CODE_CANT_DEAL_WITHSELF value
     * @property {number} RESULT_CODE_NOT_SUPPORT_DEAL=16 RESULT_CODE_NOT_SUPPORT_DEAL value
     * @property {number} RESULT_CODE_GOODS_NOT_ENOUGH=17 RESULT_CODE_GOODS_NOT_ENOUGH value
     * @property {number} RESULT_CODE_GOODS_NOT_EXIST=18 RESULT_CODE_GOODS_NOT_EXIST value
     * @property {number} RESULT_CODE_ORDER_NOT_EXIST=19 RESULT_CODE_ORDER_NOT_EXIST value
     * @property {number} RESULT_CODE_INVALID_GQRCODE=20 RESULT_CODE_INVALID_GQRCODE value
     * @property {number} RESULT_CODE_HAS_UNFINISHED_ORDER=21 RESULT_CODE_HAS_UNFINISHED_ORDER value
     * @property {number} RESULT_CODE_NO_PAYTYPE=22 RESULT_CODE_NO_PAYTYPE value
     * @property {number} RESULT_CODE_ORDER_CONFIRMED=23 RESULT_CODE_ORDER_CONFIRMED value
     * @property {number} RESULT_CODE_GROUP_FULL=24 RESULT_CODE_GROUP_FULL value
     * @property {number} RESULT_CODE_ALREADY_FRIEND=25 RESULT_CODE_ALREADY_FRIEND value
     * @property {number} RESULT_CODE_ORDER_COMPLETE=26 RESULT_CODE_ORDER_COMPLETE value
     * @property {number} RESULT_CODE_GOODS_STATUS_ERROR=27 RESULT_CODE_GOODS_STATUS_ERROR value
     * @property {number} RESULT_CODE_IN_BLACK_LIST=28 RESULT_CODE_IN_BLACK_LIST value
     * @property {number} RESULT_CODE_ORDER_STATUS_ERROR=29 RESULT_CODE_ORDER_STATUS_ERROR value
     * @property {number} RESULT_CODE_ORDER_EXPIRE=30 RESULT_CODE_ORDER_EXPIRE value
     * @property {number} RESULT_CODE_PCQRCODE_ERROR=31 RESULT_CODE_PCQRCODE_ERROR value
     * @property {number} RESULT_CODE_IS_CALLING=32 RESULT_CODE_IS_CALLING value
     * @property {number} RESULT_CODE_VOICECALL_ERROR=33 RESULT_CODE_VOICECALL_ERROR value
     * @property {number} RESULT_CODE_ALREADY_BIND=34 RESULT_CODE_ALREADY_BIND value
     * @property {number} RESULT_CODE_IN_CHATROOM=35 RESULT_CODE_IN_CHATROOM value
     * @property {number} RESULT_CODE_NOT_IN_CHATROOM=36 RESULT_CODE_NOT_IN_CHATROOM value
     * @property {number} RESULT_CODE_NOT_ADMIN=37 RESULT_CODE_NOT_ADMIN value
     * @property {number} RESULT_CODE_IS_FORBID=38 RESULT_CODE_IS_FORBID value
     * @property {number} RESULT_CODE_CHATROOM_NOTEXIST=39 RESULT_CODE_CHATROOM_NOTEXIST value
     * @property {number} RESULT_CODE_NOT_ROOMHOST=40 RESULT_CODE_NOT_ROOMHOST value
     * @property {number} RESULT_CODE_FID_NOT_EXIST=41 RESULT_CODE_FID_NOT_EXIST value
     * @property {number} RESULT_CODE_CANNOT_VIP_REWARD=42 RESULT_CODE_CANNOT_VIP_REWARD value
     * @property {number} RESULT_CODE_NOT_GROUP_MEMBER=43 RESULT_CODE_NOT_GROUP_MEMBER value
     * @property {number} RESULT_CODE_VERIFYCODE_ERROR=44 RESULT_CODE_VERIFYCODE_ERROR value
     * @property {number} RESULT_CODE_CHAT_LIMIT=45 RESULT_CODE_CHAT_LIMIT value
     * @property {number} RESULT_CODE_CHAT_FORBID=46 RESULT_CODE_CHAT_FORBID value
     */
    net.RESULT_CODE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RESULT_CODE_FAIL"] = 0;
        values[valuesById[1] = "RESULT_CODE_SUCCESS"] = 1;
        values[valuesById[2] = "RESULT_CODE_INVALID_PHONENUM"] = 2;
        values[valuesById[3] = "RESULT_CODE_PHONENUM_ERROR"] = 3;
        values[valuesById[4] = "RESULT_CODE_REDBAG_EMPTY"] = 4;
        values[valuesById[5] = "RESULT_CODE_ALREADY_GET_REDBAG"] = 5;
        values[valuesById[6] = "RESULT_CODE_NOT_YOUR_FRIEND"] = 6;
        values[valuesById[7] = "RESULT_CODE_INVALID_NICKNANME"] = 7;
        values[valuesById[8] = "RESULT_CODE_EXPIRE_REDBAG"] = 8;
        values[valuesById[9] = "RESULT_CODE_FASTKEY_ERROR"] = 9;
        values[valuesById[10] = "RESULT_CODE_MONEY_NOT_ENOUGH"] = 10;
        values[valuesById[11] = "RESULT_CODE_PWD_ERROR"] = 11;
        values[valuesById[12] = "RESULT_CODE_INVALID_AUTHCODE"] = 12;
        values[valuesById[13] = "RESULT_CODE_PWD_NOT_SET"] = 13;
        values[valuesById[14] = "RESULT_CODE_GROUP_NEED_VERIFY"] = 14;
        values[valuesById[15] = "RESULT_CODE_CANT_DEAL_WITHSELF"] = 15;
        values[valuesById[16] = "RESULT_CODE_NOT_SUPPORT_DEAL"] = 16;
        values[valuesById[17] = "RESULT_CODE_GOODS_NOT_ENOUGH"] = 17;
        values[valuesById[18] = "RESULT_CODE_GOODS_NOT_EXIST"] = 18;
        values[valuesById[19] = "RESULT_CODE_ORDER_NOT_EXIST"] = 19;
        values[valuesById[20] = "RESULT_CODE_INVALID_GQRCODE"] = 20;
        values[valuesById[21] = "RESULT_CODE_HAS_UNFINISHED_ORDER"] = 21;
        values[valuesById[22] = "RESULT_CODE_NO_PAYTYPE"] = 22;
        values[valuesById[23] = "RESULT_CODE_ORDER_CONFIRMED"] = 23;
        values[valuesById[24] = "RESULT_CODE_GROUP_FULL"] = 24;
        values[valuesById[25] = "RESULT_CODE_ALREADY_FRIEND"] = 25;
        values[valuesById[26] = "RESULT_CODE_ORDER_COMPLETE"] = 26;
        values[valuesById[27] = "RESULT_CODE_GOODS_STATUS_ERROR"] = 27;
        values[valuesById[28] = "RESULT_CODE_IN_BLACK_LIST"] = 28;
        values[valuesById[29] = "RESULT_CODE_ORDER_STATUS_ERROR"] = 29;
        values[valuesById[30] = "RESULT_CODE_ORDER_EXPIRE"] = 30;
        values[valuesById[31] = "RESULT_CODE_PCQRCODE_ERROR"] = 31;
        values[valuesById[32] = "RESULT_CODE_IS_CALLING"] = 32;
        values[valuesById[33] = "RESULT_CODE_VOICECALL_ERROR"] = 33;
        values[valuesById[34] = "RESULT_CODE_ALREADY_BIND"] = 34;
        values[valuesById[35] = "RESULT_CODE_IN_CHATROOM"] = 35;
        values[valuesById[36] = "RESULT_CODE_NOT_IN_CHATROOM"] = 36;
        values[valuesById[37] = "RESULT_CODE_NOT_ADMIN"] = 37;
        values[valuesById[38] = "RESULT_CODE_IS_FORBID"] = 38;
        values[valuesById[39] = "RESULT_CODE_CHATROOM_NOTEXIST"] = 39;
        values[valuesById[40] = "RESULT_CODE_NOT_ROOMHOST"] = 40;
        values[valuesById[41] = "RESULT_CODE_FID_NOT_EXIST"] = 41;
        values[valuesById[42] = "RESULT_CODE_CANNOT_VIP_REWARD"] = 42;
        values[valuesById[43] = "RESULT_CODE_NOT_GROUP_MEMBER"] = 43;
        values[valuesById[44] = "RESULT_CODE_VERIFYCODE_ERROR"] = 44;
        values[valuesById[45] = "RESULT_CODE_CHAT_LIMIT"] = 45;
        values[valuesById[46] = "RESULT_CODE_CHAT_FORBID"] = 46;
        return values;
    })();

    /**
     * MESSAGE_TYPE enum.
     * @name net.MESSAGE_TYPE
     * @enum {number}
     * @property {number} MESSAGE_TYPE_TXT=1 MESSAGE_TYPE_TXT value
     * @property {number} MESSAGE_TYPE_VOICE=2 MESSAGE_TYPE_VOICE value
     * @property {number} MESSAGE_TYPE_VIDEO=3 MESSAGE_TYPE_VIDEO value
     * @property {number} MESSAGE_TYPE_IMAGE=4 MESSAGE_TYPE_IMAGE value
     * @property {number} MESSAGE_TYPE_REDBAG=5 MESSAGE_TYPE_REDBAG value
     * @property {number} MESSAGE_TYPE_SHARE_LINK=6 MESSAGE_TYPE_SHARE_LINK value
     * @property {number} MESSAGE_TYPE_CARD=7 MESSAGE_TYPE_CARD value
     * @property {number} MESSAGE_TYPE_GET_REDBAG=8 MESSAGE_TYPE_GET_REDBAG value
     * @property {number} MESSAGE_TYPE_VOICE_CHAT_START=9 MESSAGE_TYPE_VOICE_CHAT_START value
     * @property {number} MESSAGE_TYPE_TRANS_MONEY=10 MESSAGE_TYPE_TRANS_MONEY value
     * @property {number} MESSAGE_TYPE_GROUP_CARD=11 MESSAGE_TYPE_GROUP_CARD value
     * @property {number} MESSAGE_TYPE_WITHDRAW_CHATMSG=12 MESSAGE_TYPE_WITHDRAW_CHATMSG value
     * @property {number} MESSAGE_TYPE_CONFIRM_ORDER=13 MESSAGE_TYPE_CONFIRM_ORDER value
     * @property {number} MESSAGE_TYPE_SERVER_TXT=14 MESSAGE_TYPE_SERVER_TXT value
     * @property {number} MESSAGE_TYPE_FILE=15 MESSAGE_TYPE_FILE value
     * @property {number} MESSAGE_TYPE_AT=16 MESSAGE_TYPE_AT value
     * @property {number} MESSAGE_TYPE_MONEY_LOG=17 MESSAGE_TYPE_MONEY_LOG value
     * @property {number} MESSAGE_TYPE_PROGRAME=18 MESSAGE_TYPE_PROGRAME value
     * @property {number} MESSAGE_TYPE_AD=19 MESSAGE_TYPE_AD value
     * @property {number} MESSAGE_TYPE_SYSTEM=20 MESSAGE_TYPE_SYSTEM value
     * @property {number} MESSAGE_TYPE_REPLY=21 MESSAGE_TYPE_REPLY value
     * @property {number} MESSAGE_TYPE_CHANNEL=22 MESSAGE_TYPE_CHANNEL value
     * @property {number} MESSAGE_TYPE_VOICE_CHAT1=102 MESSAGE_TYPE_VOICE_CHAT1 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP=10000 MESSAGE_TYPE_CENTER_TIP value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM=10001 MESSAGE_TYPE_CENTER_TIP_CONFIRM value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM1=10002 MESSAGE_TYPE_CENTER_TIP_CONFIRM1 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM2=10003 MESSAGE_TYPE_CENTER_TIP_CONFIRM2 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_GROUP_CODE=10011 MESSAGE_TYPE_CENTER_TIP_GROUP_CODE value
     * @property {number} MESSAGE_TYPE_CENTER_CHAT_ROOM_AD=10012 MESSAGE_TYPE_CENTER_CHAT_ROOM_AD value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_AGORO=20000 MESSAGE_TYPE_CENTER_TIP_AGORO value
     */
    net.MESSAGE_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "MESSAGE_TYPE_TXT"] = 1;
        values[valuesById[2] = "MESSAGE_TYPE_VOICE"] = 2;
        values[valuesById[3] = "MESSAGE_TYPE_VIDEO"] = 3;
        values[valuesById[4] = "MESSAGE_TYPE_IMAGE"] = 4;
        values[valuesById[5] = "MESSAGE_TYPE_REDBAG"] = 5;
        values[valuesById[6] = "MESSAGE_TYPE_SHARE_LINK"] = 6;
        values[valuesById[7] = "MESSAGE_TYPE_CARD"] = 7;
        values[valuesById[8] = "MESSAGE_TYPE_GET_REDBAG"] = 8;
        values[valuesById[9] = "MESSAGE_TYPE_VOICE_CHAT_START"] = 9;
        values[valuesById[10] = "MESSAGE_TYPE_TRANS_MONEY"] = 10;
        values[valuesById[11] = "MESSAGE_TYPE_GROUP_CARD"] = 11;
        values[valuesById[12] = "MESSAGE_TYPE_WITHDRAW_CHATMSG"] = 12;
        values[valuesById[13] = "MESSAGE_TYPE_CONFIRM_ORDER"] = 13;
        values[valuesById[14] = "MESSAGE_TYPE_SERVER_TXT"] = 14;
        values[valuesById[15] = "MESSAGE_TYPE_FILE"] = 15;
        values[valuesById[16] = "MESSAGE_TYPE_AT"] = 16;
        values[valuesById[17] = "MESSAGE_TYPE_MONEY_LOG"] = 17;
        values[valuesById[18] = "MESSAGE_TYPE_PROGRAME"] = 18;
        values[valuesById[19] = "MESSAGE_TYPE_AD"] = 19;
        values[valuesById[20] = "MESSAGE_TYPE_SYSTEM"] = 20;
        values[valuesById[21] = "MESSAGE_TYPE_REPLY"] = 21;
        values[valuesById[22] = "MESSAGE_TYPE_CHANNEL"] = 22;
        values[valuesById[102] = "MESSAGE_TYPE_VOICE_CHAT1"] = 102;
        values[valuesById[10000] = "MESSAGE_TYPE_CENTER_TIP"] = 10000;
        values[valuesById[10001] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM"] = 10001;
        values[valuesById[10002] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM1"] = 10002;
        values[valuesById[10003] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM2"] = 10003;
        values[valuesById[10011] = "MESSAGE_TYPE_CENTER_TIP_GROUP_CODE"] = 10011;
        values[valuesById[10012] = "MESSAGE_TYPE_CENTER_CHAT_ROOM_AD"] = 10012;
        values[valuesById[20000] = "MESSAGE_TYPE_CENTER_TIP_AGORO"] = 20000;
        return values;
    })();

    /**
     * PUSH_CHANNEL enum.
     * @name net.PUSH_CHANNEL
     * @enum {number}
     * @property {number} PUSH_CHANNEL_JG=1 PUSH_CHANNEL_JG value
     * @property {number} PUSH_CHANNEL_HW=2 PUSH_CHANNEL_HW value
     * @property {number} PUSH_CHANNEL_XM=3 PUSH_CHANNEL_XM value
     * @property {number} PUSH_CHANNEL_IOS=4 PUSH_CHANNEL_IOS value
     * @property {number} PUSH_CHANNEL_IOS_AUTHKEY=5 PUSH_CHANNEL_IOS_AUTHKEY value
     * @property {number} PUSH_CHANNEL_67JG=6 PUSH_CHANNEL_67JG value
     */
    net.PUSH_CHANNEL = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PUSH_CHANNEL_JG"] = 1;
        values[valuesById[2] = "PUSH_CHANNEL_HW"] = 2;
        values[valuesById[3] = "PUSH_CHANNEL_XM"] = 3;
        values[valuesById[4] = "PUSH_CHANNEL_IOS"] = 4;
        values[valuesById[5] = "PUSH_CHANNEL_IOS_AUTHKEY"] = 5;
        values[valuesById[6] = "PUSH_CHANNEL_67JG"] = 6;
        return values;
    })();

    /**
     * MONEY_TYPE enum.
     * @name net.MONEY_TYPE
     * @enum {number}
     * @property {number} MONEY_TYPE_TRANSFER_BYCODE=1 MONEY_TYPE_TRANSFER_BYCODE value
     * @property {number} MONEY_TYPE_TRANSFER=2 MONEY_TYPE_TRANSFER value
     * @property {number} MONEY_TYPE_REDBAG=3 MONEY_TYPE_REDBAG value
     * @property {number} MONEY_TYPE_RECHARGE=4 MONEY_TYPE_RECHARGE value
     * @property {number} MONEY_TYPE_WITHDRAW=5 MONEY_TYPE_WITHDRAW value
     * @property {number} MONEY_TYPE_REDBAG_BACK=6 MONEY_TYPE_REDBAG_BACK value
     * @property {number} MONEY_TYPE_GOODS=7 MONEY_TYPE_GOODS value
     * @property {number} MONEY_TYPE_ORDER_BACK=8 MONEY_TYPE_ORDER_BACK value
     * @property {number} MONEY_TYPE_TRANSFER_BYNO=9 MONEY_TYPE_TRANSFER_BYNO value
     * @property {number} MONEY_TYPE_EXCHANGE=10 MONEY_TYPE_EXCHANGE value
     * @property {number} MONEY_TYPE_THIRD_PAY=11 MONEY_TYPE_THIRD_PAY value
     * @property {number} MONEY_TYPE_BACKSITE_OPER=12 MONEY_TYPE_BACKSITE_OPER value
     * @property {number} MONEY_TYPE_SIGNIN=13 MONEY_TYPE_SIGNIN value
     * @property {number} MONEY_TYPE_EXCHANGE_GOODS=14 MONEY_TYPE_EXCHANGE_GOODS value
     * @property {number} MONEY_TYPE_ROOM_SPEAK=15 MONEY_TYPE_ROOM_SPEAK value
     * @property {number} MONEY_TYPE_WATCH_MATCH=16 MONEY_TYPE_WATCH_MATCH value
     * @property {number} MONEY_TYPE_VIP_REWARD=17 MONEY_TYPE_VIP_REWARD value
     * @property {number} MONEY_TYPE_INVITE_REWARD=18 MONEY_TYPE_INVITE_REWARD value
     */
    net.MONEY_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "MONEY_TYPE_TRANSFER_BYCODE"] = 1;
        values[valuesById[2] = "MONEY_TYPE_TRANSFER"] = 2;
        values[valuesById[3] = "MONEY_TYPE_REDBAG"] = 3;
        values[valuesById[4] = "MONEY_TYPE_RECHARGE"] = 4;
        values[valuesById[5] = "MONEY_TYPE_WITHDRAW"] = 5;
        values[valuesById[6] = "MONEY_TYPE_REDBAG_BACK"] = 6;
        values[valuesById[7] = "MONEY_TYPE_GOODS"] = 7;
        values[valuesById[8] = "MONEY_TYPE_ORDER_BACK"] = 8;
        values[valuesById[9] = "MONEY_TYPE_TRANSFER_BYNO"] = 9;
        values[valuesById[10] = "MONEY_TYPE_EXCHANGE"] = 10;
        values[valuesById[11] = "MONEY_TYPE_THIRD_PAY"] = 11;
        values[valuesById[12] = "MONEY_TYPE_BACKSITE_OPER"] = 12;
        values[valuesById[13] = "MONEY_TYPE_SIGNIN"] = 13;
        values[valuesById[14] = "MONEY_TYPE_EXCHANGE_GOODS"] = 14;
        values[valuesById[15] = "MONEY_TYPE_ROOM_SPEAK"] = 15;
        values[valuesById[16] = "MONEY_TYPE_WATCH_MATCH"] = 16;
        values[valuesById[17] = "MONEY_TYPE_VIP_REWARD"] = 17;
        values[valuesById[18] = "MONEY_TYPE_INVITE_REWARD"] = 18;
        return values;
    })();

    /**
     * FREEZE_MONEY_TYPE enum.
     * @name net.FREEZE_MONEY_TYPE
     * @enum {number}
     * @property {number} FREEZE_MONEY_TYPE_RECHARGE=1 FREEZE_MONEY_TYPE_RECHARGE value
     * @property {number} FREEZE_MONEY_TYPE_WITHDRAW=2 FREEZE_MONEY_TYPE_WITHDRAW value
     * @property {number} FREEZE_MONEY_TYPE_USER_RECHARGE=3 FREEZE_MONEY_TYPE_USER_RECHARGE value
     * @property {number} FREEZE_MONEY_TYPE_USER_WITHDRAW=4 FREEZE_MONEY_TYPE_USER_WITHDRAW value
     * @property {number} FREEZE_MONEY_TYPE_ORDER_BACK=5 FREEZE_MONEY_TYPE_ORDER_BACK value
     * @property {number} FREEZE_MONEY_TYPE_GOODS=6 FREEZE_MONEY_TYPE_GOODS value
     * @property {number} FREEZE_MONEY_TYPE_GOODS_WITHDRAW=7 FREEZE_MONEY_TYPE_GOODS_WITHDRAW value
     */
    net.FREEZE_MONEY_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "FREEZE_MONEY_TYPE_RECHARGE"] = 1;
        values[valuesById[2] = "FREEZE_MONEY_TYPE_WITHDRAW"] = 2;
        values[valuesById[3] = "FREEZE_MONEY_TYPE_USER_RECHARGE"] = 3;
        values[valuesById[4] = "FREEZE_MONEY_TYPE_USER_WITHDRAW"] = 4;
        values[valuesById[5] = "FREEZE_MONEY_TYPE_ORDER_BACK"] = 5;
        values[valuesById[6] = "FREEZE_MONEY_TYPE_GOODS"] = 6;
        values[valuesById[7] = "FREEZE_MONEY_TYPE_GOODS_WITHDRAW"] = 7;
        return values;
    })();

    /**
     * SERVICE_FID enum.
     * @name net.SERVICE_FID
     * @enum {number}
     * @property {number} SERVICE_FID_BEGIN=9999 SERVICE_FID_BEGIN value
     * @property {number} SERVICE_FID_UNIQUE=10000 SERVICE_FID_UNIQUE value
     * @property {number} SERVICE_FID_PAY=10001 SERVICE_FID_PAY value
     * @property {number} SERVICE_FID_C01=10010 SERVICE_FID_C01 value
     */
    net.SERVICE_FID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[9999] = "SERVICE_FID_BEGIN"] = 9999;
        values[valuesById[10000] = "SERVICE_FID_UNIQUE"] = 10000;
        values[valuesById[10001] = "SERVICE_FID_PAY"] = 10001;
        values[valuesById[10010] = "SERVICE_FID_C01"] = 10010;
        return values;
    })();

    /**
     * SERVICE_TYPE enum.
     * @name net.SERVICE_TYPE
     * @enum {number}
     * @property {number} SERVICE_TYPE_CUSTOMER=1 SERVICE_TYPE_CUSTOMER value
     * @property {number} SERVICE_TYPE_PAY=2 SERVICE_TYPE_PAY value
     */
    net.SERVICE_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "SERVICE_TYPE_CUSTOMER"] = 1;
        values[valuesById[2] = "SERVICE_TYPE_PAY"] = 2;
        return values;
    })();

    /**
     * COIN_TYPE enum.
     * @name net.COIN_TYPE
     * @enum {number}
     * @property {number} COIN_TYPE_CNY=0 COIN_TYPE_CNY value
     * @property {number} COIN_TYPE_USD=1 COIN_TYPE_USD value
     * @property {number} COIN_TYPE_BUK=2 COIN_TYPE_BUK value
     * @property {number} COIN_TYPE_MYR=3 COIN_TYPE_MYR value
     * @property {number} COIN_TYPE_PHP=4 COIN_TYPE_PHP value
     * @property {number} COIN_TYPE_TWD=5 COIN_TYPE_TWD value
     */
    net.COIN_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "COIN_TYPE_CNY"] = 0;
        values[valuesById[1] = "COIN_TYPE_USD"] = 1;
        values[valuesById[2] = "COIN_TYPE_BUK"] = 2;
        values[valuesById[3] = "COIN_TYPE_MYR"] = 3;
        values[valuesById[4] = "COIN_TYPE_PHP"] = 4;
        values[valuesById[5] = "COIN_TYPE_TWD"] = 5;
        return values;
    })();

    /**
     * THIRD_CHANNEL enum.
     * @name net.THIRD_CHANNEL
     * @enum {number}
     * @property {number} THIRD_CHANNEL_SIX=1 THIRD_CHANNEL_SIX value
     * @property {number} THIRD_CHANNEL_BBQ=2 THIRD_CHANNEL_BBQ value
     * @property {number} THIRD_CHANNEL_BQD=3 THIRD_CHANNEL_BQD value
     * @property {number} THIRD_CHANNEL_F7=4 THIRD_CHANNEL_F7 value
     * @property {number} THIRD_CHANNEL_93=5 THIRD_CHANNEL_93 value
     * @property {number} THIRD_CHANNEL_BTV=6 THIRD_CHANNEL_BTV value
     * @property {number} THIRD_CHANNEL_TQ=7 THIRD_CHANNEL_TQ value
     * @property {number} THIRD_CHANNEL_WQ=8 THIRD_CHANNEL_WQ value
     * @property {number} THIRD_CHANNEL_HONG8=9 THIRD_CHANNEL_HONG8 value
     * @property {number} THIRD_CHANNEL_KUWAN=10 THIRD_CHANNEL_KUWAN value
     * @property {number} THIRD_CHANNEL_LEQIU=11 THIRD_CHANNEL_LEQIU value
     * @property {number} THIRD_CHANNEL_WQ2=12 THIRD_CHANNEL_WQ2 value
     * @property {number} THIRD_CHANNEL_LQ1=13 THIRD_CHANNEL_LQ1 value
     * @property {number} THIRD_CHANNEL_LQ2=14 THIRD_CHANNEL_LQ2 value
     * @property {number} THIRD_CHANNEL_BS=15 THIRD_CHANNEL_BS value
     * @property {number} THIRD_CHANNEL_93Green=16 THIRD_CHANNEL_93Green value
     * @property {number} THIRD_CHANNEL_RSB=17 THIRD_CHANNEL_RSB value
     * @property {number} THIRD_CHANNEL_XZ=18 THIRD_CHANNEL_XZ value
     * @property {number} THIRD_CHANNEL_XKW=19 THIRD_CHANNEL_XKW value
     * @property {number} THIRD_CHANNEL_SSB=20 THIRD_CHANNEL_SSB value
     * @property {number} THIRD_CHANNEL_WTY=21 THIRD_CHANNEL_WTY value
     * @property {number} THIRD_CHANNEL_LEQIU7=22 THIRD_CHANNEL_LEQIU7 value
     * @property {number} THIRD_CHANNEL_LEQIU8=23 THIRD_CHANNEL_LEQIU8 value
     * @property {number} THIRD_CHANNEL_LEQIU9=24 THIRD_CHANNEL_LEQIU9 value
     * @property {number} THIRD_CHANNEL_LEQIU10=25 THIRD_CHANNEL_LEQIU10 value
     * @property {number} THIRD_CHANNEL_IDN=50 THIRD_CHANNEL_IDN value
     * @property {number} THIRD_CHANNEL_QSJ1=60 THIRD_CHANNEL_QSJ1 value
     * @property {number} THIRD_CHANNEL_QSJ2=61 THIRD_CHANNEL_QSJ2 value
     * @property {number} THIRD_CHANNEL_QSJ3=62 THIRD_CHANNEL_QSJ3 value
     * @property {number} THIRD_CHANNEL_QSJ4=63 THIRD_CHANNEL_QSJ4 value
     * @property {number} THIRD_CHANNEL_THAI=100 THIRD_CHANNEL_THAI value
     */
    net.THIRD_CHANNEL = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "THIRD_CHANNEL_SIX"] = 1;
        values[valuesById[2] = "THIRD_CHANNEL_BBQ"] = 2;
        values[valuesById[3] = "THIRD_CHANNEL_BQD"] = 3;
        values[valuesById[4] = "THIRD_CHANNEL_F7"] = 4;
        values[valuesById[5] = "THIRD_CHANNEL_93"] = 5;
        values[valuesById[6] = "THIRD_CHANNEL_BTV"] = 6;
        values[valuesById[7] = "THIRD_CHANNEL_TQ"] = 7;
        values[valuesById[8] = "THIRD_CHANNEL_WQ"] = 8;
        values[valuesById[9] = "THIRD_CHANNEL_HONG8"] = 9;
        values[valuesById[10] = "THIRD_CHANNEL_KUWAN"] = 10;
        values[valuesById[11] = "THIRD_CHANNEL_LEQIU"] = 11;
        values[valuesById[12] = "THIRD_CHANNEL_WQ2"] = 12;
        values[valuesById[13] = "THIRD_CHANNEL_LQ1"] = 13;
        values[valuesById[14] = "THIRD_CHANNEL_LQ2"] = 14;
        values[valuesById[15] = "THIRD_CHANNEL_BS"] = 15;
        values[valuesById[16] = "THIRD_CHANNEL_93Green"] = 16;
        values[valuesById[17] = "THIRD_CHANNEL_RSB"] = 17;
        values[valuesById[18] = "THIRD_CHANNEL_XZ"] = 18;
        values[valuesById[19] = "THIRD_CHANNEL_XKW"] = 19;
        values[valuesById[20] = "THIRD_CHANNEL_SSB"] = 20;
        values[valuesById[21] = "THIRD_CHANNEL_WTY"] = 21;
        values[valuesById[22] = "THIRD_CHANNEL_LEQIU7"] = 22;
        values[valuesById[23] = "THIRD_CHANNEL_LEQIU8"] = 23;
        values[valuesById[24] = "THIRD_CHANNEL_LEQIU9"] = 24;
        values[valuesById[25] = "THIRD_CHANNEL_LEQIU10"] = 25;
        values[valuesById[50] = "THIRD_CHANNEL_IDN"] = 50;
        values[valuesById[60] = "THIRD_CHANNEL_QSJ1"] = 60;
        values[valuesById[61] = "THIRD_CHANNEL_QSJ2"] = 61;
        values[valuesById[62] = "THIRD_CHANNEL_QSJ3"] = 62;
        values[valuesById[63] = "THIRD_CHANNEL_QSJ4"] = 63;
        values[valuesById[100] = "THIRD_CHANNEL_THAI"] = 100;
        return values;
    })();

    /**
     * CLIENT_MSG_ID enum.
     * @name net.CLIENT_MSG_ID
     * @enum {number}
     * @property {number} C2S_MSG_HEART=1000 C2S_MSG_HEART value
     * @property {number} C2S_MSG_LOGIN=1001 C2S_MSG_LOGIN value
     * @property {number} S2C_MSG_LOGIN_REP=1002 S2C_MSG_LOGIN_REP value
     * @property {number} S2C_MSG_USER_INFO=1003 S2C_MSG_USER_INFO value
     * @property {number} S2C_MSG_ADD_FRIEND_NTY=1004 S2C_MSG_ADD_FRIEND_NTY value
     * @property {number} C2S_MSG_ADD_FRIEND=1005 C2S_MSG_ADD_FRIEND value
     * @property {number} S2C_MSG_ADD_FRIEND_REP=1006 S2C_MSG_ADD_FRIEND_REP value
     * @property {number} C2S_MSG_HANDLE_FRIEND_APPLY=1007 C2S_MSG_HANDLE_FRIEND_APPLY value
     * @property {number} S2C_MSG_HANDLE_FRIEND_APPLY_REP=1008 S2C_MSG_HANDLE_FRIEND_APPLY_REP value
     * @property {number} C2S_MSG_FRIEND_APPLY_LIST=1009 C2S_MSG_FRIEND_APPLY_LIST value
     * @property {number} S2C_MSG_FRIEND_APPLY_LIST_REP=1010 S2C_MSG_FRIEND_APPLY_LIST_REP value
     * @property {number} C2S_MSG_FRIEND_LIST=1011 C2S_MSG_FRIEND_LIST value
     * @property {number} S2C_MSG_FRIEND_LIST_REP=1012 S2C_MSG_FRIEND_LIST_REP value
     * @property {number} C2S_MSG_GET_USER_INFO=1013 C2S_MSG_GET_USER_INFO value
     * @property {number} S2C_MSG_GET_USER_INFO_REP=1014 S2C_MSG_GET_USER_INFO_REP value
     * @property {number} C2S_MSG_SEND_PRIVATE_MSG=1015 C2S_MSG_SEND_PRIVATE_MSG value
     * @property {number} S2C_MSG_SEND_PRIVATE_MSG_REP=1016 S2C_MSG_SEND_PRIVATE_MSG_REP value
     * @property {number} C2S_MSG_GET_MSG_LIST=1017 C2S_MSG_GET_MSG_LIST value
     * @property {number} S2C_MSG_GET_MSG_LIST_REP=1018 S2C_MSG_GET_MSG_LIST_REP value
     * @property {number} C2S_MSG_CONFIRM_READ_MSG=1019 C2S_MSG_CONFIRM_READ_MSG value
     * @property {number} S2C_MSG_CONFIRM_READ_MSG_REP=1020 S2C_MSG_CONFIRM_READ_MSG_REP value
     * @property {number} C2S_MSG_CREATE_GROUP_CHAT=1021 C2S_MSG_CREATE_GROUP_CHAT value
     * @property {number} S2C_MSG_CREATE_GROUP_CHAT_REP=1022 S2C_MSG_CREATE_GROUP_CHAT_REP value
     * @property {number} C2S_MSG_ADD_GROUP_MEMBER=1023 C2S_MSG_ADD_GROUP_MEMBER value
     * @property {number} S2C_MSG_ADD_GROUP_MEMBER_REP=1024 S2C_MSG_ADD_GROUP_MEMBER_REP value
     * @property {number} C2S_MSG_DEL_GROUP_MEMBER=1025 C2S_MSG_DEL_GROUP_MEMBER value
     * @property {number} S2C_MSG_DEL_GROUP_MEMBER_REP=1026 S2C_MSG_DEL_GROUP_MEMBER_REP value
     * @property {number} C2S_MSG_DISMISS_GROUP=1027 C2S_MSG_DISMISS_GROUP value
     * @property {number} S2C_MSG_DISMISS_GROUP_REP=1028 S2C_MSG_DISMISS_GROUP_REP value
     * @property {number} C2S_MSG_SEND_GROUP_MSG=1029 C2S_MSG_SEND_GROUP_MSG value
     * @property {number} S2C_MSG_SEND_GROUP_MSG_REP=1030 S2C_MSG_SEND_GROUP_MSG_REP value
     * @property {number} C2S_MSG_GET_GROUP_INFO=1031 C2S_MSG_GET_GROUP_INFO value
     * @property {number} S2C_MSG_GET_GROUP_INFO_REP=1032 S2C_MSG_GET_GROUP_INFO_REP value
     * @property {number} C2S_MSG_CONFIRM_GROUP_INFO=1033 C2S_MSG_CONFIRM_GROUP_INFO value
     * @property {number} S2C_MSG_CONFIRM_GROUP_INFO_REP=1034 S2C_MSG_CONFIRM_GROUP_INFO_REP value
     * @property {number} C2S_MSG_GET_REDBAG_INFO=1035 C2S_MSG_GET_REDBAG_INFO value
     * @property {number} S2C_MSG_GET_REDBAG_INFO_REP=1036 S2C_MSG_GET_REDBAG_INFO_REP value
     * @property {number} C2S_MSG_MODIFY_GROUPNAME=1037 C2S_MSG_MODIFY_GROUPNAME value
     * @property {number} S2C_MSG_MODIFY_GROUPNAME_REP=1038 S2C_MSG_MODIFY_GROUPNAME_REP value
     * @property {number} C2S_MSG_MODIFY_GROUPNOTIFY=1039 C2S_MSG_MODIFY_GROUPNOTIFY value
     * @property {number} S2C_MSG_MODIFY_GROUPNOTIFY_REP=1040 S2C_MSG_MODIFY_GROUPNOTIFY_REP value
     * @property {number} C2S_MSG_SET_GROUPADMIN=1041 C2S_MSG_SET_GROUPADMIN value
     * @property {number} S2C_MSG_SET_GROUPADMIN_REP=1042 S2C_MSG_SET_GROUPADMIN_REP value
     * @property {number} C2S_MSG_SET_GROUPINFO_LIMITS=1043 C2S_MSG_SET_GROUPINFO_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPINFO_LIMITS_REP=1044 S2C_MSG_SET_GROUPINFO_LIMITS_REP value
     * @property {number} C2S_MSG_SET_GROUPADD_LIMITS=1045 C2S_MSG_SET_GROUPADD_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPADD_LIMITS_REP=1046 S2C_MSG_SET_GROUPADD_LIMITS_REP value
     * @property {number} C2S_MSG_DEL_GROUPADMIN=1047 C2S_MSG_DEL_GROUPADMIN value
     * @property {number} S2C_MSG_DEL_GROUPADMIN_REP=1048 S2C_MSG_DEL_GROUPADMIN_REP value
     * @property {number} C2S_MSG_SET_GROUPLOOK_LIMITS=1049 C2S_MSG_SET_GROUPLOOK_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPLOOK_LIMITS_REP=1050 S2C_MSG_SET_GROUPLOOK_LIMITS_REP value
     * @property {number} C2S_MSG_SET_GROUPHOST=1051 C2S_MSG_SET_GROUPHOST value
     * @property {number} S2C_MSG_SET_GROUPHOST_REP=1052 S2C_MSG_SET_GROUPHOST_REP value
     * @property {number} C2S_MSG_GET_REDBAG=1053 C2S_MSG_GET_REDBAG value
     * @property {number} S2C_MSG_GET_REDBAG_REP=1054 S2C_MSG_GET_REDBAG_REP value
     * @property {number} C2S_MSG_INPUT_SYNC=1055 C2S_MSG_INPUT_SYNC value
     * @property {number} S2C_MSG_INPUT_SYNC_REP=1056 S2C_MSG_INPUT_SYNC_REP value
     * @property {number} C2S_MSG_GET_ONLINE_STATE=1057 C2S_MSG_GET_ONLINE_STATE value
     * @property {number} S2C_MSG_GET_ONLINE_STATE_REP=1058 S2C_MSG_GET_ONLINE_STATE_REP value
     * @property {number} C2S_MSG_GET_GROUP_ONLINE=1059 C2S_MSG_GET_GROUP_ONLINE value
     * @property {number} S2C_MSG_GET_GROUP_ONLINE_REP=1060 S2C_MSG_GET_GROUP_ONLINE_REP value
     * @property {number} C2S_MSG_SET_MUTE_NOTIFICATIONS=1061 C2S_MSG_SET_MUTE_NOTIFICATIONS value
     * @property {number} S2C_MSG_SET_MUTE_NOTIFICATIONS_REP=1062 S2C_MSG_SET_MUTE_NOTIFICATIONS_REP value
     * @property {number} C2S_MSG_SET_CHAT_ON_TOP=1063 C2S_MSG_SET_CHAT_ON_TOP value
     * @property {number} S2C_MSG_SET_CHAT_ON_TOP_REP=1064 S2C_MSG_SET_CHAT_ON_TOP_REP value
     * @property {number} C2S_MSG_GET_MUTE_NOTIFY_LIST=1065 C2S_MSG_GET_MUTE_NOTIFY_LIST value
     * @property {number} S2C_MSG_GET_MUTE_NOTIFY_LIST_REP=1066 S2C_MSG_GET_MUTE_NOTIFY_LIST_REP value
     * @property {number} C2S_MSG_GET_CHAT_ON_TOP_LIST=1067 C2S_MSG_GET_CHAT_ON_TOP_LIST value
     * @property {number} S2C_MSG_GET_CHAT_ON_TOP_LIST_REP=1068 S2C_MSG_GET_CHAT_ON_TOP_LIST_REP value
     * @property {number} C2S_MSG_DEL_CHAT_MSG=1069 C2S_MSG_DEL_CHAT_MSG value
     * @property {number} S2C_MSG_DEL_CHAT_MSG_REP=1070 S2C_MSG_DEL_CHAT_MSG_REP value
     * @property {number} C2S_MSG_CONFIRM_DEL_MSG=1071 C2S_MSG_CONFIRM_DEL_MSG value
     * @property {number} S2C_MSG_CONFIRM_DEL_MSG_REP=1072 S2C_MSG_CONFIRM_DEL_MSG_REP value
     * @property {number} C2S_MSG_GET_OFFLINE_DATA=1073 C2S_MSG_GET_OFFLINE_DATA value
     * @property {number} C2S_MSG_GET_OFFLINE_DATA_REP=1074 C2S_MSG_GET_OFFLINE_DATA_REP value
     * @property {number} C2S_MSG_DELETE_FRIEND=1075 C2S_MSG_DELETE_FRIEND value
     * @property {number} S2C_MSG_DELETE_FRIEND_REP=1076 S2C_MSG_DELETE_FRIEND_REP value
     * @property {number} C2S_MSG_SET_ALIAS=1077 C2S_MSG_SET_ALIAS value
     * @property {number} S2C_MSG_SET_ALIAS_REP=1078 S2C_MSG_SET_ALIAS_REP value
     * @property {number} C2S_MSG_GET_ALIAS_LIST=1079 C2S_MSG_GET_ALIAS_LIST value
     * @property {number} S2C_MSG_GET_ALIAS_LIST_REP=1080 S2C_MSG_GET_ALIAS_LIST_REP value
     * @property {number} C2S_MSG_SET_SIGN=1081 C2S_MSG_SET_SIGN value
     * @property {number} S2C_MSG_SET_SIGN_REP=1082 S2C_MSG_SET_SIGN_REP value
     * @property {number} C2S_MSG_SET_REGION=1083 C2S_MSG_SET_REGION value
     * @property {number} S2C_MSG_SET_REGION_REP=1084 S2C_MSG_SET_REGION_REP value
     * @property {number} C2S_MSG_SET_HEADURL=1085 C2S_MSG_SET_HEADURL value
     * @property {number} S2C_MSG_SET_HEADURL_REP=1086 S2C_MSG_SET_HEADURL_REP value
     * @property {number} C2S_MSG_SET_NAME=1087 C2S_MSG_SET_NAME value
     * @property {number} S2C_MSG_SET_NAME_REP=1088 S2C_MSG_SET_NAME_REP value
     * @property {number} C2S_MSG_TOTAL_REDBAG_RECORD=1089 C2S_MSG_TOTAL_REDBAG_RECORD value
     * @property {number} S2C_MSG_TOTAL_REDBAG_RECORD_RESP=1090 S2C_MSG_TOTAL_REDBAG_RECORD_RESP value
     * @property {number} C2S_MSG_UPLOAD_ADDRESSBOOK=1091 C2S_MSG_UPLOAD_ADDRESSBOOK value
     * @property {number} S2C_MSG_UPLOAD_ADDRESSBOOK_REP=1092 S2C_MSG_UPLOAD_ADDRESSBOOK_REP value
     * @property {number} C2S_MSG_GET_ADDRESSBOOK=1093 C2S_MSG_GET_ADDRESSBOOK value
     * @property {number} S2C_MSG_GET_ADDRESSBOOK_REP=1094 S2C_MSG_GET_ADDRESSBOOK_REP value
     * @property {number} C2S_MSG_UPLOAD_PUSHID=1095 C2S_MSG_UPLOAD_PUSHID value
     * @property {number} S2C_MSG_UPLOAD_PUSHID_REP=1096 S2C_MSG_UPLOAD_PUSHID_REP value
     * @property {number} C2S_MSG_SET_BACKGROUND=1097 C2S_MSG_SET_BACKGROUND value
     * @property {number} S2C_MSG_SET_BACKGROUND_REP=1098 S2C_MSG_SET_BACKGROUND_REP value
     * @property {number} C2S_MSG_CONFIRM_HASREAD_MSG=1099 C2S_MSG_CONFIRM_HASREAD_MSG value
     * @property {number} S2C_MSG_CONFIRM_HASREAD_MSG_REP=1100 S2C_MSG_CONFIRM_HASREAD_MSG_REP value
     * @property {number} C2S_MSG_GET_HASREAD_LIST=1101 C2S_MSG_GET_HASREAD_LIST value
     * @property {number} S2C_MSG_GET_HASREAD_LIST_REP=1102 S2C_MSG_GET_HASREAD_LIST_REP value
     * @property {number} C2S_MSG_TRANSFER_ACCOUNT=1103 C2S_MSG_TRANSFER_ACCOUNT value
     * @property {number} S2C_MSG_TRANSFER_ACCOUNT_REP=1104 S2C_MSG_TRANSFER_ACCOUNT_REP value
     * @property {number} C2S_MSG_GET_ONLINE_LIST=1105 C2S_MSG_GET_ONLINE_LIST value
     * @property {number} S2C_MSG_GET_ONLINE_LIST_REP=1106 S2C_MSG_GET_ONLINE_LIST_REP value
     * @property {number} C2S_MSG_GET_MONEY_CHANGE_LIST=1107 C2S_MSG_GET_MONEY_CHANGE_LIST value
     * @property {number} S2C_MSG_GET_MONEY_CHANGE_LIST_REP=1108 S2C_MSG_GET_MONEY_CHANGE_LIST_REP value
     * @property {number} C2S_MSG_GET_PAY_AUTH_CODE=1109 C2S_MSG_GET_PAY_AUTH_CODE value
     * @property {number} S2C_MSG_GET_PAY_AUTH_CODE_REP=1110 S2C_MSG_GET_PAY_AUTH_CODE_REP value
     * @property {number} C2S_MSG_JOINGROUP_BYQRCODE=1111 C2S_MSG_JOINGROUP_BYQRCODE value
     * @property {number} S2C_MSG_JOINGROUP_BYQRCODE_REP=1112 S2C_MSG_JOINGROUP_BYQRCODE_REP value
     * @property {number} C2S_MSG_CREATE_GOODS=1113 C2S_MSG_CREATE_GOODS value
     * @property {number} S2C_MSG_CREATE_GOODS_REP=1114 S2C_MSG_CREATE_GOODS_REP value
     * @property {number} C2S_MSG_GET_MY_GOODS=1115 C2S_MSG_GET_MY_GOODS value
     * @property {number} S2C_MSG_GET_MY_GOODS_REP=1116 S2C_MSG_GET_MY_GOODS_REP value
     * @property {number} C2S_MSG_GET_GOODS=1117 C2S_MSG_GET_GOODS value
     * @property {number} S2C_MSG_GET_GOODS_REP=1118 S2C_MSG_GET_GOODS_REP value
     * @property {number} C2S_MSG_CREATE_ORDER=1119 C2S_MSG_CREATE_ORDER value
     * @property {number} S2C_MSG_CREATE_ORDER_REP=1120 S2C_MSG_CREATE_ORDER_REP value
     * @property {number} C2S_MSG_CONFIRM_ORDER=1121 C2S_MSG_CONFIRM_ORDER value
     * @property {number} S2C_MSG_CONFIRM_ORDER_REP=1122 S2C_MSG_CONFIRM_ORDER_REP value
     * @property {number} C2S_MSG_GET_MY_ORDERS=1123 C2S_MSG_GET_MY_ORDERS value
     * @property {number} S2C_MSG_GET_MY_ORDERS_REP=1124 S2C_MSG_GET_MY_ORDERS_REP value
     * @property {number} C2S_MSG_GET_ORDER_INFO=1125 C2S_MSG_GET_ORDER_INFO value
     * @property {number} S2C_MSG_GET_ORDER_INFO_REP=1126 S2C_MSG_GET_ORDER_INFO_REP value
     * @property {number} C2S_MSG_GET_GOODS_BYID=1127 C2S_MSG_GET_GOODS_BYID value
     * @property {number} S2C_MSG_GET_GOODS_BYID_REP=1128 S2C_MSG_GET_GOODS_BYID_REP value
     * @property {number} C2S_MSG_WITHDRAW_CHATMSG=1129 C2S_MSG_WITHDRAW_CHATMSG value
     * @property {number} S2C_MSG_WITHDRAW_CHATMSG_REP=1130 S2C_MSG_WITHDRAW_CHATMSG_REP value
     * @property {number} C2S_MSG_CANCEL_ORDER=1131 C2S_MSG_CANCEL_ORDER value
     * @property {number} S2C_MSG_CANCEL_ORDER_REP=1132 S2C_MSG_CANCEL_ORDER_REP value
     * @property {number} C2S_MSG_GET_GROUP_NICKNAME_LIST=1133 C2S_MSG_GET_GROUP_NICKNAME_LIST value
     * @property {number} S2C_MSG_GET_GROUP_NICKNAME_LIST_REP=1134 S2C_MSG_GET_GROUP_NICKNAME_LIST_REP value
     * @property {number} C2S_MSG_SET_GROUP_NICKNAME=1135 C2S_MSG_SET_GROUP_NICKNAME value
     * @property {number} S2C_MSG_SET_GROUP_NICKNAME_REP=1136 S2C_MSG_SET_GROUP_NICKNAME_REP value
     * @property {number} C2S_MSG_SET_ORDER_PAYTYPEID=1137 C2S_MSG_SET_ORDER_PAYTYPEID value
     * @property {number} S2C_MSG_SET_ORDER_PAYTYPEID_REP=1138 S2C_MSG_SET_ORDER_PAYTYPEID_REP value
     * @property {number} C2S_MSG_GET_GOODS_DATA=1139 C2S_MSG_GET_GOODS_DATA value
     * @property {number} S2C_MSG_GET_GOODS_DATA_REP=1140 S2C_MSG_GET_GOODS_DATA_REP value
     * @property {number} C2S_MSG_GET_GOODS_DETAIL_DATA=1141 C2S_MSG_GET_GOODS_DETAIL_DATA value
     * @property {number} S2C_MSG_GET_GOODS_DETAIL_DATA_REP=1142 S2C_MSG_GET_GOODS_DETAIL_DATA_REP value
     * @property {number} C2S_MSG_OPER_SHOPCOIN=1143 C2S_MSG_OPER_SHOPCOIN value
     * @property {number} S2C_MSG_OPER_SHOPCOIN_REP=1144 S2C_MSG_OPER_SHOPCOIN_REP value
     * @property {number} C2S_MSG_SET_SNAPCHAT=1145 C2S_MSG_SET_SNAPCHAT value
     * @property {number} S2C_MSG_SET_SNAPCHAT_REP=1146 S2C_MSG_SET_SNAPCHAT_REP value
     * @property {number} C2S_MSG_GET_SNAPCHAT_LIST=1147 C2S_MSG_GET_SNAPCHAT_LIST value
     * @property {number} S2C_MSG_GET_SNAPCHAT_LIST_REP=1148 S2C_MSG_GET_SNAPCHAT_LIST_REP value
     * @property {number} C2S_MSG_GET_SCREENSHOT=1149 C2S_MSG_GET_SCREENSHOT value
     * @property {number} S2C_MSG_GET_SCREENSHOT_REP=1150 S2C_MSG_GET_SCREENSHOT_REP value
     * @property {number} C2S_MSG_SET_SCREENSHOT=1151 C2S_MSG_SET_SCREENSHOT value
     * @property {number} S2C_MSG_SET_SCREENSHOT_REP=1152 S2C_MSG_SET_SCREENSHOT_REP value
     * @property {number} C2S_MSG_SET_GROUPSENDMSG_LIMIT=1153 C2S_MSG_SET_GROUPSENDMSG_LIMIT value
     * @property {number} S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP=1154 S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP value
     * @property {number} C2S_MSG_GET_ORDER_INFO_BYID=1155 C2S_MSG_GET_ORDER_INFO_BYID value
     * @property {number} S2C_MSG_GET_ORDER_INFO_BYID_REP=1156 S2C_MSG_GET_ORDER_INFO_BYID_REP value
     * @property {number} C2S_MSG_GET_BLACK_LIST=1157 C2S_MSG_GET_BLACK_LIST value
     * @property {number} SC2_MSG_GET_BLACK_LIST_REP=1158 SC2_MSG_GET_BLACK_LIST_REP value
     * @property {number} C2S_MSG_SET_BLACK_LIST=1159 C2S_MSG_SET_BLACK_LIST value
     * @property {number} SC2_MSG_SET_BLACK_LIST_REP=1160 SC2_MSG_SET_BLACK_LIST_REP value
     * @property {number} C2S_MSG_THIRD_PAY=1161 C2S_MSG_THIRD_PAY value
     * @property {number} S2C_MSG_THIRD_PAY_REP=1162 S2C_MSG_THIRD_PAY_REP value
     * @property {number} C2S_MSG_PCAUTH=1163 C2S_MSG_PCAUTH value
     * @property {number} S2C_MSG_PCAUTH_REP=1164 S2C_MSG_PCAUTH_REP value
     * @property {number} C2S_MSG_PCLOGIN=1165 C2S_MSG_PCLOGIN value
     * @property {number} S2C_MSG_PCLOGIN_REP=1166 S2C_MSG_PCLOGIN_REP value
     * @property {number} C2S_MSG_VOICE_CALL=1167 C2S_MSG_VOICE_CALL value
     * @property {number} S2C_MSG_VOICE_CALL_REP=1168 S2C_MSG_VOICE_CALL_REP value
     * @property {number} C2S_MSG_OPER_VOICE_CALL=1169 C2S_MSG_OPER_VOICE_CALL value
     * @property {number} S2C_MSG_OPER_VOICE_CALL_REP=1170 S2C_MSG_OPER_VOICE_CALL_REP value
     * @property {number} C2S_MSG_VOICE_DATA=1171 C2S_MSG_VOICE_DATA value
     * @property {number} S2C_MSG_VOICE_DATA_REP=1172 S2C_MSG_VOICE_DATA_REP value
     * @property {number} C2S_MSG_NEED_READ_GROUP_NOTIFY=1173 C2S_MSG_NEED_READ_GROUP_NOTIFY value
     * @property {number} S2C_MSG_NEED_READ_GROUP_NOTIFY_REP=1174 S2C_MSG_NEED_READ_GROUP_NOTIFY_REP value
     * @property {number} C2S_MSG_READ_GROUP_NOTIFY=1175 C2S_MSG_READ_GROUP_NOTIFY value
     * @property {number} S2C_MSG_READ_GROUP_NOTIFY_REP=1176 S2C_MSG_READ_GROUP_NOTIFY_REP value
     * @property {number} C2S_MSG_SET_FORBID_TM=1177 C2S_MSG_SET_FORBID_TM value
     * @property {number} S2C_MSG_SET_FORBID_TM_REP=1178 S2C_MSG_SET_FORBID_TM_REP value
     * @property {number} C2S_MSG_GET_GROUP_MEMBER_LIST=1179 C2S_MSG_GET_GROUP_MEMBER_LIST value
     * @property {number} S2C_MSG_GET_GROUP_MEMBER_LIST_REP=1180 S2C_MSG_GET_GROUP_MEMBER_LIST_REP value
     * @property {number} C2S_MSG_GET_FRIEND_INCR_LIST=1181 C2S_MSG_GET_FRIEND_INCR_LIST value
     * @property {number} S2C_MSG_GET_FRIEND_INCR_LIST_REP=1182 S2C_MSG_GET_FRIEND_INCR_LIST_REP value
     * @property {number} C2S_MSG_BIND_OPENID=1183 C2S_MSG_BIND_OPENID value
     * @property {number} S2C_MSG_BING_OPENID_REP=1184 S2C_MSG_BING_OPENID_REP value
     * @property {number} C2S_MSG_H5LOGIN=1185 C2S_MSG_H5LOGIN value
     * @property {number} S2C_MSG_H5LOGIN_REP=1186 S2C_MSG_H5LOGIN_REP value
     * @property {number} C2S_MSG_ADD_FRIEND_BYFID=1187 C2S_MSG_ADD_FRIEND_BYFID value
     * @property {number} S2C_MSG_ADD_FRIEND_BYFID_REP=1188 S2C_MSG_ADD_FRIEND_BYFID_REP value
     * @property {number} C2S_MSG_SET_GROUP_HEADURL=1189 C2S_MSG_SET_GROUP_HEADURL value
     * @property {number} S2C_MSG_SET_GROUP_HEADURL_REP=1190 S2C_MSG_SET_GROUP_HEADURL_REP value
     * @property {number} C2S_MSG_SET_COMPLETE_NAME=1191 C2S_MSG_SET_COMPLETE_NAME value
     * @property {number} S2C_MSG_SET_COMPLETE_NAME_REP=1192 S2C_MSG_SET_COMPLETE_NAME_REP value
     * @property {number} C2S_MSG_SET_PHONENUM=1193 C2S_MSG_SET_PHONENUM value
     * @property {number} S2C_MSG_SET_PHONENUM_REP=1194 S2C_MSG_SET_PHONENUM_REP value
     * @property {number} C2S_MSG_SET_PRIVACY=1195 C2S_MSG_SET_PRIVACY value
     * @property {number} S2C_MSG_SET_PRIVACY_REP=1196 S2C_MSG_SET_PRIVACY_REP value
     * @property {number} C2S_MSG_GROUP_VOICE_CALL=901 C2S_MSG_GROUP_VOICE_CALL value
     * @property {number} S2C_MSG_GROUP_VOICE_CALL_REP=902 S2C_MSG_GROUP_VOICE_CALL_REP value
     * @property {number} C2S_MSG_JOIN_GROUP_VOICE_CALL=903 C2S_MSG_JOIN_GROUP_VOICE_CALL value
     * @property {number} S2C_MSG_JOIN_GROUP_VOICE_CALL_REP=904 S2C_MSG_JOIN_GROUP_VOICE_CALL_REP value
     * @property {number} C2S_MSG_OPER_GROUP_VOICE_CALL=905 C2S_MSG_OPER_GROUP_VOICE_CALL value
     * @property {number} S2C_MSG_OPER_GROUP_VOICE_CALL_REP=906 S2C_MSG_OPER_GROUP_VOICE_CALL_REP value
     * @property {number} C2S_MSG_SET_GROUPADMIN_NEW=907 C2S_MSG_SET_GROUPADMIN_NEW value
     * @property {number} S2C_MSG_SET_GROUPADMIN_NEW_REP=908 S2C_MSG_SET_GROUPADMIN_NEW_REP value
     * @property {number} C2S_MSG_SET_GROUPFORBID=909 C2S_MSG_SET_GROUPFORBID value
     * @property {number} S2C_MSG_SET_GROUPFORBID_REP=910 S2C_MSG_SET_GROUPFORBID_REP value
     * @property {number} C2S_MSG_GET_GROUPFORBID_LIST=911 C2S_MSG_GET_GROUPFORBID_LIST value
     * @property {number} S2C_MSG_GET_GROUPFORBID_LIST_REP=912 S2C_MSG_GET_GROUPFORBID_LIST_REP value
     * @property {number} C2S_MSG_SET_BTY_REGISTER=913 C2S_MSG_SET_BTY_REGISTER value
     * @property {number} S2C_MSG_SET_BTY_REGISTER_REP=914 S2C_MSG_SET_BTY_REGISTER_REP value
     * @property {number} C2S_MSG_SET_BTY_TOPUP=915 C2S_MSG_SET_BTY_TOPUP value
     * @property {number} S2C_MSG_SET_BTY_TOPUP_REP=916 S2C_MSG_SET_BTY_TOPUP_REP value
     * @property {number} C2S_MSG_APPLY_FRIEND_NEED_VERIFY=917 C2S_MSG_APPLY_FRIEND_NEED_VERIFY value
     * @property {number} S2C_MSG_APPLY_FRIEND_NEED_VERIFY_REP=918 S2C_MSG_APPLY_FRIEND_NEED_VERIFY_REP value
     * @property {number} C2S_MSG_SET_GROUPWHITE=919 C2S_MSG_SET_GROUPWHITE value
     * @property {number} S2C_MSG_SET_GROUPWHITE_REP=920 S2C_MSG_SET_GROUPWHITE_REP value
     * @property {number} C2S_MSG_GET_GROUPWHITE_LIST=921 C2S_MSG_GET_GROUPWHITE_LIST value
     * @property {number} S2C_MSG_GET_GROUPWHITE_LIST_REP=922 S2C_MSG_GET_GROUPWHITE_LIST_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_LIST=1301 C2S_MSG_GET_CHATROOM_LIST value
     * @property {number} S2C_MSG_GET_CHATROOM_LIST_REP=1302 S2C_MSG_GET_CHATROOM_LIST_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_MEMBERS=1303 C2S_MSG_GET_CHATROOM_MEMBERS value
     * @property {number} S2C_MSG_GET_CHATROOM_MEMBERS_REP=1304 S2C_MSG_GET_CHATROOM_MEMBERS_REP value
     * @property {number} C2S_MSG_JOIN_CHATROOM=1305 C2S_MSG_JOIN_CHATROOM value
     * @property {number} S2C_MSG_JOIN_CHATROOM_REP=1306 S2C_MSG_JOIN_CHATROOM_REP value
     * @property {number} C2S_MSG_QUIT_CHATROOM=1307 C2S_MSG_QUIT_CHATROOM value
     * @property {number} S2C_MSG_QUIT_CHATROOM_REP=1308 S2C_MSG_QUIT_CHATROOM_REP value
     * @property {number} C2S_MSG_SEND_CHATROOM_MSG=1309 C2S_MSG_SEND_CHATROOM_MSG value
     * @property {number} S2C_MSG_SEND_CHATROOM_MSG_REP=1310 S2C_MSG_SEND_CHATROOM_MSG_REP value
     * @property {number} C2S_MSG_CHATROOM_KICKOUT=1311 C2S_MSG_CHATROOM_KICKOUT value
     * @property {number} S2C_MSG_CHATROOM_KICKOUT_REP=1312 S2C_MSG_CHATROOM_KICKOUT_REP value
     * @property {number} C2S_MSG_CHATROOM_FORBID=1313 C2S_MSG_CHATROOM_FORBID value
     * @property {number} S2C_MSG_CHATROOM_FORBID_REP=1314 S2C_MSG_CHATROOM_FORBID_REP value
     * @property {number} C2S_MSG_DEL_CHATROOM_MSG=1315 C2S_MSG_DEL_CHATROOM_MSG value
     * @property {number} S2C_MSG_DEL_CHATROOM_MSG_REP=1316 S2C_MSG_DEL_CHATROOM_MSG_REP value
     * @property {number} C2S_MSG_CHATROOM_SET_ADMIN=1317 C2S_MSG_CHATROOM_SET_ADMIN value
     * @property {number} S2C_MSG_CHATROOM_SET_ADMIN_REP=1318 S2C_MSG_CHATROOM_SET_ADMIN_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_HISTORY_MSG=1319 C2S_MSG_GET_CHATROOM_HISTORY_MSG value
     * @property {number} S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP=1320 S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP value
     * @property {number} S2C_MSG_JOIN_CHATROOM_NTY=1321 S2C_MSG_JOIN_CHATROOM_NTY value
     * @property {number} C2S_MSG_CHATROOM_NTY_MSG_TOALL=1323 C2S_MSG_CHATROOM_NTY_MSG_TOALL value
     * @property {number} S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP=1324 S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP value
     * @property {number} C2S_MSG_SEND_CHATROOM_AD=1325 C2S_MSG_SEND_CHATROOM_AD value
     * @property {number} S2C_MSG_SEND_CHATROOM_AD_REP=1326 S2C_MSG_SEND_CHATROOM_AD_REP value
     * @property {number} C2S_MSG_ALLCHATROOM_FORBID=1327 C2S_MSG_ALLCHATROOM_FORBID value
     * @property {number} S2C_MSG_ALLCHATROOM_FORBID_REP=1328 S2C_MSG_ALLCHATROOM_FORBID_REP value
     * @property {number} C2S_MSG_GET_FORBID_STATE=1329 C2S_MSG_GET_FORBID_STATE value
     * @property {number} S2C_MSG_GET_FORBID_STATE_REP=1330 S2C_MSG_GET_FORBID_STATE_REP value
     * @property {number} C2S_MSG_FORBID_CONTENT=1331 C2S_MSG_FORBID_CONTENT value
     * @property {number} S2C_MSG_FORBID_CONTENT_REP=1332 S2C_MSG_FORBID_CONTENT_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_ADMIN_LIST=1333 C2S_MSG_GET_CHATROOM_ADMIN_LIST value
     * @property {number} S2C_MSG_GET_CHATROOM_ADMIN_LIST_REP=1334 S2C_MSG_GET_CHATROOM_ADMIN_LIST_REP value
     * @property {number} C2S_MSG_GET_FORBIDMSG_LIST=1335 C2S_MSG_GET_FORBIDMSG_LIST value
     * @property {number} S2C_MSG_GET_FORBIDMSG_LIST_REP=1336 S2C_MSG_GET_FORBIDMSG_LIST_REP value
     * @property {number} C2S_MSG_MODIFY_FORBIDMSG_LIST=1337 C2S_MSG_MODIFY_FORBIDMSG_LIST value
     * @property {number} S2C_MSG_MODIFY_FORBIDMSG_LIST_REP=1338 S2C_MSG_MODIFY_FORBIDMSG_LIST_REP value
     * @property {number} S2C_MSG_RED_NTY=1200 S2C_MSG_RED_NTY value
     * @property {number} S2C_MSG_LOGIN_OTHER_NTY=1201 S2C_MSG_LOGIN_OTHER_NTY value
     * @property {number} S2C_MSG_GROUP_BASE_NTY=1202 S2C_MSG_GROUP_BASE_NTY value
     * @property {number} S2C_MSG_GROUP_OPER_NTY=1203 S2C_MSG_GROUP_OPER_NTY value
     * @property {number} S2C_MSG_HANDLE_FRIEND_NTY=1204 S2C_MSG_HANDLE_FRIEND_NTY value
     * @property {number} S2C_MSG_NEW_ORDER_NTY=1205 S2C_MSG_NEW_ORDER_NTY value
     * @property {number} S2C_MSG_GROUP_MEMBER_LIST_NTY=1206 S2C_MSG_GROUP_MEMBER_LIST_NTY value
     * @property {number} S2C_MSG_RATE_NTY=1207 S2C_MSG_RATE_NTY value
     * @property {number} S2C_MSG_PC_FLOW_NTY=1208 S2C_MSG_PC_FLOW_NTY value
     * @property {number} S2C_MSG_PC_DATA_NTY=1209 S2C_MSG_PC_DATA_NTY value
     * @property {number} S2C_MSG_VOICE_CALL_NTY=1210 S2C_MSG_VOICE_CALL_NTY value
     * @property {number} S2C_MSG_VOICE_DATA_NTY=1211 S2C_MSG_VOICE_DATA_NTY value
     * @property {number} S2C_MSG_FRIEND_STATE_NTY=1212 S2C_MSG_FRIEND_STATE_NTY value
     * @property {number} S2C_MSG_GROUP_VOICE_CALL_NTY=1213 S2C_MSG_GROUP_VOICE_CALL_NTY value
     * @property {number} S2C_MSG_GROUP_VOICE_CALL_STATE_NTY=1214 S2C_MSG_GROUP_VOICE_CALL_STATE_NTY value
     * @property {number} S2C_MSG_PHP_MSGBOX_NTY=1215 S2C_MSG_PHP_MSGBOX_NTY value
     */
    net.CLIENT_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1000] = "C2S_MSG_HEART"] = 1000;
        values[valuesById[1001] = "C2S_MSG_LOGIN"] = 1001;
        values[valuesById[1002] = "S2C_MSG_LOGIN_REP"] = 1002;
        values[valuesById[1003] = "S2C_MSG_USER_INFO"] = 1003;
        values[valuesById[1004] = "S2C_MSG_ADD_FRIEND_NTY"] = 1004;
        values[valuesById[1005] = "C2S_MSG_ADD_FRIEND"] = 1005;
        values[valuesById[1006] = "S2C_MSG_ADD_FRIEND_REP"] = 1006;
        values[valuesById[1007] = "C2S_MSG_HANDLE_FRIEND_APPLY"] = 1007;
        values[valuesById[1008] = "S2C_MSG_HANDLE_FRIEND_APPLY_REP"] = 1008;
        values[valuesById[1009] = "C2S_MSG_FRIEND_APPLY_LIST"] = 1009;
        values[valuesById[1010] = "S2C_MSG_FRIEND_APPLY_LIST_REP"] = 1010;
        values[valuesById[1011] = "C2S_MSG_FRIEND_LIST"] = 1011;
        values[valuesById[1012] = "S2C_MSG_FRIEND_LIST_REP"] = 1012;
        values[valuesById[1013] = "C2S_MSG_GET_USER_INFO"] = 1013;
        values[valuesById[1014] = "S2C_MSG_GET_USER_INFO_REP"] = 1014;
        values[valuesById[1015] = "C2S_MSG_SEND_PRIVATE_MSG"] = 1015;
        values[valuesById[1016] = "S2C_MSG_SEND_PRIVATE_MSG_REP"] = 1016;
        values[valuesById[1017] = "C2S_MSG_GET_MSG_LIST"] = 1017;
        values[valuesById[1018] = "S2C_MSG_GET_MSG_LIST_REP"] = 1018;
        values[valuesById[1019] = "C2S_MSG_CONFIRM_READ_MSG"] = 1019;
        values[valuesById[1020] = "S2C_MSG_CONFIRM_READ_MSG_REP"] = 1020;
        values[valuesById[1021] = "C2S_MSG_CREATE_GROUP_CHAT"] = 1021;
        values[valuesById[1022] = "S2C_MSG_CREATE_GROUP_CHAT_REP"] = 1022;
        values[valuesById[1023] = "C2S_MSG_ADD_GROUP_MEMBER"] = 1023;
        values[valuesById[1024] = "S2C_MSG_ADD_GROUP_MEMBER_REP"] = 1024;
        values[valuesById[1025] = "C2S_MSG_DEL_GROUP_MEMBER"] = 1025;
        values[valuesById[1026] = "S2C_MSG_DEL_GROUP_MEMBER_REP"] = 1026;
        values[valuesById[1027] = "C2S_MSG_DISMISS_GROUP"] = 1027;
        values[valuesById[1028] = "S2C_MSG_DISMISS_GROUP_REP"] = 1028;
        values[valuesById[1029] = "C2S_MSG_SEND_GROUP_MSG"] = 1029;
        values[valuesById[1030] = "S2C_MSG_SEND_GROUP_MSG_REP"] = 1030;
        values[valuesById[1031] = "C2S_MSG_GET_GROUP_INFO"] = 1031;
        values[valuesById[1032] = "S2C_MSG_GET_GROUP_INFO_REP"] = 1032;
        values[valuesById[1033] = "C2S_MSG_CONFIRM_GROUP_INFO"] = 1033;
        values[valuesById[1034] = "S2C_MSG_CONFIRM_GROUP_INFO_REP"] = 1034;
        values[valuesById[1035] = "C2S_MSG_GET_REDBAG_INFO"] = 1035;
        values[valuesById[1036] = "S2C_MSG_GET_REDBAG_INFO_REP"] = 1036;
        values[valuesById[1037] = "C2S_MSG_MODIFY_GROUPNAME"] = 1037;
        values[valuesById[1038] = "S2C_MSG_MODIFY_GROUPNAME_REP"] = 1038;
        values[valuesById[1039] = "C2S_MSG_MODIFY_GROUPNOTIFY"] = 1039;
        values[valuesById[1040] = "S2C_MSG_MODIFY_GROUPNOTIFY_REP"] = 1040;
        values[valuesById[1041] = "C2S_MSG_SET_GROUPADMIN"] = 1041;
        values[valuesById[1042] = "S2C_MSG_SET_GROUPADMIN_REP"] = 1042;
        values[valuesById[1043] = "C2S_MSG_SET_GROUPINFO_LIMITS"] = 1043;
        values[valuesById[1044] = "S2C_MSG_SET_GROUPINFO_LIMITS_REP"] = 1044;
        values[valuesById[1045] = "C2S_MSG_SET_GROUPADD_LIMITS"] = 1045;
        values[valuesById[1046] = "S2C_MSG_SET_GROUPADD_LIMITS_REP"] = 1046;
        values[valuesById[1047] = "C2S_MSG_DEL_GROUPADMIN"] = 1047;
        values[valuesById[1048] = "S2C_MSG_DEL_GROUPADMIN_REP"] = 1048;
        values[valuesById[1049] = "C2S_MSG_SET_GROUPLOOK_LIMITS"] = 1049;
        values[valuesById[1050] = "S2C_MSG_SET_GROUPLOOK_LIMITS_REP"] = 1050;
        values[valuesById[1051] = "C2S_MSG_SET_GROUPHOST"] = 1051;
        values[valuesById[1052] = "S2C_MSG_SET_GROUPHOST_REP"] = 1052;
        values[valuesById[1053] = "C2S_MSG_GET_REDBAG"] = 1053;
        values[valuesById[1054] = "S2C_MSG_GET_REDBAG_REP"] = 1054;
        values[valuesById[1055] = "C2S_MSG_INPUT_SYNC"] = 1055;
        values[valuesById[1056] = "S2C_MSG_INPUT_SYNC_REP"] = 1056;
        values[valuesById[1057] = "C2S_MSG_GET_ONLINE_STATE"] = 1057;
        values[valuesById[1058] = "S2C_MSG_GET_ONLINE_STATE_REP"] = 1058;
        values[valuesById[1059] = "C2S_MSG_GET_GROUP_ONLINE"] = 1059;
        values[valuesById[1060] = "S2C_MSG_GET_GROUP_ONLINE_REP"] = 1060;
        values[valuesById[1061] = "C2S_MSG_SET_MUTE_NOTIFICATIONS"] = 1061;
        values[valuesById[1062] = "S2C_MSG_SET_MUTE_NOTIFICATIONS_REP"] = 1062;
        values[valuesById[1063] = "C2S_MSG_SET_CHAT_ON_TOP"] = 1063;
        values[valuesById[1064] = "S2C_MSG_SET_CHAT_ON_TOP_REP"] = 1064;
        values[valuesById[1065] = "C2S_MSG_GET_MUTE_NOTIFY_LIST"] = 1065;
        values[valuesById[1066] = "S2C_MSG_GET_MUTE_NOTIFY_LIST_REP"] = 1066;
        values[valuesById[1067] = "C2S_MSG_GET_CHAT_ON_TOP_LIST"] = 1067;
        values[valuesById[1068] = "S2C_MSG_GET_CHAT_ON_TOP_LIST_REP"] = 1068;
        values[valuesById[1069] = "C2S_MSG_DEL_CHAT_MSG"] = 1069;
        values[valuesById[1070] = "S2C_MSG_DEL_CHAT_MSG_REP"] = 1070;
        values[valuesById[1071] = "C2S_MSG_CONFIRM_DEL_MSG"] = 1071;
        values[valuesById[1072] = "S2C_MSG_CONFIRM_DEL_MSG_REP"] = 1072;
        values[valuesById[1073] = "C2S_MSG_GET_OFFLINE_DATA"] = 1073;
        values[valuesById[1074] = "C2S_MSG_GET_OFFLINE_DATA_REP"] = 1074;
        values[valuesById[1075] = "C2S_MSG_DELETE_FRIEND"] = 1075;
        values[valuesById[1076] = "S2C_MSG_DELETE_FRIEND_REP"] = 1076;
        values[valuesById[1077] = "C2S_MSG_SET_ALIAS"] = 1077;
        values[valuesById[1078] = "S2C_MSG_SET_ALIAS_REP"] = 1078;
        values[valuesById[1079] = "C2S_MSG_GET_ALIAS_LIST"] = 1079;
        values[valuesById[1080] = "S2C_MSG_GET_ALIAS_LIST_REP"] = 1080;
        values[valuesById[1081] = "C2S_MSG_SET_SIGN"] = 1081;
        values[valuesById[1082] = "S2C_MSG_SET_SIGN_REP"] = 1082;
        values[valuesById[1083] = "C2S_MSG_SET_REGION"] = 1083;
        values[valuesById[1084] = "S2C_MSG_SET_REGION_REP"] = 1084;
        values[valuesById[1085] = "C2S_MSG_SET_HEADURL"] = 1085;
        values[valuesById[1086] = "S2C_MSG_SET_HEADURL_REP"] = 1086;
        values[valuesById[1087] = "C2S_MSG_SET_NAME"] = 1087;
        values[valuesById[1088] = "S2C_MSG_SET_NAME_REP"] = 1088;
        values[valuesById[1089] = "C2S_MSG_TOTAL_REDBAG_RECORD"] = 1089;
        values[valuesById[1090] = "S2C_MSG_TOTAL_REDBAG_RECORD_RESP"] = 1090;
        values[valuesById[1091] = "C2S_MSG_UPLOAD_ADDRESSBOOK"] = 1091;
        values[valuesById[1092] = "S2C_MSG_UPLOAD_ADDRESSBOOK_REP"] = 1092;
        values[valuesById[1093] = "C2S_MSG_GET_ADDRESSBOOK"] = 1093;
        values[valuesById[1094] = "S2C_MSG_GET_ADDRESSBOOK_REP"] = 1094;
        values[valuesById[1095] = "C2S_MSG_UPLOAD_PUSHID"] = 1095;
        values[valuesById[1096] = "S2C_MSG_UPLOAD_PUSHID_REP"] = 1096;
        values[valuesById[1097] = "C2S_MSG_SET_BACKGROUND"] = 1097;
        values[valuesById[1098] = "S2C_MSG_SET_BACKGROUND_REP"] = 1098;
        values[valuesById[1099] = "C2S_MSG_CONFIRM_HASREAD_MSG"] = 1099;
        values[valuesById[1100] = "S2C_MSG_CONFIRM_HASREAD_MSG_REP"] = 1100;
        values[valuesById[1101] = "C2S_MSG_GET_HASREAD_LIST"] = 1101;
        values[valuesById[1102] = "S2C_MSG_GET_HASREAD_LIST_REP"] = 1102;
        values[valuesById[1103] = "C2S_MSG_TRANSFER_ACCOUNT"] = 1103;
        values[valuesById[1104] = "S2C_MSG_TRANSFER_ACCOUNT_REP"] = 1104;
        values[valuesById[1105] = "C2S_MSG_GET_ONLINE_LIST"] = 1105;
        values[valuesById[1106] = "S2C_MSG_GET_ONLINE_LIST_REP"] = 1106;
        values[valuesById[1107] = "C2S_MSG_GET_MONEY_CHANGE_LIST"] = 1107;
        values[valuesById[1108] = "S2C_MSG_GET_MONEY_CHANGE_LIST_REP"] = 1108;
        values[valuesById[1109] = "C2S_MSG_GET_PAY_AUTH_CODE"] = 1109;
        values[valuesById[1110] = "S2C_MSG_GET_PAY_AUTH_CODE_REP"] = 1110;
        values[valuesById[1111] = "C2S_MSG_JOINGROUP_BYQRCODE"] = 1111;
        values[valuesById[1112] = "S2C_MSG_JOINGROUP_BYQRCODE_REP"] = 1112;
        values[valuesById[1113] = "C2S_MSG_CREATE_GOODS"] = 1113;
        values[valuesById[1114] = "S2C_MSG_CREATE_GOODS_REP"] = 1114;
        values[valuesById[1115] = "C2S_MSG_GET_MY_GOODS"] = 1115;
        values[valuesById[1116] = "S2C_MSG_GET_MY_GOODS_REP"] = 1116;
        values[valuesById[1117] = "C2S_MSG_GET_GOODS"] = 1117;
        values[valuesById[1118] = "S2C_MSG_GET_GOODS_REP"] = 1118;
        values[valuesById[1119] = "C2S_MSG_CREATE_ORDER"] = 1119;
        values[valuesById[1120] = "S2C_MSG_CREATE_ORDER_REP"] = 1120;
        values[valuesById[1121] = "C2S_MSG_CONFIRM_ORDER"] = 1121;
        values[valuesById[1122] = "S2C_MSG_CONFIRM_ORDER_REP"] = 1122;
        values[valuesById[1123] = "C2S_MSG_GET_MY_ORDERS"] = 1123;
        values[valuesById[1124] = "S2C_MSG_GET_MY_ORDERS_REP"] = 1124;
        values[valuesById[1125] = "C2S_MSG_GET_ORDER_INFO"] = 1125;
        values[valuesById[1126] = "S2C_MSG_GET_ORDER_INFO_REP"] = 1126;
        values[valuesById[1127] = "C2S_MSG_GET_GOODS_BYID"] = 1127;
        values[valuesById[1128] = "S2C_MSG_GET_GOODS_BYID_REP"] = 1128;
        values[valuesById[1129] = "C2S_MSG_WITHDRAW_CHATMSG"] = 1129;
        values[valuesById[1130] = "S2C_MSG_WITHDRAW_CHATMSG_REP"] = 1130;
        values[valuesById[1131] = "C2S_MSG_CANCEL_ORDER"] = 1131;
        values[valuesById[1132] = "S2C_MSG_CANCEL_ORDER_REP"] = 1132;
        values[valuesById[1133] = "C2S_MSG_GET_GROUP_NICKNAME_LIST"] = 1133;
        values[valuesById[1134] = "S2C_MSG_GET_GROUP_NICKNAME_LIST_REP"] = 1134;
        values[valuesById[1135] = "C2S_MSG_SET_GROUP_NICKNAME"] = 1135;
        values[valuesById[1136] = "S2C_MSG_SET_GROUP_NICKNAME_REP"] = 1136;
        values[valuesById[1137] = "C2S_MSG_SET_ORDER_PAYTYPEID"] = 1137;
        values[valuesById[1138] = "S2C_MSG_SET_ORDER_PAYTYPEID_REP"] = 1138;
        values[valuesById[1139] = "C2S_MSG_GET_GOODS_DATA"] = 1139;
        values[valuesById[1140] = "S2C_MSG_GET_GOODS_DATA_REP"] = 1140;
        values[valuesById[1141] = "C2S_MSG_GET_GOODS_DETAIL_DATA"] = 1141;
        values[valuesById[1142] = "S2C_MSG_GET_GOODS_DETAIL_DATA_REP"] = 1142;
        values[valuesById[1143] = "C2S_MSG_OPER_SHOPCOIN"] = 1143;
        values[valuesById[1144] = "S2C_MSG_OPER_SHOPCOIN_REP"] = 1144;
        values[valuesById[1145] = "C2S_MSG_SET_SNAPCHAT"] = 1145;
        values[valuesById[1146] = "S2C_MSG_SET_SNAPCHAT_REP"] = 1146;
        values[valuesById[1147] = "C2S_MSG_GET_SNAPCHAT_LIST"] = 1147;
        values[valuesById[1148] = "S2C_MSG_GET_SNAPCHAT_LIST_REP"] = 1148;
        values[valuesById[1149] = "C2S_MSG_GET_SCREENSHOT"] = 1149;
        values[valuesById[1150] = "S2C_MSG_GET_SCREENSHOT_REP"] = 1150;
        values[valuesById[1151] = "C2S_MSG_SET_SCREENSHOT"] = 1151;
        values[valuesById[1152] = "S2C_MSG_SET_SCREENSHOT_REP"] = 1152;
        values[valuesById[1153] = "C2S_MSG_SET_GROUPSENDMSG_LIMIT"] = 1153;
        values[valuesById[1154] = "S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP"] = 1154;
        values[valuesById[1155] = "C2S_MSG_GET_ORDER_INFO_BYID"] = 1155;
        values[valuesById[1156] = "S2C_MSG_GET_ORDER_INFO_BYID_REP"] = 1156;
        values[valuesById[1157] = "C2S_MSG_GET_BLACK_LIST"] = 1157;
        values[valuesById[1158] = "SC2_MSG_GET_BLACK_LIST_REP"] = 1158;
        values[valuesById[1159] = "C2S_MSG_SET_BLACK_LIST"] = 1159;
        values[valuesById[1160] = "SC2_MSG_SET_BLACK_LIST_REP"] = 1160;
        values[valuesById[1161] = "C2S_MSG_THIRD_PAY"] = 1161;
        values[valuesById[1162] = "S2C_MSG_THIRD_PAY_REP"] = 1162;
        values[valuesById[1163] = "C2S_MSG_PCAUTH"] = 1163;
        values[valuesById[1164] = "S2C_MSG_PCAUTH_REP"] = 1164;
        values[valuesById[1165] = "C2S_MSG_PCLOGIN"] = 1165;
        values[valuesById[1166] = "S2C_MSG_PCLOGIN_REP"] = 1166;
        values[valuesById[1167] = "C2S_MSG_VOICE_CALL"] = 1167;
        values[valuesById[1168] = "S2C_MSG_VOICE_CALL_REP"] = 1168;
        values[valuesById[1169] = "C2S_MSG_OPER_VOICE_CALL"] = 1169;
        values[valuesById[1170] = "S2C_MSG_OPER_VOICE_CALL_REP"] = 1170;
        values[valuesById[1171] = "C2S_MSG_VOICE_DATA"] = 1171;
        values[valuesById[1172] = "S2C_MSG_VOICE_DATA_REP"] = 1172;
        values[valuesById[1173] = "C2S_MSG_NEED_READ_GROUP_NOTIFY"] = 1173;
        values[valuesById[1174] = "S2C_MSG_NEED_READ_GROUP_NOTIFY_REP"] = 1174;
        values[valuesById[1175] = "C2S_MSG_READ_GROUP_NOTIFY"] = 1175;
        values[valuesById[1176] = "S2C_MSG_READ_GROUP_NOTIFY_REP"] = 1176;
        values[valuesById[1177] = "C2S_MSG_SET_FORBID_TM"] = 1177;
        values[valuesById[1178] = "S2C_MSG_SET_FORBID_TM_REP"] = 1178;
        values[valuesById[1179] = "C2S_MSG_GET_GROUP_MEMBER_LIST"] = 1179;
        values[valuesById[1180] = "S2C_MSG_GET_GROUP_MEMBER_LIST_REP"] = 1180;
        values[valuesById[1181] = "C2S_MSG_GET_FRIEND_INCR_LIST"] = 1181;
        values[valuesById[1182] = "S2C_MSG_GET_FRIEND_INCR_LIST_REP"] = 1182;
        values[valuesById[1183] = "C2S_MSG_BIND_OPENID"] = 1183;
        values[valuesById[1184] = "S2C_MSG_BING_OPENID_REP"] = 1184;
        values[valuesById[1185] = "C2S_MSG_H5LOGIN"] = 1185;
        values[valuesById[1186] = "S2C_MSG_H5LOGIN_REP"] = 1186;
        values[valuesById[1187] = "C2S_MSG_ADD_FRIEND_BYFID"] = 1187;
        values[valuesById[1188] = "S2C_MSG_ADD_FRIEND_BYFID_REP"] = 1188;
        values[valuesById[1189] = "C2S_MSG_SET_GROUP_HEADURL"] = 1189;
        values[valuesById[1190] = "S2C_MSG_SET_GROUP_HEADURL_REP"] = 1190;
        values[valuesById[1191] = "C2S_MSG_SET_COMPLETE_NAME"] = 1191;
        values[valuesById[1192] = "S2C_MSG_SET_COMPLETE_NAME_REP"] = 1192;
        values[valuesById[1193] = "C2S_MSG_SET_PHONENUM"] = 1193;
        values[valuesById[1194] = "S2C_MSG_SET_PHONENUM_REP"] = 1194;
        values[valuesById[1195] = "C2S_MSG_SET_PRIVACY"] = 1195;
        values[valuesById[1196] = "S2C_MSG_SET_PRIVACY_REP"] = 1196;
        values[valuesById[901] = "C2S_MSG_GROUP_VOICE_CALL"] = 901;
        values[valuesById[902] = "S2C_MSG_GROUP_VOICE_CALL_REP"] = 902;
        values[valuesById[903] = "C2S_MSG_JOIN_GROUP_VOICE_CALL"] = 903;
        values[valuesById[904] = "S2C_MSG_JOIN_GROUP_VOICE_CALL_REP"] = 904;
        values[valuesById[905] = "C2S_MSG_OPER_GROUP_VOICE_CALL"] = 905;
        values[valuesById[906] = "S2C_MSG_OPER_GROUP_VOICE_CALL_REP"] = 906;
        values[valuesById[907] = "C2S_MSG_SET_GROUPADMIN_NEW"] = 907;
        values[valuesById[908] = "S2C_MSG_SET_GROUPADMIN_NEW_REP"] = 908;
        values[valuesById[909] = "C2S_MSG_SET_GROUPFORBID"] = 909;
        values[valuesById[910] = "S2C_MSG_SET_GROUPFORBID_REP"] = 910;
        values[valuesById[911] = "C2S_MSG_GET_GROUPFORBID_LIST"] = 911;
        values[valuesById[912] = "S2C_MSG_GET_GROUPFORBID_LIST_REP"] = 912;
        values[valuesById[913] = "C2S_MSG_SET_BTY_REGISTER"] = 913;
        values[valuesById[914] = "S2C_MSG_SET_BTY_REGISTER_REP"] = 914;
        values[valuesById[915] = "C2S_MSG_SET_BTY_TOPUP"] = 915;
        values[valuesById[916] = "S2C_MSG_SET_BTY_TOPUP_REP"] = 916;
        values[valuesById[917] = "C2S_MSG_APPLY_FRIEND_NEED_VERIFY"] = 917;
        values[valuesById[918] = "S2C_MSG_APPLY_FRIEND_NEED_VERIFY_REP"] = 918;
        values[valuesById[919] = "C2S_MSG_SET_GROUPWHITE"] = 919;
        values[valuesById[920] = "S2C_MSG_SET_GROUPWHITE_REP"] = 920;
        values[valuesById[921] = "C2S_MSG_GET_GROUPWHITE_LIST"] = 921;
        values[valuesById[922] = "S2C_MSG_GET_GROUPWHITE_LIST_REP"] = 922;
        values[valuesById[1301] = "C2S_MSG_GET_CHATROOM_LIST"] = 1301;
        values[valuesById[1302] = "S2C_MSG_GET_CHATROOM_LIST_REP"] = 1302;
        values[valuesById[1303] = "C2S_MSG_GET_CHATROOM_MEMBERS"] = 1303;
        values[valuesById[1304] = "S2C_MSG_GET_CHATROOM_MEMBERS_REP"] = 1304;
        values[valuesById[1305] = "C2S_MSG_JOIN_CHATROOM"] = 1305;
        values[valuesById[1306] = "S2C_MSG_JOIN_CHATROOM_REP"] = 1306;
        values[valuesById[1307] = "C2S_MSG_QUIT_CHATROOM"] = 1307;
        values[valuesById[1308] = "S2C_MSG_QUIT_CHATROOM_REP"] = 1308;
        values[valuesById[1309] = "C2S_MSG_SEND_CHATROOM_MSG"] = 1309;
        values[valuesById[1310] = "S2C_MSG_SEND_CHATROOM_MSG_REP"] = 1310;
        values[valuesById[1311] = "C2S_MSG_CHATROOM_KICKOUT"] = 1311;
        values[valuesById[1312] = "S2C_MSG_CHATROOM_KICKOUT_REP"] = 1312;
        values[valuesById[1313] = "C2S_MSG_CHATROOM_FORBID"] = 1313;
        values[valuesById[1314] = "S2C_MSG_CHATROOM_FORBID_REP"] = 1314;
        values[valuesById[1315] = "C2S_MSG_DEL_CHATROOM_MSG"] = 1315;
        values[valuesById[1316] = "S2C_MSG_DEL_CHATROOM_MSG_REP"] = 1316;
        values[valuesById[1317] = "C2S_MSG_CHATROOM_SET_ADMIN"] = 1317;
        values[valuesById[1318] = "S2C_MSG_CHATROOM_SET_ADMIN_REP"] = 1318;
        values[valuesById[1319] = "C2S_MSG_GET_CHATROOM_HISTORY_MSG"] = 1319;
        values[valuesById[1320] = "S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP"] = 1320;
        values[valuesById[1321] = "S2C_MSG_JOIN_CHATROOM_NTY"] = 1321;
        values[valuesById[1323] = "C2S_MSG_CHATROOM_NTY_MSG_TOALL"] = 1323;
        values[valuesById[1324] = "S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP"] = 1324;
        values[valuesById[1325] = "C2S_MSG_SEND_CHATROOM_AD"] = 1325;
        values[valuesById[1326] = "S2C_MSG_SEND_CHATROOM_AD_REP"] = 1326;
        values[valuesById[1327] = "C2S_MSG_ALLCHATROOM_FORBID"] = 1327;
        values[valuesById[1328] = "S2C_MSG_ALLCHATROOM_FORBID_REP"] = 1328;
        values[valuesById[1329] = "C2S_MSG_GET_FORBID_STATE"] = 1329;
        values[valuesById[1330] = "S2C_MSG_GET_FORBID_STATE_REP"] = 1330;
        values[valuesById[1331] = "C2S_MSG_FORBID_CONTENT"] = 1331;
        values[valuesById[1332] = "S2C_MSG_FORBID_CONTENT_REP"] = 1332;
        values[valuesById[1333] = "C2S_MSG_GET_CHATROOM_ADMIN_LIST"] = 1333;
        values[valuesById[1334] = "S2C_MSG_GET_CHATROOM_ADMIN_LIST_REP"] = 1334;
        values[valuesById[1335] = "C2S_MSG_GET_FORBIDMSG_LIST"] = 1335;
        values[valuesById[1336] = "S2C_MSG_GET_FORBIDMSG_LIST_REP"] = 1336;
        values[valuesById[1337] = "C2S_MSG_MODIFY_FORBIDMSG_LIST"] = 1337;
        values[valuesById[1338] = "S2C_MSG_MODIFY_FORBIDMSG_LIST_REP"] = 1338;
        values[valuesById[1200] = "S2C_MSG_RED_NTY"] = 1200;
        values[valuesById[1201] = "S2C_MSG_LOGIN_OTHER_NTY"] = 1201;
        values[valuesById[1202] = "S2C_MSG_GROUP_BASE_NTY"] = 1202;
        values[valuesById[1203] = "S2C_MSG_GROUP_OPER_NTY"] = 1203;
        values[valuesById[1204] = "S2C_MSG_HANDLE_FRIEND_NTY"] = 1204;
        values[valuesById[1205] = "S2C_MSG_NEW_ORDER_NTY"] = 1205;
        values[valuesById[1206] = "S2C_MSG_GROUP_MEMBER_LIST_NTY"] = 1206;
        values[valuesById[1207] = "S2C_MSG_RATE_NTY"] = 1207;
        values[valuesById[1208] = "S2C_MSG_PC_FLOW_NTY"] = 1208;
        values[valuesById[1209] = "S2C_MSG_PC_DATA_NTY"] = 1209;
        values[valuesById[1210] = "S2C_MSG_VOICE_CALL_NTY"] = 1210;
        values[valuesById[1211] = "S2C_MSG_VOICE_DATA_NTY"] = 1211;
        values[valuesById[1212] = "S2C_MSG_FRIEND_STATE_NTY"] = 1212;
        values[valuesById[1213] = "S2C_MSG_GROUP_VOICE_CALL_NTY"] = 1213;
        values[valuesById[1214] = "S2C_MSG_GROUP_VOICE_CALL_STATE_NTY"] = 1214;
        values[valuesById[1215] = "S2C_MSG_PHP_MSGBOX_NTY"] = 1215;
        return values;
    })();

    /**
     * SERVER_MSG_ID enum.
     * @name net.SERVER_MSG_ID
     * @enum {number}
     * @property {number} S2S_MSG_REGISTER=501 S2S_MSG_REGISTER value
     * @property {number} S2S_MSG_REGISTER_REP=502 S2S_MSG_REGISTER_REP value
     * @property {number} S2S_MSG_SYNC_BLACK_OPER=503 S2S_MSG_SYNC_BLACK_OPER value
     * @property {number} S2S_MSG_INCR_CHAT_VERSION=504 S2S_MSG_INCR_CHAT_VERSION value
     * @property {number} S2S_MSG_CHATMSG_RED_NTY=505 S2S_MSG_CHATMSG_RED_NTY value
     * @property {number} S2S_MSG_SYNC_SCREEN_SHOT=506 S2S_MSG_SYNC_SCREEN_SHOT value
     * @property {number} S2S_MSG_SYNC_FRIEND_APPLY=507 S2S_MSG_SYNC_FRIEND_APPLY value
     * @property {number} S2S_MSG_SYNC_OPER_FRIEND_APPLY=508 S2S_MSG_SYNC_OPER_FRIEND_APPLY value
     * @property {number} S2S_MSG_SYNC_FRIEND_RELATION=509 S2S_MSG_SYNC_FRIEND_RELATION value
     * @property {number} S2S_MSG_SYNC_GROUP_BROADCAST=510 S2S_MSG_SYNC_GROUP_BROADCAST value
     * @property {number} S2S_MSG_SYNC_VOICECALL=511 S2S_MSG_SYNC_VOICECALL value
     * @property {number} S2S_MSG_SYNC_OPER_VOICECALL=512 S2S_MSG_SYNC_OPER_VOICECALL value
     * @property {number} S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM=513 S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM value
     * @property {number} S2S_MSG_SYNC_USER_INFO=514 S2S_MSG_SYNC_USER_INFO value
     * @property {number} S2S_MSG_SYNC_FOLLOW_HOST=515 S2S_MSG_SYNC_FOLLOW_HOST value
     * @property {number} S2S_MSG_SYNC_CHATROOM_NTY_MSG=516 S2S_MSG_SYNC_CHATROOM_NTY_MSG value
     * @property {number} S2S_MSG_SYNC_GROUP_CHATMSG=517 S2S_MSG_SYNC_GROUP_CHATMSG value
     * @property {number} S2S_MSG_TRANS_TO_IMSVR=601 S2S_MSG_TRANS_TO_IMSVR value
     * @property {number} S2S_MSG_BROADCAST_TO_CLIENT=602 S2S_MSG_BROADCAST_TO_CLIENT value
     * @property {number} S2S_MSG_REPORT_STATE=603 S2S_MSG_REPORT_STATE value
     */
    net.SERVER_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[501] = "S2S_MSG_REGISTER"] = 501;
        values[valuesById[502] = "S2S_MSG_REGISTER_REP"] = 502;
        values[valuesById[503] = "S2S_MSG_SYNC_BLACK_OPER"] = 503;
        values[valuesById[504] = "S2S_MSG_INCR_CHAT_VERSION"] = 504;
        values[valuesById[505] = "S2S_MSG_CHATMSG_RED_NTY"] = 505;
        values[valuesById[506] = "S2S_MSG_SYNC_SCREEN_SHOT"] = 506;
        values[valuesById[507] = "S2S_MSG_SYNC_FRIEND_APPLY"] = 507;
        values[valuesById[508] = "S2S_MSG_SYNC_OPER_FRIEND_APPLY"] = 508;
        values[valuesById[509] = "S2S_MSG_SYNC_FRIEND_RELATION"] = 509;
        values[valuesById[510] = "S2S_MSG_SYNC_GROUP_BROADCAST"] = 510;
        values[valuesById[511] = "S2S_MSG_SYNC_VOICECALL"] = 511;
        values[valuesById[512] = "S2S_MSG_SYNC_OPER_VOICECALL"] = 512;
        values[valuesById[513] = "S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM"] = 513;
        values[valuesById[514] = "S2S_MSG_SYNC_USER_INFO"] = 514;
        values[valuesById[515] = "S2S_MSG_SYNC_FOLLOW_HOST"] = 515;
        values[valuesById[516] = "S2S_MSG_SYNC_CHATROOM_NTY_MSG"] = 516;
        values[valuesById[517] = "S2S_MSG_SYNC_GROUP_CHATMSG"] = 517;
        values[valuesById[601] = "S2S_MSG_TRANS_TO_IMSVR"] = 601;
        values[valuesById[602] = "S2S_MSG_BROADCAST_TO_CLIENT"] = 602;
        values[valuesById[603] = "S2S_MSG_REPORT_STATE"] = 603;
        return values;
    })();

    /**
     * PHP_MSG_ID enum.
     * @name net.PHP_MSG_ID
     * @enum {number}
     * @property {number} PHP_MSG_THIRD_LOGIN=11 PHP_MSG_THIRD_LOGIN value
     * @property {number} PHP_MSG_CREATE_CHATROOM=12 PHP_MSG_CREATE_CHATROOM value
     * @property {number} PHP_MSG_DISMISS_CHATROOM=13 PHP_MSG_DISMISS_CHATROOM value
     * @property {number} PHP_MSG_KICK_CHATROOM_MEMBER=14 PHP_MSG_KICK_CHATROOM_MEMBER value
     * @property {number} PHP_MSG_SET_CHATROOMADMIN=15 PHP_MSG_SET_CHATROOMADMIN value
     * @property {number} PHP_MSG_SET_CHATROOM_FORBID=16 PHP_MSG_SET_CHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_CHATROOM_MEMBER=17 PHP_MSG_GET_CHATROOM_MEMBER value
     * @property {number} PHP_MSG_GET_CHATROOM_LIST=18 PHP_MSG_GET_CHATROOM_LIST value
     * @property {number} PHP_MSG_GET_ALLCHATROOM_FORBID=19 PHP_MSG_GET_ALLCHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_CHATROOM_INFO=20 PHP_MSG_GET_CHATROOM_INFO value
     * @property {number} PHP_MSG_SET_USERTYPE=21 PHP_MSG_SET_USERTYPE value
     * @property {number} PHP_MSG_GET_USER_SCORE=22 PHP_MSG_GET_USER_SCORE value
     * @property {number} PHP_MSG_CHANGE_USER_SCORE=23 PHP_MSG_CHANGE_USER_SCORE value
     * @property {number} PHP_MSG_SCORE_RECORDS=24 PHP_MSG_SCORE_RECORDS value
     * @property {number} PHP_MSG_SET_ALLCHATROOM_FORBID=25 PHP_MSG_SET_ALLCHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_VIP_DATA=26 PHP_MSG_GET_VIP_DATA value
     * @property {number} PHP_MSG_ADD_VIP_EXP=27 PHP_MSG_ADD_VIP_EXP value
     * @property {number} PHP_MSG_VIP_REWARD=28 PHP_MSG_VIP_REWARD value
     * @property {number} PHP_MSG_INVITE_REG=29 PHP_MSG_INVITE_REG value
     * @property {number} PHP_MSG_REG_USER=30 PHP_MSG_REG_USER value
     * @property {number} PHP_MSG_SET_NAME=31 PHP_MSG_SET_NAME value
     * @property {number} PHP_MSG_FOLLOW_HOST=32 PHP_MSG_FOLLOW_HOST value
     * @property {number} PHP_MSG_GET_CHATROOM_HISTORY_MSG=33 PHP_MSG_GET_CHATROOM_HISTORY_MSG value
     * @property {number} PHP_MSG_DEL_CHATROOM_MSG=34 PHP_MSG_DEL_CHATROOM_MSG value
     * @property {number} PHP_MSG_SEND_CHATMSG=35 PHP_MSG_SEND_CHATMSG value
     * @property {number} PHP_MSG_MSGBOX_NTY=36 PHP_MSG_MSGBOX_NTY value
     * @property {number} PHP_MSG_BIND_PHONE=37 PHP_MSG_BIND_PHONE value
     * @property {number} PHP_MSG_CHATROOM_SEND_AD=38 PHP_MSG_CHATROOM_SEND_AD value
     * @property {number} PHP_MSG_UPDATE_CHATROOM=39 PHP_MSG_UPDATE_CHATROOM value
     */
    net.PHP_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[11] = "PHP_MSG_THIRD_LOGIN"] = 11;
        values[valuesById[12] = "PHP_MSG_CREATE_CHATROOM"] = 12;
        values[valuesById[13] = "PHP_MSG_DISMISS_CHATROOM"] = 13;
        values[valuesById[14] = "PHP_MSG_KICK_CHATROOM_MEMBER"] = 14;
        values[valuesById[15] = "PHP_MSG_SET_CHATROOMADMIN"] = 15;
        values[valuesById[16] = "PHP_MSG_SET_CHATROOM_FORBID"] = 16;
        values[valuesById[17] = "PHP_MSG_GET_CHATROOM_MEMBER"] = 17;
        values[valuesById[18] = "PHP_MSG_GET_CHATROOM_LIST"] = 18;
        values[valuesById[19] = "PHP_MSG_GET_ALLCHATROOM_FORBID"] = 19;
        values[valuesById[20] = "PHP_MSG_GET_CHATROOM_INFO"] = 20;
        values[valuesById[21] = "PHP_MSG_SET_USERTYPE"] = 21;
        values[valuesById[22] = "PHP_MSG_GET_USER_SCORE"] = 22;
        values[valuesById[23] = "PHP_MSG_CHANGE_USER_SCORE"] = 23;
        values[valuesById[24] = "PHP_MSG_SCORE_RECORDS"] = 24;
        values[valuesById[25] = "PHP_MSG_SET_ALLCHATROOM_FORBID"] = 25;
        values[valuesById[26] = "PHP_MSG_GET_VIP_DATA"] = 26;
        values[valuesById[27] = "PHP_MSG_ADD_VIP_EXP"] = 27;
        values[valuesById[28] = "PHP_MSG_VIP_REWARD"] = 28;
        values[valuesById[29] = "PHP_MSG_INVITE_REG"] = 29;
        values[valuesById[30] = "PHP_MSG_REG_USER"] = 30;
        values[valuesById[31] = "PHP_MSG_SET_NAME"] = 31;
        values[valuesById[32] = "PHP_MSG_FOLLOW_HOST"] = 32;
        values[valuesById[33] = "PHP_MSG_GET_CHATROOM_HISTORY_MSG"] = 33;
        values[valuesById[34] = "PHP_MSG_DEL_CHATROOM_MSG"] = 34;
        values[valuesById[35] = "PHP_MSG_SEND_CHATMSG"] = 35;
        values[valuesById[36] = "PHP_MSG_MSGBOX_NTY"] = 36;
        values[valuesById[37] = "PHP_MSG_BIND_PHONE"] = 37;
        values[valuesById[38] = "PHP_MSG_CHATROOM_SEND_AD"] = 38;
        values[valuesById[39] = "PHP_MSG_UPDATE_CHATROOM"] = 39;
        return values;
    })();

    return net;
})();

module.exports = $root;
